/**
 * Typed node data interfaces -- AUTO-GENERATED from schemas/nodes/*.json.
 *
 * Do not edit manually. Run: python scripts/gen_node_metas.py
 */

import * as Y from 'yjs'
import type { Node } from 'reactflow'
import type { GeneratedNodeSchemaDef, YDocFieldDef, YDocPortSchema } from './nodeSchemaTypes'
export type { GeneratedNodeLayoutSize, GeneratedNodePortDef, GeneratedNodeSchemaDef, GeneratedNodeStateFieldDef, YDocFieldDef, YDocPortSchema } from './nodeSchemaTypes'

export type JsonPrimitive = string | number | boolean | null
export type JsonObject = { readonly [key: string]: JsonValue }
export type JsonValue = JsonPrimitive | readonly JsonValue[] | JsonObject
export type YDocPrimitive = JsonPrimitive
export type YDocValue = YDocPrimitive | Y.Map<YDocValue> | Y.Array<YDocValue> | undefined
export type YDocWriteValue = unknown
export type YDocWriteRecord = Record<string, YDocWriteValue>

export const SPARKS_PER_USD = 20

/** Convert USD generation cost to whole Dreamwrite credits. */
export function generationUsdToSparks(usd: number): number {
  if (usd <= 0) return 0
  const scaled = usd * SPARKS_PER_USD
  const lower = Math.floor(scaled)
  const fraction = scaled - lower
  if (fraction === 0.5) {
    return lower % 2 === 0 ? lower : lower + 1
  }
  return Math.max(0, Math.round(scaled))
}

export const SHOT_LIST_FRAMING_PRESETS = {"shot": ["WS (Wide Shot)", "MS (Medium Shot)", "CU (Close-Up)", "OTS", "POV", "ECU (Extreme Close-Up)"], "angle": ["Eye-Level", "Low-Angle", "High-Angle", "Dutch Tilt", "Over-the-Shoulder"], "lens": ["24 mm / f2.8", "35 mm / f2.8", "50 mm / f2.2", "85 mm / f1.8"], "focus": ["Shallow Focus", "Medium Focus", "Deep Focus"]} as const

export const SHOT_LIST_COLUMN_DEFINITIONS = [{"id": "shot_number", "width": "w-20"}, {"id": "timecode", "width": "w-40"}, {"id": "visual_description", "width": "w-72"}, {"id": "location", "width": "w-40"}, {"id": "framing", "width": "w-56"}, {"id": "transition", "width": "w-44"}, {"id": "dialogue_voiceover", "width": "w-44"}, {"id": "sfx", "width": "w-40"}, {"id": "start_frame", "width": "w-40", "role": "start"}, {"id": "key_frame", "width": "w-40", "role": "key"}, {"id": "end_frame", "width": "w-40", "role": "end"}] as const

// ---------------------------------------------------------------------------
// Shared type definitions (generated from schemas/defs.json)
// ---------------------------------------------------------------------------

export type AspectRatio =
  | "16:9"
  | "9:16"
  | "3:4"
  | "4:3"
  | "1:1"
  | "3:2"
  | "2:3"
  | "2:1"
  | "5:4"
  | "4:5"
  | "21:9"
  | "9:21"
  | "Auto";
export type AudioVariantWorkspaceDict = AudioVariantWorkspaceCleanDict | AudioVariantWorkspaceDraftDict;
export type UnifiedAudioVerdict = "manifest" | "pristine_native" | "fallback";
export type AudioLaneDuckModeV1 = "off" | "light" | "medium" | "heavy" | "silence";
export type AudioVocalSourceStrategy = "direct" | "isolate" | "unsupported";

export interface ShotVideoRenderSourcesDict {
  [k: string]: string;
}
export interface AppearanceDict {
  character_id?: string;
  expression?: string;
  pose?: string;
  position?: string;
}
export interface AudioAssetMetadataDict {
  creation_time?: string;
  source?: string;
  model?: string;
}
export interface AudioEditOperationDict {
  id?: string;
  type?: string;
  params?: {
    [k: string]: number | string;
  };
}
export interface AudioRemixConfigDict {
  groups?: AudioRemixGroupDict[];
  sourceOriginalIndex?: number;
  sourceOriginalPath?: string;
  duckDepthDb?: number;
}
export interface AudioRemixGroupDict {
  id?: string;
  character?: string;
  emotion?: string;
  text?: string;
  status?: string;
  type?: string;
  voice_role_id?: string;
  tracks?: AudioRemixTrackDict[];
}
export interface AudioRemixTrackDict {
  id?: string;
  label?: string;
  startS?: number;
  endS?: number;
  highlighted?: boolean;
  sourceSegmentIdx?: number;
  sourceVersionLabel?: string;
  fadeInS?: number;
  fadeOutS?: number;
  sourceDurationS?: number;
  sourceType?: string;
}
export interface BubbleDict {
  panel?: number;
  type?: string;
  text?: string;
  speaker?: string;
  x?: number;
  y?: number;
  width?: number;
  height?: number;
}
export interface ReferenceAdjustmentDict {
  index?: number;
  kind?: "image" | "video" | "audio";
  action?: "converted" | "reencoded" | "downscaled" | "first_frame" | "transcoded";
  before?: string;
  after?: string;
}
export interface BasicAssetMetadata {
  reference_adjustments?: ReferenceAdjustmentDict[];
  creation_time?: string;
  source?: string;
  model?: string;
  execution_route?: "native" | "byom";
  requested_model?: string;
  byom_config_id?: string;
  byom_model_name?: string;
  configured_provider_model?: string;
  provider_reported_model?: string;
  provider?: string;
  mode?: string;
  duration_seconds?: number;
  regenerated?: boolean;
  regeneration_time?: string;
  aspect_ratio?: string;
  actual_resolution?: string;
  actual_width?: number;
  actual_height?: number;
  requested_resolution?: string;
}
export interface GeneratedAssetMetadata {
  model?: string;
  provider?: string;
  mode?: string;
  loop?: string;
  segments?: number;
  segment_start_times?: number[];
  character_name?: string;
  voice_id?: string;
  voice_name?: string;
  eleven_lab_voice_id?: string;
  eleven_lab_voice_name?: string;
  voice_type?: string;
  duration_seconds?: number;
  regenerated?: boolean;
  regeneration_time?: string;
  aspect_ratio?: string;
  type?: string;
  language?: string;
}
export interface BasicImage {
  id?: string;
  local_path?: string;
  metadata?: BasicAssetMetadata;
}
export interface BasicVideo {
  id?: string;
  local_path?: string;
  metadata?: BasicAssetMetadata;
}
export interface BasicAudio {
  id?: string;
  local_path?: string;
  metadata?: BasicAssetMetadata;
  duration_seconds?: number;
  waveform?: number[];
}
export interface GeneratedImage {
  user_prompt?: string;
  result?: BasicImage;
  refs?: BasicImage[];
  metadata?: GeneratedAssetMetadata;
}
export interface GeneratedVideo {
  user_prompt?: string;
  result?: BasicVideo;
  refs?: BasicImage[];
  metadata?: GeneratedAssetMetadata;
  baked_audio?: UnifiedAudioProjectDict | UnifiedAudioProjectV2;
  audio_edit_provenance?: AudioEditProvenanceDict;
}
export interface UnifiedAudioProjectDict {
  lanes?: UnifiedAudioLaneDict[];
  sourceOriginalIndex?: number;
  sourceOriginalPath?: string;
  deletedClipIds?: string[];
  mastering?: "lufs" | "peak";
}
export interface UnifiedAudioLaneDict {
  id?: string;
  type?: "dialogue" | "narration" | "music" | "sfx";
  source?: "native_split" | "owned" | "tts" | "sts";
  clips?: UnifiedAudioClipDict[];
  laneMute?: boolean;
  laneVolume?: number;
  duckDepthDb?: number;
  laneDuckMute?: boolean;
}
export interface UnifiedAudioClipDict {
  id?: string;
  start_s?: number;
  end_s?: number;
  path?: string;
  volume?: number;
  muted?: boolean;
  fadeInS?: number;
  fadeOutS?: number;
  sourceInS?: number;
  versions?: TtsVersionDict[];
  selectedVersionLabel?: string;
  sourceSegmentIdx?: number;
  speaker?: string;
  language?: string;
  speed?: number;
  original_path?: string;
  source_sig?: string;
  native_fill?: boolean;
  added?: boolean;
}
export interface TtsVersionDict {
  label?: string;
  path?: string;
  source_type?: string;
  voice_id?: string;
  voice_name?: string;
}
export interface UnifiedAudioProjectV2 {
  contractVersion: 2;
  lanes: UnifiedAudioLaneV2Dict[];
  mastering: "lufs" | "peak";
}
export interface UnifiedAudioLaneV2Dict {
  id: string;
  type: "dialogue" | "narration" | "music" | "sfx";
  clips: UnifiedAudioClipV2Dict[];
  laneMute: boolean;
  laneVolume: number;
  duckDepthDb: number;
  laneDuckMute: boolean;
}
export interface UnifiedAudioClipV2Dict {
  id: string;
  startS: number;
  endS: number;
  userSpeed: number;
  takes: UnifiedAudioTakeV2Dict[];
  activeTakeId: string;
  volume: number;
  fadeInS: number;
  fadeOutS: number;
  muted: boolean;
  contentRole: "speech" | "background" | "music" | "sfx" | "gap_fill" | "overlap_unresolved";
  transcript: string | null;
  speaker: string | null;
  language: string | null;
  isolationGroupId?: string | null;
}
export interface UnifiedAudioTakeV2Dict {
  id: string;
  source: AudioTakeSourceV2Dict;
  baseFitRate: number;
  voiceId: string | null;
  language: string | null;
}
export interface AudioTakeSourceV2Dict {
  assetPath: string;
  assetFingerprint: string;
  inS: number;
  outS: number;
  durationS: number;
  kind: "original" | "tts" | "voice_conversion" | "dub" | "isolated_voice" | "isolated_background";
  parentClipIds: string[];
}
export interface AudioEditProvenanceDict {
  programId: string;
  planFingerprint: string;
  sourceVariantRef: string;
  sourceRevision: number;
  renderJobId: string;
}
export interface GeneratedAudio {
  user_prompt?: string;
  result?: BasicAudio;
  refs?: BasicAudio[];
  metadata?: GeneratedAssetMetadata;
}
export interface GeneratedAudioWithHistory {
  history?: GeneratedAudio[];
  picked_index?: number;
}
export interface ImageAssetRefDict {
  history?: GeneratedImage[];
  picked_index?: number;
}
export interface VideoAssetRefDict {
  history?: GeneratedVideo[];
  picked_index?: number;
}
export interface VideoReferenceEditDict {
  source_node_id?: string;
  asset_path?: string;
  start_time?: number;
  end_time?: number;
  keep_last_seconds?: number;
}
export interface AudioAssetRefDict {
  history?: GeneratedAudio[];
  picked_index?: number;
}
export interface CharacterAsset {
  user_prompt?: string;
  images?: {
    [k: string]: GeneratedImageWithHistory;
  };
  voices?: {
    [k: string]: GeneratedAudioWithHistory;
  };
}
export interface GeneratedImageWithHistory {
  history?: GeneratedImage[];
  picked_index?: number;
}
export interface CompositionDict {
  shot_type?: string;
  angle?: string;
  focus?: string;
}
export interface DialogueEntryDict {
  clip_index?: number;
  voice_text?: string;
  voice_character?: string;
  start_s?: number;
  end_s?: number;
  type?: string;
  voice_role_id?: string;
  source_node_id?: string;
}
export interface DirectorCrewDict {
  director?: string;
  character?: string;
  location?: string;
  object?: string;
  storyboard?: string;
  scriptwriter?: string;
  image?: string;
  video?: string;
  sound?: string;
}
export interface DirectorPendingToolStateDict {
  conversation_id?: string;
  last_tool_name?: string;
  last_tool_status?: string;
  pending_tool_id?: string;
  pending_tool_name?: string;
}
export interface FeedbackHistoryEntryDict {
  round?: number;
  feedback?: string;
  applied_at?: string;
}
export interface GeneratedVideoWithHistory {
  history?: GeneratedVideo[];
  picked_index?: number;
  picked_variant_id?: string | null;
}
export interface LocationAsset {
  user_prompt?: string;
  images?: {
    [k: string]: GeneratedImageWithHistory;
  };
}
export interface LocationMetadataDict {
  name?: string;
  style?: string;
  time_of_day?: string;
  weather?: string;
}
export interface LocationPanoramaViewDict {
  yaw_degrees?: number;
  pitch_degrees?: number;
  fov_degrees?: number;
}
export interface ObjectAsset {
  user_prompt?: string;
  images?: {
    [k: string]: GeneratedImageWithHistory;
  };
}
export interface ObjectMetadataDict {
  name?: string;
  style?: string;
  description?: string;
}
export interface PanelDescriptionDict {
  panel_id?: string;
  description?: string;
  characters?: string[];
  location?: string;
}
export interface PanelDialogueDict {
  speaker?: string;
  text?: string;
  type?: string;
}
export interface ReconciledDialogueEntryDict {
  character?: string;
  intended_text?: string;
  actual_text?: string;
  replacement_text?: string;
  start_s?: number;
  end_s?: number;
  duration_s?: number;
  emotion?: string;
  intensity?: number;
  status?: string;
  line_type?: string;
  voice_role_id?: string;
}
export interface ReviewHistoryEntryDict {
  feedback?: string;
  round?: number;
  accepted?: boolean;
  attempt?: number;
}
export interface SceneTextDict {
  scene_number?: number;
  text?: string;
}
export interface ScreenplayEntryDict {
  type?: string;
  character?: string;
  emotion?: string;
  voice_role_id?: string;
  text?: string;
}
export interface ScreenplayResultDict {
  error?: string;
  voice_roles?: VoiceRoleDict[];
  scenes?: ScreenplayResultSceneDict[];
  logline?: string;
  genre_tone?: string;
  synopsis?: string;
  themes?: string;
}
export interface VoiceRoleDict {
  id?: string;
  label?: string;
  kind?: string;
  source_character?: string;
  voice_description?: string;
}
export interface ScreenplayResultSceneDict {
  scene_number?: number;
  location?: string;
  interior_exterior?: string;
  time_of_day?: string;
  characters?: string[];
  entries?: ScreenplayEntryDict[];
}
export interface ScriptDialogueDict {
  character?: string;
  text?: string;
  emotion?: string;
  scene_number?: number;
  type?: string;
  voice_role_id?: string;
}
export interface ScriptScreenplaySceneDict {
  scene_number?: number;
  location?: string;
  interior_exterior?: string;
  time_of_day?: string;
  characters?: string[];
  entries?: {
    [k: string]: string;
  }[];
}
export interface SoundAudioHistoryEntryDict {
  user_prompt?: string;
  result?: _SoundAudioResultDict;
  metadata?: SoundGenerationMetadataDict;
  voice_profile?: VoiceProfileDict;
}
export interface _SoundAudioResultDict {
  local_path?: string;
  metadata?: AudioAssetMetadataDict;
}
export interface SoundGenerationMetadataDict {
  model?: string;
  provider?: string;
  mode?: string;
  loop?: string;
  lyrics_mode?: "auto" | "custom" | "instrumental";
  segments?: number;
  segment_start_times?: number[];
  character_name?: string;
  voice_id?: string;
  voice_type?: string;
  duration_seconds?: number;
}
export interface VoiceProfileDict {
  provider?: string;
  voice_id?: string;
  voice_name?: string;
  description?: string;
  voice_prompt?: string;
  name?: string;
  audio_sample?: string;
  speech_text?: string;
  characteristics?: string[];
  pronunciation_guide?: string;
  voice_source?: string;
  voice_ref?: string;
  language?: string;
  locale?: string;
  use_case?: string;
  descriptors?: string[];
}
export interface SoundGeneratedAudioDict {
  history?: SoundAudioHistoryEntryDict[];
  picked_index?: number;
}
export interface SpeechSegmentDict {
  character?: string;
  emotion?: string;
  timeRange?: string;
  audioUrl?: string;
  versions?: number;
  selectedVersion?: number;
}
export interface SpeechWindowDict {
  start_s?: number;
  end_s?: number;
  confidence?: number;
  text?: string;
}
export interface StoryContextDict {
  synopsis?: string;
  characters?: string[];
  setting?: string;
}
export interface StoryDirectionFieldDict {
  value?: string;
  status?: string;
}
export interface StoryboardEntryDict {
  panel_index?: number;
  description?: string;
  characters?: string[];
}
export interface ShotListFramingPresetCatalog {
  shot?: "WS (Wide Shot)" | "MS (Medium Shot)" | "CU (Close-Up)" | "OTS" | "POV" | "ECU (Extreme Close-Up)";
  angle?: "Eye-Level" | "Low-Angle" | "High-Angle" | "Dutch Tilt" | "Over-the-Shoulder";
  lens?: "24 mm / f2.8" | "35 mm / f2.8" | "50 mm / f2.2" | "85 mm / f1.8";
  focus?: "Shallow Focus" | "Medium Focus" | "Deep Focus";
}
export interface ShotListChoiceV2Dict {
  preset_id?: string;
  custom?: string;
}
export interface ShotListLensV2Dict {
  focal_length_mm: number;
  aperture_f_number: number;
  preset_id?: string;
}
export interface ShotListFramingV2Dict {
  shot?: ShotListChoiceV2Dict1;
  angle?: ShotListChoiceV2Dict2;
  lens?: ShotListLensV2Dict1;
  focus?: ShotListChoiceV2Dict3;
}
export interface ShotListChoiceV2Dict1 {
  preset_id?: string;
  custom?: string;
}
export interface ShotListChoiceV2Dict2 {
  preset_id?: string;
  custom?: string;
}
export interface ShotListLensV2Dict1 {
  focal_length_mm: number;
  aperture_f_number: number;
  preset_id?: string;
}
export interface ShotListChoiceV2Dict3 {
  preset_id?: string;
  custom?: string;
}
export interface GeneratedShotRowV2Dict {
  id: string;
  generation_id: string;
  scene_ordinal: number;
  scene_fingerprint: string;
  source_unit_refs: string[];
  duration_ms: number;
  visual_description: string;
  location: string;
  interior_exterior: string;
  framing?: ShotListFramingV2Dict1;
  camera_movement: string;
  dialogue_voiceover: string;
  sfx: string;
  source_truth: "SUPPLIED" | "PROPOSED" | "TBC";
  time_of_day?: string;
  purpose?: string;
  visual_prompt?: string;
  continuity_in?: string;
  continuity_out?: string;
  lighting?: string;
}
export interface ShotListFramingV2Dict1 {
  shot?: ShotListChoiceV2Dict1;
  angle?: ShotListChoiceV2Dict2;
  lens?: ShotListLensV2Dict1;
  focus?: ShotListChoiceV2Dict3;
}
export interface ShotSeamDict {
  id: string;
  transition: string;
  motivation?: string;
  boundary_type?: "Continuous" | "Soft" | "Hard";
}
export interface ShotFrameJobSlotDict {
  shot_id: string;
  shot_index: number;
  role: "start" | "key" | "end";
  prompt: string;
}
export interface ShotFrameLinkDict {
  version: 1;
  shot_id: string;
  shot_index: number;
  role: "start" | "key" | "end";
  node_id: string;
  status: "pending" | "ready" | "failed" | "stale";
  source_fingerprint: string;
  error?: string;
}
export interface ShotListRowDict {
  id: string;
  shot_number?: string;
  scene_ordinal?: number;
  duration_ms: number;
  visual_description: string;
  location?: string;
  framing_shot?: string;
  framing_angle?: string;
  framing_lens?: string;
  framing_focus?: string;
  camera_movement?: string;
  transition_in?: string;
  transition_out?: string;
  dialogue_voiceover?: string;
  sfx?: string;
}
export interface StoryboardMetadataDict {
  aspect_ratio?: string;
  scene_id?: string;
  regenerated?: boolean;
  regeneration_time?: string;
  model?: string;
  source_signature?: string;
}
export interface TimelineAudioConfigDict {
  id?: string;
  label?: string;
  source_path?: string;
  start_time?: number;
  end_time?: number;
  volume?: number;
  audio_kind?:
    | "audio"
    | "music"
    | "sfx"
    | "speech"
    | "extracted_original_audio"
    | "changed_voice"
    | "isolated_voice"
    | "isolated_background";
  role?: "original" | "replacement" | "sfx" | "music";
  start_offset?: number;
  planned_end_offset?: number;
  source_video_clip_id?: string;
  speed?: number;
  track_index?: number;
  muted?: boolean;
  split_group_id?: string | null;
  peak_dbfs?: number | null;
  fade_in_s?: number;
  fade_out_s?: number;
  original_duration?: number;
  source_node_id?: string;
}
export interface TimelineClipConfigDict {
  id?: string;
  source_path?: string;
  start_time?: number;
  end_time?: number;
  order?: number;
  speed?: number;
  start_offset?: number;
  track_index?: number;
  volume?: number;
  muted?: boolean;
  fade_out_s?: number;
  fade_in_s?: number;
  fade_color?: "black" | "white";
  adjustments?: TimelineVisualAdjustmentsDict;
  speed_curve?: TimelineSpeedCurveDict;
  audio_fade_in_s?: number;
  audio_fade_out_s?: number;
  original_duration?: number;
  source_node_id?: string;
}
export interface TimelineVisualAdjustmentsDict {
  brightness?: number;
  contrast?: number;
  saturation?: number;
  scale?: number;
  position_x?: number;
  position_y?: number;
  rotation?: number;
  flip_horizontal?: boolean;
  flip_vertical?: boolean;
}
export interface TimelineSpeedCurveDict {
  source_path: string;
  source_start: number;
  source_end: number;
  points: TimelineSpeedPointDict[];
  render_duration: number;
}
export interface TimelineSpeedPointDict {
  position: number;
  speed: number;
}
export interface TimelineConfigDict {
  operation: "timeline_render";
  timeline: TimelinePayloadDict;
}
export interface TimelinePayloadDict {
  clips?: TimelineClipConfigDict[];
  text_overlays?: EditSpecOverlayDict[];
  text_format?: EditSpecFormatDict;
  audio?: TimelineAudioConfigDict | null;
  audio_tracks?: TimelineAudioConfigDict[] | null;
  video_tracks_meta?: TimelineTrackMetaDict[] | null;
  audio_tracks_meta?: TimelineTrackMetaDict[] | null;
  total_duration?: number;
  video_track_count?: number;
  audio_track_count?: number;
  magnet_enabled?: boolean;
}
export interface EditSpecOverlayDict {
  style?: EditSpecTextStyleDict;
  visible?: boolean;
  width_pct?: number;
  rotation?: number;
  layer?: number;
  id: string;
  kind: "text";
  text: string;
  start_seconds: number;
  duration_seconds: number;
  x: number;
  y: number;
  anchor?: "top_left" | "top_center" | "top_right" | "center" | "bottom_left" | "bottom_center" | "bottom_right";
  style_preset?:
    | "bold_caption"
    | "title_card"
    | "tag"
    | "subtitle"
    | "lower_third"
    | "pill_pop"
    | "badge"
    | "highlight"
    | "kicker"
    | "editorial"
    | "editorial_sub";
  animation?: "none" | "pop" | "fade" | "slide_up" | "typewriter";
}
export interface EditSpecTextStyleDict {
  font_family?: "display" | "sans" | "mono";
  appearance_preset?:
    | "none"
    | "white_black_outline"
    | "white_double_outline"
    | "white_shadow"
    | "white_soft_shadow"
    | "yellow_black_outline"
    | "red_white_outline"
    | "orange_white_outline"
    | "blue_white_outline"
    | "green_black_outline"
    | "black_gray_box"
    | "white_gray_box"
    | "black_yellow_box"
    | "white_purple_box"
    | "purple_white_box"
    | "black_white_box"
    | "white_black_box"
    | "green_black_box"
    | "green_offset"
    | "yellow_red_shadow"
    | "white_pink_glow"
    | "white_yellow_glow"
    | "white_green_glow";
  scale_x?: number;
  scale_y?: number;
  font_size?: number;
  bold?: boolean;
  italic?: boolean;
  underline?: boolean;
  text_align?: "left" | "center" | "right";
  text_case?: "none" | "uppercase" | "lowercase" | "capitalize";
  color?: string;
  background_color?: string;
  background_opacity?: number;
  padding?: number;
  border_radius?: number;
  letter_spacing?: number;
  line_height?: number;
  outline?: "none" | "soft" | "strong";
  shadow?: "none" | "soft" | "strong";
}
export interface EditSpecFormatDict {
  aspect: "9:16" | "1:1" | "16:9";
  width: number;
  height: number;
  fps: number;
}
export interface TimelineTrackMetaDict {
  track_index?: number;
  muted?: boolean;
}
export interface TransitionDict {
  type?: string;
  description?: string;
  from_panel?: string;
  to_panel?: string;
}
export interface TtsSegmentDict {
  character?: string;
  text?: string;
  start_s?: number;
  end_s?: number;
  index?: number;
  audio_path?: string;
  duration_s?: number;
  path?: string;
  original_path?: string;
  tts_end_s?: number;
  emotion?: string;
  status?: string;
  type?: string;
  voice_role_id?: string;
  versions?: TtsVersionDict[];
}
export interface NativeSpeechTakeDict {
  clip_id?: string;
  source_sig?: string;
  versions?: TtsVersionDict[];
  selected_label?: string;
}
export interface NativeSpeechSpanDict {
  lane_id?: string;
  source_sig?: string;
  start_s?: number;
  end_s?: number;
  text?: string;
  confidence?: number;
}
export interface UpstreamContextDict {
  role?: string;
  name?: string;
  description?: string;
  prompt?: string;
  style?: string;
  aspect_ratio?: string;
  scene_id?: string;
  source_node_id?: string;
  source_node_type?: string;
  source_output?: string;
  local_path?: string;
}
export interface VlmValidationIssueDict {
  category?: string;
  severity?: string;
  description?: string;
  region?: string;
}
export interface VlmValidationReportDict {
  overall_score?: number;
  issues?: VlmValidationIssueDict[];
  summary?: string;
  passed?: boolean;
  validated_at?: string;
  model_used?: string;
}
export interface VoiceMapEntryDict {
  voice_id?: string;
  voice_name?: string;
}
export interface VoiceSettingsDict {
  stability?: number;
  similarity_boost?: number;
  style?: number;
  speed?: number;
}
export interface WebtoonDialogueDict {
  character?: string;
  text?: string;
}
export interface ResolvedVoiceMapDict {
  [k: string]: string;
}
export interface VoiceMapDict {
  [k: string]: string;
}
export interface SpeechTransformerSpanDict {
  id?: string;
  start_s?: number;
  end_s?: number;
  dirty?: boolean;
  synth_path?: string;
}
export interface SpeechTransformerSpeakerDict {
  character?: string;
  voice_role_id?: string;
  target_voice_id?: string;
  spans?: SpeechTransformerSpanDict[];
}
export interface SpeechTransformerAudioSplitDict {
  enabled?: boolean;
  status?: "success" | "skipped";
  fallbackReason?:
    | "silent_source"
    | "silent_vocals"
    | "provider_timeout"
    | "separator_model_missing"
    | "user_disabled"
    | "source_mismatch"
    | "source_too_long"
    | "no_audio_stream";
  sourceSha256?: string;
  extractorVersion?: string;
  vocalsKey?: string;
  backgroundKey?: string;
  provider?: string;
  modelVersion?: string;
  jobId?: string;
}
export interface SpeechTransformerConfigDict {
  rows?: SpeechTransformerSpeakerDict[];
  sourceOriginalIndex?: number;
  sourceOriginalPath?: string;
  duckDepthDb?: number;
  audioSplit?: SpeechTransformerAudioSplitDict;
}
export interface SpeechTransformerDetectionDict {
  rows?: SpeechTransformerSpeakerDict[];
  sourceOriginalIndex?: number;
  sourceOriginalPath?: string;
  audioSplit?: SpeechTransformerAudioSplitDict;
  detectStatus?: "ok" | "no_dialogue";
}
export interface EditSpecAudioDict {
  keep_original_audio?: boolean;
  original_audio_gain?: number;
  duck_gain?: number;
  tracks?: EditSpecAudioTrackDict[];
}
export interface EditSpecAudioTrackDict {
  id: string;
  source: EditSpecSourceRefDict;
  role: "music" | "voiceover" | "sfx";
  start_seconds: number;
  end_seconds?: number;
  gain?: number;
  fade_in_seconds?: number;
  fade_out_seconds?: number;
  loop?: boolean;
}
export interface EditSpecSourceRefDict {
  node_id: string;
  output_port: "out_video" | "out_audio" | "out_image";
  media_type: "video" | "audio" | "image";
  history_index?: number;
}
export interface EditSpecCaptionSegmentDict {
  style?: EditSpecTextStyleDict;
  visible?: boolean;
  width_pct?: number;
  rotation?: number;
  layer?: number;
  x?: number;
  y?: number;
  anchor?: "top_left" | "top_center" | "top_right" | "center" | "bottom_left" | "bottom_center" | "bottom_right";
  id: string;
  text: string;
  start_seconds: number;
  end_seconds: number;
  words?: EditSpecCaptionWordDict[];
}
export interface EditSpecCaptionWordDict {
  text: string;
  start_seconds: number;
  end_seconds: number;
}
export interface EditSpecCaptionsDict {
  style_preset:
    | "beasty"
    | "bold_white_upper"
    | "boxed"
    | "bubble_white"
    | "clean_white"
    | "cream_editorial"
    | "gold_lux"
    | "highlighter_mint"
    | "highlighter_yellow"
    | "karaoke_yellow"
    | "minimal_gray"
    | "mono_upper"
    | "neon_cyan"
    | "neon_magenta"
    | "purple_pop"
    | "red_alert"
    | "subtitle_classic"
    | "sunny"
    | "tiktok_pop"
    | "tiktok_pop_blue"
    | "tiktok_pop_green"
    | "word_pop_black";
  segments: EditSpecCaptionSegmentDict[];
  font_scale?: number;
}
export interface EditSpecClipDict {
  id: string;
  source: EditSpecSourceRefDict;
  in_seconds: number;
  out_seconds: number;
  speed?: number;
  volume?: number;
  muted?: boolean;
  effects?: ("ken_burns_in" | "ken_burns_out" | "punch_in" | "grain")[];
  transition_in?: EditSpecTransitionDict;
  transform?: EditSpecTransformDict;
}
export interface EditSpecTransitionDict {
  type?: "none" | "fade" | "slide" | "wipe" | "flip" | "clock_wipe";
  duration_s?: number;
  direction?: "from_left" | "from_right" | "from_top" | "from_bottom";
}
export interface EditSpecTransformDict {
  reframe?: "cover" | "contain" | "smart";
  focus_x?: number;
  focus_y?: number;
  scale?: number;
}
export interface EditSpecColorGradeDict {
  lut?: "none" | "warm" | "cool" | "teal_orange" | "vivid" | "film" | "bw";
  exposure?: number;
  contrast?: number;
  saturation?: number;
  temperature?: number;
}
export interface EditSpecDict {
  version: number;
  format: EditSpecFormatDict;
  clips: EditSpecClipDict[];
  overlays?: EditSpecOverlayDict[];
  overlay_clips?: EditSpecOverlayClipDict[];
  stage?: EditSpecStageDict;
  captions?: EditSpecCaptionsDict;
  audio?: EditSpecAudioDict;
  color_grade?: EditSpecColorGradeDict;
}
export interface EditSpecOverlayClipDict {
  id: string;
  role: "graphic" | "broll" | "pip";
  layer: number;
  source?: EditSpecSourceRefDict;
  graphic_sources?: EditSpecSourceRefDict[];
  component_kind?:
    | "chapter_card"
    | "quote_card"
    | "stat_countup"
    | "bar_chart"
    | "lower_third_card"
    | "image_card"
    | "top_list"
    | "atmosphere_bg"
    | "cta_card";
  component_props?: {
    [k: string]:
      | string
      | number
      | boolean
      | null
      | (string | number | boolean | null)[]
      | {
          [k: string]: string | number | boolean | null;
        }[];
  };
  theme?: "dark" | "light" | "bold" | "editorial" | "neon";
  start_seconds: number;
  duration_seconds: number;
  x?: number;
  y?: number;
  anchor?: "top_left" | "top_center" | "top_right" | "center" | "bottom_left" | "bottom_center" | "bottom_right";
  width_pct?: number;
  height_pct?: number;
  opacity?: number;
}
export interface EditSpecStageDict {
  template: "full" | "presenter_pip_tr" | "presenter_left" | "split_2up" | "grid_4up";
  theme?: string;
  background?: EditSpecStageBackgroundDict;
}
export interface EditSpecStageBackgroundDict {
  kind?: "solid" | "gradient" | "blur_broll";
  color?: string;
}
export interface AnnotationPointDict {
  x: number;
  y: number;
}
export interface ImageAnnotationDict {
  id: string;
  kind: string;
  color: string;
  stroke_width: number;
  points: AnnotationPointDict[];
  text?: string;
  font_size?: number;
  label?: string;
}
export interface AudioTakeSelectionDict {
  variant_path: string;
  clip_id: string;
  selected_label: string;
  selected_path: string;
  source_sig?: string;
}
export interface AudioTakeSelectionMapDict {
  [k: string]: AudioTakeSelectionDict;
}
export interface MotionDocumentDict {
  version: number;
  elements: MotionElementDict[];
}
export interface MotionElementDict {
  id: string;
  kind: "text" | "shape" | "image" | "video" | "audio";
  start_seconds: number;
  duration_seconds: number;
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  text?: string;
  source?: MotionSourceRefDict;
  color?: string;
  opacity?: number;
  scale_x?: number;
  scale_y?: number;
  rotation?: number;
  font_size?: number;
  font_weight?: number;
  border_radius?: number;
  volume?: number;
  fit?: "cover" | "contain" | "fill";
  keyframes?: MotionKeyframeDict[];
}
export interface MotionSourceRefDict {
  node_id: string;
  output_port: "out_video" | "out_audio" | "out_image";
  history_index?: number;
}
export interface MotionKeyframeDict {
  at: number;
  x?: number;
  y?: number;
  scale_x?: number;
  scale_y?: number;
  rotation?: number;
  opacity?: number;
  easing?: "linear" | "ease_in" | "ease_out" | "ease_in_out";
}
export interface AudioMutationReceiptDict {
  programId: string;
  programFingerprint: string;
  priorRevision: number;
  resultingRevision: number;
  compositionFingerprint: string;
}
export interface AudioVariantWorkspaceCleanDict {
  workspaceVersion: 1;
  variantRef: string;
  variantPath: string;
  variantAssetId: string;
  baseFingerprint: string;
  state: "clean";
  revision: number;
  recentMutationReceipts: AudioMutationReceiptDict[];
  composition: null;
}
export interface AudioVariantWorkspaceDraftDict {
  workspaceVersion: 1;
  variantRef: string;
  variantPath: string;
  variantAssetId: string;
  baseFingerprint: string;
  state: "draft";
  revision: number;
  recentMutationReceipts: AudioMutationReceiptDict[];
  composition: UnifiedAudioProjectV2;
}
export interface AudioVariantWorkspaceMapDict {
  [k: string]: AudioVariantWorkspaceDict;
}
export interface ScriptVariantDict {
  id: string;
  ordinal: number;
  label: string;
  model: string;
  created_at: string;
  script: string;
  scene_count?: number;
  screenplay?: ScreenplayResultSceneDict[];
  logline?: string;
  genre_tone?: string;
  synopsis?: string;
  themes?: string;
}
export interface VideoFullRemixStatusV1Dict {
  version: 1;
  source: "initial_generate" | "manual_apply" | "director_apply" | "unknown";
  state: "requested" | "preflighting" | "applying" | "completed" | "failed" | "cancelled" | "skipped";
  attempt_id: string;
  batch_id?: string | null;
  batch_revision?: number | null;
  batch_state?:
    | ("preflighting" | "awaiting_confirmation" | "applying" | "completed" | "partial_failure" | "failed" | "cancelled")
    | null;
  target_phase?: ("preflight" | "execution") | null;
  target_state?:
    | ("pending" | "analyzing" | "retry_wait" | "ready" | "queued" | "running" | "applied" | "failed" | "skipped")
    | null;
  target_step?:
    | (
        | "queued"
        | "transcribing"
        | "matching_characters"
        | "isolating_speech"
        | "ready"
        | "applying"
        | "completed"
        | "failed"
      )
    | null;
  source_variant_ref?: string | null;
  source_variant_path?: string | null;
  source_variant_index?: number | null;
  resulting_variant_index?: number | null;
  resulting_variant_path?: string | null;
  message?: string | null;
  error?: string | null;
  error_code?: string | null;
  retryable?: boolean;
  updated_at?: string;
}
export interface TimelineTimeEditRequestDict {
  source_path: string;
  mode: "reverse" | "freeze" | "speed_curve";
  start_time: number;
  end_time: number;
  freeze_at: number;
  points?: TimelineSpeedPointDict[];
}
export interface TimelineTimeEditStatusDict {
  job_id: string;
  status: "pending" | "running" | "success" | "failed" | "cancelled";
  source_path: string | null;
  duration: number | null;
  error: string | null;
}
export interface EditSpecTextPlacementDict {
  style?: EditSpecTextStyleDict;
  visible?: boolean;
  width_pct?: number;
  rotation?: number;
  layer?: number;
  x?: number;
  y?: number;
  anchor?: "top_left" | "top_center" | "top_right" | "center" | "bottom_left" | "bottom_center" | "bottom_right";
}
export interface MediaAssetRefDict {
  history?: {
    [k: string]: unknown;
  }[];
  picked_index?: number;
  media_type?: "image" | "video" | "audio";
  source_node_id?: string;
}
export interface ShotProductionChangeDict {
  element_id: string;
  value: string;
  owner: "on_screen" | "off_screen";
  account: string;
}
export interface ShotProductionPlanDict {
  version: 1;
  baseline_generation_id: string;
  production_job_id: string;
  screenplay_fingerprint: string;
  planning_status: "DRAFT" | "PROMPT-COMPLETE";
  render_readiness: "BLOCKED";
  render_blockers: string[];
  scenes: ShotProductionSceneProposalDict[];
  shots: ShotProductionShotDict[];
  seams: ShotProductionSeamProposalDict[];
  pending_decisions: string[];
}
export interface ShotProductionSceneProposalDict {
  scene_ordinal: number;
  strand_id: string;
}
export interface ShotProductionShotDict {
  shot_id: string;
  scene_ordinal: number;
  strand_id: string;
  source: ShotProductionSourceDict[];
  changes: ShotProductionChangeDict[];
  flow: string;
  action: string;
  motion_prompt: string;
  keyframe_prompt: string;
  audio_route: "SILENT" | "SEPARATE" | "TBC";
  ledger_in: ShotProductionStateDict[];
  ledger_out: ShotProductionStateDict[];
}
export interface ShotProductionSourceDict {
  ref: string;
  entry_type: string;
  speaker: string;
  text: string;
}
export interface ShotProductionStateDict {
  element_id: string;
  value: string;
  truth: "SUPPLIED" | "PROPOSED" | "TBC";
}
export interface ShotProductionSeamProposalDict {
  seam_id: string;
  time_relation: "continuous" | "simultaneous" | "elapsed" | "unknown";
  carrier: string;
  cut_point: string;
  motivation: string;
  execution: string;
}
export interface ShotProductionProposalDict {
  scenes: ShotProductionSceneProposalDict[];
  shots: ShotProductionShotProposalDict[];
  seams: ShotProductionSeamProposalDict[];
  pending_decisions: string[];
}
export interface ShotProductionShotProposalDict {
  shot_id: string;
  source_refs: string[];
  flow: string;
  action: string;
  motion_prompt: string;
  keyframe_prompt: string;
  changes: ShotProductionChangeDict[];
}
export interface ShotKeyFrameRelinkDict {
  shot_id: string;
  image: string;
}
export interface ShotVideoAnchorDict {
  shot_id: string;
  role: "first" | "last";
  image: string;
  exact?: boolean;
  origin?: "user_relink";
}
export interface ShotVideoGenerationPlanDict {
  version: 1 | 2 | 3;
  source_generation_id: string;
  source_fingerprint: string;
  request_fingerprint: string;
  reference_candidate_fingerprint?: string;
  excluded_visual_reference_ids?: string[];
  voice_candidate_fingerprint?: string;
  speech_source_fingerprint?: string;
  speech_policy?: "screenplay_units_v1";
  excluded_voice_reference_ids?: string[];
  voice_policy?: "screenplay_units" | "disabled" | "no_screenplay_evidence";
  asset_paths: {
    [k: string]: string;
  };
  packs: ShotVideoPackDict[];
  source_shots?: GeneratedShotRowV2Dict[];
  source_seams?: ShotSeamDict[];
  source_key_frames?: {
    [k: string]: string;
  };
}
export interface ShotVideoPackDict {
  id: string;
  generation_id: number;
  shot_ids: string[];
  duration_ms: number;
  mode: string;
  model: string;
  resolution: string;
  references: string[];
  auto_references?: string[];
  skipped_auto_references?: ShotVideoAutoReferenceDecisionDict[];
  voice_references?: ShotVideoVoiceReferenceDict[];
  audio_references?: ShotVideoAudioReferenceDict[];
  skipped_voice_references?: ShotVideoVoiceDecisionDict[];
  mixed_video_node_id?: string;
  speech_node_ids?: string[];
  master_frames?: string[];
  prompt_only_master_frames?: string[];
  exact_first?: string;
  exact_last?: string;
  predecessor_id?: string;
  cut_reason: string;
  video_node_id: string;
  authoring_fingerprint?: string;
  reused_source_fingerprint?: string;
  reused_request_fingerprint?: string;
}
export interface ShotVideoAutoReferenceDecisionDict {
  node_id: string;
  reason: string;
}
export interface ShotVideoVoiceReferenceDict {
  speaker: string;
  node_id: string;
  port: string;
  brief_sha256: string;
}
export interface ShotVideoAudioReferenceDict {
  speaker: string;
  node_id: string;
  port: string;
  asset_path: string;
}
export interface ShotVideoVoiceDecisionDict {
  speaker: string;
  reason: string;
  node_id?: string;
}

export type NodeStatus = 'pending_execution' | 'running' | 'completed' | 'error' | 'idle' | 'pending_cost_confirmation'

export const NODE_STATUSES: readonly NodeStatus[] = ['pending_execution', 'running', 'completed', 'error', 'idle', 'pending_cost_confirmation']

/** USD per image, by backend image-model pricing key.
 *
 * gemini-3.1-flash-image-preview has tiered keys (1k_2k / 4k); every
 * other non-GPT-Image model has a flat per_image rate. Mirrors google_pricing.json. */
export const IMAGE_MODEL_USD_PER_IMAGE: Record<string, { per_image?: number; per_image_1k_2k?: number; per_image_4k?: number }> = {
  'gemini-2.5-flash-image': { per_image: 0.039 },
  'gemini-3.1-flash-image-preview': { per_image_1k_2k: 0.134, per_image_4k: 0.24 },
  'gemini-3.1-flash-lite-image': { per_image: 0.034 },
  'gemini-nano-banana-2.1': { per_image_1k_2k: 0.134, per_image_4k: 0.24 },
  'imagen-4.0-fast-generate-001': { per_image: 0.02 },
  'imagen-4.0-generate-001': { per_image: 0.04 },
  'imagen-4.0-ultra-generate-001': { per_image: 0.06 },
  'mango-ember-drift': { per_image: 0.039 },
  'openai-gpt-image-2': { per_image: 0.053 },
  'openai-gpt-image-2.5-flare': { per_image: 0.053 },
  'openai-gpt-image-2.5-sunburst': { per_image: 0.053 },
}

export const GPT_IMAGE_MODEL_IDS: ReadonlySet<string> = new Set(['openai-gpt-image-2', 'openai-gpt-image-2.5-flare', 'openai-gpt-image-2.5-sunburst'])

export const GPT_IMAGE_2_PRICE_BASELINE_PIXELS = 1572864
export const LOCATION_PANORAMA_SOURCE_MODEL_ID = 'openai-gpt-image-2'
export const LOCATION_PANORAMA_SOURCE_PIXELS = 7372800
/** Output pixels by GPT Image resolution tier, then aspect label. */
export const GPT_IMAGE_2_SIZE_PIXELS_BY_TIER: Record<string, Record<string, number>> = {
  '1K': {
    '3:2': 1572864,
    '2:3': 1572864,
    '1:1': 1048576,
    '16:9': 2985984,
    '9:16': 2985984,
    '3:4': 1769472,
    '4:3': 1769472,
    '2:1': 2097152,
    '5:4': 1310720,
    '4:5': 1310720,
    '21:9': 2370816,
    '9:21': 2370816,
  },
  '2K': {
    '3:2': 4153344,
    '2:3': 4153344,
    '1:1': 4194304,
    '16:9': 5308416,
    '9:16': 5308416,
    '3:4': 4205568,
    '4:3': 4205568,
    '2:1': 4239872,
    '5:4': 4305920,
    '4:5': 4305920,
    '21:9': 4214784,
    '9:21': 4214784,
  },
  '4K': {
    '3:2': 8185344,
    '2:3': 8185344,
    '1:1': 8294400,
    '16:9': 8294400,
    '9:16': 8294400,
    '3:4': 7990272,
    '4:3': 7990272,
    '2:1': 7372800,
    '5:4': 8192000,
    '4:5': 8192000,
    '21:9': 6214656,
    '9:21': 6214656,
  },
}

/** Compute sparks cost for ONE image generation (no count multiplier).
 *
 * Mirrors backend CostEstimator._resolve_image_pricing + usd_to_sparks:
 *   - tiered image models: per_image_4k when quality is '4K',
 *     else per_image_1k_2k (tiered).
 *   - GPT Image models: per_image baseline scaled by the (tier, aspect) size
 *     when an aspect is supplied; tier defaults to 1K.
 *   - any other model: flat per_image.
 *   - sparks = round(usd * SPARKS_PER_USD) for usd > 0, else 0.
 * Returns 0 for unknown models so the UI degrades gracefully rather
 * than showing a misleading hardcoded number. Multiply by the run
 * count at the call site (round-per-image-then-multiply), never round
 * after multiplying — matches orchestrator `estimate.sparks *= count`. */
export function imageSparksPerGeneration(model: string, quality: string | undefined, aspectRatio?: string): number {
  const rates = IMAGE_MODEL_USD_PER_IMAGE[model]
  if (!rates) return 0
  let usd: number | undefined
  if (rates.per_image_1k_2k !== undefined) {
    const wants4k = typeof quality === 'string' && quality.trim().toUpperCase() === '4K'
    usd = wants4k ? rates.per_image_4k : rates.per_image_1k_2k
  } else {
    usd = rates.per_image
  }
  if (usd === undefined || usd <= 0) return 0
  if (GPT_IMAGE_MODEL_IDS.has(model) && aspectRatio !== undefined) {
    const pixels = GPT_IMAGE_2_SIZE_PIXELS_BY_TIER[quality ?? '1K']?.[aspectRatio]
    if (pixels !== undefined) usd *= pixels / GPT_IMAGE_2_PRICE_BASELINE_PIXELS
  }
  return generationUsdToSparks(usd)
}

/** Compute sparks cost for one Location 720 panorama source generation.
 *
 * Mirrors the backend panorama contract: the node omits in_model, but
 * the worker generates exactly one source image with the backend-owned
 * panorama model and 3840x1920 exact-size request. */
export function locationPanoramaSparksPerGeneration(): number {
  const rates = IMAGE_MODEL_USD_PER_IMAGE[LOCATION_PANORAMA_SOURCE_MODEL_ID]
  const usd = rates?.per_image
  if (usd === undefined || usd <= 0) return 0
  const scaledUsd = usd * (LOCATION_PANORAMA_SOURCE_PIXELS / GPT_IMAGE_2_PRICE_BASELINE_PIXELS)
  return generationUsdToSparks(scaledUsd)
}

/** USD per generation, by backend audio-model pricing key.
 *
 * Only models with a per_generation rate are emitted. Mirrors
 * google_pricing.json. */
export const AUDIO_MODEL_USD_PER_GENERATION: Record<string, number> = {
  'elevenlabs': 0.3,
  'gemini-2.5-flash': 0.01,
}

/** Compute sparks cost for ONE audio generation (no count multiplier).
 *
 * Mirrors backend CostEstimator per_generation branch + usd_to_sparks:
 * sparks = round(usd * SPARKS_PER_USD) for usd > 0, else 0. Returns 0 for
 * unknown models so the UI degrades gracefully. sound_expert resolves
 * to 'elevenlabs' (NODE_PRICING['sound_expert']) → 6. Multiply by the
 * run count at the call site. */
export function audioSparksPerGeneration(model: string): number {
  const usd = AUDIO_MODEL_USD_PER_GENERATION[model]
  if (usd === undefined || usd <= 0) return 0
  return generationUsdToSparks(usd)
}

/** USD per second of video output, by backend pricing key. */
export const VIDEO_MODEL_USD_PER_SECOND: Record<string, { default: number; [resolution: string]: number }> = {
  'gemini-omni-1.1-flash-preview': { default: 0.1 },
  'gemini-omni-flash-preview': { default: 0.1 },
  'mango-video-image-to-video': { default: 0.0 },
  'mango-video-text-to-video': { default: 0.0 },
  'minimax-h3-fast-image-to-video-atlas-cloud': { default: 0.044 },
  'minimax-h3-fast-reference-to-video-atlas-cloud': { default: 0.044 },
  'minimax-h3-fast-text-to-video-atlas-cloud': { default: 0.044 },
  'minimax-h3-image-to-video-atlas-cloud': { default: 0.038 },
  'minimax-h3-image-to-video-meta-hosted': { default: 0.01 },
  'minimax-h3-max-turbo-image-to-video-atlas-cloud': { default: 0.132 },
  'minimax-h3-max-turbo-text-to-video-atlas-cloud': { default: 0.132 },
  'minimax-h3-reference-to-video': { default: 0.13, '480p': 0.05, '768p': 0.08, '2k': 0.13, '4k': 0.16 },
  'minimax-h3-reference-to-video-atlas-cloud': { default: 0.038 },
  'minimax-h3-reference-to-video-meta-hosted': { default: 0.01 },
  'minimax-h3-text-to-video-atlas-cloud': { default: 0.038 },
  'muse-video-1.0': { default: 0.01 },
  'muse-video-1.0-r2v': { default: 0.01 },
  'seedance-2.0-image-to-video': { default: 0.3 },
  'seedance-2.0-image-to-video-atlas-cloud': { default: 0.3 },
  'seedance-2.0-reference-to-video': { default: 0.3 },
  'seedance-2.0-reference-to-video-atlas-cloud': { default: 0.3 },
  'seedance-2.5-first-last-frame-atlas-cloud': { default: 0.134 },
  'seedance-2.5-image-to-video-atlas-cloud': { default: 0.134 },
  'seedance-2.5-reference-to-video-atlas-cloud': { default: 0.134 },
  'seedance-2.5-video-editing-atlas-cloud': { default: 0.134 },
  'seedance-2.5-video-extension-atlas-cloud': { default: 0.134 },
  'veo-2.0-generate-001': { default: 0.35 },
  'veo-3.0-fast-generate-001': { default: 0.15 },
  'veo-3.0-generate-001': { default: 0.4 },
  'veo-3.1-fast-generate-preview': { default: 0.15, '720p_1080p': 0.15, '4k': 0.35 },
  'veo-3.1-generate-preview': { default: 0.4, '720p_1080p': 0.4, '4k': 0.6 },
}

/** Extra per-image charges after a model's included references. */
export const VIDEO_MODEL_REFERENCE_IMAGE_PRICING: Record<string, { included: number; additionalUsd: number }> = {
  'minimax-h3-reference-to-video': { included: 5, additionalUsd: 0.08 },
}

/** UI model name -> backend pricing key from google_pricing.json. */
export const VIDEO_MODEL_ALIAS: Record<string, string> = {
  'gemini-omni-1.1-flash-edit': 'gemini-omni-1.1-flash-preview',
  'gemini-omni-1.1-flash-extend': 'gemini-omni-1.1-flash-preview',
  'gemini-omni-1.1-flash-i2v': 'gemini-omni-1.1-flash-preview',
  'minimax-h3': 'minimax-h3-reference-to-video',
  'minimax-h3-atlas-cloud': 'minimax-h3-reference-to-video-atlas-cloud',
  'veo-3.1': 'veo-3.1-generate-preview',
}

/** Compute sparks cost for ONE video generation (no retry multiplier).
 *
 * Mirrors backend CostEstimator: sparks = round(perSecond * duration * SPARKS_PER_USD)
 * for any USD > 0, else 0. Returns 0 for unknown models so the UI degrades
 * gracefully rather than showing a misleading hardcoded number.
 */
export function videoSparksPerGeneration(model: string, resolution: string, durationSeconds: number, referenceImageCount = 0): number {
  if (!Number.isFinite(durationSeconds) || durationSeconds <= 0) return 0
  const lookupKey = VIDEO_MODEL_ALIAS[model] ?? model
  const tiers = VIDEO_MODEL_USD_PER_SECOND[lookupKey]
  if (!tiers) return 0
  const resolutionKey = typeof resolution === 'string' ? resolution.toLowerCase() : ''
  const perSecond = tiers[resolutionKey] ?? tiers.default
  if (!perSecond || perSecond <= 0) return 0
  const refPricing = VIDEO_MODEL_REFERENCE_IMAGE_PRICING[lookupKey]
  const extraReferenceImages = refPricing
    ? Math.max(0, Math.floor(referenceImageCount) - refPricing.included)
    : 0
  const usd = (perSecond * durationSeconds) +
    (extraReferenceImages * (refPricing?.additionalUsd ?? 0))
  return generationUsdToSparks(usd)
}

/** ElevenLabs sound-effect prompt ceiling — DISCLOSURE ONLY.
 *
 * GENERATED mirror of agentic_workflow.core.providers.audio_capability.
 * 450 is provider-observed (RFC-0777: a production 400 text_too_long
 * reporting 458/450), NOT a Dreamwrite choice.
 *
 * MUST NOT gate submission. RFC-1202 open question 1 resolves this to a
 * soft counter and warning only: blocking locally risks refusing a request
 * the provider would have accepted, and text_too_long is the provider
 * validating its own input (CLAUDE.md #7). Do not add a maxLength. */
export type TextLengthPolicy = {
  maxChars: number
  warnChars: number
}

export const SFX_PROMPT_POLICY: TextLengthPolicy = { maxChars: 450, warnChars: 400 }

/** ElevenLabs eleven_v3 text-to-speech script ceiling — DISCLOSURE ONLY.
 *
 * GENERATED mirror of agentic_workflow.core.providers.audio_capability.
 * 5000 is ElevenLabs' published per-request limit for eleven_v3 (RFC-1536).
 * Same rules as SFX_PROMPT_POLICY: soft counter and warning only, never a
 * maxLength and never wired into the Generate button. */
export const SPEECH_TEXT_POLICY: TextLengthPolicy = { maxChars: 5000, warnChars: 4500 }

/** ElevenLabs sound-effect duration bounds, in seconds.
 *
 * GENERATED mirror of agentic_workflow.core.providers.audio_capability.
 * Unlike the prompt ceiling this IS enforced backend-side — a request
 * outside the range is refused before dispatch, never clamped. */
export type SfxDurationPolicy = {
  minSeconds: number
  maxSeconds: number
}

export const SFX_DURATION_POLICY: SfxDurationPolicy = { minSeconds: 0.5, maxSeconds: 30 }

/** Node state field carrying the auto-generated-name marker. */
export const NAME_AUTOGEN_FIELD = "name_autogen"

/** One auto-generated default-name family. */
export type DefaultNodeName = {
  /** Marker token, and the i18n key under canvas:defaultNodeNames. */
  key: string
  /** Canonical English prefix, e.g. 'Panel'. */
  prefix: string
  /** Backend node type this family applies to. */
  nodeType: string
  /** Display field the name is stored in. */
  field: string
}

/** GENERATED from agentic_workflow.core.default_node_names.
 *
 * Stored names are deliberately English — the backend re-parses them to
 * compute ordinals and to resolve name-typed @-mentions. Localize at
 * render time only; never write a localized value back. */
export const DEFAULT_NODE_NAMES: DefaultNodeName[] = [
  { key: "videoGroup", prefix: "Video Group", nodeType: "node_group", field: "in_label" },
  { key: "storyboardGroup", prefix: "Storyboard Group", nodeType: "node_group", field: "in_label" },
  { key: "scene", prefix: "Scene", nodeType: "video_generator", field: "in_name" },
  { key: "gridVideo", prefix: "Grid Video", nodeType: "video_generator", field: "in_name" },
  { key: "video", prefix: "Video", nodeType: "video_generator", field: "in_name" },
  { key: "panel", prefix: "Panel", nodeType: "image_generator", field: "in_name" },
  { key: "grid", prefix: "Grid", nodeType: "image_generator", field: "in_name" },
  { key: "storyboardDesigner", prefix: "Storyboard Designer", nodeType: "storyboard_designer", field: "in_name" },
]

/** Per-model clip-duration policy (seconds).
 *
 * GENERATED mirror of the authoritative backend policy in
 * agentic_workflow.core.providers.video_duration_policy. videoConstraints.ts
 * consumes THIS — do not hand-write duration constants (single SoT).
 * Parity guard: videoDurationPolicy.parity.test.ts. */
export type VideoClipDurationPolicy = {
  allowed: number[] | null
  minS: number | null
  maxS: number | null
  fixedS: number | null
  forcedWithReferencesS: number | null
  resolutionOverrides: Record<string, number> | null
  providerSelected: boolean
  source: string
}

export const VIDEO_CLIP_DURATION_POLICY: Record<string, VideoClipDurationPolicy> = {
  'gemini-omni-flash-preview': { allowed: null, minS: 10, maxS: 10, fixedS: 10, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'gemini-omni-1.1-flash-preview': { allowed: null, minS: 3, maxS: 10, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'gemini-omni-1.1-flash-edit': { allowed: null, minS: null, maxS: null, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: true, source: 'native' },
  'gemini-omni-1.1-flash-extend': { allowed: null, minS: 3, maxS: 10, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'gemini-omni-1.1-flash-i2v': { allowed: null, minS: 3, maxS: 10, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'muse-video-1.0': { allowed: null, minS: 2, maxS: 10, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'muse-video-1.0-r2v': { allowed: null, minS: 2, maxS: 10, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'minimax-h3-reference-to-video-meta-hosted': { allowed: null, minS: 4, maxS: 15, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'minimax-h3-image-to-video-meta-hosted': { allowed: null, minS: 4, maxS: 15, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'veo-3.1': { allowed: [4, 6, 8], minS: 4, maxS: 8, fixedS: null, forcedWithReferencesS: 8, resolutionOverrides: { '1080p': 8, '4k': 8 }, providerSelected: false, source: 'native' },
  'seedance-2.0-image-to-video': { allowed: null, minS: 4, maxS: 15, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'seedance-2.0-reference-to-video': { allowed: null, minS: 4, maxS: 15, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'seedance-2.0-image-to-video-atlas-cloud': { allowed: null, minS: 4, maxS: 15, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'seedance-2.0-reference-to-video-atlas-cloud': { allowed: null, minS: 4, maxS: 15, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'seedance-2.5-image-to-video-atlas-cloud': { allowed: null, minS: 4, maxS: 30, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'seedance-2.5-first-last-frame-atlas-cloud': { allowed: null, minS: 4, maxS: 30, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'seedance-2.5-reference-to-video-atlas-cloud': { allowed: null, minS: 4, maxS: 30, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'seedance-2.5-video-editing-atlas-cloud': { allowed: null, minS: null, maxS: null, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: true, source: 'native' },
  'seedance-2.5-video-extension-atlas-cloud': { allowed: null, minS: null, maxS: null, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: true, source: 'native' },
  'minimax-h3-reference-to-video': { allowed: null, minS: 5, maxS: 15, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'minimax-h3-text-to-video-atlas-cloud': { allowed: null, minS: 4, maxS: 15, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'minimax-h3-image-to-video-atlas-cloud': { allowed: null, minS: 4, maxS: 15, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'minimax-h3-reference-to-video-atlas-cloud': { allowed: null, minS: 4, maxS: 15, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'minimax-h3-max-turbo-text-to-video-atlas-cloud': { allowed: null, minS: 5, maxS: 15, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'minimax-h3-max-turbo-image-to-video-atlas-cloud': { allowed: null, minS: 5, maxS: 15, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'minimax-h3-fast-text-to-video-atlas-cloud': { allowed: null, minS: 5, maxS: 15, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'minimax-h3-fast-image-to-video-atlas-cloud': { allowed: null, minS: 5, maxS: 15, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'minimax-h3-fast-reference-to-video-atlas-cloud': { allowed: null, minS: 5, maxS: 15, fixedS: null, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'mango-video-text-to-video': { allowed: null, minS: 10, maxS: 10, fixedS: 10, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
  'mango-video-image-to-video': { allowed: null, minS: 10, maxS: 10, fixedS: 10, forcedWithReferencesS: null, resolutionOverrides: null, providerSelected: false, source: 'native' },
}

/** BYOM missing-capability duration fallback (config selector only; NOT an
 * authoritative cap — the Director hedges when a BYOM cap is unknown). */
export const VIDEO_CLIP_DURATION_BYOM_FALLBACK: readonly number[] = [5, 6, 7, 8, 9, 10]

/** Per-model reference-media policy (counts + duration ceilings).
 *
 * GENERATED mirror of the authoritative backend policy in
 * agentic_workflow.core.providers.video_reference_policy. videoConstraints.ts
 * consumes THIS — do not hand-write reference constants (single SoT).
 *
 * Count semantics: 0 = unsupported, n = capped at n, null = no Dreamwrite
 * cap (BYOM stays fail-open; the provider owns the final say).
 * Parity guard: videoReferencePolicy.parity.test.ts. */
export type VideoReferencePolicy = {
  maxImages: number | null
  maxVideos: number | null
  maxAudios: number | null
  maxTotalReferences: number | null
  minVideoSecondsEach: number | null
  maxVideoSecondsEach: number | null
  maxVideoSecondsCombined: number | null
  minAudioSecondsEach: number | null
  maxAudioSecondsEach: number | null
  maxAudioSecondsCombined: number | null
  audioRequiresVisualAnchor: boolean
  source: string
}

export const VIDEO_REFERENCE_POLICY: Record<string, VideoReferencePolicy> = {
  'gemini-omni-1.1-flash': { maxImages: 10, maxVideos: 3, maxAudios: 0, maxTotalReferences: null, minVideoSecondsEach: null, maxVideoSecondsEach: 10.0, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'gemini-omni-1.1-flash-edit': { maxImages: 10, maxVideos: 3, maxAudios: 0, maxTotalReferences: null, minVideoSecondsEach: null, maxVideoSecondsEach: 10.0, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'gemini-omni-1.1-flash-extend': { maxImages: 10, maxVideos: 3, maxAudios: 0, maxTotalReferences: null, minVideoSecondsEach: null, maxVideoSecondsEach: 10.0, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'gemini-omni-1.1-flash-i2v': { maxImages: 1, maxVideos: 0, maxAudios: 0, maxTotalReferences: null, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'gemini-omni-1.1-flash-preview': { maxImages: 10, maxVideos: 3, maxAudios: 0, maxTotalReferences: null, minVideoSecondsEach: null, maxVideoSecondsEach: 10.0, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'gemini-omni-flash-preview': { maxImages: 3, maxVideos: 1, maxAudios: 0, maxTotalReferences: null, minVideoSecondsEach: null, maxVideoSecondsEach: 10.0, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'mango-video-image-to-video': { maxImages: 4, maxVideos: 0, maxAudios: 0, maxTotalReferences: 4, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'mango-video-text-to-video': { maxImages: 0, maxVideos: 0, maxAudios: 0, maxTotalReferences: 0, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'minimax-h3': { maxImages: 9, maxVideos: 3, maxAudios: 3, maxTotalReferences: 12, minVideoSecondsEach: 2.0, maxVideoSecondsEach: 15.0, maxVideoSecondsCombined: 15.0, minAudioSecondsEach: 2.0, maxAudioSecondsEach: 15.0, maxAudioSecondsCombined: 15.0, audioRequiresVisualAnchor: true, source: 'native' },
  'minimax-h3-atlas-cloud': { maxImages: null, maxVideos: null, maxAudios: null, maxTotalReferences: null, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: true, source: 'native' },
  'minimax-h3-fast-image-to-video-atlas-cloud': { maxImages: 2, maxVideos: 0, maxAudios: 0, maxTotalReferences: 2, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'minimax-h3-fast-reference-to-video-atlas-cloud': { maxImages: null, maxVideos: null, maxAudios: null, maxTotalReferences: null, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: true, source: 'native' },
  'minimax-h3-fast-text-to-video-atlas-cloud': { maxImages: 0, maxVideos: 0, maxAudios: 0, maxTotalReferences: 0, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'minimax-h3-image-to-video-atlas-cloud': { maxImages: 2, maxVideos: 0, maxAudios: 0, maxTotalReferences: 2, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'minimax-h3-image-to-video-meta-hosted': { maxImages: 2, maxVideos: 0, maxAudios: 0, maxTotalReferences: 2, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'minimax-h3-max-turbo-image-to-video-atlas-cloud': { maxImages: 2, maxVideos: 0, maxAudios: 0, maxTotalReferences: 2, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'minimax-h3-max-turbo-text-to-video-atlas-cloud': { maxImages: 0, maxVideos: 0, maxAudios: 0, maxTotalReferences: 0, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'minimax-h3-meta-hosted': { maxImages: 9, maxVideos: 3, maxAudios: 3, maxTotalReferences: 15, minVideoSecondsEach: 2.0, maxVideoSecondsEach: 15.0, maxVideoSecondsCombined: 15.0, minAudioSecondsEach: 2.0, maxAudioSecondsEach: 15.0, maxAudioSecondsCombined: 15.0, audioRequiresVisualAnchor: true, source: 'native' },
  'minimax-h3-reference-to-video': { maxImages: 9, maxVideos: 3, maxAudios: 3, maxTotalReferences: 12, minVideoSecondsEach: 2.0, maxVideoSecondsEach: 15.0, maxVideoSecondsCombined: 15.0, minAudioSecondsEach: 2.0, maxAudioSecondsEach: 15.0, maxAudioSecondsCombined: 15.0, audioRequiresVisualAnchor: true, source: 'native' },
  'minimax-h3-reference-to-video-atlas-cloud': { maxImages: null, maxVideos: null, maxAudios: null, maxTotalReferences: null, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: true, source: 'native' },
  'minimax-h3-reference-to-video-meta-hosted': { maxImages: 9, maxVideos: 3, maxAudios: 3, maxTotalReferences: 15, minVideoSecondsEach: 2.0, maxVideoSecondsEach: 15.0, maxVideoSecondsCombined: 15.0, minAudioSecondsEach: 2.0, maxAudioSecondsEach: 15.0, maxAudioSecondsCombined: 15.0, audioRequiresVisualAnchor: true, source: 'native' },
  'minimax-h3-text-to-video-atlas-cloud': { maxImages: 0, maxVideos: 0, maxAudios: 0, maxTotalReferences: 0, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'muse-video': { maxImages: 10, maxVideos: 0, maxAudios: 0, maxTotalReferences: 10, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'muse-video-1.0': { maxImages: 10, maxVideos: 0, maxAudios: 0, maxTotalReferences: 10, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'muse-video-1.0-r2v': { maxImages: 10, maxVideos: 0, maxAudios: 0, maxTotalReferences: 10, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'muse-video-r2v': { maxImages: 10, maxVideos: 0, maxAudios: 0, maxTotalReferences: 10, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'omni-1.1-flash': { maxImages: 10, maxVideos: 3, maxAudios: 0, maxTotalReferences: null, minVideoSecondsEach: null, maxVideoSecondsEach: 10.0, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'omni-1.1-flash-edit': { maxImages: 10, maxVideos: 3, maxAudios: 0, maxTotalReferences: null, minVideoSecondsEach: null, maxVideoSecondsEach: 10.0, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'omni-1.1-flash-extend': { maxImages: 10, maxVideos: 3, maxAudios: 0, maxTotalReferences: null, minVideoSecondsEach: null, maxVideoSecondsEach: 10.0, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'omni-1.1-flash-i2v': { maxImages: 1, maxVideos: 0, maxAudios: 0, maxTotalReferences: null, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'omni-flash': { maxImages: 3, maxVideos: 1, maxAudios: 0, maxTotalReferences: null, minVideoSecondsEach: null, maxVideoSecondsEach: 10.0, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'seedance-2.0': { maxImages: 9, maxVideos: 3, maxAudios: 3, maxTotalReferences: 12, minVideoSecondsEach: 2.0, maxVideoSecondsEach: 15.0, maxVideoSecondsCombined: 15.0, minAudioSecondsEach: 2.0, maxAudioSecondsEach: 15.0, maxAudioSecondsCombined: 15.0, audioRequiresVisualAnchor: true, source: 'native' },
  'seedance-2.0-image-to-video': { maxImages: 2, maxVideos: 0, maxAudios: 0, maxTotalReferences: null, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'seedance-2.0-image-to-video-atlas-cloud': { maxImages: 2, maxVideos: 0, maxAudios: 0, maxTotalReferences: null, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'seedance-2.0-ref': { maxImages: 9, maxVideos: 3, maxAudios: 3, maxTotalReferences: 12, minVideoSecondsEach: 2.0, maxVideoSecondsEach: 15.0, maxVideoSecondsCombined: 15.0, minAudioSecondsEach: 2.0, maxAudioSecondsEach: 15.0, maxAudioSecondsCombined: 15.0, audioRequiresVisualAnchor: true, source: 'native' },
  'seedance-2.0-reference-to-video': { maxImages: 9, maxVideos: 3, maxAudios: 3, maxTotalReferences: 12, minVideoSecondsEach: 2.0, maxVideoSecondsEach: 15.0, maxVideoSecondsCombined: 15.0, minAudioSecondsEach: 2.0, maxAudioSecondsEach: 15.0, maxAudioSecondsCombined: 15.0, audioRequiresVisualAnchor: true, source: 'native' },
  'seedance-2.0-reference-to-video-atlas-cloud': { maxImages: 9, maxVideos: 3, maxAudios: 3, maxTotalReferences: 12, minVideoSecondsEach: 2.0, maxVideoSecondsEach: 15.0, maxVideoSecondsCombined: 15.0, minAudioSecondsEach: 2.0, maxAudioSecondsEach: 15.0, maxAudioSecondsCombined: 15.0, audioRequiresVisualAnchor: true, source: 'native' },
  'seedance-2.5-first-last-frame': { maxImages: 2, maxVideos: 0, maxAudios: 0, maxTotalReferences: null, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'seedance-2.5-first-last-frame-atlas-cloud': { maxImages: 2, maxVideos: 0, maxAudios: 0, maxTotalReferences: null, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'seedance-2.5-image-to-video': { maxImages: 1, maxVideos: 0, maxAudios: 0, maxTotalReferences: null, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'seedance-2.5-image-to-video-atlas-cloud': { maxImages: 1, maxVideos: 0, maxAudios: 0, maxTotalReferences: null, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'seedance-2.5-ref': { maxImages: 30, maxVideos: 10, maxAudios: 10, maxTotalReferences: 50, minVideoSecondsEach: 2.0, maxVideoSecondsEach: 30.0, maxVideoSecondsCombined: 30.0, minAudioSecondsEach: 2.0, maxAudioSecondsEach: 30.0, maxAudioSecondsCombined: 30.0, audioRequiresVisualAnchor: false, source: 'native' },
  'seedance-2.5-reference-to-video': { maxImages: 30, maxVideos: 10, maxAudios: 10, maxTotalReferences: 50, minVideoSecondsEach: 2.0, maxVideoSecondsEach: 30.0, maxVideoSecondsCombined: 30.0, minAudioSecondsEach: 2.0, maxAudioSecondsEach: 30.0, maxAudioSecondsCombined: 30.0, audioRequiresVisualAnchor: false, source: 'native' },
  'seedance-2.5-reference-to-video-atlas-cloud': { maxImages: 30, maxVideos: 10, maxAudios: 10, maxTotalReferences: 50, minVideoSecondsEach: 2.0, maxVideoSecondsEach: 30.0, maxVideoSecondsCombined: 30.0, minAudioSecondsEach: 2.0, maxAudioSecondsEach: 30.0, maxAudioSecondsCombined: 30.0, audioRequiresVisualAnchor: false, source: 'native' },
  'seedance-2.5-video-editing': { maxImages: 30, maxVideos: 1, maxAudios: 10, maxTotalReferences: 50, minVideoSecondsEach: 4.0, maxVideoSecondsEach: 30.0, maxVideoSecondsCombined: 30.0, minAudioSecondsEach: 2.0, maxAudioSecondsEach: 30.0, maxAudioSecondsCombined: 30.0, audioRequiresVisualAnchor: false, source: 'native' },
  'seedance-2.5-video-editing-atlas-cloud': { maxImages: 30, maxVideos: 1, maxAudios: 10, maxTotalReferences: 50, minVideoSecondsEach: 4.0, maxVideoSecondsEach: 30.0, maxVideoSecondsCombined: 30.0, minAudioSecondsEach: 2.0, maxAudioSecondsEach: 30.0, maxAudioSecondsCombined: 30.0, audioRequiresVisualAnchor: false, source: 'native' },
  'seedance-2.5-video-extension': { maxImages: 30, maxVideos: 1, maxAudios: 10, maxTotalReferences: 50, minVideoSecondsEach: 2.0, maxVideoSecondsEach: 30.0, maxVideoSecondsCombined: 30.0, minAudioSecondsEach: 2.0, maxAudioSecondsEach: 30.0, maxAudioSecondsCombined: 30.0, audioRequiresVisualAnchor: false, source: 'native' },
  'seedance-2.5-video-extension-atlas-cloud': { maxImages: 30, maxVideos: 1, maxAudios: 10, maxTotalReferences: 50, minVideoSecondsEach: 2.0, maxVideoSecondsEach: 30.0, maxVideoSecondsCombined: 30.0, minAudioSecondsEach: 2.0, maxAudioSecondsEach: 30.0, maxAudioSecondsCombined: 30.0, audioRequiresVisualAnchor: false, source: 'native' },
  'veo-3': { maxImages: 3, maxVideos: 0, maxAudios: 0, maxTotalReferences: null, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'veo-3.1': { maxImages: 3, maxVideos: 0, maxAudios: 0, maxTotalReferences: null, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
  'veo-3.1-generate-preview': { maxImages: 3, maxVideos: 0, maxAudios: 0, maxTotalReferences: null, minVideoSecondsEach: null, maxVideoSecondsEach: null, maxVideoSecondsCombined: null, minAudioSecondsEach: null, maxAudioSecondsEach: null, maxAudioSecondsCombined: null, audioRequiresVisualAnchor: false, source: 'native' },
}

/** Every video model string the BACKEND accepts (UI choices + canonical enum
 * values + aliases). Exported so a parity test can assert VIDEO_REFERENCE_POLICY
 * covers all of them — checking only the keys that happen to exist cannot catch
 * a missing alias, which is exactly how veo-3.1-generate-preview slipped through
 * and read as 'unknown' (and therefore uncapped) in the console. */
export const VIDEO_MODEL_ACCEPTED_IDS: readonly string[] = ['gemini-omni-1.1-flash', 'gemini-omni-1.1-flash-edit', 'gemini-omni-1.1-flash-extend', 'gemini-omni-1.1-flash-i2v', 'gemini-omni-1.1-flash-preview', 'gemini-omni-flash-preview', 'mango-video-image-to-video', 'mango-video-text-to-video', 'minimax-h3', 'minimax-h3-atlas-cloud', 'minimax-h3-fast-image-to-video-atlas-cloud', 'minimax-h3-fast-reference-to-video-atlas-cloud', 'minimax-h3-fast-text-to-video-atlas-cloud', 'minimax-h3-image-to-video-atlas-cloud', 'minimax-h3-image-to-video-meta-hosted', 'minimax-h3-max-turbo-image-to-video-atlas-cloud', 'minimax-h3-max-turbo-text-to-video-atlas-cloud', 'minimax-h3-meta-hosted', 'minimax-h3-reference-to-video', 'minimax-h3-reference-to-video-atlas-cloud', 'minimax-h3-reference-to-video-meta-hosted', 'minimax-h3-text-to-video-atlas-cloud', 'muse-video', 'muse-video-1.0', 'muse-video-1.0-r2v', 'muse-video-r2v', 'omni-1.1-flash', 'omni-1.1-flash-edit', 'omni-1.1-flash-extend', 'omni-1.1-flash-i2v', 'omni-flash', 'seedance-2.0', 'seedance-2.0-image-to-video', 'seedance-2.0-image-to-video-atlas-cloud', 'seedance-2.0-ref', 'seedance-2.0-reference-to-video', 'seedance-2.0-reference-to-video-atlas-cloud', 'seedance-2.5-first-last-frame', 'seedance-2.5-first-last-frame-atlas-cloud', 'seedance-2.5-image-to-video', 'seedance-2.5-image-to-video-atlas-cloud', 'seedance-2.5-ref', 'seedance-2.5-reference-to-video', 'seedance-2.5-reference-to-video-atlas-cloud', 'seedance-2.5-video-editing', 'seedance-2.5-video-editing-atlas-cloud', 'seedance-2.5-video-extension', 'seedance-2.5-video-extension-atlas-cloud', 'veo-3', 'veo-3.1', 'veo-3.1-generate-preview']

/** BYOM capability keys the Gateway settings modal writes. The console reads
 * these off a ByomModelInfo to derive the same policy shape at runtime. */
export const BYOM_REFERENCE_CAPABILITY_KEYS = {
  images: 'reference_images_support',
  videos: 'reference_videos_support',
  audios: 'reference_audios_support',
} as const

/** Per-model reference-image budget for the Image Generator.
 *
 * GENERATED from the capability registry in
 * agentic_workflow.core.providers.model_capability. Do not hand-write
 * reference caps — the hard-coded maxReferences={4} this replaces
 * matched no model (real budgets are 9-15 user refs).
 *
 * maxUser is total minus the reserved style slot, and is what the
 * picker enforces. advisory=true means the cap is a quality guideline
 * with no provider error behind it: show it, never refuse on it.
 * Parity guard: imageReferencePolicy.parity.test.ts. */
export type ImageReferencePolicy = {
  maxTotal: number
  maxUser: number
  advisory: boolean
}

export const IMAGE_REFERENCE_POLICY: Record<string, ImageReferencePolicy> = {
  'gemini-2.5-flash-image': { maxTotal: 10, maxUser: 9, advisory: true },
  'gemini-3-pro-image-preview': { maxTotal: 14, maxUser: 13, advisory: false },
  'gemini-3.1-flash-image-preview': { maxTotal: 14, maxUser: 13, advisory: false },
  'gemini-3.1-flash-lite-image': { maxTotal: 14, maxUser: 13, advisory: false },
  'gemini-nano-banana-2.1': { maxTotal: 10, maxUser: 9, advisory: true },
  'openai-gpt-image-2': { maxTotal: 16, maxUser: 15, advisory: false },
  'openai-gpt-image-2.5-flare': { maxTotal: 16, maxUser: 15, advisory: false },
  'openai-gpt-image-2.5-sunburst': { maxTotal: 16, maxUser: 15, advisory: false },
  'mango-ember-drift': { maxTotal: 10, maxUser: 9, advisory: true },
}

/** Per-model image resolution (image_size) capability.
 *
 * GENERATED mirror of the authoritative backend policy in
 * agentic_workflow.core.providers.image_resolution_policy.
 * imageConstraints.ts consumes THIS — do not hand-write resolution
 * grids (single SoT). An empty `supported` means the model does not
 * accept the parameter, so the UI shows a fixed label, not a picker.
 * Parity guard: imageResolutionPolicy.parity.test.ts. */
export type ImageResolutionPolicy = {
  supported: string[]
  default: string | null
}

/** Every resolution token the product offers, ascending. */
export const ALL_IMAGE_RESOLUTIONS: string[] = ['512P', '1K', '2K', '4K']

export const IMAGE_RESOLUTION_POLICY: Record<string, ImageResolutionPolicy> = {
  'gemini-2.5-flash-image': { supported: [], default: null },
  'gemini-3-pro-image-preview': { supported: ['1K', '2K', '4K'], default: '1K' },
  'gemini-3.1-flash-image-preview': { supported: ['512P', '1K', '2K', '4K'], default: '1K' },
  'gemini-3.1-flash-lite-image': { supported: ['1K'], default: '1K' },
  'gemini-nano-banana-2.1': { supported: ['1K', '2K', '4K'], default: '1K' },
  'openai-gpt-image-2': { supported: ['1K', '2K', '4K'], default: '1K' },
  'openai-gpt-image-2.5-flare': { supported: ['1K', '2K', '4K'], default: '1K' },
  'openai-gpt-image-2.5-sunburst': { supported: ['1K', '2K', '4K'], default: '1K' },
  'mango-ember-drift': { supported: [], default: null },
}

// ---------------------------------------------------------------------------
// Full node schema registry (generated from schemas/nodes/*.json)
// ---------------------------------------------------------------------------

export const NODE_SCHEMAS_BY_TYPE: Record<string, GeneratedNodeSchemaDef> = {
  "audio": {
    "type": "audio",
    "backendType": "audio",
    "label": "Audio Upload",
    "category": "Media",
    "description": "Upload a local audio file",
    "icon": "\ud83c\udfb5",
    "layout": {
      "*": {
        "width": 315,
        "height": 200
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_file_name",
        "type": "string",
        "label": "File Name",
        "description": "",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_voice_profile",
        "type": "VoiceProfileDict",
        "label": "Voice Profile",
        "description": "Character voice profile used to mark this uploaded audio as the Character voice source.",
        "required": false,
        "multi": false,
        "pythonType": "VoiceProfileDict",
        "tsType": "VoiceProfileDict",
        "baseType": "VoiceProfileDict",
        "hidden_from_director": true,
        "portSchemaId": "voice_profile_dict_voice_profile_dict_voice_profile_dict_single_map"
      }
    ],
    "outputs": [
      {
        "id": "out_audio",
        "type": "audio",
        "label": "Audio",
        "description": "The uploaded audio",
        "required": false,
        "multi": false,
        "pythonType": "AudioAssetRefDict",
        "tsType": "AudioAssetRefDict",
        "baseType": "AudioAsset",
        "portSchemaId": "audio_audio_asset_ref_dict_audio_asset_single_map"
      }
    ],
    "state": []
  },
  "characterDesigner": {
    "type": "characterDesigner",
    "backendType": "character_designer",
    "label": "Character Designer",
    "category": "Agentic",
    "description": "Design a character with visual sheet and provider-neutral voice brief",
    "icon": "\ud83c\udfa8",
    "layout": {
      "*": {
        "width": 400,
        "height": 460
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_upstream",
        "type": "UpstreamContextDict",
        "label": "Upstream",
        "description": "Default target port for incoming edges when no port is specified by the proposer (see _DEFAULT_TARGET_PORT in backend_graph.py). Wire upstream context (director or workflow node output) here when no specialized port applies.",
        "required": false,
        "multi": false,
        "pythonType": "UpstreamContextDict",
        "tsType": "UpstreamContextDict",
        "baseType": "UpstreamContextDict",
        "portSchemaId": "upstream_context_dict_upstream_context_dict_upstream_context_dict_single_map"
      },
      {
        "id": "in_images",
        "type": "image",
        "label": "Reference",
        "description": "Optional reference image to guide the visual design",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "in_name",
        "type": "string",
        "label": "Character Name",
        "description": "Name of the character being designed",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_role",
        "type": "string",
        "label": "Role",
        "description": "Character role (e.g. protagonist, supporting, antagonist)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_style",
        "type": "string",
        "label": "Art Style",
        "description": "Visual art style for the character sheet",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_description",
        "type": "string",
        "label": "Description",
        "description": "Describe appearance, personality, voice...",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_model",
        "type": "string",
        "label": "Model",
        "description": "Image generation model",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "gemini-3.1-flash-image-preview",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_feedback",
        "type": "string",
        "label": "Feedback",
        "description": "Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_feedback_history",
        "type": "list[FeedbackHistoryEntryDict]",
        "label": "Feedback History",
        "description": "Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries.",
        "required": false,
        "multi": false,
        "pythonType": "list[FeedbackHistoryEntryDict]",
        "tsType": "Array<FeedbackHistoryEntryDict>",
        "baseType": "list[FeedbackHistoryEntryDict]",
        "default": [],
        "hidden_from_director": true,
        "portSchemaId": "list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array"
      },
      {
        "id": "in_pronunciation_guide",
        "type": "string",
        "label": "Pronunciation Guide",
        "description": "Per-word pronunciation overrides for this character's name and terms. One rule per line: 'word \u2192 pronunciation' (alias) or 'word \u2192 /IPA/' (phoneme). Example: L'Ora \u2192 LOH-rah. Automatically applied to all downstream speech generation using this character's voice.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_bg_color",
        "type": "string",
        "label": "Background Color",
        "description": "Predefined background color key for the node card",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "default",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_vlm_validation",
        "type": "boolean",
        "label": "Quality Check",
        "description": "Run Gemini VLM quality validation after generation",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_name",
        "type": "string",
        "label": "Name",
        "description": "Character name (mirrors in_name for downstream label edges)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "aliasOf": "in_name",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_image",
        "type": "image",
        "label": "Character Sheet",
        "description": "Generated multi-view character reference sheet",
        "required": false,
        "multi": false,
        "pythonType": "CharacterAsset",
        "tsType": "CharacterAsset",
        "baseType": "ImageAsset",
        "portSchemaId": "image_character_asset_image_asset_single_map"
      },
      {
        "id": "out_voice_profile",
        "type": "VoiceProfileDict",
        "label": "Voice Profile",
        "description": "Provider-neutral voice brief used to identify this character's speaker role. The linked Sound Expert node owns selected provider voice fields and sample audio.",
        "required": false,
        "multi": false,
        "pythonType": "VoiceProfileDict",
        "tsType": "VoiceProfileDict",
        "baseType": "VoiceProfileDict",
        "portSchemaId": "voice_profile_dict_voice_profile_dict_voice_profile_dict_single_map"
      },
      {
        "id": "out_vlm_report",
        "type": "VlmValidationReportDict",
        "label": "Quality Report",
        "description": "VLM quality validation report from the most recent generation",
        "required": false,
        "multi": false,
        "pythonType": "VlmValidationReportDict",
        "tsType": "VlmValidationReportDict",
        "baseType": "VlmValidationReportDict",
        "portSchemaId": "vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map"
      }
    ],
    "state": [
      {
        "id": "batch_pending",
        "type": "int",
        "label": "batch_pending",
        "description": "",
        "pythonType": "int",
        "tsType": "number"
      },
      {
        "id": "annotated_image_path",
        "type": "string",
        "label": "Annotated Image Path",
        "description": "Transient per-run path to a baked annotation of the current picked image. Written by the Refine tab as a `state_updates` argument on execute-node, consumed once as the edit target, then cleared. Never authored by the Director and never persisted as durable node data.",
        "pythonType": "str",
        "tsType": "string"
      }
    ],
    "pricing": {
      "default": {
        "category": "image_models",
        "model": "gemini-3.1-flash-image-preview",
        "priceType": "per_image"
      },
      "actions": {}
    },
    "executionActions": [
      "generate"
    ],
    "actionLabels": {},
    "directorGuidance": "On add, set in_name and in_description; include gender and age cues because image generation and the linked Sound Expert voice node depend on them. Use revise_character for visual edits; use the linked Sound Expert node for voice selection and samples. Load visual-design-workflow for multi-designer creation, references, or reruns.",
    "projectStatusOnComplete": "in_progress"
  },
  "debugHang": {
    "type": "debugHang",
    "backendType": "debug_hang",
    "label": "Debug Hang",
    "category": "Debug",
    "description": "Debug node that hangs forever for testing",
    "icon": "\ud83d\udc1b",
    "layout": {
      "*": {
        "width": 200,
        "height": 150
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_label",
        "type": "string",
        "label": "Label",
        "description": "Debug label",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_result",
        "type": "string",
        "label": "Result",
        "description": "Debug result",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "state": []
  },
  "director": {
    "type": "director",
    "backendType": "director",
    "label": "Director",
    "category": "Agentic",
    "description": "Orchestrate workflow and chat with the AI director",
    "icon": "\ud83d\udccb",
    "layout": {
      "*": {
        "width": 400,
        "height": 400
      }
    },
    "canvasHidden": true,
    "inputs": [
      {
        "id": "in_context",
        "type": "string",
        "label": "Context",
        "description": "Optional context for the conversation",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_response",
        "type": "string",
        "label": "Response",
        "description": "Director response text",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_crew",
        "type": "DirectorCrewDict",
        "label": "Crew",
        "description": "Crew configuration for sub-agents",
        "required": false,
        "multi": false,
        "pythonType": "DirectorCrewDict",
        "tsType": "DirectorCrewDict",
        "baseType": "DirectorCrewDict",
        "portSchemaId": "director_crew_dict_director_crew_dict_director_crew_dict_single_map"
      }
    ],
    "state": [
      {
        "id": "pending_tool_state",
        "type": "DirectorPendingToolStateDict",
        "label": "pending_tool_state",
        "description": "",
        "pythonType": "DirectorPendingToolStateDict",
        "tsType": "DirectorPendingToolStateDict"
      }
    ]
  },
  "generatedImageWithHistory": {
    "type": "generatedImageWithHistory",
    "backendType": "generated_image_with_history",
    "label": "Generated Image",
    "category": "Agentic",
    "description": "Panel image with generation history",
    "icon": "",
    "layout": {
      "*": {
        "width": 200,
        "height": 180
      }
    },
    "canvasHidden": false,
    "inputs": [],
    "outputs": [],
    "state": [],
    "footerHeight": 80
  },
  "image": {
    "type": "image",
    "backendType": "image",
    "label": "Image Upload",
    "category": "Media",
    "description": "Upload a local image file",
    "icon": "\ud83d\uddbc\ufe0f",
    "layout": {
      "*": {
        "width": 315,
        "height": 177
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_file_name",
        "type": "string",
        "label": "File Name",
        "description": "",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_image",
        "type": "image",
        "label": "Source Image",
        "description": "Provenance link to the image this one was derived from \u2014 set by the annotation bake so the canvas can draw a derivation edge from the source node. Inert: nothing reads this value, and Image Upload nodes never populate it.",
        "required": false,
        "multi": false,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "hidden_from_director": true,
        "portSchemaId": "image_image_asset_ref_dict_image_asset_single_map"
      }
    ],
    "outputs": [
      {
        "id": "out_image",
        "type": "image",
        "label": "Image",
        "description": "The uploaded image",
        "required": false,
        "multi": false,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "portSchemaId": "image_image_asset_ref_dict_image_asset_single_map"
      }
    ],
    "state": []
  },
  "imageGenerator": {
    "type": "imageGenerator",
    "backendType": "image_generator",
    "label": "Image Generator",
    "category": "Agentic",
    "description": "Generate images from text prompts",
    "icon": "\ud83d\uddbc\ufe0f",
    "layout": {
      "16:9": {
        "width": 315,
        "height": 177
      },
      "9:16": {
        "width": 177,
        "height": 315
      },
      "3:4": {
        "width": 236,
        "height": 315
      },
      "4:3": {
        "width": 315,
        "height": 236
      },
      "1:1": {
        "width": 240,
        "height": 240
      },
      "3:2": {
        "width": 315,
        "height": 210
      },
      "2:3": {
        "width": 210,
        "height": 315
      },
      "2:1": {
        "width": 315,
        "height": 158
      },
      "5:4": {
        "width": 315,
        "height": 252
      },
      "4:5": {
        "width": 252,
        "height": 315
      },
      "21:9": {
        "width": 315,
        "height": 135
      },
      "9:21": {
        "width": 135,
        "height": 315
      },
      "Auto": {
        "width": 240,
        "height": 240
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_images",
        "type": "image",
        "label": "Reference",
        "description": "Optional reference image to guide the generation",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "in_upstream",
        "type": "UpstreamContextDict",
        "label": "Upstream",
        "description": "Default target port for incoming edges when no port is specified by the proposer (see _DEFAULT_TARGET_PORT in backend_graph.py). Wire upstream context (director or workflow node output) here when no specialized port applies.",
        "required": false,
        "multi": false,
        "pythonType": "UpstreamContextDict",
        "tsType": "UpstreamContextDict",
        "baseType": "UpstreamContextDict",
        "portSchemaId": "upstream_context_dict_upstream_context_dict_upstream_context_dict_single_map"
      },
      {
        "id": "in_name",
        "type": "string",
        "label": "Name",
        "description": "Optional label for the generator node",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_prompt",
        "type": "string",
        "label": "Prompt",
        "description": "Text description of the image to generate",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_aspect_ratio",
        "type": "AspectRatio",
        "label": "Aspect Ratio",
        "description": "Aspect ratio for the generated image",
        "required": false,
        "multi": false,
        "pythonType": "AspectRatio",
        "tsType": "AspectRatio",
        "baseType": "AspectRatio",
        "default": "16:9",
        "portSchemaId": "aspect_ratio_aspect_ratio_aspect_ratio_single_primitive"
      },
      {
        "id": "in_style",
        "type": "string",
        "label": "Art Style",
        "description": "Visual art style for the generated image",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_quality",
        "type": "string",
        "label": "Quality",
        "description": "Output resolution quality",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "1K",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_model",
        "type": "string",
        "label": "Model",
        "description": "Image generation model",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "gemini-3.1-flash-image-preview",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_panel_refs",
        "type": "string",
        "label": "Panel Refs",
        "description": "Designer node IDs for self-wiring reference edges",
        "required": false,
        "multi": false,
        "pythonType": "list[str]",
        "tsType": "Array<string>",
        "baseType": "list[str]",
        "hidden_from_director": true,
        "portSchemaId": "string_list_str_list_str_single_array"
      },
      {
        "id": "in_update",
        "type": "boolean",
        "label": "Update",
        "description": "When True, store in_image directly (passthrough mode)",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_image",
        "type": "image",
        "label": "Image",
        "description": "Incoming panel image from storyboard",
        "required": false,
        "multi": false,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "hidden_from_director": true,
        "portSchemaId": "image_image_asset_ref_dict_image_asset_single_map"
      },
      {
        "id": "in_feedback",
        "type": "string",
        "label": "Feedback",
        "description": "Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_video",
        "type": "string",
        "label": "Video",
        "description": "Video file path (RelativePath) from upstream video generator",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_source_video",
        "type": "video",
        "label": "Source Video for Last Frame",
        "description": "Typed video input used for an exact S7 last-decoded-frame extraction.",
        "required": false,
        "multi": false,
        "pythonType": "GeneratedVideoWithHistory",
        "tsType": "GeneratedVideoWithHistory",
        "baseType": "VideoAsset",
        "hidden_from_director": true,
        "hidden_from_reference_picker": true,
        "portSchemaId": "video_generated_video_with_history_video_asset_single_map"
      },
      {
        "id": "in_expected_video_duration_ms",
        "type": "int",
        "label": "Expected S7 Source Duration",
        "description": "Exact planned predecessor clip length, checked against the decoded video stream before S7 handoff.",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "hidden_from_director": true,
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_frame",
        "type": "string",
        "label": "Frame",
        "description": "Which frame to extract: first, last, integer string (0-indexed), or time:<seconds> for the Canvas playhead",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "first",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_get_frame",
        "type": "boolean",
        "label": "Get Frame",
        "description": "When true, skip image generation and extract frame from in_video",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_feedback_history",
        "type": "list[FeedbackHistoryEntryDict]",
        "label": "Feedback History",
        "description": "Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries.",
        "required": false,
        "multi": false,
        "pythonType": "list[FeedbackHistoryEntryDict]",
        "tsType": "Array<FeedbackHistoryEntryDict>",
        "baseType": "list[FeedbackHistoryEntryDict]",
        "default": [],
        "hidden_from_director": true,
        "portSchemaId": "list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array"
      },
      {
        "id": "in_vlm_validation",
        "type": "boolean",
        "label": "Quality Check",
        "description": "Run Gemini VLM quality validation after generation",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_image",
        "type": "image",
        "label": "Generated Image",
        "description": "The generated image",
        "required": false,
        "multi": false,
        "pythonType": "GeneratedImageWithHistory",
        "tsType": "GeneratedImageWithHistory",
        "baseType": "ImageAsset",
        "portSchemaId": "image_generated_image_with_history_image_asset_single_map"
      },
      {
        "id": "out_vlm_report",
        "type": "VlmValidationReportDict",
        "label": "Quality Report",
        "description": "VLM quality validation report from the most recent generation",
        "required": false,
        "multi": false,
        "pythonType": "VlmValidationReportDict",
        "tsType": "VlmValidationReportDict",
        "baseType": "VlmValidationReportDict",
        "portSchemaId": "vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map"
      }
    ],
    "state": [
      {
        "id": "batch_pending",
        "type": "int",
        "label": "batch_pending",
        "description": "",
        "pythonType": "int",
        "tsType": "number"
      },
      {
        "id": "annotated_image_path",
        "type": "string",
        "label": "Annotated Image Path",
        "description": "Transient per-run path to a baked annotation of the current picked image. Written by the Refine tab as a `state_updates` argument on execute-node, consumed once as the edit target, then cleared. Never authored by the Director and never persisted as durable node data.",
        "pythonType": "str",
        "tsType": "string"
      },
      {
        "id": "name_autogen",
        "type": "string",
        "label": "Auto-generated Name Marker",
        "description": "Marker token identifying which auto-generated default-name family this node's display name came from (see agentic_workflow.core.default_node_names). Absent on user-created and pre-marker nodes. The console localizes the name only while the stored value still equals the canonical English rendering, so a rename automatically wins.",
        "pythonType": "str",
        "tsType": "string"
      }
    ],
    "pricing": {
      "category": "image_models",
      "model": "gemini-3.1-flash-image-preview",
      "priceType": "per_image"
    },
    "directorGuidance": "Standalone image nodes can be added by DAG with in_prompt, in_aspect_ratio, and in_style; storyboard panel image nodes are owned by create_storyboard_node. Wire reference images by edges to in_images. Use revise_image for local anchored edits that should preserve the picked image; use remake_image for major pose, composition, camera, action, subject-count, or background changes, or after repeated anchored failures. Load standalone-media-generation for recipes.",
    "projectStatusOnComplete": "in_progress",
    "footerHeight": 80
  },
  "locationDesigner": {
    "type": "locationDesigner",
    "backendType": "location_designer",
    "label": "Location Designer",
    "category": "Agentic",
    "description": "Design a location/background with reference image",
    "icon": "map",
    "layout": {
      "*": {
        "width": 400,
        "height": 460
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_images",
        "type": "image",
        "label": "Reference",
        "description": "Optional reference image to guide the visual design",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "in_name",
        "type": "string",
        "label": "Location Name",
        "description": "Name of the location being designed",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_style",
        "type": "string",
        "label": "Art Style",
        "description": "Visual art style for the location",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_time_of_day",
        "type": "string",
        "label": "Time of Day",
        "description": "Time of day for the scene",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "day",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_weather",
        "type": "string",
        "label": "Weather",
        "description": "Weather condition for the scene",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "clear",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_description",
        "type": "string",
        "label": "Description",
        "description": "Describe the location, atmosphere, key elements...",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_model",
        "type": "string",
        "label": "Model",
        "description": "Image generation model",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "gemini-3.1-flash-image-preview",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_feedback",
        "type": "string",
        "label": "Feedback",
        "description": "Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_feedback_history",
        "type": "list[FeedbackHistoryEntryDict]",
        "label": "Feedback History",
        "description": "Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries.",
        "required": false,
        "multi": false,
        "pythonType": "list[FeedbackHistoryEntryDict]",
        "tsType": "Array<FeedbackHistoryEntryDict>",
        "baseType": "list[FeedbackHistoryEntryDict]",
        "default": [],
        "hidden_from_director": true,
        "portSchemaId": "list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array"
      },
      {
        "id": "in_bg_color",
        "type": "string",
        "label": "Background Color",
        "description": "Predefined background color key for the node card",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "default",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_vlm_validation",
        "type": "boolean",
        "label": "Quality Check",
        "description": "Run Gemini VLM quality validation after generation",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_720_enabled",
        "type": "boolean",
        "label": "360 Panorama",
        "description": "Generate a 360 panorama source for this location instead of a standard flat location image",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_720_view",
        "type": "LocationPanoramaViewDict",
        "label": "360 View",
        "description": "Current 360 viewer camera state in degrees",
        "required": false,
        "multi": false,
        "pythonType": "LocationPanoramaViewDict",
        "tsType": "LocationPanoramaViewDict",
        "baseType": "LocationPanoramaViewDict",
        "default": {
          "yaw_degrees": 0,
          "pitch_degrees": 0,
          "fov_degrees": 75
        },
        "hidden_from_director": true,
        "portSchemaId": "location_panorama_view_dict_location_panorama_view_dict_location_panorama_view_dict_single_map"
      }
    ],
    "outputs": [
      {
        "id": "out_name",
        "type": "string",
        "label": "Name",
        "description": "Location name (mirrors in_name for downstream label edges)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "aliasOf": "in_name",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_image",
        "type": "image",
        "label": "Location Image",
        "description": "Generated location reference image",
        "required": false,
        "multi": false,
        "pythonType": "LocationAsset",
        "tsType": "LocationAsset",
        "baseType": "ImageAsset",
        "portSchemaId": "image_location_asset_image_asset_single_map"
      },
      {
        "id": "out_metadata",
        "type": "LocationMetadataDict",
        "label": "Metadata",
        "description": "Location metadata including name, style, time, and weather",
        "required": false,
        "multi": false,
        "pythonType": "LocationMetadataDict",
        "tsType": "LocationMetadataDict",
        "baseType": "LocationMetadataDict",
        "portSchemaId": "location_metadata_dict_location_metadata_dict_location_metadata_dict_single_map"
      },
      {
        "id": "out_vlm_report",
        "type": "VlmValidationReportDict",
        "label": "Quality Report",
        "description": "VLM quality validation report from the most recent generation",
        "required": false,
        "multi": false,
        "pythonType": "VlmValidationReportDict",
        "tsType": "VlmValidationReportDict",
        "baseType": "VlmValidationReportDict",
        "portSchemaId": "vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map"
      }
    ],
    "state": [
      {
        "id": "batch_pending",
        "type": "int",
        "label": "batch_pending",
        "description": "",
        "pythonType": "int",
        "tsType": "number"
      },
      {
        "id": "annotated_image_path",
        "type": "string",
        "label": "Annotated Image Path",
        "description": "Transient per-run path to a baked annotation of the current picked image. Written by the Refine tab as a `state_updates` argument on execute-node, consumed once as the edit target, then cleared. Never authored by the Director and never persisted as durable node data.",
        "pythonType": "str",
        "tsType": "string"
      }
    ],
    "pricing": {
      "default": {
        "category": "image_models",
        "model": "gemini-3.1-flash-image-preview",
        "priceType": "per_image"
      }
    },
    "executionActions": [
      "generate"
    ],
    "directorGuidance": "On add, set in_name and in_description; use in_time_of_day and in_weather when the user specifies atmosphere. Use revise_location for edits; load visual-design-workflow for references or reruns.",
    "projectStatusOnComplete": "in_progress"
  },
  "nodeGroup": {
    "type": "nodeGroup",
    "backendType": "node_group",
    "label": "Group",
    "category": "Layout",
    "description": "Visual group container for organizing nodes",
    "icon": "\ud83d\udcc1",
    "layout": {
      "*": {
        "width": 800,
        "height": 600
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_label",
        "type": "string",
        "label": "Label",
        "description": "Display label for the group",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "Group",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_child_node_ids",
        "type": "string",
        "label": "Child Node IDs",
        "description": "IDs of child nodes contained in this group. Null entries represent empty gap slots left by drag-out; use Rearrange to compact.",
        "required": false,
        "multi": false,
        "pythonType": "list[str | None]",
        "tsType": "Array<string | null>",
        "baseType": "list[str | None]",
        "default": [],
        "hidden_from_director": true,
        "portSchemaId": "string_list_str_none_list_str_none_single_array"
      },
      {
        "id": "in_layout_mode",
        "type": "string",
        "label": "Layout Mode",
        "description": "Child arrangement mode: horizontal (single row), vertical (single column), or auto (grid)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "auto",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_collapsed",
        "type": "boolean",
        "label": "Collapsed",
        "description": "Whether this visual group is shown in its compact collapsed state",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_collapsible",
        "type": "boolean",
        "label": "Collapsible",
        "description": "Whether this workflow-owned visual group exposes collapse and expand controls",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_bg_color",
        "type": "string",
        "label": "Background Color",
        "description": "Predefined background color key for the group container",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "default",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "outputs": [],
    "state": [
      {
        "id": "name_autogen",
        "type": "string",
        "label": "Auto-generated Name Marker",
        "description": "Marker token identifying which auto-generated default-name family this node's display label came from (see agentic_workflow.core.default_node_names). Absent on user-created and pre-marker nodes. The console localizes the label only while the stored value still equals the canonical English rendering, so a rename automatically wins.",
        "pythonType": "str",
        "tsType": "string"
      }
    ],
    "directorGuidance": "Groups are visual containers. Create groups with create_group_node, rename via in_label, and run children with execute_group_nodes. Deleting a group deletes children; warn first. Load group-editing for membership/order/move/merge edits."
  },
  "objectDesigner": {
    "type": "objectDesigner",
    "backendType": "object_designer",
    "label": "Object Designer",
    "category": "Agentic",
    "description": "Design an object/artifact with reference image",
    "icon": "\ud83c\udf81",
    "layout": {
      "*": {
        "width": 400,
        "height": 487
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_images",
        "type": "image",
        "label": "Reference",
        "description": "Optional reference image to guide the visual design",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "in_name",
        "type": "string",
        "label": "Object Name",
        "description": "Name of the object being designed",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_style",
        "type": "string",
        "label": "Art Style",
        "description": "Visual art style for the object",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_description",
        "type": "string",
        "label": "Description",
        "description": "Describe the object appearance, material, details...",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_model",
        "type": "string",
        "label": "Model",
        "description": "Image generation model",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "gemini-3.1-flash-image-preview",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_feedback",
        "type": "string",
        "label": "Feedback",
        "description": "Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_feedback_history",
        "type": "list[FeedbackHistoryEntryDict]",
        "label": "Feedback History",
        "description": "Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries.",
        "required": false,
        "multi": false,
        "pythonType": "list[FeedbackHistoryEntryDict]",
        "tsType": "Array<FeedbackHistoryEntryDict>",
        "baseType": "list[FeedbackHistoryEntryDict]",
        "default": [],
        "hidden_from_director": true,
        "portSchemaId": "list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array"
      },
      {
        "id": "in_vlm_validation",
        "type": "boolean",
        "label": "Quality Check",
        "description": "Run Gemini VLM quality validation after generation",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_name",
        "type": "string",
        "label": "Name",
        "description": "Object name (mirrors in_name for downstream label edges)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "aliasOf": "in_name",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_image",
        "type": "image",
        "label": "Object Image",
        "description": "Generated object reference image",
        "required": false,
        "multi": false,
        "pythonType": "ObjectAsset",
        "tsType": "ObjectAsset",
        "baseType": "ImageAsset",
        "portSchemaId": "image_object_asset_image_asset_single_map"
      },
      {
        "id": "out_metadata",
        "type": "ObjectMetadataDict",
        "label": "Metadata",
        "description": "Object metadata",
        "required": false,
        "multi": false,
        "pythonType": "ObjectMetadataDict",
        "tsType": "ObjectMetadataDict",
        "baseType": "ObjectMetadataDict",
        "portSchemaId": "object_metadata_dict_object_metadata_dict_object_metadata_dict_single_map"
      },
      {
        "id": "out_vlm_report",
        "type": "VlmValidationReportDict",
        "label": "Quality Report",
        "description": "VLM quality validation report from the most recent generation",
        "required": false,
        "multi": false,
        "pythonType": "VlmValidationReportDict",
        "tsType": "VlmValidationReportDict",
        "baseType": "VlmValidationReportDict",
        "portSchemaId": "vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map"
      }
    ],
    "state": [
      {
        "id": "batch_pending",
        "type": "int",
        "label": "batch_pending",
        "description": "",
        "pythonType": "int",
        "tsType": "number"
      },
      {
        "id": "annotated_image_path",
        "type": "string",
        "label": "Annotated Image Path",
        "description": "Transient per-run path to a baked annotation of the current picked image. Written by the Refine tab as a `state_updates` argument on execute-node, consumed once as the edit target, then cleared. Never authored by the Director and never persisted as durable node data.",
        "pythonType": "str",
        "tsType": "string"
      }
    ],
    "pricing": {
      "category": "image_models",
      "model": "gemini-3.1-flash-image-preview",
      "priceType": "per_image"
    },
    "directorGuidance": "On add, set in_name and in_description. Use revise_object for edits; load visual-design-workflow for references or reruns.",
    "projectStatusOnComplete": "in_progress"
  },
  "panelSource": {
    "type": "panelSource",
    "backendType": "panel_source",
    "label": "Panel Source",
    "category": "Input",
    "description": "Load panel action, dialogue, and metadata",
    "icon": "\ud83d\uddbc\ufe0f",
    "layout": {
      "*": {
        "width": 320,
        "height": 350
      }
    },
    "canvasHidden": false,
    "inputs": [],
    "outputs": [
      {
        "id": "out_image",
        "type": "image",
        "label": "Image",
        "description": "The existing panel image",
        "required": false,
        "multi": false,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "portSchemaId": "image_image_asset_ref_dict_image_asset_single_map"
      },
      {
        "id": "out_action",
        "type": "string",
        "label": "Action",
        "description": "The action/script description",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_character_ids",
        "type": "string",
        "label": "Character IDs",
        "description": "IDs of characters appearing in this panel",
        "required": false,
        "multi": false,
        "pythonType": "list[str]",
        "tsType": "Array<string>",
        "baseType": "list[str]",
        "portSchemaId": "string_list_str_list_str_single_array"
      },
      {
        "id": "out_appearances",
        "type": "list[AppearanceDict]",
        "label": "Appearances",
        "description": "Character expressions, poses, positions",
        "required": false,
        "multi": false,
        "pythonType": "list[AppearanceDict]",
        "tsType": "Array<AppearanceDict>",
        "baseType": "list[AppearanceDict]",
        "portSchemaId": "list_appearance_dict_list_appearance_dict_list_appearance_dict_single_array"
      },
      {
        "id": "out_dialogue",
        "type": "list[PanelDialogueDict]",
        "label": "Dialogue",
        "description": "Dialogue lines in this panel",
        "required": false,
        "multi": false,
        "pythonType": "list[PanelDialogueDict]",
        "tsType": "Array<PanelDialogueDict>",
        "baseType": "list[PanelDialogueDict]",
        "hidden_from_director": true,
        "portSchemaId": "list_panel_dialogue_dict_list_panel_dialogue_dict_list_panel_dialogue_dict_single_array"
      },
      {
        "id": "out_script",
        "type": "string",
        "label": "Script",
        "description": "Dialogue formatted as TTS script",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_composition",
        "type": "CompositionDict",
        "label": "Composition",
        "description": "Shot type, angle, and focus settings",
        "required": false,
        "multi": false,
        "pythonType": "CompositionDict",
        "tsType": "CompositionDict",
        "baseType": "CompositionDict",
        "portSchemaId": "composition_dict_composition_dict_composition_dict_single_map"
      }
    ],
    "state": []
  },
  "promptInput": {
    "type": "promptInput",
    "backendType": "prompt_input",
    "label": "Prompt Input",
    "category": "Input",
    "description": "Enter your story prompt for generation",
    "icon": "\ud83d\udcdd",
    "layout": {
      "*": {
        "width": 320,
        "height": 250
      }
    },
    "canvasHidden": false,
    "inputs": [],
    "outputs": [
      {
        "id": "out_prompt",
        "type": "string",
        "label": "Prompt",
        "description": "The story prompt text",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "state": []
  },
  "scriptWriter": {
    "type": "scriptWriter",
    "backendType": "script_writer",
    "label": "Script Writer",
    "category": "Agentic",
    "description": "Interactive conversational story writer",
    "icon": "\ud83d\udcdd",
    "layout": {
      "*": {
        "width": 920,
        "height": 620
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_prompt",
        "type": "string",
        "label": "Prompt",
        "description": "Story prompt or instructions",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_active_model",
        "type": "string",
        "label": "Active Model",
        "description": "Selected model variant: gemini or claude. Legacy gpt values are ignored while Script Plus is unavailable.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "claude",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_active_variant_id",
        "type": "string",
        "label": "Active Variant",
        "description": "Id of the out_script_variants entry the node currently displays. Empty means the newest variant for the active model.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_name",
        "type": "string",
        "label": "Name",
        "description": "Project or scene name",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_director_instruction",
        "type": "string",
        "label": "Director Instruction",
        "description": "Director's creative guidance composed from user Q&A \u2014 tone, structure, pacing, and other creative direction",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_format_only",
        "type": "boolean",
        "label": "Format Only",
        "description": "When true, the Script Writer only reformats the user prompt into screenplay structure without adding, modifying, or removing storyline content",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_gemini",
        "type": "boolean",
        "label": "Gemini",
        "description": "Enable Gemini model for screenplay generation",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_claude",
        "type": "boolean",
        "label": "Claude",
        "description": "Enable Claude model for screenplay generation",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": true,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_gpt",
        "type": "boolean",
        "label": "GPT",
        "description": "Legacy GPT model toggle retained for persisted project compatibility. Ignored while Script Plus is unavailable.",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_characters",
        "type": "string",
        "label": "Characters",
        "description": "Character names",
        "required": false,
        "multi": true,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_multi_array"
      },
      {
        "id": "in_feedback",
        "type": "string",
        "label": "Feedback",
        "description": "Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_target_duration_s",
        "type": "float",
        "label": "Target Duration (s)",
        "description": "Optional target total duration in seconds; used to compute suggested scene count. Director should set this from the user's duration choice (30s=30, about 1min=60, about 2min=120, about 5min=300, or a custom value).",
        "required": false,
        "multi": false,
        "pythonType": "float",
        "tsType": "number",
        "baseType": "float",
        "portSchemaId": "float_float_float_single_primitive"
      },
      {
        "id": "in_review_history",
        "type": "list[ReviewHistoryEntryDict]",
        "label": "Review History",
        "description": "Script review feedback history",
        "required": false,
        "multi": false,
        "pythonType": "list[ReviewHistoryEntryDict]",
        "tsType": "Array<ReviewHistoryEntryDict>",
        "baseType": "list[ReviewHistoryEntryDict]",
        "default": [],
        "hidden_from_director": true,
        "portSchemaId": "list_review_history_entry_dict_list_review_history_entry_dict_list_review_history_entry_dict_single_array"
      },
      {
        "id": "in_feedback_history",
        "type": "list[FeedbackHistoryEntryDict]",
        "label": "Feedback History",
        "description": "Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior screenplay + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries.",
        "required": false,
        "multi": false,
        "pythonType": "list[FeedbackHistoryEntryDict]",
        "tsType": "Array<FeedbackHistoryEntryDict>",
        "baseType": "list[FeedbackHistoryEntryDict]",
        "default": [],
        "hidden_from_director": true,
        "portSchemaId": "list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array"
      },
      {
        "id": "in_bg_color",
        "type": "string",
        "label": "Background Color",
        "description": "Predefined background color key for the node card",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "default",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_script",
        "type": "string",
        "label": "Script",
        "description": "Generated script content",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "user_editable": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_script_path",
        "type": "string",
        "label": "Script Path",
        "description": "Path to saved script file",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_screenplay",
        "type": "list[ScriptScreenplaySceneDict]",
        "label": "Screenplay",
        "description": "Structured screenplay (array of scene objects with typed entries)",
        "required": false,
        "multi": false,
        "pythonType": "list[ScriptScreenplaySceneDict]",
        "tsType": "Array<ScriptScreenplaySceneDict>",
        "baseType": "list[ScriptScreenplaySceneDict]",
        "portSchemaId": "list_script_screenplay_scene_dict_list_script_screenplay_scene_dict_list_script_screenplay_scene_dict_single_array"
      },
      {
        "id": "out_dialogue",
        "type": "list[ScriptDialogueDict]",
        "label": "Dialogue",
        "description": "Extracted dialogue entries with character, emotion, and text",
        "required": false,
        "multi": false,
        "pythonType": "list[ScriptDialogueDict]",
        "tsType": "Array<ScriptDialogueDict>",
        "baseType": "list[ScriptDialogueDict]",
        "hidden_from_director": true,
        "portSchemaId": "list_script_dialogue_dict_list_script_dialogue_dict_list_script_dialogue_dict_single_array"
      },
      {
        "id": "out_voice_roles",
        "type": "VoiceRoleDict",
        "label": "Voice Roles",
        "description": "Reusable narrator, system, and internal-monologue voice roles referenced by screenplay entries",
        "required": false,
        "multi": true,
        "pythonType": "VoiceRoleDict",
        "tsType": "VoiceRoleDict",
        "baseType": "VoiceRoleDict",
        "portSchemaId": "voice_role_dict_voice_role_dict_voice_role_dict_multi_array"
      },
      {
        "id": "out_voice_profiles",
        "type": "VoiceProfileDict",
        "label": "Narrator Voice Profiles",
        "description": "Provider-neutral narrator, system, title-card, and internal-monologue voice briefs. Profile name matches voice_role_id. Linked Sound Expert nodes choose and store concrete provider voices.",
        "required": false,
        "multi": true,
        "pythonType": "VoiceProfileDict",
        "tsType": "VoiceProfileDict",
        "baseType": "VoiceProfileDict",
        "portSchemaId": "voice_profile_dict_voice_profile_dict_voice_profile_dict_multi_array"
      },
      {
        "id": "out_action_lines",
        "type": "list[SceneTextDict]",
        "label": "Action Lines",
        "description": "Extracted action/staging direction entries per scene",
        "required": false,
        "multi": false,
        "pythonType": "list[SceneTextDict]",
        "tsType": "Array<SceneTextDict>",
        "baseType": "list[SceneTextDict]",
        "portSchemaId": "list_scene_text_dict_list_scene_text_dict_list_scene_text_dict_single_array"
      },
      {
        "id": "out_characters",
        "type": "string",
        "label": "Characters",
        "description": "Deduplicated list of character names appearing in the screenplay",
        "required": false,
        "multi": false,
        "pythonType": "list[str]",
        "tsType": "Array<string>",
        "baseType": "list[str]",
        "portSchemaId": "string_list_str_list_str_single_array"
      },
      {
        "id": "out_music_cues",
        "type": "list[SceneTextDict]",
        "label": "Music Cues",
        "description": "Music mood/genre cue entries per scene",
        "required": false,
        "multi": false,
        "pythonType": "list[SceneTextDict]",
        "tsType": "Array<SceneTextDict>",
        "baseType": "list[SceneTextDict]",
        "portSchemaId": "list_scene_text_dict_list_scene_text_dict_list_scene_text_dict_single_array"
      },
      {
        "id": "out_sfx",
        "type": "list[SceneTextDict]",
        "label": "SFX",
        "description": "Sound effect entries per scene",
        "required": false,
        "multi": false,
        "pythonType": "list[SceneTextDict]",
        "tsType": "Array<SceneTextDict>",
        "baseType": "list[SceneTextDict]",
        "portSchemaId": "list_scene_text_dict_list_scene_text_dict_list_scene_text_dict_single_array"
      },
      {
        "id": "out_gemini",
        "type": "ScreenplayResultDict",
        "label": "Gemini Result",
        "description": "Raw ScreenplayResult JSON from Gemini",
        "required": false,
        "multi": false,
        "pythonType": "ScreenplayResultDict",
        "tsType": "ScreenplayResultDict",
        "baseType": "ScreenplayResultDict",
        "hidden_from_director": true,
        "portSchemaId": "screenplay_result_dict_screenplay_result_dict_screenplay_result_dict_single_map"
      },
      {
        "id": "out_claude",
        "type": "ScreenplayResultDict",
        "label": "Claude Result",
        "description": "Raw ScreenplayResult JSON from Claude Opus 4",
        "required": false,
        "multi": false,
        "pythonType": "ScreenplayResultDict",
        "tsType": "ScreenplayResultDict",
        "baseType": "ScreenplayResultDict",
        "hidden_from_director": true,
        "portSchemaId": "screenplay_result_dict_screenplay_result_dict_screenplay_result_dict_single_map"
      },
      {
        "id": "out_gpt",
        "type": "ScreenplayResultDict",
        "label": "GPT Result",
        "description": "Legacy GPT-4o ScreenplayResult JSON retained for persisted project compatibility.",
        "required": false,
        "multi": false,
        "pythonType": "ScreenplayResultDict",
        "tsType": "ScreenplayResultDict",
        "baseType": "ScreenplayResultDict",
        "hidden_from_director": true,
        "portSchemaId": "screenplay_result_dict_screenplay_result_dict_screenplay_result_dict_single_map"
      },
      {
        "id": "out_locations",
        "type": "string",
        "label": "Locations",
        "description": "Extracted location names from screenplay",
        "required": false,
        "multi": false,
        "pythonType": "list[str]",
        "tsType": "Array<string>",
        "baseType": "list[str]",
        "portSchemaId": "string_list_str_list_str_single_array"
      },
      {
        "id": "out_active_model",
        "type": "string",
        "label": "Active Model",
        "description": "Which model variant was selected (gemini or claude)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_scene_count",
        "type": "int",
        "label": "Scene Count",
        "description": "Number of scenes in the generated screenplay",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "out_logline",
        "type": "string",
        "label": "Logline",
        "description": "One-sentence logline for the active model's screenplay",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_genre_tone",
        "type": "string",
        "label": "Genre / Tone",
        "description": "Genre and tonal register of the active model's screenplay",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_synopsis",
        "type": "string",
        "label": "Synopsis",
        "description": "Short prose synopsis of the active model's screenplay",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_themes",
        "type": "string",
        "label": "Themes",
        "description": "Central themes of the active model's screenplay",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_script_variants",
        "type": "list[ScriptVariantDict]",
        "label": "Script Variants",
        "description": "Screenplay iteration history, oldest first. One entry per model per successful run; the node's Variants panel lists these newest-first and marks the active one as the master script. Capped at the most recent 20 entries.",
        "required": false,
        "multi": false,
        "pythonType": "list[ScriptVariantDict]",
        "tsType": "Array<ScriptVariantDict>",
        "baseType": "list[ScriptVariantDict]",
        "default": [],
        "hidden_from_director": true,
        "portSchemaId": "list_script_variant_dict_list_script_variant_dict_list_script_variant_dict_single_array"
      }
    ],
    "state": [],
    "executionActions": [
      "generate",
      "rewrite_with_model",
      "resync_from_script",
      "replace_from_script"
    ],
    "actionLabels": {
      "rewrite_with_model": "Rewrite screenplay",
      "resync_from_script": "Sync edits",
      "replace_from_script": "Replace script"
    },
    "directorGuidance": "Use the screenplay tools for screenplay work instead of raw DAG changes. Load screenplay-episode-flow for new episode or chapter continuation; Script Writer outputs drive downstream designer, storyboard, and video workflows.",
    "projectStatusOnComplete": "in_progress"
  },
  "shortVideoGroup": {
    "type": "shortVideoGroup",
    "backendType": "short_video_group",
    "label": "Short Video",
    "category": "Group",
    "description": "Group node for short video production with storyboard grid and horizontal panel layout",
    "icon": "\ud83c\udfac",
    "layout": {
      "*": {
        "width": 355,
        "height": 4000
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_label",
        "type": "string",
        "label": "Label",
        "description": "Display label for the group",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "Short Video",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_collapsed",
        "type": "boolean",
        "label": "Collapsed",
        "description": "Whether the group is collapsed",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_storyboard_path",
        "type": "string",
        "label": "Storyboard Path",
        "description": "Path to the storyboard grid image",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_image",
        "type": "image",
        "label": "Reference Image",
        "description": "Reference image for connected edges",
        "required": false,
        "multi": false,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "hidden_from_director": true,
        "portSchemaId": "image_image_asset_ref_dict_image_asset_single_map"
      },
      {
        "id": "in_child_node_ids",
        "type": "string",
        "label": "Child Nodes",
        "description": "IDs of child panel nodes",
        "required": false,
        "multi": false,
        "pythonType": "list[str]",
        "tsType": "Array<string>",
        "baseType": "list[str]",
        "default": [],
        "hidden_from_director": true,
        "portSchemaId": "string_list_str_list_str_single_array"
      }
    ],
    "outputs": [],
    "state": []
  },
  "soundExpert": {
    "type": "soundExpert",
    "backendType": "sound_expert",
    "label": "Sound Expert",
    "category": "Agentic",
    "description": "Generate music, speech, or sound effects with three unified modes",
    "icon": "\ud83c\udfa7",
    "layout": {
      "*": {
        "width": 315,
        "height": 200
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_name",
        "type": "string",
        "label": "Name",
        "description": "Display name for the node (FloatingNodeLabel)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_upstream",
        "type": "UpstreamContextDict",
        "label": "Upstream",
        "description": "Upstream dependency trigger",
        "required": false,
        "multi": false,
        "pythonType": "UpstreamContextDict",
        "tsType": "UpstreamContextDict",
        "baseType": "UpstreamContextDict",
        "portSchemaId": "upstream_context_dict_upstream_context_dict_upstream_context_dict_single_map"
      },
      {
        "id": "in_prompt",
        "type": "string",
        "label": "Prompt",
        "description": "Free-text description of desired audio (music/sfx)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_mode",
        "type": "string",
        "label": "Mode",
        "description": "Audio generation mode: music, speech, or sfx",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "music",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_duration",
        "type": "string",
        "label": "Duration",
        "description": "Duration hint as human-readable string (music/sfx only)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "30s",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_voice_profile",
        "type": "VoiceProfileDict",
        "label": "Voice Profile",
        "description": "Voice profile from Character Designer for speech mode",
        "required": false,
        "multi": false,
        "pythonType": "VoiceProfileDict",
        "tsType": "VoiceProfileDict",
        "baseType": "VoiceProfileDict",
        "portSchemaId": "voice_profile_dict_voice_profile_dict_voice_profile_dict_single_map"
      },
      {
        "id": "in_text",
        "type": "string",
        "label": "Text",
        "description": "Final speakable dialogue or narration transcript for speech mode. Do not put refinement notes, instructions, headings, or prompt text here; use Feedback for revisions.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_feedback",
        "type": "string",
        "label": "Feedback",
        "description": "Correction or revision feedback for the next speech-mode run. Set this via propose_dag_changes (op=update) before calling run_nodes to revise an existing voiceover without mixing instructions into Text.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_feedback_history",
        "type": "list[FeedbackHistoryEntryDict]",
        "label": "Feedback History",
        "description": "Accumulated Sound Expert speech refinement feedback per round. The agent appends a new entry whenever it rewrites speech from non-empty feedback so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries.",
        "required": false,
        "multi": false,
        "pythonType": "list[FeedbackHistoryEntryDict]",
        "tsType": "Array<FeedbackHistoryEntryDict>",
        "baseType": "list[FeedbackHistoryEntryDict]",
        "maxItems": 10,
        "default": [],
        "hidden_from_director": true,
        "portSchemaId": "list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array"
      },
      {
        "id": "in_model",
        "type": "string",
        "label": "Model",
        "description": "Audio generation model identifier",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "elevenlabs_v3",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_loop",
        "type": "string",
        "label": "Loop",
        "description": "Whether to loop the audio (sfx mode)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "off",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_lyrics_mode",
        "type": "string",
        "label": "Lyrics Mode",
        "description": "Lyrics generation mode for music (auto/custom/instrumental)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "auto",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_voice_map",
        "type": "VoiceMapDict",
        "label": "Voice Map",
        "description": "Speaker-to-voice mapping for multi-speaker narration (speech mode)",
        "required": false,
        "multi": false,
        "pythonType": "VoiceMapDict",
        "tsType": "VoiceMapDict",
        "baseType": "VoiceMapDict",
        "default": {},
        "portSchemaId": "voice_map_dict_voice_map_dict_voice_map_dict_single_map"
      },
      {
        "id": "in_scene_id",
        "type": "string",
        "label": "Scene ID",
        "description": "Scene identifier for file naming (speech mode)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_panel_index",
        "type": "int",
        "label": "Panel Index",
        "description": "Panel index for ordering within a scene (speech mode)",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_pause_ms",
        "type": "int",
        "label": "Pause (ms)",
        "description": "Pause duration in milliseconds between segments (speech mode)",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "default": 200,
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_character_name",
        "type": "string",
        "label": "Character Name",
        "description": "Character name for single-speaker TTS (speech mode)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_character_voice_source_for",
        "type": "string",
        "label": "Character Voice Source For",
        "description": "Character node id when this Sound Expert is the active Character voice source.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_duration_seconds",
        "type": "float",
        "label": "Duration",
        "description": "Audio duration in seconds",
        "required": false,
        "multi": false,
        "pythonType": "float",
        "tsType": "number",
        "baseType": "float",
        "portSchemaId": "float_float_float_single_primitive"
      },
      {
        "id": "out_audio",
        "type": "audio",
        "label": "Generated Audio",
        "description": "Generated audio with history and picked index",
        "required": false,
        "multi": false,
        "pythonType": "SoundGeneratedAudioDict",
        "tsType": "SoundGeneratedAudioDict",
        "baseType": "AudioAsset",
        "portSchemaId": "audio_sound_generated_audio_dict_audio_asset_single_map"
      },
      {
        "id": "out_voice_profile",
        "type": "VoiceProfileDict",
        "label": "Voice Profile",
        "description": "Voice metadata selected or used by this Sound Expert node for speech generation",
        "required": false,
        "multi": false,
        "pythonType": "VoiceProfileDict",
        "tsType": "VoiceProfileDict",
        "baseType": "VoiceProfileDict",
        "portSchemaId": "voice_profile_dict_voice_profile_dict_voice_profile_dict_single_map"
      }
    ],
    "state": [
      {
        "id": "batch_pending",
        "type": "int",
        "label": "batch_pending",
        "description": "",
        "pythonType": "int",
        "tsType": "number"
      },
      {
        "id": "audio_file",
        "type": "string",
        "label": "audio_file",
        "description": "Legacy: direct path to audio file. TODO: Remove after full canvas-v2 migration",
        "pythonType": "str",
        "tsType": "string"
      },
      {
        "id": "speech_segments",
        "type": "SpeechSegmentDict",
        "label": "speech_segments",
        "description": "Per-character speech segments with generated speech results",
        "pythonType": "SpeechSegmentDict",
        "tsType": "SpeechSegmentDict"
      },
      {
        "id": "selected_voice_provider",
        "type": "string",
        "label": "selected_voice_provider",
        "description": "Provider for the selected speech voice owned by this Sound Expert node",
        "pythonType": "str",
        "tsType": "string"
      },
      {
        "id": "selected_voice_id",
        "type": "string",
        "label": "selected_voice_id",
        "description": "Provider voice id selected by this Sound Expert node for speech TTS",
        "pythonType": "str",
        "tsType": "string"
      },
      {
        "id": "selected_voice_name",
        "type": "string",
        "label": "selected_voice_name",
        "description": "Display name for the selected speech voice owned by this Sound Expert node",
        "pythonType": "str",
        "tsType": "string"
      },
      {
        "id": "selected_voice_ref",
        "type": "string",
        "label": "selected_voice_ref",
        "description": "Opaque Dreamwrite catalogue reference for the selected speech voice",
        "pythonType": "str",
        "tsType": "string"
      }
    ],
    "pricing": {
      "category": "audio_models",
      "model": "elevenlabs",
      "priceType": "per_generation"
    },
    "directorGuidance": "Modes: music, speech, sfx. On add set in_mode. For music/SFX set in_prompt; set in_lyrics_mode=instrumental for instrumental music. For new speech set in_mode=speech and in_text to final speakable transcript only: no refinement notes, instructions, headings, or prompt text. To revise existing speech, set in_feedback and call run_nodes. Prefer generate_background_music for background music; load standalone-media-generation for speech, SFX, duration, or voice references.",
    "projectStatusOnComplete": "in_progress"
  },
  "speechGenerator": {
    "type": "speechGenerator",
    "backendType": "speech_generator",
    "label": "Speech Generator",
    "category": "Agentic",
    "description": "Generate character speech or multi-voice narration",
    "icon": "\ud83d\udde3\ufe0f",
    "layout": {
      "*": {
        "width": 315,
        "height": 200
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_mode",
        "type": "string",
        "label": "Mode",
        "description": "Speech generation mode: character_voice or narrative",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "narrative",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_script",
        "type": "string",
        "label": "Script",
        "description": "Narration script or fallback text for character voice mode",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_text",
        "type": "string",
        "label": "Text",
        "description": "Single-speaker text for character voice mode",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_character_name",
        "type": "string",
        "label": "Character Name",
        "description": "Character name for single-speaker TTS",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_voice_id",
        "type": "string",
        "label": "Voice ID",
        "description": "Explicit provider voice ID override",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_voice_profile",
        "type": "VoiceProfileDict",
        "label": "Voice Profile",
        "description": "Voice profile from Character Designer",
        "required": false,
        "multi": false,
        "pythonType": "VoiceProfileDict",
        "tsType": "VoiceProfileDict",
        "baseType": "VoiceProfileDict",
        "portSchemaId": "voice_profile_dict_voice_profile_dict_voice_profile_dict_single_map"
      },
      {
        "id": "in_voice_map",
        "type": "VoiceMapDict",
        "label": "Voice Map",
        "description": "Speaker-to-voice mapping for multi-speaker narration",
        "required": false,
        "multi": false,
        "pythonType": "VoiceMapDict",
        "tsType": "VoiceMapDict",
        "baseType": "VoiceMapDict",
        "default": {},
        "portSchemaId": "voice_map_dict_voice_map_dict_voice_map_dict_single_map"
      },
      {
        "id": "in_scene_id",
        "type": "string",
        "label": "Scene ID",
        "description": "Scene identifier for file naming",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_panel_index",
        "type": "int",
        "label": "Panel Index",
        "description": "Panel index for ordering within a scene",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_pause_ms",
        "type": "int",
        "label": "Pause (ms)",
        "description": "Pause duration in milliseconds between segments",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "default": 200,
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_pronunciation_guide",
        "type": "string",
        "label": "Pronunciation Guide",
        "description": "Per-word pronunciation overrides for non-English words and proper nouns. One rule per line: 'word \u2192 pronunciation' (alias) or 'word \u2192 /IPA/' (phoneme). Example: L'Ora \u2192 LOH-rah",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_language_code",
        "type": "string",
        "label": "Language",
        "description": "ISO 639-1 language code (e.g. 'en', 'it', 'zh', 'ja'). Helps ElevenLabs apply correct phonetics instead of defaulting to English. Leave empty for auto-detection.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_duration_seconds",
        "type": "float",
        "label": "Duration",
        "description": "Audio duration in seconds",
        "required": false,
        "multi": false,
        "pythonType": "float",
        "tsType": "number",
        "baseType": "float",
        "portSchemaId": "float_float_float_single_primitive"
      },
      {
        "id": "out_waveform",
        "type": "list[float]",
        "label": "Waveform",
        "description": "Waveform samples for UI display",
        "required": false,
        "multi": false,
        "pythonType": "list[float]",
        "tsType": "Array<number>",
        "baseType": "list[float]",
        "portSchemaId": "list_float_list_float_list_float_single_array"
      },
      {
        "id": "out_audio",
        "type": "audio",
        "label": "Generated Audio",
        "description": "Generated audio with history and picked index",
        "required": false,
        "multi": false,
        "pythonType": "SoundGeneratedAudioDict",
        "tsType": "SoundGeneratedAudioDict",
        "baseType": "AudioAsset",
        "portSchemaId": "audio_sound_generated_audio_dict_audio_asset_single_map"
      }
    ],
    "state": [],
    "pricing": {
      "category": "audio_models",
      "model": "gemini_tts",
      "priceType": "per_generation"
    },
    "projectStatusOnComplete": "in_progress"
  },
  "storyDirectionPreview": {
    "type": "storyDirectionPreview",
    "backendType": "story_direction_preview",
    "label": "Story Direction",
    "category": "Story Shaping",
    "description": "Story shaping dimensions: premise, tone, hook, structure",
    "icon": "\ud83e\udded",
    "layout": {
      "*": {
        "width": 920,
        "height": 650
      }
    },
    "canvasHidden": true,
    "inputs": [],
    "outputs": [],
    "state": [
      {
        "id": "premise",
        "type": "StoryDirectionFieldDict",
        "label": "premise",
        "description": "",
        "pythonType": "StoryDirectionFieldDict",
        "tsType": "StoryDirectionFieldDict"
      },
      {
        "id": "tone",
        "type": "StoryDirectionFieldDict",
        "label": "tone",
        "description": "",
        "pythonType": "StoryDirectionFieldDict",
        "tsType": "StoryDirectionFieldDict"
      },
      {
        "id": "hook",
        "type": "StoryDirectionFieldDict",
        "label": "hook",
        "description": "",
        "pythonType": "StoryDirectionFieldDict",
        "tsType": "StoryDirectionFieldDict"
      },
      {
        "id": "structure",
        "type": "StoryDirectionFieldDict",
        "label": "structure",
        "description": "",
        "pythonType": "StoryDirectionFieldDict",
        "tsType": "StoryDirectionFieldDict"
      }
    ]
  },
  "storyboardDesigner": {
    "type": "storyboardDesigner",
    "backendType": "storyboard_designer",
    "label": "Storyboard Designer",
    "category": "Agentic",
    "description": "Generate a 9-grid storyboard from a script or scene description",
    "icon": "\ud83c\udfac",
    "layout": {
      "*": {
        "width": 480,
        "height": 420
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_script",
        "type": "string",
        "label": "Script",
        "description": "Script or scene breakdown to visualize as storyboard",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_characters",
        "type": "image",
        "label": "Characters",
        "description": "Character reference sheets for visual consistency",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "referenceDesignerNodeType": "character_designer",
        "hidden_from_director": true,
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "in_character_names",
        "type": "string",
        "label": "Character Names",
        "description": "Character names from designer out_name ports",
        "required": false,
        "multi": true,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_multi_array"
      },
      {
        "id": "in_locations",
        "type": "image",
        "label": "Locations",
        "description": "Location reference images for scene setting",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "referenceDesignerNodeType": "location_designer",
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "in_location_names",
        "type": "string",
        "label": "Location Names",
        "description": "Location names from designer out_name ports",
        "required": false,
        "multi": true,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_multi_array"
      },
      {
        "id": "in_objects",
        "type": "image",
        "label": "Objects",
        "description": "Object reference images for props and items",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "referenceDesignerNodeType": "object_designer",
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "in_object_names",
        "type": "string",
        "label": "Object Names",
        "description": "Object names from designer out_name ports",
        "required": false,
        "multi": true,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_multi_array"
      },
      {
        "id": "in_image",
        "type": "image",
        "label": "Reference Image",
        "description": "Optional reference image to guide storyboard generation",
        "required": false,
        "multi": false,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "hidden_from_director": true,
        "portSchemaId": "image_image_asset_ref_dict_image_asset_single_map"
      },
      {
        "id": "in_style",
        "type": "string",
        "label": "Art Style",
        "description": "Visual art style for the storyboard",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_panel_count",
        "type": "int",
        "label": "Panel Count",
        "description": "Number of panels (default 9 for 9-grid)",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "default": 9,
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_shot_count",
        "type": "int",
        "label": "Shot Count",
        "description": "Optional exact count for text-mode Shot List generation; when unset, the planner chooses the count.",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_aspect_ratio",
        "type": "string",
        "label": "Aspect Ratio",
        "description": "Optional storyboard aspect ratio override. When unset, uses the project aspect ratio.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_scene_id",
        "type": "string",
        "label": "Scene ID",
        "description": "Scene identifier for the storyboard",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "scene_1",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_name",
        "type": "string",
        "label": "Name",
        "description": "Optional display label for the storyboard designer node",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_location",
        "type": "string",
        "label": "Location",
        "description": "Location for the scene",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_model",
        "type": "string",
        "label": "Model",
        "description": "Image generation model",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "openai-gpt-image-2",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_feedback",
        "type": "string",
        "label": "Feedback",
        "description": "Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_vlm_validation",
        "type": "boolean",
        "label": "Quality Check",
        "description": "Run Gemini VLM quality validation after generation",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_video_anchors",
        "type": "list[ShotVideoAnchorDict]",
        "label": "Exact Video Frames",
        "description": "User-designated exact first/last frame assets by shot ID. Automatically generated frames remain reference images unless explicitly designated.",
        "required": false,
        "multi": false,
        "pythonType": "list[ShotVideoAnchorDict]",
        "tsType": "Array<ShotVideoAnchorDict>",
        "baseType": "list[ShotVideoAnchorDict]",
        "hidden_from_director": true,
        "directorWritable": false,
        "canvasEntryKeys": [
          "shot_id",
          "role"
        ],
        "canvasEntryOnlyExact": true,
        "portSchemaId": "list_shot_video_anchor_dict_list_shot_video_anchor_dict_list_shot_video_anchor_dict_single_array"
      }
    ],
    "outputs": [
      {
        "id": "out_image",
        "type": "image",
        "label": "Grid History",
        "description": "History of generated storyboard grid images and selected variant",
        "required": false,
        "multi": false,
        "pythonType": "GeneratedImageWithHistory",
        "tsType": "GeneratedImageWithHistory",
        "baseType": "ImageAsset",
        "portSchemaId": "image_generated_image_with_history_image_asset_single_map"
      },
      {
        "id": "out_grid_images",
        "type": "image",
        "label": "Grid Images",
        "description": "Per-grid storyboard composite image paths for multi-grid storyboards",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "hidden_from_director": true,
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "out_metadata",
        "type": "StoryboardMetadataDict",
        "label": "Metadata",
        "description": "Storyboard metadata including beat descriptions",
        "required": false,
        "multi": false,
        "pythonType": "StoryboardMetadataDict",
        "tsType": "StoryboardMetadataDict",
        "baseType": "StoryboardMetadataDict",
        "portSchemaId": "storyboard_metadata_dict_storyboard_metadata_dict_storyboard_metadata_dict_single_map"
      },
      {
        "id": "out_beats",
        "type": "string",
        "label": "Beats",
        "description": "Beat descriptions per panel",
        "required": false,
        "multi": true,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_multi_array"
      },
      {
        "id": "out_shots",
        "type": "GeneratedShotRowV2Dict",
        "label": "Generated Shots",
        "description": "Versioned shot records; multi-array output permits individual downstream shot references.",
        "required": false,
        "multi": true,
        "pythonType": "GeneratedShotRowV2Dict",
        "tsType": "GeneratedShotRowV2Dict",
        "baseType": "GeneratedShotRowV2Dict",
        "hidden_from_director": true,
        "directorWritable": false,
        "portSchemaId": "generated_shot_row_v2_dict_generated_shot_row_v2_dict_generated_shot_row_v2_dict_multi_array"
      },
      {
        "id": "out_shot_seams",
        "type": "list[ShotSeamDict]",
        "label": "Shot Transitions",
        "description": "Atomic ordered shot-boundary list (not flattened): N shots have N+1 seams.",
        "required": false,
        "multi": false,
        "pythonType": "list[ShotSeamDict]",
        "tsType": "Array<ShotSeamDict>",
        "baseType": "list[ShotSeamDict]",
        "hidden_from_director": true,
        "directorWritable": false,
        "portSchemaId": "list_shot_seam_dict_list_shot_seam_dict_list_shot_seam_dict_single_array"
      },
      {
        "id": "out_production_plan",
        "type": "ShotProductionPlanDict",
        "label": "Shot List Production Plan",
        "description": "Versioned production annotations for an existing text Shot List.",
        "required": false,
        "multi": false,
        "pythonType": "ShotProductionPlanDict",
        "tsType": "ShotProductionPlanDict",
        "baseType": "ShotProductionPlanDict",
        "hidden_from_director": true,
        "directorWritable": false,
        "portSchemaId": "shot_production_plan_dict_shot_production_plan_dict_shot_production_plan_dict_single_map"
      },
      {
        "id": "out_video_generation_plan",
        "type": "ShotVideoGenerationPlanDict",
        "label": "Video Generation Plan",
        "description": "Exact-duration ordered packs, shared shot Generation IDs and corresponding video node IDs.",
        "required": false,
        "multi": false,
        "pythonType": "ShotVideoGenerationPlanDict",
        "tsType": "ShotVideoGenerationPlanDict",
        "baseType": "ShotVideoGenerationPlanDict",
        "hidden_from_director": true,
        "directorWritable": false,
        "portSchemaId": "shot_video_generation_plan_dict_shot_video_generation_plan_dict_shot_video_generation_plan_dict_single_map"
      },
      {
        "id": "out_video_previous_plan",
        "type": "ShotVideoGenerationPlanDict",
        "label": "Previous Video Plan",
        "description": "Inactive pack provenance retained for selective replanning; never authorizes video generation.",
        "required": false,
        "multi": false,
        "pythonType": "ShotVideoGenerationPlanDict",
        "tsType": "ShotVideoGenerationPlanDict",
        "baseType": "ShotVideoGenerationPlanDict",
        "hidden_from_director": true,
        "directorWritable": false,
        "ydocMapCopy": true,
        "portSchemaId": "shot_video_generation_plan_dict_shot_video_generation_plan_dict_shot_video_generation_plan_dict_single_map"
      },
      {
        "id": "out_start_frames",
        "type": "image",
        "label": "Shot Start Frames",
        "description": "Text-mode images indexed by canonical shot position, never by grid packing or frame mode.",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "hidden_from_director": true,
        "directorWritable": false,
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "out_key_frames",
        "type": "image",
        "label": "Shot Key Frames",
        "description": "Text-mode key-frame images indexed by canonical shot position.",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "hidden_from_director": true,
        "directorWritable": false,
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "out_end_frames",
        "type": "image",
        "label": "Shot End Frames",
        "description": "Text-mode end-frame images indexed by canonical shot position.",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "hidden_from_director": true,
        "directorWritable": false,
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "out_start_frame_prompts",
        "type": "string",
        "label": "Start Frame Prompts",
        "description": "",
        "required": false,
        "multi": true,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "directorWritable": false,
        "portSchemaId": "string_str_str_multi_array"
      },
      {
        "id": "out_key_frame_prompts",
        "type": "string",
        "label": "Key Frame Prompts",
        "description": "",
        "required": false,
        "multi": true,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "directorWritable": false,
        "portSchemaId": "string_str_str_multi_array"
      },
      {
        "id": "out_end_frame_prompts",
        "type": "string",
        "label": "End Frame Prompts",
        "description": "",
        "required": false,
        "multi": true,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "directorWritable": false,
        "portSchemaId": "string_str_str_multi_array"
      },
      {
        "id": "out_frame_links",
        "type": "list[ShotFrameLinkDict]",
        "label": "Shot Frame Links",
        "description": "Versioned shot/role to image-generator node mapping and per-slot status.",
        "required": false,
        "multi": false,
        "pythonType": "list[ShotFrameLinkDict]",
        "tsType": "Array<ShotFrameLinkDict>",
        "baseType": "list[ShotFrameLinkDict]",
        "hidden_from_director": true,
        "directorWritable": false,
        "portSchemaId": "list_shot_frame_link_dict_list_shot_frame_link_dict_list_shot_frame_link_dict_single_array"
      },
      {
        "id": "out_panel_refs",
        "type": "string",
        "label": "Panel Refs",
        "description": "Per-panel list of designer node IDs",
        "required": false,
        "multi": true,
        "pythonType": "list[str]",
        "tsType": "Array<string>",
        "baseType": "list[str]",
        "hidden_from_director": true,
        "portSchemaId": "string_list_str_list_str_multi_array"
      },
      {
        "id": "out_images",
        "type": "image",
        "label": "Panel Images",
        "description": "Cropped panel image paths",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "hidden_from_director": true,
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "out_grid_descriptions",
        "type": "string",
        "label": "Grid Descriptions",
        "description": "Per-grid concatenated beat descriptions for grid preview node prompts",
        "required": false,
        "multi": true,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_multi_array"
      },
      {
        "id": "out_vlm_report",
        "type": "VlmValidationReportDict",
        "label": "Quality Report",
        "description": "VLM quality validation report from the most recent generation",
        "required": false,
        "multi": false,
        "pythonType": "VlmValidationReportDict",
        "tsType": "VlmValidationReportDict",
        "baseType": "VlmValidationReportDict",
        "portSchemaId": "vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map"
      }
    ],
    "state": [
      {
        "id": "shot_guidance_kind",
        "type": "string",
        "label": "Shot List Guidance Kind",
        "description": "Provenance of a generated text Shot List: prompt or script.",
        "pythonType": "str",
        "tsType": "string",
        "directorWritable": false
      },
      {
        "id": "shot_guidance_fingerprint",
        "type": "string",
        "label": "Shot List Guidance Fingerprint",
        "description": "Fingerprint of the input guidance used for the current text Shot List.",
        "pythonType": "str",
        "tsType": "string",
        "directorWritable": false
      },
      {
        "id": "shot_guidance_warning",
        "type": "string",
        "label": "Shot List Guidance Warning",
        "description": "Review notice for unplaced screenplay scenes, mismatched scene suggestions or omitted dialogue.",
        "pythonType": "str",
        "tsType": "string",
        "directorWritable": false
      },
      {
        "id": "batch_pending",
        "type": "int",
        "label": "batch_pending",
        "description": "",
        "pythonType": "int",
        "tsType": "number"
      },
      {
        "id": "storyboard_view",
        "type": "string",
        "label": "Storyboard View",
        "description": "Presentation mode. Absent on legacy storyboard nodes.",
        "pythonType": "str",
        "tsType": "string",
        "directorWritable": false
      },
      {
        "id": "shot_list_planner_version",
        "type": "int",
        "label": "Shot List Planner Version",
        "description": "Marks prompt-guided Shot Lists; absent means the legacy screenplay-bound planner.",
        "pythonType": "int",
        "tsType": "number",
        "directorWritable": false
      },
      {
        "id": "storyboard_mode",
        "type": "string",
        "label": "Storyboard Execution Mode",
        "description": "Execution mode; absent means the historical image storyboard workflow.",
        "pythonType": "str",
        "tsType": "string",
        "directorWritable": false
      },
      {
        "id": "shot_list",
        "type": "ShotListRowDict",
        "label": "Shot List",
        "description": "Text-only shot rows; no storyboard image output or execution path.",
        "pythonType": "list[ShotListRowDict]",
        "tsType": "Array<ShotListRowDict>",
        "directorWritable": false
      },
      {
        "id": "shot_key_frame_relinks",
        "type": "ShotKeyFrameRelinkDict",
        "label": "User-selected key frames",
        "description": "Unique shot-ID-keyed selections of existing image nodes; override effective video master frames without replacing generated frame links.",
        "pythonType": "list[ShotKeyFrameRelinkDict]",
        "tsType": "Array<ShotKeyFrameRelinkDict>",
        "directorWritable": false,
        "canvasEntryKeys": [
          "shot_id"
        ]
      },
      {
        "id": "name_autogen",
        "type": "string",
        "label": "Auto-generated Name Marker",
        "description": "Marker token identifying which auto-generated default-name family this node's display name came from (see agentic_workflow.core.default_node_names). Absent on user-created and pre-marker nodes. The console localizes the name only while the stored value still equals the canonical English rendering, so a rename automatically wins.",
        "pythonType": "str",
        "tsType": "string"
      }
    ],
    "pricing": {
      "default": {
        "category": "image_models",
        "model": "openai-gpt-image-2",
        "priceType": "per_image"
      },
      "actions": {
        "generate_shot_list": null,
        "rewrite_shot_list": null,
        "generate_production_plan": null,
        "generate_shot_frames_key": {
          "category": "image_models",
          "model": "openai-gpt-image-2",
          "priceType": "per_image"
        },
        "generate_shot_frames_start_end": {
          "category": "image_models",
          "model": "openai-gpt-image-2",
          "priceType": "per_image"
        },
        "generate_shot_frames_all": {
          "category": "image_models",
          "model": "openai-gpt-image-2",
          "priceType": "per_image"
        }
      }
    },
    "executionActions": [
      "generate",
      "generate_shot_list",
      "generate_production_plan",
      "generate_shot_frames_key",
      "generate_shot_frames_start_end",
      "generate_shot_frames_all"
    ],
    "actionLabels": {
      "generate_shot_list": "Generate Shot List",
      "generate_production_plan": "Plan Production Details",
      "generate_shot_frames_key": "Generate Key Frames",
      "generate_shot_frames_start_end": "Generate Start and End Frames",
      "generate_shot_frames_all": "Generate All Shot Frames"
    },
    "directorGuidance": "Create with create_storyboard_node and rerun with rerun_storyboard_node, not raw DAG changes/run_nodes; those tools keep storyboard, panel nodes, groups, and edges in sync. Load storyboard-workflow for panel count, references, or storyboard-to-video handoff.",
    "projectStatusOnComplete": "in_progress"
  },
  "storyboardNoEnhanceDesigner": {
    "type": "storyboardNoEnhanceDesigner",
    "backendType": "storyboard_no_enhance_designer",
    "label": "Storyboard (No Enhance)",
    "category": "Agentic",
    "description": "Generate a 9-grid storyboard without per-panel enhancement",
    "icon": "\ud83c\udfac",
    "layout": {
      "*": {
        "width": 480,
        "height": 420
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_script",
        "type": "string",
        "label": "Script",
        "description": "Script or scene breakdown to visualize",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_characters",
        "type": "image",
        "label": "Characters",
        "description": "Character reference sheets",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "hidden_from_director": true,
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "in_character_names",
        "type": "string",
        "label": "Character Names",
        "description": "Character names from designer out_name ports",
        "required": false,
        "multi": true,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_multi_array"
      },
      {
        "id": "in_locations",
        "type": "image",
        "label": "Locations",
        "description": "Location reference images",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "in_location_names",
        "type": "string",
        "label": "Location Names",
        "description": "Location names from designer out_name ports",
        "required": false,
        "multi": true,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_multi_array"
      },
      {
        "id": "in_style",
        "type": "string",
        "label": "Art Style",
        "description": "Visual art style",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_panel_count",
        "type": "int",
        "label": "Panel Count",
        "description": "Number of panels",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "default": 9,
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_scene_id",
        "type": "string",
        "label": "Scene ID",
        "description": "Scene identifier",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "scene_1",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_location",
        "type": "string",
        "label": "Location",
        "description": "Location for the scene",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_model",
        "type": "string",
        "label": "Model",
        "description": "Image generation model",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "openai-gpt-image-2",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_vlm_validation",
        "type": "boolean",
        "label": "Quality Check",
        "description": "Run Gemini VLM quality validation after generation",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_image",
        "type": "image",
        "label": "Grid",
        "description": "Relative path to 9-grid image",
        "required": false,
        "multi": false,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "portSchemaId": "image_image_asset_ref_dict_image_asset_single_map"
      },
      {
        "id": "out_vlm_report",
        "type": "VlmValidationReportDict",
        "label": "Quality Report",
        "description": "VLM quality validation report from the most recent generation",
        "required": false,
        "multi": false,
        "pythonType": "VlmValidationReportDict",
        "tsType": "VlmValidationReportDict",
        "baseType": "VlmValidationReportDict",
        "portSchemaId": "vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map"
      }
    ],
    "state": [],
    "pricing": {
      "category": "image_models",
      "model": "openai-gpt-image-2",
      "priceType": "per_image"
    },
    "projectStatusOnComplete": "in_progress"
  },
  "styleSelector": {
    "type": "styleSelector",
    "backendType": "style_selector",
    "label": "Style Selector",
    "category": "Input",
    "description": "Select visual style for generation",
    "icon": "\ud83c\udfa8",
    "layout": {
      "*": {
        "width": 280,
        "height": 200
      }
    },
    "canvasHidden": false,
    "inputs": [],
    "outputs": [
      {
        "id": "out_style",
        "type": "string",
        "label": "Style",
        "description": "The selected visual style",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "state": []
  },
  "text": {
    "type": "text",
    "backendType": "text",
    "label": "Text",
    "category": "Input",
    "description": "A text input with editable title",
    "icon": "\ud83d\udcdd",
    "layout": {
      "*": {
        "width": 280,
        "height": 200
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_input",
        "type": "string",
        "label": "Input",
        "description": "Text input from another node",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_text",
        "type": "string",
        "label": "Text",
        "description": "The text content",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "state": []
  },
  "video": {
    "type": "video",
    "backendType": "video",
    "label": "Video Upload",
    "category": "Media",
    "description": "Upload a local video file",
    "icon": "\ud83c\udfac",
    "layout": {
      "*": {
        "width": 315,
        "height": 177
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_file_name",
        "type": "string",
        "label": "File Name",
        "description": "",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_depth_include_audio",
        "type": "boolean",
        "label": "Include Source Audio in Depth Video",
        "description": "Keep the original clip audio in the extracted depth video.",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_transform_video",
        "type": "image",
        "label": "Transform Source Video",
        "description": "",
        "required": false,
        "multi": false,
        "pythonType": "VideoAssetRefDict",
        "tsType": "VideoAssetRefDict",
        "baseType": "VideoAsset",
        "hidden_from_director": true,
        "portSchemaId": "image_video_asset_ref_dict_video_asset_single_map"
      },
      {
        "id": "in_transform_target_resolution",
        "type": "string",
        "label": "Upscale Target Resolution",
        "description": "",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_transform_source_asset_path",
        "type": "string",
        "label": "Upscale Source Path",
        "description": "",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_transform_source_content_sha256",
        "type": "string",
        "label": "Upscale Source SHA256",
        "description": "",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_transform_source_width",
        "type": "int",
        "label": "Upscale Source Width",
        "description": "",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "hidden_from_director": true,
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_transform_source_height",
        "type": "int",
        "label": "Upscale Source Height",
        "description": "",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "hidden_from_director": true,
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_transform_source_frame_count",
        "type": "int",
        "label": "Upscale Source Frame Count",
        "description": "",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "hidden_from_director": true,
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_transform_source_fps",
        "type": "float",
        "label": "Upscale Source FPS",
        "description": "",
        "required": false,
        "multi": false,
        "pythonType": "float",
        "tsType": "number",
        "baseType": "float",
        "hidden_from_director": true,
        "portSchemaId": "float_float_float_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_video",
        "type": "video",
        "label": "Video",
        "description": "The uploaded video",
        "required": false,
        "multi": false,
        "pythonType": "GeneratedVideoWithHistory",
        "tsType": "GeneratedVideoWithHistory",
        "baseType": "VideoAsset",
        "hidden_from_director": true,
        "portSchemaId": "video_generated_video_with_history_video_asset_single_map"
      }
    ],
    "state": [],
    "executionActions": [
      "extract_depth",
      "upscale"
    ],
    "actionLabels": {
      "extract_depth": "Depth extraction",
      "upscale": "Upscale"
    }
  },
  "videoEditor": {
    "type": "videoEditor",
    "backendType": "video_editor",
    "label": "Video Editor",
    "category": "Agentic",
    "description": "Edit videos by stitching sources or placing source-local trims on a timeline",
    "icon": "\ud83c\udfac",
    "layout": {
      "*": {
        "width": 315,
        "height": 270
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_reference_media",
        "type": "video|audio",
        "label": "References",
        "description": "Ordered video and audio references. Connect outputs here; toIndex preserves cross-media order. Internal video and audio inputs are derived from source port types.",
        "required": false,
        "multi": true,
        "pythonType": "MediaAssetRefDict",
        "tsType": "MediaAssetRefDict",
        "baseType": "VideoAsset|AudioAsset",
        "referenceMediaRoutes": {
          "VideoAsset": "in_videos",
          "AudioAsset": "in_audios"
        },
        "portSchemaId": "video_audio_media_asset_ref_dict_video_asset_audio_asset_multi_array"
      },
      {
        "id": "in_videos",
        "type": "video",
        "label": "Video Clips",
        "description": "Multiple video clips to stitch together (in order)",
        "required": false,
        "multi": true,
        "pythonType": "VideoAssetRefDict",
        "tsType": "VideoAssetRefDict",
        "baseType": "VideoAsset",
        "hidden_from_director": true,
        "portSchemaId": "video_video_asset_ref_dict_video_asset_multi_array"
      },
      {
        "id": "in_audios",
        "type": "audio",
        "label": "Audio Tracks",
        "description": "Input audio tracks for the editor. Audio inputs are independent from in_videos; counts do not need to match. Without explicit placement, audio tracks are placed in input order on the timeline.",
        "required": false,
        "multi": true,
        "pythonType": "AudioAssetRefDict",
        "tsType": "AudioAssetRefDict",
        "baseType": "AudioAsset",
        "hidden_from_director": true,
        "portSchemaId": "audio_audio_asset_ref_dict_audio_asset_multi_array"
      },
      {
        "id": "in_audio",
        "type": "audio",
        "label": "Audio",
        "description": "Single audio input; treated as one additional independent audio track.",
        "required": false,
        "multi": false,
        "pythonType": "AudioAssetRefDict",
        "tsType": "AudioAssetRefDict",
        "baseType": "AudioAsset",
        "portSchemaId": "audio_audio_asset_ref_dict_audio_asset_single_map"
      },
      {
        "id": "in_video_config",
        "type": "TimelineConfigDict",
        "label": "Video Config",
        "description": "Persisted Video Editor timeline. Connected media seeds a new timeline in edge order. Use edit_video_editor_timeline for later changes. start_time/end_time trim the source; start_offset places an item on the output timeline. Omit all three for sequential whole-source clips. Use symbolic source_path values such as '<node_id>.out_video' or '<node_id>.out_audio'; the editor resolves the wired asset at render time. audio_kind is the saved audio type. role is accepted only as a compatibility input when audio_kind is absent.",
        "required": false,
        "multi": false,
        "pythonType": "TimelineConfigDict",
        "tsType": "TimelineConfigDict",
        "baseType": "TimelineConfigDict",
        "default": {
          "operation": "timeline_render",
          "timeline": {
            "clips": [],
            "audio_tracks": []
          }
        },
        "ydocCreationRoot": true,
        "legacyNullAsAbsent": true,
        "portSchemaId": "timeline_config_dict_timeline_config_dict_timeline_config_dict_single_map"
      },
      {
        "id": "in_edit_spec",
        "type": "EditSpecDict",
        "label": "Edit Spec",
        "description": "Versioned AI-authored edit contract. Additive to in_video_config during migration; renderer selection is controlled by explicit compatibility state and execution action, never field presence.",
        "required": false,
        "multi": false,
        "pythonType": "EditSpecDict",
        "tsType": "EditSpecDict",
        "baseType": "EditSpecDict",
        "hidden_from_director": true,
        "portSchemaId": "edit_spec_dict_edit_spec_dict_edit_spec_dict_single_map"
      },
      {
        "id": "in_mode",
        "type": "string",
        "label": "Mode",
        "description": "Edit operation mode",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "stitch",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_output_name",
        "type": "string",
        "label": "Output Name",
        "description": "Output file name",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "output.mp4",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_start",
        "type": "float",
        "label": "Start",
        "description": "Trim start time",
        "required": false,
        "multi": false,
        "pythonType": "float",
        "tsType": "number",
        "baseType": "float",
        "default": 0.0,
        "hidden_from_director": true,
        "portSchemaId": "float_float_float_single_primitive"
      },
      {
        "id": "in_end",
        "type": "float",
        "label": "End",
        "description": "Trim end time",
        "required": false,
        "multi": false,
        "pythonType": "float",
        "tsType": "number",
        "baseType": "float",
        "default": 0.0,
        "hidden_from_director": true,
        "portSchemaId": "float_float_float_single_primitive"
      },
      {
        "id": "in_volume",
        "type": "float",
        "label": "Volume",
        "description": "Audio volume",
        "required": false,
        "multi": false,
        "pythonType": "float",
        "tsType": "number",
        "baseType": "float",
        "default": 0.8,
        "hidden_from_director": true,
        "portSchemaId": "float_float_float_single_primitive"
      },
      {
        "id": "in_export_name",
        "type": "string",
        "label": "Export Name",
        "description": "Name chosen in the Export to Download confirm sheet for the new Video node. Transient transport \u2014 written by the frontend just before executeNode and consumed by the backend agent.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_video",
        "type": "video",
        "label": "Video",
        "description": "Edited video output",
        "required": false,
        "multi": false,
        "pythonType": "VideoAssetRefDict",
        "tsType": "VideoAssetRefDict",
        "baseType": "VideoAsset",
        "portSchemaId": "video_video_asset_ref_dict_video_asset_single_map"
      },
      {
        "id": "out_rendered_spec_hash",
        "type": "string",
        "label": "Rendered Edit Spec Hash",
        "description": "Versioned canonical fingerprint of the EditSpec that produced out_video.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_render_sources",
        "type": "ShotVideoRenderSourcesDict",
        "label": "Rendered Source Assets",
        "description": "Exact picked paths of upstream video and speech nodes used for the current render.",
        "required": false,
        "multi": false,
        "pythonType": "ShotVideoRenderSourcesDict",
        "tsType": "ShotVideoRenderSourcesDict",
        "baseType": "ShotVideoRenderSourcesDict",
        "hidden_from_director": true,
        "directorWritable": false,
        "portSchemaId": "shot_video_render_sources_dict_shot_video_render_sources_dict_shot_video_render_sources_dict_single_map"
      }
    ],
    "state": [
      {
        "id": "last_export_node_id",
        "type": "string",
        "label": "last_export_node_id",
        "description": "",
        "pythonType": "str",
        "tsType": "string"
      },
      {
        "id": "magnet_enabled",
        "type": "boolean",
        "label": "Main Track Magnet",
        "description": "When true (default), edits to track-0 video clips re-pack the track left-to-right with no gaps after commit.",
        "pythonType": "bool",
        "tsType": "boolean",
        "default": true
      },
      {
        "id": "edit_spec_compatibility_state",
        "type": "string",
        "label": "Edit Spec Compatibility State",
        "description": "Explicit source-of-truth and renderer-selection state. Field presence alone never selects a renderer.",
        "pythonType": "str",
        "tsType": "string",
        "default": "legacy_only"
      },
      {
        "id": "edit_spec_migration_error",
        "type": "string",
        "label": "Edit Spec Migration Error",
        "description": "Explicit migration failure detail; empty when no migration failure is active.",
        "pythonType": "str",
        "tsType": "string"
      }
    ],
    "executionActions": [
      "generate",
      "timeline_render",
      "vibe_render"
    ],
    "actionLabels": {
      "timeline_render": "Video editing",
      "vibe_render": "Render vibe edit"
    },
    "directorGuidance": "Add video/audio edges to in_reference_media in the desired order; their counts are independent. Load timeline-audio-editing for placement, trim, mute, duck, or source_path config. start_time/end_time trim within one source; start_offset places it on the output timeline. Never use cumulative output positions as start_time.",
    "projectStatusOnComplete": "completed"
  },
  "videoGenerator": {
    "type": "videoGenerator",
    "backendType": "video_generator",
    "label": "Video Generator",
    "category": "Agentic",
    "description": "Generate raw video clips from prompts, reference images, reference videos, and provider-supported audio references",
    "icon": "\ud83c\udfa5",
    "layout": {
      "16:9": {
        "width": 315,
        "height": 177
      },
      "9:16": {
        "width": 177,
        "height": 315
      },
      "3:4": {
        "width": 236,
        "height": 315
      },
      "4:3": {
        "width": 315,
        "height": 236
      },
      "1:1": {
        "width": 240,
        "height": 240
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_reference_media",
        "type": "image|video|audio",
        "label": "References",
        "description": "Ordered media references. Connect image, video or audio outputs here; toIndex preserves cross-media order. Provider-specific inputs are derived internally.",
        "required": false,
        "multi": true,
        "pythonType": "MediaAssetRefDict",
        "tsType": "MediaAssetRefDict",
        "baseType": "ImageAsset|VideoAsset|AudioAsset",
        "referenceMediaRoutes": {
          "ImageAsset": "in_images",
          "VideoAsset": "in_reference_videos",
          "AudioAsset": "in_reference_audios"
        },
        "portSchemaId": "image_video_audio_media_asset_ref_dict_image_asset_video_asset_audio_asset_multi_array"
      },
      {
        "id": "in_mode",
        "type": "string",
        "label": "Mode",
        "description": "Video generation mode",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "REFERENCE",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_scene_id",
        "type": "string",
        "label": "Scene ID",
        "description": "Scene identifier for organizing clips",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_clip_number",
        "type": "int",
        "label": "Clip #",
        "description": "Clip number within the scene",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_images",
        "type": "image",
        "label": "Reference",
        "description": "Reference/first-frame images for generation",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "hidden_from_director": true,
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "in_reference_videos",
        "type": "video",
        "label": "Reference Videos",
        "description": "Original/reference videos for edit-style video generation",
        "required": false,
        "multi": true,
        "pythonType": "VideoAssetRefDict",
        "tsType": "VideoAssetRefDict",
        "baseType": "VideoAsset",
        "hidden_from_director": true,
        "portSchemaId": "video_video_asset_ref_dict_video_asset_multi_array"
      },
      {
        "id": "in_continuation_source",
        "type": "video",
        "label": "S7 Predecessor Video",
        "description": "The actual completed previous pack output. An exact-first successor extracts its final decoded frame; never use this as a weak R2V reference.",
        "required": false,
        "multi": false,
        "pythonType": "GeneratedVideoWithHistory",
        "tsType": "GeneratedVideoWithHistory",
        "baseType": "VideoAsset",
        "hidden_from_director": true,
        "portSchemaId": "video_generated_video_with_history_video_asset_single_map"
      },
      {
        "id": "in_shot_list_source_id",
        "type": "string",
        "label": "Shot List Source",
        "description": "Server-owned Shot List node ID for pack fingerprint checks before charging.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_shot_list_source_fingerprint",
        "type": "string",
        "label": "Shot List Fingerprint",
        "description": "Server-owned immutable fingerprint of shots, seams, and explicit anchors at packing.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_shot_list_request_fingerprint",
        "type": "string",
        "label": "Shot List Plan Fingerprint",
        "description": "Server-owned fingerprint of the model, motion intent, and selected source image revisions.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_reference_audios",
        "type": "audio",
        "label": "Reference Audio",
        "description": "Reference audio clips that CONDITION generation (voice/language/motion guidance), e.g. Seedance 2.0 audio references. Distinct from in_audio, which bakes an audio track into the finished clip. Only valid on a model that accepts audio references.",
        "required": false,
        "multi": true,
        "pythonType": "AudioAssetRefDict",
        "tsType": "AudioAssetRefDict",
        "baseType": "AudioAsset",
        "hidden_from_director": true,
        "portSchemaId": "audio_audio_asset_ref_dict_audio_asset_multi_array"
      },
      {
        "id": "in_audio",
        "type": "audio",
        "label": "Audio",
        "description": "Optional audio track to bake into the video",
        "required": false,
        "multi": false,
        "pythonType": "AudioAssetRefDict",
        "tsType": "AudioAssetRefDict",
        "baseType": "AudioAsset",
        "portSchemaId": "audio_audio_asset_ref_dict_audio_asset_single_map"
      },
      {
        "id": "in_motion_prompt",
        "type": "string",
        "label": "Motion Prompt",
        "description": "Describe the video action and motion",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_scene_context",
        "type": "string",
        "label": "Scene Context",
        "description": "Broader scene context for coherent generation",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_duration",
        "type": "float",
        "label": "Duration (s)",
        "description": "Video duration in seconds",
        "required": false,
        "multi": false,
        "pythonType": "float",
        "tsType": "number",
        "baseType": "float",
        "default": 5.0,
        "portSchemaId": "float_float_float_single_primitive"
      },
      {
        "id": "in_reference_video_edits",
        "type": "list[VideoReferenceEditDict]",
        "label": "Reference Video Edits",
        "description": "Trim windows for in_reference_videos. Use source_node_id or asset_path to match a video reference; asset identity remains edge-derived.",
        "required": false,
        "multi": false,
        "pythonType": "list[VideoReferenceEditDict]",
        "tsType": "Array<VideoReferenceEditDict>",
        "baseType": "list[VideoReferenceEditDict]",
        "default": [],
        "portSchemaId": "list_video_reference_edit_dict_list_video_reference_edit_dict_list_video_reference_edit_dict_single_array"
      },
      {
        "id": "in_dialogue_prompt",
        "type": "list[DialogueEntryDict]",
        "label": "Dialogue",
        "description": "Edge-derived structured per-line dialogue/voiceover for generated speech. Do not write this field directly; connect an upstream dialogue output or embed dialogue in in_motion_prompt.",
        "required": false,
        "multi": false,
        "pythonType": "list[DialogueEntryDict]",
        "tsType": "Array<DialogueEntryDict>",
        "baseType": "list[DialogueEntryDict]",
        "portSchemaId": "list_dialogue_entry_dict_list_dialogue_entry_dict_list_dialogue_entry_dict_single_array"
      },
      {
        "id": "in_model",
        "type": "string",
        "label": "Model",
        "description": "Video generation model. Call list_available_models to see available options including BYOM models, and use its explicit default_video_model when no model was requested.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "gemini-omni-1.1-flash-preview",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_aspect_ratio",
        "type": "string",
        "label": "Aspect Ratio",
        "description": "Video aspect ratio",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "16:9",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_resolution",
        "type": "string",
        "label": "Resolution",
        "description": "Video output resolution",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "1080p",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_generate_audio",
        "type": "boolean",
        "label": "Legacy Generate Audio",
        "description": "Deprecated legacy compatibility flag for Dreamwrite post-generation audio. Existing nodes that only set this flag keep their legacy remix behavior. Legacy nodes without in_provider_generate_audio still request provider/native audio by default. New nodes should set in_provider_generate_audio for provider-native audio. Dreamwrite post-processing belongs in downstream Video Editor flows.",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_provider_generate_audio",
        "type": "boolean",
        "label": "Provider Generate Audio",
        "description": "Ask the selected video provider/model to generate native audio when that provider supports the option. This does not control Dreamwrite post-generation audio processing.",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_use_voice_profile_audio_references",
        "type": "boolean",
        "label": "Use Voice Samples as Video References",
        "description": "Deprecated legacy compatibility flag. Voice profiles no longer silently provide provider reference audio. New flows connect linked Sound Expert out_audio to in_reference_audios explicitly when the selected model supports audio references.",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_audio_remix_mode",
        "type": "string",
        "label": "Dreamwrite Audio Mode",
        "description": "Deprecated legacy Dreamwrite post-generation audio mode. Kept for old projects until audio post-processing fully moves to Video Editor nodes.",
        "required": false,
        "multi": false,
        "pythonType": "AudioRemixMode",
        "tsType": "\"off\" | \"voiceover_only\" | \"full_remix\"",
        "baseType": "AudioRemixMode",
        "hidden_from_director": true,
        "portSchemaId": "string_audio_remix_mode_audio_remix_mode_single_primitive"
      },
      {
        "id": "in_allow_bgm",
        "type": "boolean",
        "label": "Allow BGM",
        "description": "When enabled, the video model may generate background music and ambient sounds. When disabled (default), only SFX and specified dialogue audio are included.",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_tts_provider",
        "type": "string",
        "label": "Speech Provider",
        "description": "Deprecated legacy speech provider setting for Dreamwrite-generated dialogue, narration, and voiceover audio on Video Generator nodes. New Dreamwrite post-processing speech should be represented by Sound Expert audio and mixed downstream.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "gemini",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_dub_target_language",
        "type": "string",
        "label": "Dub Language",
        "description": "Retired legacy dub target language. Kept hidden so old project data can still load. New dubbing work should use Sound Expert and Video Editor flows.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_voice_profiles",
        "type": "VoiceProfileDict",
        "label": "Voice Profiles",
        "description": "Voice profiles from connected Character Designers, Sound Expert voice nodes, or Script Writer narrators. They identify speakers for generated speech and provide voice metadata/descriptions. Provider audio conditioning uses explicit audio edges to in_reference_media; do not infer provider audio references from voice_profile.audio_sample. Profile name should match a character label or narrator voice_role_id.",
        "required": false,
        "multi": true,
        "pythonType": "VoiceProfileDict",
        "tsType": "VoiceProfileDict",
        "baseType": "VoiceProfileDict",
        "portSchemaId": "voice_profile_dict_voice_profile_dict_voice_profile_dict_multi_array"
      },
      {
        "id": "in_voice_settings",
        "type": "VoiceSettingsDict",
        "label": "Voice Settings",
        "description": "TTS voice tuning parameters (stability, similarity_boost, style, speed)",
        "required": false,
        "multi": false,
        "pythonType": "VoiceSettingsDict",
        "tsType": "VoiceSettingsDict",
        "baseType": "VoiceSettingsDict",
        "portSchemaId": "voice_settings_dict_voice_settings_dict_voice_settings_dict_single_map"
      },
      {
        "id": "in_name",
        "type": "string",
        "label": "Name",
        "description": "Optional label for the video node",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_resolved_voice_map",
        "type": "ResolvedVoiceMapDict",
        "label": "Resolved Voice Map",
        "description": "Character name to resolved voice display name mapping for generated speech",
        "required": false,
        "multi": false,
        "pythonType": "ResolvedVoiceMapDict",
        "tsType": "ResolvedVoiceMapDict",
        "baseType": "ResolvedVoiceMapDict",
        "default": {},
        "hidden_from_director": true,
        "portSchemaId": "resolved_voice_map_dict_resolved_voice_map_dict_resolved_voice_map_dict_single_map"
      },
      {
        "id": "in_audio_remix_config",
        "type": "AudioRemixConfigDict",
        "label": "Legacy Audio Edit Config",
        "description": "Retired legacy audio editor state for saved dialogue and narrator tracks. Kept hidden so old project data can still load. Current audio edits use Sound Expert and Video Editor.",
        "required": false,
        "multi": false,
        "pythonType": "AudioRemixConfigDict",
        "tsType": "AudioRemixConfigDict",
        "baseType": "AudioRemixConfigDict",
        "hidden_from_director": true,
        "portSchemaId": "audio_remix_config_dict_audio_remix_config_dict_audio_remix_config_dict_single_map"
      },
      {
        "id": "in_speech_transformer_config",
        "type": "SpeechTransformerConfigDict",
        "label": "Retired Speech Edit Config",
        "description": "Retired speech-edit state. Kept hidden so old project data can still load. Current voice changes use Sound Expert and Video Editor.",
        "required": false,
        "multi": false,
        "pythonType": "SpeechTransformerConfigDict",
        "tsType": "SpeechTransformerConfigDict",
        "baseType": "SpeechTransformerConfigDict",
        "hidden_from_director": true,
        "portSchemaId": "speech_transformer_config_dict_speech_transformer_config_dict_speech_transformer_config_dict_single_map"
      },
      {
        "id": "in_audio_take_selections",
        "type": "AudioTakeSelectionMapDict",
        "label": "Audio Take Selections",
        "description": "Variant-scoped selected audio take per clip. Stored as a flat map keyed by `v1:` plus compact JSON for `[variant_path, clip_id]`; each value repeats that identity and stores the exact selected label/path. New nodes initialize an empty shared map; legacy nodes may omit it.",
        "required": false,
        "multi": false,
        "pythonType": "AudioTakeSelectionMapDict",
        "tsType": "AudioTakeSelectionMapDict",
        "baseType": "AudioTakeSelectionMapDict",
        "default": {},
        "hidden_from_director": true,
        "ydocCreationRoot": true,
        "portSchemaId": "audio_take_selection_map_dict_audio_take_selection_map_dict_audio_take_selection_map_dict_single_map"
      },
      {
        "id": "in_audio_variant_workspaces",
        "type": "AudioVariantWorkspaceMapDict",
        "label": "Audio Variant Workspaces",
        "description": "Retired variant-scoped audio authoring state. Kept hidden so old project data can still load.",
        "required": false,
        "multi": false,
        "pythonType": "AudioVariantWorkspaceMapDict",
        "tsType": "AudioVariantWorkspaceMapDict",
        "baseType": "AudioVariantWorkspaceMapDict",
        "hidden_from_director": true,
        "portSchemaId": "audio_variant_workspace_map_dict_audio_variant_workspace_map_dict_audio_variant_workspace_map_dict_single_map"
      },
      {
        "id": "in_unified_audio_config",
        "type": "UnifiedAudioProjectDict",
        "label": "Unified Audio Config",
        "description": "Retired audio authoring state. Kept hidden so old project data can still load. Current audio edits use the Video Editor timeline and Sound Expert audio nodes.",
        "required": false,
        "multi": false,
        "pythonType": "UnifiedAudioProjectDict",
        "tsType": "UnifiedAudioProjectDict",
        "baseType": "UnifiedAudioProjectDict",
        "hidden_from_director": true,
        "portSchemaId": "unified_audio_project_dict_unified_audio_project_dict_unified_audio_project_dict_single_map"
      },
      {
        "id": "in_style",
        "type": "string",
        "label": "Art Style",
        "description": "Visual style library ID. Empty inherits project style; NO_STYLE disables library guidance. Reference images preserve subject and composition while style guides motion and overall look.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_video",
        "type": "video",
        "label": "Video",
        "description": "Generated video clip with metadata",
        "required": false,
        "multi": false,
        "pythonType": "GeneratedVideoWithHistory",
        "tsType": "GeneratedVideoWithHistory",
        "baseType": "VideoAsset",
        "portSchemaId": "video_generated_video_with_history_video_asset_single_map"
      },
      {
        "id": "out_tts_segments",
        "type": "list[TtsSegmentDict]",
        "label": "Generated Speech Segments",
        "description": "Retired legacy Video Generator speech output. Current Dreamwrite-owned speech is generated by Sound Expert and mixed in Video Editor.",
        "required": false,
        "multi": false,
        "pythonType": "list[TtsSegmentDict]",
        "tsType": "Array<TtsSegmentDict>",
        "baseType": "list[TtsSegmentDict]",
        "hidden_from_director": true,
        "portSchemaId": "list_tts_segment_dict_list_tts_segment_dict_list_tts_segment_dict_single_array"
      },
      {
        "id": "out_audio_remix_baseline",
        "type": "AudioRemixConfigDict",
        "label": "Audio Edit Baseline",
        "description": "Retired legacy audio-edit baseline. Kept hidden so old project data can still load.",
        "required": false,
        "multi": false,
        "pythonType": "AudioRemixConfigDict",
        "tsType": "AudioRemixConfigDict",
        "baseType": "AudioRemixConfigDict",
        "hidden_from_director": true,
        "portSchemaId": "audio_remix_config_dict_audio_remix_config_dict_audio_remix_config_dict_single_map"
      },
      {
        "id": "out_speech_transformer_spans",
        "type": "SpeechTransformerDetectionDict",
        "label": "Retired Speech Edit Spans",
        "description": "Retired speech-edit detection output. Kept hidden so old project data can still load.",
        "required": false,
        "multi": false,
        "pythonType": "SpeechTransformerDetectionDict",
        "tsType": "SpeechTransformerDetectionDict",
        "baseType": "SpeechTransformerDetectionDict",
        "hidden_from_director": true,
        "portSchemaId": "speech_transformer_detection_dict_speech_transformer_detection_dict_speech_transformer_detection_dict_single_map"
      },
      {
        "id": "out_auto_dialogue",
        "type": "list[DialogueEntryDict]",
        "label": "Auto Dialogue",
        "description": "Dialogue entries auto-extracted from the motion prompt when no explicit in_dialogue_prompt is connected",
        "required": false,
        "multi": false,
        "pythonType": "list[DialogueEntryDict]",
        "tsType": "Array<DialogueEntryDict>",
        "baseType": "list[DialogueEntryDict]",
        "hidden_from_director": true,
        "portSchemaId": "list_dialogue_entry_dict_list_dialogue_entry_dict_list_dialogue_entry_dict_single_array"
      },
      {
        "id": "out_speech_windows",
        "type": "list[SpeechWindowDict]",
        "label": "Speech Windows",
        "description": "Retired legacy speech-window output. Kept hidden so old project data can still load.",
        "required": false,
        "multi": false,
        "pythonType": "list[SpeechWindowDict]",
        "tsType": "Array<SpeechWindowDict>",
        "baseType": "list[SpeechWindowDict]",
        "hidden_from_director": true,
        "portSchemaId": "list_speech_window_dict_list_speech_window_dict_list_speech_window_dict_single_array"
      },
      {
        "id": "out_native_speech_takes",
        "type": "list[NativeSpeechTakeDict]",
        "label": "Native Speech Takes",
        "description": "Deprecated legacy native speech take ledger. Kept hidden so old project data can still load.",
        "required": false,
        "multi": false,
        "pythonType": "list[NativeSpeechTakeDict]",
        "tsType": "Array<NativeSpeechTakeDict>",
        "baseType": "list[NativeSpeechTakeDict]",
        "hidden_from_director": true,
        "portSchemaId": "list_native_speech_take_dict_list_native_speech_take_dict_list_native_speech_take_dict_single_array"
      },
      {
        "id": "out_native_speech_spans",
        "type": "list[NativeSpeechSpanDict]",
        "label": "Native Speech Spans",
        "description": "RFC-1122 Phase 3: audio-first ASR detection result \u2014 per-line spans (transcript + timing) for a native/vocals lane, source-anchored. The derive splits the whole-track native clip into per-span clips (each independently re-voiceable). Phase 4: make per-variant.",
        "required": false,
        "multi": false,
        "pythonType": "list[NativeSpeechSpanDict]",
        "tsType": "Array<NativeSpeechSpanDict>",
        "baseType": "list[NativeSpeechSpanDict]",
        "hidden_from_director": true,
        "portSchemaId": "list_native_speech_span_dict_list_native_speech_span_dict_list_native_speech_span_dict_single_array"
      },
      {
        "id": "out_native_speech_detect_seq",
        "type": "int",
        "label": "Native Speech Detect Sequence",
        "description": "RFC-1122 Phase 3 (Codex impl r17 P1): a monotonic counter incremented on every SUCCESSFUL audio-first detect run. It is the FE's 'a re-detect completed' signal \u2014 robust even when the detector returns byte-identical spans (unchanged out_native_speech_spans), so the console can clear the re-detected lane's stale per-clip config/tombstones so its clips repopulate. Not per-variant (a run counter).",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "default": 0,
        "hidden_from_director": true,
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "out_video_prompt",
        "type": "string",
        "label": "Video Prompt",
        "description": "The timed prompt sent to Veo",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_video_duration",
        "type": "float",
        "label": "Video Duration",
        "description": "Video duration in seconds",
        "required": false,
        "multi": false,
        "pythonType": "float",
        "tsType": "number",
        "baseType": "float",
        "hidden_from_director": true,
        "portSchemaId": "float_float_float_single_primitive"
      },
      {
        "id": "out_dialogue",
        "type": "list[ReconciledDialogueEntryDict]",
        "label": "Dialogue Output",
        "description": "Reconciled dialogue data for generated speech, including optional narrator voice_role_id",
        "required": false,
        "multi": false,
        "pythonType": "list[ReconciledDialogueEntryDict]",
        "tsType": "Array<ReconciledDialogueEntryDict>",
        "baseType": "list[ReconciledDialogueEntryDict]",
        "hidden_from_director": true,
        "portSchemaId": "list_reconciled_dialogue_entry_dict_list_reconciled_dialogue_entry_dict_list_reconciled_dialogue_entry_dict_single_array"
      }
    ],
    "state": [
      {
        "id": "voice_acting_status",
        "type": "string",
        "label": "voice_acting_status",
        "description": "",
        "pythonType": "str",
        "tsType": "string"
      },
      {
        "id": "full_remix_status",
        "type": "video",
        "label": "full_remix_status",
        "description": "Retired audio operation status. Kept so old project state can still load.",
        "pythonType": "VideoFullRemixStatusV1Dict",
        "tsType": "VideoFullRemixStatusV1Dict"
      },
      {
        "id": "segment_index",
        "type": "int",
        "label": "segment_index",
        "description": "",
        "pythonType": "int",
        "tsType": "number"
      },
      {
        "id": "batch_pending",
        "type": "int",
        "label": "batch_pending",
        "description": "",
        "pythonType": "int",
        "tsType": "number"
      },
      {
        "id": "thumbnail",
        "type": "string",
        "label": "thumbnail",
        "description": "Legacy: video thumbnail path. TODO: Remove after full canvas-v2 migration",
        "pythonType": "str",
        "tsType": "string"
      },
      {
        "id": "action",
        "type": "string",
        "label": "action",
        "description": "Current execution action for compatibility with older node runs.",
        "pythonType": "str",
        "tsType": "string"
      },
      {
        "id": "closing_frame_handshake",
        "type": "int",
        "label": "closing_frame_handshake",
        "description": "Sent by consoles that understand Closing frame (LAST_FRAME) on every Closing-frame run, so an API that predates this field rejects the run instead of treating the image as an opening frame (RFC-1668). Its value has no other effect.",
        "pythonType": "int",
        "tsType": "number"
      },
      {
        "id": "clip_id",
        "type": "string",
        "label": "clip_id",
        "description": "Retired audio target clip id. Kept hidden so old project data can still load.",
        "pythonType": "str",
        "tsType": "string"
      },
      {
        "id": "target_voice_id",
        "type": "string",
        "label": "target_voice_id",
        "description": "Retired speech-edit target voice id. Kept hidden so old project data can still load.",
        "pythonType": "str",
        "tsType": "string"
      },
      {
        "id": "target_variant_path",
        "type": "string",
        "label": "target_variant_path",
        "description": "Retired audio target variant path. Kept hidden so old project data can still load.",
        "pythonType": "str",
        "tsType": "string"
      },
      {
        "id": "name_autogen",
        "type": "string",
        "label": "Auto-generated Name Marker",
        "description": "Marker token identifying which auto-generated default-name family this node's display name came from (see agentic_workflow.core.default_node_names). Absent on user-created and pre-marker nodes. The console localizes the name only while the stored value still equals the canonical English rendering, so a rename automatically wins.",
        "pythonType": "str",
        "tsType": "string"
      }
    ],
    "pricing": {
      "default": {
        "category": "video_models",
        "model": "gemini-omni-1.1-flash-preview",
        "priceType": "per_second"
      },
      "actions": {
        "run_speech_to_text": null,
        "reformat_motion_prompt": null
      }
    },
    "executionActions": [
      "generate",
      "run_speech_to_text",
      "reformat_motion_prompt"
    ],
    "actionLabels": {
      "run_speech_to_text": "Transcription",
      "reformat_motion_prompt": "Prompt cleanup"
    },
    "directorGuidance": "Add reference edges to in_reference_media in the desired order. Preserve curated storyboard/screenplay edges. Do not write edge-derived dialogue in config. Video/audio references are model-gated; never infer audio references from voice profiles. Video Generator owns provider video and native audio. Use Sound Expert for generated or selected audio assets; use Video Editor for timing, trim, volume, mute, isolation, voice changes, and mixes.",
    "projectStatusOnComplete": "in_progress",
    "footerHeight": 80
  },
  "webtoonGroup": {
    "type": "webtoonGroup",
    "backendType": "webtoon_group",
    "label": "Webtoon Group",
    "category": "Agentic",
    "description": "Collapsible group container for webtoon panels arranged vertically",
    "icon": "\ud83d\udcda",
    "layout": {
      "*": {
        "width": 355,
        "height": 4000
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_scene_id",
        "type": "string",
        "label": "Scene ID",
        "description": "Scene identifier (e.g., ch1_s2)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_label",
        "type": "string",
        "label": "Label",
        "description": "Display label (e.g., Chapter 1, Scene 2)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_collapsed",
        "type": "boolean",
        "label": "Collapsed",
        "description": "Whether the group is collapsed (internal, managed by UI toggle)",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_child_node_ids",
        "type": "string",
        "label": "Child Node IDs",
        "description": "IDs of child panel nodes",
        "required": false,
        "multi": false,
        "pythonType": "list[str]",
        "tsType": "Array<string>",
        "baseType": "list[str]",
        "default": [],
        "hidden_from_director": true,
        "portSchemaId": "string_list_str_list_str_single_array"
      }
    ],
    "outputs": [],
    "state": []
  },
  "webtoonPanelGenerator": {
    "type": "webtoonPanelGenerator",
    "backendType": "webtoon_panel_generator",
    "label": "Webtoon Page",
    "category": "Agentic",
    "description": "Generate a webtoon page with multiple sub-panels and text bubbles",
    "icon": "\ud83d\udcd6",
    "layout": {
      "9:16": {
        "width": 315,
        "height": 560
      },
      "3:4": {
        "width": 315,
        "height": 420
      },
      "1:1": {
        "width": 320,
        "height": 320
      },
      "16:9": {
        "width": 420,
        "height": 236
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_images",
        "type": "image",
        "label": "Reference",
        "description": "Storyboard panel thumbnails + character/location reference images",
        "required": true,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "in_prompt",
        "type": "string",
        "label": "Prompt",
        "description": "Combined visual description for the page (fallback if beats not provided)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_beats",
        "type": "string",
        "label": "Beats",
        "description": "List of beat descriptions for sub-panels on this page",
        "required": false,
        "multi": true,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": [],
        "portSchemaId": "string_str_str_multi_array"
      },
      {
        "id": "in_dialogue",
        "type": "WebtoonDialogueDict",
        "label": "Dialogue",
        "description": "Structured dialogue entries for text bubble overlay",
        "required": false,
        "multi": true,
        "pythonType": "WebtoonDialogueDict",
        "tsType": "WebtoonDialogueDict",
        "baseType": "WebtoonDialogueDict",
        "default": [],
        "portSchemaId": "webtoon_dialogue_dict_webtoon_dialogue_dict_webtoon_dialogue_dict_multi_array"
      },
      {
        "id": "in_panel_index",
        "type": "int",
        "label": "Page Index",
        "description": "Page position in the scene (0-based)",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "default": 0,
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_aspect_ratio",
        "type": "string",
        "label": "Aspect Ratio",
        "description": "Page aspect ratio",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "9:16",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_layout",
        "type": "string",
        "label": "Layout",
        "description": "Panel layout type for page composition",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "standard_box",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_style",
        "type": "string",
        "label": "Art Style",
        "description": "Visual art style",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_name",
        "type": "string",
        "label": "Name",
        "description": "Page name",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_feedback",
        "type": "string",
        "label": "Feedback",
        "description": "Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_feedback_history",
        "type": "list[FeedbackHistoryEntryDict]",
        "label": "Feedback History",
        "description": "Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries.",
        "required": false,
        "multi": false,
        "pythonType": "list[FeedbackHistoryEntryDict]",
        "tsType": "Array<FeedbackHistoryEntryDict>",
        "baseType": "list[FeedbackHistoryEntryDict]",
        "default": [],
        "hidden_from_director": true,
        "portSchemaId": "list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array"
      }
    ],
    "outputs": [
      {
        "id": "out_image",
        "type": "image",
        "label": "Page Image",
        "description": "Webtoon page with sub-panels and text bubbles",
        "required": false,
        "multi": false,
        "pythonType": "GeneratedImageWithHistory",
        "tsType": "GeneratedImageWithHistory",
        "baseType": "ImageAsset",
        "portSchemaId": "image_generated_image_with_history_image_asset_single_map"
      }
    ],
    "state": [
      {
        "id": "bubbles",
        "type": "BubbleDict",
        "label": "bubbles",
        "description": "",
        "pythonType": "list[BubbleDict]",
        "tsType": "Array<BubbleDict>"
      },
      {
        "id": "batch_pending",
        "type": "int",
        "label": "batch_pending",
        "description": "",
        "pythonType": "int",
        "tsType": "number"
      }
    ],
    "pricing": {
      "category": "image_models",
      "model": "gemini-2.5-flash-image",
      "priceType": "per_image"
    },
    "projectStatusOnComplete": "in_progress"
  }
}

export const NODE_SCHEMAS_BY_BACKEND: Record<string, GeneratedNodeSchemaDef> = {
  "audio": {
    "type": "audio",
    "backendType": "audio",
    "label": "Audio Upload",
    "category": "Media",
    "description": "Upload a local audio file",
    "icon": "\ud83c\udfb5",
    "layout": {
      "*": {
        "width": 315,
        "height": 200
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_file_name",
        "type": "string",
        "label": "File Name",
        "description": "",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_voice_profile",
        "type": "VoiceProfileDict",
        "label": "Voice Profile",
        "description": "Character voice profile used to mark this uploaded audio as the Character voice source.",
        "required": false,
        "multi": false,
        "pythonType": "VoiceProfileDict",
        "tsType": "VoiceProfileDict",
        "baseType": "VoiceProfileDict",
        "hidden_from_director": true,
        "portSchemaId": "voice_profile_dict_voice_profile_dict_voice_profile_dict_single_map"
      }
    ],
    "outputs": [
      {
        "id": "out_audio",
        "type": "audio",
        "label": "Audio",
        "description": "The uploaded audio",
        "required": false,
        "multi": false,
        "pythonType": "AudioAssetRefDict",
        "tsType": "AudioAssetRefDict",
        "baseType": "AudioAsset",
        "portSchemaId": "audio_audio_asset_ref_dict_audio_asset_single_map"
      }
    ],
    "state": []
  },
  "character_designer": {
    "type": "characterDesigner",
    "backendType": "character_designer",
    "label": "Character Designer",
    "category": "Agentic",
    "description": "Design a character with visual sheet and provider-neutral voice brief",
    "icon": "\ud83c\udfa8",
    "layout": {
      "*": {
        "width": 400,
        "height": 460
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_upstream",
        "type": "UpstreamContextDict",
        "label": "Upstream",
        "description": "Default target port for incoming edges when no port is specified by the proposer (see _DEFAULT_TARGET_PORT in backend_graph.py). Wire upstream context (director or workflow node output) here when no specialized port applies.",
        "required": false,
        "multi": false,
        "pythonType": "UpstreamContextDict",
        "tsType": "UpstreamContextDict",
        "baseType": "UpstreamContextDict",
        "portSchemaId": "upstream_context_dict_upstream_context_dict_upstream_context_dict_single_map"
      },
      {
        "id": "in_images",
        "type": "image",
        "label": "Reference",
        "description": "Optional reference image to guide the visual design",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "in_name",
        "type": "string",
        "label": "Character Name",
        "description": "Name of the character being designed",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_role",
        "type": "string",
        "label": "Role",
        "description": "Character role (e.g. protagonist, supporting, antagonist)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_style",
        "type": "string",
        "label": "Art Style",
        "description": "Visual art style for the character sheet",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_description",
        "type": "string",
        "label": "Description",
        "description": "Describe appearance, personality, voice...",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_model",
        "type": "string",
        "label": "Model",
        "description": "Image generation model",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "gemini-3.1-flash-image-preview",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_feedback",
        "type": "string",
        "label": "Feedback",
        "description": "Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_feedback_history",
        "type": "list[FeedbackHistoryEntryDict]",
        "label": "Feedback History",
        "description": "Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries.",
        "required": false,
        "multi": false,
        "pythonType": "list[FeedbackHistoryEntryDict]",
        "tsType": "Array<FeedbackHistoryEntryDict>",
        "baseType": "list[FeedbackHistoryEntryDict]",
        "default": [],
        "hidden_from_director": true,
        "portSchemaId": "list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array"
      },
      {
        "id": "in_pronunciation_guide",
        "type": "string",
        "label": "Pronunciation Guide",
        "description": "Per-word pronunciation overrides for this character's name and terms. One rule per line: 'word \u2192 pronunciation' (alias) or 'word \u2192 /IPA/' (phoneme). Example: L'Ora \u2192 LOH-rah. Automatically applied to all downstream speech generation using this character's voice.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_bg_color",
        "type": "string",
        "label": "Background Color",
        "description": "Predefined background color key for the node card",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "default",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_vlm_validation",
        "type": "boolean",
        "label": "Quality Check",
        "description": "Run Gemini VLM quality validation after generation",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_name",
        "type": "string",
        "label": "Name",
        "description": "Character name (mirrors in_name for downstream label edges)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "aliasOf": "in_name",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_image",
        "type": "image",
        "label": "Character Sheet",
        "description": "Generated multi-view character reference sheet",
        "required": false,
        "multi": false,
        "pythonType": "CharacterAsset",
        "tsType": "CharacterAsset",
        "baseType": "ImageAsset",
        "portSchemaId": "image_character_asset_image_asset_single_map"
      },
      {
        "id": "out_voice_profile",
        "type": "VoiceProfileDict",
        "label": "Voice Profile",
        "description": "Provider-neutral voice brief used to identify this character's speaker role. The linked Sound Expert node owns selected provider voice fields and sample audio.",
        "required": false,
        "multi": false,
        "pythonType": "VoiceProfileDict",
        "tsType": "VoiceProfileDict",
        "baseType": "VoiceProfileDict",
        "portSchemaId": "voice_profile_dict_voice_profile_dict_voice_profile_dict_single_map"
      },
      {
        "id": "out_vlm_report",
        "type": "VlmValidationReportDict",
        "label": "Quality Report",
        "description": "VLM quality validation report from the most recent generation",
        "required": false,
        "multi": false,
        "pythonType": "VlmValidationReportDict",
        "tsType": "VlmValidationReportDict",
        "baseType": "VlmValidationReportDict",
        "portSchemaId": "vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map"
      }
    ],
    "state": [
      {
        "id": "batch_pending",
        "type": "int",
        "label": "batch_pending",
        "description": "",
        "pythonType": "int",
        "tsType": "number"
      },
      {
        "id": "annotated_image_path",
        "type": "string",
        "label": "Annotated Image Path",
        "description": "Transient per-run path to a baked annotation of the current picked image. Written by the Refine tab as a `state_updates` argument on execute-node, consumed once as the edit target, then cleared. Never authored by the Director and never persisted as durable node data.",
        "pythonType": "str",
        "tsType": "string"
      }
    ],
    "pricing": {
      "default": {
        "category": "image_models",
        "model": "gemini-3.1-flash-image-preview",
        "priceType": "per_image"
      },
      "actions": {}
    },
    "executionActions": [
      "generate"
    ],
    "actionLabels": {},
    "directorGuidance": "On add, set in_name and in_description; include gender and age cues because image generation and the linked Sound Expert voice node depend on them. Use revise_character for visual edits; use the linked Sound Expert node for voice selection and samples. Load visual-design-workflow for multi-designer creation, references, or reruns.",
    "projectStatusOnComplete": "in_progress"
  },
  "debug_hang": {
    "type": "debugHang",
    "backendType": "debug_hang",
    "label": "Debug Hang",
    "category": "Debug",
    "description": "Debug node that hangs forever for testing",
    "icon": "\ud83d\udc1b",
    "layout": {
      "*": {
        "width": 200,
        "height": 150
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_label",
        "type": "string",
        "label": "Label",
        "description": "Debug label",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_result",
        "type": "string",
        "label": "Result",
        "description": "Debug result",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "state": []
  },
  "director": {
    "type": "director",
    "backendType": "director",
    "label": "Director",
    "category": "Agentic",
    "description": "Orchestrate workflow and chat with the AI director",
    "icon": "\ud83d\udccb",
    "layout": {
      "*": {
        "width": 400,
        "height": 400
      }
    },
    "canvasHidden": true,
    "inputs": [
      {
        "id": "in_context",
        "type": "string",
        "label": "Context",
        "description": "Optional context for the conversation",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_response",
        "type": "string",
        "label": "Response",
        "description": "Director response text",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_crew",
        "type": "DirectorCrewDict",
        "label": "Crew",
        "description": "Crew configuration for sub-agents",
        "required": false,
        "multi": false,
        "pythonType": "DirectorCrewDict",
        "tsType": "DirectorCrewDict",
        "baseType": "DirectorCrewDict",
        "portSchemaId": "director_crew_dict_director_crew_dict_director_crew_dict_single_map"
      }
    ],
    "state": [
      {
        "id": "pending_tool_state",
        "type": "DirectorPendingToolStateDict",
        "label": "pending_tool_state",
        "description": "",
        "pythonType": "DirectorPendingToolStateDict",
        "tsType": "DirectorPendingToolStateDict"
      }
    ]
  },
  "generated_image_with_history": {
    "type": "generatedImageWithHistory",
    "backendType": "generated_image_with_history",
    "label": "Generated Image",
    "category": "Agentic",
    "description": "Panel image with generation history",
    "icon": "",
    "layout": {
      "*": {
        "width": 200,
        "height": 180
      }
    },
    "canvasHidden": false,
    "inputs": [],
    "outputs": [],
    "state": [],
    "footerHeight": 80
  },
  "image": {
    "type": "image",
    "backendType": "image",
    "label": "Image Upload",
    "category": "Media",
    "description": "Upload a local image file",
    "icon": "\ud83d\uddbc\ufe0f",
    "layout": {
      "*": {
        "width": 315,
        "height": 177
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_file_name",
        "type": "string",
        "label": "File Name",
        "description": "",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_image",
        "type": "image",
        "label": "Source Image",
        "description": "Provenance link to the image this one was derived from \u2014 set by the annotation bake so the canvas can draw a derivation edge from the source node. Inert: nothing reads this value, and Image Upload nodes never populate it.",
        "required": false,
        "multi": false,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "hidden_from_director": true,
        "portSchemaId": "image_image_asset_ref_dict_image_asset_single_map"
      }
    ],
    "outputs": [
      {
        "id": "out_image",
        "type": "image",
        "label": "Image",
        "description": "The uploaded image",
        "required": false,
        "multi": false,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "portSchemaId": "image_image_asset_ref_dict_image_asset_single_map"
      }
    ],
    "state": []
  },
  "image_generator": {
    "type": "imageGenerator",
    "backendType": "image_generator",
    "label": "Image Generator",
    "category": "Agentic",
    "description": "Generate images from text prompts",
    "icon": "\ud83d\uddbc\ufe0f",
    "layout": {
      "16:9": {
        "width": 315,
        "height": 177
      },
      "9:16": {
        "width": 177,
        "height": 315
      },
      "3:4": {
        "width": 236,
        "height": 315
      },
      "4:3": {
        "width": 315,
        "height": 236
      },
      "1:1": {
        "width": 240,
        "height": 240
      },
      "3:2": {
        "width": 315,
        "height": 210
      },
      "2:3": {
        "width": 210,
        "height": 315
      },
      "2:1": {
        "width": 315,
        "height": 158
      },
      "5:4": {
        "width": 315,
        "height": 252
      },
      "4:5": {
        "width": 252,
        "height": 315
      },
      "21:9": {
        "width": 315,
        "height": 135
      },
      "9:21": {
        "width": 135,
        "height": 315
      },
      "Auto": {
        "width": 240,
        "height": 240
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_images",
        "type": "image",
        "label": "Reference",
        "description": "Optional reference image to guide the generation",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "in_upstream",
        "type": "UpstreamContextDict",
        "label": "Upstream",
        "description": "Default target port for incoming edges when no port is specified by the proposer (see _DEFAULT_TARGET_PORT in backend_graph.py). Wire upstream context (director or workflow node output) here when no specialized port applies.",
        "required": false,
        "multi": false,
        "pythonType": "UpstreamContextDict",
        "tsType": "UpstreamContextDict",
        "baseType": "UpstreamContextDict",
        "portSchemaId": "upstream_context_dict_upstream_context_dict_upstream_context_dict_single_map"
      },
      {
        "id": "in_name",
        "type": "string",
        "label": "Name",
        "description": "Optional label for the generator node",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_prompt",
        "type": "string",
        "label": "Prompt",
        "description": "Text description of the image to generate",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_aspect_ratio",
        "type": "AspectRatio",
        "label": "Aspect Ratio",
        "description": "Aspect ratio for the generated image",
        "required": false,
        "multi": false,
        "pythonType": "AspectRatio",
        "tsType": "AspectRatio",
        "baseType": "AspectRatio",
        "default": "16:9",
        "portSchemaId": "aspect_ratio_aspect_ratio_aspect_ratio_single_primitive"
      },
      {
        "id": "in_style",
        "type": "string",
        "label": "Art Style",
        "description": "Visual art style for the generated image",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_quality",
        "type": "string",
        "label": "Quality",
        "description": "Output resolution quality",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "1K",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_model",
        "type": "string",
        "label": "Model",
        "description": "Image generation model",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "gemini-3.1-flash-image-preview",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_panel_refs",
        "type": "string",
        "label": "Panel Refs",
        "description": "Designer node IDs for self-wiring reference edges",
        "required": false,
        "multi": false,
        "pythonType": "list[str]",
        "tsType": "Array<string>",
        "baseType": "list[str]",
        "hidden_from_director": true,
        "portSchemaId": "string_list_str_list_str_single_array"
      },
      {
        "id": "in_update",
        "type": "boolean",
        "label": "Update",
        "description": "When True, store in_image directly (passthrough mode)",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_image",
        "type": "image",
        "label": "Image",
        "description": "Incoming panel image from storyboard",
        "required": false,
        "multi": false,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "hidden_from_director": true,
        "portSchemaId": "image_image_asset_ref_dict_image_asset_single_map"
      },
      {
        "id": "in_feedback",
        "type": "string",
        "label": "Feedback",
        "description": "Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_video",
        "type": "string",
        "label": "Video",
        "description": "Video file path (RelativePath) from upstream video generator",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_source_video",
        "type": "video",
        "label": "Source Video for Last Frame",
        "description": "Typed video input used for an exact S7 last-decoded-frame extraction.",
        "required": false,
        "multi": false,
        "pythonType": "GeneratedVideoWithHistory",
        "tsType": "GeneratedVideoWithHistory",
        "baseType": "VideoAsset",
        "hidden_from_director": true,
        "hidden_from_reference_picker": true,
        "portSchemaId": "video_generated_video_with_history_video_asset_single_map"
      },
      {
        "id": "in_expected_video_duration_ms",
        "type": "int",
        "label": "Expected S7 Source Duration",
        "description": "Exact planned predecessor clip length, checked against the decoded video stream before S7 handoff.",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "hidden_from_director": true,
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_frame",
        "type": "string",
        "label": "Frame",
        "description": "Which frame to extract: first, last, integer string (0-indexed), or time:<seconds> for the Canvas playhead",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "first",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_get_frame",
        "type": "boolean",
        "label": "Get Frame",
        "description": "When true, skip image generation and extract frame from in_video",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_feedback_history",
        "type": "list[FeedbackHistoryEntryDict]",
        "label": "Feedback History",
        "description": "Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries.",
        "required": false,
        "multi": false,
        "pythonType": "list[FeedbackHistoryEntryDict]",
        "tsType": "Array<FeedbackHistoryEntryDict>",
        "baseType": "list[FeedbackHistoryEntryDict]",
        "default": [],
        "hidden_from_director": true,
        "portSchemaId": "list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array"
      },
      {
        "id": "in_vlm_validation",
        "type": "boolean",
        "label": "Quality Check",
        "description": "Run Gemini VLM quality validation after generation",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_image",
        "type": "image",
        "label": "Generated Image",
        "description": "The generated image",
        "required": false,
        "multi": false,
        "pythonType": "GeneratedImageWithHistory",
        "tsType": "GeneratedImageWithHistory",
        "baseType": "ImageAsset",
        "portSchemaId": "image_generated_image_with_history_image_asset_single_map"
      },
      {
        "id": "out_vlm_report",
        "type": "VlmValidationReportDict",
        "label": "Quality Report",
        "description": "VLM quality validation report from the most recent generation",
        "required": false,
        "multi": false,
        "pythonType": "VlmValidationReportDict",
        "tsType": "VlmValidationReportDict",
        "baseType": "VlmValidationReportDict",
        "portSchemaId": "vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map"
      }
    ],
    "state": [
      {
        "id": "batch_pending",
        "type": "int",
        "label": "batch_pending",
        "description": "",
        "pythonType": "int",
        "tsType": "number"
      },
      {
        "id": "annotated_image_path",
        "type": "string",
        "label": "Annotated Image Path",
        "description": "Transient per-run path to a baked annotation of the current picked image. Written by the Refine tab as a `state_updates` argument on execute-node, consumed once as the edit target, then cleared. Never authored by the Director and never persisted as durable node data.",
        "pythonType": "str",
        "tsType": "string"
      },
      {
        "id": "name_autogen",
        "type": "string",
        "label": "Auto-generated Name Marker",
        "description": "Marker token identifying which auto-generated default-name family this node's display name came from (see agentic_workflow.core.default_node_names). Absent on user-created and pre-marker nodes. The console localizes the name only while the stored value still equals the canonical English rendering, so a rename automatically wins.",
        "pythonType": "str",
        "tsType": "string"
      }
    ],
    "pricing": {
      "category": "image_models",
      "model": "gemini-3.1-flash-image-preview",
      "priceType": "per_image"
    },
    "directorGuidance": "Standalone image nodes can be added by DAG with in_prompt, in_aspect_ratio, and in_style; storyboard panel image nodes are owned by create_storyboard_node. Wire reference images by edges to in_images. Use revise_image for local anchored edits that should preserve the picked image; use remake_image for major pose, composition, camera, action, subject-count, or background changes, or after repeated anchored failures. Load standalone-media-generation for recipes.",
    "projectStatusOnComplete": "in_progress",
    "footerHeight": 80
  },
  "location_designer": {
    "type": "locationDesigner",
    "backendType": "location_designer",
    "label": "Location Designer",
    "category": "Agentic",
    "description": "Design a location/background with reference image",
    "icon": "map",
    "layout": {
      "*": {
        "width": 400,
        "height": 460
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_images",
        "type": "image",
        "label": "Reference",
        "description": "Optional reference image to guide the visual design",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "in_name",
        "type": "string",
        "label": "Location Name",
        "description": "Name of the location being designed",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_style",
        "type": "string",
        "label": "Art Style",
        "description": "Visual art style for the location",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_time_of_day",
        "type": "string",
        "label": "Time of Day",
        "description": "Time of day for the scene",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "day",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_weather",
        "type": "string",
        "label": "Weather",
        "description": "Weather condition for the scene",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "clear",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_description",
        "type": "string",
        "label": "Description",
        "description": "Describe the location, atmosphere, key elements...",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_model",
        "type": "string",
        "label": "Model",
        "description": "Image generation model",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "gemini-3.1-flash-image-preview",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_feedback",
        "type": "string",
        "label": "Feedback",
        "description": "Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_feedback_history",
        "type": "list[FeedbackHistoryEntryDict]",
        "label": "Feedback History",
        "description": "Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries.",
        "required": false,
        "multi": false,
        "pythonType": "list[FeedbackHistoryEntryDict]",
        "tsType": "Array<FeedbackHistoryEntryDict>",
        "baseType": "list[FeedbackHistoryEntryDict]",
        "default": [],
        "hidden_from_director": true,
        "portSchemaId": "list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array"
      },
      {
        "id": "in_bg_color",
        "type": "string",
        "label": "Background Color",
        "description": "Predefined background color key for the node card",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "default",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_vlm_validation",
        "type": "boolean",
        "label": "Quality Check",
        "description": "Run Gemini VLM quality validation after generation",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_720_enabled",
        "type": "boolean",
        "label": "360 Panorama",
        "description": "Generate a 360 panorama source for this location instead of a standard flat location image",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_720_view",
        "type": "LocationPanoramaViewDict",
        "label": "360 View",
        "description": "Current 360 viewer camera state in degrees",
        "required": false,
        "multi": false,
        "pythonType": "LocationPanoramaViewDict",
        "tsType": "LocationPanoramaViewDict",
        "baseType": "LocationPanoramaViewDict",
        "default": {
          "yaw_degrees": 0,
          "pitch_degrees": 0,
          "fov_degrees": 75
        },
        "hidden_from_director": true,
        "portSchemaId": "location_panorama_view_dict_location_panorama_view_dict_location_panorama_view_dict_single_map"
      }
    ],
    "outputs": [
      {
        "id": "out_name",
        "type": "string",
        "label": "Name",
        "description": "Location name (mirrors in_name for downstream label edges)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "aliasOf": "in_name",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_image",
        "type": "image",
        "label": "Location Image",
        "description": "Generated location reference image",
        "required": false,
        "multi": false,
        "pythonType": "LocationAsset",
        "tsType": "LocationAsset",
        "baseType": "ImageAsset",
        "portSchemaId": "image_location_asset_image_asset_single_map"
      },
      {
        "id": "out_metadata",
        "type": "LocationMetadataDict",
        "label": "Metadata",
        "description": "Location metadata including name, style, time, and weather",
        "required": false,
        "multi": false,
        "pythonType": "LocationMetadataDict",
        "tsType": "LocationMetadataDict",
        "baseType": "LocationMetadataDict",
        "portSchemaId": "location_metadata_dict_location_metadata_dict_location_metadata_dict_single_map"
      },
      {
        "id": "out_vlm_report",
        "type": "VlmValidationReportDict",
        "label": "Quality Report",
        "description": "VLM quality validation report from the most recent generation",
        "required": false,
        "multi": false,
        "pythonType": "VlmValidationReportDict",
        "tsType": "VlmValidationReportDict",
        "baseType": "VlmValidationReportDict",
        "portSchemaId": "vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map"
      }
    ],
    "state": [
      {
        "id": "batch_pending",
        "type": "int",
        "label": "batch_pending",
        "description": "",
        "pythonType": "int",
        "tsType": "number"
      },
      {
        "id": "annotated_image_path",
        "type": "string",
        "label": "Annotated Image Path",
        "description": "Transient per-run path to a baked annotation of the current picked image. Written by the Refine tab as a `state_updates` argument on execute-node, consumed once as the edit target, then cleared. Never authored by the Director and never persisted as durable node data.",
        "pythonType": "str",
        "tsType": "string"
      }
    ],
    "pricing": {
      "default": {
        "category": "image_models",
        "model": "gemini-3.1-flash-image-preview",
        "priceType": "per_image"
      }
    },
    "executionActions": [
      "generate"
    ],
    "directorGuidance": "On add, set in_name and in_description; use in_time_of_day and in_weather when the user specifies atmosphere. Use revise_location for edits; load visual-design-workflow for references or reruns.",
    "projectStatusOnComplete": "in_progress"
  },
  "node_group": {
    "type": "nodeGroup",
    "backendType": "node_group",
    "label": "Group",
    "category": "Layout",
    "description": "Visual group container for organizing nodes",
    "icon": "\ud83d\udcc1",
    "layout": {
      "*": {
        "width": 800,
        "height": 600
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_label",
        "type": "string",
        "label": "Label",
        "description": "Display label for the group",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "Group",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_child_node_ids",
        "type": "string",
        "label": "Child Node IDs",
        "description": "IDs of child nodes contained in this group. Null entries represent empty gap slots left by drag-out; use Rearrange to compact.",
        "required": false,
        "multi": false,
        "pythonType": "list[str | None]",
        "tsType": "Array<string | null>",
        "baseType": "list[str | None]",
        "default": [],
        "hidden_from_director": true,
        "portSchemaId": "string_list_str_none_list_str_none_single_array"
      },
      {
        "id": "in_layout_mode",
        "type": "string",
        "label": "Layout Mode",
        "description": "Child arrangement mode: horizontal (single row), vertical (single column), or auto (grid)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "auto",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_collapsed",
        "type": "boolean",
        "label": "Collapsed",
        "description": "Whether this visual group is shown in its compact collapsed state",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_collapsible",
        "type": "boolean",
        "label": "Collapsible",
        "description": "Whether this workflow-owned visual group exposes collapse and expand controls",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_bg_color",
        "type": "string",
        "label": "Background Color",
        "description": "Predefined background color key for the group container",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "default",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "outputs": [],
    "state": [
      {
        "id": "name_autogen",
        "type": "string",
        "label": "Auto-generated Name Marker",
        "description": "Marker token identifying which auto-generated default-name family this node's display label came from (see agentic_workflow.core.default_node_names). Absent on user-created and pre-marker nodes. The console localizes the label only while the stored value still equals the canonical English rendering, so a rename automatically wins.",
        "pythonType": "str",
        "tsType": "string"
      }
    ],
    "directorGuidance": "Groups are visual containers. Create groups with create_group_node, rename via in_label, and run children with execute_group_nodes. Deleting a group deletes children; warn first. Load group-editing for membership/order/move/merge edits."
  },
  "object_designer": {
    "type": "objectDesigner",
    "backendType": "object_designer",
    "label": "Object Designer",
    "category": "Agentic",
    "description": "Design an object/artifact with reference image",
    "icon": "\ud83c\udf81",
    "layout": {
      "*": {
        "width": 400,
        "height": 487
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_images",
        "type": "image",
        "label": "Reference",
        "description": "Optional reference image to guide the visual design",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "in_name",
        "type": "string",
        "label": "Object Name",
        "description": "Name of the object being designed",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_style",
        "type": "string",
        "label": "Art Style",
        "description": "Visual art style for the object",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_description",
        "type": "string",
        "label": "Description",
        "description": "Describe the object appearance, material, details...",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_model",
        "type": "string",
        "label": "Model",
        "description": "Image generation model",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "gemini-3.1-flash-image-preview",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_feedback",
        "type": "string",
        "label": "Feedback",
        "description": "Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_feedback_history",
        "type": "list[FeedbackHistoryEntryDict]",
        "label": "Feedback History",
        "description": "Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries.",
        "required": false,
        "multi": false,
        "pythonType": "list[FeedbackHistoryEntryDict]",
        "tsType": "Array<FeedbackHistoryEntryDict>",
        "baseType": "list[FeedbackHistoryEntryDict]",
        "default": [],
        "hidden_from_director": true,
        "portSchemaId": "list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array"
      },
      {
        "id": "in_vlm_validation",
        "type": "boolean",
        "label": "Quality Check",
        "description": "Run Gemini VLM quality validation after generation",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_name",
        "type": "string",
        "label": "Name",
        "description": "Object name (mirrors in_name for downstream label edges)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "aliasOf": "in_name",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_image",
        "type": "image",
        "label": "Object Image",
        "description": "Generated object reference image",
        "required": false,
        "multi": false,
        "pythonType": "ObjectAsset",
        "tsType": "ObjectAsset",
        "baseType": "ImageAsset",
        "portSchemaId": "image_object_asset_image_asset_single_map"
      },
      {
        "id": "out_metadata",
        "type": "ObjectMetadataDict",
        "label": "Metadata",
        "description": "Object metadata",
        "required": false,
        "multi": false,
        "pythonType": "ObjectMetadataDict",
        "tsType": "ObjectMetadataDict",
        "baseType": "ObjectMetadataDict",
        "portSchemaId": "object_metadata_dict_object_metadata_dict_object_metadata_dict_single_map"
      },
      {
        "id": "out_vlm_report",
        "type": "VlmValidationReportDict",
        "label": "Quality Report",
        "description": "VLM quality validation report from the most recent generation",
        "required": false,
        "multi": false,
        "pythonType": "VlmValidationReportDict",
        "tsType": "VlmValidationReportDict",
        "baseType": "VlmValidationReportDict",
        "portSchemaId": "vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map"
      }
    ],
    "state": [
      {
        "id": "batch_pending",
        "type": "int",
        "label": "batch_pending",
        "description": "",
        "pythonType": "int",
        "tsType": "number"
      },
      {
        "id": "annotated_image_path",
        "type": "string",
        "label": "Annotated Image Path",
        "description": "Transient per-run path to a baked annotation of the current picked image. Written by the Refine tab as a `state_updates` argument on execute-node, consumed once as the edit target, then cleared. Never authored by the Director and never persisted as durable node data.",
        "pythonType": "str",
        "tsType": "string"
      }
    ],
    "pricing": {
      "category": "image_models",
      "model": "gemini-3.1-flash-image-preview",
      "priceType": "per_image"
    },
    "directorGuidance": "On add, set in_name and in_description. Use revise_object for edits; load visual-design-workflow for references or reruns.",
    "projectStatusOnComplete": "in_progress"
  },
  "panel_source": {
    "type": "panelSource",
    "backendType": "panel_source",
    "label": "Panel Source",
    "category": "Input",
    "description": "Load panel action, dialogue, and metadata",
    "icon": "\ud83d\uddbc\ufe0f",
    "layout": {
      "*": {
        "width": 320,
        "height": 350
      }
    },
    "canvasHidden": false,
    "inputs": [],
    "outputs": [
      {
        "id": "out_image",
        "type": "image",
        "label": "Image",
        "description": "The existing panel image",
        "required": false,
        "multi": false,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "portSchemaId": "image_image_asset_ref_dict_image_asset_single_map"
      },
      {
        "id": "out_action",
        "type": "string",
        "label": "Action",
        "description": "The action/script description",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_character_ids",
        "type": "string",
        "label": "Character IDs",
        "description": "IDs of characters appearing in this panel",
        "required": false,
        "multi": false,
        "pythonType": "list[str]",
        "tsType": "Array<string>",
        "baseType": "list[str]",
        "portSchemaId": "string_list_str_list_str_single_array"
      },
      {
        "id": "out_appearances",
        "type": "list[AppearanceDict]",
        "label": "Appearances",
        "description": "Character expressions, poses, positions",
        "required": false,
        "multi": false,
        "pythonType": "list[AppearanceDict]",
        "tsType": "Array<AppearanceDict>",
        "baseType": "list[AppearanceDict]",
        "portSchemaId": "list_appearance_dict_list_appearance_dict_list_appearance_dict_single_array"
      },
      {
        "id": "out_dialogue",
        "type": "list[PanelDialogueDict]",
        "label": "Dialogue",
        "description": "Dialogue lines in this panel",
        "required": false,
        "multi": false,
        "pythonType": "list[PanelDialogueDict]",
        "tsType": "Array<PanelDialogueDict>",
        "baseType": "list[PanelDialogueDict]",
        "hidden_from_director": true,
        "portSchemaId": "list_panel_dialogue_dict_list_panel_dialogue_dict_list_panel_dialogue_dict_single_array"
      },
      {
        "id": "out_script",
        "type": "string",
        "label": "Script",
        "description": "Dialogue formatted as TTS script",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_composition",
        "type": "CompositionDict",
        "label": "Composition",
        "description": "Shot type, angle, and focus settings",
        "required": false,
        "multi": false,
        "pythonType": "CompositionDict",
        "tsType": "CompositionDict",
        "baseType": "CompositionDict",
        "portSchemaId": "composition_dict_composition_dict_composition_dict_single_map"
      }
    ],
    "state": []
  },
  "prompt_input": {
    "type": "promptInput",
    "backendType": "prompt_input",
    "label": "Prompt Input",
    "category": "Input",
    "description": "Enter your story prompt for generation",
    "icon": "\ud83d\udcdd",
    "layout": {
      "*": {
        "width": 320,
        "height": 250
      }
    },
    "canvasHidden": false,
    "inputs": [],
    "outputs": [
      {
        "id": "out_prompt",
        "type": "string",
        "label": "Prompt",
        "description": "The story prompt text",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "state": []
  },
  "script_writer": {
    "type": "scriptWriter",
    "backendType": "script_writer",
    "label": "Script Writer",
    "category": "Agentic",
    "description": "Interactive conversational story writer",
    "icon": "\ud83d\udcdd",
    "layout": {
      "*": {
        "width": 920,
        "height": 620
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_prompt",
        "type": "string",
        "label": "Prompt",
        "description": "Story prompt or instructions",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_active_model",
        "type": "string",
        "label": "Active Model",
        "description": "Selected model variant: gemini or claude. Legacy gpt values are ignored while Script Plus is unavailable.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "claude",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_active_variant_id",
        "type": "string",
        "label": "Active Variant",
        "description": "Id of the out_script_variants entry the node currently displays. Empty means the newest variant for the active model.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_name",
        "type": "string",
        "label": "Name",
        "description": "Project or scene name",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_director_instruction",
        "type": "string",
        "label": "Director Instruction",
        "description": "Director's creative guidance composed from user Q&A \u2014 tone, structure, pacing, and other creative direction",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_format_only",
        "type": "boolean",
        "label": "Format Only",
        "description": "When true, the Script Writer only reformats the user prompt into screenplay structure without adding, modifying, or removing storyline content",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_gemini",
        "type": "boolean",
        "label": "Gemini",
        "description": "Enable Gemini model for screenplay generation",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_claude",
        "type": "boolean",
        "label": "Claude",
        "description": "Enable Claude model for screenplay generation",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": true,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_gpt",
        "type": "boolean",
        "label": "GPT",
        "description": "Legacy GPT model toggle retained for persisted project compatibility. Ignored while Script Plus is unavailable.",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_characters",
        "type": "string",
        "label": "Characters",
        "description": "Character names",
        "required": false,
        "multi": true,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_multi_array"
      },
      {
        "id": "in_feedback",
        "type": "string",
        "label": "Feedback",
        "description": "Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_target_duration_s",
        "type": "float",
        "label": "Target Duration (s)",
        "description": "Optional target total duration in seconds; used to compute suggested scene count. Director should set this from the user's duration choice (30s=30, about 1min=60, about 2min=120, about 5min=300, or a custom value).",
        "required": false,
        "multi": false,
        "pythonType": "float",
        "tsType": "number",
        "baseType": "float",
        "portSchemaId": "float_float_float_single_primitive"
      },
      {
        "id": "in_review_history",
        "type": "list[ReviewHistoryEntryDict]",
        "label": "Review History",
        "description": "Script review feedback history",
        "required": false,
        "multi": false,
        "pythonType": "list[ReviewHistoryEntryDict]",
        "tsType": "Array<ReviewHistoryEntryDict>",
        "baseType": "list[ReviewHistoryEntryDict]",
        "default": [],
        "hidden_from_director": true,
        "portSchemaId": "list_review_history_entry_dict_list_review_history_entry_dict_list_review_history_entry_dict_single_array"
      },
      {
        "id": "in_feedback_history",
        "type": "list[FeedbackHistoryEntryDict]",
        "label": "Feedback History",
        "description": "Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior screenplay + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries.",
        "required": false,
        "multi": false,
        "pythonType": "list[FeedbackHistoryEntryDict]",
        "tsType": "Array<FeedbackHistoryEntryDict>",
        "baseType": "list[FeedbackHistoryEntryDict]",
        "default": [],
        "hidden_from_director": true,
        "portSchemaId": "list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array"
      },
      {
        "id": "in_bg_color",
        "type": "string",
        "label": "Background Color",
        "description": "Predefined background color key for the node card",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "default",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_script",
        "type": "string",
        "label": "Script",
        "description": "Generated script content",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "user_editable": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_script_path",
        "type": "string",
        "label": "Script Path",
        "description": "Path to saved script file",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_screenplay",
        "type": "list[ScriptScreenplaySceneDict]",
        "label": "Screenplay",
        "description": "Structured screenplay (array of scene objects with typed entries)",
        "required": false,
        "multi": false,
        "pythonType": "list[ScriptScreenplaySceneDict]",
        "tsType": "Array<ScriptScreenplaySceneDict>",
        "baseType": "list[ScriptScreenplaySceneDict]",
        "portSchemaId": "list_script_screenplay_scene_dict_list_script_screenplay_scene_dict_list_script_screenplay_scene_dict_single_array"
      },
      {
        "id": "out_dialogue",
        "type": "list[ScriptDialogueDict]",
        "label": "Dialogue",
        "description": "Extracted dialogue entries with character, emotion, and text",
        "required": false,
        "multi": false,
        "pythonType": "list[ScriptDialogueDict]",
        "tsType": "Array<ScriptDialogueDict>",
        "baseType": "list[ScriptDialogueDict]",
        "hidden_from_director": true,
        "portSchemaId": "list_script_dialogue_dict_list_script_dialogue_dict_list_script_dialogue_dict_single_array"
      },
      {
        "id": "out_voice_roles",
        "type": "VoiceRoleDict",
        "label": "Voice Roles",
        "description": "Reusable narrator, system, and internal-monologue voice roles referenced by screenplay entries",
        "required": false,
        "multi": true,
        "pythonType": "VoiceRoleDict",
        "tsType": "VoiceRoleDict",
        "baseType": "VoiceRoleDict",
        "portSchemaId": "voice_role_dict_voice_role_dict_voice_role_dict_multi_array"
      },
      {
        "id": "out_voice_profiles",
        "type": "VoiceProfileDict",
        "label": "Narrator Voice Profiles",
        "description": "Provider-neutral narrator, system, title-card, and internal-monologue voice briefs. Profile name matches voice_role_id. Linked Sound Expert nodes choose and store concrete provider voices.",
        "required": false,
        "multi": true,
        "pythonType": "VoiceProfileDict",
        "tsType": "VoiceProfileDict",
        "baseType": "VoiceProfileDict",
        "portSchemaId": "voice_profile_dict_voice_profile_dict_voice_profile_dict_multi_array"
      },
      {
        "id": "out_action_lines",
        "type": "list[SceneTextDict]",
        "label": "Action Lines",
        "description": "Extracted action/staging direction entries per scene",
        "required": false,
        "multi": false,
        "pythonType": "list[SceneTextDict]",
        "tsType": "Array<SceneTextDict>",
        "baseType": "list[SceneTextDict]",
        "portSchemaId": "list_scene_text_dict_list_scene_text_dict_list_scene_text_dict_single_array"
      },
      {
        "id": "out_characters",
        "type": "string",
        "label": "Characters",
        "description": "Deduplicated list of character names appearing in the screenplay",
        "required": false,
        "multi": false,
        "pythonType": "list[str]",
        "tsType": "Array<string>",
        "baseType": "list[str]",
        "portSchemaId": "string_list_str_list_str_single_array"
      },
      {
        "id": "out_music_cues",
        "type": "list[SceneTextDict]",
        "label": "Music Cues",
        "description": "Music mood/genre cue entries per scene",
        "required": false,
        "multi": false,
        "pythonType": "list[SceneTextDict]",
        "tsType": "Array<SceneTextDict>",
        "baseType": "list[SceneTextDict]",
        "portSchemaId": "list_scene_text_dict_list_scene_text_dict_list_scene_text_dict_single_array"
      },
      {
        "id": "out_sfx",
        "type": "list[SceneTextDict]",
        "label": "SFX",
        "description": "Sound effect entries per scene",
        "required": false,
        "multi": false,
        "pythonType": "list[SceneTextDict]",
        "tsType": "Array<SceneTextDict>",
        "baseType": "list[SceneTextDict]",
        "portSchemaId": "list_scene_text_dict_list_scene_text_dict_list_scene_text_dict_single_array"
      },
      {
        "id": "out_gemini",
        "type": "ScreenplayResultDict",
        "label": "Gemini Result",
        "description": "Raw ScreenplayResult JSON from Gemini",
        "required": false,
        "multi": false,
        "pythonType": "ScreenplayResultDict",
        "tsType": "ScreenplayResultDict",
        "baseType": "ScreenplayResultDict",
        "hidden_from_director": true,
        "portSchemaId": "screenplay_result_dict_screenplay_result_dict_screenplay_result_dict_single_map"
      },
      {
        "id": "out_claude",
        "type": "ScreenplayResultDict",
        "label": "Claude Result",
        "description": "Raw ScreenplayResult JSON from Claude Opus 4",
        "required": false,
        "multi": false,
        "pythonType": "ScreenplayResultDict",
        "tsType": "ScreenplayResultDict",
        "baseType": "ScreenplayResultDict",
        "hidden_from_director": true,
        "portSchemaId": "screenplay_result_dict_screenplay_result_dict_screenplay_result_dict_single_map"
      },
      {
        "id": "out_gpt",
        "type": "ScreenplayResultDict",
        "label": "GPT Result",
        "description": "Legacy GPT-4o ScreenplayResult JSON retained for persisted project compatibility.",
        "required": false,
        "multi": false,
        "pythonType": "ScreenplayResultDict",
        "tsType": "ScreenplayResultDict",
        "baseType": "ScreenplayResultDict",
        "hidden_from_director": true,
        "portSchemaId": "screenplay_result_dict_screenplay_result_dict_screenplay_result_dict_single_map"
      },
      {
        "id": "out_locations",
        "type": "string",
        "label": "Locations",
        "description": "Extracted location names from screenplay",
        "required": false,
        "multi": false,
        "pythonType": "list[str]",
        "tsType": "Array<string>",
        "baseType": "list[str]",
        "portSchemaId": "string_list_str_list_str_single_array"
      },
      {
        "id": "out_active_model",
        "type": "string",
        "label": "Active Model",
        "description": "Which model variant was selected (gemini or claude)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_scene_count",
        "type": "int",
        "label": "Scene Count",
        "description": "Number of scenes in the generated screenplay",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "out_logline",
        "type": "string",
        "label": "Logline",
        "description": "One-sentence logline for the active model's screenplay",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_genre_tone",
        "type": "string",
        "label": "Genre / Tone",
        "description": "Genre and tonal register of the active model's screenplay",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_synopsis",
        "type": "string",
        "label": "Synopsis",
        "description": "Short prose synopsis of the active model's screenplay",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_themes",
        "type": "string",
        "label": "Themes",
        "description": "Central themes of the active model's screenplay",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_script_variants",
        "type": "list[ScriptVariantDict]",
        "label": "Script Variants",
        "description": "Screenplay iteration history, oldest first. One entry per model per successful run; the node's Variants panel lists these newest-first and marks the active one as the master script. Capped at the most recent 20 entries.",
        "required": false,
        "multi": false,
        "pythonType": "list[ScriptVariantDict]",
        "tsType": "Array<ScriptVariantDict>",
        "baseType": "list[ScriptVariantDict]",
        "default": [],
        "hidden_from_director": true,
        "portSchemaId": "list_script_variant_dict_list_script_variant_dict_list_script_variant_dict_single_array"
      }
    ],
    "state": [],
    "executionActions": [
      "generate",
      "rewrite_with_model",
      "resync_from_script",
      "replace_from_script"
    ],
    "actionLabels": {
      "rewrite_with_model": "Rewrite screenplay",
      "resync_from_script": "Sync edits",
      "replace_from_script": "Replace script"
    },
    "directorGuidance": "Use the screenplay tools for screenplay work instead of raw DAG changes. Load screenplay-episode-flow for new episode or chapter continuation; Script Writer outputs drive downstream designer, storyboard, and video workflows.",
    "projectStatusOnComplete": "in_progress"
  },
  "short_video_group": {
    "type": "shortVideoGroup",
    "backendType": "short_video_group",
    "label": "Short Video",
    "category": "Group",
    "description": "Group node for short video production with storyboard grid and horizontal panel layout",
    "icon": "\ud83c\udfac",
    "layout": {
      "*": {
        "width": 355,
        "height": 4000
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_label",
        "type": "string",
        "label": "Label",
        "description": "Display label for the group",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "Short Video",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_collapsed",
        "type": "boolean",
        "label": "Collapsed",
        "description": "Whether the group is collapsed",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_storyboard_path",
        "type": "string",
        "label": "Storyboard Path",
        "description": "Path to the storyboard grid image",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_image",
        "type": "image",
        "label": "Reference Image",
        "description": "Reference image for connected edges",
        "required": false,
        "multi": false,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "hidden_from_director": true,
        "portSchemaId": "image_image_asset_ref_dict_image_asset_single_map"
      },
      {
        "id": "in_child_node_ids",
        "type": "string",
        "label": "Child Nodes",
        "description": "IDs of child panel nodes",
        "required": false,
        "multi": false,
        "pythonType": "list[str]",
        "tsType": "Array<string>",
        "baseType": "list[str]",
        "default": [],
        "hidden_from_director": true,
        "portSchemaId": "string_list_str_list_str_single_array"
      }
    ],
    "outputs": [],
    "state": []
  },
  "sound_expert": {
    "type": "soundExpert",
    "backendType": "sound_expert",
    "label": "Sound Expert",
    "category": "Agentic",
    "description": "Generate music, speech, or sound effects with three unified modes",
    "icon": "\ud83c\udfa7",
    "layout": {
      "*": {
        "width": 315,
        "height": 200
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_name",
        "type": "string",
        "label": "Name",
        "description": "Display name for the node (FloatingNodeLabel)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_upstream",
        "type": "UpstreamContextDict",
        "label": "Upstream",
        "description": "Upstream dependency trigger",
        "required": false,
        "multi": false,
        "pythonType": "UpstreamContextDict",
        "tsType": "UpstreamContextDict",
        "baseType": "UpstreamContextDict",
        "portSchemaId": "upstream_context_dict_upstream_context_dict_upstream_context_dict_single_map"
      },
      {
        "id": "in_prompt",
        "type": "string",
        "label": "Prompt",
        "description": "Free-text description of desired audio (music/sfx)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_mode",
        "type": "string",
        "label": "Mode",
        "description": "Audio generation mode: music, speech, or sfx",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "music",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_duration",
        "type": "string",
        "label": "Duration",
        "description": "Duration hint as human-readable string (music/sfx only)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "30s",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_voice_profile",
        "type": "VoiceProfileDict",
        "label": "Voice Profile",
        "description": "Voice profile from Character Designer for speech mode",
        "required": false,
        "multi": false,
        "pythonType": "VoiceProfileDict",
        "tsType": "VoiceProfileDict",
        "baseType": "VoiceProfileDict",
        "portSchemaId": "voice_profile_dict_voice_profile_dict_voice_profile_dict_single_map"
      },
      {
        "id": "in_text",
        "type": "string",
        "label": "Text",
        "description": "Final speakable dialogue or narration transcript for speech mode. Do not put refinement notes, instructions, headings, or prompt text here; use Feedback for revisions.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_feedback",
        "type": "string",
        "label": "Feedback",
        "description": "Correction or revision feedback for the next speech-mode run. Set this via propose_dag_changes (op=update) before calling run_nodes to revise an existing voiceover without mixing instructions into Text.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_feedback_history",
        "type": "list[FeedbackHistoryEntryDict]",
        "label": "Feedback History",
        "description": "Accumulated Sound Expert speech refinement feedback per round. The agent appends a new entry whenever it rewrites speech from non-empty feedback so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries.",
        "required": false,
        "multi": false,
        "pythonType": "list[FeedbackHistoryEntryDict]",
        "tsType": "Array<FeedbackHistoryEntryDict>",
        "baseType": "list[FeedbackHistoryEntryDict]",
        "maxItems": 10,
        "default": [],
        "hidden_from_director": true,
        "portSchemaId": "list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array"
      },
      {
        "id": "in_model",
        "type": "string",
        "label": "Model",
        "description": "Audio generation model identifier",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "elevenlabs_v3",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_loop",
        "type": "string",
        "label": "Loop",
        "description": "Whether to loop the audio (sfx mode)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "off",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_lyrics_mode",
        "type": "string",
        "label": "Lyrics Mode",
        "description": "Lyrics generation mode for music (auto/custom/instrumental)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "auto",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_voice_map",
        "type": "VoiceMapDict",
        "label": "Voice Map",
        "description": "Speaker-to-voice mapping for multi-speaker narration (speech mode)",
        "required": false,
        "multi": false,
        "pythonType": "VoiceMapDict",
        "tsType": "VoiceMapDict",
        "baseType": "VoiceMapDict",
        "default": {},
        "portSchemaId": "voice_map_dict_voice_map_dict_voice_map_dict_single_map"
      },
      {
        "id": "in_scene_id",
        "type": "string",
        "label": "Scene ID",
        "description": "Scene identifier for file naming (speech mode)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_panel_index",
        "type": "int",
        "label": "Panel Index",
        "description": "Panel index for ordering within a scene (speech mode)",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_pause_ms",
        "type": "int",
        "label": "Pause (ms)",
        "description": "Pause duration in milliseconds between segments (speech mode)",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "default": 200,
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_character_name",
        "type": "string",
        "label": "Character Name",
        "description": "Character name for single-speaker TTS (speech mode)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_character_voice_source_for",
        "type": "string",
        "label": "Character Voice Source For",
        "description": "Character node id when this Sound Expert is the active Character voice source.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_duration_seconds",
        "type": "float",
        "label": "Duration",
        "description": "Audio duration in seconds",
        "required": false,
        "multi": false,
        "pythonType": "float",
        "tsType": "number",
        "baseType": "float",
        "portSchemaId": "float_float_float_single_primitive"
      },
      {
        "id": "out_audio",
        "type": "audio",
        "label": "Generated Audio",
        "description": "Generated audio with history and picked index",
        "required": false,
        "multi": false,
        "pythonType": "SoundGeneratedAudioDict",
        "tsType": "SoundGeneratedAudioDict",
        "baseType": "AudioAsset",
        "portSchemaId": "audio_sound_generated_audio_dict_audio_asset_single_map"
      },
      {
        "id": "out_voice_profile",
        "type": "VoiceProfileDict",
        "label": "Voice Profile",
        "description": "Voice metadata selected or used by this Sound Expert node for speech generation",
        "required": false,
        "multi": false,
        "pythonType": "VoiceProfileDict",
        "tsType": "VoiceProfileDict",
        "baseType": "VoiceProfileDict",
        "portSchemaId": "voice_profile_dict_voice_profile_dict_voice_profile_dict_single_map"
      }
    ],
    "state": [
      {
        "id": "batch_pending",
        "type": "int",
        "label": "batch_pending",
        "description": "",
        "pythonType": "int",
        "tsType": "number"
      },
      {
        "id": "audio_file",
        "type": "string",
        "label": "audio_file",
        "description": "Legacy: direct path to audio file. TODO: Remove after full canvas-v2 migration",
        "pythonType": "str",
        "tsType": "string"
      },
      {
        "id": "speech_segments",
        "type": "SpeechSegmentDict",
        "label": "speech_segments",
        "description": "Per-character speech segments with generated speech results",
        "pythonType": "SpeechSegmentDict",
        "tsType": "SpeechSegmentDict"
      },
      {
        "id": "selected_voice_provider",
        "type": "string",
        "label": "selected_voice_provider",
        "description": "Provider for the selected speech voice owned by this Sound Expert node",
        "pythonType": "str",
        "tsType": "string"
      },
      {
        "id": "selected_voice_id",
        "type": "string",
        "label": "selected_voice_id",
        "description": "Provider voice id selected by this Sound Expert node for speech TTS",
        "pythonType": "str",
        "tsType": "string"
      },
      {
        "id": "selected_voice_name",
        "type": "string",
        "label": "selected_voice_name",
        "description": "Display name for the selected speech voice owned by this Sound Expert node",
        "pythonType": "str",
        "tsType": "string"
      },
      {
        "id": "selected_voice_ref",
        "type": "string",
        "label": "selected_voice_ref",
        "description": "Opaque Dreamwrite catalogue reference for the selected speech voice",
        "pythonType": "str",
        "tsType": "string"
      }
    ],
    "pricing": {
      "category": "audio_models",
      "model": "elevenlabs",
      "priceType": "per_generation"
    },
    "directorGuidance": "Modes: music, speech, sfx. On add set in_mode. For music/SFX set in_prompt; set in_lyrics_mode=instrumental for instrumental music. For new speech set in_mode=speech and in_text to final speakable transcript only: no refinement notes, instructions, headings, or prompt text. To revise existing speech, set in_feedback and call run_nodes. Prefer generate_background_music for background music; load standalone-media-generation for speech, SFX, duration, or voice references.",
    "projectStatusOnComplete": "in_progress"
  },
  "speech_generator": {
    "type": "speechGenerator",
    "backendType": "speech_generator",
    "label": "Speech Generator",
    "category": "Agentic",
    "description": "Generate character speech or multi-voice narration",
    "icon": "\ud83d\udde3\ufe0f",
    "layout": {
      "*": {
        "width": 315,
        "height": 200
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_mode",
        "type": "string",
        "label": "Mode",
        "description": "Speech generation mode: character_voice or narrative",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "narrative",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_script",
        "type": "string",
        "label": "Script",
        "description": "Narration script or fallback text for character voice mode",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_text",
        "type": "string",
        "label": "Text",
        "description": "Single-speaker text for character voice mode",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_character_name",
        "type": "string",
        "label": "Character Name",
        "description": "Character name for single-speaker TTS",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_voice_id",
        "type": "string",
        "label": "Voice ID",
        "description": "Explicit provider voice ID override",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_voice_profile",
        "type": "VoiceProfileDict",
        "label": "Voice Profile",
        "description": "Voice profile from Character Designer",
        "required": false,
        "multi": false,
        "pythonType": "VoiceProfileDict",
        "tsType": "VoiceProfileDict",
        "baseType": "VoiceProfileDict",
        "portSchemaId": "voice_profile_dict_voice_profile_dict_voice_profile_dict_single_map"
      },
      {
        "id": "in_voice_map",
        "type": "VoiceMapDict",
        "label": "Voice Map",
        "description": "Speaker-to-voice mapping for multi-speaker narration",
        "required": false,
        "multi": false,
        "pythonType": "VoiceMapDict",
        "tsType": "VoiceMapDict",
        "baseType": "VoiceMapDict",
        "default": {},
        "portSchemaId": "voice_map_dict_voice_map_dict_voice_map_dict_single_map"
      },
      {
        "id": "in_scene_id",
        "type": "string",
        "label": "Scene ID",
        "description": "Scene identifier for file naming",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_panel_index",
        "type": "int",
        "label": "Panel Index",
        "description": "Panel index for ordering within a scene",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_pause_ms",
        "type": "int",
        "label": "Pause (ms)",
        "description": "Pause duration in milliseconds between segments",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "default": 200,
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_pronunciation_guide",
        "type": "string",
        "label": "Pronunciation Guide",
        "description": "Per-word pronunciation overrides for non-English words and proper nouns. One rule per line: 'word \u2192 pronunciation' (alias) or 'word \u2192 /IPA/' (phoneme). Example: L'Ora \u2192 LOH-rah",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_language_code",
        "type": "string",
        "label": "Language",
        "description": "ISO 639-1 language code (e.g. 'en', 'it', 'zh', 'ja'). Helps ElevenLabs apply correct phonetics instead of defaulting to English. Leave empty for auto-detection.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_duration_seconds",
        "type": "float",
        "label": "Duration",
        "description": "Audio duration in seconds",
        "required": false,
        "multi": false,
        "pythonType": "float",
        "tsType": "number",
        "baseType": "float",
        "portSchemaId": "float_float_float_single_primitive"
      },
      {
        "id": "out_waveform",
        "type": "list[float]",
        "label": "Waveform",
        "description": "Waveform samples for UI display",
        "required": false,
        "multi": false,
        "pythonType": "list[float]",
        "tsType": "Array<number>",
        "baseType": "list[float]",
        "portSchemaId": "list_float_list_float_list_float_single_array"
      },
      {
        "id": "out_audio",
        "type": "audio",
        "label": "Generated Audio",
        "description": "Generated audio with history and picked index",
        "required": false,
        "multi": false,
        "pythonType": "SoundGeneratedAudioDict",
        "tsType": "SoundGeneratedAudioDict",
        "baseType": "AudioAsset",
        "portSchemaId": "audio_sound_generated_audio_dict_audio_asset_single_map"
      }
    ],
    "state": [],
    "pricing": {
      "category": "audio_models",
      "model": "gemini_tts",
      "priceType": "per_generation"
    },
    "projectStatusOnComplete": "in_progress"
  },
  "story_direction_preview": {
    "type": "storyDirectionPreview",
    "backendType": "story_direction_preview",
    "label": "Story Direction",
    "category": "Story Shaping",
    "description": "Story shaping dimensions: premise, tone, hook, structure",
    "icon": "\ud83e\udded",
    "layout": {
      "*": {
        "width": 920,
        "height": 650
      }
    },
    "canvasHidden": true,
    "inputs": [],
    "outputs": [],
    "state": [
      {
        "id": "premise",
        "type": "StoryDirectionFieldDict",
        "label": "premise",
        "description": "",
        "pythonType": "StoryDirectionFieldDict",
        "tsType": "StoryDirectionFieldDict"
      },
      {
        "id": "tone",
        "type": "StoryDirectionFieldDict",
        "label": "tone",
        "description": "",
        "pythonType": "StoryDirectionFieldDict",
        "tsType": "StoryDirectionFieldDict"
      },
      {
        "id": "hook",
        "type": "StoryDirectionFieldDict",
        "label": "hook",
        "description": "",
        "pythonType": "StoryDirectionFieldDict",
        "tsType": "StoryDirectionFieldDict"
      },
      {
        "id": "structure",
        "type": "StoryDirectionFieldDict",
        "label": "structure",
        "description": "",
        "pythonType": "StoryDirectionFieldDict",
        "tsType": "StoryDirectionFieldDict"
      }
    ]
  },
  "storyboard_designer": {
    "type": "storyboardDesigner",
    "backendType": "storyboard_designer",
    "label": "Storyboard Designer",
    "category": "Agentic",
    "description": "Generate a 9-grid storyboard from a script or scene description",
    "icon": "\ud83c\udfac",
    "layout": {
      "*": {
        "width": 480,
        "height": 420
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_script",
        "type": "string",
        "label": "Script",
        "description": "Script or scene breakdown to visualize as storyboard",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_characters",
        "type": "image",
        "label": "Characters",
        "description": "Character reference sheets for visual consistency",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "referenceDesignerNodeType": "character_designer",
        "hidden_from_director": true,
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "in_character_names",
        "type": "string",
        "label": "Character Names",
        "description": "Character names from designer out_name ports",
        "required": false,
        "multi": true,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_multi_array"
      },
      {
        "id": "in_locations",
        "type": "image",
        "label": "Locations",
        "description": "Location reference images for scene setting",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "referenceDesignerNodeType": "location_designer",
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "in_location_names",
        "type": "string",
        "label": "Location Names",
        "description": "Location names from designer out_name ports",
        "required": false,
        "multi": true,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_multi_array"
      },
      {
        "id": "in_objects",
        "type": "image",
        "label": "Objects",
        "description": "Object reference images for props and items",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "referenceDesignerNodeType": "object_designer",
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "in_object_names",
        "type": "string",
        "label": "Object Names",
        "description": "Object names from designer out_name ports",
        "required": false,
        "multi": true,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_multi_array"
      },
      {
        "id": "in_image",
        "type": "image",
        "label": "Reference Image",
        "description": "Optional reference image to guide storyboard generation",
        "required": false,
        "multi": false,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "hidden_from_director": true,
        "portSchemaId": "image_image_asset_ref_dict_image_asset_single_map"
      },
      {
        "id": "in_style",
        "type": "string",
        "label": "Art Style",
        "description": "Visual art style for the storyboard",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_panel_count",
        "type": "int",
        "label": "Panel Count",
        "description": "Number of panels (default 9 for 9-grid)",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "default": 9,
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_shot_count",
        "type": "int",
        "label": "Shot Count",
        "description": "Optional exact count for text-mode Shot List generation; when unset, the planner chooses the count.",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_aspect_ratio",
        "type": "string",
        "label": "Aspect Ratio",
        "description": "Optional storyboard aspect ratio override. When unset, uses the project aspect ratio.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_scene_id",
        "type": "string",
        "label": "Scene ID",
        "description": "Scene identifier for the storyboard",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "scene_1",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_name",
        "type": "string",
        "label": "Name",
        "description": "Optional display label for the storyboard designer node",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_location",
        "type": "string",
        "label": "Location",
        "description": "Location for the scene",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_model",
        "type": "string",
        "label": "Model",
        "description": "Image generation model",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "openai-gpt-image-2",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_feedback",
        "type": "string",
        "label": "Feedback",
        "description": "Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_vlm_validation",
        "type": "boolean",
        "label": "Quality Check",
        "description": "Run Gemini VLM quality validation after generation",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_video_anchors",
        "type": "list[ShotVideoAnchorDict]",
        "label": "Exact Video Frames",
        "description": "User-designated exact first/last frame assets by shot ID. Automatically generated frames remain reference images unless explicitly designated.",
        "required": false,
        "multi": false,
        "pythonType": "list[ShotVideoAnchorDict]",
        "tsType": "Array<ShotVideoAnchorDict>",
        "baseType": "list[ShotVideoAnchorDict]",
        "hidden_from_director": true,
        "directorWritable": false,
        "canvasEntryKeys": [
          "shot_id",
          "role"
        ],
        "canvasEntryOnlyExact": true,
        "portSchemaId": "list_shot_video_anchor_dict_list_shot_video_anchor_dict_list_shot_video_anchor_dict_single_array"
      }
    ],
    "outputs": [
      {
        "id": "out_image",
        "type": "image",
        "label": "Grid History",
        "description": "History of generated storyboard grid images and selected variant",
        "required": false,
        "multi": false,
        "pythonType": "GeneratedImageWithHistory",
        "tsType": "GeneratedImageWithHistory",
        "baseType": "ImageAsset",
        "portSchemaId": "image_generated_image_with_history_image_asset_single_map"
      },
      {
        "id": "out_grid_images",
        "type": "image",
        "label": "Grid Images",
        "description": "Per-grid storyboard composite image paths for multi-grid storyboards",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "hidden_from_director": true,
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "out_metadata",
        "type": "StoryboardMetadataDict",
        "label": "Metadata",
        "description": "Storyboard metadata including beat descriptions",
        "required": false,
        "multi": false,
        "pythonType": "StoryboardMetadataDict",
        "tsType": "StoryboardMetadataDict",
        "baseType": "StoryboardMetadataDict",
        "portSchemaId": "storyboard_metadata_dict_storyboard_metadata_dict_storyboard_metadata_dict_single_map"
      },
      {
        "id": "out_beats",
        "type": "string",
        "label": "Beats",
        "description": "Beat descriptions per panel",
        "required": false,
        "multi": true,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_multi_array"
      },
      {
        "id": "out_shots",
        "type": "GeneratedShotRowV2Dict",
        "label": "Generated Shots",
        "description": "Versioned shot records; multi-array output permits individual downstream shot references.",
        "required": false,
        "multi": true,
        "pythonType": "GeneratedShotRowV2Dict",
        "tsType": "GeneratedShotRowV2Dict",
        "baseType": "GeneratedShotRowV2Dict",
        "hidden_from_director": true,
        "directorWritable": false,
        "portSchemaId": "generated_shot_row_v2_dict_generated_shot_row_v2_dict_generated_shot_row_v2_dict_multi_array"
      },
      {
        "id": "out_shot_seams",
        "type": "list[ShotSeamDict]",
        "label": "Shot Transitions",
        "description": "Atomic ordered shot-boundary list (not flattened): N shots have N+1 seams.",
        "required": false,
        "multi": false,
        "pythonType": "list[ShotSeamDict]",
        "tsType": "Array<ShotSeamDict>",
        "baseType": "list[ShotSeamDict]",
        "hidden_from_director": true,
        "directorWritable": false,
        "portSchemaId": "list_shot_seam_dict_list_shot_seam_dict_list_shot_seam_dict_single_array"
      },
      {
        "id": "out_production_plan",
        "type": "ShotProductionPlanDict",
        "label": "Shot List Production Plan",
        "description": "Versioned production annotations for an existing text Shot List.",
        "required": false,
        "multi": false,
        "pythonType": "ShotProductionPlanDict",
        "tsType": "ShotProductionPlanDict",
        "baseType": "ShotProductionPlanDict",
        "hidden_from_director": true,
        "directorWritable": false,
        "portSchemaId": "shot_production_plan_dict_shot_production_plan_dict_shot_production_plan_dict_single_map"
      },
      {
        "id": "out_video_generation_plan",
        "type": "ShotVideoGenerationPlanDict",
        "label": "Video Generation Plan",
        "description": "Exact-duration ordered packs, shared shot Generation IDs and corresponding video node IDs.",
        "required": false,
        "multi": false,
        "pythonType": "ShotVideoGenerationPlanDict",
        "tsType": "ShotVideoGenerationPlanDict",
        "baseType": "ShotVideoGenerationPlanDict",
        "hidden_from_director": true,
        "directorWritable": false,
        "portSchemaId": "shot_video_generation_plan_dict_shot_video_generation_plan_dict_shot_video_generation_plan_dict_single_map"
      },
      {
        "id": "out_video_previous_plan",
        "type": "ShotVideoGenerationPlanDict",
        "label": "Previous Video Plan",
        "description": "Inactive pack provenance retained for selective replanning; never authorizes video generation.",
        "required": false,
        "multi": false,
        "pythonType": "ShotVideoGenerationPlanDict",
        "tsType": "ShotVideoGenerationPlanDict",
        "baseType": "ShotVideoGenerationPlanDict",
        "hidden_from_director": true,
        "directorWritable": false,
        "ydocMapCopy": true,
        "portSchemaId": "shot_video_generation_plan_dict_shot_video_generation_plan_dict_shot_video_generation_plan_dict_single_map"
      },
      {
        "id": "out_start_frames",
        "type": "image",
        "label": "Shot Start Frames",
        "description": "Text-mode images indexed by canonical shot position, never by grid packing or frame mode.",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "hidden_from_director": true,
        "directorWritable": false,
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "out_key_frames",
        "type": "image",
        "label": "Shot Key Frames",
        "description": "Text-mode key-frame images indexed by canonical shot position.",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "hidden_from_director": true,
        "directorWritable": false,
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "out_end_frames",
        "type": "image",
        "label": "Shot End Frames",
        "description": "Text-mode end-frame images indexed by canonical shot position.",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "hidden_from_director": true,
        "directorWritable": false,
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "out_start_frame_prompts",
        "type": "string",
        "label": "Start Frame Prompts",
        "description": "",
        "required": false,
        "multi": true,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "directorWritable": false,
        "portSchemaId": "string_str_str_multi_array"
      },
      {
        "id": "out_key_frame_prompts",
        "type": "string",
        "label": "Key Frame Prompts",
        "description": "",
        "required": false,
        "multi": true,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "directorWritable": false,
        "portSchemaId": "string_str_str_multi_array"
      },
      {
        "id": "out_end_frame_prompts",
        "type": "string",
        "label": "End Frame Prompts",
        "description": "",
        "required": false,
        "multi": true,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "directorWritable": false,
        "portSchemaId": "string_str_str_multi_array"
      },
      {
        "id": "out_frame_links",
        "type": "list[ShotFrameLinkDict]",
        "label": "Shot Frame Links",
        "description": "Versioned shot/role to image-generator node mapping and per-slot status.",
        "required": false,
        "multi": false,
        "pythonType": "list[ShotFrameLinkDict]",
        "tsType": "Array<ShotFrameLinkDict>",
        "baseType": "list[ShotFrameLinkDict]",
        "hidden_from_director": true,
        "directorWritable": false,
        "portSchemaId": "list_shot_frame_link_dict_list_shot_frame_link_dict_list_shot_frame_link_dict_single_array"
      },
      {
        "id": "out_panel_refs",
        "type": "string",
        "label": "Panel Refs",
        "description": "Per-panel list of designer node IDs",
        "required": false,
        "multi": true,
        "pythonType": "list[str]",
        "tsType": "Array<string>",
        "baseType": "list[str]",
        "hidden_from_director": true,
        "portSchemaId": "string_list_str_list_str_multi_array"
      },
      {
        "id": "out_images",
        "type": "image",
        "label": "Panel Images",
        "description": "Cropped panel image paths",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "hidden_from_director": true,
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "out_grid_descriptions",
        "type": "string",
        "label": "Grid Descriptions",
        "description": "Per-grid concatenated beat descriptions for grid preview node prompts",
        "required": false,
        "multi": true,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_multi_array"
      },
      {
        "id": "out_vlm_report",
        "type": "VlmValidationReportDict",
        "label": "Quality Report",
        "description": "VLM quality validation report from the most recent generation",
        "required": false,
        "multi": false,
        "pythonType": "VlmValidationReportDict",
        "tsType": "VlmValidationReportDict",
        "baseType": "VlmValidationReportDict",
        "portSchemaId": "vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map"
      }
    ],
    "state": [
      {
        "id": "shot_guidance_kind",
        "type": "string",
        "label": "Shot List Guidance Kind",
        "description": "Provenance of a generated text Shot List: prompt or script.",
        "pythonType": "str",
        "tsType": "string",
        "directorWritable": false
      },
      {
        "id": "shot_guidance_fingerprint",
        "type": "string",
        "label": "Shot List Guidance Fingerprint",
        "description": "Fingerprint of the input guidance used for the current text Shot List.",
        "pythonType": "str",
        "tsType": "string",
        "directorWritable": false
      },
      {
        "id": "shot_guidance_warning",
        "type": "string",
        "label": "Shot List Guidance Warning",
        "description": "Review notice for unplaced screenplay scenes, mismatched scene suggestions or omitted dialogue.",
        "pythonType": "str",
        "tsType": "string",
        "directorWritable": false
      },
      {
        "id": "batch_pending",
        "type": "int",
        "label": "batch_pending",
        "description": "",
        "pythonType": "int",
        "tsType": "number"
      },
      {
        "id": "storyboard_view",
        "type": "string",
        "label": "Storyboard View",
        "description": "Presentation mode. Absent on legacy storyboard nodes.",
        "pythonType": "str",
        "tsType": "string",
        "directorWritable": false
      },
      {
        "id": "shot_list_planner_version",
        "type": "int",
        "label": "Shot List Planner Version",
        "description": "Marks prompt-guided Shot Lists; absent means the legacy screenplay-bound planner.",
        "pythonType": "int",
        "tsType": "number",
        "directorWritable": false
      },
      {
        "id": "storyboard_mode",
        "type": "string",
        "label": "Storyboard Execution Mode",
        "description": "Execution mode; absent means the historical image storyboard workflow.",
        "pythonType": "str",
        "tsType": "string",
        "directorWritable": false
      },
      {
        "id": "shot_list",
        "type": "ShotListRowDict",
        "label": "Shot List",
        "description": "Text-only shot rows; no storyboard image output or execution path.",
        "pythonType": "list[ShotListRowDict]",
        "tsType": "Array<ShotListRowDict>",
        "directorWritable": false
      },
      {
        "id": "shot_key_frame_relinks",
        "type": "ShotKeyFrameRelinkDict",
        "label": "User-selected key frames",
        "description": "Unique shot-ID-keyed selections of existing image nodes; override effective video master frames without replacing generated frame links.",
        "pythonType": "list[ShotKeyFrameRelinkDict]",
        "tsType": "Array<ShotKeyFrameRelinkDict>",
        "directorWritable": false,
        "canvasEntryKeys": [
          "shot_id"
        ]
      },
      {
        "id": "name_autogen",
        "type": "string",
        "label": "Auto-generated Name Marker",
        "description": "Marker token identifying which auto-generated default-name family this node's display name came from (see agentic_workflow.core.default_node_names). Absent on user-created and pre-marker nodes. The console localizes the name only while the stored value still equals the canonical English rendering, so a rename automatically wins.",
        "pythonType": "str",
        "tsType": "string"
      }
    ],
    "pricing": {
      "default": {
        "category": "image_models",
        "model": "openai-gpt-image-2",
        "priceType": "per_image"
      },
      "actions": {
        "generate_shot_list": null,
        "rewrite_shot_list": null,
        "generate_production_plan": null,
        "generate_shot_frames_key": {
          "category": "image_models",
          "model": "openai-gpt-image-2",
          "priceType": "per_image"
        },
        "generate_shot_frames_start_end": {
          "category": "image_models",
          "model": "openai-gpt-image-2",
          "priceType": "per_image"
        },
        "generate_shot_frames_all": {
          "category": "image_models",
          "model": "openai-gpt-image-2",
          "priceType": "per_image"
        }
      }
    },
    "executionActions": [
      "generate",
      "generate_shot_list",
      "generate_production_plan",
      "generate_shot_frames_key",
      "generate_shot_frames_start_end",
      "generate_shot_frames_all"
    ],
    "actionLabels": {
      "generate_shot_list": "Generate Shot List",
      "generate_production_plan": "Plan Production Details",
      "generate_shot_frames_key": "Generate Key Frames",
      "generate_shot_frames_start_end": "Generate Start and End Frames",
      "generate_shot_frames_all": "Generate All Shot Frames"
    },
    "directorGuidance": "Create with create_storyboard_node and rerun with rerun_storyboard_node, not raw DAG changes/run_nodes; those tools keep storyboard, panel nodes, groups, and edges in sync. Load storyboard-workflow for panel count, references, or storyboard-to-video handoff.",
    "projectStatusOnComplete": "in_progress"
  },
  "storyboard_no_enhance_designer": {
    "type": "storyboardNoEnhanceDesigner",
    "backendType": "storyboard_no_enhance_designer",
    "label": "Storyboard (No Enhance)",
    "category": "Agentic",
    "description": "Generate a 9-grid storyboard without per-panel enhancement",
    "icon": "\ud83c\udfac",
    "layout": {
      "*": {
        "width": 480,
        "height": 420
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_script",
        "type": "string",
        "label": "Script",
        "description": "Script or scene breakdown to visualize",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_characters",
        "type": "image",
        "label": "Characters",
        "description": "Character reference sheets",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "hidden_from_director": true,
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "in_character_names",
        "type": "string",
        "label": "Character Names",
        "description": "Character names from designer out_name ports",
        "required": false,
        "multi": true,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_multi_array"
      },
      {
        "id": "in_locations",
        "type": "image",
        "label": "Locations",
        "description": "Location reference images",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "in_location_names",
        "type": "string",
        "label": "Location Names",
        "description": "Location names from designer out_name ports",
        "required": false,
        "multi": true,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_multi_array"
      },
      {
        "id": "in_style",
        "type": "string",
        "label": "Art Style",
        "description": "Visual art style",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_panel_count",
        "type": "int",
        "label": "Panel Count",
        "description": "Number of panels",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "default": 9,
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_scene_id",
        "type": "string",
        "label": "Scene ID",
        "description": "Scene identifier",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "scene_1",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_location",
        "type": "string",
        "label": "Location",
        "description": "Location for the scene",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_model",
        "type": "string",
        "label": "Model",
        "description": "Image generation model",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "openai-gpt-image-2",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_vlm_validation",
        "type": "boolean",
        "label": "Quality Check",
        "description": "Run Gemini VLM quality validation after generation",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_image",
        "type": "image",
        "label": "Grid",
        "description": "Relative path to 9-grid image",
        "required": false,
        "multi": false,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "portSchemaId": "image_image_asset_ref_dict_image_asset_single_map"
      },
      {
        "id": "out_vlm_report",
        "type": "VlmValidationReportDict",
        "label": "Quality Report",
        "description": "VLM quality validation report from the most recent generation",
        "required": false,
        "multi": false,
        "pythonType": "VlmValidationReportDict",
        "tsType": "VlmValidationReportDict",
        "baseType": "VlmValidationReportDict",
        "portSchemaId": "vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map"
      }
    ],
    "state": [],
    "pricing": {
      "category": "image_models",
      "model": "openai-gpt-image-2",
      "priceType": "per_image"
    },
    "projectStatusOnComplete": "in_progress"
  },
  "style_selector": {
    "type": "styleSelector",
    "backendType": "style_selector",
    "label": "Style Selector",
    "category": "Input",
    "description": "Select visual style for generation",
    "icon": "\ud83c\udfa8",
    "layout": {
      "*": {
        "width": 280,
        "height": 200
      }
    },
    "canvasHidden": false,
    "inputs": [],
    "outputs": [
      {
        "id": "out_style",
        "type": "string",
        "label": "Style",
        "description": "The selected visual style",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "state": []
  },
  "text": {
    "type": "text",
    "backendType": "text",
    "label": "Text",
    "category": "Input",
    "description": "A text input with editable title",
    "icon": "\ud83d\udcdd",
    "layout": {
      "*": {
        "width": 280,
        "height": 200
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_input",
        "type": "string",
        "label": "Input",
        "description": "Text input from another node",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_text",
        "type": "string",
        "label": "Text",
        "description": "The text content",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "state": []
  },
  "video": {
    "type": "video",
    "backendType": "video",
    "label": "Video Upload",
    "category": "Media",
    "description": "Upload a local video file",
    "icon": "\ud83c\udfac",
    "layout": {
      "*": {
        "width": 315,
        "height": 177
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_file_name",
        "type": "string",
        "label": "File Name",
        "description": "",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_depth_include_audio",
        "type": "boolean",
        "label": "Include Source Audio in Depth Video",
        "description": "Keep the original clip audio in the extracted depth video.",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_transform_video",
        "type": "image",
        "label": "Transform Source Video",
        "description": "",
        "required": false,
        "multi": false,
        "pythonType": "VideoAssetRefDict",
        "tsType": "VideoAssetRefDict",
        "baseType": "VideoAsset",
        "hidden_from_director": true,
        "portSchemaId": "image_video_asset_ref_dict_video_asset_single_map"
      },
      {
        "id": "in_transform_target_resolution",
        "type": "string",
        "label": "Upscale Target Resolution",
        "description": "",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_transform_source_asset_path",
        "type": "string",
        "label": "Upscale Source Path",
        "description": "",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_transform_source_content_sha256",
        "type": "string",
        "label": "Upscale Source SHA256",
        "description": "",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_transform_source_width",
        "type": "int",
        "label": "Upscale Source Width",
        "description": "",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "hidden_from_director": true,
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_transform_source_height",
        "type": "int",
        "label": "Upscale Source Height",
        "description": "",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "hidden_from_director": true,
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_transform_source_frame_count",
        "type": "int",
        "label": "Upscale Source Frame Count",
        "description": "",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "hidden_from_director": true,
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_transform_source_fps",
        "type": "float",
        "label": "Upscale Source FPS",
        "description": "",
        "required": false,
        "multi": false,
        "pythonType": "float",
        "tsType": "number",
        "baseType": "float",
        "hidden_from_director": true,
        "portSchemaId": "float_float_float_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_video",
        "type": "video",
        "label": "Video",
        "description": "The uploaded video",
        "required": false,
        "multi": false,
        "pythonType": "GeneratedVideoWithHistory",
        "tsType": "GeneratedVideoWithHistory",
        "baseType": "VideoAsset",
        "hidden_from_director": true,
        "portSchemaId": "video_generated_video_with_history_video_asset_single_map"
      }
    ],
    "state": [],
    "executionActions": [
      "extract_depth",
      "upscale"
    ],
    "actionLabels": {
      "extract_depth": "Depth extraction",
      "upscale": "Upscale"
    }
  },
  "video_editor": {
    "type": "videoEditor",
    "backendType": "video_editor",
    "label": "Video Editor",
    "category": "Agentic",
    "description": "Edit videos by stitching sources or placing source-local trims on a timeline",
    "icon": "\ud83c\udfac",
    "layout": {
      "*": {
        "width": 315,
        "height": 270
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_reference_media",
        "type": "video|audio",
        "label": "References",
        "description": "Ordered video and audio references. Connect outputs here; toIndex preserves cross-media order. Internal video and audio inputs are derived from source port types.",
        "required": false,
        "multi": true,
        "pythonType": "MediaAssetRefDict",
        "tsType": "MediaAssetRefDict",
        "baseType": "VideoAsset|AudioAsset",
        "referenceMediaRoutes": {
          "VideoAsset": "in_videos",
          "AudioAsset": "in_audios"
        },
        "portSchemaId": "video_audio_media_asset_ref_dict_video_asset_audio_asset_multi_array"
      },
      {
        "id": "in_videos",
        "type": "video",
        "label": "Video Clips",
        "description": "Multiple video clips to stitch together (in order)",
        "required": false,
        "multi": true,
        "pythonType": "VideoAssetRefDict",
        "tsType": "VideoAssetRefDict",
        "baseType": "VideoAsset",
        "hidden_from_director": true,
        "portSchemaId": "video_video_asset_ref_dict_video_asset_multi_array"
      },
      {
        "id": "in_audios",
        "type": "audio",
        "label": "Audio Tracks",
        "description": "Input audio tracks for the editor. Audio inputs are independent from in_videos; counts do not need to match. Without explicit placement, audio tracks are placed in input order on the timeline.",
        "required": false,
        "multi": true,
        "pythonType": "AudioAssetRefDict",
        "tsType": "AudioAssetRefDict",
        "baseType": "AudioAsset",
        "hidden_from_director": true,
        "portSchemaId": "audio_audio_asset_ref_dict_audio_asset_multi_array"
      },
      {
        "id": "in_audio",
        "type": "audio",
        "label": "Audio",
        "description": "Single audio input; treated as one additional independent audio track.",
        "required": false,
        "multi": false,
        "pythonType": "AudioAssetRefDict",
        "tsType": "AudioAssetRefDict",
        "baseType": "AudioAsset",
        "portSchemaId": "audio_audio_asset_ref_dict_audio_asset_single_map"
      },
      {
        "id": "in_video_config",
        "type": "TimelineConfigDict",
        "label": "Video Config",
        "description": "Persisted Video Editor timeline. Connected media seeds a new timeline in edge order. Use edit_video_editor_timeline for later changes. start_time/end_time trim the source; start_offset places an item on the output timeline. Omit all three for sequential whole-source clips. Use symbolic source_path values such as '<node_id>.out_video' or '<node_id>.out_audio'; the editor resolves the wired asset at render time. audio_kind is the saved audio type. role is accepted only as a compatibility input when audio_kind is absent.",
        "required": false,
        "multi": false,
        "pythonType": "TimelineConfigDict",
        "tsType": "TimelineConfigDict",
        "baseType": "TimelineConfigDict",
        "default": {
          "operation": "timeline_render",
          "timeline": {
            "clips": [],
            "audio_tracks": []
          }
        },
        "ydocCreationRoot": true,
        "legacyNullAsAbsent": true,
        "portSchemaId": "timeline_config_dict_timeline_config_dict_timeline_config_dict_single_map"
      },
      {
        "id": "in_edit_spec",
        "type": "EditSpecDict",
        "label": "Edit Spec",
        "description": "Versioned AI-authored edit contract. Additive to in_video_config during migration; renderer selection is controlled by explicit compatibility state and execution action, never field presence.",
        "required": false,
        "multi": false,
        "pythonType": "EditSpecDict",
        "tsType": "EditSpecDict",
        "baseType": "EditSpecDict",
        "hidden_from_director": true,
        "portSchemaId": "edit_spec_dict_edit_spec_dict_edit_spec_dict_single_map"
      },
      {
        "id": "in_mode",
        "type": "string",
        "label": "Mode",
        "description": "Edit operation mode",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "stitch",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_output_name",
        "type": "string",
        "label": "Output Name",
        "description": "Output file name",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "output.mp4",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_start",
        "type": "float",
        "label": "Start",
        "description": "Trim start time",
        "required": false,
        "multi": false,
        "pythonType": "float",
        "tsType": "number",
        "baseType": "float",
        "default": 0.0,
        "hidden_from_director": true,
        "portSchemaId": "float_float_float_single_primitive"
      },
      {
        "id": "in_end",
        "type": "float",
        "label": "End",
        "description": "Trim end time",
        "required": false,
        "multi": false,
        "pythonType": "float",
        "tsType": "number",
        "baseType": "float",
        "default": 0.0,
        "hidden_from_director": true,
        "portSchemaId": "float_float_float_single_primitive"
      },
      {
        "id": "in_volume",
        "type": "float",
        "label": "Volume",
        "description": "Audio volume",
        "required": false,
        "multi": false,
        "pythonType": "float",
        "tsType": "number",
        "baseType": "float",
        "default": 0.8,
        "hidden_from_director": true,
        "portSchemaId": "float_float_float_single_primitive"
      },
      {
        "id": "in_export_name",
        "type": "string",
        "label": "Export Name",
        "description": "Name chosen in the Export to Download confirm sheet for the new Video node. Transient transport \u2014 written by the frontend just before executeNode and consumed by the backend agent.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_video",
        "type": "video",
        "label": "Video",
        "description": "Edited video output",
        "required": false,
        "multi": false,
        "pythonType": "VideoAssetRefDict",
        "tsType": "VideoAssetRefDict",
        "baseType": "VideoAsset",
        "portSchemaId": "video_video_asset_ref_dict_video_asset_single_map"
      },
      {
        "id": "out_rendered_spec_hash",
        "type": "string",
        "label": "Rendered Edit Spec Hash",
        "description": "Versioned canonical fingerprint of the EditSpec that produced out_video.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_render_sources",
        "type": "ShotVideoRenderSourcesDict",
        "label": "Rendered Source Assets",
        "description": "Exact picked paths of upstream video and speech nodes used for the current render.",
        "required": false,
        "multi": false,
        "pythonType": "ShotVideoRenderSourcesDict",
        "tsType": "ShotVideoRenderSourcesDict",
        "baseType": "ShotVideoRenderSourcesDict",
        "hidden_from_director": true,
        "directorWritable": false,
        "portSchemaId": "shot_video_render_sources_dict_shot_video_render_sources_dict_shot_video_render_sources_dict_single_map"
      }
    ],
    "state": [
      {
        "id": "last_export_node_id",
        "type": "string",
        "label": "last_export_node_id",
        "description": "",
        "pythonType": "str",
        "tsType": "string"
      },
      {
        "id": "magnet_enabled",
        "type": "boolean",
        "label": "Main Track Magnet",
        "description": "When true (default), edits to track-0 video clips re-pack the track left-to-right with no gaps after commit.",
        "pythonType": "bool",
        "tsType": "boolean",
        "default": true
      },
      {
        "id": "edit_spec_compatibility_state",
        "type": "string",
        "label": "Edit Spec Compatibility State",
        "description": "Explicit source-of-truth and renderer-selection state. Field presence alone never selects a renderer.",
        "pythonType": "str",
        "tsType": "string",
        "default": "legacy_only"
      },
      {
        "id": "edit_spec_migration_error",
        "type": "string",
        "label": "Edit Spec Migration Error",
        "description": "Explicit migration failure detail; empty when no migration failure is active.",
        "pythonType": "str",
        "tsType": "string"
      }
    ],
    "executionActions": [
      "generate",
      "timeline_render",
      "vibe_render"
    ],
    "actionLabels": {
      "timeline_render": "Video editing",
      "vibe_render": "Render vibe edit"
    },
    "directorGuidance": "Add video/audio edges to in_reference_media in the desired order; their counts are independent. Load timeline-audio-editing for placement, trim, mute, duck, or source_path config. start_time/end_time trim within one source; start_offset places it on the output timeline. Never use cumulative output positions as start_time.",
    "projectStatusOnComplete": "completed"
  },
  "video_generator": {
    "type": "videoGenerator",
    "backendType": "video_generator",
    "label": "Video Generator",
    "category": "Agentic",
    "description": "Generate raw video clips from prompts, reference images, reference videos, and provider-supported audio references",
    "icon": "\ud83c\udfa5",
    "layout": {
      "16:9": {
        "width": 315,
        "height": 177
      },
      "9:16": {
        "width": 177,
        "height": 315
      },
      "3:4": {
        "width": 236,
        "height": 315
      },
      "4:3": {
        "width": 315,
        "height": 236
      },
      "1:1": {
        "width": 240,
        "height": 240
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_reference_media",
        "type": "image|video|audio",
        "label": "References",
        "description": "Ordered media references. Connect image, video or audio outputs here; toIndex preserves cross-media order. Provider-specific inputs are derived internally.",
        "required": false,
        "multi": true,
        "pythonType": "MediaAssetRefDict",
        "tsType": "MediaAssetRefDict",
        "baseType": "ImageAsset|VideoAsset|AudioAsset",
        "referenceMediaRoutes": {
          "ImageAsset": "in_images",
          "VideoAsset": "in_reference_videos",
          "AudioAsset": "in_reference_audios"
        },
        "portSchemaId": "image_video_audio_media_asset_ref_dict_image_asset_video_asset_audio_asset_multi_array"
      },
      {
        "id": "in_mode",
        "type": "string",
        "label": "Mode",
        "description": "Video generation mode",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "REFERENCE",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_scene_id",
        "type": "string",
        "label": "Scene ID",
        "description": "Scene identifier for organizing clips",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_clip_number",
        "type": "int",
        "label": "Clip #",
        "description": "Clip number within the scene",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_images",
        "type": "image",
        "label": "Reference",
        "description": "Reference/first-frame images for generation",
        "required": false,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "hidden_from_director": true,
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "in_reference_videos",
        "type": "video",
        "label": "Reference Videos",
        "description": "Original/reference videos for edit-style video generation",
        "required": false,
        "multi": true,
        "pythonType": "VideoAssetRefDict",
        "tsType": "VideoAssetRefDict",
        "baseType": "VideoAsset",
        "hidden_from_director": true,
        "portSchemaId": "video_video_asset_ref_dict_video_asset_multi_array"
      },
      {
        "id": "in_continuation_source",
        "type": "video",
        "label": "S7 Predecessor Video",
        "description": "The actual completed previous pack output. An exact-first successor extracts its final decoded frame; never use this as a weak R2V reference.",
        "required": false,
        "multi": false,
        "pythonType": "GeneratedVideoWithHistory",
        "tsType": "GeneratedVideoWithHistory",
        "baseType": "VideoAsset",
        "hidden_from_director": true,
        "portSchemaId": "video_generated_video_with_history_video_asset_single_map"
      },
      {
        "id": "in_shot_list_source_id",
        "type": "string",
        "label": "Shot List Source",
        "description": "Server-owned Shot List node ID for pack fingerprint checks before charging.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_shot_list_source_fingerprint",
        "type": "string",
        "label": "Shot List Fingerprint",
        "description": "Server-owned immutable fingerprint of shots, seams, and explicit anchors at packing.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_shot_list_request_fingerprint",
        "type": "string",
        "label": "Shot List Plan Fingerprint",
        "description": "Server-owned fingerprint of the model, motion intent, and selected source image revisions.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_reference_audios",
        "type": "audio",
        "label": "Reference Audio",
        "description": "Reference audio clips that CONDITION generation (voice/language/motion guidance), e.g. Seedance 2.0 audio references. Distinct from in_audio, which bakes an audio track into the finished clip. Only valid on a model that accepts audio references.",
        "required": false,
        "multi": true,
        "pythonType": "AudioAssetRefDict",
        "tsType": "AudioAssetRefDict",
        "baseType": "AudioAsset",
        "hidden_from_director": true,
        "portSchemaId": "audio_audio_asset_ref_dict_audio_asset_multi_array"
      },
      {
        "id": "in_audio",
        "type": "audio",
        "label": "Audio",
        "description": "Optional audio track to bake into the video",
        "required": false,
        "multi": false,
        "pythonType": "AudioAssetRefDict",
        "tsType": "AudioAssetRefDict",
        "baseType": "AudioAsset",
        "portSchemaId": "audio_audio_asset_ref_dict_audio_asset_single_map"
      },
      {
        "id": "in_motion_prompt",
        "type": "string",
        "label": "Motion Prompt",
        "description": "Describe the video action and motion",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_scene_context",
        "type": "string",
        "label": "Scene Context",
        "description": "Broader scene context for coherent generation",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_duration",
        "type": "float",
        "label": "Duration (s)",
        "description": "Video duration in seconds",
        "required": false,
        "multi": false,
        "pythonType": "float",
        "tsType": "number",
        "baseType": "float",
        "default": 5.0,
        "portSchemaId": "float_float_float_single_primitive"
      },
      {
        "id": "in_reference_video_edits",
        "type": "list[VideoReferenceEditDict]",
        "label": "Reference Video Edits",
        "description": "Trim windows for in_reference_videos. Use source_node_id or asset_path to match a video reference; asset identity remains edge-derived.",
        "required": false,
        "multi": false,
        "pythonType": "list[VideoReferenceEditDict]",
        "tsType": "Array<VideoReferenceEditDict>",
        "baseType": "list[VideoReferenceEditDict]",
        "default": [],
        "portSchemaId": "list_video_reference_edit_dict_list_video_reference_edit_dict_list_video_reference_edit_dict_single_array"
      },
      {
        "id": "in_dialogue_prompt",
        "type": "list[DialogueEntryDict]",
        "label": "Dialogue",
        "description": "Edge-derived structured per-line dialogue/voiceover for generated speech. Do not write this field directly; connect an upstream dialogue output or embed dialogue in in_motion_prompt.",
        "required": false,
        "multi": false,
        "pythonType": "list[DialogueEntryDict]",
        "tsType": "Array<DialogueEntryDict>",
        "baseType": "list[DialogueEntryDict]",
        "portSchemaId": "list_dialogue_entry_dict_list_dialogue_entry_dict_list_dialogue_entry_dict_single_array"
      },
      {
        "id": "in_model",
        "type": "string",
        "label": "Model",
        "description": "Video generation model. Call list_available_models to see available options including BYOM models, and use its explicit default_video_model when no model was requested.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "gemini-omni-1.1-flash-preview",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_aspect_ratio",
        "type": "string",
        "label": "Aspect Ratio",
        "description": "Video aspect ratio",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "16:9",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_resolution",
        "type": "string",
        "label": "Resolution",
        "description": "Video output resolution",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "1080p",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_generate_audio",
        "type": "boolean",
        "label": "Legacy Generate Audio",
        "description": "Deprecated legacy compatibility flag for Dreamwrite post-generation audio. Existing nodes that only set this flag keep their legacy remix behavior. Legacy nodes without in_provider_generate_audio still request provider/native audio by default. New nodes should set in_provider_generate_audio for provider-native audio. Dreamwrite post-processing belongs in downstream Video Editor flows.",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_provider_generate_audio",
        "type": "boolean",
        "label": "Provider Generate Audio",
        "description": "Ask the selected video provider/model to generate native audio when that provider supports the option. This does not control Dreamwrite post-generation audio processing.",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_use_voice_profile_audio_references",
        "type": "boolean",
        "label": "Use Voice Samples as Video References",
        "description": "Deprecated legacy compatibility flag. Voice profiles no longer silently provide provider reference audio. New flows connect linked Sound Expert out_audio to in_reference_audios explicitly when the selected model supports audio references.",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_audio_remix_mode",
        "type": "string",
        "label": "Dreamwrite Audio Mode",
        "description": "Deprecated legacy Dreamwrite post-generation audio mode. Kept for old projects until audio post-processing fully moves to Video Editor nodes.",
        "required": false,
        "multi": false,
        "pythonType": "AudioRemixMode",
        "tsType": "\"off\" | \"voiceover_only\" | \"full_remix\"",
        "baseType": "AudioRemixMode",
        "hidden_from_director": true,
        "portSchemaId": "string_audio_remix_mode_audio_remix_mode_single_primitive"
      },
      {
        "id": "in_allow_bgm",
        "type": "boolean",
        "label": "Allow BGM",
        "description": "When enabled, the video model may generate background music and ambient sounds. When disabled (default), only SFX and specified dialogue audio are included.",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_tts_provider",
        "type": "string",
        "label": "Speech Provider",
        "description": "Deprecated legacy speech provider setting for Dreamwrite-generated dialogue, narration, and voiceover audio on Video Generator nodes. New Dreamwrite post-processing speech should be represented by Sound Expert audio and mixed downstream.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "gemini",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_dub_target_language",
        "type": "string",
        "label": "Dub Language",
        "description": "Retired legacy dub target language. Kept hidden so old project data can still load. New dubbing work should use Sound Expert and Video Editor flows.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_voice_profiles",
        "type": "VoiceProfileDict",
        "label": "Voice Profiles",
        "description": "Voice profiles from connected Character Designers, Sound Expert voice nodes, or Script Writer narrators. They identify speakers for generated speech and provide voice metadata/descriptions. Provider audio conditioning uses explicit audio edges to in_reference_media; do not infer provider audio references from voice_profile.audio_sample. Profile name should match a character label or narrator voice_role_id.",
        "required": false,
        "multi": true,
        "pythonType": "VoiceProfileDict",
        "tsType": "VoiceProfileDict",
        "baseType": "VoiceProfileDict",
        "portSchemaId": "voice_profile_dict_voice_profile_dict_voice_profile_dict_multi_array"
      },
      {
        "id": "in_voice_settings",
        "type": "VoiceSettingsDict",
        "label": "Voice Settings",
        "description": "TTS voice tuning parameters (stability, similarity_boost, style, speed)",
        "required": false,
        "multi": false,
        "pythonType": "VoiceSettingsDict",
        "tsType": "VoiceSettingsDict",
        "baseType": "VoiceSettingsDict",
        "portSchemaId": "voice_settings_dict_voice_settings_dict_voice_settings_dict_single_map"
      },
      {
        "id": "in_name",
        "type": "string",
        "label": "Name",
        "description": "Optional label for the video node",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_resolved_voice_map",
        "type": "ResolvedVoiceMapDict",
        "label": "Resolved Voice Map",
        "description": "Character name to resolved voice display name mapping for generated speech",
        "required": false,
        "multi": false,
        "pythonType": "ResolvedVoiceMapDict",
        "tsType": "ResolvedVoiceMapDict",
        "baseType": "ResolvedVoiceMapDict",
        "default": {},
        "hidden_from_director": true,
        "portSchemaId": "resolved_voice_map_dict_resolved_voice_map_dict_resolved_voice_map_dict_single_map"
      },
      {
        "id": "in_audio_remix_config",
        "type": "AudioRemixConfigDict",
        "label": "Legacy Audio Edit Config",
        "description": "Retired legacy audio editor state for saved dialogue and narrator tracks. Kept hidden so old project data can still load. Current audio edits use Sound Expert and Video Editor.",
        "required": false,
        "multi": false,
        "pythonType": "AudioRemixConfigDict",
        "tsType": "AudioRemixConfigDict",
        "baseType": "AudioRemixConfigDict",
        "hidden_from_director": true,
        "portSchemaId": "audio_remix_config_dict_audio_remix_config_dict_audio_remix_config_dict_single_map"
      },
      {
        "id": "in_speech_transformer_config",
        "type": "SpeechTransformerConfigDict",
        "label": "Retired Speech Edit Config",
        "description": "Retired speech-edit state. Kept hidden so old project data can still load. Current voice changes use Sound Expert and Video Editor.",
        "required": false,
        "multi": false,
        "pythonType": "SpeechTransformerConfigDict",
        "tsType": "SpeechTransformerConfigDict",
        "baseType": "SpeechTransformerConfigDict",
        "hidden_from_director": true,
        "portSchemaId": "speech_transformer_config_dict_speech_transformer_config_dict_speech_transformer_config_dict_single_map"
      },
      {
        "id": "in_audio_take_selections",
        "type": "AudioTakeSelectionMapDict",
        "label": "Audio Take Selections",
        "description": "Variant-scoped selected audio take per clip. Stored as a flat map keyed by `v1:` plus compact JSON for `[variant_path, clip_id]`; each value repeats that identity and stores the exact selected label/path. New nodes initialize an empty shared map; legacy nodes may omit it.",
        "required": false,
        "multi": false,
        "pythonType": "AudioTakeSelectionMapDict",
        "tsType": "AudioTakeSelectionMapDict",
        "baseType": "AudioTakeSelectionMapDict",
        "default": {},
        "hidden_from_director": true,
        "ydocCreationRoot": true,
        "portSchemaId": "audio_take_selection_map_dict_audio_take_selection_map_dict_audio_take_selection_map_dict_single_map"
      },
      {
        "id": "in_audio_variant_workspaces",
        "type": "AudioVariantWorkspaceMapDict",
        "label": "Audio Variant Workspaces",
        "description": "Retired variant-scoped audio authoring state. Kept hidden so old project data can still load.",
        "required": false,
        "multi": false,
        "pythonType": "AudioVariantWorkspaceMapDict",
        "tsType": "AudioVariantWorkspaceMapDict",
        "baseType": "AudioVariantWorkspaceMapDict",
        "hidden_from_director": true,
        "portSchemaId": "audio_variant_workspace_map_dict_audio_variant_workspace_map_dict_audio_variant_workspace_map_dict_single_map"
      },
      {
        "id": "in_unified_audio_config",
        "type": "UnifiedAudioProjectDict",
        "label": "Unified Audio Config",
        "description": "Retired audio authoring state. Kept hidden so old project data can still load. Current audio edits use the Video Editor timeline and Sound Expert audio nodes.",
        "required": false,
        "multi": false,
        "pythonType": "UnifiedAudioProjectDict",
        "tsType": "UnifiedAudioProjectDict",
        "baseType": "UnifiedAudioProjectDict",
        "hidden_from_director": true,
        "portSchemaId": "unified_audio_project_dict_unified_audio_project_dict_unified_audio_project_dict_single_map"
      },
      {
        "id": "in_style",
        "type": "string",
        "label": "Art Style",
        "description": "Visual style library ID. Empty inherits project style; NO_STYLE disables library guidance. Reference images preserve subject and composition while style guides motion and overall look.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      }
    ],
    "outputs": [
      {
        "id": "out_video",
        "type": "video",
        "label": "Video",
        "description": "Generated video clip with metadata",
        "required": false,
        "multi": false,
        "pythonType": "GeneratedVideoWithHistory",
        "tsType": "GeneratedVideoWithHistory",
        "baseType": "VideoAsset",
        "portSchemaId": "video_generated_video_with_history_video_asset_single_map"
      },
      {
        "id": "out_tts_segments",
        "type": "list[TtsSegmentDict]",
        "label": "Generated Speech Segments",
        "description": "Retired legacy Video Generator speech output. Current Dreamwrite-owned speech is generated by Sound Expert and mixed in Video Editor.",
        "required": false,
        "multi": false,
        "pythonType": "list[TtsSegmentDict]",
        "tsType": "Array<TtsSegmentDict>",
        "baseType": "list[TtsSegmentDict]",
        "hidden_from_director": true,
        "portSchemaId": "list_tts_segment_dict_list_tts_segment_dict_list_tts_segment_dict_single_array"
      },
      {
        "id": "out_audio_remix_baseline",
        "type": "AudioRemixConfigDict",
        "label": "Audio Edit Baseline",
        "description": "Retired legacy audio-edit baseline. Kept hidden so old project data can still load.",
        "required": false,
        "multi": false,
        "pythonType": "AudioRemixConfigDict",
        "tsType": "AudioRemixConfigDict",
        "baseType": "AudioRemixConfigDict",
        "hidden_from_director": true,
        "portSchemaId": "audio_remix_config_dict_audio_remix_config_dict_audio_remix_config_dict_single_map"
      },
      {
        "id": "out_speech_transformer_spans",
        "type": "SpeechTransformerDetectionDict",
        "label": "Retired Speech Edit Spans",
        "description": "Retired speech-edit detection output. Kept hidden so old project data can still load.",
        "required": false,
        "multi": false,
        "pythonType": "SpeechTransformerDetectionDict",
        "tsType": "SpeechTransformerDetectionDict",
        "baseType": "SpeechTransformerDetectionDict",
        "hidden_from_director": true,
        "portSchemaId": "speech_transformer_detection_dict_speech_transformer_detection_dict_speech_transformer_detection_dict_single_map"
      },
      {
        "id": "out_auto_dialogue",
        "type": "list[DialogueEntryDict]",
        "label": "Auto Dialogue",
        "description": "Dialogue entries auto-extracted from the motion prompt when no explicit in_dialogue_prompt is connected",
        "required": false,
        "multi": false,
        "pythonType": "list[DialogueEntryDict]",
        "tsType": "Array<DialogueEntryDict>",
        "baseType": "list[DialogueEntryDict]",
        "hidden_from_director": true,
        "portSchemaId": "list_dialogue_entry_dict_list_dialogue_entry_dict_list_dialogue_entry_dict_single_array"
      },
      {
        "id": "out_speech_windows",
        "type": "list[SpeechWindowDict]",
        "label": "Speech Windows",
        "description": "Retired legacy speech-window output. Kept hidden so old project data can still load.",
        "required": false,
        "multi": false,
        "pythonType": "list[SpeechWindowDict]",
        "tsType": "Array<SpeechWindowDict>",
        "baseType": "list[SpeechWindowDict]",
        "hidden_from_director": true,
        "portSchemaId": "list_speech_window_dict_list_speech_window_dict_list_speech_window_dict_single_array"
      },
      {
        "id": "out_native_speech_takes",
        "type": "list[NativeSpeechTakeDict]",
        "label": "Native Speech Takes",
        "description": "Deprecated legacy native speech take ledger. Kept hidden so old project data can still load.",
        "required": false,
        "multi": false,
        "pythonType": "list[NativeSpeechTakeDict]",
        "tsType": "Array<NativeSpeechTakeDict>",
        "baseType": "list[NativeSpeechTakeDict]",
        "hidden_from_director": true,
        "portSchemaId": "list_native_speech_take_dict_list_native_speech_take_dict_list_native_speech_take_dict_single_array"
      },
      {
        "id": "out_native_speech_spans",
        "type": "list[NativeSpeechSpanDict]",
        "label": "Native Speech Spans",
        "description": "RFC-1122 Phase 3: audio-first ASR detection result \u2014 per-line spans (transcript + timing) for a native/vocals lane, source-anchored. The derive splits the whole-track native clip into per-span clips (each independently re-voiceable). Phase 4: make per-variant.",
        "required": false,
        "multi": false,
        "pythonType": "list[NativeSpeechSpanDict]",
        "tsType": "Array<NativeSpeechSpanDict>",
        "baseType": "list[NativeSpeechSpanDict]",
        "hidden_from_director": true,
        "portSchemaId": "list_native_speech_span_dict_list_native_speech_span_dict_list_native_speech_span_dict_single_array"
      },
      {
        "id": "out_native_speech_detect_seq",
        "type": "int",
        "label": "Native Speech Detect Sequence",
        "description": "RFC-1122 Phase 3 (Codex impl r17 P1): a monotonic counter incremented on every SUCCESSFUL audio-first detect run. It is the FE's 'a re-detect completed' signal \u2014 robust even when the detector returns byte-identical spans (unchanged out_native_speech_spans), so the console can clear the re-detected lane's stale per-clip config/tombstones so its clips repopulate. Not per-variant (a run counter).",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "default": 0,
        "hidden_from_director": true,
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "out_video_prompt",
        "type": "string",
        "label": "Video Prompt",
        "description": "The timed prompt sent to Veo",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "out_video_duration",
        "type": "float",
        "label": "Video Duration",
        "description": "Video duration in seconds",
        "required": false,
        "multi": false,
        "pythonType": "float",
        "tsType": "number",
        "baseType": "float",
        "hidden_from_director": true,
        "portSchemaId": "float_float_float_single_primitive"
      },
      {
        "id": "out_dialogue",
        "type": "list[ReconciledDialogueEntryDict]",
        "label": "Dialogue Output",
        "description": "Reconciled dialogue data for generated speech, including optional narrator voice_role_id",
        "required": false,
        "multi": false,
        "pythonType": "list[ReconciledDialogueEntryDict]",
        "tsType": "Array<ReconciledDialogueEntryDict>",
        "baseType": "list[ReconciledDialogueEntryDict]",
        "hidden_from_director": true,
        "portSchemaId": "list_reconciled_dialogue_entry_dict_list_reconciled_dialogue_entry_dict_list_reconciled_dialogue_entry_dict_single_array"
      }
    ],
    "state": [
      {
        "id": "voice_acting_status",
        "type": "string",
        "label": "voice_acting_status",
        "description": "",
        "pythonType": "str",
        "tsType": "string"
      },
      {
        "id": "full_remix_status",
        "type": "video",
        "label": "full_remix_status",
        "description": "Retired audio operation status. Kept so old project state can still load.",
        "pythonType": "VideoFullRemixStatusV1Dict",
        "tsType": "VideoFullRemixStatusV1Dict"
      },
      {
        "id": "segment_index",
        "type": "int",
        "label": "segment_index",
        "description": "",
        "pythonType": "int",
        "tsType": "number"
      },
      {
        "id": "batch_pending",
        "type": "int",
        "label": "batch_pending",
        "description": "",
        "pythonType": "int",
        "tsType": "number"
      },
      {
        "id": "thumbnail",
        "type": "string",
        "label": "thumbnail",
        "description": "Legacy: video thumbnail path. TODO: Remove after full canvas-v2 migration",
        "pythonType": "str",
        "tsType": "string"
      },
      {
        "id": "action",
        "type": "string",
        "label": "action",
        "description": "Current execution action for compatibility with older node runs.",
        "pythonType": "str",
        "tsType": "string"
      },
      {
        "id": "closing_frame_handshake",
        "type": "int",
        "label": "closing_frame_handshake",
        "description": "Sent by consoles that understand Closing frame (LAST_FRAME) on every Closing-frame run, so an API that predates this field rejects the run instead of treating the image as an opening frame (RFC-1668). Its value has no other effect.",
        "pythonType": "int",
        "tsType": "number"
      },
      {
        "id": "clip_id",
        "type": "string",
        "label": "clip_id",
        "description": "Retired audio target clip id. Kept hidden so old project data can still load.",
        "pythonType": "str",
        "tsType": "string"
      },
      {
        "id": "target_voice_id",
        "type": "string",
        "label": "target_voice_id",
        "description": "Retired speech-edit target voice id. Kept hidden so old project data can still load.",
        "pythonType": "str",
        "tsType": "string"
      },
      {
        "id": "target_variant_path",
        "type": "string",
        "label": "target_variant_path",
        "description": "Retired audio target variant path. Kept hidden so old project data can still load.",
        "pythonType": "str",
        "tsType": "string"
      },
      {
        "id": "name_autogen",
        "type": "string",
        "label": "Auto-generated Name Marker",
        "description": "Marker token identifying which auto-generated default-name family this node's display name came from (see agentic_workflow.core.default_node_names). Absent on user-created and pre-marker nodes. The console localizes the name only while the stored value still equals the canonical English rendering, so a rename automatically wins.",
        "pythonType": "str",
        "tsType": "string"
      }
    ],
    "pricing": {
      "default": {
        "category": "video_models",
        "model": "gemini-omni-1.1-flash-preview",
        "priceType": "per_second"
      },
      "actions": {
        "run_speech_to_text": null,
        "reformat_motion_prompt": null
      }
    },
    "executionActions": [
      "generate",
      "run_speech_to_text",
      "reformat_motion_prompt"
    ],
    "actionLabels": {
      "run_speech_to_text": "Transcription",
      "reformat_motion_prompt": "Prompt cleanup"
    },
    "directorGuidance": "Add reference edges to in_reference_media in the desired order. Preserve curated storyboard/screenplay edges. Do not write edge-derived dialogue in config. Video/audio references are model-gated; never infer audio references from voice profiles. Video Generator owns provider video and native audio. Use Sound Expert for generated or selected audio assets; use Video Editor for timing, trim, volume, mute, isolation, voice changes, and mixes.",
    "projectStatusOnComplete": "in_progress",
    "footerHeight": 80
  },
  "webtoon_group": {
    "type": "webtoonGroup",
    "backendType": "webtoon_group",
    "label": "Webtoon Group",
    "category": "Agentic",
    "description": "Collapsible group container for webtoon panels arranged vertically",
    "icon": "\ud83d\udcda",
    "layout": {
      "*": {
        "width": 355,
        "height": 4000
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_scene_id",
        "type": "string",
        "label": "Scene ID",
        "description": "Scene identifier (e.g., ch1_s2)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_label",
        "type": "string",
        "label": "Label",
        "description": "Display label (e.g., Chapter 1, Scene 2)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_collapsed",
        "type": "boolean",
        "label": "Collapsed",
        "description": "Whether the group is collapsed (internal, managed by UI toggle)",
        "required": false,
        "multi": false,
        "pythonType": "bool",
        "tsType": "boolean",
        "baseType": "bool",
        "default": false,
        "hidden_from_director": true,
        "portSchemaId": "boolean_bool_bool_single_primitive"
      },
      {
        "id": "in_child_node_ids",
        "type": "string",
        "label": "Child Node IDs",
        "description": "IDs of child panel nodes",
        "required": false,
        "multi": false,
        "pythonType": "list[str]",
        "tsType": "Array<string>",
        "baseType": "list[str]",
        "default": [],
        "hidden_from_director": true,
        "portSchemaId": "string_list_str_list_str_single_array"
      }
    ],
    "outputs": [],
    "state": []
  },
  "webtoon_panel_generator": {
    "type": "webtoonPanelGenerator",
    "backendType": "webtoon_panel_generator",
    "label": "Webtoon Page",
    "category": "Agentic",
    "description": "Generate a webtoon page with multiple sub-panels and text bubbles",
    "icon": "\ud83d\udcd6",
    "layout": {
      "9:16": {
        "width": 315,
        "height": 560
      },
      "3:4": {
        "width": 315,
        "height": 420
      },
      "1:1": {
        "width": 320,
        "height": 320
      },
      "16:9": {
        "width": 420,
        "height": 236
      }
    },
    "canvasHidden": false,
    "inputs": [
      {
        "id": "in_images",
        "type": "image",
        "label": "Reference",
        "description": "Storyboard panel thumbnails + character/location reference images",
        "required": true,
        "multi": true,
        "pythonType": "ImageAssetRefDict",
        "tsType": "ImageAssetRefDict",
        "baseType": "ImageAsset",
        "portSchemaId": "image_image_asset_ref_dict_image_asset_multi_array"
      },
      {
        "id": "in_prompt",
        "type": "string",
        "label": "Prompt",
        "description": "Combined visual description for the page (fallback if beats not provided)",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_beats",
        "type": "string",
        "label": "Beats",
        "description": "List of beat descriptions for sub-panels on this page",
        "required": false,
        "multi": true,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": [],
        "portSchemaId": "string_str_str_multi_array"
      },
      {
        "id": "in_dialogue",
        "type": "WebtoonDialogueDict",
        "label": "Dialogue",
        "description": "Structured dialogue entries for text bubble overlay",
        "required": false,
        "multi": true,
        "pythonType": "WebtoonDialogueDict",
        "tsType": "WebtoonDialogueDict",
        "baseType": "WebtoonDialogueDict",
        "default": [],
        "portSchemaId": "webtoon_dialogue_dict_webtoon_dialogue_dict_webtoon_dialogue_dict_multi_array"
      },
      {
        "id": "in_panel_index",
        "type": "int",
        "label": "Page Index",
        "description": "Page position in the scene (0-based)",
        "required": false,
        "multi": false,
        "pythonType": "int",
        "tsType": "number",
        "baseType": "int",
        "default": 0,
        "portSchemaId": "int_int_int_single_primitive"
      },
      {
        "id": "in_aspect_ratio",
        "type": "string",
        "label": "Aspect Ratio",
        "description": "Page aspect ratio",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "9:16",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_layout",
        "type": "string",
        "label": "Layout",
        "description": "Panel layout type for page composition",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "standard_box",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_style",
        "type": "string",
        "label": "Art Style",
        "description": "Visual art style",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "default": "",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_name",
        "type": "string",
        "label": "Name",
        "description": "Page name",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "hidden_from_director": true,
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_feedback",
        "type": "string",
        "label": "Feedback",
        "description": "Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance.",
        "required": false,
        "multi": false,
        "pythonType": "str",
        "tsType": "string",
        "baseType": "str",
        "portSchemaId": "string_str_str_single_primitive"
      },
      {
        "id": "in_feedback_history",
        "type": "list[FeedbackHistoryEntryDict]",
        "label": "Feedback History",
        "description": "Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries.",
        "required": false,
        "multi": false,
        "pythonType": "list[FeedbackHistoryEntryDict]",
        "tsType": "Array<FeedbackHistoryEntryDict>",
        "baseType": "list[FeedbackHistoryEntryDict]",
        "default": [],
        "hidden_from_director": true,
        "portSchemaId": "list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array"
      }
    ],
    "outputs": [
      {
        "id": "out_image",
        "type": "image",
        "label": "Page Image",
        "description": "Webtoon page with sub-panels and text bubbles",
        "required": false,
        "multi": false,
        "pythonType": "GeneratedImageWithHistory",
        "tsType": "GeneratedImageWithHistory",
        "baseType": "ImageAsset",
        "portSchemaId": "image_generated_image_with_history_image_asset_single_map"
      }
    ],
    "state": [
      {
        "id": "bubbles",
        "type": "BubbleDict",
        "label": "bubbles",
        "description": "",
        "pythonType": "list[BubbleDict]",
        "tsType": "Array<BubbleDict>"
      },
      {
        "id": "batch_pending",
        "type": "int",
        "label": "batch_pending",
        "description": "",
        "pythonType": "int",
        "tsType": "number"
      }
    ],
    "pricing": {
      "category": "image_models",
      "model": "gemini-2.5-flash-image",
      "priceType": "per_image"
    },
    "projectStatusOnComplete": "in_progress"
  }
}

/** Upload a local audio file */
export interface AudioNodeData {
  /**  */
  in_file_name?: string
  /** Character voice profile used to mark this uploaded audio as the Character voice source. */
  in_voice_profile?: VoiceProfileDictYMap
  /** The uploaded audio */
  out_audio?: AudioAssetRefDictYMap
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** Design a character with visual sheet and provider-neutral voice brief */
export interface CharacterDesignerNodeData {
  /** Default target port for incoming edges when no port is specified by the proposer (see _DEFAULT_TARGET_PORT in backend_graph.py). Wire upstream context (director or workflow node output) here when no specialized port applies. */
  in_upstream?: UpstreamContextDictYMap
  /** Optional reference image to guide the visual design */
  in_images?: Array<ImageAssetRefDictYMap | null>
  /** Name of the character being designed */
  in_name?: string
  /** Character role (e.g. protagonist, supporting, antagonist) */
  in_role?: string
  /** Visual art style for the character sheet */
  in_style?: string
  /** Describe appearance, personality, voice... */
  in_description?: string
  /** Image generation model */
  in_model?: string
  /** Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance. */
  in_feedback?: string
  /** Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries. */
  in_feedback_history?: Array<FeedbackHistoryEntryDictYMap>
  /** Per-word pronunciation overrides for this character's name and terms. One rule per line: 'word → pronunciation' (alias) or 'word → /IPA/' (phoneme). Example: L'Ora → LOH-rah. Automatically applied to all downstream speech generation using this character's voice. */
  in_pronunciation_guide?: string
  /** Predefined background color key for the node card */
  in_bg_color?: string
  /** Run Gemini VLM quality validation after generation */
  in_vlm_validation?: boolean
  /** Character name (mirrors in_name for downstream label edges) */
  readonly out_name?: string
  /** Generated multi-view character reference sheet */
  out_image?: CharacterAssetYMap
  /** Provider-neutral voice brief used to identify this character's speaker role. The linked Sound Expert node owns selected provider voice fields and sample audio. */
  out_voice_profile?: VoiceProfileDictYMap
  /** VLM quality validation report from the most recent generation */
  out_vlm_report?: VlmValidationReportDictYMap
  /**  */
  batch_pending?: number
  /** Transient per-run path to a baked annotation of the current picked image. Written by the Refine tab as a `state_updates` argument on execute-node, consumed once as the edit target, then cleared. Never authored by the Director and never persisted as durable node data. */
  annotated_image_path?: string
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** Debug node that hangs forever for testing */
export interface DebugHangNodeData {
  /** Debug label */
  in_label?: string
  /** Debug result */
  out_result?: string
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** Orchestrate workflow and chat with the AI director */
export interface DirectorNodeData {
  /** Optional context for the conversation */
  in_context?: string
  /** Director response text */
  out_response?: string
  /** Crew configuration for sub-agents */
  out_crew?: DirectorCrewDictYMap
  /**  */
  pending_tool_state?: DirectorPendingToolStateDictYMap
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** Panel image with generation history */
export interface GeneratedImageWithHistoryNodeData {
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** Upload a local image file */
export interface ImageNodeData {
  /**  */
  in_file_name?: string
  /** Provenance link to the image this one was derived from — set by the annotation bake so the canvas can draw a derivation edge from the source node. Inert: nothing reads this value, and Image Upload nodes never populate it. */
  in_image?: ImageAssetRefDictYMap
  /** The uploaded image */
  out_image?: ImageAssetRefDictYMap
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** Generate images from text prompts */
export interface ImageGeneratorNodeData {
  /** Optional reference image to guide the generation */
  in_images?: Array<ImageAssetRefDictYMap | null>
  /** Default target port for incoming edges when no port is specified by the proposer (see _DEFAULT_TARGET_PORT in backend_graph.py). Wire upstream context (director or workflow node output) here when no specialized port applies. */
  in_upstream?: UpstreamContextDictYMap
  /** Optional label for the generator node */
  in_name?: string
  /** Text description of the image to generate */
  in_prompt?: string
  /** Aspect ratio for the generated image */
  in_aspect_ratio?: AspectRatio
  /** Visual art style for the generated image */
  in_style?: string
  /** Output resolution quality */
  in_quality?: string
  /** Image generation model */
  in_model?: string
  /** Designer node IDs for self-wiring reference edges */
  in_panel_refs?: Array<string>
  /** When True, store in_image directly (passthrough mode) */
  in_update?: boolean
  /** Incoming panel image from storyboard */
  in_image?: ImageAssetRefDictYMap
  /** Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance. */
  in_feedback?: string
  /** Video file path (RelativePath) from upstream video generator */
  in_video?: string
  /** Typed video input used for an exact S7 last-decoded-frame extraction. */
  in_source_video?: GeneratedVideoWithHistoryYMap
  /** Exact planned predecessor clip length, checked against the decoded video stream before S7 handoff. */
  in_expected_video_duration_ms?: number
  /** Which frame to extract: first, last, integer string (0-indexed), or time:<seconds> for the Canvas playhead */
  in_frame?: string
  /** When true, skip image generation and extract frame from in_video */
  in_get_frame?: boolean
  /** Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries. */
  in_feedback_history?: Array<FeedbackHistoryEntryDictYMap>
  /** Run Gemini VLM quality validation after generation */
  in_vlm_validation?: boolean
  /** The generated image */
  out_image?: GeneratedImageWithHistoryYMap
  /** VLM quality validation report from the most recent generation */
  out_vlm_report?: VlmValidationReportDictYMap
  /**  */
  batch_pending?: number
  /** Transient per-run path to a baked annotation of the current picked image. Written by the Refine tab as a `state_updates` argument on execute-node, consumed once as the edit target, then cleared. Never authored by the Director and never persisted as durable node data. */
  annotated_image_path?: string
  /** Marker token identifying which auto-generated default-name family this node's display name came from (see agentic_workflow.core.default_node_names). Absent on user-created and pre-marker nodes. The console localizes the name only while the stored value still equals the canonical English rendering, so a rename automatically wins. */
  name_autogen?: string
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** Design a location/background with reference image */
export interface LocationDesignerNodeData {
  /** Optional reference image to guide the visual design */
  in_images?: Array<ImageAssetRefDictYMap | null>
  /** Name of the location being designed */
  in_name?: string
  /** Visual art style for the location */
  in_style?: string
  /** Time of day for the scene */
  in_time_of_day?: string
  /** Weather condition for the scene */
  in_weather?: string
  /** Describe the location, atmosphere, key elements... */
  in_description?: string
  /** Image generation model */
  in_model?: string
  /** Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance. */
  in_feedback?: string
  /** Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries. */
  in_feedback_history?: Array<FeedbackHistoryEntryDictYMap>
  /** Predefined background color key for the node card */
  in_bg_color?: string
  /** Run Gemini VLM quality validation after generation */
  in_vlm_validation?: boolean
  /** Generate a 360 panorama source for this location instead of a standard flat location image */
  in_720_enabled?: boolean
  /** Current 360 viewer camera state in degrees */
  in_720_view?: LocationPanoramaViewDictYMap
  /** Location name (mirrors in_name for downstream label edges) */
  readonly out_name?: string
  /** Generated location reference image */
  out_image?: LocationAssetYMap
  /** Location metadata including name, style, time, and weather */
  out_metadata?: LocationMetadataDictYMap
  /** VLM quality validation report from the most recent generation */
  out_vlm_report?: VlmValidationReportDictYMap
  /**  */
  batch_pending?: number
  /** Transient per-run path to a baked annotation of the current picked image. Written by the Refine tab as a `state_updates` argument on execute-node, consumed once as the edit target, then cleared. Never authored by the Director and never persisted as durable node data. */
  annotated_image_path?: string
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** Visual group container for organizing nodes */
export interface NodeGroupNodeData {
  /** Display label for the group */
  in_label?: string
  /** IDs of child nodes contained in this group. Null entries represent empty gap slots left by drag-out; use Rearrange to compact. */
  in_child_node_ids?: Array<string | null>
  /** Child arrangement mode: horizontal (single row), vertical (single column), or auto (grid) */
  in_layout_mode?: string
  /** Whether this visual group is shown in its compact collapsed state */
  in_collapsed?: boolean
  /** Whether this workflow-owned visual group exposes collapse and expand controls */
  in_collapsible?: boolean
  /** Predefined background color key for the group container */
  in_bg_color?: string
  /** Marker token identifying which auto-generated default-name family this node's display label came from (see agentic_workflow.core.default_node_names). Absent on user-created and pre-marker nodes. The console localizes the label only while the stored value still equals the canonical English rendering, so a rename automatically wins. */
  name_autogen?: string
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** Design an object/artifact with reference image */
export interface ObjectDesignerNodeData {
  /** Optional reference image to guide the visual design */
  in_images?: Array<ImageAssetRefDictYMap | null>
  /** Name of the object being designed */
  in_name?: string
  /** Visual art style for the object */
  in_style?: string
  /** Describe the object appearance, material, details... */
  in_description?: string
  /** Image generation model */
  in_model?: string
  /** Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance. */
  in_feedback?: string
  /** Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries. */
  in_feedback_history?: Array<FeedbackHistoryEntryDictYMap>
  /** Run Gemini VLM quality validation after generation */
  in_vlm_validation?: boolean
  /** Object name (mirrors in_name for downstream label edges) */
  readonly out_name?: string
  /** Generated object reference image */
  out_image?: ObjectAssetYMap
  /** Object metadata */
  out_metadata?: ObjectMetadataDictYMap
  /** VLM quality validation report from the most recent generation */
  out_vlm_report?: VlmValidationReportDictYMap
  /**  */
  batch_pending?: number
  /** Transient per-run path to a baked annotation of the current picked image. Written by the Refine tab as a `state_updates` argument on execute-node, consumed once as the edit target, then cleared. Never authored by the Director and never persisted as durable node data. */
  annotated_image_path?: string
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** Load panel action, dialogue, and metadata */
export interface PanelSourceNodeData {
  /** The existing panel image */
  out_image?: ImageAssetRefDictYMap
  /** The action/script description */
  out_action?: string
  /** IDs of characters appearing in this panel */
  out_character_ids?: Array<string>
  /** Character expressions, poses, positions */
  out_appearances?: Array<AppearanceDictYMap>
  /** Dialogue lines in this panel */
  out_dialogue?: Array<PanelDialogueDictYMap>
  /** Dialogue formatted as TTS script */
  out_script?: string
  /** Shot type, angle, and focus settings */
  out_composition?: CompositionDictYMap
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** Enter your story prompt for generation */
export interface PromptInputNodeData {
  /** The story prompt text */
  out_prompt?: string
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** Interactive conversational story writer */
export interface ScriptWriterNodeData {
  /** Story prompt or instructions */
  in_prompt?: string
  /** Selected model variant: gemini or claude. Legacy gpt values are ignored while Script Plus is unavailable. */
  in_active_model?: string
  /** Id of the out_script_variants entry the node currently displays. Empty means the newest variant for the active model. */
  in_active_variant_id?: string
  /** Project or scene name */
  in_name?: string
  /** Director's creative guidance composed from user Q&A — tone, structure, pacing, and other creative direction */
  in_director_instruction?: string
  /** When true, the Script Writer only reformats the user prompt into screenplay structure without adding, modifying, or removing storyline content */
  in_format_only?: boolean
  /** Enable Gemini model for screenplay generation */
  in_gemini?: boolean
  /** Enable Claude model for screenplay generation */
  in_claude?: boolean
  /** Legacy GPT model toggle retained for persisted project compatibility. Ignored while Script Plus is unavailable. */
  in_gpt?: boolean
  /** Character names */
  in_characters?: Array<string | null>
  /** Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance. */
  in_feedback?: string
  /** Optional target total duration in seconds; used to compute suggested scene count. Director should set this from the user's duration choice (30s=30, about 1min=60, about 2min=120, about 5min=300, or a custom value). */
  in_target_duration_s?: number
  /** Script review feedback history */
  in_review_history?: Array<ReviewHistoryEntryDictYMap>
  /** Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior screenplay + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries. */
  in_feedback_history?: Array<FeedbackHistoryEntryDictYMap>
  /** Predefined background color key for the node card */
  in_bg_color?: string
  /** Generated script content */
  out_script?: string
  /** Path to saved script file */
  out_script_path?: string
  /** Structured screenplay (array of scene objects with typed entries) */
  out_screenplay?: Array<ScriptScreenplaySceneDictYMap>
  /** Extracted dialogue entries with character, emotion, and text */
  out_dialogue?: Array<ScriptDialogueDictYMap>
  /** Reusable narrator, system, and internal-monologue voice roles referenced by screenplay entries */
  out_voice_roles?: Array<VoiceRoleDictYMap>
  /** Provider-neutral narrator, system, title-card, and internal-monologue voice briefs. Profile name matches voice_role_id. Linked Sound Expert nodes choose and store concrete provider voices. */
  out_voice_profiles?: Array<VoiceProfileDictYMap>
  /** Extracted action/staging direction entries per scene */
  out_action_lines?: Array<SceneTextDictYMap>
  /** Deduplicated list of character names appearing in the screenplay */
  out_characters?: Array<string>
  /** Music mood/genre cue entries per scene */
  out_music_cues?: Array<SceneTextDictYMap>
  /** Sound effect entries per scene */
  out_sfx?: Array<SceneTextDictYMap>
  /** Raw ScreenplayResult JSON from Gemini */
  out_gemini?: ScreenplayResultDictYMap
  /** Raw ScreenplayResult JSON from Claude Opus 4 */
  out_claude?: ScreenplayResultDictYMap
  /** Legacy GPT-4o ScreenplayResult JSON retained for persisted project compatibility. */
  out_gpt?: ScreenplayResultDictYMap
  /** Extracted location names from screenplay */
  out_locations?: Array<string>
  /** Which model variant was selected (gemini or claude) */
  out_active_model?: string
  /** Number of scenes in the generated screenplay */
  out_scene_count?: number
  /** One-sentence logline for the active model's screenplay */
  out_logline?: string
  /** Genre and tonal register of the active model's screenplay */
  out_genre_tone?: string
  /** Short prose synopsis of the active model's screenplay */
  out_synopsis?: string
  /** Central themes of the active model's screenplay */
  out_themes?: string
  /** Screenplay iteration history, oldest first. One entry per model per successful run; the node's Variants panel lists these newest-first and marks the active one as the master script. Capped at the most recent 20 entries. */
  out_script_variants?: Array<ScriptVariantDictYMap>
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** Group node for short video production with storyboard grid and horizontal panel layout */
export interface ShortVideoGroupNodeData {
  /** Display label for the group */
  in_label?: string
  /** Whether the group is collapsed */
  in_collapsed?: boolean
  /** Path to the storyboard grid image */
  in_storyboard_path?: string
  /** Reference image for connected edges */
  in_image?: ImageAssetRefDictYMap
  /** IDs of child panel nodes */
  in_child_node_ids?: Array<string>
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** Generate music, speech, or sound effects with three unified modes */
export interface SoundExpertNodeData {
  /** Display name for the node (FloatingNodeLabel) */
  in_name?: string
  /** Upstream dependency trigger */
  in_upstream?: UpstreamContextDictYMap
  /** Free-text description of desired audio (music/sfx) */
  in_prompt?: string
  /** Audio generation mode: music, speech, or sfx */
  in_mode?: string
  /** Duration hint as human-readable string (music/sfx only) */
  in_duration?: string
  /** Voice profile from Character Designer for speech mode */
  in_voice_profile?: VoiceProfileDictYMap
  /** Final speakable dialogue or narration transcript for speech mode. Do not put refinement notes, instructions, headings, or prompt text here; use Feedback for revisions. */
  in_text?: string
  /** Correction or revision feedback for the next speech-mode run. Set this via propose_dag_changes (op=update) before calling run_nodes to revise an existing voiceover without mixing instructions into Text. */
  in_feedback?: string
  /** Accumulated Sound Expert speech refinement feedback per round. The agent appends a new entry whenever it rewrites speech from non-empty feedback so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries. */
  in_feedback_history?: Array<FeedbackHistoryEntryDictYMap>
  /** Audio generation model identifier */
  in_model?: string
  /** Whether to loop the audio (sfx mode) */
  in_loop?: string
  /** Lyrics generation mode for music (auto/custom/instrumental) */
  in_lyrics_mode?: string
  /** Speaker-to-voice mapping for multi-speaker narration (speech mode) */
  in_voice_map?: VoiceMapDictYMap
  /** Scene identifier for file naming (speech mode) */
  in_scene_id?: string
  /** Panel index for ordering within a scene (speech mode) */
  in_panel_index?: number
  /** Pause duration in milliseconds between segments (speech mode) */
  in_pause_ms?: number
  /** Character name for single-speaker TTS (speech mode) */
  in_character_name?: string
  /** Character node id when this Sound Expert is the active Character voice source. */
  in_character_voice_source_for?: string
  /** Audio duration in seconds */
  out_duration_seconds?: number
  /** Generated audio with history and picked index */
  out_audio?: SoundGeneratedAudioDictYMap
  /** Voice metadata selected or used by this Sound Expert node for speech generation */
  out_voice_profile?: VoiceProfileDictYMap
  /**  */
  batch_pending?: number
  /** Legacy: direct path to audio file. TODO: Remove after full canvas-v2 migration */
  audio_file?: string
  /** Per-character speech segments with generated speech results */
  speech_segments?: SpeechSegmentDictYMap
  /** Provider for the selected speech voice owned by this Sound Expert node */
  selected_voice_provider?: string
  /** Provider voice id selected by this Sound Expert node for speech TTS */
  selected_voice_id?: string
  /** Display name for the selected speech voice owned by this Sound Expert node */
  selected_voice_name?: string
  /** Opaque Dreamwrite catalogue reference for the selected speech voice */
  selected_voice_ref?: string
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** Generate character speech or multi-voice narration */
export interface SpeechGeneratorNodeData {
  /** Speech generation mode: character_voice or narrative */
  in_mode?: string
  /** Narration script or fallback text for character voice mode */
  in_script?: string
  /** Single-speaker text for character voice mode */
  in_text?: string
  /** Character name for single-speaker TTS */
  in_character_name?: string
  /** Explicit provider voice ID override */
  in_voice_id?: string
  /** Voice profile from Character Designer */
  in_voice_profile?: VoiceProfileDictYMap
  /** Speaker-to-voice mapping for multi-speaker narration */
  in_voice_map?: VoiceMapDictYMap
  /** Scene identifier for file naming */
  in_scene_id?: string
  /** Panel index for ordering within a scene */
  in_panel_index?: number
  /** Pause duration in milliseconds between segments */
  in_pause_ms?: number
  /** Per-word pronunciation overrides for non-English words and proper nouns. One rule per line: 'word → pronunciation' (alias) or 'word → /IPA/' (phoneme). Example: L'Ora → LOH-rah */
  in_pronunciation_guide?: string
  /** ISO 639-1 language code (e.g. 'en', 'it', 'zh', 'ja'). Helps ElevenLabs apply correct phonetics instead of defaulting to English. Leave empty for auto-detection. */
  in_language_code?: string
  /** Audio duration in seconds */
  out_duration_seconds?: number
  /** Waveform samples for UI display */
  out_waveform?: Array<number>
  /** Generated audio with history and picked index */
  out_audio?: SoundGeneratedAudioDictYMap
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** Story shaping dimensions: premise, tone, hook, structure */
export interface StoryDirectionPreviewNodeData {
  /**  */
  premise?: StoryDirectionFieldDictYMap
  /**  */
  tone?: StoryDirectionFieldDictYMap
  /**  */
  hook?: StoryDirectionFieldDictYMap
  /**  */
  structure?: StoryDirectionFieldDictYMap
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** Generate a 9-grid storyboard from a script or scene description */
export interface StoryboardDesignerNodeData {
  /** Script or scene breakdown to visualize as storyboard */
  in_script?: string
  /** Character reference sheets for visual consistency */
  in_characters?: Array<ImageAssetRefDictYMap | null>
  /** Character names from designer out_name ports */
  in_character_names?: Array<string | null>
  /** Location reference images for scene setting */
  in_locations?: Array<ImageAssetRefDictYMap | null>
  /** Location names from designer out_name ports */
  in_location_names?: Array<string | null>
  /** Object reference images for props and items */
  in_objects?: Array<ImageAssetRefDictYMap | null>
  /** Object names from designer out_name ports */
  in_object_names?: Array<string | null>
  /** Optional reference image to guide storyboard generation */
  in_image?: ImageAssetRefDictYMap
  /** Visual art style for the storyboard */
  in_style?: string
  /** Number of panels (default 9 for 9-grid) */
  in_panel_count?: number
  /** Optional exact count for text-mode Shot List generation; when unset, the planner chooses the count. */
  in_shot_count?: number
  /** Optional storyboard aspect ratio override. When unset, uses the project aspect ratio. */
  in_aspect_ratio?: string
  /** Scene identifier for the storyboard */
  in_scene_id?: string
  /** Optional display label for the storyboard designer node */
  in_name?: string
  /** Location for the scene */
  in_location?: string
  /** Image generation model */
  in_model?: string
  /** Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance. */
  in_feedback?: string
  /** Run Gemini VLM quality validation after generation */
  in_vlm_validation?: boolean
  /** User-designated exact first/last frame assets by shot ID. Automatically generated frames remain reference images unless explicitly designated. */
  in_video_anchors?: Array<ShotVideoAnchorDictYMap>
  /** History of generated storyboard grid images and selected variant */
  out_image?: GeneratedImageWithHistoryYMap
  /** Per-grid storyboard composite image paths for multi-grid storyboards */
  out_grid_images?: Array<ImageAssetRefDictYMap>
  /** Storyboard metadata including beat descriptions */
  out_metadata?: StoryboardMetadataDictYMap
  /** Beat descriptions per panel */
  out_beats?: Array<string>
  /** Versioned shot records; multi-array output permits individual downstream shot references. */
  out_shots?: Array<GeneratedShotRowV2DictYMap>
  /** Atomic ordered shot-boundary list (not flattened): N shots have N+1 seams. */
  out_shot_seams?: Array<ShotSeamDictYMap>
  /** Versioned production annotations for an existing text Shot List. */
  out_production_plan?: ShotProductionPlanDictYMap
  /** Exact-duration ordered packs, shared shot Generation IDs and corresponding video node IDs. */
  out_video_generation_plan?: ShotVideoGenerationPlanDictYMap
  /** Inactive pack provenance retained for selective replanning; never authorizes video generation. */
  out_video_previous_plan?: ShotVideoGenerationPlanDictYMap
  /** Text-mode images indexed by canonical shot position, never by grid packing or frame mode. */
  out_start_frames?: Array<ImageAssetRefDictYMap>
  /** Text-mode key-frame images indexed by canonical shot position. */
  out_key_frames?: Array<ImageAssetRefDictYMap>
  /** Text-mode end-frame images indexed by canonical shot position. */
  out_end_frames?: Array<ImageAssetRefDictYMap>
  /**  */
  out_start_frame_prompts?: Array<string>
  /**  */
  out_key_frame_prompts?: Array<string>
  /**  */
  out_end_frame_prompts?: Array<string>
  /** Versioned shot/role to image-generator node mapping and per-slot status. */
  out_frame_links?: Array<ShotFrameLinkDictYMap>
  /** Per-panel list of designer node IDs */
  out_panel_refs?: Array<Array<string>>
  /** Cropped panel image paths */
  out_images?: Array<ImageAssetRefDictYMap>
  /** Per-grid concatenated beat descriptions for grid preview node prompts */
  out_grid_descriptions?: Array<string>
  /** VLM quality validation report from the most recent generation */
  out_vlm_report?: VlmValidationReportDictYMap
  /** Provenance of a generated text Shot List: prompt or script. */
  shot_guidance_kind?: string
  /** Fingerprint of the input guidance used for the current text Shot List. */
  shot_guidance_fingerprint?: string
  /** Review notice for unplaced screenplay scenes, mismatched scene suggestions or omitted dialogue. */
  shot_guidance_warning?: string
  /**  */
  batch_pending?: number
  /** Presentation mode. Absent on legacy storyboard nodes. */
  storyboard_view?: string
  /** Marks prompt-guided Shot Lists; absent means the legacy screenplay-bound planner. */
  shot_list_planner_version?: number
  /** Execution mode; absent means the historical image storyboard workflow. */
  storyboard_mode?: string
  /** Text-only shot rows; no storyboard image output or execution path. */
  shot_list?: Array<ShotListRowDictYMap>
  /** Unique shot-ID-keyed selections of existing image nodes; override effective video master frames without replacing generated frame links. */
  shot_key_frame_relinks?: Array<ShotKeyFrameRelinkDictYMap>
  /** Marker token identifying which auto-generated default-name family this node's display name came from (see agentic_workflow.core.default_node_names). Absent on user-created and pre-marker nodes. The console localizes the name only while the stored value still equals the canonical English rendering, so a rename automatically wins. */
  name_autogen?: string
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** Generate a 9-grid storyboard without per-panel enhancement */
export interface StoryboardNoEnhanceDesignerNodeData {
  /** Script or scene breakdown to visualize */
  in_script?: string
  /** Character reference sheets */
  in_characters?: Array<ImageAssetRefDictYMap | null>
  /** Character names from designer out_name ports */
  in_character_names?: Array<string | null>
  /** Location reference images */
  in_locations?: Array<ImageAssetRefDictYMap | null>
  /** Location names from designer out_name ports */
  in_location_names?: Array<string | null>
  /** Visual art style */
  in_style?: string
  /** Number of panels */
  in_panel_count?: number
  /** Scene identifier */
  in_scene_id?: string
  /** Location for the scene */
  in_location?: string
  /** Image generation model */
  in_model?: string
  /** Run Gemini VLM quality validation after generation */
  in_vlm_validation?: boolean
  /** Relative path to 9-grid image */
  out_image?: ImageAssetRefDictYMap
  /** VLM quality validation report from the most recent generation */
  out_vlm_report?: VlmValidationReportDictYMap
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** Select visual style for generation */
export interface StyleSelectorNodeData {
  /** The selected visual style */
  out_style?: string
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** A text input with editable title */
export interface TextNodeData {
  /** Text input from another node */
  in_input?: string
  /** The text content */
  out_text?: string
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** Upload a local video file */
export interface VideoNodeData {
  /**  */
  in_file_name?: string
  /** Keep the original clip audio in the extracted depth video. */
  in_depth_include_audio?: boolean
  /**  */
  in_transform_video?: VideoAssetRefDictYMap
  /**  */
  in_transform_target_resolution?: string
  /**  */
  in_transform_source_asset_path?: string
  /**  */
  in_transform_source_content_sha256?: string
  /**  */
  in_transform_source_width?: number
  /**  */
  in_transform_source_height?: number
  /**  */
  in_transform_source_frame_count?: number
  /**  */
  in_transform_source_fps?: number
  /** The uploaded video */
  out_video?: GeneratedVideoWithHistoryYMap
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** Edit videos by stitching sources or placing source-local trims on a timeline */
export interface VideoEditorNodeData {
  /** Ordered video and audio references. Connect outputs here; toIndex preserves cross-media order. Internal video and audio inputs are derived from source port types. */
  in_reference_media?: Array<MediaAssetRefDictYMap | null>
  /** Multiple video clips to stitch together (in order) */
  in_videos?: Array<VideoAssetRefDictYMap | null>
  /** Input audio tracks for the editor. Audio inputs are independent from in_videos; counts do not need to match. Without explicit placement, audio tracks are placed in input order on the timeline. */
  in_audios?: Array<AudioAssetRefDictYMap | null>
  /** Single audio input; treated as one additional independent audio track. */
  in_audio?: AudioAssetRefDictYMap
  /** Persisted Video Editor timeline. Connected media seeds a new timeline in edge order. Use edit_video_editor_timeline for later changes. start_time/end_time trim the source; start_offset places an item on the output timeline. Omit all three for sequential whole-source clips. Use symbolic source_path values such as '<node_id>.out_video' or '<node_id>.out_audio'; the editor resolves the wired asset at render time. audio_kind is the saved audio type. role is accepted only as a compatibility input when audio_kind is absent. */
  in_video_config?: TimelineConfigDictYMap
  /** Versioned AI-authored edit contract. Additive to in_video_config during migration; renderer selection is controlled by explicit compatibility state and execution action, never field presence. */
  in_edit_spec?: EditSpecDictYMap
  /** Edit operation mode */
  in_mode?: string
  /** Output file name */
  in_output_name?: string
  /** Trim start time */
  in_start?: number
  /** Trim end time */
  in_end?: number
  /** Audio volume */
  in_volume?: number
  /** Name chosen in the Export to Download confirm sheet for the new Video node. Transient transport — written by the frontend just before executeNode and consumed by the backend agent. */
  in_export_name?: string
  /** Edited video output */
  out_video?: VideoAssetRefDictYMap
  /** Versioned canonical fingerprint of the EditSpec that produced out_video. */
  out_rendered_spec_hash?: string
  /** Exact picked paths of upstream video and speech nodes used for the current render. */
  out_render_sources?: ShotVideoRenderSourcesDictYMap
  /**  */
  last_export_node_id?: string
  /** When true (default), edits to track-0 video clips re-pack the track left-to-right with no gaps after commit. */
  magnet_enabled?: boolean
  /** Explicit source-of-truth and renderer-selection state. Field presence alone never selects a renderer. */
  edit_spec_compatibility_state?: string
  /** Explicit migration failure detail; empty when no migration failure is active. */
  edit_spec_migration_error?: string
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** Generate raw video clips from prompts, reference images, reference videos, and provider-supported audio references */
export interface VideoGeneratorNodeData {
  /** Ordered media references. Connect image, video or audio outputs here; toIndex preserves cross-media order. Provider-specific inputs are derived internally. */
  in_reference_media?: Array<MediaAssetRefDictYMap | null>
  /** Video generation mode */
  in_mode?: string
  /** Scene identifier for organizing clips */
  in_scene_id?: string
  /** Clip number within the scene */
  in_clip_number?: number
  /** Reference/first-frame images for generation */
  in_images?: Array<ImageAssetRefDictYMap | null>
  /** Original/reference videos for edit-style video generation */
  in_reference_videos?: Array<VideoAssetRefDictYMap | null>
  /** The actual completed previous pack output. An exact-first successor extracts its final decoded frame; never use this as a weak R2V reference. */
  in_continuation_source?: GeneratedVideoWithHistoryYMap
  /** Server-owned Shot List node ID for pack fingerprint checks before charging. */
  in_shot_list_source_id?: string
  /** Server-owned immutable fingerprint of shots, seams, and explicit anchors at packing. */
  in_shot_list_source_fingerprint?: string
  /** Server-owned fingerprint of the model, motion intent, and selected source image revisions. */
  in_shot_list_request_fingerprint?: string
  /** Reference audio clips that CONDITION generation (voice/language/motion guidance), e.g. Seedance 2.0 audio references. Distinct from in_audio, which bakes an audio track into the finished clip. Only valid on a model that accepts audio references. */
  in_reference_audios?: Array<AudioAssetRefDictYMap | null>
  /** Optional audio track to bake into the video */
  in_audio?: AudioAssetRefDictYMap
  /** Describe the video action and motion */
  in_motion_prompt?: string
  /** Broader scene context for coherent generation */
  in_scene_context?: string
  /** Video duration in seconds */
  in_duration?: number
  /** Trim windows for in_reference_videos. Use source_node_id or asset_path to match a video reference; asset identity remains edge-derived. */
  in_reference_video_edits?: Array<VideoReferenceEditDictYMap>
  /** Edge-derived structured per-line dialogue/voiceover for generated speech. Do not write this field directly; connect an upstream dialogue output or embed dialogue in in_motion_prompt. */
  in_dialogue_prompt?: Array<DialogueEntryDictYMap>
  /** Video generation model. Call list_available_models to see available options including BYOM models, and use its explicit default_video_model when no model was requested. */
  in_model?: string
  /** Video aspect ratio */
  in_aspect_ratio?: string
  /** Video output resolution */
  in_resolution?: string
  /** Deprecated legacy compatibility flag for Dreamwrite post-generation audio. Existing nodes that only set this flag keep their legacy remix behavior. Legacy nodes without in_provider_generate_audio still request provider/native audio by default. New nodes should set in_provider_generate_audio for provider-native audio. Dreamwrite post-processing belongs in downstream Video Editor flows. */
  in_generate_audio?: boolean
  /** Ask the selected video provider/model to generate native audio when that provider supports the option. This does not control Dreamwrite post-generation audio processing. */
  in_provider_generate_audio?: boolean
  /** Deprecated legacy compatibility flag. Voice profiles no longer silently provide provider reference audio. New flows connect linked Sound Expert out_audio to in_reference_audios explicitly when the selected model supports audio references. */
  in_use_voice_profile_audio_references?: boolean
  /** Deprecated legacy Dreamwrite post-generation audio mode. Kept for old projects until audio post-processing fully moves to Video Editor nodes. */
  in_audio_remix_mode?: "off" | "voiceover_only" | "full_remix"
  /** When enabled, the video model may generate background music and ambient sounds. When disabled (default), only SFX and specified dialogue audio are included. */
  in_allow_bgm?: boolean
  /** Deprecated legacy speech provider setting for Dreamwrite-generated dialogue, narration, and voiceover audio on Video Generator nodes. New Dreamwrite post-processing speech should be represented by Sound Expert audio and mixed downstream. */
  in_tts_provider?: string
  /** Retired legacy dub target language. Kept hidden so old project data can still load. New dubbing work should use Sound Expert and Video Editor flows. */
  in_dub_target_language?: string
  /** Voice profiles from connected Character Designers, Sound Expert voice nodes, or Script Writer narrators. They identify speakers for generated speech and provide voice metadata/descriptions. Provider audio conditioning uses explicit audio edges to in_reference_media; do not infer provider audio references from voice_profile.audio_sample. Profile name should match a character label or narrator voice_role_id. */
  in_voice_profiles?: Array<VoiceProfileDictYMap | null>
  /** TTS voice tuning parameters (stability, similarity_boost, style, speed) */
  in_voice_settings?: VoiceSettingsDictYMap
  /** Optional label for the video node */
  in_name?: string
  /** Character name to resolved voice display name mapping for generated speech */
  in_resolved_voice_map?: ResolvedVoiceMapDictYMap
  /** Retired legacy audio editor state for saved dialogue and narrator tracks. Kept hidden so old project data can still load. Current audio edits use Sound Expert and Video Editor. */
  in_audio_remix_config?: AudioRemixConfigDictYMap
  /** Retired speech-edit state. Kept hidden so old project data can still load. Current voice changes use Sound Expert and Video Editor. */
  in_speech_transformer_config?: SpeechTransformerConfigDictYMap
  /** Variant-scoped selected audio take per clip. Stored as a flat map keyed by `v1:` plus compact JSON for `[variant_path, clip_id]`; each value repeats that identity and stores the exact selected label/path. New nodes initialize an empty shared map; legacy nodes may omit it. */
  in_audio_take_selections?: AudioTakeSelectionMapDictYMap
  /** Retired variant-scoped audio authoring state. Kept hidden so old project data can still load. */
  in_audio_variant_workspaces?: AudioVariantWorkspaceMapDictYMap
  /** Retired audio authoring state. Kept hidden so old project data can still load. Current audio edits use the Video Editor timeline and Sound Expert audio nodes. */
  in_unified_audio_config?: UnifiedAudioProjectDictYMap
  /** Visual style library ID. Empty inherits project style; NO_STYLE disables library guidance. Reference images preserve subject and composition while style guides motion and overall look. */
  in_style?: string
  /** Generated video clip with metadata */
  out_video?: GeneratedVideoWithHistoryYMap
  /** Retired legacy Video Generator speech output. Current Dreamwrite-owned speech is generated by Sound Expert and mixed in Video Editor. */
  out_tts_segments?: Array<TtsSegmentDictYMap>
  /** Retired legacy audio-edit baseline. Kept hidden so old project data can still load. */
  out_audio_remix_baseline?: AudioRemixConfigDictYMap
  /** Retired speech-edit detection output. Kept hidden so old project data can still load. */
  out_speech_transformer_spans?: SpeechTransformerDetectionDictYMap
  /** Dialogue entries auto-extracted from the motion prompt when no explicit in_dialogue_prompt is connected */
  out_auto_dialogue?: Array<DialogueEntryDictYMap>
  /** Retired legacy speech-window output. Kept hidden so old project data can still load. */
  out_speech_windows?: Array<SpeechWindowDictYMap>
  /** Deprecated legacy native speech take ledger. Kept hidden so old project data can still load. */
  out_native_speech_takes?: Array<NativeSpeechTakeDictYMap>
  /** RFC-1122 Phase 3: audio-first ASR detection result — per-line spans (transcript + timing) for a native/vocals lane, source-anchored. The derive splits the whole-track native clip into per-span clips (each independently re-voiceable). Phase 4: make per-variant. */
  out_native_speech_spans?: Array<NativeSpeechSpanDictYMap>
  /** RFC-1122 Phase 3 (Codex impl r17 P1): a monotonic counter incremented on every SUCCESSFUL audio-first detect run. It is the FE's 'a re-detect completed' signal — robust even when the detector returns byte-identical spans (unchanged out_native_speech_spans), so the console can clear the re-detected lane's stale per-clip config/tombstones so its clips repopulate. Not per-variant (a run counter). */
  out_native_speech_detect_seq?: number
  /** The timed prompt sent to Veo */
  out_video_prompt?: string
  /** Video duration in seconds */
  out_video_duration?: number
  /** Reconciled dialogue data for generated speech, including optional narrator voice_role_id */
  out_dialogue?: Array<ReconciledDialogueEntryDictYMap>
  /**  */
  voice_acting_status?: string
  /** Retired audio operation status. Kept so old project state can still load. */
  full_remix_status?: VideoFullRemixStatusV1DictYMap
  /**  */
  segment_index?: number
  /**  */
  batch_pending?: number
  /** Legacy: video thumbnail path. TODO: Remove after full canvas-v2 migration */
  thumbnail?: string
  /** Current execution action for compatibility with older node runs. */
  action?: string
  /** Sent by consoles that understand Closing frame (LAST_FRAME) on every Closing-frame run, so an API that predates this field rejects the run instead of treating the image as an opening frame (RFC-1668). Its value has no other effect. */
  closing_frame_handshake?: number
  /** Retired audio target clip id. Kept hidden so old project data can still load. */
  clip_id?: string
  /** Retired speech-edit target voice id. Kept hidden so old project data can still load. */
  target_voice_id?: string
  /** Retired audio target variant path. Kept hidden so old project data can still load. */
  target_variant_path?: string
  /** Marker token identifying which auto-generated default-name family this node's display name came from (see agentic_workflow.core.default_node_names). Absent on user-created and pre-marker nodes. The console localizes the name only while the stored value still equals the canonical English rendering, so a rename automatically wins. */
  name_autogen?: string
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** Collapsible group container for webtoon panels arranged vertically */
export interface WebtoonGroupNodeData {
  /** Scene identifier (e.g., ch1_s2) */
  in_scene_id?: string
  /** Display label (e.g., Chapter 1, Scene 2) */
  in_label?: string
  /** Whether the group is collapsed (internal, managed by UI toggle) */
  in_collapsed?: boolean
  /** IDs of child panel nodes */
  in_child_node_ids?: Array<string>
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

/** Generate a webtoon page with multiple sub-panels and text bubbles */
export interface WebtoonPanelGeneratorNodeData {
  /** Storyboard panel thumbnails + character/location reference images */
  in_images?: Array<ImageAssetRefDictYMap | null>
  /** Combined visual description for the page (fallback if beats not provided) */
  in_prompt?: string
  /** List of beat descriptions for sub-panels on this page */
  in_beats?: Array<string | null>
  /** Structured dialogue entries for text bubble overlay */
  in_dialogue?: Array<WebtoonDialogueDictYMap | null>
  /** Page position in the scene (0-based) */
  in_panel_index?: number
  /** Page aspect ratio */
  in_aspect_ratio?: string
  /** Panel layout type for page composition */
  in_layout?: string
  /** Visual art style */
  in_style?: string
  /** Page name */
  in_name?: string
  /** Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance. */
  in_feedback?: string
  /** Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries. */
  in_feedback_history?: Array<FeedbackHistoryEntryDictYMap>
  /** Webtoon page with sub-panels and text bubbles */
  out_image?: GeneratedImageWithHistoryYMap
  /**  */
  bubbles?: Array<BubbleDictYMap>
  /**  */
  batch_pending?: number
  // Common status fields
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
}

export type AnyNodeData = AudioNodeData | CharacterDesignerNodeData | DebugHangNodeData | DirectorNodeData | GeneratedImageWithHistoryNodeData | ImageNodeData | ImageGeneratorNodeData | LocationDesignerNodeData | NodeGroupNodeData | ObjectDesignerNodeData | PanelSourceNodeData | PromptInputNodeData | ScriptWriterNodeData | ShortVideoGroupNodeData | SoundExpertNodeData | SpeechGeneratorNodeData | StoryDirectionPreviewNodeData | StoryboardDesignerNodeData | StoryboardNoEnhanceDesignerNodeData | StyleSelectorNodeData | TextNodeData | VideoNodeData | VideoEditorNodeData | VideoGeneratorNodeData | WebtoonGroupNodeData | WebtoonPanelGeneratorNodeData

/** Backend type to interface type mapping */
export type NodeDataMap = {
  'audio': AudioNodeData
  'character_designer': CharacterDesignerNodeData
  'debug_hang': DebugHangNodeData
  'director': DirectorNodeData
  'generated_image_with_history': GeneratedImageWithHistoryNodeData
  'image': ImageNodeData
  'image_generator': ImageGeneratorNodeData
  'location_designer': LocationDesignerNodeData
  'node_group': NodeGroupNodeData
  'object_designer': ObjectDesignerNodeData
  'panel_source': PanelSourceNodeData
  'prompt_input': PromptInputNodeData
  'script_writer': ScriptWriterNodeData
  'short_video_group': ShortVideoGroupNodeData
  'sound_expert': SoundExpertNodeData
  'speech_generator': SpeechGeneratorNodeData
  'story_direction_preview': StoryDirectionPreviewNodeData
  'storyboard_designer': StoryboardDesignerNodeData
  'storyboard_no_enhance_designer': StoryboardNoEnhanceDesignerNodeData
  'style_selector': StyleSelectorNodeData
  'text': TextNodeData
  'video': VideoNodeData
  'video_editor': VideoEditorNodeData
  'video_generator': VideoGeneratorNodeData
  'webtoon_group': WebtoonGroupNodeData
  'webtoon_panel_generator': WebtoonPanelGeneratorNodeData
}

// ---------------------------------------------------------------------------
// Frontend node write payload types
// ---------------------------------------------------------------------------

export interface CommonNodeWriteData {
  status?: NodeStatus
  label?: string
  name?: string
  error?: string
  progress?: number
  progressMessage?: string
  projectId?: string
  cacheKey?: string
  initialFile?: File
  _initialPreviewUrl?: string
}

export interface AudioNodeWriteData extends CommonNodeWriteData {
  /**  */
  in_file_name?: string
  /** Character voice profile used to mark this uploaded audio as the Character voice source. */
  in_voice_profile?: VoiceProfileDict
  /** The uploaded audio */
  out_audio?: AudioAssetRefDict
}

export interface CharacterDesignerNodeWriteData extends CommonNodeWriteData {
  /** Default target port for incoming edges when no port is specified by the proposer (see _DEFAULT_TARGET_PORT in backend_graph.py). Wire upstream context (director or workflow node output) here when no specialized port applies. */
  in_upstream?: UpstreamContextDict
  /** Optional reference image to guide the visual design */
  in_images?: Array<ImageAssetRefDict | null>
  /** Name of the character being designed */
  in_name?: string
  /** Character role (e.g. protagonist, supporting, antagonist) */
  in_role?: string
  /** Visual art style for the character sheet */
  in_style?: string
  /** Describe appearance, personality, voice... */
  in_description?: string
  /** Image generation model */
  in_model?: string
  /** Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance. */
  in_feedback?: string
  /** Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries. */
  in_feedback_history?: Array<FeedbackHistoryEntryDict>
  /** Per-word pronunciation overrides for this character's name and terms. One rule per line: 'word → pronunciation' (alias) or 'word → /IPA/' (phoneme). Example: L'Ora → LOH-rah. Automatically applied to all downstream speech generation using this character's voice. */
  in_pronunciation_guide?: string
  /** Predefined background color key for the node card */
  in_bg_color?: string
  /** Run Gemini VLM quality validation after generation */
  in_vlm_validation?: boolean
  /** Generated multi-view character reference sheet */
  out_image?: CharacterAsset
  /** Provider-neutral voice brief used to identify this character's speaker role. The linked Sound Expert node owns selected provider voice fields and sample audio. */
  out_voice_profile?: VoiceProfileDict
  /** VLM quality validation report from the most recent generation */
  out_vlm_report?: VlmValidationReportDict
  /**  */
  batch_pending?: number
  /** Transient per-run path to a baked annotation of the current picked image. Written by the Refine tab as a `state_updates` argument on execute-node, consumed once as the edit target, then cleared. Never authored by the Director and never persisted as durable node data. */
  annotated_image_path?: string
}

export interface DebugHangNodeWriteData extends CommonNodeWriteData {
  /** Debug label */
  in_label?: string
  /** Debug result */
  out_result?: string
}

export interface DirectorNodeWriteData extends CommonNodeWriteData {
  /** Optional context for the conversation */
  in_context?: string
  /** Director response text */
  out_response?: string
  /** Crew configuration for sub-agents */
  out_crew?: DirectorCrewDict
  /**  */
  pending_tool_state?: DirectorPendingToolStateDict
}

export interface GeneratedImageWithHistoryNodeWriteData extends CommonNodeWriteData {
}

export interface ImageNodeWriteData extends CommonNodeWriteData {
  /**  */
  in_file_name?: string
  /** Provenance link to the image this one was derived from — set by the annotation bake so the canvas can draw a derivation edge from the source node. Inert: nothing reads this value, and Image Upload nodes never populate it. */
  in_image?: ImageAssetRefDict
  /** The uploaded image */
  out_image?: ImageAssetRefDict
}

export interface ImageGeneratorNodeWriteData extends CommonNodeWriteData {
  /** Optional reference image to guide the generation */
  in_images?: Array<ImageAssetRefDict | null>
  /** Default target port for incoming edges when no port is specified by the proposer (see _DEFAULT_TARGET_PORT in backend_graph.py). Wire upstream context (director or workflow node output) here when no specialized port applies. */
  in_upstream?: UpstreamContextDict
  /** Optional label for the generator node */
  in_name?: string
  /** Text description of the image to generate */
  in_prompt?: string
  /** Aspect ratio for the generated image */
  in_aspect_ratio?: AspectRatio
  /** Visual art style for the generated image */
  in_style?: string
  /** Output resolution quality */
  in_quality?: string
  /** Image generation model */
  in_model?: string
  /** Designer node IDs for self-wiring reference edges */
  in_panel_refs?: Array<string>
  /** When True, store in_image directly (passthrough mode) */
  in_update?: boolean
  /** Incoming panel image from storyboard */
  in_image?: ImageAssetRefDict
  /** Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance. */
  in_feedback?: string
  /** Video file path (RelativePath) from upstream video generator */
  in_video?: string
  /** Typed video input used for an exact S7 last-decoded-frame extraction. */
  in_source_video?: GeneratedVideoWithHistory
  /** Exact planned predecessor clip length, checked against the decoded video stream before S7 handoff. */
  in_expected_video_duration_ms?: number
  /** Which frame to extract: first, last, integer string (0-indexed), or time:<seconds> for the Canvas playhead */
  in_frame?: string
  /** When true, skip image generation and extract frame from in_video */
  in_get_frame?: boolean
  /** Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries. */
  in_feedback_history?: Array<FeedbackHistoryEntryDict>
  /** Run Gemini VLM quality validation after generation */
  in_vlm_validation?: boolean
  /** The generated image */
  out_image?: GeneratedImageWithHistory
  /** VLM quality validation report from the most recent generation */
  out_vlm_report?: VlmValidationReportDict
  /**  */
  batch_pending?: number
  /** Transient per-run path to a baked annotation of the current picked image. Written by the Refine tab as a `state_updates` argument on execute-node, consumed once as the edit target, then cleared. Never authored by the Director and never persisted as durable node data. */
  annotated_image_path?: string
  /** Marker token identifying which auto-generated default-name family this node's display name came from (see agentic_workflow.core.default_node_names). Absent on user-created and pre-marker nodes. The console localizes the name only while the stored value still equals the canonical English rendering, so a rename automatically wins. */
  name_autogen?: string
}

export interface LocationDesignerNodeWriteData extends CommonNodeWriteData {
  /** Optional reference image to guide the visual design */
  in_images?: Array<ImageAssetRefDict | null>
  /** Name of the location being designed */
  in_name?: string
  /** Visual art style for the location */
  in_style?: string
  /** Time of day for the scene */
  in_time_of_day?: string
  /** Weather condition for the scene */
  in_weather?: string
  /** Describe the location, atmosphere, key elements... */
  in_description?: string
  /** Image generation model */
  in_model?: string
  /** Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance. */
  in_feedback?: string
  /** Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries. */
  in_feedback_history?: Array<FeedbackHistoryEntryDict>
  /** Predefined background color key for the node card */
  in_bg_color?: string
  /** Run Gemini VLM quality validation after generation */
  in_vlm_validation?: boolean
  /** Generate a 360 panorama source for this location instead of a standard flat location image */
  in_720_enabled?: boolean
  /** Current 360 viewer camera state in degrees */
  in_720_view?: LocationPanoramaViewDict
  /** Generated location reference image */
  out_image?: LocationAsset
  /** Location metadata including name, style, time, and weather */
  out_metadata?: LocationMetadataDict
  /** VLM quality validation report from the most recent generation */
  out_vlm_report?: VlmValidationReportDict
  /**  */
  batch_pending?: number
  /** Transient per-run path to a baked annotation of the current picked image. Written by the Refine tab as a `state_updates` argument on execute-node, consumed once as the edit target, then cleared. Never authored by the Director and never persisted as durable node data. */
  annotated_image_path?: string
}

export interface NodeGroupNodeWriteData extends CommonNodeWriteData {
  /** Display label for the group */
  in_label?: string
  /** IDs of child nodes contained in this group. Null entries represent empty gap slots left by drag-out; use Rearrange to compact. */
  in_child_node_ids?: Array<string | null>
  /** Child arrangement mode: horizontal (single row), vertical (single column), or auto (grid) */
  in_layout_mode?: string
  /** Whether this visual group is shown in its compact collapsed state */
  in_collapsed?: boolean
  /** Whether this workflow-owned visual group exposes collapse and expand controls */
  in_collapsible?: boolean
  /** Predefined background color key for the group container */
  in_bg_color?: string
  /** Marker token identifying which auto-generated default-name family this node's display label came from (see agentic_workflow.core.default_node_names). Absent on user-created and pre-marker nodes. The console localizes the label only while the stored value still equals the canonical English rendering, so a rename automatically wins. */
  name_autogen?: string
}

export interface ObjectDesignerNodeWriteData extends CommonNodeWriteData {
  /** Optional reference image to guide the visual design */
  in_images?: Array<ImageAssetRefDict | null>
  /** Name of the object being designed */
  in_name?: string
  /** Visual art style for the object */
  in_style?: string
  /** Describe the object appearance, material, details... */
  in_description?: string
  /** Image generation model */
  in_model?: string
  /** Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance. */
  in_feedback?: string
  /** Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries. */
  in_feedback_history?: Array<FeedbackHistoryEntryDict>
  /** Run Gemini VLM quality validation after generation */
  in_vlm_validation?: boolean
  /** Generated object reference image */
  out_image?: ObjectAsset
  /** Object metadata */
  out_metadata?: ObjectMetadataDict
  /** VLM quality validation report from the most recent generation */
  out_vlm_report?: VlmValidationReportDict
  /**  */
  batch_pending?: number
  /** Transient per-run path to a baked annotation of the current picked image. Written by the Refine tab as a `state_updates` argument on execute-node, consumed once as the edit target, then cleared. Never authored by the Director and never persisted as durable node data. */
  annotated_image_path?: string
}

export interface PanelSourceNodeWriteData extends CommonNodeWriteData {
  /** The existing panel image */
  out_image?: ImageAssetRefDict
  /** The action/script description */
  out_action?: string
  /** IDs of characters appearing in this panel */
  out_character_ids?: Array<string>
  /** Character expressions, poses, positions */
  out_appearances?: Array<AppearanceDict>
  /** Dialogue lines in this panel */
  out_dialogue?: Array<PanelDialogueDict>
  /** Dialogue formatted as TTS script */
  out_script?: string
  /** Shot type, angle, and focus settings */
  out_composition?: CompositionDict
}

export interface PromptInputNodeWriteData extends CommonNodeWriteData {
  /** The story prompt text */
  out_prompt?: string
}

export interface ScriptWriterNodeWriteData extends CommonNodeWriteData {
  /** Story prompt or instructions */
  in_prompt?: string
  /** Selected model variant: gemini or claude. Legacy gpt values are ignored while Script Plus is unavailable. */
  in_active_model?: string
  /** Id of the out_script_variants entry the node currently displays. Empty means the newest variant for the active model. */
  in_active_variant_id?: string
  /** Project or scene name */
  in_name?: string
  /** Director's creative guidance composed from user Q&A — tone, structure, pacing, and other creative direction */
  in_director_instruction?: string
  /** When true, the Script Writer only reformats the user prompt into screenplay structure without adding, modifying, or removing storyline content */
  in_format_only?: boolean
  /** Enable Gemini model for screenplay generation */
  in_gemini?: boolean
  /** Enable Claude model for screenplay generation */
  in_claude?: boolean
  /** Legacy GPT model toggle retained for persisted project compatibility. Ignored while Script Plus is unavailable. */
  in_gpt?: boolean
  /** Character names */
  in_characters?: Array<string | null>
  /** Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance. */
  in_feedback?: string
  /** Optional target total duration in seconds; used to compute suggested scene count. Director should set this from the user's duration choice (30s=30, about 1min=60, about 2min=120, about 5min=300, or a custom value). */
  in_target_duration_s?: number
  /** Script review feedback history */
  in_review_history?: Array<ReviewHistoryEntryDict>
  /** Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior screenplay + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries. */
  in_feedback_history?: Array<FeedbackHistoryEntryDict>
  /** Predefined background color key for the node card */
  in_bg_color?: string
  /** Generated script content */
  out_script?: string
  /** Path to saved script file */
  out_script_path?: string
  /** Structured screenplay (array of scene objects with typed entries) */
  out_screenplay?: Array<ScriptScreenplaySceneDict>
  /** Extracted dialogue entries with character, emotion, and text */
  out_dialogue?: Array<ScriptDialogueDict>
  /** Reusable narrator, system, and internal-monologue voice roles referenced by screenplay entries */
  out_voice_roles?: VoiceRoleDict[]
  /** Provider-neutral narrator, system, title-card, and internal-monologue voice briefs. Profile name matches voice_role_id. Linked Sound Expert nodes choose and store concrete provider voices. */
  out_voice_profiles?: VoiceProfileDict[]
  /** Extracted action/staging direction entries per scene */
  out_action_lines?: Array<SceneTextDict>
  /** Deduplicated list of character names appearing in the screenplay */
  out_characters?: Array<string>
  /** Music mood/genre cue entries per scene */
  out_music_cues?: Array<SceneTextDict>
  /** Sound effect entries per scene */
  out_sfx?: Array<SceneTextDict>
  /** Raw ScreenplayResult JSON from Gemini */
  out_gemini?: ScreenplayResultDict
  /** Raw ScreenplayResult JSON from Claude Opus 4 */
  out_claude?: ScreenplayResultDict
  /** Legacy GPT-4o ScreenplayResult JSON retained for persisted project compatibility. */
  out_gpt?: ScreenplayResultDict
  /** Extracted location names from screenplay */
  out_locations?: Array<string>
  /** Which model variant was selected (gemini or claude) */
  out_active_model?: string
  /** Number of scenes in the generated screenplay */
  out_scene_count?: number
  /** One-sentence logline for the active model's screenplay */
  out_logline?: string
  /** Genre and tonal register of the active model's screenplay */
  out_genre_tone?: string
  /** Short prose synopsis of the active model's screenplay */
  out_synopsis?: string
  /** Central themes of the active model's screenplay */
  out_themes?: string
  /** Screenplay iteration history, oldest first. One entry per model per successful run; the node's Variants panel lists these newest-first and marks the active one as the master script. Capped at the most recent 20 entries. */
  out_script_variants?: Array<ScriptVariantDict>
}

export interface ShortVideoGroupNodeWriteData extends CommonNodeWriteData {
  /** Display label for the group */
  in_label?: string
  /** Whether the group is collapsed */
  in_collapsed?: boolean
  /** Path to the storyboard grid image */
  in_storyboard_path?: string
  /** Reference image for connected edges */
  in_image?: ImageAssetRefDict
  /** IDs of child panel nodes */
  in_child_node_ids?: Array<string>
}

export interface SoundExpertNodeWriteData extends CommonNodeWriteData {
  /** Display name for the node (FloatingNodeLabel) */
  in_name?: string
  /** Upstream dependency trigger */
  in_upstream?: UpstreamContextDict
  /** Free-text description of desired audio (music/sfx) */
  in_prompt?: string
  /** Audio generation mode: music, speech, or sfx */
  in_mode?: string
  /** Duration hint as human-readable string (music/sfx only) */
  in_duration?: string
  /** Voice profile from Character Designer for speech mode */
  in_voice_profile?: VoiceProfileDict
  /** Final speakable dialogue or narration transcript for speech mode. Do not put refinement notes, instructions, headings, or prompt text here; use Feedback for revisions. */
  in_text?: string
  /** Correction or revision feedback for the next speech-mode run. Set this via propose_dag_changes (op=update) before calling run_nodes to revise an existing voiceover without mixing instructions into Text. */
  in_feedback?: string
  /** Accumulated Sound Expert speech refinement feedback per round. The agent appends a new entry whenever it rewrites speech from non-empty feedback so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries. */
  in_feedback_history?: Array<FeedbackHistoryEntryDict>
  /** Audio generation model identifier */
  in_model?: string
  /** Whether to loop the audio (sfx mode) */
  in_loop?: string
  /** Lyrics generation mode for music (auto/custom/instrumental) */
  in_lyrics_mode?: string
  /** Speaker-to-voice mapping for multi-speaker narration (speech mode) */
  in_voice_map?: VoiceMapDict
  /** Scene identifier for file naming (speech mode) */
  in_scene_id?: string
  /** Panel index for ordering within a scene (speech mode) */
  in_panel_index?: number
  /** Pause duration in milliseconds between segments (speech mode) */
  in_pause_ms?: number
  /** Character name for single-speaker TTS (speech mode) */
  in_character_name?: string
  /** Character node id when this Sound Expert is the active Character voice source. */
  in_character_voice_source_for?: string
  /** Audio duration in seconds */
  out_duration_seconds?: number
  /** Generated audio with history and picked index */
  out_audio?: SoundGeneratedAudioDict
  /** Voice metadata selected or used by this Sound Expert node for speech generation */
  out_voice_profile?: VoiceProfileDict
  /**  */
  batch_pending?: number
  /** Legacy: direct path to audio file. TODO: Remove after full canvas-v2 migration */
  audio_file?: string
  /** Per-character speech segments with generated speech results */
  speech_segments?: SpeechSegmentDict
  /** Provider for the selected speech voice owned by this Sound Expert node */
  selected_voice_provider?: string
  /** Provider voice id selected by this Sound Expert node for speech TTS */
  selected_voice_id?: string
  /** Display name for the selected speech voice owned by this Sound Expert node */
  selected_voice_name?: string
  /** Opaque Dreamwrite catalogue reference for the selected speech voice */
  selected_voice_ref?: string
}

export interface SpeechGeneratorNodeWriteData extends CommonNodeWriteData {
  /** Speech generation mode: character_voice or narrative */
  in_mode?: string
  /** Narration script or fallback text for character voice mode */
  in_script?: string
  /** Single-speaker text for character voice mode */
  in_text?: string
  /** Character name for single-speaker TTS */
  in_character_name?: string
  /** Explicit provider voice ID override */
  in_voice_id?: string
  /** Voice profile from Character Designer */
  in_voice_profile?: VoiceProfileDict
  /** Speaker-to-voice mapping for multi-speaker narration */
  in_voice_map?: VoiceMapDict
  /** Scene identifier for file naming */
  in_scene_id?: string
  /** Panel index for ordering within a scene */
  in_panel_index?: number
  /** Pause duration in milliseconds between segments */
  in_pause_ms?: number
  /** Per-word pronunciation overrides for non-English words and proper nouns. One rule per line: 'word → pronunciation' (alias) or 'word → /IPA/' (phoneme). Example: L'Ora → LOH-rah */
  in_pronunciation_guide?: string
  /** ISO 639-1 language code (e.g. 'en', 'it', 'zh', 'ja'). Helps ElevenLabs apply correct phonetics instead of defaulting to English. Leave empty for auto-detection. */
  in_language_code?: string
  /** Audio duration in seconds */
  out_duration_seconds?: number
  /** Waveform samples for UI display */
  out_waveform?: Array<number>
  /** Generated audio with history and picked index */
  out_audio?: SoundGeneratedAudioDict
}

export interface StoryDirectionPreviewNodeWriteData extends CommonNodeWriteData {
  /**  */
  premise?: StoryDirectionFieldDict
  /**  */
  tone?: StoryDirectionFieldDict
  /**  */
  hook?: StoryDirectionFieldDict
  /**  */
  structure?: StoryDirectionFieldDict
}

export interface StoryboardDesignerNodeWriteData extends CommonNodeWriteData {
  /** Script or scene breakdown to visualize as storyboard */
  in_script?: string
  /** Character reference sheets for visual consistency */
  in_characters?: Array<ImageAssetRefDict | null>
  /** Character names from designer out_name ports */
  in_character_names?: Array<string | null>
  /** Location reference images for scene setting */
  in_locations?: Array<ImageAssetRefDict | null>
  /** Location names from designer out_name ports */
  in_location_names?: Array<string | null>
  /** Object reference images for props and items */
  in_objects?: Array<ImageAssetRefDict | null>
  /** Object names from designer out_name ports */
  in_object_names?: Array<string | null>
  /** Optional reference image to guide storyboard generation */
  in_image?: ImageAssetRefDict
  /** Visual art style for the storyboard */
  in_style?: string
  /** Number of panels (default 9 for 9-grid) */
  in_panel_count?: number
  /** Optional exact count for text-mode Shot List generation; when unset, the planner chooses the count. */
  in_shot_count?: number
  /** Optional storyboard aspect ratio override. When unset, uses the project aspect ratio. */
  in_aspect_ratio?: string
  /** Scene identifier for the storyboard */
  in_scene_id?: string
  /** Optional display label for the storyboard designer node */
  in_name?: string
  /** Location for the scene */
  in_location?: string
  /** Image generation model */
  in_model?: string
  /** Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance. */
  in_feedback?: string
  /** Run Gemini VLM quality validation after generation */
  in_vlm_validation?: boolean
  /** User-designated exact first/last frame assets by shot ID. Automatically generated frames remain reference images unless explicitly designated. */
  in_video_anchors?: Array<ShotVideoAnchorDict>
  /** History of generated storyboard grid images and selected variant */
  out_image?: GeneratedImageWithHistory
  /** Per-grid storyboard composite image paths for multi-grid storyboards */
  out_grid_images?: ImageAssetRefDict[]
  /** Storyboard metadata including beat descriptions */
  out_metadata?: StoryboardMetadataDict
  /** Beat descriptions per panel */
  out_beats?: string[]
  /** Versioned shot records; multi-array output permits individual downstream shot references. */
  out_shots?: GeneratedShotRowV2Dict[]
  /** Atomic ordered shot-boundary list (not flattened): N shots have N+1 seams. */
  out_shot_seams?: Array<ShotSeamDict>
  /** Versioned production annotations for an existing text Shot List. */
  out_production_plan?: ShotProductionPlanDict
  /** Exact-duration ordered packs, shared shot Generation IDs and corresponding video node IDs. */
  out_video_generation_plan?: ShotVideoGenerationPlanDict
  /** Inactive pack provenance retained for selective replanning; never authorizes video generation. */
  out_video_previous_plan?: ShotVideoGenerationPlanDict
  /** Text-mode images indexed by canonical shot position, never by grid packing or frame mode. */
  out_start_frames?: ImageAssetRefDict[]
  /** Text-mode key-frame images indexed by canonical shot position. */
  out_key_frames?: ImageAssetRefDict[]
  /** Text-mode end-frame images indexed by canonical shot position. */
  out_end_frames?: ImageAssetRefDict[]
  /**  */
  out_start_frame_prompts?: string[]
  /**  */
  out_key_frame_prompts?: string[]
  /**  */
  out_end_frame_prompts?: string[]
  /** Versioned shot/role to image-generator node mapping and per-slot status. */
  out_frame_links?: Array<ShotFrameLinkDict>
  /** Per-panel list of designer node IDs */
  out_panel_refs?: Array<string>[]
  /** Cropped panel image paths */
  out_images?: ImageAssetRefDict[]
  /** Per-grid concatenated beat descriptions for grid preview node prompts */
  out_grid_descriptions?: string[]
  /** VLM quality validation report from the most recent generation */
  out_vlm_report?: VlmValidationReportDict
  /** Provenance of a generated text Shot List: prompt or script. */
  shot_guidance_kind?: string
  /** Fingerprint of the input guidance used for the current text Shot List. */
  shot_guidance_fingerprint?: string
  /** Review notice for unplaced screenplay scenes, mismatched scene suggestions or omitted dialogue. */
  shot_guidance_warning?: string
  /**  */
  batch_pending?: number
  /** Presentation mode. Absent on legacy storyboard nodes. */
  storyboard_view?: string
  /** Marks prompt-guided Shot Lists; absent means the legacy screenplay-bound planner. */
  shot_list_planner_version?: number
  /** Execution mode; absent means the historical image storyboard workflow. */
  storyboard_mode?: string
  /** Text-only shot rows; no storyboard image output or execution path. */
  shot_list?: Array<ShotListRowDict>
  /** Unique shot-ID-keyed selections of existing image nodes; override effective video master frames without replacing generated frame links. */
  shot_key_frame_relinks?: Array<ShotKeyFrameRelinkDict>
  /** Marker token identifying which auto-generated default-name family this node's display name came from (see agentic_workflow.core.default_node_names). Absent on user-created and pre-marker nodes. The console localizes the name only while the stored value still equals the canonical English rendering, so a rename automatically wins. */
  name_autogen?: string
}

export interface StoryboardNoEnhanceDesignerNodeWriteData extends CommonNodeWriteData {
  /** Script or scene breakdown to visualize */
  in_script?: string
  /** Character reference sheets */
  in_characters?: Array<ImageAssetRefDict | null>
  /** Character names from designer out_name ports */
  in_character_names?: Array<string | null>
  /** Location reference images */
  in_locations?: Array<ImageAssetRefDict | null>
  /** Location names from designer out_name ports */
  in_location_names?: Array<string | null>
  /** Visual art style */
  in_style?: string
  /** Number of panels */
  in_panel_count?: number
  /** Scene identifier */
  in_scene_id?: string
  /** Location for the scene */
  in_location?: string
  /** Image generation model */
  in_model?: string
  /** Run Gemini VLM quality validation after generation */
  in_vlm_validation?: boolean
  /** Relative path to 9-grid image */
  out_image?: ImageAssetRefDict
  /** VLM quality validation report from the most recent generation */
  out_vlm_report?: VlmValidationReportDict
}

export interface StyleSelectorNodeWriteData extends CommonNodeWriteData {
  /** The selected visual style */
  out_style?: string
}

export interface TextNodeWriteData extends CommonNodeWriteData {
  /** Text input from another node */
  in_input?: string
  /** The text content */
  out_text?: string
}

export interface VideoNodeWriteData extends CommonNodeWriteData {
  /**  */
  in_file_name?: string
  /** Keep the original clip audio in the extracted depth video. */
  in_depth_include_audio?: boolean
  /**  */
  in_transform_video?: VideoAssetRefDict
  /**  */
  in_transform_target_resolution?: string
  /**  */
  in_transform_source_asset_path?: string
  /**  */
  in_transform_source_content_sha256?: string
  /**  */
  in_transform_source_width?: number
  /**  */
  in_transform_source_height?: number
  /**  */
  in_transform_source_frame_count?: number
  /**  */
  in_transform_source_fps?: number
  /** The uploaded video */
  out_video?: GeneratedVideoWithHistory
}

export interface VideoEditorNodeWriteData extends CommonNodeWriteData {
  /** Ordered video and audio references. Connect outputs here; toIndex preserves cross-media order. Internal video and audio inputs are derived from source port types. */
  in_reference_media?: Array<MediaAssetRefDict | null>
  /** Multiple video clips to stitch together (in order) */
  in_videos?: Array<VideoAssetRefDict | null>
  /** Input audio tracks for the editor. Audio inputs are independent from in_videos; counts do not need to match. Without explicit placement, audio tracks are placed in input order on the timeline. */
  in_audios?: Array<AudioAssetRefDict | null>
  /** Single audio input; treated as one additional independent audio track. */
  in_audio?: AudioAssetRefDict
  /** Persisted Video Editor timeline. Connected media seeds a new timeline in edge order. Use edit_video_editor_timeline for later changes. start_time/end_time trim the source; start_offset places an item on the output timeline. Omit all three for sequential whole-source clips. Use symbolic source_path values such as '<node_id>.out_video' or '<node_id>.out_audio'; the editor resolves the wired asset at render time. audio_kind is the saved audio type. role is accepted only as a compatibility input when audio_kind is absent. */
  in_video_config?: TimelineConfigDict
  /** Versioned AI-authored edit contract. Additive to in_video_config during migration; renderer selection is controlled by explicit compatibility state and execution action, never field presence. */
  in_edit_spec?: EditSpecDict
  /** Edit operation mode */
  in_mode?: string
  /** Output file name */
  in_output_name?: string
  /** Trim start time */
  in_start?: number
  /** Trim end time */
  in_end?: number
  /** Audio volume */
  in_volume?: number
  /** Name chosen in the Export to Download confirm sheet for the new Video node. Transient transport — written by the frontend just before executeNode and consumed by the backend agent. */
  in_export_name?: string
  /** Edited video output */
  out_video?: VideoAssetRefDict
  /** Versioned canonical fingerprint of the EditSpec that produced out_video. */
  out_rendered_spec_hash?: string
  /** Exact picked paths of upstream video and speech nodes used for the current render. */
  out_render_sources?: ShotVideoRenderSourcesDict
  /**  */
  last_export_node_id?: string
  /** When true (default), edits to track-0 video clips re-pack the track left-to-right with no gaps after commit. */
  magnet_enabled?: boolean
  /** Explicit source-of-truth and renderer-selection state. Field presence alone never selects a renderer. */
  edit_spec_compatibility_state?: string
  /** Explicit migration failure detail; empty when no migration failure is active. */
  edit_spec_migration_error?: string
}

export interface VideoGeneratorNodeWriteData extends CommonNodeWriteData {
  /** Ordered media references. Connect image, video or audio outputs here; toIndex preserves cross-media order. Provider-specific inputs are derived internally. */
  in_reference_media?: Array<MediaAssetRefDict | null>
  /** Video generation mode */
  in_mode?: string
  /** Scene identifier for organizing clips */
  in_scene_id?: string
  /** Clip number within the scene */
  in_clip_number?: number
  /** Reference/first-frame images for generation */
  in_images?: Array<ImageAssetRefDict | null>
  /** Original/reference videos for edit-style video generation */
  in_reference_videos?: Array<VideoAssetRefDict | null>
  /** The actual completed previous pack output. An exact-first successor extracts its final decoded frame; never use this as a weak R2V reference. */
  in_continuation_source?: GeneratedVideoWithHistory
  /** Server-owned Shot List node ID for pack fingerprint checks before charging. */
  in_shot_list_source_id?: string
  /** Server-owned immutable fingerprint of shots, seams, and explicit anchors at packing. */
  in_shot_list_source_fingerprint?: string
  /** Server-owned fingerprint of the model, motion intent, and selected source image revisions. */
  in_shot_list_request_fingerprint?: string
  /** Reference audio clips that CONDITION generation (voice/language/motion guidance), e.g. Seedance 2.0 audio references. Distinct from in_audio, which bakes an audio track into the finished clip. Only valid on a model that accepts audio references. */
  in_reference_audios?: Array<AudioAssetRefDict | null>
  /** Optional audio track to bake into the video */
  in_audio?: AudioAssetRefDict
  /** Describe the video action and motion */
  in_motion_prompt?: string
  /** Broader scene context for coherent generation */
  in_scene_context?: string
  /** Video duration in seconds */
  in_duration?: number
  /** Trim windows for in_reference_videos. Use source_node_id or asset_path to match a video reference; asset identity remains edge-derived. */
  in_reference_video_edits?: Array<VideoReferenceEditDict>
  /** Edge-derived structured per-line dialogue/voiceover for generated speech. Do not write this field directly; connect an upstream dialogue output or embed dialogue in in_motion_prompt. */
  in_dialogue_prompt?: Array<DialogueEntryDict>
  /** Video generation model. Call list_available_models to see available options including BYOM models, and use its explicit default_video_model when no model was requested. */
  in_model?: string
  /** Video aspect ratio */
  in_aspect_ratio?: string
  /** Video output resolution */
  in_resolution?: string
  /** Deprecated legacy compatibility flag for Dreamwrite post-generation audio. Existing nodes that only set this flag keep their legacy remix behavior. Legacy nodes without in_provider_generate_audio still request provider/native audio by default. New nodes should set in_provider_generate_audio for provider-native audio. Dreamwrite post-processing belongs in downstream Video Editor flows. */
  in_generate_audio?: boolean
  /** Ask the selected video provider/model to generate native audio when that provider supports the option. This does not control Dreamwrite post-generation audio processing. */
  in_provider_generate_audio?: boolean
  /** Deprecated legacy compatibility flag. Voice profiles no longer silently provide provider reference audio. New flows connect linked Sound Expert out_audio to in_reference_audios explicitly when the selected model supports audio references. */
  in_use_voice_profile_audio_references?: boolean
  /** Deprecated legacy Dreamwrite post-generation audio mode. Kept for old projects until audio post-processing fully moves to Video Editor nodes. */
  in_audio_remix_mode?: "off" | "voiceover_only" | "full_remix"
  /** When enabled, the video model may generate background music and ambient sounds. When disabled (default), only SFX and specified dialogue audio are included. */
  in_allow_bgm?: boolean
  /** Deprecated legacy speech provider setting for Dreamwrite-generated dialogue, narration, and voiceover audio on Video Generator nodes. New Dreamwrite post-processing speech should be represented by Sound Expert audio and mixed downstream. */
  in_tts_provider?: string
  /** Retired legacy dub target language. Kept hidden so old project data can still load. New dubbing work should use Sound Expert and Video Editor flows. */
  in_dub_target_language?: string
  /** Voice profiles from connected Character Designers, Sound Expert voice nodes, or Script Writer narrators. They identify speakers for generated speech and provide voice metadata/descriptions. Provider audio conditioning uses explicit audio edges to in_reference_media; do not infer provider audio references from voice_profile.audio_sample. Profile name should match a character label or narrator voice_role_id. */
  in_voice_profiles?: Array<VoiceProfileDict | null>
  /** TTS voice tuning parameters (stability, similarity_boost, style, speed) */
  in_voice_settings?: VoiceSettingsDict
  /** Optional label for the video node */
  in_name?: string
  /** Character name to resolved voice display name mapping for generated speech */
  in_resolved_voice_map?: ResolvedVoiceMapDict
  /** Retired legacy audio editor state for saved dialogue and narrator tracks. Kept hidden so old project data can still load. Current audio edits use Sound Expert and Video Editor. */
  in_audio_remix_config?: AudioRemixConfigDict
  /** Retired speech-edit state. Kept hidden so old project data can still load. Current voice changes use Sound Expert and Video Editor. */
  in_speech_transformer_config?: SpeechTransformerConfigDict
  /** Variant-scoped selected audio take per clip. Stored as a flat map keyed by `v1:` plus compact JSON for `[variant_path, clip_id]`; each value repeats that identity and stores the exact selected label/path. New nodes initialize an empty shared map; legacy nodes may omit it. */
  in_audio_take_selections?: AudioTakeSelectionMapDict
  /** Retired variant-scoped audio authoring state. Kept hidden so old project data can still load. */
  in_audio_variant_workspaces?: AudioVariantWorkspaceMapDict
  /** Retired audio authoring state. Kept hidden so old project data can still load. Current audio edits use the Video Editor timeline and Sound Expert audio nodes. */
  in_unified_audio_config?: UnifiedAudioProjectDict
  /** Visual style library ID. Empty inherits project style; NO_STYLE disables library guidance. Reference images preserve subject and composition while style guides motion and overall look. */
  in_style?: string
  /** Generated video clip with metadata */
  out_video?: GeneratedVideoWithHistory
  /** Retired legacy Video Generator speech output. Current Dreamwrite-owned speech is generated by Sound Expert and mixed in Video Editor. */
  out_tts_segments?: Array<TtsSegmentDict>
  /** Retired legacy audio-edit baseline. Kept hidden so old project data can still load. */
  out_audio_remix_baseline?: AudioRemixConfigDict
  /** Retired speech-edit detection output. Kept hidden so old project data can still load. */
  out_speech_transformer_spans?: SpeechTransformerDetectionDict
  /** Dialogue entries auto-extracted from the motion prompt when no explicit in_dialogue_prompt is connected */
  out_auto_dialogue?: Array<DialogueEntryDict>
  /** Retired legacy speech-window output. Kept hidden so old project data can still load. */
  out_speech_windows?: Array<SpeechWindowDict>
  /** Deprecated legacy native speech take ledger. Kept hidden so old project data can still load. */
  out_native_speech_takes?: Array<NativeSpeechTakeDict>
  /** RFC-1122 Phase 3: audio-first ASR detection result — per-line spans (transcript + timing) for a native/vocals lane, source-anchored. The derive splits the whole-track native clip into per-span clips (each independently re-voiceable). Phase 4: make per-variant. */
  out_native_speech_spans?: Array<NativeSpeechSpanDict>
  /** RFC-1122 Phase 3 (Codex impl r17 P1): a monotonic counter incremented on every SUCCESSFUL audio-first detect run. It is the FE's 'a re-detect completed' signal — robust even when the detector returns byte-identical spans (unchanged out_native_speech_spans), so the console can clear the re-detected lane's stale per-clip config/tombstones so its clips repopulate. Not per-variant (a run counter). */
  out_native_speech_detect_seq?: number
  /** The timed prompt sent to Veo */
  out_video_prompt?: string
  /** Video duration in seconds */
  out_video_duration?: number
  /** Reconciled dialogue data for generated speech, including optional narrator voice_role_id */
  out_dialogue?: Array<ReconciledDialogueEntryDict>
  /**  */
  voice_acting_status?: string
  /** Retired audio operation status. Kept so old project state can still load. */
  full_remix_status?: VideoFullRemixStatusV1Dict
  /**  */
  segment_index?: number
  /**  */
  batch_pending?: number
  /** Legacy: video thumbnail path. TODO: Remove after full canvas-v2 migration */
  thumbnail?: string
  /** Current execution action for compatibility with older node runs. */
  action?: string
  /** Sent by consoles that understand Closing frame (LAST_FRAME) on every Closing-frame run, so an API that predates this field rejects the run instead of treating the image as an opening frame (RFC-1668). Its value has no other effect. */
  closing_frame_handshake?: number
  /** Retired audio target clip id. Kept hidden so old project data can still load. */
  clip_id?: string
  /** Retired speech-edit target voice id. Kept hidden so old project data can still load. */
  target_voice_id?: string
  /** Retired audio target variant path. Kept hidden so old project data can still load. */
  target_variant_path?: string
  /** Marker token identifying which auto-generated default-name family this node's display name came from (see agentic_workflow.core.default_node_names). Absent on user-created and pre-marker nodes. The console localizes the name only while the stored value still equals the canonical English rendering, so a rename automatically wins. */
  name_autogen?: string
}

export interface WebtoonGroupNodeWriteData extends CommonNodeWriteData {
  /** Scene identifier (e.g., ch1_s2) */
  in_scene_id?: string
  /** Display label (e.g., Chapter 1, Scene 2) */
  in_label?: string
  /** Whether the group is collapsed (internal, managed by UI toggle) */
  in_collapsed?: boolean
  /** IDs of child panel nodes */
  in_child_node_ids?: Array<string>
}

export interface WebtoonPanelGeneratorNodeWriteData extends CommonNodeWriteData {
  /** Storyboard panel thumbnails + character/location reference images */
  in_images?: Array<ImageAssetRefDict | null>
  /** Combined visual description for the page (fallback if beats not provided) */
  in_prompt?: string
  /** List of beat descriptions for sub-panels on this page */
  in_beats?: Array<string | null>
  /** Structured dialogue entries for text bubble overlay */
  in_dialogue?: Array<WebtoonDialogueDict | null>
  /** Page position in the scene (0-based) */
  in_panel_index?: number
  /** Page aspect ratio */
  in_aspect_ratio?: string
  /** Panel layout type for page composition */
  in_layout?: string
  /** Visual art style */
  in_style?: string
  /** Page name */
  in_name?: string
  /** Correction or revision feedback for the next run. Set this via propose_dag_changes (op=update) before calling run_nodes to retry a failed or completed node with guidance. */
  in_feedback?: string
  /** Accumulated Refine feedback per round. The agent appends a new entry whenever it runs in edit mode (prior picked image + non-empty feedback) so multi-turn editorial intent survives across runs. Capped at the most recent 10 entries. */
  in_feedback_history?: Array<FeedbackHistoryEntryDict>
  /** Webtoon page with sub-panels and text bubbles */
  out_image?: GeneratedImageWithHistory
  /**  */
  bubbles?: Array<BubbleDict>
  /**  */
  batch_pending?: number
}

export type AnyNodeWriteData = AudioNodeWriteData | CharacterDesignerNodeWriteData | DebugHangNodeWriteData | DirectorNodeWriteData | GeneratedImageWithHistoryNodeWriteData | ImageNodeWriteData | ImageGeneratorNodeWriteData | LocationDesignerNodeWriteData | NodeGroupNodeWriteData | ObjectDesignerNodeWriteData | PanelSourceNodeWriteData | PromptInputNodeWriteData | ScriptWriterNodeWriteData | ShortVideoGroupNodeWriteData | SoundExpertNodeWriteData | SpeechGeneratorNodeWriteData | StoryDirectionPreviewNodeWriteData | StoryboardDesignerNodeWriteData | StoryboardNoEnhanceDesignerNodeWriteData | StyleSelectorNodeWriteData | TextNodeWriteData | VideoNodeWriteData | VideoEditorNodeWriteData | VideoGeneratorNodeWriteData | WebtoonGroupNodeWriteData | WebtoonPanelGeneratorNodeWriteData

/** Backend type to frontend write payload type mapping */
export type NodeWriteDataMap = {
  'audio': AudioNodeWriteData
  'character_designer': CharacterDesignerNodeWriteData
  'debug_hang': DebugHangNodeWriteData
  'director': DirectorNodeWriteData
  'generated_image_with_history': GeneratedImageWithHistoryNodeWriteData
  'image': ImageNodeWriteData
  'image_generator': ImageGeneratorNodeWriteData
  'location_designer': LocationDesignerNodeWriteData
  'node_group': NodeGroupNodeWriteData
  'object_designer': ObjectDesignerNodeWriteData
  'panel_source': PanelSourceNodeWriteData
  'prompt_input': PromptInputNodeWriteData
  'script_writer': ScriptWriterNodeWriteData
  'short_video_group': ShortVideoGroupNodeWriteData
  'sound_expert': SoundExpertNodeWriteData
  'speech_generator': SpeechGeneratorNodeWriteData
  'story_direction_preview': StoryDirectionPreviewNodeWriteData
  'storyboard_designer': StoryboardDesignerNodeWriteData
  'storyboard_no_enhance_designer': StoryboardNoEnhanceDesignerNodeWriteData
  'style_selector': StyleSelectorNodeWriteData
  'text': TextNodeWriteData
  'video': VideoNodeWriteData
  'video_editor': VideoEditorNodeWriteData
  'video_generator': VideoGeneratorNodeWriteData
  'webtoon_group': WebtoonGroupNodeWriteData
  'webtoon_panel_generator': WebtoonPanelGeneratorNodeWriteData
}

// ---------------------------------------------------------------------------
// Generated YDoc data-field readers/writers
// ---------------------------------------------------------------------------

export const YDOC_STRUCTURAL_KEYS = new Set<string>([
  'type', 'status', 'label',
  'x', 'y', 'tainted', 'width', 'height',
  'parentNode', 'extent',
])

const YDOC_LEGACY_FIELD_RENAMES: Record<string, string> = {}

const YDOC_RETIRED_DATA_KEYS = new Set<string>([
  'character_sheet',
  'location_image',
  'object_image',
  'generated_image_path',
  'history',
  'picked_index',
  'picked_variant_index',
  'applied_operations_count',
  'isInsideGroup',
  'duration',
  'audio_selections',
  'id',
  'out_character_sheet',
  'out_location_image',
  'out_object_image',
  'out_generated_image',
  'out_generated_storyboard_grid',
  'out_storyboard_grid',
  'out_panel_image',
  'out_generated_video',
  'in_generated_audio',
  'out_generated_audio',
  'out_image_path',
  'in_reference_images',
  'out_panel_images',
  'out_video_path',
  'out_video_output',
  'in_video_paths',
  'in_video_path',
  'out_audio_file',
  'in_audio_paths',
  'in_audio_path',
  'out_unified_audio',
])

const YDOC_COMMON_DATA_KEYS = new Set<string>([
  'name',
  'error',
  'progress',
  'progressMessage',
  'projectId',
  'cacheKey',
])

function _isYDocWriteObject(value: YDocWriteValue): value is YDocWriteRecord {
  return (
    typeof value === 'object' &&
    value !== null &&
    !Array.isArray(value) &&
    !(value instanceof Y.Map) &&
    !(value instanceof Y.Array) &&
    !(value instanceof YMapWrapper) &&
    !(value instanceof YMapRecord) &&
    !(typeof File !== 'undefined' && value instanceof File)
  )
}

function _toYDocValue(value: YDocWriteValue): YDocValue {
  if (value === null || value === undefined) return value
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return value
  if (value instanceof Y.Map) {
    const yMap = new Y.Map<YDocValue>()
    value.forEach((item, key) => yMap.set(key, _toYDocValue(item)))
    return yMap
  }
  if (value instanceof Y.Array) {
    const yArr = new Y.Array<YDocValue>()
    yArr.push(value.toArray().map((item) => _toYDocValue(item)))
    return yArr
  }
  if (value instanceof YMapWrapper) return _toYDocValue(value._raw)
  if (value instanceof YMapRecord) return _toYDocValue(value._raw)
  if (typeof File !== 'undefined' && value instanceof File) return undefined
  if (Array.isArray(value)) {
    const arr = new Y.Array<YDocValue>()
    arr.push(value.map((item) => _toYDocValue(item)))
    return arr
  }

  if (typeof value !== 'object') {
    throw new TypeError(`YDoc value must be JSON-compatible, got ${_yDocTypeName(value)}`)
  }

  const yMap = new Y.Map<YDocValue>()
  for (const [key, item] of Object.entries(value)) {
    yMap.set(key, _toYDocValue(item))
  }
  return yMap
}

function _serializeYDocFieldValue(field: string, value: YDocWriteValue): YDocValue {
  if (value === null || value === undefined) return value
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return value
  throw new TypeError(`${field} must be a JSON primitive for primitive wire field, got ${_yDocTypeName(value)}`)
}

export function readYDocNodeDataRecord(
  rawRecord: Record<string, YDocValue>,
  _backendType: string,
): Record<string, YDocValue> {
  const dataRaw: Record<string, YDocValue> = {}
  for (const [key, raw] of Object.entries(rawRecord)) {
    if (YDOC_STRUCTURAL_KEYS.has(key)) continue
    if (key.startsWith('_')) continue
    if (YDOC_RETIRED_DATA_KEYS.has(key)) continue
    const newKey = YDOC_LEGACY_FIELD_RENAMES[key]
    if (newKey && !(newKey in dataRaw)) {
      dataRaw[newKey] = raw
      continue
    }
    dataRaw[key] = raw
  }
  if (_backendType === 'character_designer') {
    dataRaw.out_name = rawRecord.in_name
  }
  if (_backendType === 'location_designer') {
    dataRaw.out_name = rawRecord.in_name
  }
  if (_backendType === 'object_designer') {
    dataRaw.out_name = rawRecord.in_name
  }
  return dataRaw
}

export interface YDocWriteOpts {
  forceDesignerJsonFields?: boolean
}

// ---------------------------------------------------------------------------
// Generated concrete YDoc field writers
// ---------------------------------------------------------------------------

export function writeAudioInFileName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<AudioNodeWriteData['in_file_name'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindAudioCanvasNode(ynode).writeInFileName(value, opts)
}

export function writeAudioInVoiceProfile(
  ynode: Y.Map<YDocValue>,
  value: Exclude<AudioNodeWriteData['in_voice_profile'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindAudioCanvasNode(ynode).writeInVoiceProfile(value, opts)
}

export function writeAudioOutAudio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<AudioNodeWriteData['out_audio'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindAudioCanvasNode(ynode).writeOutAudio(value, opts)
}

export function writeCharacterDesignerInUpstream(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeWriteData['in_upstream'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindCharacterDesignerCanvasNode(ynode).writeInUpstream(value, opts)
}

export function writeCharacterDesignerInImages(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeWriteData['in_images'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindCharacterDesignerCanvasNode(ynode).writeInImages(value, opts)
}

export function writeCharacterDesignerInName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeWriteData['in_name'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindCharacterDesignerCanvasNode(ynode).writeInName(value, opts)
}

export function writeCharacterDesignerInRole(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeWriteData['in_role'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindCharacterDesignerCanvasNode(ynode).writeInRole(value, opts)
}

export function writeCharacterDesignerInStyle(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeWriteData['in_style'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindCharacterDesignerCanvasNode(ynode).writeInStyle(value, opts)
}

export function writeCharacterDesignerInDescription(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeWriteData['in_description'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindCharacterDesignerCanvasNode(ynode).writeInDescription(value, opts)
}

export function writeCharacterDesignerInModel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeWriteData['in_model'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindCharacterDesignerCanvasNode(ynode).writeInModel(value, opts)
}

export function writeCharacterDesignerInFeedback(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeWriteData['in_feedback'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindCharacterDesignerCanvasNode(ynode).writeInFeedback(value, opts)
}

export function writeCharacterDesignerInFeedbackHistory(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeWriteData['in_feedback_history'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindCharacterDesignerCanvasNode(ynode).writeInFeedbackHistory(value, opts)
}

export function writeCharacterDesignerInPronunciationGuide(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeWriteData['in_pronunciation_guide'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindCharacterDesignerCanvasNode(ynode).writeInPronunciationGuide(value, opts)
}

export function writeCharacterDesignerInBgColor(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeWriteData['in_bg_color'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindCharacterDesignerCanvasNode(ynode).writeInBgColor(value, opts)
}

export function writeCharacterDesignerInVlmValidation(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeWriteData['in_vlm_validation'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindCharacterDesignerCanvasNode(ynode).writeInVlmValidation(value, opts)
}

export function writeCharacterDesignerOutImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeWriteData['out_image'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindCharacterDesignerCanvasNode(ynode).writeOutImage(value, opts)
}

export function writeCharacterDesignerOutVoiceProfile(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeWriteData['out_voice_profile'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindCharacterDesignerCanvasNode(ynode).writeOutVoiceProfile(value, opts)
}

export function writeCharacterDesignerOutVlmReport(
  ynode: Y.Map<YDocValue>,
  value: Exclude<CharacterDesignerNodeWriteData['out_vlm_report'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindCharacterDesignerCanvasNode(ynode).writeOutVlmReport(value, opts)
}

export function writeDebugHangInLabel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<DebugHangNodeWriteData['in_label'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindDebugHangCanvasNode(ynode).writeInLabel(value, opts)
}

export function writeDebugHangOutResult(
  ynode: Y.Map<YDocValue>,
  value: Exclude<DebugHangNodeWriteData['out_result'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindDebugHangCanvasNode(ynode).writeOutResult(value, opts)
}

export function writeDirectorInContext(
  ynode: Y.Map<YDocValue>,
  value: Exclude<DirectorNodeWriteData['in_context'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindDirectorCanvasNode(ynode).writeInContext(value, opts)
}

export function writeDirectorOutResponse(
  ynode: Y.Map<YDocValue>,
  value: Exclude<DirectorNodeWriteData['out_response'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindDirectorCanvasNode(ynode).writeOutResponse(value, opts)
}

export function writeDirectorOutCrew(
  ynode: Y.Map<YDocValue>,
  value: Exclude<DirectorNodeWriteData['out_crew'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindDirectorCanvasNode(ynode).writeOutCrew(value, opts)
}

export function writeImageInFileName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageNodeWriteData['in_file_name'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindImageCanvasNode(ynode).writeInFileName(value, opts)
}

export function writeImageInImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageNodeWriteData['in_image'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindImageCanvasNode(ynode).writeInImage(value, opts)
}

export function writeImageOutImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageNodeWriteData['out_image'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindImageCanvasNode(ynode).writeOutImage(value, opts)
}

export function writeImageGeneratorInImages(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeWriteData['in_images'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindImageGeneratorCanvasNode(ynode).writeInImages(value, opts)
}

export function writeImageGeneratorInUpstream(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeWriteData['in_upstream'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindImageGeneratorCanvasNode(ynode).writeInUpstream(value, opts)
}

export function writeImageGeneratorInName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeWriteData['in_name'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindImageGeneratorCanvasNode(ynode).writeInName(value, opts)
}

export function writeImageGeneratorInPrompt(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeWriteData['in_prompt'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindImageGeneratorCanvasNode(ynode).writeInPrompt(value, opts)
}

export function writeImageGeneratorInAspectRatio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeWriteData['in_aspect_ratio'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindImageGeneratorCanvasNode(ynode).writeInAspectRatio(value, opts)
}

export function writeImageGeneratorInStyle(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeWriteData['in_style'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindImageGeneratorCanvasNode(ynode).writeInStyle(value, opts)
}

export function writeImageGeneratorInQuality(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeWriteData['in_quality'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindImageGeneratorCanvasNode(ynode).writeInQuality(value, opts)
}

export function writeImageGeneratorInModel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeWriteData['in_model'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindImageGeneratorCanvasNode(ynode).writeInModel(value, opts)
}

export function writeImageGeneratorInPanelRefs(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeWriteData['in_panel_refs'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindImageGeneratorCanvasNode(ynode).writeInPanelRefs(value, opts)
}

export function writeImageGeneratorInUpdate(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeWriteData['in_update'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindImageGeneratorCanvasNode(ynode).writeInUpdate(value, opts)
}

export function writeImageGeneratorInImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeWriteData['in_image'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindImageGeneratorCanvasNode(ynode).writeInImage(value, opts)
}

export function writeImageGeneratorInFeedback(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeWriteData['in_feedback'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindImageGeneratorCanvasNode(ynode).writeInFeedback(value, opts)
}

export function writeImageGeneratorInVideo(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeWriteData['in_video'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindImageGeneratorCanvasNode(ynode).writeInVideo(value, opts)
}

export function writeImageGeneratorInSourceVideo(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeWriteData['in_source_video'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindImageGeneratorCanvasNode(ynode).writeInSourceVideo(value, opts)
}

export function writeImageGeneratorInExpectedVideoDurationMs(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeWriteData['in_expected_video_duration_ms'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindImageGeneratorCanvasNode(ynode).writeInExpectedVideoDurationMs(value, opts)
}

export function writeImageGeneratorInFrame(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeWriteData['in_frame'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindImageGeneratorCanvasNode(ynode).writeInFrame(value, opts)
}

export function writeImageGeneratorInGetFrame(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeWriteData['in_get_frame'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindImageGeneratorCanvasNode(ynode).writeInGetFrame(value, opts)
}

export function writeImageGeneratorInFeedbackHistory(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeWriteData['in_feedback_history'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindImageGeneratorCanvasNode(ynode).writeInFeedbackHistory(value, opts)
}

export function writeImageGeneratorInVlmValidation(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeWriteData['in_vlm_validation'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindImageGeneratorCanvasNode(ynode).writeInVlmValidation(value, opts)
}

export function writeImageGeneratorOutImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeWriteData['out_image'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindImageGeneratorCanvasNode(ynode).writeOutImage(value, opts)
}

export function writeImageGeneratorOutVlmReport(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ImageGeneratorNodeWriteData['out_vlm_report'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindImageGeneratorCanvasNode(ynode).writeOutVlmReport(value, opts)
}

export function writeLocationDesignerInImages(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeWriteData['in_images'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindLocationDesignerCanvasNode(ynode).writeInImages(value, opts)
}

export function writeLocationDesignerInName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeWriteData['in_name'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindLocationDesignerCanvasNode(ynode).writeInName(value, opts)
}

export function writeLocationDesignerInStyle(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeWriteData['in_style'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindLocationDesignerCanvasNode(ynode).writeInStyle(value, opts)
}

export function writeLocationDesignerInTimeOfDay(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeWriteData['in_time_of_day'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindLocationDesignerCanvasNode(ynode).writeInTimeOfDay(value, opts)
}

export function writeLocationDesignerInWeather(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeWriteData['in_weather'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindLocationDesignerCanvasNode(ynode).writeInWeather(value, opts)
}

export function writeLocationDesignerInDescription(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeWriteData['in_description'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindLocationDesignerCanvasNode(ynode).writeInDescription(value, opts)
}

export function writeLocationDesignerInModel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeWriteData['in_model'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindLocationDesignerCanvasNode(ynode).writeInModel(value, opts)
}

export function writeLocationDesignerInFeedback(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeWriteData['in_feedback'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindLocationDesignerCanvasNode(ynode).writeInFeedback(value, opts)
}

export function writeLocationDesignerInFeedbackHistory(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeWriteData['in_feedback_history'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindLocationDesignerCanvasNode(ynode).writeInFeedbackHistory(value, opts)
}

export function writeLocationDesignerInBgColor(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeWriteData['in_bg_color'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindLocationDesignerCanvasNode(ynode).writeInBgColor(value, opts)
}

export function writeLocationDesignerInVlmValidation(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeWriteData['in_vlm_validation'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindLocationDesignerCanvasNode(ynode).writeInVlmValidation(value, opts)
}

export function writeLocationDesignerIn720Enabled(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeWriteData['in_720_enabled'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindLocationDesignerCanvasNode(ynode).writeIn720Enabled(value, opts)
}

export function writeLocationDesignerIn720View(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeWriteData['in_720_view'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindLocationDesignerCanvasNode(ynode).writeIn720View(value, opts)
}

export function writeLocationDesignerOutImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeWriteData['out_image'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindLocationDesignerCanvasNode(ynode).writeOutImage(value, opts)
}

export function writeLocationDesignerOutMetadata(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeWriteData['out_metadata'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindLocationDesignerCanvasNode(ynode).writeOutMetadata(value, opts)
}

export function writeLocationDesignerOutVlmReport(
  ynode: Y.Map<YDocValue>,
  value: Exclude<LocationDesignerNodeWriteData['out_vlm_report'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindLocationDesignerCanvasNode(ynode).writeOutVlmReport(value, opts)
}

export function writeNodeGroupInLabel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<NodeGroupNodeWriteData['in_label'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindNodeGroupCanvasNode(ynode).writeInLabel(value, opts)
}

export function writeNodeGroupInChildNodeIds(
  ynode: Y.Map<YDocValue>,
  value: Exclude<NodeGroupNodeWriteData['in_child_node_ids'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindNodeGroupCanvasNode(ynode).writeInChildNodeIds(value, opts)
}

export function writeNodeGroupInLayoutMode(
  ynode: Y.Map<YDocValue>,
  value: Exclude<NodeGroupNodeWriteData['in_layout_mode'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindNodeGroupCanvasNode(ynode).writeInLayoutMode(value, opts)
}

export function writeNodeGroupInCollapsed(
  ynode: Y.Map<YDocValue>,
  value: Exclude<NodeGroupNodeWriteData['in_collapsed'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindNodeGroupCanvasNode(ynode).writeInCollapsed(value, opts)
}

export function writeNodeGroupInCollapsible(
  ynode: Y.Map<YDocValue>,
  value: Exclude<NodeGroupNodeWriteData['in_collapsible'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindNodeGroupCanvasNode(ynode).writeInCollapsible(value, opts)
}

export function writeNodeGroupInBgColor(
  ynode: Y.Map<YDocValue>,
  value: Exclude<NodeGroupNodeWriteData['in_bg_color'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindNodeGroupCanvasNode(ynode).writeInBgColor(value, opts)
}

export function writeObjectDesignerInImages(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ObjectDesignerNodeWriteData['in_images'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindObjectDesignerCanvasNode(ynode).writeInImages(value, opts)
}

export function writeObjectDesignerInName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ObjectDesignerNodeWriteData['in_name'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindObjectDesignerCanvasNode(ynode).writeInName(value, opts)
}

export function writeObjectDesignerInStyle(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ObjectDesignerNodeWriteData['in_style'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindObjectDesignerCanvasNode(ynode).writeInStyle(value, opts)
}

export function writeObjectDesignerInDescription(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ObjectDesignerNodeWriteData['in_description'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindObjectDesignerCanvasNode(ynode).writeInDescription(value, opts)
}

export function writeObjectDesignerInModel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ObjectDesignerNodeWriteData['in_model'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindObjectDesignerCanvasNode(ynode).writeInModel(value, opts)
}

export function writeObjectDesignerInFeedback(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ObjectDesignerNodeWriteData['in_feedback'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindObjectDesignerCanvasNode(ynode).writeInFeedback(value, opts)
}

export function writeObjectDesignerInFeedbackHistory(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ObjectDesignerNodeWriteData['in_feedback_history'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindObjectDesignerCanvasNode(ynode).writeInFeedbackHistory(value, opts)
}

export function writeObjectDesignerInVlmValidation(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ObjectDesignerNodeWriteData['in_vlm_validation'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindObjectDesignerCanvasNode(ynode).writeInVlmValidation(value, opts)
}

export function writeObjectDesignerOutImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ObjectDesignerNodeWriteData['out_image'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindObjectDesignerCanvasNode(ynode).writeOutImage(value, opts)
}

export function writeObjectDesignerOutMetadata(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ObjectDesignerNodeWriteData['out_metadata'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindObjectDesignerCanvasNode(ynode).writeOutMetadata(value, opts)
}

export function writeObjectDesignerOutVlmReport(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ObjectDesignerNodeWriteData['out_vlm_report'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindObjectDesignerCanvasNode(ynode).writeOutVlmReport(value, opts)
}

export function writePanelSourceOutImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<PanelSourceNodeWriteData['out_image'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindPanelSourceCanvasNode(ynode).writeOutImage(value, opts)
}

export function writePanelSourceOutAction(
  ynode: Y.Map<YDocValue>,
  value: Exclude<PanelSourceNodeWriteData['out_action'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindPanelSourceCanvasNode(ynode).writeOutAction(value, opts)
}

export function writePanelSourceOutCharacterIds(
  ynode: Y.Map<YDocValue>,
  value: Exclude<PanelSourceNodeWriteData['out_character_ids'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindPanelSourceCanvasNode(ynode).writeOutCharacterIds(value, opts)
}

export function writePanelSourceOutAppearances(
  ynode: Y.Map<YDocValue>,
  value: Exclude<PanelSourceNodeWriteData['out_appearances'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindPanelSourceCanvasNode(ynode).writeOutAppearances(value, opts)
}

export function writePanelSourceOutDialogue(
  ynode: Y.Map<YDocValue>,
  value: Exclude<PanelSourceNodeWriteData['out_dialogue'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindPanelSourceCanvasNode(ynode).writeOutDialogue(value, opts)
}

export function writePanelSourceOutScript(
  ynode: Y.Map<YDocValue>,
  value: Exclude<PanelSourceNodeWriteData['out_script'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindPanelSourceCanvasNode(ynode).writeOutScript(value, opts)
}

export function writePanelSourceOutComposition(
  ynode: Y.Map<YDocValue>,
  value: Exclude<PanelSourceNodeWriteData['out_composition'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindPanelSourceCanvasNode(ynode).writeOutComposition(value, opts)
}

export function writePromptInputOutPrompt(
  ynode: Y.Map<YDocValue>,
  value: Exclude<PromptInputNodeWriteData['out_prompt'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindPromptInputCanvasNode(ynode).writeOutPrompt(value, opts)
}

export function writeScriptWriterInPrompt(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['in_prompt'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeInPrompt(value, opts)
}

export function writeScriptWriterInActiveModel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['in_active_model'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeInActiveModel(value, opts)
}

export function writeScriptWriterInActiveVariantId(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['in_active_variant_id'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeInActiveVariantId(value, opts)
}

export function writeScriptWriterInName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['in_name'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeInName(value, opts)
}

export function writeScriptWriterInDirectorInstruction(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['in_director_instruction'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeInDirectorInstruction(value, opts)
}

export function writeScriptWriterInFormatOnly(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['in_format_only'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeInFormatOnly(value, opts)
}

export function writeScriptWriterInGemini(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['in_gemini'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeInGemini(value, opts)
}

export function writeScriptWriterInClaude(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['in_claude'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeInClaude(value, opts)
}

export function writeScriptWriterInGpt(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['in_gpt'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeInGpt(value, opts)
}

export function writeScriptWriterInCharacters(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['in_characters'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeInCharacters(value, opts)
}

export function writeScriptWriterInFeedback(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['in_feedback'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeInFeedback(value, opts)
}

export function writeScriptWriterInTargetDurationS(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['in_target_duration_s'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeInTargetDurationS(value, opts)
}

export function writeScriptWriterInReviewHistory(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['in_review_history'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeInReviewHistory(value, opts)
}

export function writeScriptWriterInFeedbackHistory(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['in_feedback_history'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeInFeedbackHistory(value, opts)
}

export function writeScriptWriterInBgColor(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['in_bg_color'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeInBgColor(value, opts)
}

export function writeScriptWriterOutScript(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['out_script'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeOutScript(value, opts)
}

export function writeScriptWriterOutScriptPath(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['out_script_path'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeOutScriptPath(value, opts)
}

export function writeScriptWriterOutScreenplay(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['out_screenplay'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeOutScreenplay(value, opts)
}

export function writeScriptWriterOutDialogue(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['out_dialogue'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeOutDialogue(value, opts)
}

export function writeScriptWriterOutVoiceRoles(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['out_voice_roles'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeOutVoiceRoles(value, opts)
}

export function writeScriptWriterOutVoiceProfiles(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['out_voice_profiles'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeOutVoiceProfiles(value, opts)
}

export function writeScriptWriterOutActionLines(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['out_action_lines'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeOutActionLines(value, opts)
}

export function writeScriptWriterOutCharacters(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['out_characters'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeOutCharacters(value, opts)
}

export function writeScriptWriterOutMusicCues(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['out_music_cues'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeOutMusicCues(value, opts)
}

export function writeScriptWriterOutSfx(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['out_sfx'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeOutSfx(value, opts)
}

export function writeScriptWriterOutGemini(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['out_gemini'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeOutGemini(value, opts)
}

export function writeScriptWriterOutClaude(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['out_claude'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeOutClaude(value, opts)
}

export function writeScriptWriterOutGpt(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['out_gpt'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeOutGpt(value, opts)
}

export function writeScriptWriterOutLocations(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['out_locations'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeOutLocations(value, opts)
}

export function writeScriptWriterOutActiveModel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['out_active_model'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeOutActiveModel(value, opts)
}

export function writeScriptWriterOutSceneCount(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['out_scene_count'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeOutSceneCount(value, opts)
}

export function writeScriptWriterOutLogline(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['out_logline'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeOutLogline(value, opts)
}

export function writeScriptWriterOutGenreTone(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['out_genre_tone'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeOutGenreTone(value, opts)
}

export function writeScriptWriterOutSynopsis(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['out_synopsis'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeOutSynopsis(value, opts)
}

export function writeScriptWriterOutThemes(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['out_themes'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeOutThemes(value, opts)
}

export function writeScriptWriterOutScriptVariants(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ScriptWriterNodeWriteData['out_script_variants'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindScriptWriterCanvasNode(ynode).writeOutScriptVariants(value, opts)
}

export function writeShortVideoGroupInLabel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ShortVideoGroupNodeWriteData['in_label'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindShortVideoGroupCanvasNode(ynode).writeInLabel(value, opts)
}

export function writeShortVideoGroupInCollapsed(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ShortVideoGroupNodeWriteData['in_collapsed'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindShortVideoGroupCanvasNode(ynode).writeInCollapsed(value, opts)
}

export function writeShortVideoGroupInStoryboardPath(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ShortVideoGroupNodeWriteData['in_storyboard_path'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindShortVideoGroupCanvasNode(ynode).writeInStoryboardPath(value, opts)
}

export function writeShortVideoGroupInImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ShortVideoGroupNodeWriteData['in_image'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindShortVideoGroupCanvasNode(ynode).writeInImage(value, opts)
}

export function writeShortVideoGroupInChildNodeIds(
  ynode: Y.Map<YDocValue>,
  value: Exclude<ShortVideoGroupNodeWriteData['in_child_node_ids'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindShortVideoGroupCanvasNode(ynode).writeInChildNodeIds(value, opts)
}

export function writeSoundExpertInName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeWriteData['in_name'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSoundExpertCanvasNode(ynode).writeInName(value, opts)
}

export function writeSoundExpertInUpstream(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeWriteData['in_upstream'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSoundExpertCanvasNode(ynode).writeInUpstream(value, opts)
}

export function writeSoundExpertInPrompt(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeWriteData['in_prompt'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSoundExpertCanvasNode(ynode).writeInPrompt(value, opts)
}

export function writeSoundExpertInMode(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeWriteData['in_mode'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSoundExpertCanvasNode(ynode).writeInMode(value, opts)
}

export function writeSoundExpertInDuration(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeWriteData['in_duration'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSoundExpertCanvasNode(ynode).writeInDuration(value, opts)
}

export function writeSoundExpertInVoiceProfile(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeWriteData['in_voice_profile'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSoundExpertCanvasNode(ynode).writeInVoiceProfile(value, opts)
}

export function writeSoundExpertInText(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeWriteData['in_text'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSoundExpertCanvasNode(ynode).writeInText(value, opts)
}

export function writeSoundExpertInFeedback(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeWriteData['in_feedback'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSoundExpertCanvasNode(ynode).writeInFeedback(value, opts)
}

export function writeSoundExpertInFeedbackHistory(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeWriteData['in_feedback_history'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSoundExpertCanvasNode(ynode).writeInFeedbackHistory(value, opts)
}

export function writeSoundExpertInModel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeWriteData['in_model'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSoundExpertCanvasNode(ynode).writeInModel(value, opts)
}

export function writeSoundExpertInLoop(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeWriteData['in_loop'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSoundExpertCanvasNode(ynode).writeInLoop(value, opts)
}

export function writeSoundExpertInLyricsMode(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeWriteData['in_lyrics_mode'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSoundExpertCanvasNode(ynode).writeInLyricsMode(value, opts)
}

export function writeSoundExpertInVoiceMap(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeWriteData['in_voice_map'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSoundExpertCanvasNode(ynode).writeInVoiceMap(value, opts)
}

export function writeSoundExpertInSceneId(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeWriteData['in_scene_id'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSoundExpertCanvasNode(ynode).writeInSceneId(value, opts)
}

export function writeSoundExpertInPanelIndex(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeWriteData['in_panel_index'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSoundExpertCanvasNode(ynode).writeInPanelIndex(value, opts)
}

export function writeSoundExpertInPauseMs(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeWriteData['in_pause_ms'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSoundExpertCanvasNode(ynode).writeInPauseMs(value, opts)
}

export function writeSoundExpertInCharacterName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeWriteData['in_character_name'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSoundExpertCanvasNode(ynode).writeInCharacterName(value, opts)
}

export function writeSoundExpertInCharacterVoiceSourceFor(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeWriteData['in_character_voice_source_for'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSoundExpertCanvasNode(ynode).writeInCharacterVoiceSourceFor(value, opts)
}

export function writeSoundExpertOutDurationSeconds(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeWriteData['out_duration_seconds'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSoundExpertCanvasNode(ynode).writeOutDurationSeconds(value, opts)
}

export function writeSoundExpertOutAudio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeWriteData['out_audio'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSoundExpertCanvasNode(ynode).writeOutAudio(value, opts)
}

export function writeSoundExpertOutVoiceProfile(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SoundExpertNodeWriteData['out_voice_profile'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSoundExpertCanvasNode(ynode).writeOutVoiceProfile(value, opts)
}

export function writeSpeechGeneratorInMode(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeWriteData['in_mode'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSpeechGeneratorCanvasNode(ynode).writeInMode(value, opts)
}

export function writeSpeechGeneratorInScript(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeWriteData['in_script'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSpeechGeneratorCanvasNode(ynode).writeInScript(value, opts)
}

export function writeSpeechGeneratorInText(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeWriteData['in_text'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSpeechGeneratorCanvasNode(ynode).writeInText(value, opts)
}

export function writeSpeechGeneratorInCharacterName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeWriteData['in_character_name'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSpeechGeneratorCanvasNode(ynode).writeInCharacterName(value, opts)
}

export function writeSpeechGeneratorInVoiceId(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeWriteData['in_voice_id'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSpeechGeneratorCanvasNode(ynode).writeInVoiceId(value, opts)
}

export function writeSpeechGeneratorInVoiceProfile(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeWriteData['in_voice_profile'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSpeechGeneratorCanvasNode(ynode).writeInVoiceProfile(value, opts)
}

export function writeSpeechGeneratorInVoiceMap(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeWriteData['in_voice_map'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSpeechGeneratorCanvasNode(ynode).writeInVoiceMap(value, opts)
}

export function writeSpeechGeneratorInSceneId(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeWriteData['in_scene_id'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSpeechGeneratorCanvasNode(ynode).writeInSceneId(value, opts)
}

export function writeSpeechGeneratorInPanelIndex(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeWriteData['in_panel_index'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSpeechGeneratorCanvasNode(ynode).writeInPanelIndex(value, opts)
}

export function writeSpeechGeneratorInPauseMs(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeWriteData['in_pause_ms'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSpeechGeneratorCanvasNode(ynode).writeInPauseMs(value, opts)
}

export function writeSpeechGeneratorInPronunciationGuide(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeWriteData['in_pronunciation_guide'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSpeechGeneratorCanvasNode(ynode).writeInPronunciationGuide(value, opts)
}

export function writeSpeechGeneratorInLanguageCode(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeWriteData['in_language_code'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSpeechGeneratorCanvasNode(ynode).writeInLanguageCode(value, opts)
}

export function writeSpeechGeneratorOutDurationSeconds(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeWriteData['out_duration_seconds'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSpeechGeneratorCanvasNode(ynode).writeOutDurationSeconds(value, opts)
}

export function writeSpeechGeneratorOutWaveform(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeWriteData['out_waveform'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSpeechGeneratorCanvasNode(ynode).writeOutWaveform(value, opts)
}

export function writeSpeechGeneratorOutAudio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<SpeechGeneratorNodeWriteData['out_audio'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindSpeechGeneratorCanvasNode(ynode).writeOutAudio(value, opts)
}

export function writeStoryboardDesignerInScript(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['in_script'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeInScript(value, opts)
}

export function writeStoryboardDesignerInCharacters(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['in_characters'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeInCharacters(value, opts)
}

export function writeStoryboardDesignerInCharacterNames(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['in_character_names'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeInCharacterNames(value, opts)
}

export function writeStoryboardDesignerInLocations(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['in_locations'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeInLocations(value, opts)
}

export function writeStoryboardDesignerInLocationNames(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['in_location_names'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeInLocationNames(value, opts)
}

export function writeStoryboardDesignerInObjects(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['in_objects'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeInObjects(value, opts)
}

export function writeStoryboardDesignerInObjectNames(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['in_object_names'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeInObjectNames(value, opts)
}

export function writeStoryboardDesignerInImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['in_image'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeInImage(value, opts)
}

export function writeStoryboardDesignerInStyle(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['in_style'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeInStyle(value, opts)
}

export function writeStoryboardDesignerInPanelCount(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['in_panel_count'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeInPanelCount(value, opts)
}

export function writeStoryboardDesignerInShotCount(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['in_shot_count'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeInShotCount(value, opts)
}

export function writeStoryboardDesignerInAspectRatio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['in_aspect_ratio'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeInAspectRatio(value, opts)
}

export function writeStoryboardDesignerInSceneId(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['in_scene_id'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeInSceneId(value, opts)
}

export function writeStoryboardDesignerInName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['in_name'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeInName(value, opts)
}

export function writeStoryboardDesignerInLocation(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['in_location'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeInLocation(value, opts)
}

export function writeStoryboardDesignerInModel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['in_model'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeInModel(value, opts)
}

export function writeStoryboardDesignerInFeedback(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['in_feedback'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeInFeedback(value, opts)
}

export function writeStoryboardDesignerInVlmValidation(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['in_vlm_validation'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeInVlmValidation(value, opts)
}

export function writeStoryboardDesignerInVideoAnchors(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['in_video_anchors'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeInVideoAnchors(value, opts)
}

export function writeStoryboardDesignerOutImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['out_image'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeOutImage(value, opts)
}

export function writeStoryboardDesignerOutGridImages(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['out_grid_images'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeOutGridImages(value, opts)
}

export function writeStoryboardDesignerOutMetadata(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['out_metadata'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeOutMetadata(value, opts)
}

export function writeStoryboardDesignerOutBeats(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['out_beats'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeOutBeats(value, opts)
}

export function writeStoryboardDesignerOutShots(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['out_shots'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeOutShots(value, opts)
}

export function writeStoryboardDesignerOutShotSeams(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['out_shot_seams'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeOutShotSeams(value, opts)
}

export function writeStoryboardDesignerOutProductionPlan(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['out_production_plan'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeOutProductionPlan(value, opts)
}

export function writeStoryboardDesignerOutVideoGenerationPlan(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['out_video_generation_plan'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeOutVideoGenerationPlan(value, opts)
}

export function writeStoryboardDesignerOutVideoPreviousPlan(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['out_video_previous_plan'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeOutVideoPreviousPlan(value, opts)
}

export function writeStoryboardDesignerOutStartFrames(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['out_start_frames'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeOutStartFrames(value, opts)
}

export function writeStoryboardDesignerOutKeyFrames(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['out_key_frames'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeOutKeyFrames(value, opts)
}

export function writeStoryboardDesignerOutEndFrames(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['out_end_frames'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeOutEndFrames(value, opts)
}

export function writeStoryboardDesignerOutStartFramePrompts(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['out_start_frame_prompts'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeOutStartFramePrompts(value, opts)
}

export function writeStoryboardDesignerOutKeyFramePrompts(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['out_key_frame_prompts'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeOutKeyFramePrompts(value, opts)
}

export function writeStoryboardDesignerOutEndFramePrompts(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['out_end_frame_prompts'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeOutEndFramePrompts(value, opts)
}

export function writeStoryboardDesignerOutFrameLinks(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['out_frame_links'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeOutFrameLinks(value, opts)
}

export function writeStoryboardDesignerOutPanelRefs(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['out_panel_refs'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeOutPanelRefs(value, opts)
}

export function writeStoryboardDesignerOutImages(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['out_images'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeOutImages(value, opts)
}

export function writeStoryboardDesignerOutGridDescriptions(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['out_grid_descriptions'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeOutGridDescriptions(value, opts)
}

export function writeStoryboardDesignerOutVlmReport(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardDesignerNodeWriteData['out_vlm_report'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardDesignerCanvasNode(ynode).writeOutVlmReport(value, opts)
}

export function writeStoryboardNoEnhanceDesignerInScript(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_script'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardNoEnhanceDesignerCanvasNode(ynode).writeInScript(value, opts)
}

export function writeStoryboardNoEnhanceDesignerInCharacters(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_characters'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardNoEnhanceDesignerCanvasNode(ynode).writeInCharacters(value, opts)
}

export function writeStoryboardNoEnhanceDesignerInCharacterNames(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_character_names'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardNoEnhanceDesignerCanvasNode(ynode).writeInCharacterNames(value, opts)
}

export function writeStoryboardNoEnhanceDesignerInLocations(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_locations'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardNoEnhanceDesignerCanvasNode(ynode).writeInLocations(value, opts)
}

export function writeStoryboardNoEnhanceDesignerInLocationNames(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_location_names'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardNoEnhanceDesignerCanvasNode(ynode).writeInLocationNames(value, opts)
}

export function writeStoryboardNoEnhanceDesignerInStyle(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_style'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardNoEnhanceDesignerCanvasNode(ynode).writeInStyle(value, opts)
}

export function writeStoryboardNoEnhanceDesignerInPanelCount(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_panel_count'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardNoEnhanceDesignerCanvasNode(ynode).writeInPanelCount(value, opts)
}

export function writeStoryboardNoEnhanceDesignerInSceneId(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_scene_id'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardNoEnhanceDesignerCanvasNode(ynode).writeInSceneId(value, opts)
}

export function writeStoryboardNoEnhanceDesignerInLocation(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_location'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardNoEnhanceDesignerCanvasNode(ynode).writeInLocation(value, opts)
}

export function writeStoryboardNoEnhanceDesignerInModel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_model'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardNoEnhanceDesignerCanvasNode(ynode).writeInModel(value, opts)
}

export function writeStoryboardNoEnhanceDesignerInVlmValidation(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_vlm_validation'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardNoEnhanceDesignerCanvasNode(ynode).writeInVlmValidation(value, opts)
}

export function writeStoryboardNoEnhanceDesignerOutImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['out_image'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardNoEnhanceDesignerCanvasNode(ynode).writeOutImage(value, opts)
}

export function writeStoryboardNoEnhanceDesignerOutVlmReport(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['out_vlm_report'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStoryboardNoEnhanceDesignerCanvasNode(ynode).writeOutVlmReport(value, opts)
}

export function writeStyleSelectorOutStyle(
  ynode: Y.Map<YDocValue>,
  value: Exclude<StyleSelectorNodeWriteData['out_style'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindStyleSelectorCanvasNode(ynode).writeOutStyle(value, opts)
}

export function writeTextInInput(
  ynode: Y.Map<YDocValue>,
  value: Exclude<TextNodeWriteData['in_input'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindTextCanvasNode(ynode).writeInInput(value, opts)
}

export function writeTextOutText(
  ynode: Y.Map<YDocValue>,
  value: Exclude<TextNodeWriteData['out_text'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindTextCanvasNode(ynode).writeOutText(value, opts)
}

export function writeVideoInFileName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoNodeWriteData['in_file_name'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoCanvasNode(ynode).writeInFileName(value, opts)
}

export function writeVideoInDepthIncludeAudio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoNodeWriteData['in_depth_include_audio'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoCanvasNode(ynode).writeInDepthIncludeAudio(value, opts)
}

export function writeVideoInTransformVideo(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoNodeWriteData['in_transform_video'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoCanvasNode(ynode).writeInTransformVideo(value, opts)
}

export function writeVideoInTransformTargetResolution(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoNodeWriteData['in_transform_target_resolution'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoCanvasNode(ynode).writeInTransformTargetResolution(value, opts)
}

export function writeVideoInTransformSourceAssetPath(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoNodeWriteData['in_transform_source_asset_path'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoCanvasNode(ynode).writeInTransformSourceAssetPath(value, opts)
}

export function writeVideoInTransformSourceContentSha256(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoNodeWriteData['in_transform_source_content_sha256'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoCanvasNode(ynode).writeInTransformSourceContentSha256(value, opts)
}

export function writeVideoInTransformSourceWidth(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoNodeWriteData['in_transform_source_width'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoCanvasNode(ynode).writeInTransformSourceWidth(value, opts)
}

export function writeVideoInTransformSourceHeight(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoNodeWriteData['in_transform_source_height'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoCanvasNode(ynode).writeInTransformSourceHeight(value, opts)
}

export function writeVideoInTransformSourceFrameCount(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoNodeWriteData['in_transform_source_frame_count'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoCanvasNode(ynode).writeInTransformSourceFrameCount(value, opts)
}

export function writeVideoInTransformSourceFps(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoNodeWriteData['in_transform_source_fps'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoCanvasNode(ynode).writeInTransformSourceFps(value, opts)
}

export function writeVideoOutVideo(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoNodeWriteData['out_video'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoCanvasNode(ynode).writeOutVideo(value, opts)
}

export function writeVideoEditorInReferenceMedia(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeWriteData['in_reference_media'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoEditorCanvasNode(ynode).writeInReferenceMedia(value, opts)
}

export function writeVideoEditorInVideos(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeWriteData['in_videos'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoEditorCanvasNode(ynode).writeInVideos(value, opts)
}

export function writeVideoEditorInAudios(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeWriteData['in_audios'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoEditorCanvasNode(ynode).writeInAudios(value, opts)
}

export function writeVideoEditorInAudio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeWriteData['in_audio'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoEditorCanvasNode(ynode).writeInAudio(value, opts)
}

export function writeVideoEditorInVideoConfig(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeWriteData['in_video_config'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoEditorCanvasNode(ynode).writeInVideoConfig(value, opts)
}

export function writeVideoEditorInEditSpec(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeWriteData['in_edit_spec'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoEditorCanvasNode(ynode).writeInEditSpec(value, opts)
}

export function writeVideoEditorInMode(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeWriteData['in_mode'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoEditorCanvasNode(ynode).writeInMode(value, opts)
}

export function writeVideoEditorInOutputName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeWriteData['in_output_name'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoEditorCanvasNode(ynode).writeInOutputName(value, opts)
}

export function writeVideoEditorInStart(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeWriteData['in_start'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoEditorCanvasNode(ynode).writeInStart(value, opts)
}

export function writeVideoEditorInEnd(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeWriteData['in_end'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoEditorCanvasNode(ynode).writeInEnd(value, opts)
}

export function writeVideoEditorInVolume(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeWriteData['in_volume'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoEditorCanvasNode(ynode).writeInVolume(value, opts)
}

export function writeVideoEditorInExportName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeWriteData['in_export_name'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoEditorCanvasNode(ynode).writeInExportName(value, opts)
}

export function writeVideoEditorOutVideo(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeWriteData['out_video'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoEditorCanvasNode(ynode).writeOutVideo(value, opts)
}

export function writeVideoEditorOutRenderedSpecHash(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeWriteData['out_rendered_spec_hash'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoEditorCanvasNode(ynode).writeOutRenderedSpecHash(value, opts)
}

export function writeVideoEditorOutRenderSources(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoEditorNodeWriteData['out_render_sources'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoEditorCanvasNode(ynode).writeOutRenderSources(value, opts)
}

export function writeVideoGeneratorInReferenceMedia(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_reference_media'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInReferenceMedia(value, opts)
}

export function writeVideoGeneratorInMode(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_mode'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInMode(value, opts)
}

export function writeVideoGeneratorInSceneId(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_scene_id'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInSceneId(value, opts)
}

export function writeVideoGeneratorInClipNumber(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_clip_number'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInClipNumber(value, opts)
}

export function writeVideoGeneratorInImages(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_images'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInImages(value, opts)
}

export function writeVideoGeneratorInReferenceVideos(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_reference_videos'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInReferenceVideos(value, opts)
}

export function writeVideoGeneratorInContinuationSource(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_continuation_source'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInContinuationSource(value, opts)
}

export function writeVideoGeneratorInShotListSourceId(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_shot_list_source_id'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInShotListSourceId(value, opts)
}

export function writeVideoGeneratorInShotListSourceFingerprint(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_shot_list_source_fingerprint'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInShotListSourceFingerprint(value, opts)
}

export function writeVideoGeneratorInShotListRequestFingerprint(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_shot_list_request_fingerprint'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInShotListRequestFingerprint(value, opts)
}

export function writeVideoGeneratorInReferenceAudios(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_reference_audios'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInReferenceAudios(value, opts)
}

export function writeVideoGeneratorInAudio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_audio'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInAudio(value, opts)
}

export function writeVideoGeneratorInMotionPrompt(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_motion_prompt'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInMotionPrompt(value, opts)
}

export function writeVideoGeneratorInSceneContext(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_scene_context'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInSceneContext(value, opts)
}

export function writeVideoGeneratorInDuration(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_duration'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInDuration(value, opts)
}

export function writeVideoGeneratorInReferenceVideoEdits(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_reference_video_edits'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInReferenceVideoEdits(value, opts)
}

export function writeVideoGeneratorInDialoguePrompt(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_dialogue_prompt'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInDialoguePrompt(value, opts)
}

export function writeVideoGeneratorInModel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_model'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInModel(value, opts)
}

export function writeVideoGeneratorInAspectRatio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_aspect_ratio'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInAspectRatio(value, opts)
}

export function writeVideoGeneratorInResolution(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_resolution'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInResolution(value, opts)
}

export function writeVideoGeneratorInGenerateAudio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_generate_audio'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInGenerateAudio(value, opts)
}

export function writeVideoGeneratorInProviderGenerateAudio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_provider_generate_audio'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInProviderGenerateAudio(value, opts)
}

export function writeVideoGeneratorInUseVoiceProfileAudioReferences(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_use_voice_profile_audio_references'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInUseVoiceProfileAudioReferences(value, opts)
}

export function writeVideoGeneratorInAudioRemixMode(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_audio_remix_mode'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInAudioRemixMode(value, opts)
}

export function writeVideoGeneratorInAllowBgm(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_allow_bgm'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInAllowBgm(value, opts)
}

export function writeVideoGeneratorInTtsProvider(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_tts_provider'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInTtsProvider(value, opts)
}

export function writeVideoGeneratorInDubTargetLanguage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_dub_target_language'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInDubTargetLanguage(value, opts)
}

export function writeVideoGeneratorInVoiceProfiles(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_voice_profiles'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInVoiceProfiles(value, opts)
}

export function writeVideoGeneratorInVoiceSettings(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_voice_settings'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInVoiceSettings(value, opts)
}

export function writeVideoGeneratorInName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_name'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInName(value, opts)
}

export function writeVideoGeneratorInResolvedVoiceMap(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_resolved_voice_map'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInResolvedVoiceMap(value, opts)
}

export function writeVideoGeneratorInAudioRemixConfig(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_audio_remix_config'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInAudioRemixConfig(value, opts)
}

export function writeVideoGeneratorInSpeechTransformerConfig(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_speech_transformer_config'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInSpeechTransformerConfig(value, opts)
}

export function writeVideoGeneratorInAudioTakeSelections(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_audio_take_selections'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInAudioTakeSelections(value, opts)
}

export function writeVideoGeneratorInAudioVariantWorkspaces(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_audio_variant_workspaces'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInAudioVariantWorkspaces(value, opts)
}

export function writeVideoGeneratorInUnifiedAudioConfig(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_unified_audio_config'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInUnifiedAudioConfig(value, opts)
}

export function writeVideoGeneratorInStyle(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['in_style'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeInStyle(value, opts)
}

export function writeVideoGeneratorOutVideo(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['out_video'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeOutVideo(value, opts)
}

export function writeVideoGeneratorOutTtsSegments(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['out_tts_segments'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeOutTtsSegments(value, opts)
}

export function writeVideoGeneratorOutAudioRemixBaseline(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['out_audio_remix_baseline'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeOutAudioRemixBaseline(value, opts)
}

export function writeVideoGeneratorOutSpeechTransformerSpans(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['out_speech_transformer_spans'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeOutSpeechTransformerSpans(value, opts)
}

export function writeVideoGeneratorOutAutoDialogue(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['out_auto_dialogue'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeOutAutoDialogue(value, opts)
}

export function writeVideoGeneratorOutSpeechWindows(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['out_speech_windows'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeOutSpeechWindows(value, opts)
}

export function writeVideoGeneratorOutNativeSpeechTakes(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['out_native_speech_takes'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeOutNativeSpeechTakes(value, opts)
}

export function writeVideoGeneratorOutNativeSpeechSpans(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['out_native_speech_spans'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeOutNativeSpeechSpans(value, opts)
}

export function writeVideoGeneratorOutNativeSpeechDetectSeq(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['out_native_speech_detect_seq'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeOutNativeSpeechDetectSeq(value, opts)
}

export function writeVideoGeneratorOutVideoPrompt(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['out_video_prompt'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeOutVideoPrompt(value, opts)
}

export function writeVideoGeneratorOutVideoDuration(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['out_video_duration'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeOutVideoDuration(value, opts)
}

export function writeVideoGeneratorOutDialogue(
  ynode: Y.Map<YDocValue>,
  value: Exclude<VideoGeneratorNodeWriteData['out_dialogue'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindVideoGeneratorCanvasNode(ynode).writeOutDialogue(value, opts)
}

export function writeWebtoonGroupInSceneId(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonGroupNodeWriteData['in_scene_id'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindWebtoonGroupCanvasNode(ynode).writeInSceneId(value, opts)
}

export function writeWebtoonGroupInLabel(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonGroupNodeWriteData['in_label'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindWebtoonGroupCanvasNode(ynode).writeInLabel(value, opts)
}

export function writeWebtoonGroupInCollapsed(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonGroupNodeWriteData['in_collapsed'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindWebtoonGroupCanvasNode(ynode).writeInCollapsed(value, opts)
}

export function writeWebtoonGroupInChildNodeIds(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonGroupNodeWriteData['in_child_node_ids'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindWebtoonGroupCanvasNode(ynode).writeInChildNodeIds(value, opts)
}

export function writeWebtoonPanelGeneratorInImages(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeWriteData['in_images'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindWebtoonPanelGeneratorCanvasNode(ynode).writeInImages(value, opts)
}

export function writeWebtoonPanelGeneratorInPrompt(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeWriteData['in_prompt'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindWebtoonPanelGeneratorCanvasNode(ynode).writeInPrompt(value, opts)
}

export function writeWebtoonPanelGeneratorInBeats(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeWriteData['in_beats'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindWebtoonPanelGeneratorCanvasNode(ynode).writeInBeats(value, opts)
}

export function writeWebtoonPanelGeneratorInDialogue(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeWriteData['in_dialogue'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindWebtoonPanelGeneratorCanvasNode(ynode).writeInDialogue(value, opts)
}

export function writeWebtoonPanelGeneratorInPanelIndex(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeWriteData['in_panel_index'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindWebtoonPanelGeneratorCanvasNode(ynode).writeInPanelIndex(value, opts)
}

export function writeWebtoonPanelGeneratorInAspectRatio(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeWriteData['in_aspect_ratio'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindWebtoonPanelGeneratorCanvasNode(ynode).writeInAspectRatio(value, opts)
}

export function writeWebtoonPanelGeneratorInLayout(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeWriteData['in_layout'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindWebtoonPanelGeneratorCanvasNode(ynode).writeInLayout(value, opts)
}

export function writeWebtoonPanelGeneratorInStyle(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeWriteData['in_style'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindWebtoonPanelGeneratorCanvasNode(ynode).writeInStyle(value, opts)
}

export function writeWebtoonPanelGeneratorInName(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeWriteData['in_name'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindWebtoonPanelGeneratorCanvasNode(ynode).writeInName(value, opts)
}

export function writeWebtoonPanelGeneratorInFeedback(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeWriteData['in_feedback'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindWebtoonPanelGeneratorCanvasNode(ynode).writeInFeedback(value, opts)
}

export function writeWebtoonPanelGeneratorInFeedbackHistory(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeWriteData['in_feedback_history'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindWebtoonPanelGeneratorCanvasNode(ynode).writeInFeedbackHistory(value, opts)
}

export function writeWebtoonPanelGeneratorOutImage(
  ynode: Y.Map<YDocValue>,
  value: Exclude<WebtoonPanelGeneratorNodeWriteData['out_image'], undefined>,
  opts?: YDocWriteOpts,
): boolean {
  return bindWebtoonPanelGeneratorCanvasNode(ynode).writeOutImage(value, opts)
}

// ---------------------------------------------------------------------------
// Generated downstream input flushing
// ---------------------------------------------------------------------------

export type YDocInputFlushEdgeRef = {
  source: string
  sourceHandle?: string
  toIndex?: number
  fromIndex?: number
}

export type YDocInputFlushNode = {
  id: string
  type?: string | null
  data?: unknown
}

export type YDocInputFlushResult = {
  field: string
  value: YDocWriteValue
  written: boolean
}

type _TypedInputFlushNode<T extends FeNodeType> = {
  id: string
  type: T
  data?: Partial<ReactFlowCanvasNodeDataByType[T]>
}

type _IndexedInputFlushValue<T> = {
  toIndex?: number
  edgeOrder: number
  valueOrder: number
  value: T
}

function _isInputFlushNodeType<T extends FeNodeType>(
  node: YDocInputFlushNode | undefined,
  type: T,
): node is _TypedInputFlushNode<T> {
  return node?.type === type
}

function _orderedInputFlushEdges(
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushEdgeRef[] {
  return [...edgeRefs].sort((left, right) => {
    if (left.toIndex === undefined && right.toIndex !== undefined) return 1
    if (left.toIndex !== undefined && right.toIndex === undefined) return -1
    if (left.toIndex !== undefined && right.toIndex !== undefined) {
      return left.toIndex - right.toIndex
    }
    return 0
  })
}

function _findInputFlushNode(
  nodes: readonly YDocInputFlushNode[],
  nodeId: string,
): YDocInputFlushNode | undefined {
  return nodes.find((node) => node.id === nodeId)
}

function _missingInputFlushFromIndex(sourcePort: string, targetPort: string): never {
  throw new Error(`${targetPort} requires fromIndex when flushing ${sourcePort}`)
}

function _throwUnsupportedInputFlushEdge(
  sourceType: string | null | undefined,
  sourceHandle: string | undefined,
  targetPort: string,
): never {
  const renderedSource = `${sourceType ?? '<missing>'}.${sourceHandle ?? '<missing>'}`
  throw new Error(`Unsupported generated input flush edge ${renderedSource} -> ${targetPort}`)
}

function _selectIndexedInputFlushValue<T>(
  value: { readonly length: number; get(i: number): T } | readonly T[] | undefined,
  fromIndex: number | undefined,
  sourcePort: string,
  targetPort: string,
): T | undefined {
  if (fromIndex === undefined) return _missingInputFlushFromIndex(sourcePort, targetPort)
  if (value === undefined) return undefined
  if (fromIndex < 0 || fromIndex >= value.length) return undefined
  if (Array.isArray(value)) return value[fromIndex]
  return (value as { get(i: number): T }).get(fromIndex)
}

function _pushIndexedInputFlushValue<T>(
  values: Array<_IndexedInputFlushValue<T>>,
  edge: YDocInputFlushEdgeRef,
  edgeOrder: number,
  valueOrder: number,
  value: T,
): void {
  values.push({
    toIndex: edge.toIndex === undefined ? undefined : edge.toIndex + valueOrder,
    edgeOrder,
    valueOrder,
    value,
  })
}

function _pushIndexedInputFlushValues<T>(
  values: Array<_IndexedInputFlushValue<T>>,
  edge: YDocInputFlushEdgeRef,
  edgeOrder: number,
  edgeValues: { readonly length: number; get(i: number): T } | readonly T[],
): void {
  if (Array.isArray(edgeValues)) {
    edgeValues.forEach((value, valueOrder) =>
      _pushIndexedInputFlushValue(values, edge, edgeOrder, valueOrder, value),
    )
    return
  }
  const yArr = edgeValues as { readonly length: number; get(i: number): T }
  for (let i = 0; i < yArr.length; i++) {
    _pushIndexedInputFlushValue(values, edge, edgeOrder, i, yArr.get(i))
  }
}

function _orderedInputFlushValues<T>(
  values: Array<_IndexedInputFlushValue<T>>,
): T[] {
  return values
    .sort((left, right) => {
      if (left.toIndex === undefined && right.toIndex !== undefined) return 1
      if (left.toIndex !== undefined && right.toIndex === undefined) return -1
      if (left.toIndex !== undefined && right.toIndex !== undefined) {
        if (left.toIndex !== right.toIndex) return left.toIndex - right.toIndex
      }
      if (left.edgeOrder !== right.edgeOrder) return left.edgeOrder - right.edgeOrder
      return left.valueOrder - right.valueOrder
    })
    .map((item) => item.value)
}

function _inputFlushMapEntry(value: YDocWriteValue, key: string): YDocWriteValue | undefined {
  if (value == null) return undefined
  if (value instanceof Y.Map) return value.get(key)
  if (value instanceof YMapWrapper) return value.get(key)
  if (value instanceof YMapRecord) return value.get(key) as YDocWriteValue | undefined
  if (_isYDocWriteObject(value)) return value[key]
  return undefined
}

function _imageAssetRefFromDesignerAsset(value: YDocWriteValue): YDocWriteValue | undefined {
  return _inputFlushMapEntry(_inputFlushMapEntry(value, 'images'), 'main')
}

export type YDocInputFlushTarget = {
  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined
}

export function flushYDocInputFromEdgeRefs(
  target: YDocInputFlushTarget,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocInputFlushResult | undefined {
  return target.flushInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
}

function _resolveAudioInFileNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'audio.in_file_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'audio.in_file_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'audio.in_file_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'audio.in_file_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'audio.in_file_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'audio.in_file_name')
  }
  return undefined
}

function _resolveAudioInVoiceProfileInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_voice_profile') {
      const value = sourceNode.data?.out_voice_profile
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_voice_profiles') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_voice_profiles, edge.fromIndex, 'scriptWriter.out_voice_profiles', 'audio.in_voice_profile')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_voice_profile') {
      const value = sourceNode.data?.out_voice_profile
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'audio.in_voice_profile')
  }
  return undefined
}

function _resolveCharacterDesignerInUpstreamInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_upstream')
  }
  return undefined
}

function _resolveCharacterDesignerInImagesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_images, edge.fromIndex, 'storyboardDesigner.out_grid_images', 'characterDesigner.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frames, edge.fromIndex, 'storyboardDesigner.out_start_frames', 'characterDesigner.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_start_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frames, edge.fromIndex, 'storyboardDesigner.out_key_frames', 'characterDesigner.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_key_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frames, edge.fromIndex, 'storyboardDesigner.out_end_frames', 'characterDesigner.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_end_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'characterDesigner.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_images')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveCharacterDesignerInNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'characterDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'characterDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'characterDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'characterDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'characterDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_name')
  }
  return undefined
}

function _resolveCharacterDesignerInRoleInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'characterDesigner.in_role')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'characterDesigner.in_role')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'characterDesigner.in_role')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'characterDesigner.in_role')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'characterDesigner.in_role')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_role')
  }
  return undefined
}

function _resolveCharacterDesignerInStyleInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'characterDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'characterDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'characterDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'characterDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'characterDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_style')
  }
  return undefined
}

function _resolveCharacterDesignerInDescriptionInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'characterDesigner.in_description')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'characterDesigner.in_description')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'characterDesigner.in_description')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'characterDesigner.in_description')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'characterDesigner.in_description')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_description')
  }
  return undefined
}

function _resolveCharacterDesignerInModelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'characterDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'characterDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'characterDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'characterDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'characterDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_model')
  }
  return undefined
}

function _resolveCharacterDesignerInFeedbackInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'characterDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'characterDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'characterDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'characterDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'characterDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_feedback')
  }
  return undefined
}

function _resolveCharacterDesignerInFeedbackHistoryInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_feedback_history')
  }
  return undefined
}

function _resolveCharacterDesignerInPronunciationGuideInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'characterDesigner.in_pronunciation_guide')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'characterDesigner.in_pronunciation_guide')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'characterDesigner.in_pronunciation_guide')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'characterDesigner.in_pronunciation_guide')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'characterDesigner.in_pronunciation_guide')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_pronunciation_guide')
  }
  return undefined
}

function _resolveCharacterDesignerInBgColorInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'characterDesigner.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'characterDesigner.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'characterDesigner.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'characterDesigner.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'characterDesigner.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_bg_color')
  }
  return undefined
}

function _resolveCharacterDesignerInVlmValidationInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'characterDesigner.in_vlm_validation')
  }
  return undefined
}

function _resolveDebugHangInLabelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'debugHang.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'debugHang.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'debugHang.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'debugHang.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'debugHang.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'debugHang.in_label')
  }
  return undefined
}

function _resolveDirectorInContextInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'director.in_context')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'director.in_context')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'director.in_context')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'director.in_context')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'director.in_context')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'director.in_context')
  }
  return undefined
}

function _resolveImageInFileNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'image.in_file_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'image.in_file_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'image.in_file_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'image.in_file_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'image.in_file_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'image.in_file_name')
  }
  return undefined
}

function _resolveImageInImageInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) return edgeValue
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) return edgeValue
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) return edgeValue
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_images') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_images, edge.fromIndex, 'storyboardDesigner.out_grid_images', 'image.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frames') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frames, edge.fromIndex, 'storyboardDesigner.out_start_frames', 'image.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frames') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frames, edge.fromIndex, 'storyboardDesigner.out_key_frames', 'image.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frames') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frames, edge.fromIndex, 'storyboardDesigner.out_end_frames', 'image.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'image.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'image.in_image')
  }
  return undefined
}

function _resolveImageGeneratorInImagesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_images, edge.fromIndex, 'storyboardDesigner.out_grid_images', 'imageGenerator.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frames, edge.fromIndex, 'storyboardDesigner.out_start_frames', 'imageGenerator.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_start_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frames, edge.fromIndex, 'storyboardDesigner.out_key_frames', 'imageGenerator.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_key_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frames, edge.fromIndex, 'storyboardDesigner.out_end_frames', 'imageGenerator.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_end_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'imageGenerator.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_images')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveImageGeneratorInUpstreamInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_upstream')
  }
  return undefined
}

function _resolveImageGeneratorInNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'imageGenerator.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'imageGenerator.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'imageGenerator.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'imageGenerator.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'imageGenerator.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_name')
  }
  return undefined
}

function _resolveImageGeneratorInPromptInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'imageGenerator.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'imageGenerator.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'imageGenerator.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'imageGenerator.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'imageGenerator.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_prompt')
  }
  return undefined
}

function _resolveImageGeneratorInAspectRatioInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_aspect_ratio')
  }
  return undefined
}

function _resolveImageGeneratorInStyleInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'imageGenerator.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'imageGenerator.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'imageGenerator.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'imageGenerator.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'imageGenerator.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_style')
  }
  return undefined
}

function _resolveImageGeneratorInQualityInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'imageGenerator.in_quality')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'imageGenerator.in_quality')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'imageGenerator.in_quality')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'imageGenerator.in_quality')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'imageGenerator.in_quality')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_quality')
  }
  return undefined
}

function _resolveImageGeneratorInModelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'imageGenerator.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'imageGenerator.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'imageGenerator.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'imageGenerator.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'imageGenerator.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_model')
  }
  return undefined
}

function _resolveImageGeneratorInPanelRefsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_character_ids') {
      const value = sourceNode.data?.out_character_ids
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_characters') {
      const value = sourceNode.data?.out_characters
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_locations') {
      const value = sourceNode.data?.out_locations
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_panel_refs') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_panel_refs, edge.fromIndex, 'storyboardDesigner.out_panel_refs', 'imageGenerator.in_panel_refs')
      if (selected !== undefined) return selected
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_panel_refs')
  }
  return undefined
}

function _resolveImageGeneratorInUpdateInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_update')
  }
  return undefined
}

function _resolveImageGeneratorInImageInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) return edgeValue
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) return edgeValue
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) return edgeValue
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_images') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_images, edge.fromIndex, 'storyboardDesigner.out_grid_images', 'imageGenerator.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frames') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frames, edge.fromIndex, 'storyboardDesigner.out_start_frames', 'imageGenerator.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frames') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frames, edge.fromIndex, 'storyboardDesigner.out_key_frames', 'imageGenerator.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frames') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frames, edge.fromIndex, 'storyboardDesigner.out_end_frames', 'imageGenerator.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'imageGenerator.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_image')
  }
  return undefined
}

function _resolveImageGeneratorInFeedbackInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'imageGenerator.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'imageGenerator.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'imageGenerator.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'imageGenerator.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'imageGenerator.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_feedback')
  }
  return undefined
}

function _resolveImageGeneratorInVideoInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'imageGenerator.in_video')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'imageGenerator.in_video')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'imageGenerator.in_video')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'imageGenerator.in_video')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'imageGenerator.in_video')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_video')
  }
  return undefined
}

function _resolveImageGeneratorInSourceVideoInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_source_video')
  }
  return undefined
}

function _resolveImageGeneratorInExpectedVideoDurationMsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_scene_count') {
      const value = sourceNode.data?.out_scene_count
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_native_speech_detect_seq') {
      const value = sourceNode.data?.out_native_speech_detect_seq
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_expected_video_duration_ms')
  }
  return undefined
}

function _resolveImageGeneratorInFrameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'imageGenerator.in_frame')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'imageGenerator.in_frame')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'imageGenerator.in_frame')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'imageGenerator.in_frame')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'imageGenerator.in_frame')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_frame')
  }
  return undefined
}

function _resolveImageGeneratorInGetFrameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_get_frame')
  }
  return undefined
}

function _resolveImageGeneratorInFeedbackHistoryInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_feedback_history')
  }
  return undefined
}

function _resolveImageGeneratorInVlmValidationInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'imageGenerator.in_vlm_validation')
  }
  return undefined
}

function _resolveLocationDesignerInImagesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_images, edge.fromIndex, 'storyboardDesigner.out_grid_images', 'locationDesigner.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frames, edge.fromIndex, 'storyboardDesigner.out_start_frames', 'locationDesigner.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_start_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frames, edge.fromIndex, 'storyboardDesigner.out_key_frames', 'locationDesigner.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_key_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frames, edge.fromIndex, 'storyboardDesigner.out_end_frames', 'locationDesigner.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_end_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'locationDesigner.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'locationDesigner.in_images')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveLocationDesignerInNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'locationDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'locationDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'locationDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'locationDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'locationDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'locationDesigner.in_name')
  }
  return undefined
}

function _resolveLocationDesignerInStyleInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'locationDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'locationDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'locationDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'locationDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'locationDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'locationDesigner.in_style')
  }
  return undefined
}

function _resolveLocationDesignerInTimeOfDayInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'locationDesigner.in_time_of_day')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'locationDesigner.in_time_of_day')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'locationDesigner.in_time_of_day')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'locationDesigner.in_time_of_day')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'locationDesigner.in_time_of_day')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'locationDesigner.in_time_of_day')
  }
  return undefined
}

function _resolveLocationDesignerInWeatherInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'locationDesigner.in_weather')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'locationDesigner.in_weather')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'locationDesigner.in_weather')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'locationDesigner.in_weather')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'locationDesigner.in_weather')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'locationDesigner.in_weather')
  }
  return undefined
}

function _resolveLocationDesignerInDescriptionInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'locationDesigner.in_description')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'locationDesigner.in_description')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'locationDesigner.in_description')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'locationDesigner.in_description')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'locationDesigner.in_description')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'locationDesigner.in_description')
  }
  return undefined
}

function _resolveLocationDesignerInModelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'locationDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'locationDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'locationDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'locationDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'locationDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'locationDesigner.in_model')
  }
  return undefined
}

function _resolveLocationDesignerInFeedbackInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'locationDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'locationDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'locationDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'locationDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'locationDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'locationDesigner.in_feedback')
  }
  return undefined
}

function _resolveLocationDesignerInFeedbackHistoryInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'locationDesigner.in_feedback_history')
  }
  return undefined
}

function _resolveLocationDesignerInBgColorInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'locationDesigner.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'locationDesigner.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'locationDesigner.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'locationDesigner.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'locationDesigner.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'locationDesigner.in_bg_color')
  }
  return undefined
}

function _resolveLocationDesignerInVlmValidationInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'locationDesigner.in_vlm_validation')
  }
  return undefined
}

function _resolveLocationDesignerIn720EnabledInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'locationDesigner.in_720_enabled')
  }
  return undefined
}

function _resolveLocationDesignerIn720ViewInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'locationDesigner.in_720_view')
  }
  return undefined
}

function _resolveNodeGroupInLabelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'nodeGroup.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'nodeGroup.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'nodeGroup.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'nodeGroup.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'nodeGroup.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'nodeGroup.in_label')
  }
  return undefined
}

function _resolveNodeGroupInChildNodeIdsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'nodeGroup.in_child_node_ids')
  }
  return undefined
}

function _resolveNodeGroupInLayoutModeInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'nodeGroup.in_layout_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'nodeGroup.in_layout_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'nodeGroup.in_layout_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'nodeGroup.in_layout_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'nodeGroup.in_layout_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'nodeGroup.in_layout_mode')
  }
  return undefined
}

function _resolveNodeGroupInCollapsedInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'nodeGroup.in_collapsed')
  }
  return undefined
}

function _resolveNodeGroupInCollapsibleInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'nodeGroup.in_collapsible')
  }
  return undefined
}

function _resolveNodeGroupInBgColorInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'nodeGroup.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'nodeGroup.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'nodeGroup.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'nodeGroup.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'nodeGroup.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'nodeGroup.in_bg_color')
  }
  return undefined
}

function _resolveObjectDesignerInImagesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_images, edge.fromIndex, 'storyboardDesigner.out_grid_images', 'objectDesigner.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frames, edge.fromIndex, 'storyboardDesigner.out_start_frames', 'objectDesigner.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_start_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frames, edge.fromIndex, 'storyboardDesigner.out_key_frames', 'objectDesigner.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_key_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frames, edge.fromIndex, 'storyboardDesigner.out_end_frames', 'objectDesigner.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_end_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'objectDesigner.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'objectDesigner.in_images')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveObjectDesignerInNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'objectDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'objectDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'objectDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'objectDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'objectDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'objectDesigner.in_name')
  }
  return undefined
}

function _resolveObjectDesignerInStyleInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'objectDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'objectDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'objectDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'objectDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'objectDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'objectDesigner.in_style')
  }
  return undefined
}

function _resolveObjectDesignerInDescriptionInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'objectDesigner.in_description')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'objectDesigner.in_description')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'objectDesigner.in_description')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'objectDesigner.in_description')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'objectDesigner.in_description')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'objectDesigner.in_description')
  }
  return undefined
}

function _resolveObjectDesignerInModelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'objectDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'objectDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'objectDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'objectDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'objectDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'objectDesigner.in_model')
  }
  return undefined
}

function _resolveObjectDesignerInFeedbackInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'objectDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'objectDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'objectDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'objectDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'objectDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'objectDesigner.in_feedback')
  }
  return undefined
}

function _resolveObjectDesignerInFeedbackHistoryInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'objectDesigner.in_feedback_history')
  }
  return undefined
}

function _resolveObjectDesignerInVlmValidationInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'objectDesigner.in_vlm_validation')
  }
  return undefined
}

function _resolveScriptWriterInPromptInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'scriptWriter.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'scriptWriter.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'scriptWriter.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'scriptWriter.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'scriptWriter.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_prompt')
  }
  return undefined
}

function _resolveScriptWriterInActiveModelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'scriptWriter.in_active_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'scriptWriter.in_active_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'scriptWriter.in_active_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'scriptWriter.in_active_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'scriptWriter.in_active_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_active_model')
  }
  return undefined
}

function _resolveScriptWriterInActiveVariantIdInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'scriptWriter.in_active_variant_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'scriptWriter.in_active_variant_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'scriptWriter.in_active_variant_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'scriptWriter.in_active_variant_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'scriptWriter.in_active_variant_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_active_variant_id')
  }
  return undefined
}

function _resolveScriptWriterInNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'scriptWriter.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'scriptWriter.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'scriptWriter.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'scriptWriter.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'scriptWriter.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_name')
  }
  return undefined
}

function _resolveScriptWriterInDirectorInstructionInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'scriptWriter.in_director_instruction')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'scriptWriter.in_director_instruction')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'scriptWriter.in_director_instruction')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'scriptWriter.in_director_instruction')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'scriptWriter.in_director_instruction')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_director_instruction')
  }
  return undefined
}

function _resolveScriptWriterInFormatOnlyInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_format_only')
  }
  return undefined
}

function _resolveScriptWriterInGeminiInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_gemini')
  }
  return undefined
}

function _resolveScriptWriterInClaudeInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_claude')
  }
  return undefined
}

function _resolveScriptWriterInGptInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_gpt')
  }
  return undefined
}

function _resolveScriptWriterInCharactersInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'scriptWriter.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_beats
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'scriptWriter.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_start_frame_prompts
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'scriptWriter.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_key_frame_prompts
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'scriptWriter.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_end_frame_prompts
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'scriptWriter.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_descriptions
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_characters')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveScriptWriterInFeedbackInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'scriptWriter.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'scriptWriter.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'scriptWriter.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'scriptWriter.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'scriptWriter.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_feedback')
  }
  return undefined
}

function _resolveScriptWriterInTargetDurationSInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_duration') {
      const value = sourceNode.data?.out_video_duration
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_target_duration_s')
  }
  return undefined
}

function _resolveScriptWriterInReviewHistoryInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_review_history')
  }
  return undefined
}

function _resolveScriptWriterInFeedbackHistoryInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_feedback_history')
  }
  return undefined
}

function _resolveScriptWriterInBgColorInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'scriptWriter.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'scriptWriter.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'scriptWriter.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'scriptWriter.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'scriptWriter.in_bg_color')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'scriptWriter.in_bg_color')
  }
  return undefined
}

function _resolveShortVideoGroupInLabelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'shortVideoGroup.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'shortVideoGroup.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'shortVideoGroup.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'shortVideoGroup.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'shortVideoGroup.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'shortVideoGroup.in_label')
  }
  return undefined
}

function _resolveShortVideoGroupInCollapsedInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'shortVideoGroup.in_collapsed')
  }
  return undefined
}

function _resolveShortVideoGroupInStoryboardPathInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'shortVideoGroup.in_storyboard_path')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'shortVideoGroup.in_storyboard_path')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'shortVideoGroup.in_storyboard_path')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'shortVideoGroup.in_storyboard_path')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'shortVideoGroup.in_storyboard_path')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'shortVideoGroup.in_storyboard_path')
  }
  return undefined
}

function _resolveShortVideoGroupInImageInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) return edgeValue
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) return edgeValue
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) return edgeValue
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_images') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_images, edge.fromIndex, 'storyboardDesigner.out_grid_images', 'shortVideoGroup.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frames') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frames, edge.fromIndex, 'storyboardDesigner.out_start_frames', 'shortVideoGroup.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frames') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frames, edge.fromIndex, 'storyboardDesigner.out_key_frames', 'shortVideoGroup.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frames') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frames, edge.fromIndex, 'storyboardDesigner.out_end_frames', 'shortVideoGroup.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'shortVideoGroup.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'shortVideoGroup.in_image')
  }
  return undefined
}

function _resolveShortVideoGroupInChildNodeIdsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_character_ids') {
      const value = sourceNode.data?.out_character_ids
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_characters') {
      const value = sourceNode.data?.out_characters
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_locations') {
      const value = sourceNode.data?.out_locations
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_panel_refs') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_panel_refs, edge.fromIndex, 'storyboardDesigner.out_panel_refs', 'shortVideoGroup.in_child_node_ids')
      if (selected !== undefined) return selected
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'shortVideoGroup.in_child_node_ids')
  }
  return undefined
}

function _resolveSoundExpertInNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'soundExpert.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'soundExpert.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'soundExpert.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'soundExpert.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'soundExpert.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_name')
  }
  return undefined
}

function _resolveSoundExpertInUpstreamInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_upstream')
  }
  return undefined
}

function _resolveSoundExpertInPromptInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'soundExpert.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'soundExpert.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'soundExpert.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'soundExpert.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'soundExpert.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_prompt')
  }
  return undefined
}

function _resolveSoundExpertInModeInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'soundExpert.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'soundExpert.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'soundExpert.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'soundExpert.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'soundExpert.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_mode')
  }
  return undefined
}

function _resolveSoundExpertInDurationInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'soundExpert.in_duration')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'soundExpert.in_duration')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'soundExpert.in_duration')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'soundExpert.in_duration')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'soundExpert.in_duration')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_duration')
  }
  return undefined
}

function _resolveSoundExpertInVoiceProfileInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_voice_profile') {
      const value = sourceNode.data?.out_voice_profile
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_voice_profiles') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_voice_profiles, edge.fromIndex, 'scriptWriter.out_voice_profiles', 'soundExpert.in_voice_profile')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_voice_profile') {
      const value = sourceNode.data?.out_voice_profile
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_voice_profile')
  }
  return undefined
}

function _resolveSoundExpertInTextInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'soundExpert.in_text')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'soundExpert.in_text')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'soundExpert.in_text')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'soundExpert.in_text')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'soundExpert.in_text')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_text')
  }
  return undefined
}

function _resolveSoundExpertInFeedbackInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'soundExpert.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'soundExpert.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'soundExpert.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'soundExpert.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'soundExpert.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_feedback')
  }
  return undefined
}

function _resolveSoundExpertInFeedbackHistoryInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_feedback_history')
  }
  return undefined
}

function _resolveSoundExpertInModelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'soundExpert.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'soundExpert.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'soundExpert.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'soundExpert.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'soundExpert.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_model')
  }
  return undefined
}

function _resolveSoundExpertInLoopInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'soundExpert.in_loop')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'soundExpert.in_loop')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'soundExpert.in_loop')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'soundExpert.in_loop')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'soundExpert.in_loop')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_loop')
  }
  return undefined
}

function _resolveSoundExpertInLyricsModeInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'soundExpert.in_lyrics_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'soundExpert.in_lyrics_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'soundExpert.in_lyrics_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'soundExpert.in_lyrics_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'soundExpert.in_lyrics_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_lyrics_mode')
  }
  return undefined
}

function _resolveSoundExpertInVoiceMapInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_voice_map')
  }
  return undefined
}

function _resolveSoundExpertInSceneIdInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'soundExpert.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'soundExpert.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'soundExpert.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'soundExpert.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'soundExpert.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_scene_id')
  }
  return undefined
}

function _resolveSoundExpertInPanelIndexInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_scene_count') {
      const value = sourceNode.data?.out_scene_count
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_native_speech_detect_seq') {
      const value = sourceNode.data?.out_native_speech_detect_seq
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_panel_index')
  }
  return undefined
}

function _resolveSoundExpertInPauseMsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_scene_count') {
      const value = sourceNode.data?.out_scene_count
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_native_speech_detect_seq') {
      const value = sourceNode.data?.out_native_speech_detect_seq
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_pause_ms')
  }
  return undefined
}

function _resolveSoundExpertInCharacterNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'soundExpert.in_character_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'soundExpert.in_character_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'soundExpert.in_character_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'soundExpert.in_character_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'soundExpert.in_character_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_character_name')
  }
  return undefined
}

function _resolveSoundExpertInCharacterVoiceSourceForInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'soundExpert.in_character_voice_source_for')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'soundExpert.in_character_voice_source_for')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'soundExpert.in_character_voice_source_for')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'soundExpert.in_character_voice_source_for')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'soundExpert.in_character_voice_source_for')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'soundExpert.in_character_voice_source_for')
  }
  return undefined
}

function _resolveSpeechGeneratorInModeInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'speechGenerator.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'speechGenerator.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'speechGenerator.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'speechGenerator.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'speechGenerator.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'speechGenerator.in_mode')
  }
  return undefined
}

function _resolveSpeechGeneratorInScriptInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'speechGenerator.in_script')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'speechGenerator.in_script')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'speechGenerator.in_script')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'speechGenerator.in_script')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'speechGenerator.in_script')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'speechGenerator.in_script')
  }
  return undefined
}

function _resolveSpeechGeneratorInTextInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'speechGenerator.in_text')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'speechGenerator.in_text')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'speechGenerator.in_text')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'speechGenerator.in_text')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'speechGenerator.in_text')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'speechGenerator.in_text')
  }
  return undefined
}

function _resolveSpeechGeneratorInCharacterNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'speechGenerator.in_character_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'speechGenerator.in_character_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'speechGenerator.in_character_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'speechGenerator.in_character_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'speechGenerator.in_character_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'speechGenerator.in_character_name')
  }
  return undefined
}

function _resolveSpeechGeneratorInVoiceIdInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'speechGenerator.in_voice_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'speechGenerator.in_voice_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'speechGenerator.in_voice_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'speechGenerator.in_voice_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'speechGenerator.in_voice_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'speechGenerator.in_voice_id')
  }
  return undefined
}

function _resolveSpeechGeneratorInVoiceProfileInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_voice_profile') {
      const value = sourceNode.data?.out_voice_profile
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_voice_profiles') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_voice_profiles, edge.fromIndex, 'scriptWriter.out_voice_profiles', 'speechGenerator.in_voice_profile')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_voice_profile') {
      const value = sourceNode.data?.out_voice_profile
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'speechGenerator.in_voice_profile')
  }
  return undefined
}

function _resolveSpeechGeneratorInVoiceMapInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'speechGenerator.in_voice_map')
  }
  return undefined
}

function _resolveSpeechGeneratorInSceneIdInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'speechGenerator.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'speechGenerator.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'speechGenerator.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'speechGenerator.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'speechGenerator.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'speechGenerator.in_scene_id')
  }
  return undefined
}

function _resolveSpeechGeneratorInPanelIndexInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_scene_count') {
      const value = sourceNode.data?.out_scene_count
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_native_speech_detect_seq') {
      const value = sourceNode.data?.out_native_speech_detect_seq
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'speechGenerator.in_panel_index')
  }
  return undefined
}

function _resolveSpeechGeneratorInPauseMsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_scene_count') {
      const value = sourceNode.data?.out_scene_count
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_native_speech_detect_seq') {
      const value = sourceNode.data?.out_native_speech_detect_seq
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'speechGenerator.in_pause_ms')
  }
  return undefined
}

function _resolveSpeechGeneratorInPronunciationGuideInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'speechGenerator.in_pronunciation_guide')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'speechGenerator.in_pronunciation_guide')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'speechGenerator.in_pronunciation_guide')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'speechGenerator.in_pronunciation_guide')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'speechGenerator.in_pronunciation_guide')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'speechGenerator.in_pronunciation_guide')
  }
  return undefined
}

function _resolveSpeechGeneratorInLanguageCodeInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'speechGenerator.in_language_code')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'speechGenerator.in_language_code')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'speechGenerator.in_language_code')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'speechGenerator.in_language_code')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'speechGenerator.in_language_code')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'speechGenerator.in_language_code')
  }
  return undefined
}

function _resolveStoryboardDesignerInScriptInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardDesigner.in_script')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'storyboardDesigner.in_script')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'storyboardDesigner.in_script')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'storyboardDesigner.in_script')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardDesigner.in_script')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_script')
  }
  return undefined
}

function _resolveStoryboardDesignerInCharactersInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_images, edge.fromIndex, 'storyboardDesigner.out_grid_images', 'storyboardDesigner.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frames, edge.fromIndex, 'storyboardDesigner.out_start_frames', 'storyboardDesigner.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_start_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frames, edge.fromIndex, 'storyboardDesigner.out_key_frames', 'storyboardDesigner.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_key_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frames, edge.fromIndex, 'storyboardDesigner.out_end_frames', 'storyboardDesigner.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_end_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'storyboardDesigner.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_characters')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveStoryboardDesignerInCharacterNamesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardDesigner.in_character_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_beats
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'storyboardDesigner.in_character_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_start_frame_prompts
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'storyboardDesigner.in_character_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_key_frame_prompts
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'storyboardDesigner.in_character_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_end_frame_prompts
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardDesigner.in_character_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_descriptions
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_character_names')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveStoryboardDesignerInLocationsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_images, edge.fromIndex, 'storyboardDesigner.out_grid_images', 'storyboardDesigner.in_locations')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frames, edge.fromIndex, 'storyboardDesigner.out_start_frames', 'storyboardDesigner.in_locations')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_start_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frames, edge.fromIndex, 'storyboardDesigner.out_key_frames', 'storyboardDesigner.in_locations')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_key_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frames, edge.fromIndex, 'storyboardDesigner.out_end_frames', 'storyboardDesigner.in_locations')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_end_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'storyboardDesigner.in_locations')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_locations')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveStoryboardDesignerInLocationNamesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardDesigner.in_location_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_beats
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'storyboardDesigner.in_location_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_start_frame_prompts
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'storyboardDesigner.in_location_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_key_frame_prompts
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'storyboardDesigner.in_location_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_end_frame_prompts
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardDesigner.in_location_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_descriptions
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_location_names')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveStoryboardDesignerInObjectsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_images, edge.fromIndex, 'storyboardDesigner.out_grid_images', 'storyboardDesigner.in_objects')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frames, edge.fromIndex, 'storyboardDesigner.out_start_frames', 'storyboardDesigner.in_objects')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_start_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frames, edge.fromIndex, 'storyboardDesigner.out_key_frames', 'storyboardDesigner.in_objects')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_key_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frames, edge.fromIndex, 'storyboardDesigner.out_end_frames', 'storyboardDesigner.in_objects')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_end_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'storyboardDesigner.in_objects')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_objects')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveStoryboardDesignerInObjectNamesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardDesigner.in_object_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_beats
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'storyboardDesigner.in_object_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_start_frame_prompts
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'storyboardDesigner.in_object_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_key_frame_prompts
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'storyboardDesigner.in_object_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_end_frame_prompts
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardDesigner.in_object_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_descriptions
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_object_names')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveStoryboardDesignerInImageInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) return edgeValue
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) return edgeValue
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) return edgeValue
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_images') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_images, edge.fromIndex, 'storyboardDesigner.out_grid_images', 'storyboardDesigner.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frames') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frames, edge.fromIndex, 'storyboardDesigner.out_start_frames', 'storyboardDesigner.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frames') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frames, edge.fromIndex, 'storyboardDesigner.out_key_frames', 'storyboardDesigner.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frames') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frames, edge.fromIndex, 'storyboardDesigner.out_end_frames', 'storyboardDesigner.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'storyboardDesigner.in_image')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_image')
  }
  return undefined
}

function _resolveStoryboardDesignerInStyleInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'storyboardDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'storyboardDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'storyboardDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_style')
  }
  return undefined
}

function _resolveStoryboardDesignerInPanelCountInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_scene_count') {
      const value = sourceNode.data?.out_scene_count
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_native_speech_detect_seq') {
      const value = sourceNode.data?.out_native_speech_detect_seq
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_panel_count')
  }
  return undefined
}

function _resolveStoryboardDesignerInShotCountInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_scene_count') {
      const value = sourceNode.data?.out_scene_count
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_native_speech_detect_seq') {
      const value = sourceNode.data?.out_native_speech_detect_seq
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_shot_count')
  }
  return undefined
}

function _resolveStoryboardDesignerInAspectRatioInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardDesigner.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'storyboardDesigner.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'storyboardDesigner.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'storyboardDesigner.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardDesigner.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_aspect_ratio')
  }
  return undefined
}

function _resolveStoryboardDesignerInSceneIdInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardDesigner.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'storyboardDesigner.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'storyboardDesigner.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'storyboardDesigner.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardDesigner.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_scene_id')
  }
  return undefined
}

function _resolveStoryboardDesignerInNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'storyboardDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'storyboardDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'storyboardDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardDesigner.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_name')
  }
  return undefined
}

function _resolveStoryboardDesignerInLocationInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardDesigner.in_location')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'storyboardDesigner.in_location')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'storyboardDesigner.in_location')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'storyboardDesigner.in_location')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardDesigner.in_location')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_location')
  }
  return undefined
}

function _resolveStoryboardDesignerInModelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'storyboardDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'storyboardDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'storyboardDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_model')
  }
  return undefined
}

function _resolveStoryboardDesignerInFeedbackInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'storyboardDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'storyboardDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'storyboardDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardDesigner.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_feedback')
  }
  return undefined
}

function _resolveStoryboardDesignerInVlmValidationInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_vlm_validation')
  }
  return undefined
}

function _resolveStoryboardDesignerInVideoAnchorsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardDesigner.in_video_anchors')
  }
  return undefined
}

function _resolveStoryboardNoEnhanceDesignerInScriptInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardNoEnhanceDesigner.in_script')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'storyboardNoEnhanceDesigner.in_script')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'storyboardNoEnhanceDesigner.in_script')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'storyboardNoEnhanceDesigner.in_script')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardNoEnhanceDesigner.in_script')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardNoEnhanceDesigner.in_script')
  }
  return undefined
}

function _resolveStoryboardNoEnhanceDesignerInCharactersInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_images, edge.fromIndex, 'storyboardDesigner.out_grid_images', 'storyboardNoEnhanceDesigner.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frames, edge.fromIndex, 'storyboardDesigner.out_start_frames', 'storyboardNoEnhanceDesigner.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_start_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frames, edge.fromIndex, 'storyboardDesigner.out_key_frames', 'storyboardNoEnhanceDesigner.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_key_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frames, edge.fromIndex, 'storyboardDesigner.out_end_frames', 'storyboardNoEnhanceDesigner.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_end_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'storyboardNoEnhanceDesigner.in_characters')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardNoEnhanceDesigner.in_characters')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveStoryboardNoEnhanceDesignerInCharacterNamesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardNoEnhanceDesigner.in_character_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_beats
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'storyboardNoEnhanceDesigner.in_character_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_start_frame_prompts
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'storyboardNoEnhanceDesigner.in_character_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_key_frame_prompts
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'storyboardNoEnhanceDesigner.in_character_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_end_frame_prompts
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardNoEnhanceDesigner.in_character_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_descriptions
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardNoEnhanceDesigner.in_character_names')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveStoryboardNoEnhanceDesignerInLocationsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_images, edge.fromIndex, 'storyboardDesigner.out_grid_images', 'storyboardNoEnhanceDesigner.in_locations')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frames, edge.fromIndex, 'storyboardDesigner.out_start_frames', 'storyboardNoEnhanceDesigner.in_locations')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_start_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frames, edge.fromIndex, 'storyboardDesigner.out_key_frames', 'storyboardNoEnhanceDesigner.in_locations')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_key_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frames, edge.fromIndex, 'storyboardDesigner.out_end_frames', 'storyboardNoEnhanceDesigner.in_locations')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_end_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'storyboardNoEnhanceDesigner.in_locations')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardNoEnhanceDesigner.in_locations')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveStoryboardNoEnhanceDesignerInLocationNamesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardNoEnhanceDesigner.in_location_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_beats
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'storyboardNoEnhanceDesigner.in_location_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_start_frame_prompts
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'storyboardNoEnhanceDesigner.in_location_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_key_frame_prompts
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'storyboardNoEnhanceDesigner.in_location_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_end_frame_prompts
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardNoEnhanceDesigner.in_location_names')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_descriptions
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardNoEnhanceDesigner.in_location_names')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveStoryboardNoEnhanceDesignerInStyleInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardNoEnhanceDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'storyboardNoEnhanceDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'storyboardNoEnhanceDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'storyboardNoEnhanceDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardNoEnhanceDesigner.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardNoEnhanceDesigner.in_style')
  }
  return undefined
}

function _resolveStoryboardNoEnhanceDesignerInPanelCountInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_scene_count') {
      const value = sourceNode.data?.out_scene_count
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_native_speech_detect_seq') {
      const value = sourceNode.data?.out_native_speech_detect_seq
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardNoEnhanceDesigner.in_panel_count')
  }
  return undefined
}

function _resolveStoryboardNoEnhanceDesignerInSceneIdInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardNoEnhanceDesigner.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'storyboardNoEnhanceDesigner.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'storyboardNoEnhanceDesigner.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'storyboardNoEnhanceDesigner.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardNoEnhanceDesigner.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardNoEnhanceDesigner.in_scene_id')
  }
  return undefined
}

function _resolveStoryboardNoEnhanceDesignerInLocationInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardNoEnhanceDesigner.in_location')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'storyboardNoEnhanceDesigner.in_location')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'storyboardNoEnhanceDesigner.in_location')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'storyboardNoEnhanceDesigner.in_location')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardNoEnhanceDesigner.in_location')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardNoEnhanceDesigner.in_location')
  }
  return undefined
}

function _resolveStoryboardNoEnhanceDesignerInModelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'storyboardNoEnhanceDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'storyboardNoEnhanceDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'storyboardNoEnhanceDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'storyboardNoEnhanceDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'storyboardNoEnhanceDesigner.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardNoEnhanceDesigner.in_model')
  }
  return undefined
}

function _resolveStoryboardNoEnhanceDesignerInVlmValidationInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'storyboardNoEnhanceDesigner.in_vlm_validation')
  }
  return undefined
}

function _resolveTextInInputInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'text.in_input')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'text.in_input')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'text.in_input')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'text.in_input')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'text.in_input')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'text.in_input')
  }
  return undefined
}

function _resolveVideoInFileNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'video.in_file_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'video.in_file_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'video.in_file_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'video.in_file_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'video.in_file_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'video.in_file_name')
  }
  return undefined
}

function _resolveVideoInDepthIncludeAudioInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'video.in_depth_include_audio')
  }
  return undefined
}

function _resolveVideoInTransformVideoInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'video.in_transform_video')
  }
  return undefined
}

function _resolveVideoInTransformTargetResolutionInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'video.in_transform_target_resolution')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'video.in_transform_target_resolution')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'video.in_transform_target_resolution')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'video.in_transform_target_resolution')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'video.in_transform_target_resolution')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'video.in_transform_target_resolution')
  }
  return undefined
}

function _resolveVideoInTransformSourceAssetPathInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'video.in_transform_source_asset_path')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'video.in_transform_source_asset_path')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'video.in_transform_source_asset_path')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'video.in_transform_source_asset_path')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'video.in_transform_source_asset_path')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'video.in_transform_source_asset_path')
  }
  return undefined
}

function _resolveVideoInTransformSourceContentSha256InputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'video.in_transform_source_content_sha256')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'video.in_transform_source_content_sha256')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'video.in_transform_source_content_sha256')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'video.in_transform_source_content_sha256')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'video.in_transform_source_content_sha256')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'video.in_transform_source_content_sha256')
  }
  return undefined
}

function _resolveVideoInTransformSourceWidthInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_scene_count') {
      const value = sourceNode.data?.out_scene_count
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_native_speech_detect_seq') {
      const value = sourceNode.data?.out_native_speech_detect_seq
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'video.in_transform_source_width')
  }
  return undefined
}

function _resolveVideoInTransformSourceHeightInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_scene_count') {
      const value = sourceNode.data?.out_scene_count
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_native_speech_detect_seq') {
      const value = sourceNode.data?.out_native_speech_detect_seq
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'video.in_transform_source_height')
  }
  return undefined
}

function _resolveVideoInTransformSourceFrameCountInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_scene_count') {
      const value = sourceNode.data?.out_scene_count
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_native_speech_detect_seq') {
      const value = sourceNode.data?.out_native_speech_detect_seq
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'video.in_transform_source_frame_count')
  }
  return undefined
}

function _resolveVideoInTransformSourceFpsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_duration') {
      const value = sourceNode.data?.out_video_duration
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'video.in_transform_source_fps')
  }
  return undefined
}

function _resolveVideoEditorInReferenceMediaInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoEditor.in_reference_media')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveVideoEditorInVideosInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoEditor.in_videos')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveVideoEditorInAudiosInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoEditor.in_audios')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveVideoEditorInAudioInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoEditor.in_audio')
  }
  return undefined
}

function _resolveVideoEditorInVideoConfigInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoEditor.in_video_config')
  }
  return undefined
}

function _resolveVideoEditorInEditSpecInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoEditor.in_edit_spec')
  }
  return undefined
}

function _resolveVideoEditorInModeInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoEditor.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'videoEditor.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'videoEditor.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'videoEditor.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoEditor.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoEditor.in_mode')
  }
  return undefined
}

function _resolveVideoEditorInOutputNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoEditor.in_output_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'videoEditor.in_output_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'videoEditor.in_output_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'videoEditor.in_output_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoEditor.in_output_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoEditor.in_output_name')
  }
  return undefined
}

function _resolveVideoEditorInStartInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_duration') {
      const value = sourceNode.data?.out_video_duration
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoEditor.in_start')
  }
  return undefined
}

function _resolveVideoEditorInEndInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_duration') {
      const value = sourceNode.data?.out_video_duration
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoEditor.in_end')
  }
  return undefined
}

function _resolveVideoEditorInVolumeInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_duration') {
      const value = sourceNode.data?.out_video_duration
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoEditor.in_volume')
  }
  return undefined
}

function _resolveVideoEditorInExportNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoEditor.in_export_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'videoEditor.in_export_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'videoEditor.in_export_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'videoEditor.in_export_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoEditor.in_export_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoEditor.in_export_name')
  }
  return undefined
}

function _resolveVideoGeneratorInReferenceMediaInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_images, edge.fromIndex, 'storyboardDesigner.out_grid_images', 'videoGenerator.in_reference_media')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frames, edge.fromIndex, 'storyboardDesigner.out_start_frames', 'videoGenerator.in_reference_media')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_start_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frames, edge.fromIndex, 'storyboardDesigner.out_key_frames', 'videoGenerator.in_reference_media')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_key_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frames, edge.fromIndex, 'storyboardDesigner.out_end_frames', 'videoGenerator.in_reference_media')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_end_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'videoGenerator.in_reference_media')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_reference_media')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveVideoGeneratorInModeInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'videoGenerator.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'videoGenerator.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'videoGenerator.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_mode')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_mode')
  }
  return undefined
}

function _resolveVideoGeneratorInSceneIdInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'videoGenerator.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'videoGenerator.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'videoGenerator.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_scene_id')
  }
  return undefined
}

function _resolveVideoGeneratorInClipNumberInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_scene_count') {
      const value = sourceNode.data?.out_scene_count
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_native_speech_detect_seq') {
      const value = sourceNode.data?.out_native_speech_detect_seq
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_clip_number')
  }
  return undefined
}

function _resolveVideoGeneratorInImagesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_images, edge.fromIndex, 'storyboardDesigner.out_grid_images', 'videoGenerator.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frames, edge.fromIndex, 'storyboardDesigner.out_start_frames', 'videoGenerator.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_start_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frames, edge.fromIndex, 'storyboardDesigner.out_key_frames', 'videoGenerator.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_key_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frames, edge.fromIndex, 'storyboardDesigner.out_end_frames', 'videoGenerator.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_end_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'videoGenerator.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_images')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveVideoGeneratorInReferenceVideosInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_reference_videos')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveVideoGeneratorInContinuationSourceInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'video') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video') {
      const value = sourceNode.data?.out_video
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_continuation_source')
  }
  return undefined
}

function _resolveVideoGeneratorInShotListSourceIdInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_shot_list_source_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'videoGenerator.in_shot_list_source_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'videoGenerator.in_shot_list_source_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'videoGenerator.in_shot_list_source_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_shot_list_source_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_shot_list_source_id')
  }
  return undefined
}

function _resolveVideoGeneratorInShotListSourceFingerprintInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_shot_list_source_fingerprint')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'videoGenerator.in_shot_list_source_fingerprint')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'videoGenerator.in_shot_list_source_fingerprint')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'videoGenerator.in_shot_list_source_fingerprint')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_shot_list_source_fingerprint')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_shot_list_source_fingerprint')
  }
  return undefined
}

function _resolveVideoGeneratorInShotListRequestFingerprintInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_shot_list_request_fingerprint')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'videoGenerator.in_shot_list_request_fingerprint')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'videoGenerator.in_shot_list_request_fingerprint')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'videoGenerator.in_shot_list_request_fingerprint')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_shot_list_request_fingerprint')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_shot_list_request_fingerprint')
  }
  return undefined
}

function _resolveVideoGeneratorInReferenceAudiosInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_reference_audios')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveVideoGeneratorInAudioInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'audio') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_audio') {
      const value = sourceNode.data?.out_audio
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_audio')
  }
  return undefined
}

function _resolveVideoGeneratorInMotionPromptInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_motion_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'videoGenerator.in_motion_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'videoGenerator.in_motion_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'videoGenerator.in_motion_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_motion_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_motion_prompt')
  }
  return undefined
}

function _resolveVideoGeneratorInSceneContextInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_scene_context')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'videoGenerator.in_scene_context')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'videoGenerator.in_scene_context')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'videoGenerator.in_scene_context')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_scene_context')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_scene_context')
  }
  return undefined
}

function _resolveVideoGeneratorInDurationInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'speechGenerator') && edge.sourceHandle === 'out_duration_seconds') {
      const value = sourceNode.data?.out_duration_seconds
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_duration') {
      const value = sourceNode.data?.out_video_duration
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_duration')
  }
  return undefined
}

function _resolveVideoGeneratorInReferenceVideoEditsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_reference_video_edits')
  }
  return undefined
}

function _resolveVideoGeneratorInDialoguePromptInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_auto_dialogue') {
      const value = sourceNode.data?.out_auto_dialogue
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_dialogue_prompt')
  }
  return undefined
}

function _resolveVideoGeneratorInModelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'videoGenerator.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'videoGenerator.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'videoGenerator.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_model')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_model')
  }
  return undefined
}

function _resolveVideoGeneratorInAspectRatioInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'videoGenerator.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'videoGenerator.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'videoGenerator.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_aspect_ratio')
  }
  return undefined
}

function _resolveVideoGeneratorInResolutionInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_resolution')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'videoGenerator.in_resolution')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'videoGenerator.in_resolution')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'videoGenerator.in_resolution')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_resolution')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_resolution')
  }
  return undefined
}

function _resolveVideoGeneratorInGenerateAudioInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_generate_audio')
  }
  return undefined
}

function _resolveVideoGeneratorInProviderGenerateAudioInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_provider_generate_audio')
  }
  return undefined
}

function _resolveVideoGeneratorInUseVoiceProfileAudioReferencesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_use_voice_profile_audio_references')
  }
  return undefined
}

function _resolveVideoGeneratorInAudioRemixModeInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_audio_remix_mode')
  }
  return undefined
}

function _resolveVideoGeneratorInAllowBgmInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_allow_bgm')
  }
  return undefined
}

function _resolveVideoGeneratorInTtsProviderInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_tts_provider')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'videoGenerator.in_tts_provider')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'videoGenerator.in_tts_provider')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'videoGenerator.in_tts_provider')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_tts_provider')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_tts_provider')
  }
  return undefined
}

function _resolveVideoGeneratorInDubTargetLanguageInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_dub_target_language')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'videoGenerator.in_dub_target_language')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'videoGenerator.in_dub_target_language')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'videoGenerator.in_dub_target_language')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_dub_target_language')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_dub_target_language')
  }
  return undefined
}

function _resolveVideoGeneratorInVoiceProfilesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_voice_profile') {
      const value = sourceNode.data?.out_voice_profile
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_voice_profiles') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_voice_profiles, edge.fromIndex, 'scriptWriter.out_voice_profiles', 'videoGenerator.in_voice_profiles')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_voice_profiles
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'soundExpert') && edge.sourceHandle === 'out_voice_profile') {
      const value = sourceNode.data?.out_voice_profile
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_voice_profiles')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveVideoGeneratorInVoiceSettingsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_voice_settings')
  }
  return undefined
}

function _resolveVideoGeneratorInNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'videoGenerator.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'videoGenerator.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'videoGenerator.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_name')
  }
  return undefined
}

function _resolveVideoGeneratorInResolvedVoiceMapInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_resolved_voice_map')
  }
  return undefined
}

function _resolveVideoGeneratorInAudioRemixConfigInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_audio_remix_baseline') {
      const value = sourceNode.data?.out_audio_remix_baseline
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_audio_remix_config')
  }
  return undefined
}

function _resolveVideoGeneratorInSpeechTransformerConfigInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_speech_transformer_config')
  }
  return undefined
}

function _resolveVideoGeneratorInAudioTakeSelectionsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_audio_take_selections')
  }
  return undefined
}

function _resolveVideoGeneratorInAudioVariantWorkspacesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_audio_variant_workspaces')
  }
  return undefined
}

function _resolveVideoGeneratorInUnifiedAudioConfigInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_unified_audio_config')
  }
  return undefined
}

function _resolveVideoGeneratorInStyleInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'videoGenerator.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'videoGenerator.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'videoGenerator.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'videoGenerator.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'videoGenerator.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'videoGenerator.in_style')
  }
  return undefined
}

function _resolveWebtoonGroupInSceneIdInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'webtoonGroup.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'webtoonGroup.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'webtoonGroup.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'webtoonGroup.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'webtoonGroup.in_scene_id')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonGroup.in_scene_id')
  }
  return undefined
}

function _resolveWebtoonGroupInLabelInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'webtoonGroup.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'webtoonGroup.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'webtoonGroup.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'webtoonGroup.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'webtoonGroup.in_label')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonGroup.in_label')
  }
  return undefined
}

function _resolveWebtoonGroupInCollapsedInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonGroup.in_collapsed')
  }
  return undefined
}

function _resolveWebtoonGroupInChildNodeIdsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_character_ids') {
      const value = sourceNode.data?.out_character_ids
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_characters') {
      const value = sourceNode.data?.out_characters
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_locations') {
      const value = sourceNode.data?.out_locations
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_panel_refs') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_panel_refs, edge.fromIndex, 'storyboardDesigner.out_panel_refs', 'webtoonGroup.in_child_node_ids')
      if (selected !== undefined) return selected
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonGroup.in_child_node_ids')
  }
  return undefined
}

function _resolveWebtoonPanelGeneratorInImagesInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'image') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'imageGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      const edgeValue = _imageAssetRefFromDesignerAsset(value)
      if (edgeValue !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, edgeValue)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_images, edge.fromIndex, 'storyboardDesigner.out_grid_images', 'webtoonPanelGenerator.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frames, edge.fromIndex, 'storyboardDesigner.out_start_frames', 'webtoonPanelGenerator.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_start_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frames, edge.fromIndex, 'storyboardDesigner.out_key_frames', 'webtoonPanelGenerator.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_key_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frames') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frames, edge.fromIndex, 'storyboardDesigner.out_end_frames', 'webtoonPanelGenerator.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_end_frames
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_images') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_images, edge.fromIndex, 'storyboardDesigner.out_images', 'webtoonPanelGenerator.in_images')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_images
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardNoEnhanceDesigner') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'webtoonPanelGenerator') && edge.sourceHandle === 'out_image') {
      const value = sourceNode.data?.out_image
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonPanelGenerator.in_images')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveWebtoonPanelGeneratorInPromptInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'webtoonPanelGenerator.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'webtoonPanelGenerator.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'webtoonPanelGenerator.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'webtoonPanelGenerator.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'webtoonPanelGenerator.in_prompt')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonPanelGenerator.in_prompt')
  }
  return undefined
}

function _resolveWebtoonPanelGeneratorInBeatsInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'webtoonPanelGenerator.in_beats')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_beats
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'webtoonPanelGenerator.in_beats')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_start_frame_prompts
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'webtoonPanelGenerator.in_beats')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_key_frame_prompts
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'webtoonPanelGenerator.in_beats')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_end_frame_prompts
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      if (edge.fromIndex !== undefined) {
        const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'webtoonPanelGenerator.in_beats')
        if (selected !== undefined) {
          _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, selected)
        }
        return
      }
      const value = sourceNode.data?.out_grid_descriptions
      if (value !== undefined) {
        _pushIndexedInputFlushValues(resolved, edge, edgeOrder, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) {
        _pushIndexedInputFlushValue(resolved, edge, edgeOrder, 0, value)
      }
      return
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonPanelGenerator.in_beats')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveWebtoonPanelGeneratorInDialogueInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue[] {
  const resolved: Array<_IndexedInputFlushValue<YDocWriteValue>> = []
  _orderedInputFlushEdges(edgeRefs).forEach((edge, edgeOrder) => {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    void edgeOrder
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonPanelGenerator.in_dialogue')
  })
  return _orderedInputFlushValues(resolved)
}

function _resolveWebtoonPanelGeneratorInPanelIndexInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_scene_count') {
      const value = sourceNode.data?.out_scene_count
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_native_speech_detect_seq') {
      const value = sourceNode.data?.out_native_speech_detect_seq
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonPanelGenerator.in_panel_index')
  }
  return undefined
}

function _resolveWebtoonPanelGeneratorInAspectRatioInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'webtoonPanelGenerator.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'webtoonPanelGenerator.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'webtoonPanelGenerator.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'webtoonPanelGenerator.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'webtoonPanelGenerator.in_aspect_ratio')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonPanelGenerator.in_aspect_ratio')
  }
  return undefined
}

function _resolveWebtoonPanelGeneratorInLayoutInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'webtoonPanelGenerator.in_layout')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'webtoonPanelGenerator.in_layout')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'webtoonPanelGenerator.in_layout')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'webtoonPanelGenerator.in_layout')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'webtoonPanelGenerator.in_layout')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonPanelGenerator.in_layout')
  }
  return undefined
}

function _resolveWebtoonPanelGeneratorInStyleInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'webtoonPanelGenerator.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'webtoonPanelGenerator.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'webtoonPanelGenerator.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'webtoonPanelGenerator.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'webtoonPanelGenerator.in_style')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonPanelGenerator.in_style')
  }
  return undefined
}

function _resolveWebtoonPanelGeneratorInNameInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'webtoonPanelGenerator.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'webtoonPanelGenerator.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'webtoonPanelGenerator.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'webtoonPanelGenerator.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'webtoonPanelGenerator.in_name')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonPanelGenerator.in_name')
  }
  return undefined
}

function _resolveWebtoonPanelGeneratorInFeedbackInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    if (_isInputFlushNodeType(sourceNode, 'characterDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'debugHang') && edge.sourceHandle === 'out_result') {
      const value = sourceNode.data?.out_result
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'director') && edge.sourceHandle === 'out_response') {
      const value = sourceNode.data?.out_response
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'locationDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'objectDesigner') && edge.sourceHandle === 'out_name') {
      const value = sourceNode.data?.in_name
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_action') {
      const value = sourceNode.data?.out_action
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'panelSource') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'promptInput') && edge.sourceHandle === 'out_prompt') {
      const value = sourceNode.data?.out_prompt
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script') {
      const value = sourceNode.data?.out_script
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_script_path') {
      const value = sourceNode.data?.out_script_path
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_active_model') {
      const value = sourceNode.data?.out_active_model
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_logline') {
      const value = sourceNode.data?.out_logline
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_genre_tone') {
      const value = sourceNode.data?.out_genre_tone
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_synopsis') {
      const value = sourceNode.data?.out_synopsis
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'scriptWriter') && edge.sourceHandle === 'out_themes') {
      const value = sourceNode.data?.out_themes
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_beats') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_beats, edge.fromIndex, 'storyboardDesigner.out_beats', 'webtoonPanelGenerator.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_start_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_start_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_start_frame_prompts', 'webtoonPanelGenerator.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_key_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_key_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_key_frame_prompts', 'webtoonPanelGenerator.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_end_frame_prompts') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_end_frame_prompts, edge.fromIndex, 'storyboardDesigner.out_end_frame_prompts', 'webtoonPanelGenerator.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'storyboardDesigner') && edge.sourceHandle === 'out_grid_descriptions') {
      const selected = _selectIndexedInputFlushValue(sourceNode.data?.out_grid_descriptions, edge.fromIndex, 'storyboardDesigner.out_grid_descriptions', 'webtoonPanelGenerator.in_feedback')
      if (selected !== undefined) return selected
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'styleSelector') && edge.sourceHandle === 'out_style') {
      const value = sourceNode.data?.out_style
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'text') && edge.sourceHandle === 'out_text') {
      const value = sourceNode.data?.out_text
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoEditor') && edge.sourceHandle === 'out_rendered_spec_hash') {
      const value = sourceNode.data?.out_rendered_spec_hash
      if (value !== undefined) return value
      continue
    }
    if (_isInputFlushNodeType(sourceNode, 'videoGenerator') && edge.sourceHandle === 'out_video_prompt') {
      const value = sourceNode.data?.out_video_prompt
      if (value !== undefined) return value
      continue
    }
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonPanelGenerator.in_feedback')
  }
  return undefined
}

function _resolveWebtoonPanelGeneratorInFeedbackHistoryInputFlushValue(
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | undefined {
  for (const edge of _orderedInputFlushEdges(edgeRefs)) {
    const sourceNode = _findInputFlushNode(nodes, edge.source)
    _throwUnsupportedInputFlushEdge(sourceNode?.type, edge.sourceHandle, 'webtoonPanelGenerator.in_feedback_history')
  }
  return undefined
}

function _resolveAudioInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  switch (targetHandle) {
    case 'in_file_name':
      return _resolveAudioInFileNameInputFlushValue(nodes, edgeRefs)
    case 'in_voice_profile':
      return _resolveAudioInVoiceProfileInputFlushValue(nodes, edgeRefs)
    default:
      throw new Error(`Unknown input port ${targetHandle} for audio`)
  }
}

function _resolveCharacterDesignerInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  switch (targetHandle) {
    case 'in_upstream':
      return _resolveCharacterDesignerInUpstreamInputFlushValue(nodes, edgeRefs)
    case 'in_images':
      return _resolveCharacterDesignerInImagesInputFlushValue(nodes, edgeRefs)
    case 'in_name':
      return _resolveCharacterDesignerInNameInputFlushValue(nodes, edgeRefs)
    case 'in_role':
      return _resolveCharacterDesignerInRoleInputFlushValue(nodes, edgeRefs)
    case 'in_style':
      return _resolveCharacterDesignerInStyleInputFlushValue(nodes, edgeRefs)
    case 'in_description':
      return _resolveCharacterDesignerInDescriptionInputFlushValue(nodes, edgeRefs)
    case 'in_model':
      return _resolveCharacterDesignerInModelInputFlushValue(nodes, edgeRefs)
    case 'in_feedback':
      return _resolveCharacterDesignerInFeedbackInputFlushValue(nodes, edgeRefs)
    case 'in_feedback_history':
      return _resolveCharacterDesignerInFeedbackHistoryInputFlushValue(nodes, edgeRefs)
    case 'in_pronunciation_guide':
      return _resolveCharacterDesignerInPronunciationGuideInputFlushValue(nodes, edgeRefs)
    case 'in_bg_color':
      return _resolveCharacterDesignerInBgColorInputFlushValue(nodes, edgeRefs)
    case 'in_vlm_validation':
      return _resolveCharacterDesignerInVlmValidationInputFlushValue(nodes, edgeRefs)
    default:
      throw new Error(`Unknown input port ${targetHandle} for character_designer`)
  }
}

function _resolveDebugHangInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  switch (targetHandle) {
    case 'in_label':
      return _resolveDebugHangInLabelInputFlushValue(nodes, edgeRefs)
    default:
      throw new Error(`Unknown input port ${targetHandle} for debug_hang`)
  }
}

function _resolveDirectorInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  switch (targetHandle) {
    case 'in_context':
      return _resolveDirectorInContextInputFlushValue(nodes, edgeRefs)
    default:
      throw new Error(`Unknown input port ${targetHandle} for director`)
  }
}

function _resolveGeneratedImageWithHistoryInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  void nodes
  void edgeRefs
  switch (targetHandle) {
    default:
      throw new Error(`Unknown input port ${targetHandle} for generated_image_with_history`)
  }
}

function _resolveImageInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  switch (targetHandle) {
    case 'in_file_name':
      return _resolveImageInFileNameInputFlushValue(nodes, edgeRefs)
    case 'in_image':
      return _resolveImageInImageInputFlushValue(nodes, edgeRefs)
    default:
      throw new Error(`Unknown input port ${targetHandle} for image`)
  }
}

function _resolveImageGeneratorInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  switch (targetHandle) {
    case 'in_images':
      return _resolveImageGeneratorInImagesInputFlushValue(nodes, edgeRefs)
    case 'in_upstream':
      return _resolveImageGeneratorInUpstreamInputFlushValue(nodes, edgeRefs)
    case 'in_name':
      return _resolveImageGeneratorInNameInputFlushValue(nodes, edgeRefs)
    case 'in_prompt':
      return _resolveImageGeneratorInPromptInputFlushValue(nodes, edgeRefs)
    case 'in_aspect_ratio':
      return _resolveImageGeneratorInAspectRatioInputFlushValue(nodes, edgeRefs)
    case 'in_style':
      return _resolveImageGeneratorInStyleInputFlushValue(nodes, edgeRefs)
    case 'in_quality':
      return _resolveImageGeneratorInQualityInputFlushValue(nodes, edgeRefs)
    case 'in_model':
      return _resolveImageGeneratorInModelInputFlushValue(nodes, edgeRefs)
    case 'in_panel_refs':
      return _resolveImageGeneratorInPanelRefsInputFlushValue(nodes, edgeRefs)
    case 'in_update':
      return _resolveImageGeneratorInUpdateInputFlushValue(nodes, edgeRefs)
    case 'in_image':
      return _resolveImageGeneratorInImageInputFlushValue(nodes, edgeRefs)
    case 'in_feedback':
      return _resolveImageGeneratorInFeedbackInputFlushValue(nodes, edgeRefs)
    case 'in_video':
      return _resolveImageGeneratorInVideoInputFlushValue(nodes, edgeRefs)
    case 'in_source_video':
      return _resolveImageGeneratorInSourceVideoInputFlushValue(nodes, edgeRefs)
    case 'in_expected_video_duration_ms':
      return _resolveImageGeneratorInExpectedVideoDurationMsInputFlushValue(nodes, edgeRefs)
    case 'in_frame':
      return _resolveImageGeneratorInFrameInputFlushValue(nodes, edgeRefs)
    case 'in_get_frame':
      return _resolveImageGeneratorInGetFrameInputFlushValue(nodes, edgeRefs)
    case 'in_feedback_history':
      return _resolveImageGeneratorInFeedbackHistoryInputFlushValue(nodes, edgeRefs)
    case 'in_vlm_validation':
      return _resolveImageGeneratorInVlmValidationInputFlushValue(nodes, edgeRefs)
    default:
      throw new Error(`Unknown input port ${targetHandle} for image_generator`)
  }
}

function _resolveLocationDesignerInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  switch (targetHandle) {
    case 'in_images':
      return _resolveLocationDesignerInImagesInputFlushValue(nodes, edgeRefs)
    case 'in_name':
      return _resolveLocationDesignerInNameInputFlushValue(nodes, edgeRefs)
    case 'in_style':
      return _resolveLocationDesignerInStyleInputFlushValue(nodes, edgeRefs)
    case 'in_time_of_day':
      return _resolveLocationDesignerInTimeOfDayInputFlushValue(nodes, edgeRefs)
    case 'in_weather':
      return _resolveLocationDesignerInWeatherInputFlushValue(nodes, edgeRefs)
    case 'in_description':
      return _resolveLocationDesignerInDescriptionInputFlushValue(nodes, edgeRefs)
    case 'in_model':
      return _resolveLocationDesignerInModelInputFlushValue(nodes, edgeRefs)
    case 'in_feedback':
      return _resolveLocationDesignerInFeedbackInputFlushValue(nodes, edgeRefs)
    case 'in_feedback_history':
      return _resolveLocationDesignerInFeedbackHistoryInputFlushValue(nodes, edgeRefs)
    case 'in_bg_color':
      return _resolveLocationDesignerInBgColorInputFlushValue(nodes, edgeRefs)
    case 'in_vlm_validation':
      return _resolveLocationDesignerInVlmValidationInputFlushValue(nodes, edgeRefs)
    case 'in_720_enabled':
      return _resolveLocationDesignerIn720EnabledInputFlushValue(nodes, edgeRefs)
    case 'in_720_view':
      return _resolveLocationDesignerIn720ViewInputFlushValue(nodes, edgeRefs)
    default:
      throw new Error(`Unknown input port ${targetHandle} for location_designer`)
  }
}

function _resolveNodeGroupInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  switch (targetHandle) {
    case 'in_label':
      return _resolveNodeGroupInLabelInputFlushValue(nodes, edgeRefs)
    case 'in_child_node_ids':
      return _resolveNodeGroupInChildNodeIdsInputFlushValue(nodes, edgeRefs)
    case 'in_layout_mode':
      return _resolveNodeGroupInLayoutModeInputFlushValue(nodes, edgeRefs)
    case 'in_collapsed':
      return _resolveNodeGroupInCollapsedInputFlushValue(nodes, edgeRefs)
    case 'in_collapsible':
      return _resolveNodeGroupInCollapsibleInputFlushValue(nodes, edgeRefs)
    case 'in_bg_color':
      return _resolveNodeGroupInBgColorInputFlushValue(nodes, edgeRefs)
    default:
      throw new Error(`Unknown input port ${targetHandle} for node_group`)
  }
}

function _resolveObjectDesignerInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  switch (targetHandle) {
    case 'in_images':
      return _resolveObjectDesignerInImagesInputFlushValue(nodes, edgeRefs)
    case 'in_name':
      return _resolveObjectDesignerInNameInputFlushValue(nodes, edgeRefs)
    case 'in_style':
      return _resolveObjectDesignerInStyleInputFlushValue(nodes, edgeRefs)
    case 'in_description':
      return _resolveObjectDesignerInDescriptionInputFlushValue(nodes, edgeRefs)
    case 'in_model':
      return _resolveObjectDesignerInModelInputFlushValue(nodes, edgeRefs)
    case 'in_feedback':
      return _resolveObjectDesignerInFeedbackInputFlushValue(nodes, edgeRefs)
    case 'in_feedback_history':
      return _resolveObjectDesignerInFeedbackHistoryInputFlushValue(nodes, edgeRefs)
    case 'in_vlm_validation':
      return _resolveObjectDesignerInVlmValidationInputFlushValue(nodes, edgeRefs)
    default:
      throw new Error(`Unknown input port ${targetHandle} for object_designer`)
  }
}

function _resolvePanelSourceInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  void nodes
  void edgeRefs
  switch (targetHandle) {
    default:
      throw new Error(`Unknown input port ${targetHandle} for panel_source`)
  }
}

function _resolvePromptInputInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  void nodes
  void edgeRefs
  switch (targetHandle) {
    default:
      throw new Error(`Unknown input port ${targetHandle} for prompt_input`)
  }
}

function _resolveScriptWriterInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  switch (targetHandle) {
    case 'in_prompt':
      return _resolveScriptWriterInPromptInputFlushValue(nodes, edgeRefs)
    case 'in_active_model':
      return _resolveScriptWriterInActiveModelInputFlushValue(nodes, edgeRefs)
    case 'in_active_variant_id':
      return _resolveScriptWriterInActiveVariantIdInputFlushValue(nodes, edgeRefs)
    case 'in_name':
      return _resolveScriptWriterInNameInputFlushValue(nodes, edgeRefs)
    case 'in_director_instruction':
      return _resolveScriptWriterInDirectorInstructionInputFlushValue(nodes, edgeRefs)
    case 'in_format_only':
      return _resolveScriptWriterInFormatOnlyInputFlushValue(nodes, edgeRefs)
    case 'in_gemini':
      return _resolveScriptWriterInGeminiInputFlushValue(nodes, edgeRefs)
    case 'in_claude':
      return _resolveScriptWriterInClaudeInputFlushValue(nodes, edgeRefs)
    case 'in_gpt':
      return _resolveScriptWriterInGptInputFlushValue(nodes, edgeRefs)
    case 'in_characters':
      return _resolveScriptWriterInCharactersInputFlushValue(nodes, edgeRefs)
    case 'in_feedback':
      return _resolveScriptWriterInFeedbackInputFlushValue(nodes, edgeRefs)
    case 'in_target_duration_s':
      return _resolveScriptWriterInTargetDurationSInputFlushValue(nodes, edgeRefs)
    case 'in_review_history':
      return _resolveScriptWriterInReviewHistoryInputFlushValue(nodes, edgeRefs)
    case 'in_feedback_history':
      return _resolveScriptWriterInFeedbackHistoryInputFlushValue(nodes, edgeRefs)
    case 'in_bg_color':
      return _resolveScriptWriterInBgColorInputFlushValue(nodes, edgeRefs)
    default:
      throw new Error(`Unknown input port ${targetHandle} for script_writer`)
  }
}

function _resolveShortVideoGroupInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  switch (targetHandle) {
    case 'in_label':
      return _resolveShortVideoGroupInLabelInputFlushValue(nodes, edgeRefs)
    case 'in_collapsed':
      return _resolveShortVideoGroupInCollapsedInputFlushValue(nodes, edgeRefs)
    case 'in_storyboard_path':
      return _resolveShortVideoGroupInStoryboardPathInputFlushValue(nodes, edgeRefs)
    case 'in_image':
      return _resolveShortVideoGroupInImageInputFlushValue(nodes, edgeRefs)
    case 'in_child_node_ids':
      return _resolveShortVideoGroupInChildNodeIdsInputFlushValue(nodes, edgeRefs)
    default:
      throw new Error(`Unknown input port ${targetHandle} for short_video_group`)
  }
}

function _resolveSoundExpertInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  switch (targetHandle) {
    case 'in_name':
      return _resolveSoundExpertInNameInputFlushValue(nodes, edgeRefs)
    case 'in_upstream':
      return _resolveSoundExpertInUpstreamInputFlushValue(nodes, edgeRefs)
    case 'in_prompt':
      return _resolveSoundExpertInPromptInputFlushValue(nodes, edgeRefs)
    case 'in_mode':
      return _resolveSoundExpertInModeInputFlushValue(nodes, edgeRefs)
    case 'in_duration':
      return _resolveSoundExpertInDurationInputFlushValue(nodes, edgeRefs)
    case 'in_voice_profile':
      return _resolveSoundExpertInVoiceProfileInputFlushValue(nodes, edgeRefs)
    case 'in_text':
      return _resolveSoundExpertInTextInputFlushValue(nodes, edgeRefs)
    case 'in_feedback':
      return _resolveSoundExpertInFeedbackInputFlushValue(nodes, edgeRefs)
    case 'in_feedback_history':
      return _resolveSoundExpertInFeedbackHistoryInputFlushValue(nodes, edgeRefs)
    case 'in_model':
      return _resolveSoundExpertInModelInputFlushValue(nodes, edgeRefs)
    case 'in_loop':
      return _resolveSoundExpertInLoopInputFlushValue(nodes, edgeRefs)
    case 'in_lyrics_mode':
      return _resolveSoundExpertInLyricsModeInputFlushValue(nodes, edgeRefs)
    case 'in_voice_map':
      return _resolveSoundExpertInVoiceMapInputFlushValue(nodes, edgeRefs)
    case 'in_scene_id':
      return _resolveSoundExpertInSceneIdInputFlushValue(nodes, edgeRefs)
    case 'in_panel_index':
      return _resolveSoundExpertInPanelIndexInputFlushValue(nodes, edgeRefs)
    case 'in_pause_ms':
      return _resolveSoundExpertInPauseMsInputFlushValue(nodes, edgeRefs)
    case 'in_character_name':
      return _resolveSoundExpertInCharacterNameInputFlushValue(nodes, edgeRefs)
    case 'in_character_voice_source_for':
      return _resolveSoundExpertInCharacterVoiceSourceForInputFlushValue(nodes, edgeRefs)
    default:
      throw new Error(`Unknown input port ${targetHandle} for sound_expert`)
  }
}

function _resolveSpeechGeneratorInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  switch (targetHandle) {
    case 'in_mode':
      return _resolveSpeechGeneratorInModeInputFlushValue(nodes, edgeRefs)
    case 'in_script':
      return _resolveSpeechGeneratorInScriptInputFlushValue(nodes, edgeRefs)
    case 'in_text':
      return _resolveSpeechGeneratorInTextInputFlushValue(nodes, edgeRefs)
    case 'in_character_name':
      return _resolveSpeechGeneratorInCharacterNameInputFlushValue(nodes, edgeRefs)
    case 'in_voice_id':
      return _resolveSpeechGeneratorInVoiceIdInputFlushValue(nodes, edgeRefs)
    case 'in_voice_profile':
      return _resolveSpeechGeneratorInVoiceProfileInputFlushValue(nodes, edgeRefs)
    case 'in_voice_map':
      return _resolveSpeechGeneratorInVoiceMapInputFlushValue(nodes, edgeRefs)
    case 'in_scene_id':
      return _resolveSpeechGeneratorInSceneIdInputFlushValue(nodes, edgeRefs)
    case 'in_panel_index':
      return _resolveSpeechGeneratorInPanelIndexInputFlushValue(nodes, edgeRefs)
    case 'in_pause_ms':
      return _resolveSpeechGeneratorInPauseMsInputFlushValue(nodes, edgeRefs)
    case 'in_pronunciation_guide':
      return _resolveSpeechGeneratorInPronunciationGuideInputFlushValue(nodes, edgeRefs)
    case 'in_language_code':
      return _resolveSpeechGeneratorInLanguageCodeInputFlushValue(nodes, edgeRefs)
    default:
      throw new Error(`Unknown input port ${targetHandle} for speech_generator`)
  }
}

function _resolveStoryDirectionPreviewInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  void nodes
  void edgeRefs
  switch (targetHandle) {
    default:
      throw new Error(`Unknown input port ${targetHandle} for story_direction_preview`)
  }
}

function _resolveStoryboardDesignerInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  switch (targetHandle) {
    case 'in_script':
      return _resolveStoryboardDesignerInScriptInputFlushValue(nodes, edgeRefs)
    case 'in_characters':
      return _resolveStoryboardDesignerInCharactersInputFlushValue(nodes, edgeRefs)
    case 'in_character_names':
      return _resolveStoryboardDesignerInCharacterNamesInputFlushValue(nodes, edgeRefs)
    case 'in_locations':
      return _resolveStoryboardDesignerInLocationsInputFlushValue(nodes, edgeRefs)
    case 'in_location_names':
      return _resolveStoryboardDesignerInLocationNamesInputFlushValue(nodes, edgeRefs)
    case 'in_objects':
      return _resolveStoryboardDesignerInObjectsInputFlushValue(nodes, edgeRefs)
    case 'in_object_names':
      return _resolveStoryboardDesignerInObjectNamesInputFlushValue(nodes, edgeRefs)
    case 'in_image':
      return _resolveStoryboardDesignerInImageInputFlushValue(nodes, edgeRefs)
    case 'in_style':
      return _resolveStoryboardDesignerInStyleInputFlushValue(nodes, edgeRefs)
    case 'in_panel_count':
      return _resolveStoryboardDesignerInPanelCountInputFlushValue(nodes, edgeRefs)
    case 'in_shot_count':
      return _resolveStoryboardDesignerInShotCountInputFlushValue(nodes, edgeRefs)
    case 'in_aspect_ratio':
      return _resolveStoryboardDesignerInAspectRatioInputFlushValue(nodes, edgeRefs)
    case 'in_scene_id':
      return _resolveStoryboardDesignerInSceneIdInputFlushValue(nodes, edgeRefs)
    case 'in_name':
      return _resolveStoryboardDesignerInNameInputFlushValue(nodes, edgeRefs)
    case 'in_location':
      return _resolveStoryboardDesignerInLocationInputFlushValue(nodes, edgeRefs)
    case 'in_model':
      return _resolveStoryboardDesignerInModelInputFlushValue(nodes, edgeRefs)
    case 'in_feedback':
      return _resolveStoryboardDesignerInFeedbackInputFlushValue(nodes, edgeRefs)
    case 'in_vlm_validation':
      return _resolveStoryboardDesignerInVlmValidationInputFlushValue(nodes, edgeRefs)
    case 'in_video_anchors':
      return _resolveStoryboardDesignerInVideoAnchorsInputFlushValue(nodes, edgeRefs)
    default:
      throw new Error(`Unknown input port ${targetHandle} for storyboard_designer`)
  }
}

function _resolveStoryboardNoEnhanceDesignerInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  switch (targetHandle) {
    case 'in_script':
      return _resolveStoryboardNoEnhanceDesignerInScriptInputFlushValue(nodes, edgeRefs)
    case 'in_characters':
      return _resolveStoryboardNoEnhanceDesignerInCharactersInputFlushValue(nodes, edgeRefs)
    case 'in_character_names':
      return _resolveStoryboardNoEnhanceDesignerInCharacterNamesInputFlushValue(nodes, edgeRefs)
    case 'in_locations':
      return _resolveStoryboardNoEnhanceDesignerInLocationsInputFlushValue(nodes, edgeRefs)
    case 'in_location_names':
      return _resolveStoryboardNoEnhanceDesignerInLocationNamesInputFlushValue(nodes, edgeRefs)
    case 'in_style':
      return _resolveStoryboardNoEnhanceDesignerInStyleInputFlushValue(nodes, edgeRefs)
    case 'in_panel_count':
      return _resolveStoryboardNoEnhanceDesignerInPanelCountInputFlushValue(nodes, edgeRefs)
    case 'in_scene_id':
      return _resolveStoryboardNoEnhanceDesignerInSceneIdInputFlushValue(nodes, edgeRefs)
    case 'in_location':
      return _resolveStoryboardNoEnhanceDesignerInLocationInputFlushValue(nodes, edgeRefs)
    case 'in_model':
      return _resolveStoryboardNoEnhanceDesignerInModelInputFlushValue(nodes, edgeRefs)
    case 'in_vlm_validation':
      return _resolveStoryboardNoEnhanceDesignerInVlmValidationInputFlushValue(nodes, edgeRefs)
    default:
      throw new Error(`Unknown input port ${targetHandle} for storyboard_no_enhance_designer`)
  }
}

function _resolveStyleSelectorInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  void nodes
  void edgeRefs
  switch (targetHandle) {
    default:
      throw new Error(`Unknown input port ${targetHandle} for style_selector`)
  }
}

function _resolveTextInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  switch (targetHandle) {
    case 'in_input':
      return _resolveTextInInputInputFlushValue(nodes, edgeRefs)
    default:
      throw new Error(`Unknown input port ${targetHandle} for text`)
  }
}

function _resolveVideoInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  switch (targetHandle) {
    case 'in_file_name':
      return _resolveVideoInFileNameInputFlushValue(nodes, edgeRefs)
    case 'in_depth_include_audio':
      return _resolveVideoInDepthIncludeAudioInputFlushValue(nodes, edgeRefs)
    case 'in_transform_video':
      return _resolveVideoInTransformVideoInputFlushValue(nodes, edgeRefs)
    case 'in_transform_target_resolution':
      return _resolveVideoInTransformTargetResolutionInputFlushValue(nodes, edgeRefs)
    case 'in_transform_source_asset_path':
      return _resolveVideoInTransformSourceAssetPathInputFlushValue(nodes, edgeRefs)
    case 'in_transform_source_content_sha256':
      return _resolveVideoInTransformSourceContentSha256InputFlushValue(nodes, edgeRefs)
    case 'in_transform_source_width':
      return _resolveVideoInTransformSourceWidthInputFlushValue(nodes, edgeRefs)
    case 'in_transform_source_height':
      return _resolveVideoInTransformSourceHeightInputFlushValue(nodes, edgeRefs)
    case 'in_transform_source_frame_count':
      return _resolveVideoInTransformSourceFrameCountInputFlushValue(nodes, edgeRefs)
    case 'in_transform_source_fps':
      return _resolveVideoInTransformSourceFpsInputFlushValue(nodes, edgeRefs)
    default:
      throw new Error(`Unknown input port ${targetHandle} for video`)
  }
}

function _resolveVideoEditorInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  switch (targetHandle) {
    case 'in_reference_media':
      return _resolveVideoEditorInReferenceMediaInputFlushValue(nodes, edgeRefs)
    case 'in_videos':
      return _resolveVideoEditorInVideosInputFlushValue(nodes, edgeRefs)
    case 'in_audios':
      return _resolveVideoEditorInAudiosInputFlushValue(nodes, edgeRefs)
    case 'in_audio':
      return _resolveVideoEditorInAudioInputFlushValue(nodes, edgeRefs)
    case 'in_video_config':
      return _resolveVideoEditorInVideoConfigInputFlushValue(nodes, edgeRefs)
    case 'in_edit_spec':
      return _resolveVideoEditorInEditSpecInputFlushValue(nodes, edgeRefs)
    case 'in_mode':
      return _resolveVideoEditorInModeInputFlushValue(nodes, edgeRefs)
    case 'in_output_name':
      return _resolveVideoEditorInOutputNameInputFlushValue(nodes, edgeRefs)
    case 'in_start':
      return _resolveVideoEditorInStartInputFlushValue(nodes, edgeRefs)
    case 'in_end':
      return _resolveVideoEditorInEndInputFlushValue(nodes, edgeRefs)
    case 'in_volume':
      return _resolveVideoEditorInVolumeInputFlushValue(nodes, edgeRefs)
    case 'in_export_name':
      return _resolveVideoEditorInExportNameInputFlushValue(nodes, edgeRefs)
    default:
      throw new Error(`Unknown input port ${targetHandle} for video_editor`)
  }
}

function _resolveVideoGeneratorInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  switch (targetHandle) {
    case 'in_reference_media':
      return _resolveVideoGeneratorInReferenceMediaInputFlushValue(nodes, edgeRefs)
    case 'in_mode':
      return _resolveVideoGeneratorInModeInputFlushValue(nodes, edgeRefs)
    case 'in_scene_id':
      return _resolveVideoGeneratorInSceneIdInputFlushValue(nodes, edgeRefs)
    case 'in_clip_number':
      return _resolveVideoGeneratorInClipNumberInputFlushValue(nodes, edgeRefs)
    case 'in_images':
      return _resolveVideoGeneratorInImagesInputFlushValue(nodes, edgeRefs)
    case 'in_reference_videos':
      return _resolveVideoGeneratorInReferenceVideosInputFlushValue(nodes, edgeRefs)
    case 'in_continuation_source':
      return _resolveVideoGeneratorInContinuationSourceInputFlushValue(nodes, edgeRefs)
    case 'in_shot_list_source_id':
      return _resolveVideoGeneratorInShotListSourceIdInputFlushValue(nodes, edgeRefs)
    case 'in_shot_list_source_fingerprint':
      return _resolveVideoGeneratorInShotListSourceFingerprintInputFlushValue(nodes, edgeRefs)
    case 'in_shot_list_request_fingerprint':
      return _resolveVideoGeneratorInShotListRequestFingerprintInputFlushValue(nodes, edgeRefs)
    case 'in_reference_audios':
      return _resolveVideoGeneratorInReferenceAudiosInputFlushValue(nodes, edgeRefs)
    case 'in_audio':
      return _resolveVideoGeneratorInAudioInputFlushValue(nodes, edgeRefs)
    case 'in_motion_prompt':
      return _resolveVideoGeneratorInMotionPromptInputFlushValue(nodes, edgeRefs)
    case 'in_scene_context':
      return _resolveVideoGeneratorInSceneContextInputFlushValue(nodes, edgeRefs)
    case 'in_duration':
      return _resolveVideoGeneratorInDurationInputFlushValue(nodes, edgeRefs)
    case 'in_reference_video_edits':
      return _resolveVideoGeneratorInReferenceVideoEditsInputFlushValue(nodes, edgeRefs)
    case 'in_dialogue_prompt':
      return _resolveVideoGeneratorInDialoguePromptInputFlushValue(nodes, edgeRefs)
    case 'in_model':
      return _resolveVideoGeneratorInModelInputFlushValue(nodes, edgeRefs)
    case 'in_aspect_ratio':
      return _resolveVideoGeneratorInAspectRatioInputFlushValue(nodes, edgeRefs)
    case 'in_resolution':
      return _resolveVideoGeneratorInResolutionInputFlushValue(nodes, edgeRefs)
    case 'in_generate_audio':
      return _resolveVideoGeneratorInGenerateAudioInputFlushValue(nodes, edgeRefs)
    case 'in_provider_generate_audio':
      return _resolveVideoGeneratorInProviderGenerateAudioInputFlushValue(nodes, edgeRefs)
    case 'in_use_voice_profile_audio_references':
      return _resolveVideoGeneratorInUseVoiceProfileAudioReferencesInputFlushValue(nodes, edgeRefs)
    case 'in_audio_remix_mode':
      return _resolveVideoGeneratorInAudioRemixModeInputFlushValue(nodes, edgeRefs)
    case 'in_allow_bgm':
      return _resolveVideoGeneratorInAllowBgmInputFlushValue(nodes, edgeRefs)
    case 'in_tts_provider':
      return _resolveVideoGeneratorInTtsProviderInputFlushValue(nodes, edgeRefs)
    case 'in_dub_target_language':
      return _resolveVideoGeneratorInDubTargetLanguageInputFlushValue(nodes, edgeRefs)
    case 'in_voice_profiles':
      return _resolveVideoGeneratorInVoiceProfilesInputFlushValue(nodes, edgeRefs)
    case 'in_voice_settings':
      return _resolveVideoGeneratorInVoiceSettingsInputFlushValue(nodes, edgeRefs)
    case 'in_name':
      return _resolveVideoGeneratorInNameInputFlushValue(nodes, edgeRefs)
    case 'in_resolved_voice_map':
      return _resolveVideoGeneratorInResolvedVoiceMapInputFlushValue(nodes, edgeRefs)
    case 'in_audio_remix_config':
      return _resolveVideoGeneratorInAudioRemixConfigInputFlushValue(nodes, edgeRefs)
    case 'in_speech_transformer_config':
      return _resolveVideoGeneratorInSpeechTransformerConfigInputFlushValue(nodes, edgeRefs)
    case 'in_audio_take_selections':
      return _resolveVideoGeneratorInAudioTakeSelectionsInputFlushValue(nodes, edgeRefs)
    case 'in_audio_variant_workspaces':
      return _resolveVideoGeneratorInAudioVariantWorkspacesInputFlushValue(nodes, edgeRefs)
    case 'in_unified_audio_config':
      return _resolveVideoGeneratorInUnifiedAudioConfigInputFlushValue(nodes, edgeRefs)
    case 'in_style':
      return _resolveVideoGeneratorInStyleInputFlushValue(nodes, edgeRefs)
    default:
      throw new Error(`Unknown input port ${targetHandle} for video_generator`)
  }
}

function _resolveWebtoonGroupInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  switch (targetHandle) {
    case 'in_scene_id':
      return _resolveWebtoonGroupInSceneIdInputFlushValue(nodes, edgeRefs)
    case 'in_label':
      return _resolveWebtoonGroupInLabelInputFlushValue(nodes, edgeRefs)
    case 'in_collapsed':
      return _resolveWebtoonGroupInCollapsedInputFlushValue(nodes, edgeRefs)
    case 'in_child_node_ids':
      return _resolveWebtoonGroupInChildNodeIdsInputFlushValue(nodes, edgeRefs)
    default:
      throw new Error(`Unknown input port ${targetHandle} for webtoon_group`)
  }
}

function _resolveWebtoonPanelGeneratorInputFromEdgeRefs(
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  switch (targetHandle) {
    case 'in_images':
      return _resolveWebtoonPanelGeneratorInImagesInputFlushValue(nodes, edgeRefs)
    case 'in_prompt':
      return _resolveWebtoonPanelGeneratorInPromptInputFlushValue(nodes, edgeRefs)
    case 'in_beats':
      return _resolveWebtoonPanelGeneratorInBeatsInputFlushValue(nodes, edgeRefs)
    case 'in_dialogue':
      return _resolveWebtoonPanelGeneratorInDialogueInputFlushValue(nodes, edgeRefs)
    case 'in_panel_index':
      return _resolveWebtoonPanelGeneratorInPanelIndexInputFlushValue(nodes, edgeRefs)
    case 'in_aspect_ratio':
      return _resolveWebtoonPanelGeneratorInAspectRatioInputFlushValue(nodes, edgeRefs)
    case 'in_layout':
      return _resolveWebtoonPanelGeneratorInLayoutInputFlushValue(nodes, edgeRefs)
    case 'in_style':
      return _resolveWebtoonPanelGeneratorInStyleInputFlushValue(nodes, edgeRefs)
    case 'in_name':
      return _resolveWebtoonPanelGeneratorInNameInputFlushValue(nodes, edgeRefs)
    case 'in_feedback':
      return _resolveWebtoonPanelGeneratorInFeedbackInputFlushValue(nodes, edgeRefs)
    case 'in_feedback_history':
      return _resolveWebtoonPanelGeneratorInFeedbackHistoryInputFlushValue(nodes, edgeRefs)
    default:
      throw new Error(`Unknown input port ${targetHandle} for webtoon_panel_generator`)
  }
}

// Read-only counterpart of flushYDocInputFromEdgeRefs: identical edge
// semantics (edge order, fromIndex selection, multi-port flattening),
// no YDoc write and no bound node required.
export function resolveYDocInputFromEdgeRefsByFeType(
  feType: FeNodeType,
  targetHandle: string,
  nodes: readonly YDocInputFlushNode[],
  edgeRefs: readonly YDocInputFlushEdgeRef[],
): YDocWriteValue | YDocWriteValue[] | undefined {
  switch (feType) {
    case 'audio':
      return _resolveAudioInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'characterDesigner':
      return _resolveCharacterDesignerInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'debugHang':
      return _resolveDebugHangInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'director':
      return _resolveDirectorInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'generatedImageWithHistory':
      return _resolveGeneratedImageWithHistoryInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'image':
      return _resolveImageInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'imageGenerator':
      return _resolveImageGeneratorInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'locationDesigner':
      return _resolveLocationDesignerInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'nodeGroup':
      return _resolveNodeGroupInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'objectDesigner':
      return _resolveObjectDesignerInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'panelSource':
      return _resolvePanelSourceInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'promptInput':
      return _resolvePromptInputInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'scriptWriter':
      return _resolveScriptWriterInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'shortVideoGroup':
      return _resolveShortVideoGroupInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'soundExpert':
      return _resolveSoundExpertInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'speechGenerator':
      return _resolveSpeechGeneratorInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'storyDirectionPreview':
      return _resolveStoryDirectionPreviewInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'storyboardDesigner':
      return _resolveStoryboardDesignerInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'storyboardNoEnhanceDesigner':
      return _resolveStoryboardNoEnhanceDesignerInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'styleSelector':
      return _resolveStyleSelectorInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'text':
      return _resolveTextInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'video':
      return _resolveVideoInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'videoEditor':
      return _resolveVideoEditorInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'videoGenerator':
      return _resolveVideoGeneratorInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'webtoonGroup':
      return _resolveWebtoonGroupInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    case 'webtoonPanelGenerator':
      return _resolveWebtoonPanelGeneratorInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
    default:
      throw new Error(`Unknown node type ${feType} for input resolution`)
  }
}

/** Frontend type to interface type mapping (use with getTypedNodeData) */
export type FeNodeDataMap = {
  'audio': AudioNodeData
  'characterDesigner': CharacterDesignerNodeData
  'debugHang': DebugHangNodeData
  'director': DirectorNodeData
  'generatedImageWithHistory': GeneratedImageWithHistoryNodeData
  'image': ImageNodeData
  'imageGenerator': ImageGeneratorNodeData
  'locationDesigner': LocationDesignerNodeData
  'nodeGroup': NodeGroupNodeData
  'objectDesigner': ObjectDesignerNodeData
  'panelSource': PanelSourceNodeData
  'promptInput': PromptInputNodeData
  'scriptWriter': ScriptWriterNodeData
  'shortVideoGroup': ShortVideoGroupNodeData
  'soundExpert': SoundExpertNodeData
  'speechGenerator': SpeechGeneratorNodeData
  'storyDirectionPreview': StoryDirectionPreviewNodeData
  'storyboardDesigner': StoryboardDesignerNodeData
  'storyboardNoEnhanceDesigner': StoryboardNoEnhanceDesignerNodeData
  'styleSelector': StyleSelectorNodeData
  'text': TextNodeData
  'video': VideoNodeData
  'videoEditor': VideoEditorNodeData
  'videoGenerator': VideoGeneratorNodeData
  'webtoonGroup': WebtoonGroupNodeData
  'webtoonPanelGenerator': WebtoonPanelGeneratorNodeData
}

export type FeNodeType = keyof FeNodeDataMap
/** Frontend type to write payload type mapping */
export type FeNodeWriteDataMap = {
  'audio': AudioNodeWriteData
  'characterDesigner': CharacterDesignerNodeWriteData
  'debugHang': DebugHangNodeWriteData
  'director': DirectorNodeWriteData
  'generatedImageWithHistory': GeneratedImageWithHistoryNodeWriteData
  'image': ImageNodeWriteData
  'imageGenerator': ImageGeneratorNodeWriteData
  'locationDesigner': LocationDesignerNodeWriteData
  'nodeGroup': NodeGroupNodeWriteData
  'objectDesigner': ObjectDesignerNodeWriteData
  'panelSource': PanelSourceNodeWriteData
  'promptInput': PromptInputNodeWriteData
  'scriptWriter': ScriptWriterNodeWriteData
  'shortVideoGroup': ShortVideoGroupNodeWriteData
  'soundExpert': SoundExpertNodeWriteData
  'speechGenerator': SpeechGeneratorNodeWriteData
  'storyDirectionPreview': StoryDirectionPreviewNodeWriteData
  'storyboardDesigner': StoryboardDesignerNodeWriteData
  'storyboardNoEnhanceDesigner': StoryboardNoEnhanceDesignerNodeWriteData
  'styleSelector': StyleSelectorNodeWriteData
  'text': TextNodeWriteData
  'video': VideoNodeWriteData
  'videoEditor': VideoEditorNodeWriteData
  'videoGenerator': VideoGeneratorNodeWriteData
  'webtoonGroup': WebtoonGroupNodeWriteData
  'webtoonPanelGenerator': WebtoonPanelGeneratorNodeWriteData
}
export type FeNodeDataUpdate<T extends FeNodeType> = Partial<FeNodeWriteDataMap[T]>
export function feNodeDataFieldUpdate<T extends FeNodeType, K extends keyof FeNodeWriteDataMap[T] & string>(
  _type: T,
  key: K,
  value: FeNodeWriteDataMap[T][K],
): Pick<FeNodeWriteDataMap[T], K> {
  return { [key]: value } as Pick<FeNodeWriteDataMap[T], K>
}

export type ReactFlowNodeLike = { type?: string | null; data?: unknown }
export type UntypedReactFlowNode = Node<unknown, string | undefined>
export interface ReactFlowNodeUiData {
  initialFile?: File
  _initialPreviewUrl?: string
  _expandedHeight?: number
}
export type ReactFlowCanvasNodeDataByType = {
  'audio': FeNodeWriteDataMap['audio'] & ReactFlowNodeUiData
  'characterDesigner': FeNodeWriteDataMap['characterDesigner'] & ReactFlowNodeUiData
  'debugHang': FeNodeWriteDataMap['debugHang'] & ReactFlowNodeUiData
  'director': FeNodeWriteDataMap['director'] & ReactFlowNodeUiData
  'generatedImageWithHistory': FeNodeWriteDataMap['generatedImageWithHistory'] & ReactFlowNodeUiData
  'image': FeNodeWriteDataMap['image'] & ReactFlowNodeUiData
  'imageGenerator': FeNodeWriteDataMap['imageGenerator'] & ReactFlowNodeUiData
  'locationDesigner': FeNodeWriteDataMap['locationDesigner'] & ReactFlowNodeUiData
  'nodeGroup': FeNodeWriteDataMap['nodeGroup'] & ReactFlowNodeUiData
  'objectDesigner': FeNodeWriteDataMap['objectDesigner'] & ReactFlowNodeUiData
  'panelSource': FeNodeWriteDataMap['panelSource'] & ReactFlowNodeUiData
  'promptInput': FeNodeWriteDataMap['promptInput'] & ReactFlowNodeUiData
  'scriptWriter': FeNodeWriteDataMap['scriptWriter'] & ReactFlowNodeUiData
  'shortVideoGroup': FeNodeWriteDataMap['shortVideoGroup'] & ReactFlowNodeUiData
  'soundExpert': FeNodeWriteDataMap['soundExpert'] & ReactFlowNodeUiData
  'speechGenerator': FeNodeWriteDataMap['speechGenerator'] & ReactFlowNodeUiData
  'storyDirectionPreview': FeNodeWriteDataMap['storyDirectionPreview'] & ReactFlowNodeUiData
  'storyboardDesigner': FeNodeWriteDataMap['storyboardDesigner'] & ReactFlowNodeUiData
  'storyboardNoEnhanceDesigner': FeNodeWriteDataMap['storyboardNoEnhanceDesigner'] & ReactFlowNodeUiData
  'styleSelector': FeNodeWriteDataMap['styleSelector'] & ReactFlowNodeUiData
  'text': FeNodeWriteDataMap['text'] & ReactFlowNodeUiData
  'video': FeNodeWriteDataMap['video'] & ReactFlowNodeUiData
  'videoEditor': FeNodeWriteDataMap['videoEditor'] & ReactFlowNodeUiData
  'videoGenerator': FeNodeWriteDataMap['videoGenerator'] & ReactFlowNodeUiData
  'webtoonGroup': FeNodeWriteDataMap['webtoonGroup'] & ReactFlowNodeUiData
  'webtoonPanelGenerator': FeNodeWriteDataMap['webtoonPanelGenerator'] & ReactFlowNodeUiData
}
export type ReactFlowNodeDataPatch<T extends FeNodeType> = Partial<ReactFlowCanvasNodeDataByType[T]>
export type ReactFlowNodeRef<T extends FeNodeType> = { id: string; type: T }
export type AppNodeData = ReactFlowCanvasNodeDataByType[keyof ReactFlowCanvasNodeDataByType]
export type ReactFlowNodeByType = {
  'audio': Node<ReactFlowCanvasNodeDataByType['audio'], 'audio'>
  'characterDesigner': Node<ReactFlowCanvasNodeDataByType['characterDesigner'], 'characterDesigner'>
  'debugHang': Node<ReactFlowCanvasNodeDataByType['debugHang'], 'debugHang'>
  'director': Node<ReactFlowCanvasNodeDataByType['director'], 'director'>
  'generatedImageWithHistory': Node<ReactFlowCanvasNodeDataByType['generatedImageWithHistory'], 'generatedImageWithHistory'>
  'image': Node<ReactFlowCanvasNodeDataByType['image'], 'image'>
  'imageGenerator': Node<ReactFlowCanvasNodeDataByType['imageGenerator'], 'imageGenerator'>
  'locationDesigner': Node<ReactFlowCanvasNodeDataByType['locationDesigner'], 'locationDesigner'>
  'nodeGroup': Node<ReactFlowCanvasNodeDataByType['nodeGroup'], 'nodeGroup'>
  'objectDesigner': Node<ReactFlowCanvasNodeDataByType['objectDesigner'], 'objectDesigner'>
  'panelSource': Node<ReactFlowCanvasNodeDataByType['panelSource'], 'panelSource'>
  'promptInput': Node<ReactFlowCanvasNodeDataByType['promptInput'], 'promptInput'>
  'scriptWriter': Node<ReactFlowCanvasNodeDataByType['scriptWriter'], 'scriptWriter'>
  'shortVideoGroup': Node<ReactFlowCanvasNodeDataByType['shortVideoGroup'], 'shortVideoGroup'>
  'soundExpert': Node<ReactFlowCanvasNodeDataByType['soundExpert'], 'soundExpert'>
  'speechGenerator': Node<ReactFlowCanvasNodeDataByType['speechGenerator'], 'speechGenerator'>
  'storyDirectionPreview': Node<ReactFlowCanvasNodeDataByType['storyDirectionPreview'], 'storyDirectionPreview'>
  'storyboardDesigner': Node<ReactFlowCanvasNodeDataByType['storyboardDesigner'], 'storyboardDesigner'>
  'storyboardNoEnhanceDesigner': Node<ReactFlowCanvasNodeDataByType['storyboardNoEnhanceDesigner'], 'storyboardNoEnhanceDesigner'>
  'styleSelector': Node<ReactFlowCanvasNodeDataByType['styleSelector'], 'styleSelector'>
  'text': Node<ReactFlowCanvasNodeDataByType['text'], 'text'>
  'video': Node<ReactFlowCanvasNodeDataByType['video'], 'video'>
  'videoEditor': Node<ReactFlowCanvasNodeDataByType['videoEditor'], 'videoEditor'>
  'videoGenerator': Node<ReactFlowCanvasNodeDataByType['videoGenerator'], 'videoGenerator'>
  'webtoonGroup': Node<ReactFlowCanvasNodeDataByType['webtoonGroup'], 'webtoonGroup'>
  'webtoonPanelGenerator': Node<ReactFlowCanvasNodeDataByType['webtoonPanelGenerator'], 'webtoonPanelGenerator'>
}
export type TypedReactFlowNode<T extends FeNodeType> = T extends FeNodeType ? ReactFlowNodeByType[T] : never
export type AppNode = TypedReactFlowNode<FeNodeType>
export const FE_NODE_TYPES: ReadonlyArray<FeNodeType> = [
  'audio',
  'characterDesigner',
  'debugHang',
  'director',
  'generatedImageWithHistory',
  'image',
  'imageGenerator',
  'locationDesigner',
  'nodeGroup',
  'objectDesigner',
  'panelSource',
  'promptInput',
  'scriptWriter',
  'shortVideoGroup',
  'soundExpert',
  'speechGenerator',
  'storyDirectionPreview',
  'storyboardDesigner',
  'storyboardNoEnhanceDesigner',
  'styleSelector',
  'text',
  'video',
  'videoEditor',
  'videoGenerator',
  'webtoonGroup',
  'webtoonPanelGenerator',
]

export function isFeNodeType(type: string | null | undefined): type is FeNodeType {
  return typeof type === 'string' && FE_NODE_TYPES.some((candidate) => candidate === type)
}

export function isTypedReactFlowNode<T extends FeNodeType>(
  node: UntypedReactFlowNode,
  type: T,
): node is TypedReactFlowNode<T> {
  return node.type === type
}

// ---------------------------------------------------------------------------
// Raw typed YDoc node surfaces
// ---------------------------------------------------------------------------

export type GeneratedAssetEntryJson = GeneratedImage

export abstract class GeneratedCanvasNode<TWriteData> implements YDocInputFlushTarget {
  protected constructor(protected readonly _raw: Y.Map<YDocValue>) {}

  abstract get(key: string): unknown
  protected isDerivedField(_key: string): boolean { return false }

  readDataFields(): Record<string, unknown> {
    const dataRaw: Record<string, unknown> = {}
    for (const key of this._raw.keys()) {
      if (YDOC_STRUCTURAL_KEYS.has(key)) continue
      if (key.startsWith('_')) continue
      if (YDOC_RETIRED_DATA_KEYS.has(key)) continue
      const raw = this._raw.get(key)
      const newKey = YDOC_LEGACY_FIELD_RENAMES[key]
      const dataKey = newKey ?? key
      if (dataKey in dataRaw) continue
      if (YDOC_COMMON_DATA_KEYS.has(dataKey)) {
        // Preserve explicit clears in partial ReactFlow data merges.
        dataRaw[dataKey] = raw ?? undefined
        continue
      }
      const typed = this.get(dataKey)
      if (typed !== undefined) {
        dataRaw[dataKey] = typed
        continue
      }
      if (raw == null) {
        dataRaw[dataKey] = undefined
        continue
      }
      if (this.isDerivedField(dataKey)) continue
      throw new Error(`${this.constructor.name}.readDataFields: field ${key} is not declared in generated schema`)
    }
    return dataRaw
  }

  abstract writeDataFields(updates: Partial<TWriteData>, opts?: YDocWriteOpts): string[]

  abstract flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined

  abstract resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined

  protected _getMapField<T extends YMapWrapper>(
    field: string,
    Wrapper: new (raw: Y.Map<YDocValue>) => T,
  ): T | undefined {
    const raw = this._raw.get(field)
    if (!(raw instanceof Y.Map)) return undefined
    return new Wrapper(raw)
  }

  protected _writeMapField(field: string, value: YDocWriteValue): boolean {
    if (value === null || value === undefined) {
      if (this._raw.get(field) === value) return false
      this._raw.set(field, value)
      return true
    }
    if (value instanceof Y.Map || value instanceof YMapWrapper) {
      const serialized = _toYDocValue(value)
      if (this._raw.get(field) === serialized) return false
      this._raw.set(field, serialized)
      return true
    }
    if (!_isYDocWriteObject(value)) {
      throw new TypeError(`${field} must be object or Y.Map for map wire field, got ${_yDocTypeName(value)}`)
    }

    const existing = this._raw.get(field)
    if (existing instanceof Y.Map) {
      let written = false
      for (const oldKey of [...existing.keys()]) {
        if (!(oldKey in value)) {
          existing.delete(oldKey)
          written = true
        }
      }
      for (const [entryKey, entryValue] of Object.entries(value)) {
        const serialized = _toYDocValue(entryValue)
        if (existing.get(entryKey) !== serialized) {
          existing.set(entryKey, serialized)
          written = true
        }
      }
      return written
    }

    const yMap = new Y.Map<YDocValue>()
    for (const [entryKey, entryValue] of Object.entries(value)) {
      yMap.set(entryKey, _toYDocValue(entryValue))
    }
    this._raw.set(field, yMap)
    return true
  }

  protected _writeArrayField(field: string, value: YDocWriteValue): boolean {
    let arr: YDocValue[]
    if (value instanceof Y.Array) {
      arr = value.toArray().map((item) => _toYDocValue(item))
    } else {
      arr = Array.isArray(value)
        ? value.map((item) => _toYDocValue(item))
        : (value != null ? [_toYDocValue(value)] : [])
    }
    if (field === 'in_child_node_ids') {
      const seen = new Set<string>()
      arr = arr.filter((id) => {
        if (id === null) return true
        if (typeof id === 'string' && seen.has(id)) return false
        if (typeof id === 'string') seen.add(id)
        return true
      })
    }
    const existing = this._raw.get(field)
    if (existing instanceof Y.Array) {
      const current = existing.toArray()
      if (current.length === arr.length && current.every((item, index) => item === arr[index])) return false
      existing.delete(0, existing.length)
      existing.push(arr)
      return true
    }
    const yArr = new Y.Array<YDocValue>()
    yArr.push(arr)
    this._raw.set(field, yArr)
    return true
  }

  protected _writeDesignerJsonField(field: string, _value: YDocWriteValue): boolean {
    // CRDT race prevention: designer asset JSON fields are backend-authored
    // only. Writing the full JSON string from the frontend races with the
    // backend's emit_outputs in production (multi-instance Yjs sync latency),
    // causing last-writer-wins to discard newly-appended variant history.
    // See Workplace #1518197933270838 for full RCA.
    throw new Error(`${field} is backend-authored; use a narrow Y.Map patch or forceDesignerJsonFields for import/restore`)
  }

  protected _writePrimitiveJsonField(field: string, value: YDocWriteValue): boolean {
    const serialized = _serializeYDocFieldValue(field, value)
    if (this._raw.get(field) === serialized) return false
    this._raw.set(field, serialized)
    return true
  }

  protected _writeDataFieldByWireType(
    field: string,
    wireType: YDocWireType,
    value: YDocWriteValue,
    opts?: YDocWriteOpts,
    isDesignerImageField = false,
    primitiveType?: 'string' | 'number' | 'boolean',
    validator?: _YDocValidator,
  ): boolean {
    if (YDOC_STRUCTURAL_KEYS.has(field)) return false
    if (field.startsWith('_')) return false
    if (typeof File !== 'undefined' && value instanceof File) return false
    if (validator !== undefined) {
      const validationValue = _attachYDocValidationCandidate(value)
      validator(validationValue, field)
    }
    if (isDesignerImageField) {
      if (opts?.forceDesignerJsonFields) return this._writeMapField(field, value)
      return this._writeDesignerJsonField(field, value)
    }
    if (wireType === 'map') return this._writeMapField(field, value)
    if (wireType === 'array') return this._writeArrayField(field, value)
    if (primitiveType !== undefined && value !== null && value !== undefined && typeof value !== primitiveType) {
      throw new TypeError(`${field} must be ${primitiveType}, got ${_yDocTypeName(value)}`)
    }
    return this._writePrimitiveJsonField(field, value)
  }

  protected _writeCommonDataField(field: string, value: YDocWriteValue): boolean {
    if (YDOC_STRUCTURAL_KEYS.has(field)) return false
    if (field.startsWith('_')) return false
    if (typeof File !== 'undefined' && value instanceof File) return false
    switch (field) {
      case 'name':
      case 'error':
      case 'progress':
      case 'progressMessage':
      case 'projectId':
      case 'cacheKey':
        return this._writePrimitiveJsonField(field, value)
      default:
        return false
    }
  }
}

export class AudioCanvasNode extends GeneratedCanvasNode<AudioNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  get(key: 'type'): "audio" | undefined
  get(key: 'in_file_name'): string | undefined
  get(key: 'in_voice_profile'): VoiceProfileDictYMap | undefined
  get(key: 'out_audio'): AudioAssetRefDictYMap | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'in_file_name': return _readYDocOptionalString(this._raw.get('in_file_name'), "audio.in_file_name")
      case 'in_voice_profile': return _readYDocOptionalMapWrapper(this._raw.get('in_voice_profile'), VoiceProfileDictYMap, "audio.in_voice_profile")
      case 'out_audio': return _readYDocOptionalMapWrapper(this._raw.get('out_audio'), AudioAssetRefDictYMap, "audio.out_audio")
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "in_file_name" | "in_voice_profile" | "out_audio" | "revision"): void { this._raw.delete(key) }
  has(key: "type" | "in_file_name" | "in_voice_profile" | "out_audio" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<AudioNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this._writeDataField(field as keyof AudioNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof AudioNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'in_file_name': return this.writeInFileName(value as Exclude<AudioNodeWriteData['in_file_name'], undefined>, opts)
      case 'in_voice_profile': return this.writeInVoiceProfile(value as Exclude<AudioNodeWriteData['in_voice_profile'], undefined>, opts)
      case 'out_audio': return this.writeOutAudio(value as Exclude<AudioNodeWriteData['out_audio'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writeInFileName(value: Exclude<AudioNodeWriteData['in_file_name'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_file_name', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInVoiceProfile(value: Exclude<AudioNodeWriteData['in_voice_profile'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_voice_profile', 'map', value, opts, false, undefined, undefined)
  }

  writeOutAudio(value: Exclude<AudioNodeWriteData['out_audio'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_audio', 'map', value, opts, false, undefined, undefined)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolveAudioInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    switch (targetHandle) {
      case 'in_file_name': {
        const value = _resolveAudioInFileNameInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInFileName(value as unknown as Exclude<AudioNodeWriteData['in_file_name'], undefined>)
        return { field: 'in_file_name', value, written }
      }
      case 'in_voice_profile': {
        const value = _resolveAudioInVoiceProfileInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_voice_profile')
        if (hadPersistedValue) this.delete('in_voice_profile')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_voice_profile', value, written }
      }
      default:
        throw new Error(`Unknown input port ${targetHandle} for AudioCanvasNode`)
    }
  }
}

export class CharacterDesignerCanvasNode extends GeneratedCanvasNode<CharacterDesignerNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  protected isDerivedField(key: string): boolean { return key === 'out_name' }
  readDataFields(): Record<string, unknown> {
    const data = super.readDataFields()
    data.out_name = this.get('out_name')
    return data
  }
  get(key: 'type'): "characterDesigner" | undefined
  get(key: 'in_upstream'): UpstreamContextDictYMap | undefined
  get(key: 'in_images'): Array<ImageAssetRefDictYMap | null> | undefined
  get(key: 'in_name'): string | undefined
  get(key: 'in_role'): string | undefined
  get(key: 'in_style'): string | undefined
  get(key: 'in_description'): string | undefined
  get(key: 'in_model'): string | undefined
  get(key: 'in_feedback'): string | undefined
  get(key: 'in_feedback_history'): Array<FeedbackHistoryEntryDictYMap> | undefined
  get(key: 'in_pronunciation_guide'): string | undefined
  get(key: 'in_bg_color'): string | undefined
  get(key: 'in_vlm_validation'): boolean | undefined
  get(key: 'out_name'): string | undefined
  get(key: 'out_image'): CharacterAssetYMap | undefined
  get(key: 'out_voice_profile'): VoiceProfileDictYMap | undefined
  get(key: 'out_vlm_report'): VlmValidationReportDictYMap | undefined
  get(key: 'batch_pending'): number | undefined
  get(key: 'annotated_image_path'): string | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'in_upstream': return _readYDocOptionalMapWrapper(this._raw.get('in_upstream'), UpstreamContextDictYMap, "characterDesigner.in_upstream")
      case 'in_images': return _readYDocOptionalArray(this._raw.get('in_images'), "characterDesigner.in_images", (item, itemLabel) => item == null ? null : _readYDocMapWrapper(item, ImageAssetRefDictYMap, itemLabel))
      case 'in_name': return _readYDocOptionalString(this._raw.get('in_name'), "characterDesigner.in_name")
      case 'in_role': return _readYDocOptionalString(this._raw.get('in_role'), "characterDesigner.in_role")
      case 'in_style': return _readYDocOptionalString(this._raw.get('in_style'), "characterDesigner.in_style")
      case 'in_description': return _readYDocOptionalString(this._raw.get('in_description'), "characterDesigner.in_description")
      case 'in_model': return _readYDocOptionalString(this._raw.get('in_model'), "characterDesigner.in_model")
      case 'in_feedback': return _readYDocOptionalString(this._raw.get('in_feedback'), "characterDesigner.in_feedback")
      case 'in_feedback_history': return _readYDocOptionalArray(this._raw.get('in_feedback_history'), "characterDesigner.in_feedback_history", (item, itemLabel) => _readYDocMapWrapper(item, FeedbackHistoryEntryDictYMap, itemLabel))
      case 'in_pronunciation_guide': return _readYDocOptionalString(this._raw.get('in_pronunciation_guide'), "characterDesigner.in_pronunciation_guide")
      case 'in_bg_color': return _readYDocOptionalString(this._raw.get('in_bg_color'), "characterDesigner.in_bg_color")
      case 'in_vlm_validation': return _readYDocOptionalBoolean(this._raw.get('in_vlm_validation'), "characterDesigner.in_vlm_validation")
      case 'out_name': return _readYDocOptionalString(this._raw.get('in_name'), "characterDesigner.out_name")
      case 'out_image': return _readYDocOptionalMapWrapper(this._raw.get('out_image'), CharacterAssetYMap, "characterDesigner.out_image")
      case 'out_voice_profile': return _readYDocOptionalMapWrapper(this._raw.get('out_voice_profile'), VoiceProfileDictYMap, "characterDesigner.out_voice_profile")
      case 'out_vlm_report': return _readYDocOptionalMapWrapper(this._raw.get('out_vlm_report'), VlmValidationReportDictYMap, "characterDesigner.out_vlm_report")
      case 'batch_pending': return _readYDocOptionalNumber(this._raw.get('batch_pending'), "characterDesigner.batch_pending")
      case 'annotated_image_path': return _readYDocOptionalString(this._raw.get('annotated_image_path'), "characterDesigner.annotated_image_path")
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "in_upstream" | "in_images" | "in_name" | "in_role" | "in_style" | "in_description" | "in_model" | "in_feedback" | "in_feedback_history" | "in_pronunciation_guide" | "in_bg_color" | "in_vlm_validation" | "out_name" | "out_image" | "out_voice_profile" | "out_vlm_report" | "batch_pending" | "annotated_image_path" | "revision"): void { if (this.isDerivedField(key)) throw new Error(`Read-only alias ${key}`); this._raw.delete(key) }
  has(key: "type" | "in_upstream" | "in_images" | "in_name" | "in_role" | "in_style" | "in_description" | "in_model" | "in_feedback" | "in_feedback_history" | "in_pronunciation_guide" | "in_bg_color" | "in_vlm_validation" | "out_name" | "out_image" | "out_voice_profile" | "out_vlm_report" | "batch_pending" | "annotated_image_path" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<CharacterDesignerNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this.isDerivedField(field)) throw new Error(`Read-only alias ${field}`)
      if (this._writeDataField(field as keyof CharacterDesignerNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof CharacterDesignerNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'in_upstream': return this.writeInUpstream(value as Exclude<CharacterDesignerNodeWriteData['in_upstream'], undefined>, opts)
      case 'in_images': return this.writeInImages(value as Exclude<CharacterDesignerNodeWriteData['in_images'], undefined>, opts)
      case 'in_name': return this.writeInName(value as Exclude<CharacterDesignerNodeWriteData['in_name'], undefined>, opts)
      case 'in_role': return this.writeInRole(value as Exclude<CharacterDesignerNodeWriteData['in_role'], undefined>, opts)
      case 'in_style': return this.writeInStyle(value as Exclude<CharacterDesignerNodeWriteData['in_style'], undefined>, opts)
      case 'in_description': return this.writeInDescription(value as Exclude<CharacterDesignerNodeWriteData['in_description'], undefined>, opts)
      case 'in_model': return this.writeInModel(value as Exclude<CharacterDesignerNodeWriteData['in_model'], undefined>, opts)
      case 'in_feedback': return this.writeInFeedback(value as Exclude<CharacterDesignerNodeWriteData['in_feedback'], undefined>, opts)
      case 'in_feedback_history': return this.writeInFeedbackHistory(value as Exclude<CharacterDesignerNodeWriteData['in_feedback_history'], undefined>, opts)
      case 'in_pronunciation_guide': return this.writeInPronunciationGuide(value as Exclude<CharacterDesignerNodeWriteData['in_pronunciation_guide'], undefined>, opts)
      case 'in_bg_color': return this.writeInBgColor(value as Exclude<CharacterDesignerNodeWriteData['in_bg_color'], undefined>, opts)
      case 'in_vlm_validation': return this.writeInVlmValidation(value as Exclude<CharacterDesignerNodeWriteData['in_vlm_validation'], undefined>, opts)
      case 'out_image': return this.writeOutImage(value as Exclude<CharacterDesignerNodeWriteData['out_image'], undefined>, opts)
      case 'out_voice_profile': return this.writeOutVoiceProfile(value as Exclude<CharacterDesignerNodeWriteData['out_voice_profile'], undefined>, opts)
      case 'out_vlm_report': return this.writeOutVlmReport(value as Exclude<CharacterDesignerNodeWriteData['out_vlm_report'], undefined>, opts)
      case 'batch_pending': return this.writeBatchPending(value as Exclude<CharacterDesignerNodeWriteData['batch_pending'], undefined>, opts)
      case 'annotated_image_path': return this.writeAnnotatedImagePath(value as Exclude<CharacterDesignerNodeWriteData['annotated_image_path'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writeInUpstream(value: Exclude<CharacterDesignerNodeWriteData['in_upstream'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_upstream', 'map', value, opts, false, undefined, undefined)
  }

  writeInImages(value: Exclude<CharacterDesignerNodeWriteData['in_images'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_images', 'array', value, opts, false, undefined, undefined)
  }

  writeInName(value: Exclude<CharacterDesignerNodeWriteData['in_name'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_name', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInRole(value: Exclude<CharacterDesignerNodeWriteData['in_role'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_role', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInStyle(value: Exclude<CharacterDesignerNodeWriteData['in_style'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_style', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInDescription(value: Exclude<CharacterDesignerNodeWriteData['in_description'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_description', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInModel(value: Exclude<CharacterDesignerNodeWriteData['in_model'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_model', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInFeedback(value: Exclude<CharacterDesignerNodeWriteData['in_feedback'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_feedback', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInFeedbackHistory(value: Exclude<CharacterDesignerNodeWriteData['in_feedback_history'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_feedback_history', 'array', value, opts, false, undefined, undefined)
  }

  writeInPronunciationGuide(value: Exclude<CharacterDesignerNodeWriteData['in_pronunciation_guide'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_pronunciation_guide', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInBgColor(value: Exclude<CharacterDesignerNodeWriteData['in_bg_color'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_bg_color', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInVlmValidation(value: Exclude<CharacterDesignerNodeWriteData['in_vlm_validation'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_vlm_validation', 'primitive', value, opts, false, 'boolean', undefined)
  }

  writeOutImage(value: Exclude<CharacterDesignerNodeWriteData['out_image'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_image', 'map', value, opts, true, undefined, undefined)
  }

  writeOutVoiceProfile(value: Exclude<CharacterDesignerNodeWriteData['out_voice_profile'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_voice_profile', 'map', value, opts, false, undefined, undefined)
  }

  writeOutVlmReport(value: Exclude<CharacterDesignerNodeWriteData['out_vlm_report'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_vlm_report', 'map', value, opts, false, undefined, undefined)
  }

  writeBatchPending(value: Exclude<CharacterDesignerNodeWriteData['batch_pending'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('batch_pending', 'primitive', value, opts, false, 'number', undefined)
  }

  writeAnnotatedImagePath(value: Exclude<CharacterDesignerNodeWriteData['annotated_image_path'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('annotated_image_path', 'primitive', value, opts, false, 'string', undefined)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolveCharacterDesignerInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    switch (targetHandle) {
      case 'in_upstream': {
        const value = _resolveCharacterDesignerInUpstreamInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInUpstream(value as unknown as Exclude<CharacterDesignerNodeWriteData['in_upstream'], undefined>)
        return { field: 'in_upstream', value, written }
      }
      case 'in_images': {
        const value = _resolveCharacterDesignerInImagesInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_images')
        if (hadPersistedValue) this.delete('in_images')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_images', value, written }
      }
      case 'in_name': {
        const value = _resolveCharacterDesignerInNameInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInName(value as unknown as Exclude<CharacterDesignerNodeWriteData['in_name'], undefined>)
        return { field: 'in_name', value, written }
      }
      case 'in_role': {
        const value = _resolveCharacterDesignerInRoleInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInRole(value as unknown as Exclude<CharacterDesignerNodeWriteData['in_role'], undefined>)
        return { field: 'in_role', value, written }
      }
      case 'in_style': {
        const value = _resolveCharacterDesignerInStyleInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInStyle(value as unknown as Exclude<CharacterDesignerNodeWriteData['in_style'], undefined>)
        return { field: 'in_style', value, written }
      }
      case 'in_description': {
        const value = _resolveCharacterDesignerInDescriptionInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInDescription(value as unknown as Exclude<CharacterDesignerNodeWriteData['in_description'], undefined>)
        return { field: 'in_description', value, written }
      }
      case 'in_model': {
        const value = _resolveCharacterDesignerInModelInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInModel(value as unknown as Exclude<CharacterDesignerNodeWriteData['in_model'], undefined>)
        return { field: 'in_model', value, written }
      }
      case 'in_feedback': {
        const value = _resolveCharacterDesignerInFeedbackInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInFeedback(value as unknown as Exclude<CharacterDesignerNodeWriteData['in_feedback'], undefined>)
        return { field: 'in_feedback', value, written }
      }
      case 'in_feedback_history': {
        const value = _resolveCharacterDesignerInFeedbackHistoryInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInFeedbackHistory(value as unknown as Exclude<CharacterDesignerNodeWriteData['in_feedback_history'], undefined>)
        return { field: 'in_feedback_history', value, written }
      }
      case 'in_pronunciation_guide': {
        const value = _resolveCharacterDesignerInPronunciationGuideInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInPronunciationGuide(value as unknown as Exclude<CharacterDesignerNodeWriteData['in_pronunciation_guide'], undefined>)
        return { field: 'in_pronunciation_guide', value, written }
      }
      case 'in_bg_color': {
        const value = _resolveCharacterDesignerInBgColorInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInBgColor(value as unknown as Exclude<CharacterDesignerNodeWriteData['in_bg_color'], undefined>)
        return { field: 'in_bg_color', value, written }
      }
      case 'in_vlm_validation': {
        const value = _resolveCharacterDesignerInVlmValidationInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInVlmValidation(value as unknown as Exclude<CharacterDesignerNodeWriteData['in_vlm_validation'], undefined>)
        return { field: 'in_vlm_validation', value, written }
      }
      default:
        throw new Error(`Unknown input port ${targetHandle} for CharacterDesignerCanvasNode`)
    }
  }
}

export class DebugHangCanvasNode extends GeneratedCanvasNode<DebugHangNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  get(key: 'type'): "debugHang" | undefined
  get(key: 'in_label'): string | undefined
  get(key: 'out_result'): string | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'in_label': return _readYDocOptionalString(this._raw.get('in_label'), "debugHang.in_label")
      case 'out_result': return _readYDocOptionalString(this._raw.get('out_result'), "debugHang.out_result")
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "in_label" | "out_result" | "revision"): void { this._raw.delete(key) }
  has(key: "type" | "in_label" | "out_result" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<DebugHangNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this._writeDataField(field as keyof DebugHangNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof DebugHangNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'in_label': return this.writeInLabel(value as Exclude<DebugHangNodeWriteData['in_label'], undefined>, opts)
      case 'out_result': return this.writeOutResult(value as Exclude<DebugHangNodeWriteData['out_result'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writeInLabel(value: Exclude<DebugHangNodeWriteData['in_label'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_label', 'primitive', value, opts, false, 'string', undefined)
  }

  writeOutResult(value: Exclude<DebugHangNodeWriteData['out_result'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_result', 'primitive', value, opts, false, 'string', undefined)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolveDebugHangInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    switch (targetHandle) {
      case 'in_label': {
        const value = _resolveDebugHangInLabelInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInLabel(value as unknown as Exclude<DebugHangNodeWriteData['in_label'], undefined>)
        return { field: 'in_label', value, written }
      }
      default:
        throw new Error(`Unknown input port ${targetHandle} for DebugHangCanvasNode`)
    }
  }
}

export class DirectorCanvasNode extends GeneratedCanvasNode<DirectorNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  get(key: 'type'): "director" | undefined
  get(key: 'in_context'): string | undefined
  get(key: 'out_response'): string | undefined
  get(key: 'out_crew'): DirectorCrewDictYMap | undefined
  get(key: 'pending_tool_state'): DirectorPendingToolStateDictYMap | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'in_context': return _readYDocOptionalString(this._raw.get('in_context'), "director.in_context")
      case 'out_response': return _readYDocOptionalString(this._raw.get('out_response'), "director.out_response")
      case 'out_crew': return _readYDocOptionalMapWrapper(this._raw.get('out_crew'), DirectorCrewDictYMap, "director.out_crew")
      case 'pending_tool_state': return _readYDocOptionalMapWrapper(this._raw.get('pending_tool_state'), DirectorPendingToolStateDictYMap, "director.pending_tool_state")
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "in_context" | "out_response" | "out_crew" | "pending_tool_state" | "revision"): void { this._raw.delete(key) }
  has(key: "type" | "in_context" | "out_response" | "out_crew" | "pending_tool_state" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<DirectorNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this._writeDataField(field as keyof DirectorNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof DirectorNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'in_context': return this.writeInContext(value as Exclude<DirectorNodeWriteData['in_context'], undefined>, opts)
      case 'out_response': return this.writeOutResponse(value as Exclude<DirectorNodeWriteData['out_response'], undefined>, opts)
      case 'out_crew': return this.writeOutCrew(value as Exclude<DirectorNodeWriteData['out_crew'], undefined>, opts)
      case 'pending_tool_state': return this.writePendingToolState(value as Exclude<DirectorNodeWriteData['pending_tool_state'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writeInContext(value: Exclude<DirectorNodeWriteData['in_context'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_context', 'primitive', value, opts, false, 'string', undefined)
  }

  writeOutResponse(value: Exclude<DirectorNodeWriteData['out_response'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_response', 'primitive', value, opts, false, 'string', undefined)
  }

  writeOutCrew(value: Exclude<DirectorNodeWriteData['out_crew'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_crew', 'map', value, opts, false, undefined, undefined)
  }

  writePendingToolState(value: Exclude<DirectorNodeWriteData['pending_tool_state'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('pending_tool_state', 'map', value, opts, false, undefined, undefined)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolveDirectorInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    switch (targetHandle) {
      case 'in_context': {
        const value = _resolveDirectorInContextInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInContext(value as unknown as Exclude<DirectorNodeWriteData['in_context'], undefined>)
        return { field: 'in_context', value, written }
      }
      default:
        throw new Error(`Unknown input port ${targetHandle} for DirectorCanvasNode`)
    }
  }
}

export class GeneratedImageWithHistoryCanvasNode extends GeneratedCanvasNode<GeneratedImageWithHistoryNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  get(key: 'type'): "generatedImageWithHistory" | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "revision"): void { this._raw.delete(key) }
  has(key: "type" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<GeneratedImageWithHistoryNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this._writeDataField(field as keyof GeneratedImageWithHistoryNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof GeneratedImageWithHistoryNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    void opts
    switch (field) {
      default: return this._writeCommonDataField(field, value)
    }
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolveGeneratedImageWithHistoryInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    void nodes
    void edgeRefs
    switch (targetHandle) {
      default:
        throw new Error(`Unknown input port ${targetHandle} for GeneratedImageWithHistoryCanvasNode`)
    }
  }
}

export class ImageCanvasNode extends GeneratedCanvasNode<ImageNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  get(key: 'type'): "image" | undefined
  get(key: 'in_file_name'): string | undefined
  get(key: 'in_image'): ImageAssetRefDictYMap | undefined
  get(key: 'out_image'): ImageAssetRefDictYMap | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'in_file_name': return _readYDocOptionalString(this._raw.get('in_file_name'), "image.in_file_name")
      case 'in_image': return _readYDocOptionalMapWrapper(this._raw.get('in_image'), ImageAssetRefDictYMap, "image.in_image")
      case 'out_image': return _readYDocOptionalMapWrapper(this._raw.get('out_image'), ImageAssetRefDictYMap, "image.out_image")
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "in_file_name" | "in_image" | "out_image" | "revision"): void { this._raw.delete(key) }
  has(key: "type" | "in_file_name" | "in_image" | "out_image" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<ImageNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this._writeDataField(field as keyof ImageNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof ImageNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'in_file_name': return this.writeInFileName(value as Exclude<ImageNodeWriteData['in_file_name'], undefined>, opts)
      case 'in_image': return this.writeInImage(value as Exclude<ImageNodeWriteData['in_image'], undefined>, opts)
      case 'out_image': return this.writeOutImage(value as Exclude<ImageNodeWriteData['out_image'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writeInFileName(value: Exclude<ImageNodeWriteData['in_file_name'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_file_name', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInImage(value: Exclude<ImageNodeWriteData['in_image'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_image', 'map', value, opts, false, undefined, undefined)
  }

  writeOutImage(value: Exclude<ImageNodeWriteData['out_image'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_image', 'map', value, opts, false, undefined, undefined)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolveImageInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    switch (targetHandle) {
      case 'in_file_name': {
        const value = _resolveImageInFileNameInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInFileName(value as unknown as Exclude<ImageNodeWriteData['in_file_name'], undefined>)
        return { field: 'in_file_name', value, written }
      }
      case 'in_image': {
        const value = _resolveImageInImageInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_image')
        if (hadPersistedValue) this.delete('in_image')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_image', value, written }
      }
      default:
        throw new Error(`Unknown input port ${targetHandle} for ImageCanvasNode`)
    }
  }
}

export class ImageGeneratorCanvasNode extends GeneratedCanvasNode<ImageGeneratorNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  get(key: 'type'): "imageGenerator" | undefined
  get(key: 'in_images'): Array<ImageAssetRefDictYMap | null> | undefined
  get(key: 'in_upstream'): UpstreamContextDictYMap | undefined
  get(key: 'in_name'): string | undefined
  get(key: 'in_prompt'): string | undefined
  get(key: 'in_aspect_ratio'): AspectRatio | undefined
  get(key: 'in_style'): string | undefined
  get(key: 'in_quality'): string | undefined
  get(key: 'in_model'): string | undefined
  get(key: 'in_panel_refs'): Array<string> | undefined
  get(key: 'in_update'): boolean | undefined
  get(key: 'in_image'): ImageAssetRefDictYMap | undefined
  get(key: 'in_feedback'): string | undefined
  get(key: 'in_video'): string | undefined
  get(key: 'in_source_video'): GeneratedVideoWithHistoryYMap | undefined
  get(key: 'in_expected_video_duration_ms'): number | undefined
  get(key: 'in_frame'): string | undefined
  get(key: 'in_get_frame'): boolean | undefined
  get(key: 'in_feedback_history'): Array<FeedbackHistoryEntryDictYMap> | undefined
  get(key: 'in_vlm_validation'): boolean | undefined
  get(key: 'out_image'): GeneratedImageWithHistoryYMap | undefined
  get(key: 'out_vlm_report'): VlmValidationReportDictYMap | undefined
  get(key: 'batch_pending'): number | undefined
  get(key: 'annotated_image_path'): string | undefined
  get(key: 'name_autogen'): string | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'in_images': return _readYDocOptionalArray(this._raw.get('in_images'), "imageGenerator.in_images", (item, itemLabel) => item == null ? null : _readYDocMapWrapper(item, ImageAssetRefDictYMap, itemLabel))
      case 'in_upstream': return _readYDocOptionalMapWrapper(this._raw.get('in_upstream'), UpstreamContextDictYMap, "imageGenerator.in_upstream")
      case 'in_name': return _readYDocOptionalString(this._raw.get('in_name'), "imageGenerator.in_name")
      case 'in_prompt': return _readYDocOptionalString(this._raw.get('in_prompt'), "imageGenerator.in_prompt")
      case 'in_aspect_ratio': return (this._raw.get('in_aspect_ratio') == null ? undefined : _readYDocJsonValue<AspectRatio>(this._raw.get('in_aspect_ratio'), "imageGenerator.in_aspect_ratio"))
      case 'in_style': return _readYDocOptionalString(this._raw.get('in_style'), "imageGenerator.in_style")
      case 'in_quality': return _readYDocOptionalString(this._raw.get('in_quality'), "imageGenerator.in_quality")
      case 'in_model': return _readYDocOptionalString(this._raw.get('in_model'), "imageGenerator.in_model")
      case 'in_panel_refs': return _readYDocOptionalArray(this._raw.get('in_panel_refs'), "imageGenerator.in_panel_refs", (item, itemLabel) => _readYDocString(item, itemLabel))
      case 'in_update': return _readYDocOptionalBoolean(this._raw.get('in_update'), "imageGenerator.in_update")
      case 'in_image': return _readYDocOptionalMapWrapper(this._raw.get('in_image'), ImageAssetRefDictYMap, "imageGenerator.in_image")
      case 'in_feedback': return _readYDocOptionalString(this._raw.get('in_feedback'), "imageGenerator.in_feedback")
      case 'in_video': return _readYDocOptionalString(this._raw.get('in_video'), "imageGenerator.in_video")
      case 'in_source_video': return _readYDocOptionalMapWrapper(this._raw.get('in_source_video'), GeneratedVideoWithHistoryYMap, "imageGenerator.in_source_video")
      case 'in_expected_video_duration_ms': return _readYDocOptionalNumber(this._raw.get('in_expected_video_duration_ms'), "imageGenerator.in_expected_video_duration_ms")
      case 'in_frame': return _readYDocOptionalString(this._raw.get('in_frame'), "imageGenerator.in_frame")
      case 'in_get_frame': return _readYDocOptionalBoolean(this._raw.get('in_get_frame'), "imageGenerator.in_get_frame")
      case 'in_feedback_history': return _readYDocOptionalArray(this._raw.get('in_feedback_history'), "imageGenerator.in_feedback_history", (item, itemLabel) => _readYDocMapWrapper(item, FeedbackHistoryEntryDictYMap, itemLabel))
      case 'in_vlm_validation': return _readYDocOptionalBoolean(this._raw.get('in_vlm_validation'), "imageGenerator.in_vlm_validation")
      case 'out_image': return _readYDocOptionalMapWrapper(this._raw.get('out_image'), GeneratedImageWithHistoryYMap, "imageGenerator.out_image")
      case 'out_vlm_report': return _readYDocOptionalMapWrapper(this._raw.get('out_vlm_report'), VlmValidationReportDictYMap, "imageGenerator.out_vlm_report")
      case 'batch_pending': return _readYDocOptionalNumber(this._raw.get('batch_pending'), "imageGenerator.batch_pending")
      case 'annotated_image_path': return _readYDocOptionalString(this._raw.get('annotated_image_path'), "imageGenerator.annotated_image_path")
      case 'name_autogen': return _readYDocOptionalString(this._raw.get('name_autogen'), "imageGenerator.name_autogen")
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "in_images" | "in_upstream" | "in_name" | "in_prompt" | "in_aspect_ratio" | "in_style" | "in_quality" | "in_model" | "in_panel_refs" | "in_update" | "in_image" | "in_feedback" | "in_video" | "in_source_video" | "in_expected_video_duration_ms" | "in_frame" | "in_get_frame" | "in_feedback_history" | "in_vlm_validation" | "out_image" | "out_vlm_report" | "batch_pending" | "annotated_image_path" | "name_autogen" | "revision"): void { this._raw.delete(key) }
  has(key: "type" | "in_images" | "in_upstream" | "in_name" | "in_prompt" | "in_aspect_ratio" | "in_style" | "in_quality" | "in_model" | "in_panel_refs" | "in_update" | "in_image" | "in_feedback" | "in_video" | "in_source_video" | "in_expected_video_duration_ms" | "in_frame" | "in_get_frame" | "in_feedback_history" | "in_vlm_validation" | "out_image" | "out_vlm_report" | "batch_pending" | "annotated_image_path" | "name_autogen" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<ImageGeneratorNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this._writeDataField(field as keyof ImageGeneratorNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof ImageGeneratorNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'in_images': return this.writeInImages(value as Exclude<ImageGeneratorNodeWriteData['in_images'], undefined>, opts)
      case 'in_upstream': return this.writeInUpstream(value as Exclude<ImageGeneratorNodeWriteData['in_upstream'], undefined>, opts)
      case 'in_name': return this.writeInName(value as Exclude<ImageGeneratorNodeWriteData['in_name'], undefined>, opts)
      case 'in_prompt': return this.writeInPrompt(value as Exclude<ImageGeneratorNodeWriteData['in_prompt'], undefined>, opts)
      case 'in_aspect_ratio': return this.writeInAspectRatio(value as Exclude<ImageGeneratorNodeWriteData['in_aspect_ratio'], undefined>, opts)
      case 'in_style': return this.writeInStyle(value as Exclude<ImageGeneratorNodeWriteData['in_style'], undefined>, opts)
      case 'in_quality': return this.writeInQuality(value as Exclude<ImageGeneratorNodeWriteData['in_quality'], undefined>, opts)
      case 'in_model': return this.writeInModel(value as Exclude<ImageGeneratorNodeWriteData['in_model'], undefined>, opts)
      case 'in_panel_refs': return this.writeInPanelRefs(value as Exclude<ImageGeneratorNodeWriteData['in_panel_refs'], undefined>, opts)
      case 'in_update': return this.writeInUpdate(value as Exclude<ImageGeneratorNodeWriteData['in_update'], undefined>, opts)
      case 'in_image': return this.writeInImage(value as Exclude<ImageGeneratorNodeWriteData['in_image'], undefined>, opts)
      case 'in_feedback': return this.writeInFeedback(value as Exclude<ImageGeneratorNodeWriteData['in_feedback'], undefined>, opts)
      case 'in_video': return this.writeInVideo(value as Exclude<ImageGeneratorNodeWriteData['in_video'], undefined>, opts)
      case 'in_source_video': return this.writeInSourceVideo(value as Exclude<ImageGeneratorNodeWriteData['in_source_video'], undefined>, opts)
      case 'in_expected_video_duration_ms': return this.writeInExpectedVideoDurationMs(value as Exclude<ImageGeneratorNodeWriteData['in_expected_video_duration_ms'], undefined>, opts)
      case 'in_frame': return this.writeInFrame(value as Exclude<ImageGeneratorNodeWriteData['in_frame'], undefined>, opts)
      case 'in_get_frame': return this.writeInGetFrame(value as Exclude<ImageGeneratorNodeWriteData['in_get_frame'], undefined>, opts)
      case 'in_feedback_history': return this.writeInFeedbackHistory(value as Exclude<ImageGeneratorNodeWriteData['in_feedback_history'], undefined>, opts)
      case 'in_vlm_validation': return this.writeInVlmValidation(value as Exclude<ImageGeneratorNodeWriteData['in_vlm_validation'], undefined>, opts)
      case 'out_image': return this.writeOutImage(value as Exclude<ImageGeneratorNodeWriteData['out_image'], undefined>, opts)
      case 'out_vlm_report': return this.writeOutVlmReport(value as Exclude<ImageGeneratorNodeWriteData['out_vlm_report'], undefined>, opts)
      case 'batch_pending': return this.writeBatchPending(value as Exclude<ImageGeneratorNodeWriteData['batch_pending'], undefined>, opts)
      case 'annotated_image_path': return this.writeAnnotatedImagePath(value as Exclude<ImageGeneratorNodeWriteData['annotated_image_path'], undefined>, opts)
      case 'name_autogen': return this.writeNameAutogen(value as Exclude<ImageGeneratorNodeWriteData['name_autogen'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writeInImages(value: Exclude<ImageGeneratorNodeWriteData['in_images'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_images', 'array', value, opts, false, undefined, undefined)
  }

  writeInUpstream(value: Exclude<ImageGeneratorNodeWriteData['in_upstream'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_upstream', 'map', value, opts, false, undefined, undefined)
  }

  writeInName(value: Exclude<ImageGeneratorNodeWriteData['in_name'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_name', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInPrompt(value: Exclude<ImageGeneratorNodeWriteData['in_prompt'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_prompt', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInAspectRatio(value: Exclude<ImageGeneratorNodeWriteData['in_aspect_ratio'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_aspect_ratio', 'primitive', value, opts, false, undefined, undefined)
  }

  writeInStyle(value: Exclude<ImageGeneratorNodeWriteData['in_style'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_style', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInQuality(value: Exclude<ImageGeneratorNodeWriteData['in_quality'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_quality', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInModel(value: Exclude<ImageGeneratorNodeWriteData['in_model'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_model', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInPanelRefs(value: Exclude<ImageGeneratorNodeWriteData['in_panel_refs'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_panel_refs', 'array', value, opts, false, undefined, undefined)
  }

  writeInUpdate(value: Exclude<ImageGeneratorNodeWriteData['in_update'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_update', 'primitive', value, opts, false, 'boolean', undefined)
  }

  writeInImage(value: Exclude<ImageGeneratorNodeWriteData['in_image'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_image', 'map', value, opts, false, undefined, undefined)
  }

  writeInFeedback(value: Exclude<ImageGeneratorNodeWriteData['in_feedback'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_feedback', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInVideo(value: Exclude<ImageGeneratorNodeWriteData['in_video'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_video', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInSourceVideo(value: Exclude<ImageGeneratorNodeWriteData['in_source_video'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_source_video', 'map', value, opts, false, undefined, _validateYDocGeneratedVideoWithHistory)
  }

  writeInExpectedVideoDurationMs(value: Exclude<ImageGeneratorNodeWriteData['in_expected_video_duration_ms'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_expected_video_duration_ms', 'primitive', value, opts, false, 'number', undefined)
  }

  writeInFrame(value: Exclude<ImageGeneratorNodeWriteData['in_frame'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_frame', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInGetFrame(value: Exclude<ImageGeneratorNodeWriteData['in_get_frame'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_get_frame', 'primitive', value, opts, false, 'boolean', undefined)
  }

  writeInFeedbackHistory(value: Exclude<ImageGeneratorNodeWriteData['in_feedback_history'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_feedback_history', 'array', value, opts, false, undefined, undefined)
  }

  writeInVlmValidation(value: Exclude<ImageGeneratorNodeWriteData['in_vlm_validation'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_vlm_validation', 'primitive', value, opts, false, 'boolean', undefined)
  }

  writeOutImage(value: Exclude<ImageGeneratorNodeWriteData['out_image'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_image', 'map', value, opts, false, undefined, undefined)
  }

  writeOutVlmReport(value: Exclude<ImageGeneratorNodeWriteData['out_vlm_report'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_vlm_report', 'map', value, opts, false, undefined, undefined)
  }

  writeBatchPending(value: Exclude<ImageGeneratorNodeWriteData['batch_pending'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('batch_pending', 'primitive', value, opts, false, 'number', undefined)
  }

  writeAnnotatedImagePath(value: Exclude<ImageGeneratorNodeWriteData['annotated_image_path'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('annotated_image_path', 'primitive', value, opts, false, 'string', undefined)
  }

  writeNameAutogen(value: Exclude<ImageGeneratorNodeWriteData['name_autogen'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('name_autogen', 'primitive', value, opts, false, 'string', undefined)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolveImageGeneratorInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    switch (targetHandle) {
      case 'in_images': {
        const value = _resolveImageGeneratorInImagesInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_images')
        if (hadPersistedValue) this.delete('in_images')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_images', value, written }
      }
      case 'in_upstream': {
        const value = _resolveImageGeneratorInUpstreamInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInUpstream(value as unknown as Exclude<ImageGeneratorNodeWriteData['in_upstream'], undefined>)
        return { field: 'in_upstream', value, written }
      }
      case 'in_name': {
        const value = _resolveImageGeneratorInNameInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInName(value as unknown as Exclude<ImageGeneratorNodeWriteData['in_name'], undefined>)
        return { field: 'in_name', value, written }
      }
      case 'in_prompt': {
        const value = _resolveImageGeneratorInPromptInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInPrompt(value as unknown as Exclude<ImageGeneratorNodeWriteData['in_prompt'], undefined>)
        return { field: 'in_prompt', value, written }
      }
      case 'in_aspect_ratio': {
        const value = _resolveImageGeneratorInAspectRatioInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInAspectRatio(value as unknown as Exclude<ImageGeneratorNodeWriteData['in_aspect_ratio'], undefined>)
        return { field: 'in_aspect_ratio', value, written }
      }
      case 'in_style': {
        const value = _resolveImageGeneratorInStyleInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInStyle(value as unknown as Exclude<ImageGeneratorNodeWriteData['in_style'], undefined>)
        return { field: 'in_style', value, written }
      }
      case 'in_quality': {
        const value = _resolveImageGeneratorInQualityInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInQuality(value as unknown as Exclude<ImageGeneratorNodeWriteData['in_quality'], undefined>)
        return { field: 'in_quality', value, written }
      }
      case 'in_model': {
        const value = _resolveImageGeneratorInModelInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInModel(value as unknown as Exclude<ImageGeneratorNodeWriteData['in_model'], undefined>)
        return { field: 'in_model', value, written }
      }
      case 'in_panel_refs': {
        const value = _resolveImageGeneratorInPanelRefsInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_panel_refs')
        if (hadPersistedValue) this.delete('in_panel_refs')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_panel_refs', value, written }
      }
      case 'in_update': {
        const value = _resolveImageGeneratorInUpdateInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInUpdate(value as unknown as Exclude<ImageGeneratorNodeWriteData['in_update'], undefined>)
        return { field: 'in_update', value, written }
      }
      case 'in_image': {
        const value = _resolveImageGeneratorInImageInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_image')
        if (hadPersistedValue) this.delete('in_image')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_image', value, written }
      }
      case 'in_feedback': {
        const value = _resolveImageGeneratorInFeedbackInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInFeedback(value as unknown as Exclude<ImageGeneratorNodeWriteData['in_feedback'], undefined>)
        return { field: 'in_feedback', value, written }
      }
      case 'in_video': {
        const value = _resolveImageGeneratorInVideoInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInVideo(value as unknown as Exclude<ImageGeneratorNodeWriteData['in_video'], undefined>)
        return { field: 'in_video', value, written }
      }
      case 'in_source_video': {
        const value = _resolveImageGeneratorInSourceVideoInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInSourceVideo(value as unknown as Exclude<ImageGeneratorNodeWriteData['in_source_video'], undefined>)
        return { field: 'in_source_video', value, written }
      }
      case 'in_expected_video_duration_ms': {
        const value = _resolveImageGeneratorInExpectedVideoDurationMsInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInExpectedVideoDurationMs(value as unknown as Exclude<ImageGeneratorNodeWriteData['in_expected_video_duration_ms'], undefined>)
        return { field: 'in_expected_video_duration_ms', value, written }
      }
      case 'in_frame': {
        const value = _resolveImageGeneratorInFrameInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInFrame(value as unknown as Exclude<ImageGeneratorNodeWriteData['in_frame'], undefined>)
        return { field: 'in_frame', value, written }
      }
      case 'in_get_frame': {
        const value = _resolveImageGeneratorInGetFrameInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInGetFrame(value as unknown as Exclude<ImageGeneratorNodeWriteData['in_get_frame'], undefined>)
        return { field: 'in_get_frame', value, written }
      }
      case 'in_feedback_history': {
        const value = _resolveImageGeneratorInFeedbackHistoryInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInFeedbackHistory(value as unknown as Exclude<ImageGeneratorNodeWriteData['in_feedback_history'], undefined>)
        return { field: 'in_feedback_history', value, written }
      }
      case 'in_vlm_validation': {
        const value = _resolveImageGeneratorInVlmValidationInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInVlmValidation(value as unknown as Exclude<ImageGeneratorNodeWriteData['in_vlm_validation'], undefined>)
        return { field: 'in_vlm_validation', value, written }
      }
      default:
        throw new Error(`Unknown input port ${targetHandle} for ImageGeneratorCanvasNode`)
    }
  }
}

export class LocationDesignerCanvasNode extends GeneratedCanvasNode<LocationDesignerNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  protected isDerivedField(key: string): boolean { return key === 'out_name' }
  readDataFields(): Record<string, unknown> {
    const data = super.readDataFields()
    data.out_name = this.get('out_name')
    return data
  }
  get(key: 'type'): "locationDesigner" | undefined
  get(key: 'in_images'): Array<ImageAssetRefDictYMap | null> | undefined
  get(key: 'in_name'): string | undefined
  get(key: 'in_style'): string | undefined
  get(key: 'in_time_of_day'): string | undefined
  get(key: 'in_weather'): string | undefined
  get(key: 'in_description'): string | undefined
  get(key: 'in_model'): string | undefined
  get(key: 'in_feedback'): string | undefined
  get(key: 'in_feedback_history'): Array<FeedbackHistoryEntryDictYMap> | undefined
  get(key: 'in_bg_color'): string | undefined
  get(key: 'in_vlm_validation'): boolean | undefined
  get(key: 'in_720_enabled'): boolean | undefined
  get(key: 'in_720_view'): LocationPanoramaViewDictYMap | undefined
  get(key: 'out_name'): string | undefined
  get(key: 'out_image'): LocationAssetYMap | undefined
  get(key: 'out_metadata'): LocationMetadataDictYMap | undefined
  get(key: 'out_vlm_report'): VlmValidationReportDictYMap | undefined
  get(key: 'batch_pending'): number | undefined
  get(key: 'annotated_image_path'): string | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'in_images': return _readYDocOptionalArray(this._raw.get('in_images'), "locationDesigner.in_images", (item, itemLabel) => item == null ? null : _readYDocMapWrapper(item, ImageAssetRefDictYMap, itemLabel))
      case 'in_name': return _readYDocOptionalString(this._raw.get('in_name'), "locationDesigner.in_name")
      case 'in_style': return _readYDocOptionalString(this._raw.get('in_style'), "locationDesigner.in_style")
      case 'in_time_of_day': return _readYDocOptionalString(this._raw.get('in_time_of_day'), "locationDesigner.in_time_of_day")
      case 'in_weather': return _readYDocOptionalString(this._raw.get('in_weather'), "locationDesigner.in_weather")
      case 'in_description': return _readYDocOptionalString(this._raw.get('in_description'), "locationDesigner.in_description")
      case 'in_model': return _readYDocOptionalString(this._raw.get('in_model'), "locationDesigner.in_model")
      case 'in_feedback': return _readYDocOptionalString(this._raw.get('in_feedback'), "locationDesigner.in_feedback")
      case 'in_feedback_history': return _readYDocOptionalArray(this._raw.get('in_feedback_history'), "locationDesigner.in_feedback_history", (item, itemLabel) => _readYDocMapWrapper(item, FeedbackHistoryEntryDictYMap, itemLabel))
      case 'in_bg_color': return _readYDocOptionalString(this._raw.get('in_bg_color'), "locationDesigner.in_bg_color")
      case 'in_vlm_validation': return _readYDocOptionalBoolean(this._raw.get('in_vlm_validation'), "locationDesigner.in_vlm_validation")
      case 'in_720_enabled': return _readYDocOptionalBoolean(this._raw.get('in_720_enabled'), "locationDesigner.in_720_enabled")
      case 'in_720_view': return _readYDocOptionalMapWrapper(this._raw.get('in_720_view'), LocationPanoramaViewDictYMap, "locationDesigner.in_720_view")
      case 'out_name': return _readYDocOptionalString(this._raw.get('in_name'), "locationDesigner.out_name")
      case 'out_image': return _readYDocOptionalMapWrapper(this._raw.get('out_image'), LocationAssetYMap, "locationDesigner.out_image")
      case 'out_metadata': return _readYDocOptionalMapWrapper(this._raw.get('out_metadata'), LocationMetadataDictYMap, "locationDesigner.out_metadata")
      case 'out_vlm_report': return _readYDocOptionalMapWrapper(this._raw.get('out_vlm_report'), VlmValidationReportDictYMap, "locationDesigner.out_vlm_report")
      case 'batch_pending': return _readYDocOptionalNumber(this._raw.get('batch_pending'), "locationDesigner.batch_pending")
      case 'annotated_image_path': return _readYDocOptionalString(this._raw.get('annotated_image_path'), "locationDesigner.annotated_image_path")
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "in_images" | "in_name" | "in_style" | "in_time_of_day" | "in_weather" | "in_description" | "in_model" | "in_feedback" | "in_feedback_history" | "in_bg_color" | "in_vlm_validation" | "in_720_enabled" | "in_720_view" | "out_name" | "out_image" | "out_metadata" | "out_vlm_report" | "batch_pending" | "annotated_image_path" | "revision"): void { if (this.isDerivedField(key)) throw new Error(`Read-only alias ${key}`); this._raw.delete(key) }
  has(key: "type" | "in_images" | "in_name" | "in_style" | "in_time_of_day" | "in_weather" | "in_description" | "in_model" | "in_feedback" | "in_feedback_history" | "in_bg_color" | "in_vlm_validation" | "in_720_enabled" | "in_720_view" | "out_name" | "out_image" | "out_metadata" | "out_vlm_report" | "batch_pending" | "annotated_image_path" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<LocationDesignerNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this.isDerivedField(field)) throw new Error(`Read-only alias ${field}`)
      if (this._writeDataField(field as keyof LocationDesignerNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof LocationDesignerNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'in_images': return this.writeInImages(value as Exclude<LocationDesignerNodeWriteData['in_images'], undefined>, opts)
      case 'in_name': return this.writeInName(value as Exclude<LocationDesignerNodeWriteData['in_name'], undefined>, opts)
      case 'in_style': return this.writeInStyle(value as Exclude<LocationDesignerNodeWriteData['in_style'], undefined>, opts)
      case 'in_time_of_day': return this.writeInTimeOfDay(value as Exclude<LocationDesignerNodeWriteData['in_time_of_day'], undefined>, opts)
      case 'in_weather': return this.writeInWeather(value as Exclude<LocationDesignerNodeWriteData['in_weather'], undefined>, opts)
      case 'in_description': return this.writeInDescription(value as Exclude<LocationDesignerNodeWriteData['in_description'], undefined>, opts)
      case 'in_model': return this.writeInModel(value as Exclude<LocationDesignerNodeWriteData['in_model'], undefined>, opts)
      case 'in_feedback': return this.writeInFeedback(value as Exclude<LocationDesignerNodeWriteData['in_feedback'], undefined>, opts)
      case 'in_feedback_history': return this.writeInFeedbackHistory(value as Exclude<LocationDesignerNodeWriteData['in_feedback_history'], undefined>, opts)
      case 'in_bg_color': return this.writeInBgColor(value as Exclude<LocationDesignerNodeWriteData['in_bg_color'], undefined>, opts)
      case 'in_vlm_validation': return this.writeInVlmValidation(value as Exclude<LocationDesignerNodeWriteData['in_vlm_validation'], undefined>, opts)
      case 'in_720_enabled': return this.writeIn720Enabled(value as Exclude<LocationDesignerNodeWriteData['in_720_enabled'], undefined>, opts)
      case 'in_720_view': return this.writeIn720View(value as Exclude<LocationDesignerNodeWriteData['in_720_view'], undefined>, opts)
      case 'out_image': return this.writeOutImage(value as Exclude<LocationDesignerNodeWriteData['out_image'], undefined>, opts)
      case 'out_metadata': return this.writeOutMetadata(value as Exclude<LocationDesignerNodeWriteData['out_metadata'], undefined>, opts)
      case 'out_vlm_report': return this.writeOutVlmReport(value as Exclude<LocationDesignerNodeWriteData['out_vlm_report'], undefined>, opts)
      case 'batch_pending': return this.writeBatchPending(value as Exclude<LocationDesignerNodeWriteData['batch_pending'], undefined>, opts)
      case 'annotated_image_path': return this.writeAnnotatedImagePath(value as Exclude<LocationDesignerNodeWriteData['annotated_image_path'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writeInImages(value: Exclude<LocationDesignerNodeWriteData['in_images'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_images', 'array', value, opts, false, undefined, undefined)
  }

  writeInName(value: Exclude<LocationDesignerNodeWriteData['in_name'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_name', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInStyle(value: Exclude<LocationDesignerNodeWriteData['in_style'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_style', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInTimeOfDay(value: Exclude<LocationDesignerNodeWriteData['in_time_of_day'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_time_of_day', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInWeather(value: Exclude<LocationDesignerNodeWriteData['in_weather'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_weather', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInDescription(value: Exclude<LocationDesignerNodeWriteData['in_description'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_description', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInModel(value: Exclude<LocationDesignerNodeWriteData['in_model'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_model', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInFeedback(value: Exclude<LocationDesignerNodeWriteData['in_feedback'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_feedback', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInFeedbackHistory(value: Exclude<LocationDesignerNodeWriteData['in_feedback_history'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_feedback_history', 'array', value, opts, false, undefined, undefined)
  }

  writeInBgColor(value: Exclude<LocationDesignerNodeWriteData['in_bg_color'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_bg_color', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInVlmValidation(value: Exclude<LocationDesignerNodeWriteData['in_vlm_validation'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_vlm_validation', 'primitive', value, opts, false, 'boolean', undefined)
  }

  writeIn720Enabled(value: Exclude<LocationDesignerNodeWriteData['in_720_enabled'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_720_enabled', 'primitive', value, opts, false, 'boolean', undefined)
  }

  writeIn720View(value: Exclude<LocationDesignerNodeWriteData['in_720_view'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_720_view', 'map', value, opts, false, undefined, undefined)
  }

  writeOutImage(value: Exclude<LocationDesignerNodeWriteData['out_image'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_image', 'map', value, opts, true, undefined, undefined)
  }

  writeOutMetadata(value: Exclude<LocationDesignerNodeWriteData['out_metadata'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_metadata', 'map', value, opts, false, undefined, undefined)
  }

  writeOutVlmReport(value: Exclude<LocationDesignerNodeWriteData['out_vlm_report'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_vlm_report', 'map', value, opts, false, undefined, undefined)
  }

  writeBatchPending(value: Exclude<LocationDesignerNodeWriteData['batch_pending'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('batch_pending', 'primitive', value, opts, false, 'number', undefined)
  }

  writeAnnotatedImagePath(value: Exclude<LocationDesignerNodeWriteData['annotated_image_path'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('annotated_image_path', 'primitive', value, opts, false, 'string', undefined)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolveLocationDesignerInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    switch (targetHandle) {
      case 'in_images': {
        const value = _resolveLocationDesignerInImagesInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_images')
        if (hadPersistedValue) this.delete('in_images')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_images', value, written }
      }
      case 'in_name': {
        const value = _resolveLocationDesignerInNameInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInName(value as unknown as Exclude<LocationDesignerNodeWriteData['in_name'], undefined>)
        return { field: 'in_name', value, written }
      }
      case 'in_style': {
        const value = _resolveLocationDesignerInStyleInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInStyle(value as unknown as Exclude<LocationDesignerNodeWriteData['in_style'], undefined>)
        return { field: 'in_style', value, written }
      }
      case 'in_time_of_day': {
        const value = _resolveLocationDesignerInTimeOfDayInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInTimeOfDay(value as unknown as Exclude<LocationDesignerNodeWriteData['in_time_of_day'], undefined>)
        return { field: 'in_time_of_day', value, written }
      }
      case 'in_weather': {
        const value = _resolveLocationDesignerInWeatherInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInWeather(value as unknown as Exclude<LocationDesignerNodeWriteData['in_weather'], undefined>)
        return { field: 'in_weather', value, written }
      }
      case 'in_description': {
        const value = _resolveLocationDesignerInDescriptionInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInDescription(value as unknown as Exclude<LocationDesignerNodeWriteData['in_description'], undefined>)
        return { field: 'in_description', value, written }
      }
      case 'in_model': {
        const value = _resolveLocationDesignerInModelInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInModel(value as unknown as Exclude<LocationDesignerNodeWriteData['in_model'], undefined>)
        return { field: 'in_model', value, written }
      }
      case 'in_feedback': {
        const value = _resolveLocationDesignerInFeedbackInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInFeedback(value as unknown as Exclude<LocationDesignerNodeWriteData['in_feedback'], undefined>)
        return { field: 'in_feedback', value, written }
      }
      case 'in_feedback_history': {
        const value = _resolveLocationDesignerInFeedbackHistoryInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInFeedbackHistory(value as unknown as Exclude<LocationDesignerNodeWriteData['in_feedback_history'], undefined>)
        return { field: 'in_feedback_history', value, written }
      }
      case 'in_bg_color': {
        const value = _resolveLocationDesignerInBgColorInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInBgColor(value as unknown as Exclude<LocationDesignerNodeWriteData['in_bg_color'], undefined>)
        return { field: 'in_bg_color', value, written }
      }
      case 'in_vlm_validation': {
        const value = _resolveLocationDesignerInVlmValidationInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInVlmValidation(value as unknown as Exclude<LocationDesignerNodeWriteData['in_vlm_validation'], undefined>)
        return { field: 'in_vlm_validation', value, written }
      }
      case 'in_720_enabled': {
        const value = _resolveLocationDesignerIn720EnabledInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeIn720Enabled(value as unknown as Exclude<LocationDesignerNodeWriteData['in_720_enabled'], undefined>)
        return { field: 'in_720_enabled', value, written }
      }
      case 'in_720_view': {
        const value = _resolveLocationDesignerIn720ViewInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeIn720View(value as unknown as Exclude<LocationDesignerNodeWriteData['in_720_view'], undefined>)
        return { field: 'in_720_view', value, written }
      }
      default:
        throw new Error(`Unknown input port ${targetHandle} for LocationDesignerCanvasNode`)
    }
  }
}

export class NodeGroupCanvasNode extends GeneratedCanvasNode<NodeGroupNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  get(key: 'type'): "nodeGroup" | undefined
  get(key: 'in_label'): string | undefined
  get(key: 'in_child_node_ids'): Array<string | null> | undefined
  get(key: 'in_layout_mode'): string | undefined
  get(key: 'in_collapsed'): boolean | undefined
  get(key: 'in_collapsible'): boolean | undefined
  get(key: 'in_bg_color'): string | undefined
  get(key: 'name_autogen'): string | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'in_label': return _readYDocOptionalString(this._raw.get('in_label'), "nodeGroup.in_label")
      case 'in_child_node_ids': return _readYDocOptionalArray(this._raw.get('in_child_node_ids'), "nodeGroup.in_child_node_ids", (item, itemLabel) => item == null ? null : _readYDocString(item, itemLabel))
      case 'in_layout_mode': return _readYDocOptionalString(this._raw.get('in_layout_mode'), "nodeGroup.in_layout_mode")
      case 'in_collapsed': return _readYDocOptionalBoolean(this._raw.get('in_collapsed'), "nodeGroup.in_collapsed")
      case 'in_collapsible': return _readYDocOptionalBoolean(this._raw.get('in_collapsible'), "nodeGroup.in_collapsible")
      case 'in_bg_color': return _readYDocOptionalString(this._raw.get('in_bg_color'), "nodeGroup.in_bg_color")
      case 'name_autogen': return _readYDocOptionalString(this._raw.get('name_autogen'), "nodeGroup.name_autogen")
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "in_label" | "in_child_node_ids" | "in_layout_mode" | "in_collapsed" | "in_collapsible" | "in_bg_color" | "name_autogen" | "revision"): void { this._raw.delete(key) }
  has(key: "type" | "in_label" | "in_child_node_ids" | "in_layout_mode" | "in_collapsed" | "in_collapsible" | "in_bg_color" | "name_autogen" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<NodeGroupNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this._writeDataField(field as keyof NodeGroupNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof NodeGroupNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'in_label': return this.writeInLabel(value as Exclude<NodeGroupNodeWriteData['in_label'], undefined>, opts)
      case 'in_child_node_ids': return this.writeInChildNodeIds(value as Exclude<NodeGroupNodeWriteData['in_child_node_ids'], undefined>, opts)
      case 'in_layout_mode': return this.writeInLayoutMode(value as Exclude<NodeGroupNodeWriteData['in_layout_mode'], undefined>, opts)
      case 'in_collapsed': return this.writeInCollapsed(value as Exclude<NodeGroupNodeWriteData['in_collapsed'], undefined>, opts)
      case 'in_collapsible': return this.writeInCollapsible(value as Exclude<NodeGroupNodeWriteData['in_collapsible'], undefined>, opts)
      case 'in_bg_color': return this.writeInBgColor(value as Exclude<NodeGroupNodeWriteData['in_bg_color'], undefined>, opts)
      case 'name_autogen': return this.writeNameAutogen(value as Exclude<NodeGroupNodeWriteData['name_autogen'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writeInLabel(value: Exclude<NodeGroupNodeWriteData['in_label'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_label', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInChildNodeIds(value: Exclude<NodeGroupNodeWriteData['in_child_node_ids'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_child_node_ids', 'array', value, opts, false, undefined, undefined)
  }

  writeInLayoutMode(value: Exclude<NodeGroupNodeWriteData['in_layout_mode'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_layout_mode', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInCollapsed(value: Exclude<NodeGroupNodeWriteData['in_collapsed'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_collapsed', 'primitive', value, opts, false, 'boolean', undefined)
  }

  writeInCollapsible(value: Exclude<NodeGroupNodeWriteData['in_collapsible'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_collapsible', 'primitive', value, opts, false, 'boolean', undefined)
  }

  writeInBgColor(value: Exclude<NodeGroupNodeWriteData['in_bg_color'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_bg_color', 'primitive', value, opts, false, 'string', undefined)
  }

  writeNameAutogen(value: Exclude<NodeGroupNodeWriteData['name_autogen'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('name_autogen', 'primitive', value, opts, false, 'string', undefined)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolveNodeGroupInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    switch (targetHandle) {
      case 'in_label': {
        const value = _resolveNodeGroupInLabelInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInLabel(value as unknown as Exclude<NodeGroupNodeWriteData['in_label'], undefined>)
        return { field: 'in_label', value, written }
      }
      case 'in_child_node_ids': {
        const value = _resolveNodeGroupInChildNodeIdsInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInChildNodeIds(value as unknown as Exclude<NodeGroupNodeWriteData['in_child_node_ids'], undefined>)
        return { field: 'in_child_node_ids', value, written }
      }
      case 'in_layout_mode': {
        const value = _resolveNodeGroupInLayoutModeInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInLayoutMode(value as unknown as Exclude<NodeGroupNodeWriteData['in_layout_mode'], undefined>)
        return { field: 'in_layout_mode', value, written }
      }
      case 'in_collapsed': {
        const value = _resolveNodeGroupInCollapsedInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInCollapsed(value as unknown as Exclude<NodeGroupNodeWriteData['in_collapsed'], undefined>)
        return { field: 'in_collapsed', value, written }
      }
      case 'in_collapsible': {
        const value = _resolveNodeGroupInCollapsibleInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInCollapsible(value as unknown as Exclude<NodeGroupNodeWriteData['in_collapsible'], undefined>)
        return { field: 'in_collapsible', value, written }
      }
      case 'in_bg_color': {
        const value = _resolveNodeGroupInBgColorInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInBgColor(value as unknown as Exclude<NodeGroupNodeWriteData['in_bg_color'], undefined>)
        return { field: 'in_bg_color', value, written }
      }
      default:
        throw new Error(`Unknown input port ${targetHandle} for NodeGroupCanvasNode`)
    }
  }
}

export class ObjectDesignerCanvasNode extends GeneratedCanvasNode<ObjectDesignerNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  protected isDerivedField(key: string): boolean { return key === 'out_name' }
  readDataFields(): Record<string, unknown> {
    const data = super.readDataFields()
    data.out_name = this.get('out_name')
    return data
  }
  get(key: 'type'): "objectDesigner" | undefined
  get(key: 'in_images'): Array<ImageAssetRefDictYMap | null> | undefined
  get(key: 'in_name'): string | undefined
  get(key: 'in_style'): string | undefined
  get(key: 'in_description'): string | undefined
  get(key: 'in_model'): string | undefined
  get(key: 'in_feedback'): string | undefined
  get(key: 'in_feedback_history'): Array<FeedbackHistoryEntryDictYMap> | undefined
  get(key: 'in_vlm_validation'): boolean | undefined
  get(key: 'out_name'): string | undefined
  get(key: 'out_image'): ObjectAssetYMap | undefined
  get(key: 'out_metadata'): ObjectMetadataDictYMap | undefined
  get(key: 'out_vlm_report'): VlmValidationReportDictYMap | undefined
  get(key: 'batch_pending'): number | undefined
  get(key: 'annotated_image_path'): string | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'in_images': return _readYDocOptionalArray(this._raw.get('in_images'), "objectDesigner.in_images", (item, itemLabel) => item == null ? null : _readYDocMapWrapper(item, ImageAssetRefDictYMap, itemLabel))
      case 'in_name': return _readYDocOptionalString(this._raw.get('in_name'), "objectDesigner.in_name")
      case 'in_style': return _readYDocOptionalString(this._raw.get('in_style'), "objectDesigner.in_style")
      case 'in_description': return _readYDocOptionalString(this._raw.get('in_description'), "objectDesigner.in_description")
      case 'in_model': return _readYDocOptionalString(this._raw.get('in_model'), "objectDesigner.in_model")
      case 'in_feedback': return _readYDocOptionalString(this._raw.get('in_feedback'), "objectDesigner.in_feedback")
      case 'in_feedback_history': return _readYDocOptionalArray(this._raw.get('in_feedback_history'), "objectDesigner.in_feedback_history", (item, itemLabel) => _readYDocMapWrapper(item, FeedbackHistoryEntryDictYMap, itemLabel))
      case 'in_vlm_validation': return _readYDocOptionalBoolean(this._raw.get('in_vlm_validation'), "objectDesigner.in_vlm_validation")
      case 'out_name': return _readYDocOptionalString(this._raw.get('in_name'), "objectDesigner.out_name")
      case 'out_image': return _readYDocOptionalMapWrapper(this._raw.get('out_image'), ObjectAssetYMap, "objectDesigner.out_image")
      case 'out_metadata': return _readYDocOptionalMapWrapper(this._raw.get('out_metadata'), ObjectMetadataDictYMap, "objectDesigner.out_metadata")
      case 'out_vlm_report': return _readYDocOptionalMapWrapper(this._raw.get('out_vlm_report'), VlmValidationReportDictYMap, "objectDesigner.out_vlm_report")
      case 'batch_pending': return _readYDocOptionalNumber(this._raw.get('batch_pending'), "objectDesigner.batch_pending")
      case 'annotated_image_path': return _readYDocOptionalString(this._raw.get('annotated_image_path'), "objectDesigner.annotated_image_path")
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "in_images" | "in_name" | "in_style" | "in_description" | "in_model" | "in_feedback" | "in_feedback_history" | "in_vlm_validation" | "out_name" | "out_image" | "out_metadata" | "out_vlm_report" | "batch_pending" | "annotated_image_path" | "revision"): void { if (this.isDerivedField(key)) throw new Error(`Read-only alias ${key}`); this._raw.delete(key) }
  has(key: "type" | "in_images" | "in_name" | "in_style" | "in_description" | "in_model" | "in_feedback" | "in_feedback_history" | "in_vlm_validation" | "out_name" | "out_image" | "out_metadata" | "out_vlm_report" | "batch_pending" | "annotated_image_path" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<ObjectDesignerNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this.isDerivedField(field)) throw new Error(`Read-only alias ${field}`)
      if (this._writeDataField(field as keyof ObjectDesignerNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof ObjectDesignerNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'in_images': return this.writeInImages(value as Exclude<ObjectDesignerNodeWriteData['in_images'], undefined>, opts)
      case 'in_name': return this.writeInName(value as Exclude<ObjectDesignerNodeWriteData['in_name'], undefined>, opts)
      case 'in_style': return this.writeInStyle(value as Exclude<ObjectDesignerNodeWriteData['in_style'], undefined>, opts)
      case 'in_description': return this.writeInDescription(value as Exclude<ObjectDesignerNodeWriteData['in_description'], undefined>, opts)
      case 'in_model': return this.writeInModel(value as Exclude<ObjectDesignerNodeWriteData['in_model'], undefined>, opts)
      case 'in_feedback': return this.writeInFeedback(value as Exclude<ObjectDesignerNodeWriteData['in_feedback'], undefined>, opts)
      case 'in_feedback_history': return this.writeInFeedbackHistory(value as Exclude<ObjectDesignerNodeWriteData['in_feedback_history'], undefined>, opts)
      case 'in_vlm_validation': return this.writeInVlmValidation(value as Exclude<ObjectDesignerNodeWriteData['in_vlm_validation'], undefined>, opts)
      case 'out_image': return this.writeOutImage(value as Exclude<ObjectDesignerNodeWriteData['out_image'], undefined>, opts)
      case 'out_metadata': return this.writeOutMetadata(value as Exclude<ObjectDesignerNodeWriteData['out_metadata'], undefined>, opts)
      case 'out_vlm_report': return this.writeOutVlmReport(value as Exclude<ObjectDesignerNodeWriteData['out_vlm_report'], undefined>, opts)
      case 'batch_pending': return this.writeBatchPending(value as Exclude<ObjectDesignerNodeWriteData['batch_pending'], undefined>, opts)
      case 'annotated_image_path': return this.writeAnnotatedImagePath(value as Exclude<ObjectDesignerNodeWriteData['annotated_image_path'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writeInImages(value: Exclude<ObjectDesignerNodeWriteData['in_images'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_images', 'array', value, opts, false, undefined, undefined)
  }

  writeInName(value: Exclude<ObjectDesignerNodeWriteData['in_name'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_name', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInStyle(value: Exclude<ObjectDesignerNodeWriteData['in_style'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_style', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInDescription(value: Exclude<ObjectDesignerNodeWriteData['in_description'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_description', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInModel(value: Exclude<ObjectDesignerNodeWriteData['in_model'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_model', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInFeedback(value: Exclude<ObjectDesignerNodeWriteData['in_feedback'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_feedback', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInFeedbackHistory(value: Exclude<ObjectDesignerNodeWriteData['in_feedback_history'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_feedback_history', 'array', value, opts, false, undefined, undefined)
  }

  writeInVlmValidation(value: Exclude<ObjectDesignerNodeWriteData['in_vlm_validation'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_vlm_validation', 'primitive', value, opts, false, 'boolean', undefined)
  }

  writeOutImage(value: Exclude<ObjectDesignerNodeWriteData['out_image'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_image', 'map', value, opts, true, undefined, undefined)
  }

  writeOutMetadata(value: Exclude<ObjectDesignerNodeWriteData['out_metadata'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_metadata', 'map', value, opts, false, undefined, undefined)
  }

  writeOutVlmReport(value: Exclude<ObjectDesignerNodeWriteData['out_vlm_report'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_vlm_report', 'map', value, opts, false, undefined, undefined)
  }

  writeBatchPending(value: Exclude<ObjectDesignerNodeWriteData['batch_pending'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('batch_pending', 'primitive', value, opts, false, 'number', undefined)
  }

  writeAnnotatedImagePath(value: Exclude<ObjectDesignerNodeWriteData['annotated_image_path'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('annotated_image_path', 'primitive', value, opts, false, 'string', undefined)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolveObjectDesignerInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    switch (targetHandle) {
      case 'in_images': {
        const value = _resolveObjectDesignerInImagesInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_images')
        if (hadPersistedValue) this.delete('in_images')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_images', value, written }
      }
      case 'in_name': {
        const value = _resolveObjectDesignerInNameInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInName(value as unknown as Exclude<ObjectDesignerNodeWriteData['in_name'], undefined>)
        return { field: 'in_name', value, written }
      }
      case 'in_style': {
        const value = _resolveObjectDesignerInStyleInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInStyle(value as unknown as Exclude<ObjectDesignerNodeWriteData['in_style'], undefined>)
        return { field: 'in_style', value, written }
      }
      case 'in_description': {
        const value = _resolveObjectDesignerInDescriptionInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInDescription(value as unknown as Exclude<ObjectDesignerNodeWriteData['in_description'], undefined>)
        return { field: 'in_description', value, written }
      }
      case 'in_model': {
        const value = _resolveObjectDesignerInModelInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInModel(value as unknown as Exclude<ObjectDesignerNodeWriteData['in_model'], undefined>)
        return { field: 'in_model', value, written }
      }
      case 'in_feedback': {
        const value = _resolveObjectDesignerInFeedbackInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInFeedback(value as unknown as Exclude<ObjectDesignerNodeWriteData['in_feedback'], undefined>)
        return { field: 'in_feedback', value, written }
      }
      case 'in_feedback_history': {
        const value = _resolveObjectDesignerInFeedbackHistoryInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInFeedbackHistory(value as unknown as Exclude<ObjectDesignerNodeWriteData['in_feedback_history'], undefined>)
        return { field: 'in_feedback_history', value, written }
      }
      case 'in_vlm_validation': {
        const value = _resolveObjectDesignerInVlmValidationInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInVlmValidation(value as unknown as Exclude<ObjectDesignerNodeWriteData['in_vlm_validation'], undefined>)
        return { field: 'in_vlm_validation', value, written }
      }
      default:
        throw new Error(`Unknown input port ${targetHandle} for ObjectDesignerCanvasNode`)
    }
  }
}

export class PanelSourceCanvasNode extends GeneratedCanvasNode<PanelSourceNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  get(key: 'type'): "panelSource" | undefined
  get(key: 'out_image'): ImageAssetRefDictYMap | undefined
  get(key: 'out_action'): string | undefined
  get(key: 'out_character_ids'): Array<string> | undefined
  get(key: 'out_appearances'): Array<AppearanceDictYMap> | undefined
  get(key: 'out_dialogue'): Array<PanelDialogueDictYMap> | undefined
  get(key: 'out_script'): string | undefined
  get(key: 'out_composition'): CompositionDictYMap | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'out_image': return _readYDocOptionalMapWrapper(this._raw.get('out_image'), ImageAssetRefDictYMap, "panelSource.out_image")
      case 'out_action': return _readYDocOptionalString(this._raw.get('out_action'), "panelSource.out_action")
      case 'out_character_ids': return _readYDocOptionalArray(this._raw.get('out_character_ids'), "panelSource.out_character_ids", (item, itemLabel) => _readYDocString(item, itemLabel))
      case 'out_appearances': return _readYDocOptionalArray(this._raw.get('out_appearances'), "panelSource.out_appearances", (item, itemLabel) => _readYDocMapWrapper(item, AppearanceDictYMap, itemLabel))
      case 'out_dialogue': return _readYDocOptionalArray(this._raw.get('out_dialogue'), "panelSource.out_dialogue", (item, itemLabel) => _readYDocMapWrapper(item, PanelDialogueDictYMap, itemLabel))
      case 'out_script': return _readYDocOptionalString(this._raw.get('out_script'), "panelSource.out_script")
      case 'out_composition': return _readYDocOptionalMapWrapper(this._raw.get('out_composition'), CompositionDictYMap, "panelSource.out_composition")
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "out_image" | "out_action" | "out_character_ids" | "out_appearances" | "out_dialogue" | "out_script" | "out_composition" | "revision"): void { this._raw.delete(key) }
  has(key: "type" | "out_image" | "out_action" | "out_character_ids" | "out_appearances" | "out_dialogue" | "out_script" | "out_composition" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<PanelSourceNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this._writeDataField(field as keyof PanelSourceNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof PanelSourceNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'out_image': return this.writeOutImage(value as Exclude<PanelSourceNodeWriteData['out_image'], undefined>, opts)
      case 'out_action': return this.writeOutAction(value as Exclude<PanelSourceNodeWriteData['out_action'], undefined>, opts)
      case 'out_character_ids': return this.writeOutCharacterIds(value as Exclude<PanelSourceNodeWriteData['out_character_ids'], undefined>, opts)
      case 'out_appearances': return this.writeOutAppearances(value as Exclude<PanelSourceNodeWriteData['out_appearances'], undefined>, opts)
      case 'out_dialogue': return this.writeOutDialogue(value as Exclude<PanelSourceNodeWriteData['out_dialogue'], undefined>, opts)
      case 'out_script': return this.writeOutScript(value as Exclude<PanelSourceNodeWriteData['out_script'], undefined>, opts)
      case 'out_composition': return this.writeOutComposition(value as Exclude<PanelSourceNodeWriteData['out_composition'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writeOutImage(value: Exclude<PanelSourceNodeWriteData['out_image'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_image', 'map', value, opts, false, undefined, undefined)
  }

  writeOutAction(value: Exclude<PanelSourceNodeWriteData['out_action'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_action', 'primitive', value, opts, false, 'string', undefined)
  }

  writeOutCharacterIds(value: Exclude<PanelSourceNodeWriteData['out_character_ids'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_character_ids', 'array', value, opts, false, undefined, undefined)
  }

  writeOutAppearances(value: Exclude<PanelSourceNodeWriteData['out_appearances'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_appearances', 'array', value, opts, false, undefined, undefined)
  }

  writeOutDialogue(value: Exclude<PanelSourceNodeWriteData['out_dialogue'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_dialogue', 'array', value, opts, false, undefined, undefined)
  }

  writeOutScript(value: Exclude<PanelSourceNodeWriteData['out_script'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_script', 'primitive', value, opts, false, 'string', undefined)
  }

  writeOutComposition(value: Exclude<PanelSourceNodeWriteData['out_composition'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_composition', 'map', value, opts, false, undefined, undefined)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolvePanelSourceInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    void nodes
    void edgeRefs
    switch (targetHandle) {
      default:
        throw new Error(`Unknown input port ${targetHandle} for PanelSourceCanvasNode`)
    }
  }
}

export class PromptInputCanvasNode extends GeneratedCanvasNode<PromptInputNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  get(key: 'type'): "promptInput" | undefined
  get(key: 'out_prompt'): string | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'out_prompt': return _readYDocOptionalString(this._raw.get('out_prompt'), "promptInput.out_prompt")
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "out_prompt" | "revision"): void { this._raw.delete(key) }
  has(key: "type" | "out_prompt" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<PromptInputNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this._writeDataField(field as keyof PromptInputNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof PromptInputNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'out_prompt': return this.writeOutPrompt(value as Exclude<PromptInputNodeWriteData['out_prompt'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writeOutPrompt(value: Exclude<PromptInputNodeWriteData['out_prompt'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_prompt', 'primitive', value, opts, false, 'string', undefined)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolvePromptInputInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    void nodes
    void edgeRefs
    switch (targetHandle) {
      default:
        throw new Error(`Unknown input port ${targetHandle} for PromptInputCanvasNode`)
    }
  }
}

export class ScriptWriterCanvasNode extends GeneratedCanvasNode<ScriptWriterNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  get(key: 'type'): "scriptWriter" | undefined
  get(key: 'in_prompt'): string | undefined
  get(key: 'in_active_model'): string | undefined
  get(key: 'in_active_variant_id'): string | undefined
  get(key: 'in_name'): string | undefined
  get(key: 'in_director_instruction'): string | undefined
  get(key: 'in_format_only'): boolean | undefined
  get(key: 'in_gemini'): boolean | undefined
  get(key: 'in_claude'): boolean | undefined
  get(key: 'in_gpt'): boolean | undefined
  get(key: 'in_characters'): Array<string | null> | undefined
  get(key: 'in_feedback'): string | undefined
  get(key: 'in_target_duration_s'): number | undefined
  get(key: 'in_review_history'): Array<ReviewHistoryEntryDictYMap> | undefined
  get(key: 'in_feedback_history'): Array<FeedbackHistoryEntryDictYMap> | undefined
  get(key: 'in_bg_color'): string | undefined
  get(key: 'out_script'): string | undefined
  get(key: 'out_script_path'): string | undefined
  get(key: 'out_screenplay'): Array<ScriptScreenplaySceneDictYMap> | undefined
  get(key: 'out_dialogue'): Array<ScriptDialogueDictYMap> | undefined
  get(key: 'out_voice_roles'): Array<VoiceRoleDictYMap> | undefined
  get(key: 'out_voice_profiles'): Array<VoiceProfileDictYMap> | undefined
  get(key: 'out_action_lines'): Array<SceneTextDictYMap> | undefined
  get(key: 'out_characters'): Array<string> | undefined
  get(key: 'out_music_cues'): Array<SceneTextDictYMap> | undefined
  get(key: 'out_sfx'): Array<SceneTextDictYMap> | undefined
  get(key: 'out_gemini'): ScreenplayResultDictYMap | undefined
  get(key: 'out_claude'): ScreenplayResultDictYMap | undefined
  get(key: 'out_gpt'): ScreenplayResultDictYMap | undefined
  get(key: 'out_locations'): Array<string> | undefined
  get(key: 'out_active_model'): string | undefined
  get(key: 'out_scene_count'): number | undefined
  get(key: 'out_logline'): string | undefined
  get(key: 'out_genre_tone'): string | undefined
  get(key: 'out_synopsis'): string | undefined
  get(key: 'out_themes'): string | undefined
  get(key: 'out_script_variants'): Array<ScriptVariantDictYMap> | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'in_prompt': return _readYDocOptionalString(this._raw.get('in_prompt'), "scriptWriter.in_prompt")
      case 'in_active_model': return _readYDocOptionalString(this._raw.get('in_active_model'), "scriptWriter.in_active_model")
      case 'in_active_variant_id': return _readYDocOptionalString(this._raw.get('in_active_variant_id'), "scriptWriter.in_active_variant_id")
      case 'in_name': return _readYDocOptionalString(this._raw.get('in_name'), "scriptWriter.in_name")
      case 'in_director_instruction': return _readYDocOptionalString(this._raw.get('in_director_instruction'), "scriptWriter.in_director_instruction")
      case 'in_format_only': return _readYDocOptionalBoolean(this._raw.get('in_format_only'), "scriptWriter.in_format_only")
      case 'in_gemini': return _readYDocOptionalBoolean(this._raw.get('in_gemini'), "scriptWriter.in_gemini")
      case 'in_claude': return _readYDocOptionalBoolean(this._raw.get('in_claude'), "scriptWriter.in_claude")
      case 'in_gpt': return _readYDocOptionalBoolean(this._raw.get('in_gpt'), "scriptWriter.in_gpt")
      case 'in_characters': return _readYDocOptionalArray(this._raw.get('in_characters'), "scriptWriter.in_characters", (item, itemLabel) => item == null ? null : _readYDocString(item, itemLabel))
      case 'in_feedback': return _readYDocOptionalString(this._raw.get('in_feedback'), "scriptWriter.in_feedback")
      case 'in_target_duration_s': return _readYDocOptionalNumber(this._raw.get('in_target_duration_s'), "scriptWriter.in_target_duration_s")
      case 'in_review_history': return _readYDocOptionalArray(this._raw.get('in_review_history'), "scriptWriter.in_review_history", (item, itemLabel) => _readYDocMapWrapper(item, ReviewHistoryEntryDictYMap, itemLabel))
      case 'in_feedback_history': return _readYDocOptionalArray(this._raw.get('in_feedback_history'), "scriptWriter.in_feedback_history", (item, itemLabel) => _readYDocMapWrapper(item, FeedbackHistoryEntryDictYMap, itemLabel))
      case 'in_bg_color': return _readYDocOptionalString(this._raw.get('in_bg_color'), "scriptWriter.in_bg_color")
      case 'out_script': return _readYDocOptionalString(this._raw.get('out_script'), "scriptWriter.out_script")
      case 'out_script_path': return _readYDocOptionalString(this._raw.get('out_script_path'), "scriptWriter.out_script_path")
      case 'out_screenplay': return _readYDocOptionalArray(this._raw.get('out_screenplay'), "scriptWriter.out_screenplay", (item, itemLabel) => _readYDocMapWrapper(item, ScriptScreenplaySceneDictYMap, itemLabel))
      case 'out_dialogue': return _readYDocOptionalArray(this._raw.get('out_dialogue'), "scriptWriter.out_dialogue", (item, itemLabel) => _readYDocMapWrapper(item, ScriptDialogueDictYMap, itemLabel))
      case 'out_voice_roles': return _readYDocOptionalArray(this._raw.get('out_voice_roles'), "scriptWriter.out_voice_roles", (item, itemLabel) => _readYDocMapWrapper(item, VoiceRoleDictYMap, itemLabel))
      case 'out_voice_profiles': return _readYDocOptionalArray(this._raw.get('out_voice_profiles'), "scriptWriter.out_voice_profiles", (item, itemLabel) => _readYDocMapWrapper(item, VoiceProfileDictYMap, itemLabel))
      case 'out_action_lines': return _readYDocOptionalArray(this._raw.get('out_action_lines'), "scriptWriter.out_action_lines", (item, itemLabel) => _readYDocMapWrapper(item, SceneTextDictYMap, itemLabel))
      case 'out_characters': return _readYDocOptionalArray(this._raw.get('out_characters'), "scriptWriter.out_characters", (item, itemLabel) => _readYDocString(item, itemLabel))
      case 'out_music_cues': return _readYDocOptionalArray(this._raw.get('out_music_cues'), "scriptWriter.out_music_cues", (item, itemLabel) => _readYDocMapWrapper(item, SceneTextDictYMap, itemLabel))
      case 'out_sfx': return _readYDocOptionalArray(this._raw.get('out_sfx'), "scriptWriter.out_sfx", (item, itemLabel) => _readYDocMapWrapper(item, SceneTextDictYMap, itemLabel))
      case 'out_gemini': return _readYDocOptionalMapWrapper(this._raw.get('out_gemini'), ScreenplayResultDictYMap, "scriptWriter.out_gemini")
      case 'out_claude': return _readYDocOptionalMapWrapper(this._raw.get('out_claude'), ScreenplayResultDictYMap, "scriptWriter.out_claude")
      case 'out_gpt': return _readYDocOptionalMapWrapper(this._raw.get('out_gpt'), ScreenplayResultDictYMap, "scriptWriter.out_gpt")
      case 'out_locations': return _readYDocOptionalArray(this._raw.get('out_locations'), "scriptWriter.out_locations", (item, itemLabel) => _readYDocString(item, itemLabel))
      case 'out_active_model': return _readYDocOptionalString(this._raw.get('out_active_model'), "scriptWriter.out_active_model")
      case 'out_scene_count': return _readYDocOptionalNumber(this._raw.get('out_scene_count'), "scriptWriter.out_scene_count")
      case 'out_logline': return _readYDocOptionalString(this._raw.get('out_logline'), "scriptWriter.out_logline")
      case 'out_genre_tone': return _readYDocOptionalString(this._raw.get('out_genre_tone'), "scriptWriter.out_genre_tone")
      case 'out_synopsis': return _readYDocOptionalString(this._raw.get('out_synopsis'), "scriptWriter.out_synopsis")
      case 'out_themes': return _readYDocOptionalString(this._raw.get('out_themes'), "scriptWriter.out_themes")
      case 'out_script_variants': return _readYDocOptionalArray(this._raw.get('out_script_variants'), "scriptWriter.out_script_variants", (item, itemLabel) => _readYDocMapWrapper(item, ScriptVariantDictYMap, itemLabel))
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "in_prompt" | "in_active_model" | "in_active_variant_id" | "in_name" | "in_director_instruction" | "in_format_only" | "in_gemini" | "in_claude" | "in_gpt" | "in_characters" | "in_feedback" | "in_target_duration_s" | "in_review_history" | "in_feedback_history" | "in_bg_color" | "out_script" | "out_script_path" | "out_screenplay" | "out_dialogue" | "out_voice_roles" | "out_voice_profiles" | "out_action_lines" | "out_characters" | "out_music_cues" | "out_sfx" | "out_gemini" | "out_claude" | "out_gpt" | "out_locations" | "out_active_model" | "out_scene_count" | "out_logline" | "out_genre_tone" | "out_synopsis" | "out_themes" | "out_script_variants" | "revision"): void { this._raw.delete(key) }
  has(key: "type" | "in_prompt" | "in_active_model" | "in_active_variant_id" | "in_name" | "in_director_instruction" | "in_format_only" | "in_gemini" | "in_claude" | "in_gpt" | "in_characters" | "in_feedback" | "in_target_duration_s" | "in_review_history" | "in_feedback_history" | "in_bg_color" | "out_script" | "out_script_path" | "out_screenplay" | "out_dialogue" | "out_voice_roles" | "out_voice_profiles" | "out_action_lines" | "out_characters" | "out_music_cues" | "out_sfx" | "out_gemini" | "out_claude" | "out_gpt" | "out_locations" | "out_active_model" | "out_scene_count" | "out_logline" | "out_genre_tone" | "out_synopsis" | "out_themes" | "out_script_variants" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<ScriptWriterNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this._writeDataField(field as keyof ScriptWriterNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof ScriptWriterNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'in_prompt': return this.writeInPrompt(value as Exclude<ScriptWriterNodeWriteData['in_prompt'], undefined>, opts)
      case 'in_active_model': return this.writeInActiveModel(value as Exclude<ScriptWriterNodeWriteData['in_active_model'], undefined>, opts)
      case 'in_active_variant_id': return this.writeInActiveVariantId(value as Exclude<ScriptWriterNodeWriteData['in_active_variant_id'], undefined>, opts)
      case 'in_name': return this.writeInName(value as Exclude<ScriptWriterNodeWriteData['in_name'], undefined>, opts)
      case 'in_director_instruction': return this.writeInDirectorInstruction(value as Exclude<ScriptWriterNodeWriteData['in_director_instruction'], undefined>, opts)
      case 'in_format_only': return this.writeInFormatOnly(value as Exclude<ScriptWriterNodeWriteData['in_format_only'], undefined>, opts)
      case 'in_gemini': return this.writeInGemini(value as Exclude<ScriptWriterNodeWriteData['in_gemini'], undefined>, opts)
      case 'in_claude': return this.writeInClaude(value as Exclude<ScriptWriterNodeWriteData['in_claude'], undefined>, opts)
      case 'in_gpt': return this.writeInGpt(value as Exclude<ScriptWriterNodeWriteData['in_gpt'], undefined>, opts)
      case 'in_characters': return this.writeInCharacters(value as Exclude<ScriptWriterNodeWriteData['in_characters'], undefined>, opts)
      case 'in_feedback': return this.writeInFeedback(value as Exclude<ScriptWriterNodeWriteData['in_feedback'], undefined>, opts)
      case 'in_target_duration_s': return this.writeInTargetDurationS(value as Exclude<ScriptWriterNodeWriteData['in_target_duration_s'], undefined>, opts)
      case 'in_review_history': return this.writeInReviewHistory(value as Exclude<ScriptWriterNodeWriteData['in_review_history'], undefined>, opts)
      case 'in_feedback_history': return this.writeInFeedbackHistory(value as Exclude<ScriptWriterNodeWriteData['in_feedback_history'], undefined>, opts)
      case 'in_bg_color': return this.writeInBgColor(value as Exclude<ScriptWriterNodeWriteData['in_bg_color'], undefined>, opts)
      case 'out_script': return this.writeOutScript(value as Exclude<ScriptWriterNodeWriteData['out_script'], undefined>, opts)
      case 'out_script_path': return this.writeOutScriptPath(value as Exclude<ScriptWriterNodeWriteData['out_script_path'], undefined>, opts)
      case 'out_screenplay': return this.writeOutScreenplay(value as Exclude<ScriptWriterNodeWriteData['out_screenplay'], undefined>, opts)
      case 'out_dialogue': return this.writeOutDialogue(value as Exclude<ScriptWriterNodeWriteData['out_dialogue'], undefined>, opts)
      case 'out_voice_roles': return this.writeOutVoiceRoles(value as Exclude<ScriptWriterNodeWriteData['out_voice_roles'], undefined>, opts)
      case 'out_voice_profiles': return this.writeOutVoiceProfiles(value as Exclude<ScriptWriterNodeWriteData['out_voice_profiles'], undefined>, opts)
      case 'out_action_lines': return this.writeOutActionLines(value as Exclude<ScriptWriterNodeWriteData['out_action_lines'], undefined>, opts)
      case 'out_characters': return this.writeOutCharacters(value as Exclude<ScriptWriterNodeWriteData['out_characters'], undefined>, opts)
      case 'out_music_cues': return this.writeOutMusicCues(value as Exclude<ScriptWriterNodeWriteData['out_music_cues'], undefined>, opts)
      case 'out_sfx': return this.writeOutSfx(value as Exclude<ScriptWriterNodeWriteData['out_sfx'], undefined>, opts)
      case 'out_gemini': return this.writeOutGemini(value as Exclude<ScriptWriterNodeWriteData['out_gemini'], undefined>, opts)
      case 'out_claude': return this.writeOutClaude(value as Exclude<ScriptWriterNodeWriteData['out_claude'], undefined>, opts)
      case 'out_gpt': return this.writeOutGpt(value as Exclude<ScriptWriterNodeWriteData['out_gpt'], undefined>, opts)
      case 'out_locations': return this.writeOutLocations(value as Exclude<ScriptWriterNodeWriteData['out_locations'], undefined>, opts)
      case 'out_active_model': return this.writeOutActiveModel(value as Exclude<ScriptWriterNodeWriteData['out_active_model'], undefined>, opts)
      case 'out_scene_count': return this.writeOutSceneCount(value as Exclude<ScriptWriterNodeWriteData['out_scene_count'], undefined>, opts)
      case 'out_logline': return this.writeOutLogline(value as Exclude<ScriptWriterNodeWriteData['out_logline'], undefined>, opts)
      case 'out_genre_tone': return this.writeOutGenreTone(value as Exclude<ScriptWriterNodeWriteData['out_genre_tone'], undefined>, opts)
      case 'out_synopsis': return this.writeOutSynopsis(value as Exclude<ScriptWriterNodeWriteData['out_synopsis'], undefined>, opts)
      case 'out_themes': return this.writeOutThemes(value as Exclude<ScriptWriterNodeWriteData['out_themes'], undefined>, opts)
      case 'out_script_variants': return this.writeOutScriptVariants(value as Exclude<ScriptWriterNodeWriteData['out_script_variants'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writeInPrompt(value: Exclude<ScriptWriterNodeWriteData['in_prompt'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_prompt', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInActiveModel(value: Exclude<ScriptWriterNodeWriteData['in_active_model'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_active_model', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInActiveVariantId(value: Exclude<ScriptWriterNodeWriteData['in_active_variant_id'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_active_variant_id', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInName(value: Exclude<ScriptWriterNodeWriteData['in_name'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_name', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInDirectorInstruction(value: Exclude<ScriptWriterNodeWriteData['in_director_instruction'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_director_instruction', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInFormatOnly(value: Exclude<ScriptWriterNodeWriteData['in_format_only'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_format_only', 'primitive', value, opts, false, 'boolean', undefined)
  }

  writeInGemini(value: Exclude<ScriptWriterNodeWriteData['in_gemini'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_gemini', 'primitive', value, opts, false, 'boolean', undefined)
  }

  writeInClaude(value: Exclude<ScriptWriterNodeWriteData['in_claude'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_claude', 'primitive', value, opts, false, 'boolean', undefined)
  }

  writeInGpt(value: Exclude<ScriptWriterNodeWriteData['in_gpt'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_gpt', 'primitive', value, opts, false, 'boolean', undefined)
  }

  writeInCharacters(value: Exclude<ScriptWriterNodeWriteData['in_characters'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_characters', 'array', value, opts, false, undefined, undefined)
  }

  writeInFeedback(value: Exclude<ScriptWriterNodeWriteData['in_feedback'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_feedback', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInTargetDurationS(value: Exclude<ScriptWriterNodeWriteData['in_target_duration_s'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_target_duration_s', 'primitive', value, opts, false, 'number', undefined)
  }

  writeInReviewHistory(value: Exclude<ScriptWriterNodeWriteData['in_review_history'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_review_history', 'array', value, opts, false, undefined, undefined)
  }

  writeInFeedbackHistory(value: Exclude<ScriptWriterNodeWriteData['in_feedback_history'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_feedback_history', 'array', value, opts, false, undefined, undefined)
  }

  writeInBgColor(value: Exclude<ScriptWriterNodeWriteData['in_bg_color'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_bg_color', 'primitive', value, opts, false, 'string', undefined)
  }

  writeOutScript(value: Exclude<ScriptWriterNodeWriteData['out_script'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_script', 'primitive', value, opts, false, 'string', undefined)
  }

  writeOutScriptPath(value: Exclude<ScriptWriterNodeWriteData['out_script_path'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_script_path', 'primitive', value, opts, false, 'string', undefined)
  }

  writeOutScreenplay(value: Exclude<ScriptWriterNodeWriteData['out_screenplay'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_screenplay', 'array', value, opts, false, undefined, undefined)
  }

  writeOutDialogue(value: Exclude<ScriptWriterNodeWriteData['out_dialogue'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_dialogue', 'array', value, opts, false, undefined, undefined)
  }

  writeOutVoiceRoles(value: Exclude<ScriptWriterNodeWriteData['out_voice_roles'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_voice_roles', 'array', value, opts, false, undefined, undefined)
  }

  writeOutVoiceProfiles(value: Exclude<ScriptWriterNodeWriteData['out_voice_profiles'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_voice_profiles', 'array', value, opts, false, undefined, undefined)
  }

  writeOutActionLines(value: Exclude<ScriptWriterNodeWriteData['out_action_lines'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_action_lines', 'array', value, opts, false, undefined, undefined)
  }

  writeOutCharacters(value: Exclude<ScriptWriterNodeWriteData['out_characters'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_characters', 'array', value, opts, false, undefined, undefined)
  }

  writeOutMusicCues(value: Exclude<ScriptWriterNodeWriteData['out_music_cues'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_music_cues', 'array', value, opts, false, undefined, undefined)
  }

  writeOutSfx(value: Exclude<ScriptWriterNodeWriteData['out_sfx'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_sfx', 'array', value, opts, false, undefined, undefined)
  }

  writeOutGemini(value: Exclude<ScriptWriterNodeWriteData['out_gemini'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_gemini', 'map', value, opts, false, undefined, undefined)
  }

  writeOutClaude(value: Exclude<ScriptWriterNodeWriteData['out_claude'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_claude', 'map', value, opts, false, undefined, undefined)
  }

  writeOutGpt(value: Exclude<ScriptWriterNodeWriteData['out_gpt'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_gpt', 'map', value, opts, false, undefined, undefined)
  }

  writeOutLocations(value: Exclude<ScriptWriterNodeWriteData['out_locations'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_locations', 'array', value, opts, false, undefined, undefined)
  }

  writeOutActiveModel(value: Exclude<ScriptWriterNodeWriteData['out_active_model'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_active_model', 'primitive', value, opts, false, 'string', undefined)
  }

  writeOutSceneCount(value: Exclude<ScriptWriterNodeWriteData['out_scene_count'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_scene_count', 'primitive', value, opts, false, 'number', undefined)
  }

  writeOutLogline(value: Exclude<ScriptWriterNodeWriteData['out_logline'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_logline', 'primitive', value, opts, false, 'string', undefined)
  }

  writeOutGenreTone(value: Exclude<ScriptWriterNodeWriteData['out_genre_tone'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_genre_tone', 'primitive', value, opts, false, 'string', undefined)
  }

  writeOutSynopsis(value: Exclude<ScriptWriterNodeWriteData['out_synopsis'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_synopsis', 'primitive', value, opts, false, 'string', undefined)
  }

  writeOutThemes(value: Exclude<ScriptWriterNodeWriteData['out_themes'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_themes', 'primitive', value, opts, false, 'string', undefined)
  }

  writeOutScriptVariants(value: Exclude<ScriptWriterNodeWriteData['out_script_variants'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_script_variants', 'array', value, opts, false, undefined, undefined)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolveScriptWriterInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    switch (targetHandle) {
      case 'in_prompt': {
        const value = _resolveScriptWriterInPromptInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInPrompt(value as unknown as Exclude<ScriptWriterNodeWriteData['in_prompt'], undefined>)
        return { field: 'in_prompt', value, written }
      }
      case 'in_active_model': {
        const value = _resolveScriptWriterInActiveModelInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInActiveModel(value as unknown as Exclude<ScriptWriterNodeWriteData['in_active_model'], undefined>)
        return { field: 'in_active_model', value, written }
      }
      case 'in_active_variant_id': {
        const value = _resolveScriptWriterInActiveVariantIdInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInActiveVariantId(value as unknown as Exclude<ScriptWriterNodeWriteData['in_active_variant_id'], undefined>)
        return { field: 'in_active_variant_id', value, written }
      }
      case 'in_name': {
        const value = _resolveScriptWriterInNameInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInName(value as unknown as Exclude<ScriptWriterNodeWriteData['in_name'], undefined>)
        return { field: 'in_name', value, written }
      }
      case 'in_director_instruction': {
        const value = _resolveScriptWriterInDirectorInstructionInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInDirectorInstruction(value as unknown as Exclude<ScriptWriterNodeWriteData['in_director_instruction'], undefined>)
        return { field: 'in_director_instruction', value, written }
      }
      case 'in_format_only': {
        const value = _resolveScriptWriterInFormatOnlyInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInFormatOnly(value as unknown as Exclude<ScriptWriterNodeWriteData['in_format_only'], undefined>)
        return { field: 'in_format_only', value, written }
      }
      case 'in_gemini': {
        const value = _resolveScriptWriterInGeminiInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInGemini(value as unknown as Exclude<ScriptWriterNodeWriteData['in_gemini'], undefined>)
        return { field: 'in_gemini', value, written }
      }
      case 'in_claude': {
        const value = _resolveScriptWriterInClaudeInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInClaude(value as unknown as Exclude<ScriptWriterNodeWriteData['in_claude'], undefined>)
        return { field: 'in_claude', value, written }
      }
      case 'in_gpt': {
        const value = _resolveScriptWriterInGptInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInGpt(value as unknown as Exclude<ScriptWriterNodeWriteData['in_gpt'], undefined>)
        return { field: 'in_gpt', value, written }
      }
      case 'in_characters': {
        const value = _resolveScriptWriterInCharactersInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_characters')
        if (hadPersistedValue) this.delete('in_characters')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_characters', value, written }
      }
      case 'in_feedback': {
        const value = _resolveScriptWriterInFeedbackInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInFeedback(value as unknown as Exclude<ScriptWriterNodeWriteData['in_feedback'], undefined>)
        return { field: 'in_feedback', value, written }
      }
      case 'in_target_duration_s': {
        const value = _resolveScriptWriterInTargetDurationSInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInTargetDurationS(value as unknown as Exclude<ScriptWriterNodeWriteData['in_target_duration_s'], undefined>)
        return { field: 'in_target_duration_s', value, written }
      }
      case 'in_review_history': {
        const value = _resolveScriptWriterInReviewHistoryInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInReviewHistory(value as unknown as Exclude<ScriptWriterNodeWriteData['in_review_history'], undefined>)
        return { field: 'in_review_history', value, written }
      }
      case 'in_feedback_history': {
        const value = _resolveScriptWriterInFeedbackHistoryInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInFeedbackHistory(value as unknown as Exclude<ScriptWriterNodeWriteData['in_feedback_history'], undefined>)
        return { field: 'in_feedback_history', value, written }
      }
      case 'in_bg_color': {
        const value = _resolveScriptWriterInBgColorInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInBgColor(value as unknown as Exclude<ScriptWriterNodeWriteData['in_bg_color'], undefined>)
        return { field: 'in_bg_color', value, written }
      }
      default:
        throw new Error(`Unknown input port ${targetHandle} for ScriptWriterCanvasNode`)
    }
  }
}

export class ShortVideoGroupCanvasNode extends GeneratedCanvasNode<ShortVideoGroupNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  get(key: 'type'): "shortVideoGroup" | undefined
  get(key: 'in_label'): string | undefined
  get(key: 'in_collapsed'): boolean | undefined
  get(key: 'in_storyboard_path'): string | undefined
  get(key: 'in_image'): ImageAssetRefDictYMap | undefined
  get(key: 'in_child_node_ids'): Array<string> | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'in_label': return _readYDocOptionalString(this._raw.get('in_label'), "shortVideoGroup.in_label")
      case 'in_collapsed': return _readYDocOptionalBoolean(this._raw.get('in_collapsed'), "shortVideoGroup.in_collapsed")
      case 'in_storyboard_path': return _readYDocOptionalString(this._raw.get('in_storyboard_path'), "shortVideoGroup.in_storyboard_path")
      case 'in_image': return _readYDocOptionalMapWrapper(this._raw.get('in_image'), ImageAssetRefDictYMap, "shortVideoGroup.in_image")
      case 'in_child_node_ids': return _readYDocOptionalArray(this._raw.get('in_child_node_ids'), "shortVideoGroup.in_child_node_ids", (item, itemLabel) => _readYDocString(item, itemLabel))
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "in_label" | "in_collapsed" | "in_storyboard_path" | "in_image" | "in_child_node_ids" | "revision"): void { this._raw.delete(key) }
  has(key: "type" | "in_label" | "in_collapsed" | "in_storyboard_path" | "in_image" | "in_child_node_ids" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<ShortVideoGroupNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this._writeDataField(field as keyof ShortVideoGroupNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof ShortVideoGroupNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'in_label': return this.writeInLabel(value as Exclude<ShortVideoGroupNodeWriteData['in_label'], undefined>, opts)
      case 'in_collapsed': return this.writeInCollapsed(value as Exclude<ShortVideoGroupNodeWriteData['in_collapsed'], undefined>, opts)
      case 'in_storyboard_path': return this.writeInStoryboardPath(value as Exclude<ShortVideoGroupNodeWriteData['in_storyboard_path'], undefined>, opts)
      case 'in_image': return this.writeInImage(value as Exclude<ShortVideoGroupNodeWriteData['in_image'], undefined>, opts)
      case 'in_child_node_ids': return this.writeInChildNodeIds(value as Exclude<ShortVideoGroupNodeWriteData['in_child_node_ids'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writeInLabel(value: Exclude<ShortVideoGroupNodeWriteData['in_label'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_label', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInCollapsed(value: Exclude<ShortVideoGroupNodeWriteData['in_collapsed'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_collapsed', 'primitive', value, opts, false, 'boolean', undefined)
  }

  writeInStoryboardPath(value: Exclude<ShortVideoGroupNodeWriteData['in_storyboard_path'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_storyboard_path', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInImage(value: Exclude<ShortVideoGroupNodeWriteData['in_image'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_image', 'map', value, opts, false, undefined, undefined)
  }

  writeInChildNodeIds(value: Exclude<ShortVideoGroupNodeWriteData['in_child_node_ids'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_child_node_ids', 'array', value, opts, false, undefined, undefined)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolveShortVideoGroupInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    switch (targetHandle) {
      case 'in_label': {
        const value = _resolveShortVideoGroupInLabelInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInLabel(value as unknown as Exclude<ShortVideoGroupNodeWriteData['in_label'], undefined>)
        return { field: 'in_label', value, written }
      }
      case 'in_collapsed': {
        const value = _resolveShortVideoGroupInCollapsedInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInCollapsed(value as unknown as Exclude<ShortVideoGroupNodeWriteData['in_collapsed'], undefined>)
        return { field: 'in_collapsed', value, written }
      }
      case 'in_storyboard_path': {
        const value = _resolveShortVideoGroupInStoryboardPathInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInStoryboardPath(value as unknown as Exclude<ShortVideoGroupNodeWriteData['in_storyboard_path'], undefined>)
        return { field: 'in_storyboard_path', value, written }
      }
      case 'in_image': {
        const value = _resolveShortVideoGroupInImageInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_image')
        if (hadPersistedValue) this.delete('in_image')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_image', value, written }
      }
      case 'in_child_node_ids': {
        const value = _resolveShortVideoGroupInChildNodeIdsInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInChildNodeIds(value as unknown as Exclude<ShortVideoGroupNodeWriteData['in_child_node_ids'], undefined>)
        return { field: 'in_child_node_ids', value, written }
      }
      default:
        throw new Error(`Unknown input port ${targetHandle} for ShortVideoGroupCanvasNode`)
    }
  }
}

export class SoundExpertCanvasNode extends GeneratedCanvasNode<SoundExpertNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  get(key: 'type'): "soundExpert" | undefined
  get(key: 'in_name'): string | undefined
  get(key: 'in_upstream'): UpstreamContextDictYMap | undefined
  get(key: 'in_prompt'): string | undefined
  get(key: 'in_mode'): string | undefined
  get(key: 'in_duration'): string | undefined
  get(key: 'in_voice_profile'): VoiceProfileDictYMap | undefined
  get(key: 'in_text'): string | undefined
  get(key: 'in_feedback'): string | undefined
  get(key: 'in_feedback_history'): Array<FeedbackHistoryEntryDictYMap> | undefined
  get(key: 'in_model'): string | undefined
  get(key: 'in_loop'): string | undefined
  get(key: 'in_lyrics_mode'): string | undefined
  get(key: 'in_voice_map'): VoiceMapDictYMap | undefined
  get(key: 'in_scene_id'): string | undefined
  get(key: 'in_panel_index'): number | undefined
  get(key: 'in_pause_ms'): number | undefined
  get(key: 'in_character_name'): string | undefined
  get(key: 'in_character_voice_source_for'): string | undefined
  get(key: 'out_duration_seconds'): number | undefined
  get(key: 'out_audio'): SoundGeneratedAudioDictYMap | undefined
  get(key: 'out_voice_profile'): VoiceProfileDictYMap | undefined
  get(key: 'batch_pending'): number | undefined
  get(key: 'audio_file'): string | undefined
  get(key: 'speech_segments'): SpeechSegmentDictYMap | undefined
  get(key: 'selected_voice_provider'): string | undefined
  get(key: 'selected_voice_id'): string | undefined
  get(key: 'selected_voice_name'): string | undefined
  get(key: 'selected_voice_ref'): string | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'in_name': return _readYDocOptionalString(this._raw.get('in_name'), "soundExpert.in_name")
      case 'in_upstream': return _readYDocOptionalMapWrapper(this._raw.get('in_upstream'), UpstreamContextDictYMap, "soundExpert.in_upstream")
      case 'in_prompt': return _readYDocOptionalString(this._raw.get('in_prompt'), "soundExpert.in_prompt")
      case 'in_mode': return _readYDocOptionalString(this._raw.get('in_mode'), "soundExpert.in_mode")
      case 'in_duration': return _readYDocOptionalString(this._raw.get('in_duration'), "soundExpert.in_duration")
      case 'in_voice_profile': return _readYDocOptionalMapWrapper(this._raw.get('in_voice_profile'), VoiceProfileDictYMap, "soundExpert.in_voice_profile")
      case 'in_text': return _readYDocOptionalString(this._raw.get('in_text'), "soundExpert.in_text")
      case 'in_feedback': return _readYDocOptionalString(this._raw.get('in_feedback'), "soundExpert.in_feedback")
      case 'in_feedback_history': return _readYDocOptionalArray(this._raw.get('in_feedback_history'), "soundExpert.in_feedback_history", (item, itemLabel) => _readYDocMapWrapper(item, FeedbackHistoryEntryDictYMap, itemLabel))
      case 'in_model': return _readYDocOptionalString(this._raw.get('in_model'), "soundExpert.in_model")
      case 'in_loop': return _readYDocOptionalString(this._raw.get('in_loop'), "soundExpert.in_loop")
      case 'in_lyrics_mode': return _readYDocOptionalString(this._raw.get('in_lyrics_mode'), "soundExpert.in_lyrics_mode")
      case 'in_voice_map': return _readYDocOptionalMapWrapper(this._raw.get('in_voice_map'), VoiceMapDictYMap, "soundExpert.in_voice_map")
      case 'in_scene_id': return _readYDocOptionalString(this._raw.get('in_scene_id'), "soundExpert.in_scene_id")
      case 'in_panel_index': return _readYDocOptionalNumber(this._raw.get('in_panel_index'), "soundExpert.in_panel_index")
      case 'in_pause_ms': return _readYDocOptionalNumber(this._raw.get('in_pause_ms'), "soundExpert.in_pause_ms")
      case 'in_character_name': return _readYDocOptionalString(this._raw.get('in_character_name'), "soundExpert.in_character_name")
      case 'in_character_voice_source_for': return _readYDocOptionalString(this._raw.get('in_character_voice_source_for'), "soundExpert.in_character_voice_source_for")
      case 'out_duration_seconds': return _readYDocOptionalNumber(this._raw.get('out_duration_seconds'), "soundExpert.out_duration_seconds")
      case 'out_audio': return _readYDocOptionalMapWrapper(this._raw.get('out_audio'), SoundGeneratedAudioDictYMap, "soundExpert.out_audio")
      case 'out_voice_profile': return _readYDocOptionalMapWrapper(this._raw.get('out_voice_profile'), VoiceProfileDictYMap, "soundExpert.out_voice_profile")
      case 'batch_pending': return _readYDocOptionalNumber(this._raw.get('batch_pending'), "soundExpert.batch_pending")
      case 'audio_file': return _readYDocOptionalString(this._raw.get('audio_file'), "soundExpert.audio_file")
      case 'speech_segments': return _readYDocOptionalMapWrapper(this._raw.get('speech_segments'), SpeechSegmentDictYMap, "soundExpert.speech_segments")
      case 'selected_voice_provider': return _readYDocOptionalString(this._raw.get('selected_voice_provider'), "soundExpert.selected_voice_provider")
      case 'selected_voice_id': return _readYDocOptionalString(this._raw.get('selected_voice_id'), "soundExpert.selected_voice_id")
      case 'selected_voice_name': return _readYDocOptionalString(this._raw.get('selected_voice_name'), "soundExpert.selected_voice_name")
      case 'selected_voice_ref': return _readYDocOptionalString(this._raw.get('selected_voice_ref'), "soundExpert.selected_voice_ref")
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "in_name" | "in_upstream" | "in_prompt" | "in_mode" | "in_duration" | "in_voice_profile" | "in_text" | "in_feedback" | "in_feedback_history" | "in_model" | "in_loop" | "in_lyrics_mode" | "in_voice_map" | "in_scene_id" | "in_panel_index" | "in_pause_ms" | "in_character_name" | "in_character_voice_source_for" | "out_duration_seconds" | "out_audio" | "out_voice_profile" | "batch_pending" | "audio_file" | "speech_segments" | "selected_voice_provider" | "selected_voice_id" | "selected_voice_name" | "selected_voice_ref" | "revision"): void { this._raw.delete(key) }
  has(key: "type" | "in_name" | "in_upstream" | "in_prompt" | "in_mode" | "in_duration" | "in_voice_profile" | "in_text" | "in_feedback" | "in_feedback_history" | "in_model" | "in_loop" | "in_lyrics_mode" | "in_voice_map" | "in_scene_id" | "in_panel_index" | "in_pause_ms" | "in_character_name" | "in_character_voice_source_for" | "out_duration_seconds" | "out_audio" | "out_voice_profile" | "batch_pending" | "audio_file" | "speech_segments" | "selected_voice_provider" | "selected_voice_id" | "selected_voice_name" | "selected_voice_ref" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<SoundExpertNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this._writeDataField(field as keyof SoundExpertNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof SoundExpertNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'in_name': return this.writeInName(value as Exclude<SoundExpertNodeWriteData['in_name'], undefined>, opts)
      case 'in_upstream': return this.writeInUpstream(value as Exclude<SoundExpertNodeWriteData['in_upstream'], undefined>, opts)
      case 'in_prompt': return this.writeInPrompt(value as Exclude<SoundExpertNodeWriteData['in_prompt'], undefined>, opts)
      case 'in_mode': return this.writeInMode(value as Exclude<SoundExpertNodeWriteData['in_mode'], undefined>, opts)
      case 'in_duration': return this.writeInDuration(value as Exclude<SoundExpertNodeWriteData['in_duration'], undefined>, opts)
      case 'in_voice_profile': return this.writeInVoiceProfile(value as Exclude<SoundExpertNodeWriteData['in_voice_profile'], undefined>, opts)
      case 'in_text': return this.writeInText(value as Exclude<SoundExpertNodeWriteData['in_text'], undefined>, opts)
      case 'in_feedback': return this.writeInFeedback(value as Exclude<SoundExpertNodeWriteData['in_feedback'], undefined>, opts)
      case 'in_feedback_history': return this.writeInFeedbackHistory(value as Exclude<SoundExpertNodeWriteData['in_feedback_history'], undefined>, opts)
      case 'in_model': return this.writeInModel(value as Exclude<SoundExpertNodeWriteData['in_model'], undefined>, opts)
      case 'in_loop': return this.writeInLoop(value as Exclude<SoundExpertNodeWriteData['in_loop'], undefined>, opts)
      case 'in_lyrics_mode': return this.writeInLyricsMode(value as Exclude<SoundExpertNodeWriteData['in_lyrics_mode'], undefined>, opts)
      case 'in_voice_map': return this.writeInVoiceMap(value as Exclude<SoundExpertNodeWriteData['in_voice_map'], undefined>, opts)
      case 'in_scene_id': return this.writeInSceneId(value as Exclude<SoundExpertNodeWriteData['in_scene_id'], undefined>, opts)
      case 'in_panel_index': return this.writeInPanelIndex(value as Exclude<SoundExpertNodeWriteData['in_panel_index'], undefined>, opts)
      case 'in_pause_ms': return this.writeInPauseMs(value as Exclude<SoundExpertNodeWriteData['in_pause_ms'], undefined>, opts)
      case 'in_character_name': return this.writeInCharacterName(value as Exclude<SoundExpertNodeWriteData['in_character_name'], undefined>, opts)
      case 'in_character_voice_source_for': return this.writeInCharacterVoiceSourceFor(value as Exclude<SoundExpertNodeWriteData['in_character_voice_source_for'], undefined>, opts)
      case 'out_duration_seconds': return this.writeOutDurationSeconds(value as Exclude<SoundExpertNodeWriteData['out_duration_seconds'], undefined>, opts)
      case 'out_audio': return this.writeOutAudio(value as Exclude<SoundExpertNodeWriteData['out_audio'], undefined>, opts)
      case 'out_voice_profile': return this.writeOutVoiceProfile(value as Exclude<SoundExpertNodeWriteData['out_voice_profile'], undefined>, opts)
      case 'batch_pending': return this.writeBatchPending(value as Exclude<SoundExpertNodeWriteData['batch_pending'], undefined>, opts)
      case 'audio_file': return this.writeAudioFile(value as Exclude<SoundExpertNodeWriteData['audio_file'], undefined>, opts)
      case 'speech_segments': return this.writeSpeechSegments(value as Exclude<SoundExpertNodeWriteData['speech_segments'], undefined>, opts)
      case 'selected_voice_provider': return this.writeSelectedVoiceProvider(value as Exclude<SoundExpertNodeWriteData['selected_voice_provider'], undefined>, opts)
      case 'selected_voice_id': return this.writeSelectedVoiceId(value as Exclude<SoundExpertNodeWriteData['selected_voice_id'], undefined>, opts)
      case 'selected_voice_name': return this.writeSelectedVoiceName(value as Exclude<SoundExpertNodeWriteData['selected_voice_name'], undefined>, opts)
      case 'selected_voice_ref': return this.writeSelectedVoiceRef(value as Exclude<SoundExpertNodeWriteData['selected_voice_ref'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writeInName(value: Exclude<SoundExpertNodeWriteData['in_name'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_name', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInUpstream(value: Exclude<SoundExpertNodeWriteData['in_upstream'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_upstream', 'map', value, opts, false, undefined, undefined)
  }

  writeInPrompt(value: Exclude<SoundExpertNodeWriteData['in_prompt'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_prompt', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInMode(value: Exclude<SoundExpertNodeWriteData['in_mode'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_mode', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInDuration(value: Exclude<SoundExpertNodeWriteData['in_duration'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_duration', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInVoiceProfile(value: Exclude<SoundExpertNodeWriteData['in_voice_profile'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_voice_profile', 'map', value, opts, false, undefined, undefined)
  }

  writeInText(value: Exclude<SoundExpertNodeWriteData['in_text'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_text', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInFeedback(value: Exclude<SoundExpertNodeWriteData['in_feedback'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_feedback', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInFeedbackHistory(value: Exclude<SoundExpertNodeWriteData['in_feedback_history'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_feedback_history', 'array', value, opts, false, undefined, (value, fieldLabel) => _validateYDocArray(value, fieldLabel, () => undefined, 10))
  }

  writeInModel(value: Exclude<SoundExpertNodeWriteData['in_model'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_model', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInLoop(value: Exclude<SoundExpertNodeWriteData['in_loop'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_loop', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInLyricsMode(value: Exclude<SoundExpertNodeWriteData['in_lyrics_mode'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_lyrics_mode', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInVoiceMap(value: Exclude<SoundExpertNodeWriteData['in_voice_map'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_voice_map', 'map', value, opts, false, undefined, undefined)
  }

  writeInSceneId(value: Exclude<SoundExpertNodeWriteData['in_scene_id'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_scene_id', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInPanelIndex(value: Exclude<SoundExpertNodeWriteData['in_panel_index'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_panel_index', 'primitive', value, opts, false, 'number', undefined)
  }

  writeInPauseMs(value: Exclude<SoundExpertNodeWriteData['in_pause_ms'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_pause_ms', 'primitive', value, opts, false, 'number', undefined)
  }

  writeInCharacterName(value: Exclude<SoundExpertNodeWriteData['in_character_name'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_character_name', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInCharacterVoiceSourceFor(value: Exclude<SoundExpertNodeWriteData['in_character_voice_source_for'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_character_voice_source_for', 'primitive', value, opts, false, 'string', undefined)
  }

  writeOutDurationSeconds(value: Exclude<SoundExpertNodeWriteData['out_duration_seconds'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_duration_seconds', 'primitive', value, opts, false, 'number', undefined)
  }

  writeOutAudio(value: Exclude<SoundExpertNodeWriteData['out_audio'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_audio', 'map', value, opts, false, undefined, undefined)
  }

  writeOutVoiceProfile(value: Exclude<SoundExpertNodeWriteData['out_voice_profile'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_voice_profile', 'map', value, opts, false, undefined, undefined)
  }

  writeBatchPending(value: Exclude<SoundExpertNodeWriteData['batch_pending'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('batch_pending', 'primitive', value, opts, false, 'number', undefined)
  }

  writeAudioFile(value: Exclude<SoundExpertNodeWriteData['audio_file'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('audio_file', 'primitive', value, opts, false, 'string', undefined)
  }

  writeSpeechSegments(value: Exclude<SoundExpertNodeWriteData['speech_segments'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('speech_segments', 'map', value, opts, false, undefined, undefined)
  }

  writeSelectedVoiceProvider(value: Exclude<SoundExpertNodeWriteData['selected_voice_provider'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('selected_voice_provider', 'primitive', value, opts, false, 'string', undefined)
  }

  writeSelectedVoiceId(value: Exclude<SoundExpertNodeWriteData['selected_voice_id'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('selected_voice_id', 'primitive', value, opts, false, 'string', undefined)
  }

  writeSelectedVoiceName(value: Exclude<SoundExpertNodeWriteData['selected_voice_name'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('selected_voice_name', 'primitive', value, opts, false, 'string', undefined)
  }

  writeSelectedVoiceRef(value: Exclude<SoundExpertNodeWriteData['selected_voice_ref'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('selected_voice_ref', 'primitive', value, opts, false, 'string', undefined)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolveSoundExpertInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    switch (targetHandle) {
      case 'in_name': {
        const value = _resolveSoundExpertInNameInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInName(value as unknown as Exclude<SoundExpertNodeWriteData['in_name'], undefined>)
        return { field: 'in_name', value, written }
      }
      case 'in_upstream': {
        const value = _resolveSoundExpertInUpstreamInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInUpstream(value as unknown as Exclude<SoundExpertNodeWriteData['in_upstream'], undefined>)
        return { field: 'in_upstream', value, written }
      }
      case 'in_prompt': {
        const value = _resolveSoundExpertInPromptInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInPrompt(value as unknown as Exclude<SoundExpertNodeWriteData['in_prompt'], undefined>)
        return { field: 'in_prompt', value, written }
      }
      case 'in_mode': {
        const value = _resolveSoundExpertInModeInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInMode(value as unknown as Exclude<SoundExpertNodeWriteData['in_mode'], undefined>)
        return { field: 'in_mode', value, written }
      }
      case 'in_duration': {
        const value = _resolveSoundExpertInDurationInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInDuration(value as unknown as Exclude<SoundExpertNodeWriteData['in_duration'], undefined>)
        return { field: 'in_duration', value, written }
      }
      case 'in_voice_profile': {
        const value = _resolveSoundExpertInVoiceProfileInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_voice_profile')
        if (hadPersistedValue) this.delete('in_voice_profile')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_voice_profile', value, written }
      }
      case 'in_text': {
        const value = _resolveSoundExpertInTextInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInText(value as unknown as Exclude<SoundExpertNodeWriteData['in_text'], undefined>)
        return { field: 'in_text', value, written }
      }
      case 'in_feedback': {
        const value = _resolveSoundExpertInFeedbackInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInFeedback(value as unknown as Exclude<SoundExpertNodeWriteData['in_feedback'], undefined>)
        return { field: 'in_feedback', value, written }
      }
      case 'in_feedback_history': {
        const value = _resolveSoundExpertInFeedbackHistoryInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInFeedbackHistory(value as unknown as Exclude<SoundExpertNodeWriteData['in_feedback_history'], undefined>)
        return { field: 'in_feedback_history', value, written }
      }
      case 'in_model': {
        const value = _resolveSoundExpertInModelInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInModel(value as unknown as Exclude<SoundExpertNodeWriteData['in_model'], undefined>)
        return { field: 'in_model', value, written }
      }
      case 'in_loop': {
        const value = _resolveSoundExpertInLoopInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInLoop(value as unknown as Exclude<SoundExpertNodeWriteData['in_loop'], undefined>)
        return { field: 'in_loop', value, written }
      }
      case 'in_lyrics_mode': {
        const value = _resolveSoundExpertInLyricsModeInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInLyricsMode(value as unknown as Exclude<SoundExpertNodeWriteData['in_lyrics_mode'], undefined>)
        return { field: 'in_lyrics_mode', value, written }
      }
      case 'in_voice_map': {
        const value = _resolveSoundExpertInVoiceMapInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInVoiceMap(value as unknown as Exclude<SoundExpertNodeWriteData['in_voice_map'], undefined>)
        return { field: 'in_voice_map', value, written }
      }
      case 'in_scene_id': {
        const value = _resolveSoundExpertInSceneIdInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInSceneId(value as unknown as Exclude<SoundExpertNodeWriteData['in_scene_id'], undefined>)
        return { field: 'in_scene_id', value, written }
      }
      case 'in_panel_index': {
        const value = _resolveSoundExpertInPanelIndexInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInPanelIndex(value as unknown as Exclude<SoundExpertNodeWriteData['in_panel_index'], undefined>)
        return { field: 'in_panel_index', value, written }
      }
      case 'in_pause_ms': {
        const value = _resolveSoundExpertInPauseMsInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInPauseMs(value as unknown as Exclude<SoundExpertNodeWriteData['in_pause_ms'], undefined>)
        return { field: 'in_pause_ms', value, written }
      }
      case 'in_character_name': {
        const value = _resolveSoundExpertInCharacterNameInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInCharacterName(value as unknown as Exclude<SoundExpertNodeWriteData['in_character_name'], undefined>)
        return { field: 'in_character_name', value, written }
      }
      case 'in_character_voice_source_for': {
        const value = _resolveSoundExpertInCharacterVoiceSourceForInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInCharacterVoiceSourceFor(value as unknown as Exclude<SoundExpertNodeWriteData['in_character_voice_source_for'], undefined>)
        return { field: 'in_character_voice_source_for', value, written }
      }
      default:
        throw new Error(`Unknown input port ${targetHandle} for SoundExpertCanvasNode`)
    }
  }
}

export class SpeechGeneratorCanvasNode extends GeneratedCanvasNode<SpeechGeneratorNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  get(key: 'type'): "speechGenerator" | undefined
  get(key: 'in_mode'): string | undefined
  get(key: 'in_script'): string | undefined
  get(key: 'in_text'): string | undefined
  get(key: 'in_character_name'): string | undefined
  get(key: 'in_voice_id'): string | undefined
  get(key: 'in_voice_profile'): VoiceProfileDictYMap | undefined
  get(key: 'in_voice_map'): VoiceMapDictYMap | undefined
  get(key: 'in_scene_id'): string | undefined
  get(key: 'in_panel_index'): number | undefined
  get(key: 'in_pause_ms'): number | undefined
  get(key: 'in_pronunciation_guide'): string | undefined
  get(key: 'in_language_code'): string | undefined
  get(key: 'out_duration_seconds'): number | undefined
  get(key: 'out_waveform'): Array<number> | undefined
  get(key: 'out_audio'): SoundGeneratedAudioDictYMap | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'in_mode': return _readYDocOptionalString(this._raw.get('in_mode'), "speechGenerator.in_mode")
      case 'in_script': return _readYDocOptionalString(this._raw.get('in_script'), "speechGenerator.in_script")
      case 'in_text': return _readYDocOptionalString(this._raw.get('in_text'), "speechGenerator.in_text")
      case 'in_character_name': return _readYDocOptionalString(this._raw.get('in_character_name'), "speechGenerator.in_character_name")
      case 'in_voice_id': return _readYDocOptionalString(this._raw.get('in_voice_id'), "speechGenerator.in_voice_id")
      case 'in_voice_profile': return _readYDocOptionalMapWrapper(this._raw.get('in_voice_profile'), VoiceProfileDictYMap, "speechGenerator.in_voice_profile")
      case 'in_voice_map': return _readYDocOptionalMapWrapper(this._raw.get('in_voice_map'), VoiceMapDictYMap, "speechGenerator.in_voice_map")
      case 'in_scene_id': return _readYDocOptionalString(this._raw.get('in_scene_id'), "speechGenerator.in_scene_id")
      case 'in_panel_index': return _readYDocOptionalNumber(this._raw.get('in_panel_index'), "speechGenerator.in_panel_index")
      case 'in_pause_ms': return _readYDocOptionalNumber(this._raw.get('in_pause_ms'), "speechGenerator.in_pause_ms")
      case 'in_pronunciation_guide': return _readYDocOptionalString(this._raw.get('in_pronunciation_guide'), "speechGenerator.in_pronunciation_guide")
      case 'in_language_code': return _readYDocOptionalString(this._raw.get('in_language_code'), "speechGenerator.in_language_code")
      case 'out_duration_seconds': return _readYDocOptionalNumber(this._raw.get('out_duration_seconds'), "speechGenerator.out_duration_seconds")
      case 'out_waveform': return _readYDocOptionalArray(this._raw.get('out_waveform'), "speechGenerator.out_waveform", (item, itemLabel) => _readYDocNumber(item, itemLabel))
      case 'out_audio': return _readYDocOptionalMapWrapper(this._raw.get('out_audio'), SoundGeneratedAudioDictYMap, "speechGenerator.out_audio")
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "in_mode" | "in_script" | "in_text" | "in_character_name" | "in_voice_id" | "in_voice_profile" | "in_voice_map" | "in_scene_id" | "in_panel_index" | "in_pause_ms" | "in_pronunciation_guide" | "in_language_code" | "out_duration_seconds" | "out_waveform" | "out_audio" | "revision"): void { this._raw.delete(key) }
  has(key: "type" | "in_mode" | "in_script" | "in_text" | "in_character_name" | "in_voice_id" | "in_voice_profile" | "in_voice_map" | "in_scene_id" | "in_panel_index" | "in_pause_ms" | "in_pronunciation_guide" | "in_language_code" | "out_duration_seconds" | "out_waveform" | "out_audio" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<SpeechGeneratorNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this._writeDataField(field as keyof SpeechGeneratorNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof SpeechGeneratorNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'in_mode': return this.writeInMode(value as Exclude<SpeechGeneratorNodeWriteData['in_mode'], undefined>, opts)
      case 'in_script': return this.writeInScript(value as Exclude<SpeechGeneratorNodeWriteData['in_script'], undefined>, opts)
      case 'in_text': return this.writeInText(value as Exclude<SpeechGeneratorNodeWriteData['in_text'], undefined>, opts)
      case 'in_character_name': return this.writeInCharacterName(value as Exclude<SpeechGeneratorNodeWriteData['in_character_name'], undefined>, opts)
      case 'in_voice_id': return this.writeInVoiceId(value as Exclude<SpeechGeneratorNodeWriteData['in_voice_id'], undefined>, opts)
      case 'in_voice_profile': return this.writeInVoiceProfile(value as Exclude<SpeechGeneratorNodeWriteData['in_voice_profile'], undefined>, opts)
      case 'in_voice_map': return this.writeInVoiceMap(value as Exclude<SpeechGeneratorNodeWriteData['in_voice_map'], undefined>, opts)
      case 'in_scene_id': return this.writeInSceneId(value as Exclude<SpeechGeneratorNodeWriteData['in_scene_id'], undefined>, opts)
      case 'in_panel_index': return this.writeInPanelIndex(value as Exclude<SpeechGeneratorNodeWriteData['in_panel_index'], undefined>, opts)
      case 'in_pause_ms': return this.writeInPauseMs(value as Exclude<SpeechGeneratorNodeWriteData['in_pause_ms'], undefined>, opts)
      case 'in_pronunciation_guide': return this.writeInPronunciationGuide(value as Exclude<SpeechGeneratorNodeWriteData['in_pronunciation_guide'], undefined>, opts)
      case 'in_language_code': return this.writeInLanguageCode(value as Exclude<SpeechGeneratorNodeWriteData['in_language_code'], undefined>, opts)
      case 'out_duration_seconds': return this.writeOutDurationSeconds(value as Exclude<SpeechGeneratorNodeWriteData['out_duration_seconds'], undefined>, opts)
      case 'out_waveform': return this.writeOutWaveform(value as Exclude<SpeechGeneratorNodeWriteData['out_waveform'], undefined>, opts)
      case 'out_audio': return this.writeOutAudio(value as Exclude<SpeechGeneratorNodeWriteData['out_audio'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writeInMode(value: Exclude<SpeechGeneratorNodeWriteData['in_mode'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_mode', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInScript(value: Exclude<SpeechGeneratorNodeWriteData['in_script'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_script', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInText(value: Exclude<SpeechGeneratorNodeWriteData['in_text'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_text', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInCharacterName(value: Exclude<SpeechGeneratorNodeWriteData['in_character_name'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_character_name', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInVoiceId(value: Exclude<SpeechGeneratorNodeWriteData['in_voice_id'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_voice_id', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInVoiceProfile(value: Exclude<SpeechGeneratorNodeWriteData['in_voice_profile'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_voice_profile', 'map', value, opts, false, undefined, undefined)
  }

  writeInVoiceMap(value: Exclude<SpeechGeneratorNodeWriteData['in_voice_map'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_voice_map', 'map', value, opts, false, undefined, undefined)
  }

  writeInSceneId(value: Exclude<SpeechGeneratorNodeWriteData['in_scene_id'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_scene_id', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInPanelIndex(value: Exclude<SpeechGeneratorNodeWriteData['in_panel_index'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_panel_index', 'primitive', value, opts, false, 'number', undefined)
  }

  writeInPauseMs(value: Exclude<SpeechGeneratorNodeWriteData['in_pause_ms'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_pause_ms', 'primitive', value, opts, false, 'number', undefined)
  }

  writeInPronunciationGuide(value: Exclude<SpeechGeneratorNodeWriteData['in_pronunciation_guide'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_pronunciation_guide', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInLanguageCode(value: Exclude<SpeechGeneratorNodeWriteData['in_language_code'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_language_code', 'primitive', value, opts, false, 'string', undefined)
  }

  writeOutDurationSeconds(value: Exclude<SpeechGeneratorNodeWriteData['out_duration_seconds'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_duration_seconds', 'primitive', value, opts, false, 'number', undefined)
  }

  writeOutWaveform(value: Exclude<SpeechGeneratorNodeWriteData['out_waveform'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_waveform', 'array', value, opts, false, undefined, undefined)
  }

  writeOutAudio(value: Exclude<SpeechGeneratorNodeWriteData['out_audio'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_audio', 'map', value, opts, false, undefined, undefined)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolveSpeechGeneratorInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    switch (targetHandle) {
      case 'in_mode': {
        const value = _resolveSpeechGeneratorInModeInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInMode(value as unknown as Exclude<SpeechGeneratorNodeWriteData['in_mode'], undefined>)
        return { field: 'in_mode', value, written }
      }
      case 'in_script': {
        const value = _resolveSpeechGeneratorInScriptInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInScript(value as unknown as Exclude<SpeechGeneratorNodeWriteData['in_script'], undefined>)
        return { field: 'in_script', value, written }
      }
      case 'in_text': {
        const value = _resolveSpeechGeneratorInTextInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInText(value as unknown as Exclude<SpeechGeneratorNodeWriteData['in_text'], undefined>)
        return { field: 'in_text', value, written }
      }
      case 'in_character_name': {
        const value = _resolveSpeechGeneratorInCharacterNameInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInCharacterName(value as unknown as Exclude<SpeechGeneratorNodeWriteData['in_character_name'], undefined>)
        return { field: 'in_character_name', value, written }
      }
      case 'in_voice_id': {
        const value = _resolveSpeechGeneratorInVoiceIdInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInVoiceId(value as unknown as Exclude<SpeechGeneratorNodeWriteData['in_voice_id'], undefined>)
        return { field: 'in_voice_id', value, written }
      }
      case 'in_voice_profile': {
        const value = _resolveSpeechGeneratorInVoiceProfileInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_voice_profile')
        if (hadPersistedValue) this.delete('in_voice_profile')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_voice_profile', value, written }
      }
      case 'in_voice_map': {
        const value = _resolveSpeechGeneratorInVoiceMapInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInVoiceMap(value as unknown as Exclude<SpeechGeneratorNodeWriteData['in_voice_map'], undefined>)
        return { field: 'in_voice_map', value, written }
      }
      case 'in_scene_id': {
        const value = _resolveSpeechGeneratorInSceneIdInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInSceneId(value as unknown as Exclude<SpeechGeneratorNodeWriteData['in_scene_id'], undefined>)
        return { field: 'in_scene_id', value, written }
      }
      case 'in_panel_index': {
        const value = _resolveSpeechGeneratorInPanelIndexInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInPanelIndex(value as unknown as Exclude<SpeechGeneratorNodeWriteData['in_panel_index'], undefined>)
        return { field: 'in_panel_index', value, written }
      }
      case 'in_pause_ms': {
        const value = _resolveSpeechGeneratorInPauseMsInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInPauseMs(value as unknown as Exclude<SpeechGeneratorNodeWriteData['in_pause_ms'], undefined>)
        return { field: 'in_pause_ms', value, written }
      }
      case 'in_pronunciation_guide': {
        const value = _resolveSpeechGeneratorInPronunciationGuideInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInPronunciationGuide(value as unknown as Exclude<SpeechGeneratorNodeWriteData['in_pronunciation_guide'], undefined>)
        return { field: 'in_pronunciation_guide', value, written }
      }
      case 'in_language_code': {
        const value = _resolveSpeechGeneratorInLanguageCodeInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInLanguageCode(value as unknown as Exclude<SpeechGeneratorNodeWriteData['in_language_code'], undefined>)
        return { field: 'in_language_code', value, written }
      }
      default:
        throw new Error(`Unknown input port ${targetHandle} for SpeechGeneratorCanvasNode`)
    }
  }
}

export class StoryDirectionPreviewCanvasNode extends GeneratedCanvasNode<StoryDirectionPreviewNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  get(key: 'type'): "storyDirectionPreview" | undefined
  get(key: 'premise'): StoryDirectionFieldDictYMap | undefined
  get(key: 'tone'): StoryDirectionFieldDictYMap | undefined
  get(key: 'hook'): StoryDirectionFieldDictYMap | undefined
  get(key: 'structure'): StoryDirectionFieldDictYMap | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'premise': return _readYDocOptionalMapWrapper(this._raw.get('premise'), StoryDirectionFieldDictYMap, "storyDirectionPreview.premise")
      case 'tone': return _readYDocOptionalMapWrapper(this._raw.get('tone'), StoryDirectionFieldDictYMap, "storyDirectionPreview.tone")
      case 'hook': return _readYDocOptionalMapWrapper(this._raw.get('hook'), StoryDirectionFieldDictYMap, "storyDirectionPreview.hook")
      case 'structure': return _readYDocOptionalMapWrapper(this._raw.get('structure'), StoryDirectionFieldDictYMap, "storyDirectionPreview.structure")
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "premise" | "tone" | "hook" | "structure" | "revision"): void { this._raw.delete(key) }
  has(key: "type" | "premise" | "tone" | "hook" | "structure" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<StoryDirectionPreviewNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this._writeDataField(field as keyof StoryDirectionPreviewNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof StoryDirectionPreviewNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'premise': return this.writePremise(value as Exclude<StoryDirectionPreviewNodeWriteData['premise'], undefined>, opts)
      case 'tone': return this.writeTone(value as Exclude<StoryDirectionPreviewNodeWriteData['tone'], undefined>, opts)
      case 'hook': return this.writeHook(value as Exclude<StoryDirectionPreviewNodeWriteData['hook'], undefined>, opts)
      case 'structure': return this.writeStructure(value as Exclude<StoryDirectionPreviewNodeWriteData['structure'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writePremise(value: Exclude<StoryDirectionPreviewNodeWriteData['premise'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('premise', 'map', value, opts, false, undefined, undefined)
  }

  writeTone(value: Exclude<StoryDirectionPreviewNodeWriteData['tone'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('tone', 'map', value, opts, false, undefined, undefined)
  }

  writeHook(value: Exclude<StoryDirectionPreviewNodeWriteData['hook'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('hook', 'map', value, opts, false, undefined, undefined)
  }

  writeStructure(value: Exclude<StoryDirectionPreviewNodeWriteData['structure'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('structure', 'map', value, opts, false, undefined, undefined)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolveStoryDirectionPreviewInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    void nodes
    void edgeRefs
    switch (targetHandle) {
      default:
        throw new Error(`Unknown input port ${targetHandle} for StoryDirectionPreviewCanvasNode`)
    }
  }
}

export class StoryboardDesignerCanvasNode extends GeneratedCanvasNode<StoryboardDesignerNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  get(key: 'type'): "storyboardDesigner" | undefined
  get(key: 'in_script'): string | undefined
  get(key: 'in_characters'): Array<ImageAssetRefDictYMap | null> | undefined
  get(key: 'in_character_names'): Array<string | null> | undefined
  get(key: 'in_locations'): Array<ImageAssetRefDictYMap | null> | undefined
  get(key: 'in_location_names'): Array<string | null> | undefined
  get(key: 'in_objects'): Array<ImageAssetRefDictYMap | null> | undefined
  get(key: 'in_object_names'): Array<string | null> | undefined
  get(key: 'in_image'): ImageAssetRefDictYMap | undefined
  get(key: 'in_style'): string | undefined
  get(key: 'in_panel_count'): number | undefined
  get(key: 'in_shot_count'): number | undefined
  get(key: 'in_aspect_ratio'): string | undefined
  get(key: 'in_scene_id'): string | undefined
  get(key: 'in_name'): string | undefined
  get(key: 'in_location'): string | undefined
  get(key: 'in_model'): string | undefined
  get(key: 'in_feedback'): string | undefined
  get(key: 'in_vlm_validation'): boolean | undefined
  get(key: 'in_video_anchors'): Array<ShotVideoAnchorDictYMap> | undefined
  get(key: 'out_image'): GeneratedImageWithHistoryYMap | undefined
  get(key: 'out_grid_images'): Array<ImageAssetRefDictYMap> | undefined
  get(key: 'out_metadata'): StoryboardMetadataDictYMap | undefined
  get(key: 'out_beats'): Array<string> | undefined
  get(key: 'out_shots'): Array<GeneratedShotRowV2DictYMap> | undefined
  get(key: 'out_shot_seams'): Array<ShotSeamDictYMap> | undefined
  get(key: 'out_production_plan'): ShotProductionPlanDictYMap | undefined
  get(key: 'out_video_generation_plan'): ShotVideoGenerationPlanDictYMap | undefined
  get(key: 'out_video_previous_plan'): ShotVideoGenerationPlanDictYMap | undefined
  get(key: 'out_start_frames'): Array<ImageAssetRefDictYMap> | undefined
  get(key: 'out_key_frames'): Array<ImageAssetRefDictYMap> | undefined
  get(key: 'out_end_frames'): Array<ImageAssetRefDictYMap> | undefined
  get(key: 'out_start_frame_prompts'): Array<string> | undefined
  get(key: 'out_key_frame_prompts'): Array<string> | undefined
  get(key: 'out_end_frame_prompts'): Array<string> | undefined
  get(key: 'out_frame_links'): Array<ShotFrameLinkDictYMap> | undefined
  get(key: 'out_panel_refs'): Array<Array<string>> | undefined
  get(key: 'out_images'): Array<ImageAssetRefDictYMap> | undefined
  get(key: 'out_grid_descriptions'): Array<string> | undefined
  get(key: 'out_vlm_report'): VlmValidationReportDictYMap | undefined
  get(key: 'shot_guidance_kind'): string | undefined
  get(key: 'shot_guidance_fingerprint'): string | undefined
  get(key: 'shot_guidance_warning'): string | undefined
  get(key: 'batch_pending'): number | undefined
  get(key: 'storyboard_view'): string | undefined
  get(key: 'shot_list_planner_version'): number | undefined
  get(key: 'storyboard_mode'): string | undefined
  get(key: 'shot_list'): Array<ShotListRowDictYMap> | undefined
  get(key: 'shot_key_frame_relinks'): Array<ShotKeyFrameRelinkDictYMap> | undefined
  get(key: 'name_autogen'): string | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'in_script': return _readYDocOptionalString(this._raw.get('in_script'), "storyboardDesigner.in_script")
      case 'in_characters': return _readYDocOptionalArray(this._raw.get('in_characters'), "storyboardDesigner.in_characters", (item, itemLabel) => item == null ? null : _readYDocMapWrapper(item, ImageAssetRefDictYMap, itemLabel))
      case 'in_character_names': return _readYDocOptionalArray(this._raw.get('in_character_names'), "storyboardDesigner.in_character_names", (item, itemLabel) => item == null ? null : _readYDocString(item, itemLabel))
      case 'in_locations': return _readYDocOptionalArray(this._raw.get('in_locations'), "storyboardDesigner.in_locations", (item, itemLabel) => item == null ? null : _readYDocMapWrapper(item, ImageAssetRefDictYMap, itemLabel))
      case 'in_location_names': return _readYDocOptionalArray(this._raw.get('in_location_names'), "storyboardDesigner.in_location_names", (item, itemLabel) => item == null ? null : _readYDocString(item, itemLabel))
      case 'in_objects': return _readYDocOptionalArray(this._raw.get('in_objects'), "storyboardDesigner.in_objects", (item, itemLabel) => item == null ? null : _readYDocMapWrapper(item, ImageAssetRefDictYMap, itemLabel))
      case 'in_object_names': return _readYDocOptionalArray(this._raw.get('in_object_names'), "storyboardDesigner.in_object_names", (item, itemLabel) => item == null ? null : _readYDocString(item, itemLabel))
      case 'in_image': return _readYDocOptionalMapWrapper(this._raw.get('in_image'), ImageAssetRefDictYMap, "storyboardDesigner.in_image")
      case 'in_style': return _readYDocOptionalString(this._raw.get('in_style'), "storyboardDesigner.in_style")
      case 'in_panel_count': return _readYDocOptionalNumber(this._raw.get('in_panel_count'), "storyboardDesigner.in_panel_count")
      case 'in_shot_count': return _readYDocOptionalNumber(this._raw.get('in_shot_count'), "storyboardDesigner.in_shot_count")
      case 'in_aspect_ratio': return _readYDocOptionalString(this._raw.get('in_aspect_ratio'), "storyboardDesigner.in_aspect_ratio")
      case 'in_scene_id': return _readYDocOptionalString(this._raw.get('in_scene_id'), "storyboardDesigner.in_scene_id")
      case 'in_name': return _readYDocOptionalString(this._raw.get('in_name'), "storyboardDesigner.in_name")
      case 'in_location': return _readYDocOptionalString(this._raw.get('in_location'), "storyboardDesigner.in_location")
      case 'in_model': return _readYDocOptionalString(this._raw.get('in_model'), "storyboardDesigner.in_model")
      case 'in_feedback': return _readYDocOptionalString(this._raw.get('in_feedback'), "storyboardDesigner.in_feedback")
      case 'in_vlm_validation': return _readYDocOptionalBoolean(this._raw.get('in_vlm_validation'), "storyboardDesigner.in_vlm_validation")
      case 'in_video_anchors': return _readYDocOptionalArray(this._raw.get('in_video_anchors'), "storyboardDesigner.in_video_anchors", (item, itemLabel) => _readYDocMapWrapper(item, ShotVideoAnchorDictYMap, itemLabel))
      case 'out_image': return _readYDocOptionalMapWrapper(this._raw.get('out_image'), GeneratedImageWithHistoryYMap, "storyboardDesigner.out_image")
      case 'out_grid_images': return _readYDocOptionalArray(this._raw.get('out_grid_images'), "storyboardDesigner.out_grid_images", (item, itemLabel) => _readYDocMapWrapper(item, ImageAssetRefDictYMap, itemLabel))
      case 'out_metadata': return _readYDocOptionalMapWrapper(this._raw.get('out_metadata'), StoryboardMetadataDictYMap, "storyboardDesigner.out_metadata")
      case 'out_beats': return _readYDocOptionalArray(this._raw.get('out_beats'), "storyboardDesigner.out_beats", (item, itemLabel) => _readYDocString(item, itemLabel))
      case 'out_shots': return _readYDocOptionalArray(this._raw.get('out_shots'), "storyboardDesigner.out_shots", (item, itemLabel) => _readYDocMapWrapper(item, GeneratedShotRowV2DictYMap, itemLabel))
      case 'out_shot_seams': return _readYDocOptionalArray(this._raw.get('out_shot_seams'), "storyboardDesigner.out_shot_seams", (item, itemLabel) => _readYDocMapWrapper(item, ShotSeamDictYMap, itemLabel))
      case 'out_production_plan': return _readYDocOptionalMapWrapper(this._raw.get('out_production_plan'), ShotProductionPlanDictYMap, "storyboardDesigner.out_production_plan")
      case 'out_video_generation_plan': return _readYDocOptionalMapWrapper(this._raw.get('out_video_generation_plan'), ShotVideoGenerationPlanDictYMap, "storyboardDesigner.out_video_generation_plan")
      case 'out_video_previous_plan': return _readYDocOptionalMapWrapper(this._raw.get('out_video_previous_plan'), ShotVideoGenerationPlanDictYMap, "storyboardDesigner.out_video_previous_plan")
      case 'out_start_frames': return _readYDocOptionalArray(this._raw.get('out_start_frames'), "storyboardDesigner.out_start_frames", (item, itemLabel) => _readYDocMapWrapper(item, ImageAssetRefDictYMap, itemLabel))
      case 'out_key_frames': return _readYDocOptionalArray(this._raw.get('out_key_frames'), "storyboardDesigner.out_key_frames", (item, itemLabel) => _readYDocMapWrapper(item, ImageAssetRefDictYMap, itemLabel))
      case 'out_end_frames': return _readYDocOptionalArray(this._raw.get('out_end_frames'), "storyboardDesigner.out_end_frames", (item, itemLabel) => _readYDocMapWrapper(item, ImageAssetRefDictYMap, itemLabel))
      case 'out_start_frame_prompts': return _readYDocOptionalArray(this._raw.get('out_start_frame_prompts'), "storyboardDesigner.out_start_frame_prompts", (item, itemLabel) => _readYDocString(item, itemLabel))
      case 'out_key_frame_prompts': return _readYDocOptionalArray(this._raw.get('out_key_frame_prompts'), "storyboardDesigner.out_key_frame_prompts", (item, itemLabel) => _readYDocString(item, itemLabel))
      case 'out_end_frame_prompts': return _readYDocOptionalArray(this._raw.get('out_end_frame_prompts'), "storyboardDesigner.out_end_frame_prompts", (item, itemLabel) => _readYDocString(item, itemLabel))
      case 'out_frame_links': return _readYDocOptionalArray(this._raw.get('out_frame_links'), "storyboardDesigner.out_frame_links", (item, itemLabel) => _readYDocMapWrapper(item, ShotFrameLinkDictYMap, itemLabel))
      case 'out_panel_refs': return _readYDocOptionalArray(this._raw.get('out_panel_refs'), "storyboardDesigner.out_panel_refs", (item, itemLabel) => _readYDocArray(item, itemLabel, (item, itemLabel) => _readYDocString(item, itemLabel)))
      case 'out_images': return _readYDocOptionalArray(this._raw.get('out_images'), "storyboardDesigner.out_images", (item, itemLabel) => _readYDocMapWrapper(item, ImageAssetRefDictYMap, itemLabel))
      case 'out_grid_descriptions': return _readYDocOptionalArray(this._raw.get('out_grid_descriptions'), "storyboardDesigner.out_grid_descriptions", (item, itemLabel) => _readYDocString(item, itemLabel))
      case 'out_vlm_report': return _readYDocOptionalMapWrapper(this._raw.get('out_vlm_report'), VlmValidationReportDictYMap, "storyboardDesigner.out_vlm_report")
      case 'shot_guidance_kind': return _readYDocOptionalString(this._raw.get('shot_guidance_kind'), "storyboardDesigner.shot_guidance_kind")
      case 'shot_guidance_fingerprint': return _readYDocOptionalString(this._raw.get('shot_guidance_fingerprint'), "storyboardDesigner.shot_guidance_fingerprint")
      case 'shot_guidance_warning': return _readYDocOptionalString(this._raw.get('shot_guidance_warning'), "storyboardDesigner.shot_guidance_warning")
      case 'batch_pending': return _readYDocOptionalNumber(this._raw.get('batch_pending'), "storyboardDesigner.batch_pending")
      case 'storyboard_view': return _readYDocOptionalString(this._raw.get('storyboard_view'), "storyboardDesigner.storyboard_view")
      case 'shot_list_planner_version': return _readYDocOptionalNumber(this._raw.get('shot_list_planner_version'), "storyboardDesigner.shot_list_planner_version")
      case 'storyboard_mode': return _readYDocOptionalString(this._raw.get('storyboard_mode'), "storyboardDesigner.storyboard_mode")
      case 'shot_list': return _readYDocOptionalArray(this._raw.get('shot_list'), "storyboardDesigner.shot_list", (item, itemLabel) => _readYDocMapWrapper(item, ShotListRowDictYMap, itemLabel))
      case 'shot_key_frame_relinks': return _readYDocOptionalArray(this._raw.get('shot_key_frame_relinks'), "storyboardDesigner.shot_key_frame_relinks", (item, itemLabel) => _readYDocMapWrapper(item, ShotKeyFrameRelinkDictYMap, itemLabel))
      case 'name_autogen': return _readYDocOptionalString(this._raw.get('name_autogen'), "storyboardDesigner.name_autogen")
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "in_script" | "in_characters" | "in_character_names" | "in_locations" | "in_location_names" | "in_objects" | "in_object_names" | "in_image" | "in_style" | "in_panel_count" | "in_shot_count" | "in_aspect_ratio" | "in_scene_id" | "in_name" | "in_location" | "in_model" | "in_feedback" | "in_vlm_validation" | "in_video_anchors" | "out_image" | "out_grid_images" | "out_metadata" | "out_beats" | "out_shots" | "out_shot_seams" | "out_production_plan" | "out_video_generation_plan" | "out_video_previous_plan" | "out_start_frames" | "out_key_frames" | "out_end_frames" | "out_start_frame_prompts" | "out_key_frame_prompts" | "out_end_frame_prompts" | "out_frame_links" | "out_panel_refs" | "out_images" | "out_grid_descriptions" | "out_vlm_report" | "shot_guidance_kind" | "shot_guidance_fingerprint" | "shot_guidance_warning" | "batch_pending" | "storyboard_view" | "shot_list_planner_version" | "storyboard_mode" | "shot_list" | "shot_key_frame_relinks" | "name_autogen" | "revision"): void { this._raw.delete(key) }
  has(key: "type" | "in_script" | "in_characters" | "in_character_names" | "in_locations" | "in_location_names" | "in_objects" | "in_object_names" | "in_image" | "in_style" | "in_panel_count" | "in_shot_count" | "in_aspect_ratio" | "in_scene_id" | "in_name" | "in_location" | "in_model" | "in_feedback" | "in_vlm_validation" | "in_video_anchors" | "out_image" | "out_grid_images" | "out_metadata" | "out_beats" | "out_shots" | "out_shot_seams" | "out_production_plan" | "out_video_generation_plan" | "out_video_previous_plan" | "out_start_frames" | "out_key_frames" | "out_end_frames" | "out_start_frame_prompts" | "out_key_frame_prompts" | "out_end_frame_prompts" | "out_frame_links" | "out_panel_refs" | "out_images" | "out_grid_descriptions" | "out_vlm_report" | "shot_guidance_kind" | "shot_guidance_fingerprint" | "shot_guidance_warning" | "batch_pending" | "storyboard_view" | "shot_list_planner_version" | "storyboard_mode" | "shot_list" | "shot_key_frame_relinks" | "name_autogen" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<StoryboardDesignerNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this._writeDataField(field as keyof StoryboardDesignerNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof StoryboardDesignerNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'in_script': return this.writeInScript(value as Exclude<StoryboardDesignerNodeWriteData['in_script'], undefined>, opts)
      case 'in_characters': return this.writeInCharacters(value as Exclude<StoryboardDesignerNodeWriteData['in_characters'], undefined>, opts)
      case 'in_character_names': return this.writeInCharacterNames(value as Exclude<StoryboardDesignerNodeWriteData['in_character_names'], undefined>, opts)
      case 'in_locations': return this.writeInLocations(value as Exclude<StoryboardDesignerNodeWriteData['in_locations'], undefined>, opts)
      case 'in_location_names': return this.writeInLocationNames(value as Exclude<StoryboardDesignerNodeWriteData['in_location_names'], undefined>, opts)
      case 'in_objects': return this.writeInObjects(value as Exclude<StoryboardDesignerNodeWriteData['in_objects'], undefined>, opts)
      case 'in_object_names': return this.writeInObjectNames(value as Exclude<StoryboardDesignerNodeWriteData['in_object_names'], undefined>, opts)
      case 'in_image': return this.writeInImage(value as Exclude<StoryboardDesignerNodeWriteData['in_image'], undefined>, opts)
      case 'in_style': return this.writeInStyle(value as Exclude<StoryboardDesignerNodeWriteData['in_style'], undefined>, opts)
      case 'in_panel_count': return this.writeInPanelCount(value as Exclude<StoryboardDesignerNodeWriteData['in_panel_count'], undefined>, opts)
      case 'in_shot_count': return this.writeInShotCount(value as Exclude<StoryboardDesignerNodeWriteData['in_shot_count'], undefined>, opts)
      case 'in_aspect_ratio': return this.writeInAspectRatio(value as Exclude<StoryboardDesignerNodeWriteData['in_aspect_ratio'], undefined>, opts)
      case 'in_scene_id': return this.writeInSceneId(value as Exclude<StoryboardDesignerNodeWriteData['in_scene_id'], undefined>, opts)
      case 'in_name': return this.writeInName(value as Exclude<StoryboardDesignerNodeWriteData['in_name'], undefined>, opts)
      case 'in_location': return this.writeInLocation(value as Exclude<StoryboardDesignerNodeWriteData['in_location'], undefined>, opts)
      case 'in_model': return this.writeInModel(value as Exclude<StoryboardDesignerNodeWriteData['in_model'], undefined>, opts)
      case 'in_feedback': return this.writeInFeedback(value as Exclude<StoryboardDesignerNodeWriteData['in_feedback'], undefined>, opts)
      case 'in_vlm_validation': return this.writeInVlmValidation(value as Exclude<StoryboardDesignerNodeWriteData['in_vlm_validation'], undefined>, opts)
      case 'in_video_anchors': return this.writeInVideoAnchors(value as Exclude<StoryboardDesignerNodeWriteData['in_video_anchors'], undefined>, opts)
      case 'out_image': return this.writeOutImage(value as Exclude<StoryboardDesignerNodeWriteData['out_image'], undefined>, opts)
      case 'out_grid_images': return this.writeOutGridImages(value as Exclude<StoryboardDesignerNodeWriteData['out_grid_images'], undefined>, opts)
      case 'out_metadata': return this.writeOutMetadata(value as Exclude<StoryboardDesignerNodeWriteData['out_metadata'], undefined>, opts)
      case 'out_beats': return this.writeOutBeats(value as Exclude<StoryboardDesignerNodeWriteData['out_beats'], undefined>, opts)
      case 'out_shots': return this.writeOutShots(value as Exclude<StoryboardDesignerNodeWriteData['out_shots'], undefined>, opts)
      case 'out_shot_seams': return this.writeOutShotSeams(value as Exclude<StoryboardDesignerNodeWriteData['out_shot_seams'], undefined>, opts)
      case 'out_production_plan': return this.writeOutProductionPlan(value as Exclude<StoryboardDesignerNodeWriteData['out_production_plan'], undefined>, opts)
      case 'out_video_generation_plan': return this.writeOutVideoGenerationPlan(value as Exclude<StoryboardDesignerNodeWriteData['out_video_generation_plan'], undefined>, opts)
      case 'out_video_previous_plan': return this.writeOutVideoPreviousPlan(value as Exclude<StoryboardDesignerNodeWriteData['out_video_previous_plan'], undefined>, opts)
      case 'out_start_frames': return this.writeOutStartFrames(value as Exclude<StoryboardDesignerNodeWriteData['out_start_frames'], undefined>, opts)
      case 'out_key_frames': return this.writeOutKeyFrames(value as Exclude<StoryboardDesignerNodeWriteData['out_key_frames'], undefined>, opts)
      case 'out_end_frames': return this.writeOutEndFrames(value as Exclude<StoryboardDesignerNodeWriteData['out_end_frames'], undefined>, opts)
      case 'out_start_frame_prompts': return this.writeOutStartFramePrompts(value as Exclude<StoryboardDesignerNodeWriteData['out_start_frame_prompts'], undefined>, opts)
      case 'out_key_frame_prompts': return this.writeOutKeyFramePrompts(value as Exclude<StoryboardDesignerNodeWriteData['out_key_frame_prompts'], undefined>, opts)
      case 'out_end_frame_prompts': return this.writeOutEndFramePrompts(value as Exclude<StoryboardDesignerNodeWriteData['out_end_frame_prompts'], undefined>, opts)
      case 'out_frame_links': return this.writeOutFrameLinks(value as Exclude<StoryboardDesignerNodeWriteData['out_frame_links'], undefined>, opts)
      case 'out_panel_refs': return this.writeOutPanelRefs(value as Exclude<StoryboardDesignerNodeWriteData['out_panel_refs'], undefined>, opts)
      case 'out_images': return this.writeOutImages(value as Exclude<StoryboardDesignerNodeWriteData['out_images'], undefined>, opts)
      case 'out_grid_descriptions': return this.writeOutGridDescriptions(value as Exclude<StoryboardDesignerNodeWriteData['out_grid_descriptions'], undefined>, opts)
      case 'out_vlm_report': return this.writeOutVlmReport(value as Exclude<StoryboardDesignerNodeWriteData['out_vlm_report'], undefined>, opts)
      case 'shot_guidance_kind': return this.writeShotGuidanceKind(value as Exclude<StoryboardDesignerNodeWriteData['shot_guidance_kind'], undefined>, opts)
      case 'shot_guidance_fingerprint': return this.writeShotGuidanceFingerprint(value as Exclude<StoryboardDesignerNodeWriteData['shot_guidance_fingerprint'], undefined>, opts)
      case 'shot_guidance_warning': return this.writeShotGuidanceWarning(value as Exclude<StoryboardDesignerNodeWriteData['shot_guidance_warning'], undefined>, opts)
      case 'batch_pending': return this.writeBatchPending(value as Exclude<StoryboardDesignerNodeWriteData['batch_pending'], undefined>, opts)
      case 'storyboard_view': return this.writeStoryboardView(value as Exclude<StoryboardDesignerNodeWriteData['storyboard_view'], undefined>, opts)
      case 'shot_list_planner_version': return this.writeShotListPlannerVersion(value as Exclude<StoryboardDesignerNodeWriteData['shot_list_planner_version'], undefined>, opts)
      case 'storyboard_mode': return this.writeStoryboardMode(value as Exclude<StoryboardDesignerNodeWriteData['storyboard_mode'], undefined>, opts)
      case 'shot_list': return this.writeShotList(value as Exclude<StoryboardDesignerNodeWriteData['shot_list'], undefined>, opts)
      case 'shot_key_frame_relinks': return this.writeShotKeyFrameRelinks(value as Exclude<StoryboardDesignerNodeWriteData['shot_key_frame_relinks'], undefined>, opts)
      case 'name_autogen': return this.writeNameAutogen(value as Exclude<StoryboardDesignerNodeWriteData['name_autogen'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writeInScript(value: Exclude<StoryboardDesignerNodeWriteData['in_script'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_script', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInCharacters(value: Exclude<StoryboardDesignerNodeWriteData['in_characters'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_characters', 'array', value, opts, false, undefined, undefined)
  }

  writeInCharacterNames(value: Exclude<StoryboardDesignerNodeWriteData['in_character_names'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_character_names', 'array', value, opts, false, undefined, undefined)
  }

  writeInLocations(value: Exclude<StoryboardDesignerNodeWriteData['in_locations'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_locations', 'array', value, opts, false, undefined, undefined)
  }

  writeInLocationNames(value: Exclude<StoryboardDesignerNodeWriteData['in_location_names'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_location_names', 'array', value, opts, false, undefined, undefined)
  }

  writeInObjects(value: Exclude<StoryboardDesignerNodeWriteData['in_objects'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_objects', 'array', value, opts, false, undefined, undefined)
  }

  writeInObjectNames(value: Exclude<StoryboardDesignerNodeWriteData['in_object_names'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_object_names', 'array', value, opts, false, undefined, undefined)
  }

  writeInImage(value: Exclude<StoryboardDesignerNodeWriteData['in_image'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_image', 'map', value, opts, false, undefined, undefined)
  }

  writeInStyle(value: Exclude<StoryboardDesignerNodeWriteData['in_style'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_style', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInPanelCount(value: Exclude<StoryboardDesignerNodeWriteData['in_panel_count'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_panel_count', 'primitive', value, opts, false, 'number', undefined)
  }

  writeInShotCount(value: Exclude<StoryboardDesignerNodeWriteData['in_shot_count'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_shot_count', 'primitive', value, opts, false, 'number', undefined)
  }

  writeInAspectRatio(value: Exclude<StoryboardDesignerNodeWriteData['in_aspect_ratio'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_aspect_ratio', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInSceneId(value: Exclude<StoryboardDesignerNodeWriteData['in_scene_id'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_scene_id', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInName(value: Exclude<StoryboardDesignerNodeWriteData['in_name'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_name', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInLocation(value: Exclude<StoryboardDesignerNodeWriteData['in_location'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_location', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInModel(value: Exclude<StoryboardDesignerNodeWriteData['in_model'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_model', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInFeedback(value: Exclude<StoryboardDesignerNodeWriteData['in_feedback'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_feedback', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInVlmValidation(value: Exclude<StoryboardDesignerNodeWriteData['in_vlm_validation'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_vlm_validation', 'primitive', value, opts, false, 'boolean', undefined)
  }

  writeInVideoAnchors(value: Exclude<StoryboardDesignerNodeWriteData['in_video_anchors'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_video_anchors', 'array', value, opts, false, undefined, undefined)
  }

  replaceInVideoAnchorsEntry(key: Pick<ShotVideoAnchorDict, "shot_id" | "role">, value?: ShotVideoAnchorDict): void {
    const fieldLabel = 'in_video_anchors entry'
    if (value !== undefined) {
      const validationValue = _attachYDocValidationCandidate(value)
      _validateYDocMap(validationValue, fieldLabel, _YDOC_MAP_SPEC_0)
      if (value.exact === false) throw new Error(`${fieldLabel}: only exact anchors can be relinked`)
      if (value.shot_id !== key.shot_id) throw new Error(`${fieldLabel}: key mismatch`)
      if (value.role !== key.role) throw new Error(`${fieldLabel}: key mismatch`)
    }
    let array = this._raw.get('in_video_anchors')
    if (array === undefined) {
      array = new Y.Array<YDocValue>()
      this._raw.set('in_video_anchors', array)
    }
    if (!(array instanceof Y.Array)) throw new Error(`${fieldLabel}: invalid array storage`)
    let insertAt = array.length
    for (let index = array.length - 1; index >= 0; index--) {
      const existing = array.get(index)
      if (!(existing instanceof Y.Map)) throw new Error(`${fieldLabel}: invalid entry storage`)
      if (existing.get('shot_id') === key.shot_id && existing.get('role') === key.role && existing.get('exact') !== false) { array.delete(index, 1); insertAt = index }
    }
    if (value !== undefined) array.insert(insertAt, [_toYDocValue(value)])
  }

  writeOutImage(value: Exclude<StoryboardDesignerNodeWriteData['out_image'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_image', 'map', value, opts, false, undefined, undefined)
  }

  writeOutGridImages(value: Exclude<StoryboardDesignerNodeWriteData['out_grid_images'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_grid_images', 'array', value, opts, false, undefined, undefined)
  }

  writeOutMetadata(value: Exclude<StoryboardDesignerNodeWriteData['out_metadata'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_metadata', 'map', value, opts, false, undefined, undefined)
  }

  writeOutBeats(value: Exclude<StoryboardDesignerNodeWriteData['out_beats'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_beats', 'array', value, opts, false, undefined, undefined)
  }

  writeOutShots(value: Exclude<StoryboardDesignerNodeWriteData['out_shots'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_shots', 'array', value, opts, false, undefined, undefined)
  }

  writeOutShotSeams(value: Exclude<StoryboardDesignerNodeWriteData['out_shot_seams'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_shot_seams', 'array', value, opts, false, undefined, undefined)
  }

  writeOutProductionPlan(value: Exclude<StoryboardDesignerNodeWriteData['out_production_plan'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_production_plan', 'map', value, opts, false, undefined, undefined)
  }

  writeOutVideoGenerationPlan(value: Exclude<StoryboardDesignerNodeWriteData['out_video_generation_plan'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_video_generation_plan', 'map', value, opts, false, undefined, _validateYDocShotVideoGenerationPlanDict)
  }

  writeOutVideoPreviousPlan(value: Exclude<StoryboardDesignerNodeWriteData['out_video_previous_plan'], undefined> | ShotVideoGenerationPlanDictYMap, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_video_previous_plan', 'map', value, opts, false, undefined, _validateYDocShotVideoGenerationPlanDict)
  }

  writeOutStartFrames(value: Exclude<StoryboardDesignerNodeWriteData['out_start_frames'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_start_frames', 'array', value, opts, false, undefined, undefined)
  }

  writeOutKeyFrames(value: Exclude<StoryboardDesignerNodeWriteData['out_key_frames'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_key_frames', 'array', value, opts, false, undefined, undefined)
  }

  writeOutEndFrames(value: Exclude<StoryboardDesignerNodeWriteData['out_end_frames'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_end_frames', 'array', value, opts, false, undefined, undefined)
  }

  writeOutStartFramePrompts(value: Exclude<StoryboardDesignerNodeWriteData['out_start_frame_prompts'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_start_frame_prompts', 'array', value, opts, false, undefined, undefined)
  }

  writeOutKeyFramePrompts(value: Exclude<StoryboardDesignerNodeWriteData['out_key_frame_prompts'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_key_frame_prompts', 'array', value, opts, false, undefined, undefined)
  }

  writeOutEndFramePrompts(value: Exclude<StoryboardDesignerNodeWriteData['out_end_frame_prompts'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_end_frame_prompts', 'array', value, opts, false, undefined, undefined)
  }

  writeOutFrameLinks(value: Exclude<StoryboardDesignerNodeWriteData['out_frame_links'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_frame_links', 'array', value, opts, false, undefined, undefined)
  }

  writeOutPanelRefs(value: Exclude<StoryboardDesignerNodeWriteData['out_panel_refs'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_panel_refs', 'array', value, opts, false, undefined, undefined)
  }

  writeOutImages(value: Exclude<StoryboardDesignerNodeWriteData['out_images'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_images', 'array', value, opts, false, undefined, undefined)
  }

  writeOutGridDescriptions(value: Exclude<StoryboardDesignerNodeWriteData['out_grid_descriptions'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_grid_descriptions', 'array', value, opts, false, undefined, undefined)
  }

  writeOutVlmReport(value: Exclude<StoryboardDesignerNodeWriteData['out_vlm_report'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_vlm_report', 'map', value, opts, false, undefined, undefined)
  }

  writeShotGuidanceKind(value: Exclude<StoryboardDesignerNodeWriteData['shot_guidance_kind'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('shot_guidance_kind', 'primitive', value, opts, false, 'string', undefined)
  }

  writeShotGuidanceFingerprint(value: Exclude<StoryboardDesignerNodeWriteData['shot_guidance_fingerprint'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('shot_guidance_fingerprint', 'primitive', value, opts, false, 'string', undefined)
  }

  writeShotGuidanceWarning(value: Exclude<StoryboardDesignerNodeWriteData['shot_guidance_warning'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('shot_guidance_warning', 'primitive', value, opts, false, 'string', undefined)
  }

  writeBatchPending(value: Exclude<StoryboardDesignerNodeWriteData['batch_pending'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('batch_pending', 'primitive', value, opts, false, 'number', undefined)
  }

  writeStoryboardView(value: Exclude<StoryboardDesignerNodeWriteData['storyboard_view'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('storyboard_view', 'primitive', value, opts, false, 'string', undefined)
  }

  writeShotListPlannerVersion(value: Exclude<StoryboardDesignerNodeWriteData['shot_list_planner_version'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('shot_list_planner_version', 'primitive', value, opts, false, 'number', undefined)
  }

  writeStoryboardMode(value: Exclude<StoryboardDesignerNodeWriteData['storyboard_mode'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('storyboard_mode', 'primitive', value, opts, false, 'string', undefined)
  }

  writeShotList(value: Exclude<StoryboardDesignerNodeWriteData['shot_list'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('shot_list', 'array', value, opts, false, undefined, undefined)
  }

  writeShotKeyFrameRelinks(value: Exclude<StoryboardDesignerNodeWriteData['shot_key_frame_relinks'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('shot_key_frame_relinks', 'array', value, opts, false, undefined, undefined)
  }

  replaceShotKeyFrameRelinksEntry(key: Pick<ShotKeyFrameRelinkDict, "shot_id">, value?: ShotKeyFrameRelinkDict): void {
    const fieldLabel = 'shot_key_frame_relinks entry'
    if (value !== undefined) {
      const validationValue = _attachYDocValidationCandidate(value)
      _validateYDocMap(validationValue, fieldLabel, _YDOC_MAP_SPEC_1)
      if (value.shot_id !== key.shot_id) throw new Error(`${fieldLabel}: key mismatch`)
    }
    let array = this._raw.get('shot_key_frame_relinks')
    if (array === undefined) {
      array = new Y.Array<YDocValue>()
      this._raw.set('shot_key_frame_relinks', array)
    }
    if (!(array instanceof Y.Array)) throw new Error(`${fieldLabel}: invalid array storage`)
    let insertAt = array.length
    for (let index = array.length - 1; index >= 0; index--) {
      const existing = array.get(index)
      if (!(existing instanceof Y.Map)) throw new Error(`${fieldLabel}: invalid entry storage`)
      if (existing.get('shot_id') === key.shot_id) { array.delete(index, 1); insertAt = index }
    }
    if (value !== undefined) array.insert(insertAt, [_toYDocValue(value)])
  }

  writeNameAutogen(value: Exclude<StoryboardDesignerNodeWriteData['name_autogen'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('name_autogen', 'primitive', value, opts, false, 'string', undefined)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolveStoryboardDesignerInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    switch (targetHandle) {
      case 'in_script': {
        const value = _resolveStoryboardDesignerInScriptInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInScript(value as unknown as Exclude<StoryboardDesignerNodeWriteData['in_script'], undefined>)
        return { field: 'in_script', value, written }
      }
      case 'in_characters': {
        const value = _resolveStoryboardDesignerInCharactersInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_characters')
        if (hadPersistedValue) this.delete('in_characters')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_characters', value, written }
      }
      case 'in_character_names': {
        const value = _resolveStoryboardDesignerInCharacterNamesInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInCharacterNames(value as unknown as Exclude<StoryboardDesignerNodeWriteData['in_character_names'], undefined>)
        return { field: 'in_character_names', value, written }
      }
      case 'in_locations': {
        const value = _resolveStoryboardDesignerInLocationsInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_locations')
        if (hadPersistedValue) this.delete('in_locations')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_locations', value, written }
      }
      case 'in_location_names': {
        const value = _resolveStoryboardDesignerInLocationNamesInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInLocationNames(value as unknown as Exclude<StoryboardDesignerNodeWriteData['in_location_names'], undefined>)
        return { field: 'in_location_names', value, written }
      }
      case 'in_objects': {
        const value = _resolveStoryboardDesignerInObjectsInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_objects')
        if (hadPersistedValue) this.delete('in_objects')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_objects', value, written }
      }
      case 'in_object_names': {
        const value = _resolveStoryboardDesignerInObjectNamesInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInObjectNames(value as unknown as Exclude<StoryboardDesignerNodeWriteData['in_object_names'], undefined>)
        return { field: 'in_object_names', value, written }
      }
      case 'in_image': {
        const value = _resolveStoryboardDesignerInImageInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_image')
        if (hadPersistedValue) this.delete('in_image')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_image', value, written }
      }
      case 'in_style': {
        const value = _resolveStoryboardDesignerInStyleInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInStyle(value as unknown as Exclude<StoryboardDesignerNodeWriteData['in_style'], undefined>)
        return { field: 'in_style', value, written }
      }
      case 'in_panel_count': {
        const value = _resolveStoryboardDesignerInPanelCountInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInPanelCount(value as unknown as Exclude<StoryboardDesignerNodeWriteData['in_panel_count'], undefined>)
        return { field: 'in_panel_count', value, written }
      }
      case 'in_shot_count': {
        const value = _resolveStoryboardDesignerInShotCountInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInShotCount(value as unknown as Exclude<StoryboardDesignerNodeWriteData['in_shot_count'], undefined>)
        return { field: 'in_shot_count', value, written }
      }
      case 'in_aspect_ratio': {
        const value = _resolveStoryboardDesignerInAspectRatioInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInAspectRatio(value as unknown as Exclude<StoryboardDesignerNodeWriteData['in_aspect_ratio'], undefined>)
        return { field: 'in_aspect_ratio', value, written }
      }
      case 'in_scene_id': {
        const value = _resolveStoryboardDesignerInSceneIdInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInSceneId(value as unknown as Exclude<StoryboardDesignerNodeWriteData['in_scene_id'], undefined>)
        return { field: 'in_scene_id', value, written }
      }
      case 'in_name': {
        const value = _resolveStoryboardDesignerInNameInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInName(value as unknown as Exclude<StoryboardDesignerNodeWriteData['in_name'], undefined>)
        return { field: 'in_name', value, written }
      }
      case 'in_location': {
        const value = _resolveStoryboardDesignerInLocationInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInLocation(value as unknown as Exclude<StoryboardDesignerNodeWriteData['in_location'], undefined>)
        return { field: 'in_location', value, written }
      }
      case 'in_model': {
        const value = _resolveStoryboardDesignerInModelInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInModel(value as unknown as Exclude<StoryboardDesignerNodeWriteData['in_model'], undefined>)
        return { field: 'in_model', value, written }
      }
      case 'in_feedback': {
        const value = _resolveStoryboardDesignerInFeedbackInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInFeedback(value as unknown as Exclude<StoryboardDesignerNodeWriteData['in_feedback'], undefined>)
        return { field: 'in_feedback', value, written }
      }
      case 'in_vlm_validation': {
        const value = _resolveStoryboardDesignerInVlmValidationInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInVlmValidation(value as unknown as Exclude<StoryboardDesignerNodeWriteData['in_vlm_validation'], undefined>)
        return { field: 'in_vlm_validation', value, written }
      }
      case 'in_video_anchors': {
        const value = _resolveStoryboardDesignerInVideoAnchorsInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInVideoAnchors(value as unknown as Exclude<StoryboardDesignerNodeWriteData['in_video_anchors'], undefined>)
        return { field: 'in_video_anchors', value, written }
      }
      default:
        throw new Error(`Unknown input port ${targetHandle} for StoryboardDesignerCanvasNode`)
    }
  }
}

export class StoryboardNoEnhanceDesignerCanvasNode extends GeneratedCanvasNode<StoryboardNoEnhanceDesignerNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  get(key: 'type'): "storyboardNoEnhanceDesigner" | undefined
  get(key: 'in_script'): string | undefined
  get(key: 'in_characters'): Array<ImageAssetRefDictYMap | null> | undefined
  get(key: 'in_character_names'): Array<string | null> | undefined
  get(key: 'in_locations'): Array<ImageAssetRefDictYMap | null> | undefined
  get(key: 'in_location_names'): Array<string | null> | undefined
  get(key: 'in_style'): string | undefined
  get(key: 'in_panel_count'): number | undefined
  get(key: 'in_scene_id'): string | undefined
  get(key: 'in_location'): string | undefined
  get(key: 'in_model'): string | undefined
  get(key: 'in_vlm_validation'): boolean | undefined
  get(key: 'out_image'): ImageAssetRefDictYMap | undefined
  get(key: 'out_vlm_report'): VlmValidationReportDictYMap | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'in_script': return _readYDocOptionalString(this._raw.get('in_script'), "storyboardNoEnhanceDesigner.in_script")
      case 'in_characters': return _readYDocOptionalArray(this._raw.get('in_characters'), "storyboardNoEnhanceDesigner.in_characters", (item, itemLabel) => item == null ? null : _readYDocMapWrapper(item, ImageAssetRefDictYMap, itemLabel))
      case 'in_character_names': return _readYDocOptionalArray(this._raw.get('in_character_names'), "storyboardNoEnhanceDesigner.in_character_names", (item, itemLabel) => item == null ? null : _readYDocString(item, itemLabel))
      case 'in_locations': return _readYDocOptionalArray(this._raw.get('in_locations'), "storyboardNoEnhanceDesigner.in_locations", (item, itemLabel) => item == null ? null : _readYDocMapWrapper(item, ImageAssetRefDictYMap, itemLabel))
      case 'in_location_names': return _readYDocOptionalArray(this._raw.get('in_location_names'), "storyboardNoEnhanceDesigner.in_location_names", (item, itemLabel) => item == null ? null : _readYDocString(item, itemLabel))
      case 'in_style': return _readYDocOptionalString(this._raw.get('in_style'), "storyboardNoEnhanceDesigner.in_style")
      case 'in_panel_count': return _readYDocOptionalNumber(this._raw.get('in_panel_count'), "storyboardNoEnhanceDesigner.in_panel_count")
      case 'in_scene_id': return _readYDocOptionalString(this._raw.get('in_scene_id'), "storyboardNoEnhanceDesigner.in_scene_id")
      case 'in_location': return _readYDocOptionalString(this._raw.get('in_location'), "storyboardNoEnhanceDesigner.in_location")
      case 'in_model': return _readYDocOptionalString(this._raw.get('in_model'), "storyboardNoEnhanceDesigner.in_model")
      case 'in_vlm_validation': return _readYDocOptionalBoolean(this._raw.get('in_vlm_validation'), "storyboardNoEnhanceDesigner.in_vlm_validation")
      case 'out_image': return _readYDocOptionalMapWrapper(this._raw.get('out_image'), ImageAssetRefDictYMap, "storyboardNoEnhanceDesigner.out_image")
      case 'out_vlm_report': return _readYDocOptionalMapWrapper(this._raw.get('out_vlm_report'), VlmValidationReportDictYMap, "storyboardNoEnhanceDesigner.out_vlm_report")
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "in_script" | "in_characters" | "in_character_names" | "in_locations" | "in_location_names" | "in_style" | "in_panel_count" | "in_scene_id" | "in_location" | "in_model" | "in_vlm_validation" | "out_image" | "out_vlm_report" | "revision"): void { this._raw.delete(key) }
  has(key: "type" | "in_script" | "in_characters" | "in_character_names" | "in_locations" | "in_location_names" | "in_style" | "in_panel_count" | "in_scene_id" | "in_location" | "in_model" | "in_vlm_validation" | "out_image" | "out_vlm_report" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<StoryboardNoEnhanceDesignerNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this._writeDataField(field as keyof StoryboardNoEnhanceDesignerNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof StoryboardNoEnhanceDesignerNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'in_script': return this.writeInScript(value as Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_script'], undefined>, opts)
      case 'in_characters': return this.writeInCharacters(value as Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_characters'], undefined>, opts)
      case 'in_character_names': return this.writeInCharacterNames(value as Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_character_names'], undefined>, opts)
      case 'in_locations': return this.writeInLocations(value as Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_locations'], undefined>, opts)
      case 'in_location_names': return this.writeInLocationNames(value as Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_location_names'], undefined>, opts)
      case 'in_style': return this.writeInStyle(value as Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_style'], undefined>, opts)
      case 'in_panel_count': return this.writeInPanelCount(value as Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_panel_count'], undefined>, opts)
      case 'in_scene_id': return this.writeInSceneId(value as Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_scene_id'], undefined>, opts)
      case 'in_location': return this.writeInLocation(value as Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_location'], undefined>, opts)
      case 'in_model': return this.writeInModel(value as Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_model'], undefined>, opts)
      case 'in_vlm_validation': return this.writeInVlmValidation(value as Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_vlm_validation'], undefined>, opts)
      case 'out_image': return this.writeOutImage(value as Exclude<StoryboardNoEnhanceDesignerNodeWriteData['out_image'], undefined>, opts)
      case 'out_vlm_report': return this.writeOutVlmReport(value as Exclude<StoryboardNoEnhanceDesignerNodeWriteData['out_vlm_report'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writeInScript(value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_script'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_script', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInCharacters(value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_characters'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_characters', 'array', value, opts, false, undefined, undefined)
  }

  writeInCharacterNames(value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_character_names'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_character_names', 'array', value, opts, false, undefined, undefined)
  }

  writeInLocations(value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_locations'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_locations', 'array', value, opts, false, undefined, undefined)
  }

  writeInLocationNames(value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_location_names'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_location_names', 'array', value, opts, false, undefined, undefined)
  }

  writeInStyle(value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_style'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_style', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInPanelCount(value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_panel_count'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_panel_count', 'primitive', value, opts, false, 'number', undefined)
  }

  writeInSceneId(value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_scene_id'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_scene_id', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInLocation(value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_location'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_location', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInModel(value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_model'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_model', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInVlmValidation(value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_vlm_validation'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_vlm_validation', 'primitive', value, opts, false, 'boolean', undefined)
  }

  writeOutImage(value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['out_image'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_image', 'map', value, opts, false, undefined, undefined)
  }

  writeOutVlmReport(value: Exclude<StoryboardNoEnhanceDesignerNodeWriteData['out_vlm_report'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_vlm_report', 'map', value, opts, false, undefined, undefined)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolveStoryboardNoEnhanceDesignerInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    switch (targetHandle) {
      case 'in_script': {
        const value = _resolveStoryboardNoEnhanceDesignerInScriptInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInScript(value as unknown as Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_script'], undefined>)
        return { field: 'in_script', value, written }
      }
      case 'in_characters': {
        const value = _resolveStoryboardNoEnhanceDesignerInCharactersInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_characters')
        if (hadPersistedValue) this.delete('in_characters')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_characters', value, written }
      }
      case 'in_character_names': {
        const value = _resolveStoryboardNoEnhanceDesignerInCharacterNamesInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInCharacterNames(value as unknown as Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_character_names'], undefined>)
        return { field: 'in_character_names', value, written }
      }
      case 'in_locations': {
        const value = _resolveStoryboardNoEnhanceDesignerInLocationsInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_locations')
        if (hadPersistedValue) this.delete('in_locations')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_locations', value, written }
      }
      case 'in_location_names': {
        const value = _resolveStoryboardNoEnhanceDesignerInLocationNamesInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInLocationNames(value as unknown as Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_location_names'], undefined>)
        return { field: 'in_location_names', value, written }
      }
      case 'in_style': {
        const value = _resolveStoryboardNoEnhanceDesignerInStyleInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInStyle(value as unknown as Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_style'], undefined>)
        return { field: 'in_style', value, written }
      }
      case 'in_panel_count': {
        const value = _resolveStoryboardNoEnhanceDesignerInPanelCountInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInPanelCount(value as unknown as Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_panel_count'], undefined>)
        return { field: 'in_panel_count', value, written }
      }
      case 'in_scene_id': {
        const value = _resolveStoryboardNoEnhanceDesignerInSceneIdInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInSceneId(value as unknown as Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_scene_id'], undefined>)
        return { field: 'in_scene_id', value, written }
      }
      case 'in_location': {
        const value = _resolveStoryboardNoEnhanceDesignerInLocationInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInLocation(value as unknown as Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_location'], undefined>)
        return { field: 'in_location', value, written }
      }
      case 'in_model': {
        const value = _resolveStoryboardNoEnhanceDesignerInModelInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInModel(value as unknown as Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_model'], undefined>)
        return { field: 'in_model', value, written }
      }
      case 'in_vlm_validation': {
        const value = _resolveStoryboardNoEnhanceDesignerInVlmValidationInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInVlmValidation(value as unknown as Exclude<StoryboardNoEnhanceDesignerNodeWriteData['in_vlm_validation'], undefined>)
        return { field: 'in_vlm_validation', value, written }
      }
      default:
        throw new Error(`Unknown input port ${targetHandle} for StoryboardNoEnhanceDesignerCanvasNode`)
    }
  }
}

export class StyleSelectorCanvasNode extends GeneratedCanvasNode<StyleSelectorNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  get(key: 'type'): "styleSelector" | undefined
  get(key: 'out_style'): string | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'out_style': return _readYDocOptionalString(this._raw.get('out_style'), "styleSelector.out_style")
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "out_style" | "revision"): void { this._raw.delete(key) }
  has(key: "type" | "out_style" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<StyleSelectorNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this._writeDataField(field as keyof StyleSelectorNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof StyleSelectorNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'out_style': return this.writeOutStyle(value as Exclude<StyleSelectorNodeWriteData['out_style'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writeOutStyle(value: Exclude<StyleSelectorNodeWriteData['out_style'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_style', 'primitive', value, opts, false, 'string', undefined)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolveStyleSelectorInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    void nodes
    void edgeRefs
    switch (targetHandle) {
      default:
        throw new Error(`Unknown input port ${targetHandle} for StyleSelectorCanvasNode`)
    }
  }
}

export class TextCanvasNode extends GeneratedCanvasNode<TextNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  get(key: 'type'): "text" | undefined
  get(key: 'in_input'): string | undefined
  get(key: 'out_text'): string | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'in_input': return _readYDocOptionalString(this._raw.get('in_input'), "text.in_input")
      case 'out_text': return _readYDocOptionalString(this._raw.get('out_text'), "text.out_text")
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "in_input" | "out_text" | "revision"): void { this._raw.delete(key) }
  has(key: "type" | "in_input" | "out_text" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<TextNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this._writeDataField(field as keyof TextNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof TextNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'in_input': return this.writeInInput(value as Exclude<TextNodeWriteData['in_input'], undefined>, opts)
      case 'out_text': return this.writeOutText(value as Exclude<TextNodeWriteData['out_text'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writeInInput(value: Exclude<TextNodeWriteData['in_input'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_input', 'primitive', value, opts, false, 'string', undefined)
  }

  writeOutText(value: Exclude<TextNodeWriteData['out_text'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_text', 'primitive', value, opts, false, 'string', undefined)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolveTextInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    switch (targetHandle) {
      case 'in_input': {
        const value = _resolveTextInInputInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInInput(value as unknown as Exclude<TextNodeWriteData['in_input'], undefined>)
        return { field: 'in_input', value, written }
      }
      default:
        throw new Error(`Unknown input port ${targetHandle} for TextCanvasNode`)
    }
  }
}

export class VideoCanvasNode extends GeneratedCanvasNode<VideoNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  get(key: 'type'): "video" | undefined
  get(key: 'in_file_name'): string | undefined
  get(key: 'in_depth_include_audio'): boolean | undefined
  get(key: 'in_transform_video'): VideoAssetRefDictYMap | undefined
  get(key: 'in_transform_target_resolution'): string | undefined
  get(key: 'in_transform_source_asset_path'): string | undefined
  get(key: 'in_transform_source_content_sha256'): string | undefined
  get(key: 'in_transform_source_width'): number | undefined
  get(key: 'in_transform_source_height'): number | undefined
  get(key: 'in_transform_source_frame_count'): number | undefined
  get(key: 'in_transform_source_fps'): number | undefined
  get(key: 'out_video'): GeneratedVideoWithHistoryYMap | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'in_file_name': return _readYDocOptionalString(this._raw.get('in_file_name'), "video.in_file_name")
      case 'in_depth_include_audio': return _readYDocOptionalBoolean(this._raw.get('in_depth_include_audio'), "video.in_depth_include_audio")
      case 'in_transform_video': return _readYDocOptionalMapWrapper(this._raw.get('in_transform_video'), VideoAssetRefDictYMap, "video.in_transform_video")
      case 'in_transform_target_resolution': return _readYDocOptionalString(this._raw.get('in_transform_target_resolution'), "video.in_transform_target_resolution")
      case 'in_transform_source_asset_path': return _readYDocOptionalString(this._raw.get('in_transform_source_asset_path'), "video.in_transform_source_asset_path")
      case 'in_transform_source_content_sha256': return _readYDocOptionalString(this._raw.get('in_transform_source_content_sha256'), "video.in_transform_source_content_sha256")
      case 'in_transform_source_width': return _readYDocOptionalNumber(this._raw.get('in_transform_source_width'), "video.in_transform_source_width")
      case 'in_transform_source_height': return _readYDocOptionalNumber(this._raw.get('in_transform_source_height'), "video.in_transform_source_height")
      case 'in_transform_source_frame_count': return _readYDocOptionalNumber(this._raw.get('in_transform_source_frame_count'), "video.in_transform_source_frame_count")
      case 'in_transform_source_fps': return _readYDocOptionalNumber(this._raw.get('in_transform_source_fps'), "video.in_transform_source_fps")
      case 'out_video': return _readYDocOptionalMapWrapper(this._raw.get('out_video'), GeneratedVideoWithHistoryYMap, "video.out_video")
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "in_file_name" | "in_depth_include_audio" | "in_transform_video" | "in_transform_target_resolution" | "in_transform_source_asset_path" | "in_transform_source_content_sha256" | "in_transform_source_width" | "in_transform_source_height" | "in_transform_source_frame_count" | "in_transform_source_fps" | "out_video" | "revision"): void { this._raw.delete(key) }
  has(key: "type" | "in_file_name" | "in_depth_include_audio" | "in_transform_video" | "in_transform_target_resolution" | "in_transform_source_asset_path" | "in_transform_source_content_sha256" | "in_transform_source_width" | "in_transform_source_height" | "in_transform_source_frame_count" | "in_transform_source_fps" | "out_video" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<VideoNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this._writeDataField(field as keyof VideoNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof VideoNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'in_file_name': return this.writeInFileName(value as Exclude<VideoNodeWriteData['in_file_name'], undefined>, opts)
      case 'in_depth_include_audio': return this.writeInDepthIncludeAudio(value as Exclude<VideoNodeWriteData['in_depth_include_audio'], undefined>, opts)
      case 'in_transform_video': return this.writeInTransformVideo(value as Exclude<VideoNodeWriteData['in_transform_video'], undefined>, opts)
      case 'in_transform_target_resolution': return this.writeInTransformTargetResolution(value as Exclude<VideoNodeWriteData['in_transform_target_resolution'], undefined>, opts)
      case 'in_transform_source_asset_path': return this.writeInTransformSourceAssetPath(value as Exclude<VideoNodeWriteData['in_transform_source_asset_path'], undefined>, opts)
      case 'in_transform_source_content_sha256': return this.writeInTransformSourceContentSha256(value as Exclude<VideoNodeWriteData['in_transform_source_content_sha256'], undefined>, opts)
      case 'in_transform_source_width': return this.writeInTransformSourceWidth(value as Exclude<VideoNodeWriteData['in_transform_source_width'], undefined>, opts)
      case 'in_transform_source_height': return this.writeInTransformSourceHeight(value as Exclude<VideoNodeWriteData['in_transform_source_height'], undefined>, opts)
      case 'in_transform_source_frame_count': return this.writeInTransformSourceFrameCount(value as Exclude<VideoNodeWriteData['in_transform_source_frame_count'], undefined>, opts)
      case 'in_transform_source_fps': return this.writeInTransformSourceFps(value as Exclude<VideoNodeWriteData['in_transform_source_fps'], undefined>, opts)
      case 'out_video': return this.writeOutVideo(value as Exclude<VideoNodeWriteData['out_video'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writeInFileName(value: Exclude<VideoNodeWriteData['in_file_name'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_file_name', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInDepthIncludeAudio(value: Exclude<VideoNodeWriteData['in_depth_include_audio'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_depth_include_audio', 'primitive', value, opts, false, 'boolean', undefined)
  }

  writeInTransformVideo(value: Exclude<VideoNodeWriteData['in_transform_video'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_transform_video', 'map', value, opts, false, undefined, _validateYDocVideoAssetRefDict)
  }

  writeInTransformTargetResolution(value: Exclude<VideoNodeWriteData['in_transform_target_resolution'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_transform_target_resolution', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInTransformSourceAssetPath(value: Exclude<VideoNodeWriteData['in_transform_source_asset_path'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_transform_source_asset_path', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInTransformSourceContentSha256(value: Exclude<VideoNodeWriteData['in_transform_source_content_sha256'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_transform_source_content_sha256', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInTransformSourceWidth(value: Exclude<VideoNodeWriteData['in_transform_source_width'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_transform_source_width', 'primitive', value, opts, false, 'number', undefined)
  }

  writeInTransformSourceHeight(value: Exclude<VideoNodeWriteData['in_transform_source_height'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_transform_source_height', 'primitive', value, opts, false, 'number', undefined)
  }

  writeInTransformSourceFrameCount(value: Exclude<VideoNodeWriteData['in_transform_source_frame_count'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_transform_source_frame_count', 'primitive', value, opts, false, 'number', undefined)
  }

  writeInTransformSourceFps(value: Exclude<VideoNodeWriteData['in_transform_source_fps'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_transform_source_fps', 'primitive', value, opts, false, 'number', undefined)
  }

  writeOutVideo(value: Exclude<VideoNodeWriteData['out_video'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_video', 'map', value, opts, false, undefined, _validateYDocGeneratedVideoWithHistory)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolveVideoInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    switch (targetHandle) {
      case 'in_file_name': {
        const value = _resolveVideoInFileNameInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInFileName(value as unknown as Exclude<VideoNodeWriteData['in_file_name'], undefined>)
        return { field: 'in_file_name', value, written }
      }
      case 'in_depth_include_audio': {
        const value = _resolveVideoInDepthIncludeAudioInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInDepthIncludeAudio(value as unknown as Exclude<VideoNodeWriteData['in_depth_include_audio'], undefined>)
        return { field: 'in_depth_include_audio', value, written }
      }
      case 'in_transform_video': {
        const value = _resolveVideoInTransformVideoInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInTransformVideo(value as unknown as Exclude<VideoNodeWriteData['in_transform_video'], undefined>)
        return { field: 'in_transform_video', value, written }
      }
      case 'in_transform_target_resolution': {
        const value = _resolveVideoInTransformTargetResolutionInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInTransformTargetResolution(value as unknown as Exclude<VideoNodeWriteData['in_transform_target_resolution'], undefined>)
        return { field: 'in_transform_target_resolution', value, written }
      }
      case 'in_transform_source_asset_path': {
        const value = _resolveVideoInTransformSourceAssetPathInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInTransformSourceAssetPath(value as unknown as Exclude<VideoNodeWriteData['in_transform_source_asset_path'], undefined>)
        return { field: 'in_transform_source_asset_path', value, written }
      }
      case 'in_transform_source_content_sha256': {
        const value = _resolveVideoInTransformSourceContentSha256InputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInTransformSourceContentSha256(value as unknown as Exclude<VideoNodeWriteData['in_transform_source_content_sha256'], undefined>)
        return { field: 'in_transform_source_content_sha256', value, written }
      }
      case 'in_transform_source_width': {
        const value = _resolveVideoInTransformSourceWidthInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInTransformSourceWidth(value as unknown as Exclude<VideoNodeWriteData['in_transform_source_width'], undefined>)
        return { field: 'in_transform_source_width', value, written }
      }
      case 'in_transform_source_height': {
        const value = _resolveVideoInTransformSourceHeightInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInTransformSourceHeight(value as unknown as Exclude<VideoNodeWriteData['in_transform_source_height'], undefined>)
        return { field: 'in_transform_source_height', value, written }
      }
      case 'in_transform_source_frame_count': {
        const value = _resolveVideoInTransformSourceFrameCountInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInTransformSourceFrameCount(value as unknown as Exclude<VideoNodeWriteData['in_transform_source_frame_count'], undefined>)
        return { field: 'in_transform_source_frame_count', value, written }
      }
      case 'in_transform_source_fps': {
        const value = _resolveVideoInTransformSourceFpsInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInTransformSourceFps(value as unknown as Exclude<VideoNodeWriteData['in_transform_source_fps'], undefined>)
        return { field: 'in_transform_source_fps', value, written }
      }
      default:
        throw new Error(`Unknown input port ${targetHandle} for VideoCanvasNode`)
    }
  }
}

export class VideoEditorCanvasNode extends GeneratedCanvasNode<VideoEditorNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  get(key: 'type'): "videoEditor" | undefined
  get(key: 'in_reference_media'): Array<MediaAssetRefDictYMap | null> | undefined
  get(key: 'in_videos'): Array<VideoAssetRefDictYMap | null> | undefined
  get(key: 'in_audios'): Array<AudioAssetRefDictYMap | null> | undefined
  get(key: 'in_audio'): AudioAssetRefDictYMap | undefined
  get(key: 'in_video_config'): TimelineConfigDictYMap | undefined
  get(key: 'in_edit_spec'): EditSpecDictYMap | undefined
  get(key: 'in_mode'): string | undefined
  get(key: 'in_output_name'): string | undefined
  get(key: 'in_start'): number | undefined
  get(key: 'in_end'): number | undefined
  get(key: 'in_volume'): number | undefined
  get(key: 'in_export_name'): string | undefined
  get(key: 'out_video'): VideoAssetRefDictYMap | undefined
  get(key: 'out_rendered_spec_hash'): string | undefined
  get(key: 'out_render_sources'): ShotVideoRenderSourcesDictYMap | undefined
  get(key: 'last_export_node_id'): string | undefined
  get(key: 'magnet_enabled'): boolean | undefined
  get(key: 'edit_spec_compatibility_state'): string | undefined
  get(key: 'edit_spec_migration_error'): string | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'in_reference_media': return _readYDocOptionalArray(this._raw.get('in_reference_media'), "videoEditor.in_reference_media", (item, itemLabel) => item == null ? null : _readYDocMapWrapper(item, MediaAssetRefDictYMap, itemLabel))
      case 'in_videos': return _readYDocOptionalArray(this._raw.get('in_videos'), "videoEditor.in_videos", (item, itemLabel) => item == null ? null : _readYDocMapWrapper(item, VideoAssetRefDictYMap, itemLabel))
      case 'in_audios': return _readYDocOptionalArray(this._raw.get('in_audios'), "videoEditor.in_audios", (item, itemLabel) => item == null ? null : _readYDocMapWrapper(item, AudioAssetRefDictYMap, itemLabel))
      case 'in_audio': return _readYDocOptionalMapWrapper(this._raw.get('in_audio'), AudioAssetRefDictYMap, "videoEditor.in_audio")
      case 'in_video_config': return _readYDocOptionalMapWrapper(this._raw.get('in_video_config'), TimelineConfigDictYMap, "videoEditor.in_video_config")
      case 'in_edit_spec': return _readYDocOptionalMapWrapper(this._raw.get('in_edit_spec'), EditSpecDictYMap, "videoEditor.in_edit_spec")
      case 'in_mode': return _readYDocOptionalString(this._raw.get('in_mode'), "videoEditor.in_mode")
      case 'in_output_name': return _readYDocOptionalString(this._raw.get('in_output_name'), "videoEditor.in_output_name")
      case 'in_start': return _readYDocOptionalNumber(this._raw.get('in_start'), "videoEditor.in_start")
      case 'in_end': return _readYDocOptionalNumber(this._raw.get('in_end'), "videoEditor.in_end")
      case 'in_volume': return _readYDocOptionalNumber(this._raw.get('in_volume'), "videoEditor.in_volume")
      case 'in_export_name': return _readYDocOptionalString(this._raw.get('in_export_name'), "videoEditor.in_export_name")
      case 'out_video': return _readYDocOptionalMapWrapper(this._raw.get('out_video'), VideoAssetRefDictYMap, "videoEditor.out_video")
      case 'out_rendered_spec_hash': return _readYDocOptionalString(this._raw.get('out_rendered_spec_hash'), "videoEditor.out_rendered_spec_hash")
      case 'out_render_sources': return _readYDocOptionalMapWrapper(this._raw.get('out_render_sources'), ShotVideoRenderSourcesDictYMap, "videoEditor.out_render_sources")
      case 'last_export_node_id': return _readYDocOptionalString(this._raw.get('last_export_node_id'), "videoEditor.last_export_node_id")
      case 'magnet_enabled': return _readYDocOptionalBoolean(this._raw.get('magnet_enabled'), "videoEditor.magnet_enabled")
      case 'edit_spec_compatibility_state': return _readYDocOptionalString(this._raw.get('edit_spec_compatibility_state'), "videoEditor.edit_spec_compatibility_state")
      case 'edit_spec_migration_error': return _readYDocOptionalString(this._raw.get('edit_spec_migration_error'), "videoEditor.edit_spec_migration_error")
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "in_reference_media" | "in_videos" | "in_audios" | "in_audio" | "in_video_config" | "in_edit_spec" | "in_mode" | "in_output_name" | "in_start" | "in_end" | "in_volume" | "in_export_name" | "out_video" | "out_rendered_spec_hash" | "out_render_sources" | "last_export_node_id" | "magnet_enabled" | "edit_spec_compatibility_state" | "edit_spec_migration_error" | "revision"): void { this._raw.delete(key) }
  has(key: "type" | "in_reference_media" | "in_videos" | "in_audios" | "in_audio" | "in_video_config" | "in_edit_spec" | "in_mode" | "in_output_name" | "in_start" | "in_end" | "in_volume" | "in_export_name" | "out_video" | "out_rendered_spec_hash" | "out_render_sources" | "last_export_node_id" | "magnet_enabled" | "edit_spec_compatibility_state" | "edit_spec_migration_error" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<VideoEditorNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this._writeDataField(field as keyof VideoEditorNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof VideoEditorNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'in_reference_media': return this.writeInReferenceMedia(value as Exclude<VideoEditorNodeWriteData['in_reference_media'], undefined>, opts)
      case 'in_videos': return this.writeInVideos(value as Exclude<VideoEditorNodeWriteData['in_videos'], undefined>, opts)
      case 'in_audios': return this.writeInAudios(value as Exclude<VideoEditorNodeWriteData['in_audios'], undefined>, opts)
      case 'in_audio': return this.writeInAudio(value as Exclude<VideoEditorNodeWriteData['in_audio'], undefined>, opts)
      case 'in_video_config': return this.writeInVideoConfig(value as Exclude<VideoEditorNodeWriteData['in_video_config'], undefined>, opts)
      case 'in_edit_spec': return this.writeInEditSpec(value as Exclude<VideoEditorNodeWriteData['in_edit_spec'], undefined>, opts)
      case 'in_mode': return this.writeInMode(value as Exclude<VideoEditorNodeWriteData['in_mode'], undefined>, opts)
      case 'in_output_name': return this.writeInOutputName(value as Exclude<VideoEditorNodeWriteData['in_output_name'], undefined>, opts)
      case 'in_start': return this.writeInStart(value as Exclude<VideoEditorNodeWriteData['in_start'], undefined>, opts)
      case 'in_end': return this.writeInEnd(value as Exclude<VideoEditorNodeWriteData['in_end'], undefined>, opts)
      case 'in_volume': return this.writeInVolume(value as Exclude<VideoEditorNodeWriteData['in_volume'], undefined>, opts)
      case 'in_export_name': return this.writeInExportName(value as Exclude<VideoEditorNodeWriteData['in_export_name'], undefined>, opts)
      case 'out_video': return this.writeOutVideo(value as Exclude<VideoEditorNodeWriteData['out_video'], undefined>, opts)
      case 'out_rendered_spec_hash': return this.writeOutRenderedSpecHash(value as Exclude<VideoEditorNodeWriteData['out_rendered_spec_hash'], undefined>, opts)
      case 'out_render_sources': return this.writeOutRenderSources(value as Exclude<VideoEditorNodeWriteData['out_render_sources'], undefined>, opts)
      case 'last_export_node_id': return this.writeLastExportNodeId(value as Exclude<VideoEditorNodeWriteData['last_export_node_id'], undefined>, opts)
      case 'magnet_enabled': return this.writeMagnetEnabled(value as Exclude<VideoEditorNodeWriteData['magnet_enabled'], undefined>, opts)
      case 'edit_spec_compatibility_state': return this.writeEditSpecCompatibilityState(value as Exclude<VideoEditorNodeWriteData['edit_spec_compatibility_state'], undefined>, opts)
      case 'edit_spec_migration_error': return this.writeEditSpecMigrationError(value as Exclude<VideoEditorNodeWriteData['edit_spec_migration_error'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writeInReferenceMedia(value: Exclude<VideoEditorNodeWriteData['in_reference_media'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_reference_media', 'array', value, opts, false, undefined, undefined)
  }

  writeInVideos(value: Exclude<VideoEditorNodeWriteData['in_videos'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_videos', 'array', value, opts, false, undefined, (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => { if (item !== null) _validateYDocVideoAssetRefDict(item, itemLabel) }))
  }

  writeInAudios(value: Exclude<VideoEditorNodeWriteData['in_audios'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_audios', 'array', value, opts, false, undefined, undefined)
  }

  writeInAudio(value: Exclude<VideoEditorNodeWriteData['in_audio'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_audio', 'map', value, opts, false, undefined, undefined)
  }

  writeInVideoConfig(value: Exclude<VideoEditorNodeWriteData['in_video_config'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_video_config', 'map', value, opts, false, undefined, undefined)
  }

  writeInEditSpec(value: Exclude<VideoEditorNodeWriteData['in_edit_spec'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_edit_spec', 'map', value, opts, false, undefined, undefined)
  }

  writeInMode(value: Exclude<VideoEditorNodeWriteData['in_mode'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_mode', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInOutputName(value: Exclude<VideoEditorNodeWriteData['in_output_name'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_output_name', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInStart(value: Exclude<VideoEditorNodeWriteData['in_start'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_start', 'primitive', value, opts, false, 'number', undefined)
  }

  writeInEnd(value: Exclude<VideoEditorNodeWriteData['in_end'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_end', 'primitive', value, opts, false, 'number', undefined)
  }

  writeInVolume(value: Exclude<VideoEditorNodeWriteData['in_volume'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_volume', 'primitive', value, opts, false, 'number', undefined)
  }

  writeInExportName(value: Exclude<VideoEditorNodeWriteData['in_export_name'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_export_name', 'primitive', value, opts, false, 'string', undefined)
  }

  writeOutVideo(value: Exclude<VideoEditorNodeWriteData['out_video'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_video', 'map', value, opts, false, undefined, _validateYDocVideoAssetRefDict)
  }

  writeOutRenderedSpecHash(value: Exclude<VideoEditorNodeWriteData['out_rendered_spec_hash'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_rendered_spec_hash', 'primitive', value, opts, false, 'string', undefined)
  }

  writeOutRenderSources(value: Exclude<VideoEditorNodeWriteData['out_render_sources'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_render_sources', 'map', value, opts, false, undefined, undefined)
  }

  writeLastExportNodeId(value: Exclude<VideoEditorNodeWriteData['last_export_node_id'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('last_export_node_id', 'primitive', value, opts, false, 'string', undefined)
  }

  writeMagnetEnabled(value: Exclude<VideoEditorNodeWriteData['magnet_enabled'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('magnet_enabled', 'primitive', value, opts, false, 'boolean', undefined)
  }

  writeEditSpecCompatibilityState(value: Exclude<VideoEditorNodeWriteData['edit_spec_compatibility_state'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('edit_spec_compatibility_state', 'primitive', value, opts, false, 'string', undefined)
  }

  writeEditSpecMigrationError(value: Exclude<VideoEditorNodeWriteData['edit_spec_migration_error'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('edit_spec_migration_error', 'primitive', value, opts, false, 'string', undefined)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolveVideoEditorInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    switch (targetHandle) {
      case 'in_reference_media': {
        const value = _resolveVideoEditorInReferenceMediaInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_reference_media')
        if (hadPersistedValue) this.delete('in_reference_media')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_reference_media', value, written }
      }
      case 'in_videos': {
        const value = _resolveVideoEditorInVideosInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_videos')
        if (hadPersistedValue) this.delete('in_videos')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_videos', value, written }
      }
      case 'in_audios': {
        const value = _resolveVideoEditorInAudiosInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_audios')
        if (hadPersistedValue) this.delete('in_audios')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_audios', value, written }
      }
      case 'in_audio': {
        const value = _resolveVideoEditorInAudioInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_audio')
        if (hadPersistedValue) this.delete('in_audio')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_audio', value, written }
      }
      case 'in_video_config': {
        const value = _resolveVideoEditorInVideoConfigInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInVideoConfig(value as unknown as Exclude<VideoEditorNodeWriteData['in_video_config'], undefined>)
        return { field: 'in_video_config', value, written }
      }
      case 'in_edit_spec': {
        const value = _resolveVideoEditorInEditSpecInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInEditSpec(value as unknown as Exclude<VideoEditorNodeWriteData['in_edit_spec'], undefined>)
        return { field: 'in_edit_spec', value, written }
      }
      case 'in_mode': {
        const value = _resolveVideoEditorInModeInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInMode(value as unknown as Exclude<VideoEditorNodeWriteData['in_mode'], undefined>)
        return { field: 'in_mode', value, written }
      }
      case 'in_output_name': {
        const value = _resolveVideoEditorInOutputNameInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInOutputName(value as unknown as Exclude<VideoEditorNodeWriteData['in_output_name'], undefined>)
        return { field: 'in_output_name', value, written }
      }
      case 'in_start': {
        const value = _resolveVideoEditorInStartInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInStart(value as unknown as Exclude<VideoEditorNodeWriteData['in_start'], undefined>)
        return { field: 'in_start', value, written }
      }
      case 'in_end': {
        const value = _resolveVideoEditorInEndInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInEnd(value as unknown as Exclude<VideoEditorNodeWriteData['in_end'], undefined>)
        return { field: 'in_end', value, written }
      }
      case 'in_volume': {
        const value = _resolveVideoEditorInVolumeInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInVolume(value as unknown as Exclude<VideoEditorNodeWriteData['in_volume'], undefined>)
        return { field: 'in_volume', value, written }
      }
      case 'in_export_name': {
        const value = _resolveVideoEditorInExportNameInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInExportName(value as unknown as Exclude<VideoEditorNodeWriteData['in_export_name'], undefined>)
        return { field: 'in_export_name', value, written }
      }
      default:
        throw new Error(`Unknown input port ${targetHandle} for VideoEditorCanvasNode`)
    }
  }
}

export class VideoGeneratorCanvasNode extends GeneratedCanvasNode<VideoGeneratorNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  get(key: 'type'): "videoGenerator" | undefined
  get(key: 'in_reference_media'): Array<MediaAssetRefDictYMap | null> | undefined
  get(key: 'in_mode'): string | undefined
  get(key: 'in_scene_id'): string | undefined
  get(key: 'in_clip_number'): number | undefined
  get(key: 'in_images'): Array<ImageAssetRefDictYMap | null> | undefined
  get(key: 'in_reference_videos'): Array<VideoAssetRefDictYMap | null> | undefined
  get(key: 'in_continuation_source'): GeneratedVideoWithHistoryYMap | undefined
  get(key: 'in_shot_list_source_id'): string | undefined
  get(key: 'in_shot_list_source_fingerprint'): string | undefined
  get(key: 'in_shot_list_request_fingerprint'): string | undefined
  get(key: 'in_reference_audios'): Array<AudioAssetRefDictYMap | null> | undefined
  get(key: 'in_audio'): AudioAssetRefDictYMap | undefined
  get(key: 'in_motion_prompt'): string | undefined
  get(key: 'in_scene_context'): string | undefined
  get(key: 'in_duration'): number | undefined
  get(key: 'in_reference_video_edits'): Array<VideoReferenceEditDictYMap> | undefined
  get(key: 'in_dialogue_prompt'): Array<DialogueEntryDictYMap> | undefined
  get(key: 'in_model'): string | undefined
  get(key: 'in_aspect_ratio'): string | undefined
  get(key: 'in_resolution'): string | undefined
  get(key: 'in_generate_audio'): boolean | undefined
  get(key: 'in_provider_generate_audio'): boolean | undefined
  get(key: 'in_use_voice_profile_audio_references'): boolean | undefined
  get(key: 'in_audio_remix_mode'): "off" | "voiceover_only" | "full_remix" | undefined
  get(key: 'in_allow_bgm'): boolean | undefined
  get(key: 'in_tts_provider'): string | undefined
  get(key: 'in_dub_target_language'): string | undefined
  get(key: 'in_voice_profiles'): Array<VoiceProfileDictYMap | null> | undefined
  get(key: 'in_voice_settings'): VoiceSettingsDictYMap | undefined
  get(key: 'in_name'): string | undefined
  get(key: 'in_resolved_voice_map'): ResolvedVoiceMapDictYMap | undefined
  get(key: 'in_audio_remix_config'): AudioRemixConfigDictYMap | undefined
  get(key: 'in_speech_transformer_config'): SpeechTransformerConfigDictYMap | undefined
  get(key: 'in_audio_take_selections'): AudioTakeSelectionMapDictYMap | undefined
  get(key: 'in_audio_variant_workspaces'): AudioVariantWorkspaceMapDictYMap | undefined
  get(key: 'in_unified_audio_config'): UnifiedAudioProjectDictYMap | undefined
  get(key: 'in_style'): string | undefined
  get(key: 'out_video'): GeneratedVideoWithHistoryYMap | undefined
  get(key: 'out_tts_segments'): Array<TtsSegmentDictYMap> | undefined
  get(key: 'out_audio_remix_baseline'): AudioRemixConfigDictYMap | undefined
  get(key: 'out_speech_transformer_spans'): SpeechTransformerDetectionDictYMap | undefined
  get(key: 'out_auto_dialogue'): Array<DialogueEntryDictYMap> | undefined
  get(key: 'out_speech_windows'): Array<SpeechWindowDictYMap> | undefined
  get(key: 'out_native_speech_takes'): Array<NativeSpeechTakeDictYMap> | undefined
  get(key: 'out_native_speech_spans'): Array<NativeSpeechSpanDictYMap> | undefined
  get(key: 'out_native_speech_detect_seq'): number | undefined
  get(key: 'out_video_prompt'): string | undefined
  get(key: 'out_video_duration'): number | undefined
  get(key: 'out_dialogue'): Array<ReconciledDialogueEntryDictYMap> | undefined
  get(key: 'voice_acting_status'): string | undefined
  get(key: 'full_remix_status'): VideoFullRemixStatusV1DictYMap | undefined
  get(key: 'segment_index'): number | undefined
  get(key: 'batch_pending'): number | undefined
  get(key: 'thumbnail'): string | undefined
  get(key: 'action'): string | undefined
  get(key: 'closing_frame_handshake'): number | undefined
  get(key: 'clip_id'): string | undefined
  get(key: 'target_voice_id'): string | undefined
  get(key: 'target_variant_path'): string | undefined
  get(key: 'name_autogen'): string | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'in_reference_media': return _readYDocOptionalArray(this._raw.get('in_reference_media'), "videoGenerator.in_reference_media", (item, itemLabel) => item == null ? null : _readYDocMapWrapper(item, MediaAssetRefDictYMap, itemLabel))
      case 'in_mode': return _readYDocOptionalString(this._raw.get('in_mode'), "videoGenerator.in_mode")
      case 'in_scene_id': return _readYDocOptionalString(this._raw.get('in_scene_id'), "videoGenerator.in_scene_id")
      case 'in_clip_number': return _readYDocOptionalNumber(this._raw.get('in_clip_number'), "videoGenerator.in_clip_number")
      case 'in_images': return _readYDocOptionalArray(this._raw.get('in_images'), "videoGenerator.in_images", (item, itemLabel) => item == null ? null : _readYDocMapWrapper(item, ImageAssetRefDictYMap, itemLabel))
      case 'in_reference_videos': return _readYDocOptionalArray(this._raw.get('in_reference_videos'), "videoGenerator.in_reference_videos", (item, itemLabel) => item == null ? null : _readYDocMapWrapper(item, VideoAssetRefDictYMap, itemLabel))
      case 'in_continuation_source': return _readYDocOptionalMapWrapper(this._raw.get('in_continuation_source'), GeneratedVideoWithHistoryYMap, "videoGenerator.in_continuation_source")
      case 'in_shot_list_source_id': return _readYDocOptionalString(this._raw.get('in_shot_list_source_id'), "videoGenerator.in_shot_list_source_id")
      case 'in_shot_list_source_fingerprint': return _readYDocOptionalString(this._raw.get('in_shot_list_source_fingerprint'), "videoGenerator.in_shot_list_source_fingerprint")
      case 'in_shot_list_request_fingerprint': return _readYDocOptionalString(this._raw.get('in_shot_list_request_fingerprint'), "videoGenerator.in_shot_list_request_fingerprint")
      case 'in_reference_audios': return _readYDocOptionalArray(this._raw.get('in_reference_audios'), "videoGenerator.in_reference_audios", (item, itemLabel) => item == null ? null : _readYDocMapWrapper(item, AudioAssetRefDictYMap, itemLabel))
      case 'in_audio': return _readYDocOptionalMapWrapper(this._raw.get('in_audio'), AudioAssetRefDictYMap, "videoGenerator.in_audio")
      case 'in_motion_prompt': return _readYDocOptionalString(this._raw.get('in_motion_prompt'), "videoGenerator.in_motion_prompt")
      case 'in_scene_context': return _readYDocOptionalString(this._raw.get('in_scene_context'), "videoGenerator.in_scene_context")
      case 'in_duration': return _readYDocOptionalNumber(this._raw.get('in_duration'), "videoGenerator.in_duration")
      case 'in_reference_video_edits': return _readYDocOptionalArray(this._raw.get('in_reference_video_edits'), "videoGenerator.in_reference_video_edits", (item, itemLabel) => _readYDocMapWrapper(item, VideoReferenceEditDictYMap, itemLabel))
      case 'in_dialogue_prompt': return _readYDocOptionalArray(this._raw.get('in_dialogue_prompt'), "videoGenerator.in_dialogue_prompt", (item, itemLabel) => _readYDocMapWrapper(item, DialogueEntryDictYMap, itemLabel))
      case 'in_model': return _readYDocOptionalString(this._raw.get('in_model'), "videoGenerator.in_model")
      case 'in_aspect_ratio': return _readYDocOptionalString(this._raw.get('in_aspect_ratio'), "videoGenerator.in_aspect_ratio")
      case 'in_resolution': return _readYDocOptionalString(this._raw.get('in_resolution'), "videoGenerator.in_resolution")
      case 'in_generate_audio': return _readYDocOptionalBoolean(this._raw.get('in_generate_audio'), "videoGenerator.in_generate_audio")
      case 'in_provider_generate_audio': return _readYDocOptionalBoolean(this._raw.get('in_provider_generate_audio'), "videoGenerator.in_provider_generate_audio")
      case 'in_use_voice_profile_audio_references': return _readYDocOptionalBoolean(this._raw.get('in_use_voice_profile_audio_references'), "videoGenerator.in_use_voice_profile_audio_references")
      case 'in_audio_remix_mode': return (this._raw.get('in_audio_remix_mode') == null ? undefined : _readYDocJsonValue<"off" | "voiceover_only" | "full_remix">(this._raw.get('in_audio_remix_mode'), "videoGenerator.in_audio_remix_mode"))
      case 'in_allow_bgm': return _readYDocOptionalBoolean(this._raw.get('in_allow_bgm'), "videoGenerator.in_allow_bgm")
      case 'in_tts_provider': return _readYDocOptionalString(this._raw.get('in_tts_provider'), "videoGenerator.in_tts_provider")
      case 'in_dub_target_language': return _readYDocOptionalString(this._raw.get('in_dub_target_language'), "videoGenerator.in_dub_target_language")
      case 'in_voice_profiles': return _readYDocOptionalArray(this._raw.get('in_voice_profiles'), "videoGenerator.in_voice_profiles", (item, itemLabel) => item == null ? null : _readYDocMapWrapper(item, VoiceProfileDictYMap, itemLabel))
      case 'in_voice_settings': return _readYDocOptionalMapWrapper(this._raw.get('in_voice_settings'), VoiceSettingsDictYMap, "videoGenerator.in_voice_settings")
      case 'in_name': return _readYDocOptionalString(this._raw.get('in_name'), "videoGenerator.in_name")
      case 'in_resolved_voice_map': return _readYDocOptionalMapWrapper(this._raw.get('in_resolved_voice_map'), ResolvedVoiceMapDictYMap, "videoGenerator.in_resolved_voice_map")
      case 'in_audio_remix_config': return _readYDocOptionalMapWrapper(this._raw.get('in_audio_remix_config'), AudioRemixConfigDictYMap, "videoGenerator.in_audio_remix_config")
      case 'in_speech_transformer_config': return _readYDocOptionalMapWrapper(this._raw.get('in_speech_transformer_config'), SpeechTransformerConfigDictYMap, "videoGenerator.in_speech_transformer_config")
      case 'in_audio_take_selections': return _readYDocOptionalMapWrapper(this._raw.get('in_audio_take_selections'), AudioTakeSelectionMapDictYMap, "videoGenerator.in_audio_take_selections")
      case 'in_audio_variant_workspaces': return _readYDocOptionalMapWrapper(this._raw.get('in_audio_variant_workspaces'), AudioVariantWorkspaceMapDictYMap, "videoGenerator.in_audio_variant_workspaces")
      case 'in_unified_audio_config': return _readYDocOptionalMapWrapper(this._raw.get('in_unified_audio_config'), UnifiedAudioProjectDictYMap, "videoGenerator.in_unified_audio_config")
      case 'in_style': return _readYDocOptionalString(this._raw.get('in_style'), "videoGenerator.in_style")
      case 'out_video': return _readYDocOptionalMapWrapper(this._raw.get('out_video'), GeneratedVideoWithHistoryYMap, "videoGenerator.out_video")
      case 'out_tts_segments': return _readYDocOptionalArray(this._raw.get('out_tts_segments'), "videoGenerator.out_tts_segments", (item, itemLabel) => _readYDocMapWrapper(item, TtsSegmentDictYMap, itemLabel))
      case 'out_audio_remix_baseline': return _readYDocOptionalMapWrapper(this._raw.get('out_audio_remix_baseline'), AudioRemixConfigDictYMap, "videoGenerator.out_audio_remix_baseline")
      case 'out_speech_transformer_spans': return _readYDocOptionalMapWrapper(this._raw.get('out_speech_transformer_spans'), SpeechTransformerDetectionDictYMap, "videoGenerator.out_speech_transformer_spans")
      case 'out_auto_dialogue': return _readYDocOptionalArray(this._raw.get('out_auto_dialogue'), "videoGenerator.out_auto_dialogue", (item, itemLabel) => _readYDocMapWrapper(item, DialogueEntryDictYMap, itemLabel))
      case 'out_speech_windows': return _readYDocOptionalArray(this._raw.get('out_speech_windows'), "videoGenerator.out_speech_windows", (item, itemLabel) => _readYDocMapWrapper(item, SpeechWindowDictYMap, itemLabel))
      case 'out_native_speech_takes': return _readYDocOptionalArray(this._raw.get('out_native_speech_takes'), "videoGenerator.out_native_speech_takes", (item, itemLabel) => _readYDocMapWrapper(item, NativeSpeechTakeDictYMap, itemLabel))
      case 'out_native_speech_spans': return _readYDocOptionalArray(this._raw.get('out_native_speech_spans'), "videoGenerator.out_native_speech_spans", (item, itemLabel) => _readYDocMapWrapper(item, NativeSpeechSpanDictYMap, itemLabel))
      case 'out_native_speech_detect_seq': return _readYDocOptionalNumber(this._raw.get('out_native_speech_detect_seq'), "videoGenerator.out_native_speech_detect_seq")
      case 'out_video_prompt': return _readYDocOptionalString(this._raw.get('out_video_prompt'), "videoGenerator.out_video_prompt")
      case 'out_video_duration': return _readYDocOptionalNumber(this._raw.get('out_video_duration'), "videoGenerator.out_video_duration")
      case 'out_dialogue': return _readYDocOptionalArray(this._raw.get('out_dialogue'), "videoGenerator.out_dialogue", (item, itemLabel) => _readYDocMapWrapper(item, ReconciledDialogueEntryDictYMap, itemLabel))
      case 'voice_acting_status': return _readYDocOptionalString(this._raw.get('voice_acting_status'), "videoGenerator.voice_acting_status")
      case 'full_remix_status': return _readYDocOptionalMapWrapper(this._raw.get('full_remix_status'), VideoFullRemixStatusV1DictYMap, "videoGenerator.full_remix_status")
      case 'segment_index': return _readYDocOptionalNumber(this._raw.get('segment_index'), "videoGenerator.segment_index")
      case 'batch_pending': return _readYDocOptionalNumber(this._raw.get('batch_pending'), "videoGenerator.batch_pending")
      case 'thumbnail': return _readYDocOptionalString(this._raw.get('thumbnail'), "videoGenerator.thumbnail")
      case 'action': return _readYDocOptionalString(this._raw.get('action'), "videoGenerator.action")
      case 'closing_frame_handshake': return _readYDocOptionalNumber(this._raw.get('closing_frame_handshake'), "videoGenerator.closing_frame_handshake")
      case 'clip_id': return _readYDocOptionalString(this._raw.get('clip_id'), "videoGenerator.clip_id")
      case 'target_voice_id': return _readYDocOptionalString(this._raw.get('target_voice_id'), "videoGenerator.target_voice_id")
      case 'target_variant_path': return _readYDocOptionalString(this._raw.get('target_variant_path'), "videoGenerator.target_variant_path")
      case 'name_autogen': return _readYDocOptionalString(this._raw.get('name_autogen'), "videoGenerator.name_autogen")
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "in_reference_media" | "in_mode" | "in_scene_id" | "in_clip_number" | "in_images" | "in_reference_videos" | "in_continuation_source" | "in_shot_list_source_id" | "in_shot_list_source_fingerprint" | "in_shot_list_request_fingerprint" | "in_reference_audios" | "in_audio" | "in_motion_prompt" | "in_scene_context" | "in_duration" | "in_reference_video_edits" | "in_dialogue_prompt" | "in_model" | "in_aspect_ratio" | "in_resolution" | "in_generate_audio" | "in_provider_generate_audio" | "in_use_voice_profile_audio_references" | "in_audio_remix_mode" | "in_allow_bgm" | "in_tts_provider" | "in_dub_target_language" | "in_voice_profiles" | "in_voice_settings" | "in_name" | "in_resolved_voice_map" | "in_audio_remix_config" | "in_speech_transformer_config" | "in_audio_take_selections" | "in_audio_variant_workspaces" | "in_unified_audio_config" | "in_style" | "out_video" | "out_tts_segments" | "out_audio_remix_baseline" | "out_speech_transformer_spans" | "out_auto_dialogue" | "out_speech_windows" | "out_native_speech_takes" | "out_native_speech_spans" | "out_native_speech_detect_seq" | "out_video_prompt" | "out_video_duration" | "out_dialogue" | "voice_acting_status" | "full_remix_status" | "segment_index" | "batch_pending" | "thumbnail" | "action" | "closing_frame_handshake" | "clip_id" | "target_voice_id" | "target_variant_path" | "name_autogen" | "revision"): void { this._raw.delete(key) }
  has(key: "type" | "in_reference_media" | "in_mode" | "in_scene_id" | "in_clip_number" | "in_images" | "in_reference_videos" | "in_continuation_source" | "in_shot_list_source_id" | "in_shot_list_source_fingerprint" | "in_shot_list_request_fingerprint" | "in_reference_audios" | "in_audio" | "in_motion_prompt" | "in_scene_context" | "in_duration" | "in_reference_video_edits" | "in_dialogue_prompt" | "in_model" | "in_aspect_ratio" | "in_resolution" | "in_generate_audio" | "in_provider_generate_audio" | "in_use_voice_profile_audio_references" | "in_audio_remix_mode" | "in_allow_bgm" | "in_tts_provider" | "in_dub_target_language" | "in_voice_profiles" | "in_voice_settings" | "in_name" | "in_resolved_voice_map" | "in_audio_remix_config" | "in_speech_transformer_config" | "in_audio_take_selections" | "in_audio_variant_workspaces" | "in_unified_audio_config" | "in_style" | "out_video" | "out_tts_segments" | "out_audio_remix_baseline" | "out_speech_transformer_spans" | "out_auto_dialogue" | "out_speech_windows" | "out_native_speech_takes" | "out_native_speech_spans" | "out_native_speech_detect_seq" | "out_video_prompt" | "out_video_duration" | "out_dialogue" | "voice_acting_status" | "full_remix_status" | "segment_index" | "batch_pending" | "thumbnail" | "action" | "closing_frame_handshake" | "clip_id" | "target_voice_id" | "target_variant_path" | "name_autogen" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<VideoGeneratorNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this._writeDataField(field as keyof VideoGeneratorNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof VideoGeneratorNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'in_reference_media': return this.writeInReferenceMedia(value as Exclude<VideoGeneratorNodeWriteData['in_reference_media'], undefined>, opts)
      case 'in_mode': return this.writeInMode(value as Exclude<VideoGeneratorNodeWriteData['in_mode'], undefined>, opts)
      case 'in_scene_id': return this.writeInSceneId(value as Exclude<VideoGeneratorNodeWriteData['in_scene_id'], undefined>, opts)
      case 'in_clip_number': return this.writeInClipNumber(value as Exclude<VideoGeneratorNodeWriteData['in_clip_number'], undefined>, opts)
      case 'in_images': return this.writeInImages(value as Exclude<VideoGeneratorNodeWriteData['in_images'], undefined>, opts)
      case 'in_reference_videos': return this.writeInReferenceVideos(value as Exclude<VideoGeneratorNodeWriteData['in_reference_videos'], undefined>, opts)
      case 'in_continuation_source': return this.writeInContinuationSource(value as Exclude<VideoGeneratorNodeWriteData['in_continuation_source'], undefined>, opts)
      case 'in_shot_list_source_id': return this.writeInShotListSourceId(value as Exclude<VideoGeneratorNodeWriteData['in_shot_list_source_id'], undefined>, opts)
      case 'in_shot_list_source_fingerprint': return this.writeInShotListSourceFingerprint(value as Exclude<VideoGeneratorNodeWriteData['in_shot_list_source_fingerprint'], undefined>, opts)
      case 'in_shot_list_request_fingerprint': return this.writeInShotListRequestFingerprint(value as Exclude<VideoGeneratorNodeWriteData['in_shot_list_request_fingerprint'], undefined>, opts)
      case 'in_reference_audios': return this.writeInReferenceAudios(value as Exclude<VideoGeneratorNodeWriteData['in_reference_audios'], undefined>, opts)
      case 'in_audio': return this.writeInAudio(value as Exclude<VideoGeneratorNodeWriteData['in_audio'], undefined>, opts)
      case 'in_motion_prompt': return this.writeInMotionPrompt(value as Exclude<VideoGeneratorNodeWriteData['in_motion_prompt'], undefined>, opts)
      case 'in_scene_context': return this.writeInSceneContext(value as Exclude<VideoGeneratorNodeWriteData['in_scene_context'], undefined>, opts)
      case 'in_duration': return this.writeInDuration(value as Exclude<VideoGeneratorNodeWriteData['in_duration'], undefined>, opts)
      case 'in_reference_video_edits': return this.writeInReferenceVideoEdits(value as Exclude<VideoGeneratorNodeWriteData['in_reference_video_edits'], undefined>, opts)
      case 'in_dialogue_prompt': return this.writeInDialoguePrompt(value as Exclude<VideoGeneratorNodeWriteData['in_dialogue_prompt'], undefined>, opts)
      case 'in_model': return this.writeInModel(value as Exclude<VideoGeneratorNodeWriteData['in_model'], undefined>, opts)
      case 'in_aspect_ratio': return this.writeInAspectRatio(value as Exclude<VideoGeneratorNodeWriteData['in_aspect_ratio'], undefined>, opts)
      case 'in_resolution': return this.writeInResolution(value as Exclude<VideoGeneratorNodeWriteData['in_resolution'], undefined>, opts)
      case 'in_generate_audio': return this.writeInGenerateAudio(value as Exclude<VideoGeneratorNodeWriteData['in_generate_audio'], undefined>, opts)
      case 'in_provider_generate_audio': return this.writeInProviderGenerateAudio(value as Exclude<VideoGeneratorNodeWriteData['in_provider_generate_audio'], undefined>, opts)
      case 'in_use_voice_profile_audio_references': return this.writeInUseVoiceProfileAudioReferences(value as Exclude<VideoGeneratorNodeWriteData['in_use_voice_profile_audio_references'], undefined>, opts)
      case 'in_audio_remix_mode': return this.writeInAudioRemixMode(value as Exclude<VideoGeneratorNodeWriteData['in_audio_remix_mode'], undefined>, opts)
      case 'in_allow_bgm': return this.writeInAllowBgm(value as Exclude<VideoGeneratorNodeWriteData['in_allow_bgm'], undefined>, opts)
      case 'in_tts_provider': return this.writeInTtsProvider(value as Exclude<VideoGeneratorNodeWriteData['in_tts_provider'], undefined>, opts)
      case 'in_dub_target_language': return this.writeInDubTargetLanguage(value as Exclude<VideoGeneratorNodeWriteData['in_dub_target_language'], undefined>, opts)
      case 'in_voice_profiles': return this.writeInVoiceProfiles(value as Exclude<VideoGeneratorNodeWriteData['in_voice_profiles'], undefined>, opts)
      case 'in_voice_settings': return this.writeInVoiceSettings(value as Exclude<VideoGeneratorNodeWriteData['in_voice_settings'], undefined>, opts)
      case 'in_name': return this.writeInName(value as Exclude<VideoGeneratorNodeWriteData['in_name'], undefined>, opts)
      case 'in_resolved_voice_map': return this.writeInResolvedVoiceMap(value as Exclude<VideoGeneratorNodeWriteData['in_resolved_voice_map'], undefined>, opts)
      case 'in_audio_remix_config': return this.writeInAudioRemixConfig(value as Exclude<VideoGeneratorNodeWriteData['in_audio_remix_config'], undefined>, opts)
      case 'in_speech_transformer_config': return this.writeInSpeechTransformerConfig(value as Exclude<VideoGeneratorNodeWriteData['in_speech_transformer_config'], undefined>, opts)
      case 'in_audio_take_selections': return this.writeInAudioTakeSelections(value as Exclude<VideoGeneratorNodeWriteData['in_audio_take_selections'], undefined>, opts)
      case 'in_audio_variant_workspaces': return this.writeInAudioVariantWorkspaces(value as Exclude<VideoGeneratorNodeWriteData['in_audio_variant_workspaces'], undefined>, opts)
      case 'in_unified_audio_config': return this.writeInUnifiedAudioConfig(value as Exclude<VideoGeneratorNodeWriteData['in_unified_audio_config'], undefined>, opts)
      case 'in_style': return this.writeInStyle(value as Exclude<VideoGeneratorNodeWriteData['in_style'], undefined>, opts)
      case 'out_video': return this.writeOutVideo(value as Exclude<VideoGeneratorNodeWriteData['out_video'], undefined>, opts)
      case 'out_tts_segments': return this.writeOutTtsSegments(value as Exclude<VideoGeneratorNodeWriteData['out_tts_segments'], undefined>, opts)
      case 'out_audio_remix_baseline': return this.writeOutAudioRemixBaseline(value as Exclude<VideoGeneratorNodeWriteData['out_audio_remix_baseline'], undefined>, opts)
      case 'out_speech_transformer_spans': return this.writeOutSpeechTransformerSpans(value as Exclude<VideoGeneratorNodeWriteData['out_speech_transformer_spans'], undefined>, opts)
      case 'out_auto_dialogue': return this.writeOutAutoDialogue(value as Exclude<VideoGeneratorNodeWriteData['out_auto_dialogue'], undefined>, opts)
      case 'out_speech_windows': return this.writeOutSpeechWindows(value as Exclude<VideoGeneratorNodeWriteData['out_speech_windows'], undefined>, opts)
      case 'out_native_speech_takes': return this.writeOutNativeSpeechTakes(value as Exclude<VideoGeneratorNodeWriteData['out_native_speech_takes'], undefined>, opts)
      case 'out_native_speech_spans': return this.writeOutNativeSpeechSpans(value as Exclude<VideoGeneratorNodeWriteData['out_native_speech_spans'], undefined>, opts)
      case 'out_native_speech_detect_seq': return this.writeOutNativeSpeechDetectSeq(value as Exclude<VideoGeneratorNodeWriteData['out_native_speech_detect_seq'], undefined>, opts)
      case 'out_video_prompt': return this.writeOutVideoPrompt(value as Exclude<VideoGeneratorNodeWriteData['out_video_prompt'], undefined>, opts)
      case 'out_video_duration': return this.writeOutVideoDuration(value as Exclude<VideoGeneratorNodeWriteData['out_video_duration'], undefined>, opts)
      case 'out_dialogue': return this.writeOutDialogue(value as Exclude<VideoGeneratorNodeWriteData['out_dialogue'], undefined>, opts)
      case 'voice_acting_status': return this.writeVoiceActingStatus(value as Exclude<VideoGeneratorNodeWriteData['voice_acting_status'], undefined>, opts)
      case 'full_remix_status': return this.writeFullRemixStatus(value as Exclude<VideoGeneratorNodeWriteData['full_remix_status'], undefined>, opts)
      case 'segment_index': return this.writeSegmentIndex(value as Exclude<VideoGeneratorNodeWriteData['segment_index'], undefined>, opts)
      case 'batch_pending': return this.writeBatchPending(value as Exclude<VideoGeneratorNodeWriteData['batch_pending'], undefined>, opts)
      case 'thumbnail': return this.writeThumbnail(value as Exclude<VideoGeneratorNodeWriteData['thumbnail'], undefined>, opts)
      case 'action': return this.writeAction(value as Exclude<VideoGeneratorNodeWriteData['action'], undefined>, opts)
      case 'closing_frame_handshake': return this.writeClosingFrameHandshake(value as Exclude<VideoGeneratorNodeWriteData['closing_frame_handshake'], undefined>, opts)
      case 'clip_id': return this.writeClipId(value as Exclude<VideoGeneratorNodeWriteData['clip_id'], undefined>, opts)
      case 'target_voice_id': return this.writeTargetVoiceId(value as Exclude<VideoGeneratorNodeWriteData['target_voice_id'], undefined>, opts)
      case 'target_variant_path': return this.writeTargetVariantPath(value as Exclude<VideoGeneratorNodeWriteData['target_variant_path'], undefined>, opts)
      case 'name_autogen': return this.writeNameAutogen(value as Exclude<VideoGeneratorNodeWriteData['name_autogen'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writeInReferenceMedia(value: Exclude<VideoGeneratorNodeWriteData['in_reference_media'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_reference_media', 'array', value, opts, false, undefined, undefined)
  }

  writeInMode(value: Exclude<VideoGeneratorNodeWriteData['in_mode'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_mode', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInSceneId(value: Exclude<VideoGeneratorNodeWriteData['in_scene_id'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_scene_id', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInClipNumber(value: Exclude<VideoGeneratorNodeWriteData['in_clip_number'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_clip_number', 'primitive', value, opts, false, 'number', undefined)
  }

  writeInImages(value: Exclude<VideoGeneratorNodeWriteData['in_images'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_images', 'array', value, opts, false, undefined, undefined)
  }

  writeInReferenceVideos(value: Exclude<VideoGeneratorNodeWriteData['in_reference_videos'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_reference_videos', 'array', value, opts, false, undefined, (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => { if (item !== null) _validateYDocVideoAssetRefDict(item, itemLabel) }))
  }

  writeInContinuationSource(value: Exclude<VideoGeneratorNodeWriteData['in_continuation_source'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_continuation_source', 'map', value, opts, false, undefined, _validateYDocGeneratedVideoWithHistory)
  }

  writeInShotListSourceId(value: Exclude<VideoGeneratorNodeWriteData['in_shot_list_source_id'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_shot_list_source_id', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInShotListSourceFingerprint(value: Exclude<VideoGeneratorNodeWriteData['in_shot_list_source_fingerprint'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_shot_list_source_fingerprint', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInShotListRequestFingerprint(value: Exclude<VideoGeneratorNodeWriteData['in_shot_list_request_fingerprint'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_shot_list_request_fingerprint', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInReferenceAudios(value: Exclude<VideoGeneratorNodeWriteData['in_reference_audios'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_reference_audios', 'array', value, opts, false, undefined, undefined)
  }

  writeInAudio(value: Exclude<VideoGeneratorNodeWriteData['in_audio'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_audio', 'map', value, opts, false, undefined, undefined)
  }

  writeInMotionPrompt(value: Exclude<VideoGeneratorNodeWriteData['in_motion_prompt'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_motion_prompt', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInSceneContext(value: Exclude<VideoGeneratorNodeWriteData['in_scene_context'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_scene_context', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInDuration(value: Exclude<VideoGeneratorNodeWriteData['in_duration'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_duration', 'primitive', value, opts, false, 'number', undefined)
  }

  writeInReferenceVideoEdits(value: Exclude<VideoGeneratorNodeWriteData['in_reference_video_edits'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_reference_video_edits', 'array', value, opts, false, undefined, undefined)
  }

  writeInDialoguePrompt(value: Exclude<VideoGeneratorNodeWriteData['in_dialogue_prompt'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_dialogue_prompt', 'array', value, opts, false, undefined, undefined)
  }

  writeInModel(value: Exclude<VideoGeneratorNodeWriteData['in_model'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_model', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInAspectRatio(value: Exclude<VideoGeneratorNodeWriteData['in_aspect_ratio'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_aspect_ratio', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInResolution(value: Exclude<VideoGeneratorNodeWriteData['in_resolution'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_resolution', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInGenerateAudio(value: Exclude<VideoGeneratorNodeWriteData['in_generate_audio'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_generate_audio', 'primitive', value, opts, false, 'boolean', undefined)
  }

  writeInProviderGenerateAudio(value: Exclude<VideoGeneratorNodeWriteData['in_provider_generate_audio'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_provider_generate_audio', 'primitive', value, opts, false, 'boolean', undefined)
  }

  writeInUseVoiceProfileAudioReferences(value: Exclude<VideoGeneratorNodeWriteData['in_use_voice_profile_audio_references'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_use_voice_profile_audio_references', 'primitive', value, opts, false, 'boolean', undefined)
  }

  writeInAudioRemixMode(value: Exclude<VideoGeneratorNodeWriteData['in_audio_remix_mode'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_audio_remix_mode', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInAllowBgm(value: Exclude<VideoGeneratorNodeWriteData['in_allow_bgm'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_allow_bgm', 'primitive', value, opts, false, 'boolean', undefined)
  }

  writeInTtsProvider(value: Exclude<VideoGeneratorNodeWriteData['in_tts_provider'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_tts_provider', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInDubTargetLanguage(value: Exclude<VideoGeneratorNodeWriteData['in_dub_target_language'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_dub_target_language', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInVoiceProfiles(value: Exclude<VideoGeneratorNodeWriteData['in_voice_profiles'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_voice_profiles', 'array', value, opts, false, undefined, undefined)
  }

  writeInVoiceSettings(value: Exclude<VideoGeneratorNodeWriteData['in_voice_settings'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_voice_settings', 'map', value, opts, false, undefined, undefined)
  }

  writeInName(value: Exclude<VideoGeneratorNodeWriteData['in_name'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_name', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInResolvedVoiceMap(value: Exclude<VideoGeneratorNodeWriteData['in_resolved_voice_map'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_resolved_voice_map', 'map', value, opts, false, undefined, undefined)
  }

  writeInAudioRemixConfig(value: Exclude<VideoGeneratorNodeWriteData['in_audio_remix_config'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_audio_remix_config', 'map', value, opts, false, undefined, undefined)
  }

  writeInSpeechTransformerConfig(value: Exclude<VideoGeneratorNodeWriteData['in_speech_transformer_config'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_speech_transformer_config', 'map', value, opts, false, undefined, undefined)
  }

  writeInAudioTakeSelections(value: Exclude<VideoGeneratorNodeWriteData['in_audio_take_selections'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_audio_take_selections', 'map', value, opts, false, undefined, undefined)
  }

  writeInAudioVariantWorkspaces(value: Exclude<VideoGeneratorNodeWriteData['in_audio_variant_workspaces'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_audio_variant_workspaces', 'map', value, opts, false, undefined, _validateYDocAudioVariantWorkspaceMapDict)
  }

  writeInUnifiedAudioConfig(value: Exclude<VideoGeneratorNodeWriteData['in_unified_audio_config'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_unified_audio_config', 'map', value, opts, false, undefined, undefined)
  }

  writeInStyle(value: Exclude<VideoGeneratorNodeWriteData['in_style'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_style', 'primitive', value, opts, false, 'string', undefined)
  }

  writeOutVideo(value: Exclude<VideoGeneratorNodeWriteData['out_video'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_video', 'map', value, opts, false, undefined, _validateYDocGeneratedVideoWithHistory)
  }

  writeOutTtsSegments(value: Exclude<VideoGeneratorNodeWriteData['out_tts_segments'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_tts_segments', 'array', value, opts, false, undefined, undefined)
  }

  writeOutAudioRemixBaseline(value: Exclude<VideoGeneratorNodeWriteData['out_audio_remix_baseline'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_audio_remix_baseline', 'map', value, opts, false, undefined, undefined)
  }

  writeOutSpeechTransformerSpans(value: Exclude<VideoGeneratorNodeWriteData['out_speech_transformer_spans'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_speech_transformer_spans', 'map', value, opts, false, undefined, undefined)
  }

  writeOutAutoDialogue(value: Exclude<VideoGeneratorNodeWriteData['out_auto_dialogue'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_auto_dialogue', 'array', value, opts, false, undefined, undefined)
  }

  writeOutSpeechWindows(value: Exclude<VideoGeneratorNodeWriteData['out_speech_windows'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_speech_windows', 'array', value, opts, false, undefined, undefined)
  }

  writeOutNativeSpeechTakes(value: Exclude<VideoGeneratorNodeWriteData['out_native_speech_takes'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_native_speech_takes', 'array', value, opts, false, undefined, undefined)
  }

  writeOutNativeSpeechSpans(value: Exclude<VideoGeneratorNodeWriteData['out_native_speech_spans'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_native_speech_spans', 'array', value, opts, false, undefined, undefined)
  }

  writeOutNativeSpeechDetectSeq(value: Exclude<VideoGeneratorNodeWriteData['out_native_speech_detect_seq'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_native_speech_detect_seq', 'primitive', value, opts, false, 'number', undefined)
  }

  writeOutVideoPrompt(value: Exclude<VideoGeneratorNodeWriteData['out_video_prompt'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_video_prompt', 'primitive', value, opts, false, 'string', undefined)
  }

  writeOutVideoDuration(value: Exclude<VideoGeneratorNodeWriteData['out_video_duration'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_video_duration', 'primitive', value, opts, false, 'number', undefined)
  }

  writeOutDialogue(value: Exclude<VideoGeneratorNodeWriteData['out_dialogue'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_dialogue', 'array', value, opts, false, undefined, undefined)
  }

  writeVoiceActingStatus(value: Exclude<VideoGeneratorNodeWriteData['voice_acting_status'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('voice_acting_status', 'primitive', value, opts, false, 'string', undefined)
  }

  writeFullRemixStatus(value: Exclude<VideoGeneratorNodeWriteData['full_remix_status'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('full_remix_status', 'map', value, opts, false, undefined, _validateYDocVideoFullRemixStatusV1Dict)
  }

  writeSegmentIndex(value: Exclude<VideoGeneratorNodeWriteData['segment_index'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('segment_index', 'primitive', value, opts, false, 'number', undefined)
  }

  writeBatchPending(value: Exclude<VideoGeneratorNodeWriteData['batch_pending'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('batch_pending', 'primitive', value, opts, false, 'number', undefined)
  }

  writeThumbnail(value: Exclude<VideoGeneratorNodeWriteData['thumbnail'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('thumbnail', 'primitive', value, opts, false, 'string', undefined)
  }

  writeAction(value: Exclude<VideoGeneratorNodeWriteData['action'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('action', 'primitive', value, opts, false, 'string', undefined)
  }

  writeClosingFrameHandshake(value: Exclude<VideoGeneratorNodeWriteData['closing_frame_handshake'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('closing_frame_handshake', 'primitive', value, opts, false, 'number', undefined)
  }

  writeClipId(value: Exclude<VideoGeneratorNodeWriteData['clip_id'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('clip_id', 'primitive', value, opts, false, 'string', undefined)
  }

  writeTargetVoiceId(value: Exclude<VideoGeneratorNodeWriteData['target_voice_id'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('target_voice_id', 'primitive', value, opts, false, 'string', undefined)
  }

  writeTargetVariantPath(value: Exclude<VideoGeneratorNodeWriteData['target_variant_path'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('target_variant_path', 'primitive', value, opts, false, 'string', undefined)
  }

  writeNameAutogen(value: Exclude<VideoGeneratorNodeWriteData['name_autogen'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('name_autogen', 'primitive', value, opts, false, 'string', undefined)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolveVideoGeneratorInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    switch (targetHandle) {
      case 'in_reference_media': {
        const value = _resolveVideoGeneratorInReferenceMediaInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_reference_media')
        if (hadPersistedValue) this.delete('in_reference_media')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_reference_media', value, written }
      }
      case 'in_mode': {
        const value = _resolveVideoGeneratorInModeInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInMode(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_mode'], undefined>)
        return { field: 'in_mode', value, written }
      }
      case 'in_scene_id': {
        const value = _resolveVideoGeneratorInSceneIdInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInSceneId(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_scene_id'], undefined>)
        return { field: 'in_scene_id', value, written }
      }
      case 'in_clip_number': {
        const value = _resolveVideoGeneratorInClipNumberInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInClipNumber(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_clip_number'], undefined>)
        return { field: 'in_clip_number', value, written }
      }
      case 'in_images': {
        const value = _resolveVideoGeneratorInImagesInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_images')
        if (hadPersistedValue) this.delete('in_images')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_images', value, written }
      }
      case 'in_reference_videos': {
        const value = _resolveVideoGeneratorInReferenceVideosInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_reference_videos')
        if (hadPersistedValue) this.delete('in_reference_videos')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_reference_videos', value, written }
      }
      case 'in_continuation_source': {
        const value = _resolveVideoGeneratorInContinuationSourceInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInContinuationSource(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_continuation_source'], undefined>)
        return { field: 'in_continuation_source', value, written }
      }
      case 'in_shot_list_source_id': {
        const value = _resolveVideoGeneratorInShotListSourceIdInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInShotListSourceId(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_shot_list_source_id'], undefined>)
        return { field: 'in_shot_list_source_id', value, written }
      }
      case 'in_shot_list_source_fingerprint': {
        const value = _resolveVideoGeneratorInShotListSourceFingerprintInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInShotListSourceFingerprint(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_shot_list_source_fingerprint'], undefined>)
        return { field: 'in_shot_list_source_fingerprint', value, written }
      }
      case 'in_shot_list_request_fingerprint': {
        const value = _resolveVideoGeneratorInShotListRequestFingerprintInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInShotListRequestFingerprint(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_shot_list_request_fingerprint'], undefined>)
        return { field: 'in_shot_list_request_fingerprint', value, written }
      }
      case 'in_reference_audios': {
        const value = _resolveVideoGeneratorInReferenceAudiosInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_reference_audios')
        if (hadPersistedValue) this.delete('in_reference_audios')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_reference_audios', value, written }
      }
      case 'in_audio': {
        const value = _resolveVideoGeneratorInAudioInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_audio')
        if (hadPersistedValue) this.delete('in_audio')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_audio', value, written }
      }
      case 'in_motion_prompt': {
        const value = _resolveVideoGeneratorInMotionPromptInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInMotionPrompt(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_motion_prompt'], undefined>)
        return { field: 'in_motion_prompt', value, written }
      }
      case 'in_scene_context': {
        const value = _resolveVideoGeneratorInSceneContextInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInSceneContext(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_scene_context'], undefined>)
        return { field: 'in_scene_context', value, written }
      }
      case 'in_duration': {
        const value = _resolveVideoGeneratorInDurationInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInDuration(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_duration'], undefined>)
        return { field: 'in_duration', value, written }
      }
      case 'in_reference_video_edits': {
        const value = _resolveVideoGeneratorInReferenceVideoEditsInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInReferenceVideoEdits(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_reference_video_edits'], undefined>)
        return { field: 'in_reference_video_edits', value, written }
      }
      case 'in_dialogue_prompt': {
        const value = _resolveVideoGeneratorInDialoguePromptInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_dialogue_prompt')
        if (hadPersistedValue) this.delete('in_dialogue_prompt')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_dialogue_prompt', value, written }
      }
      case 'in_model': {
        const value = _resolveVideoGeneratorInModelInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInModel(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_model'], undefined>)
        return { field: 'in_model', value, written }
      }
      case 'in_aspect_ratio': {
        const value = _resolveVideoGeneratorInAspectRatioInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInAspectRatio(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_aspect_ratio'], undefined>)
        return { field: 'in_aspect_ratio', value, written }
      }
      case 'in_resolution': {
        const value = _resolveVideoGeneratorInResolutionInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInResolution(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_resolution'], undefined>)
        return { field: 'in_resolution', value, written }
      }
      case 'in_generate_audio': {
        const value = _resolveVideoGeneratorInGenerateAudioInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInGenerateAudio(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_generate_audio'], undefined>)
        return { field: 'in_generate_audio', value, written }
      }
      case 'in_provider_generate_audio': {
        const value = _resolveVideoGeneratorInProviderGenerateAudioInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInProviderGenerateAudio(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_provider_generate_audio'], undefined>)
        return { field: 'in_provider_generate_audio', value, written }
      }
      case 'in_use_voice_profile_audio_references': {
        const value = _resolveVideoGeneratorInUseVoiceProfileAudioReferencesInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInUseVoiceProfileAudioReferences(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_use_voice_profile_audio_references'], undefined>)
        return { field: 'in_use_voice_profile_audio_references', value, written }
      }
      case 'in_audio_remix_mode': {
        const value = _resolveVideoGeneratorInAudioRemixModeInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInAudioRemixMode(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_audio_remix_mode'], undefined>)
        return { field: 'in_audio_remix_mode', value, written }
      }
      case 'in_allow_bgm': {
        const value = _resolveVideoGeneratorInAllowBgmInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInAllowBgm(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_allow_bgm'], undefined>)
        return { field: 'in_allow_bgm', value, written }
      }
      case 'in_tts_provider': {
        const value = _resolveVideoGeneratorInTtsProviderInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInTtsProvider(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_tts_provider'], undefined>)
        return { field: 'in_tts_provider', value, written }
      }
      case 'in_dub_target_language': {
        const value = _resolveVideoGeneratorInDubTargetLanguageInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInDubTargetLanguage(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_dub_target_language'], undefined>)
        return { field: 'in_dub_target_language', value, written }
      }
      case 'in_voice_profiles': {
        const value = _resolveVideoGeneratorInVoiceProfilesInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_voice_profiles')
        if (hadPersistedValue) this.delete('in_voice_profiles')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_voice_profiles', value, written }
      }
      case 'in_voice_settings': {
        const value = _resolveVideoGeneratorInVoiceSettingsInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInVoiceSettings(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_voice_settings'], undefined>)
        return { field: 'in_voice_settings', value, written }
      }
      case 'in_name': {
        const value = _resolveVideoGeneratorInNameInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInName(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_name'], undefined>)
        return { field: 'in_name', value, written }
      }
      case 'in_resolved_voice_map': {
        const value = _resolveVideoGeneratorInResolvedVoiceMapInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInResolvedVoiceMap(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_resolved_voice_map'], undefined>)
        return { field: 'in_resolved_voice_map', value, written }
      }
      case 'in_audio_remix_config': {
        const value = _resolveVideoGeneratorInAudioRemixConfigInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInAudioRemixConfig(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_audio_remix_config'], undefined>)
        return { field: 'in_audio_remix_config', value, written }
      }
      case 'in_speech_transformer_config': {
        const value = _resolveVideoGeneratorInSpeechTransformerConfigInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInSpeechTransformerConfig(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_speech_transformer_config'], undefined>)
        return { field: 'in_speech_transformer_config', value, written }
      }
      case 'in_audio_take_selections': {
        const value = _resolveVideoGeneratorInAudioTakeSelectionsInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInAudioTakeSelections(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_audio_take_selections'], undefined>)
        return { field: 'in_audio_take_selections', value, written }
      }
      case 'in_audio_variant_workspaces': {
        const value = _resolveVideoGeneratorInAudioVariantWorkspacesInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInAudioVariantWorkspaces(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_audio_variant_workspaces'], undefined>)
        return { field: 'in_audio_variant_workspaces', value, written }
      }
      case 'in_unified_audio_config': {
        const value = _resolveVideoGeneratorInUnifiedAudioConfigInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInUnifiedAudioConfig(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_unified_audio_config'], undefined>)
        return { field: 'in_unified_audio_config', value, written }
      }
      case 'in_style': {
        const value = _resolveVideoGeneratorInStyleInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInStyle(value as unknown as Exclude<VideoGeneratorNodeWriteData['in_style'], undefined>)
        return { field: 'in_style', value, written }
      }
      default:
        throw new Error(`Unknown input port ${targetHandle} for VideoGeneratorCanvasNode`)
    }
  }
}

export class WebtoonGroupCanvasNode extends GeneratedCanvasNode<WebtoonGroupNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  get(key: 'type'): "webtoonGroup" | undefined
  get(key: 'in_scene_id'): string | undefined
  get(key: 'in_label'): string | undefined
  get(key: 'in_collapsed'): boolean | undefined
  get(key: 'in_child_node_ids'): Array<string> | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'in_scene_id': return _readYDocOptionalString(this._raw.get('in_scene_id'), "webtoonGroup.in_scene_id")
      case 'in_label': return _readYDocOptionalString(this._raw.get('in_label'), "webtoonGroup.in_label")
      case 'in_collapsed': return _readYDocOptionalBoolean(this._raw.get('in_collapsed'), "webtoonGroup.in_collapsed")
      case 'in_child_node_ids': return _readYDocOptionalArray(this._raw.get('in_child_node_ids'), "webtoonGroup.in_child_node_ids", (item, itemLabel) => _readYDocString(item, itemLabel))
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "in_scene_id" | "in_label" | "in_collapsed" | "in_child_node_ids" | "revision"): void { this._raw.delete(key) }
  has(key: "type" | "in_scene_id" | "in_label" | "in_collapsed" | "in_child_node_ids" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<WebtoonGroupNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this._writeDataField(field as keyof WebtoonGroupNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof WebtoonGroupNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'in_scene_id': return this.writeInSceneId(value as Exclude<WebtoonGroupNodeWriteData['in_scene_id'], undefined>, opts)
      case 'in_label': return this.writeInLabel(value as Exclude<WebtoonGroupNodeWriteData['in_label'], undefined>, opts)
      case 'in_collapsed': return this.writeInCollapsed(value as Exclude<WebtoonGroupNodeWriteData['in_collapsed'], undefined>, opts)
      case 'in_child_node_ids': return this.writeInChildNodeIds(value as Exclude<WebtoonGroupNodeWriteData['in_child_node_ids'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writeInSceneId(value: Exclude<WebtoonGroupNodeWriteData['in_scene_id'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_scene_id', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInLabel(value: Exclude<WebtoonGroupNodeWriteData['in_label'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_label', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInCollapsed(value: Exclude<WebtoonGroupNodeWriteData['in_collapsed'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_collapsed', 'primitive', value, opts, false, 'boolean', undefined)
  }

  writeInChildNodeIds(value: Exclude<WebtoonGroupNodeWriteData['in_child_node_ids'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_child_node_ids', 'array', value, opts, false, undefined, undefined)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolveWebtoonGroupInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    switch (targetHandle) {
      case 'in_scene_id': {
        const value = _resolveWebtoonGroupInSceneIdInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInSceneId(value as unknown as Exclude<WebtoonGroupNodeWriteData['in_scene_id'], undefined>)
        return { field: 'in_scene_id', value, written }
      }
      case 'in_label': {
        const value = _resolveWebtoonGroupInLabelInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInLabel(value as unknown as Exclude<WebtoonGroupNodeWriteData['in_label'], undefined>)
        return { field: 'in_label', value, written }
      }
      case 'in_collapsed': {
        const value = _resolveWebtoonGroupInCollapsedInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInCollapsed(value as unknown as Exclude<WebtoonGroupNodeWriteData['in_collapsed'], undefined>)
        return { field: 'in_collapsed', value, written }
      }
      case 'in_child_node_ids': {
        const value = _resolveWebtoonGroupInChildNodeIdsInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInChildNodeIds(value as unknown as Exclude<WebtoonGroupNodeWriteData['in_child_node_ids'], undefined>)
        return { field: 'in_child_node_ids', value, written }
      }
      default:
        throw new Error(`Unknown input port ${targetHandle} for WebtoonGroupCanvasNode`)
    }
  }
}

export class WebtoonPanelGeneratorCanvasNode extends GeneratedCanvasNode<WebtoonPanelGeneratorNodeWriteData> {
  constructor(raw: Y.Map<YDocValue>) { super(raw) }

  get(key: 'type'): "webtoonPanelGenerator" | undefined
  get(key: 'in_images'): Array<ImageAssetRefDictYMap | null> | undefined
  get(key: 'in_prompt'): string | undefined
  get(key: 'in_beats'): Array<string | null> | undefined
  get(key: 'in_dialogue'): Array<WebtoonDialogueDictYMap | null> | undefined
  get(key: 'in_panel_index'): number | undefined
  get(key: 'in_aspect_ratio'): string | undefined
  get(key: 'in_layout'): string | undefined
  get(key: 'in_style'): string | undefined
  get(key: 'in_name'): string | undefined
  get(key: 'in_feedback'): string | undefined
  get(key: 'in_feedback_history'): Array<FeedbackHistoryEntryDictYMap> | undefined
  get(key: 'out_image'): GeneratedImageWithHistoryYMap | undefined
  get(key: 'bubbles'): Array<BubbleDictYMap> | undefined
  get(key: 'batch_pending'): number | undefined
  get(key: 'revision'): number | undefined
  get(key: string): unknown {
    switch (key) {
      case 'type': return this._raw.get('type')
      case 'in_images': return _readYDocOptionalArray(this._raw.get('in_images'), "webtoonPanelGenerator.in_images", (item, itemLabel) => item == null ? null : _readYDocMapWrapper(item, ImageAssetRefDictYMap, itemLabel))
      case 'in_prompt': return _readYDocOptionalString(this._raw.get('in_prompt'), "webtoonPanelGenerator.in_prompt")
      case 'in_beats': return _readYDocOptionalArray(this._raw.get('in_beats'), "webtoonPanelGenerator.in_beats", (item, itemLabel) => item == null ? null : _readYDocString(item, itemLabel))
      case 'in_dialogue': return _readYDocOptionalArray(this._raw.get('in_dialogue'), "webtoonPanelGenerator.in_dialogue", (item, itemLabel) => item == null ? null : _readYDocMapWrapper(item, WebtoonDialogueDictYMap, itemLabel))
      case 'in_panel_index': return _readYDocOptionalNumber(this._raw.get('in_panel_index'), "webtoonPanelGenerator.in_panel_index")
      case 'in_aspect_ratio': return _readYDocOptionalString(this._raw.get('in_aspect_ratio'), "webtoonPanelGenerator.in_aspect_ratio")
      case 'in_layout': return _readYDocOptionalString(this._raw.get('in_layout'), "webtoonPanelGenerator.in_layout")
      case 'in_style': return _readYDocOptionalString(this._raw.get('in_style'), "webtoonPanelGenerator.in_style")
      case 'in_name': return _readYDocOptionalString(this._raw.get('in_name'), "webtoonPanelGenerator.in_name")
      case 'in_feedback': return _readYDocOptionalString(this._raw.get('in_feedback'), "webtoonPanelGenerator.in_feedback")
      case 'in_feedback_history': return _readYDocOptionalArray(this._raw.get('in_feedback_history'), "webtoonPanelGenerator.in_feedback_history", (item, itemLabel) => _readYDocMapWrapper(item, FeedbackHistoryEntryDictYMap, itemLabel))
      case 'out_image': return _readYDocOptionalMapWrapper(this._raw.get('out_image'), GeneratedImageWithHistoryYMap, "webtoonPanelGenerator.out_image")
      case 'bubbles': return _readYDocOptionalArray(this._raw.get('bubbles'), "webtoonPanelGenerator.bubbles", (item, itemLabel) => _readYDocMapWrapper(item, BubbleDictYMap, itemLabel))
      case 'batch_pending': return _readYDocOptionalNumber(this._raw.get('batch_pending'), "webtoonPanelGenerator.batch_pending")
      case 'revision': return _readYDocOptionalNumber(this._raw.get('revision'), "revision")
      default: return undefined
    }
  }

  delete(key: "type" | "in_images" | "in_prompt" | "in_beats" | "in_dialogue" | "in_panel_index" | "in_aspect_ratio" | "in_layout" | "in_style" | "in_name" | "in_feedback" | "in_feedback_history" | "out_image" | "bubbles" | "batch_pending" | "revision"): void { this._raw.delete(key) }
  has(key: "type" | "in_images" | "in_prompt" | "in_beats" | "in_dialogue" | "in_panel_index" | "in_aspect_ratio" | "in_layout" | "in_style" | "in_name" | "in_feedback" | "in_feedback_history" | "out_image" | "bubbles" | "batch_pending" | "revision"): boolean { return this._raw.has(key) }

  writeDataFields(updates: Partial<WebtoonPanelGeneratorNodeWriteData>, opts?: YDocWriteOpts): string[] {
    const written: string[] = []
    for (const [field, value] of Object.entries(updates)) {
      if (this._writeDataField(field as keyof WebtoonPanelGeneratorNodeWriteData & string, value as YDocWriteValue, opts)) written.push(field)
    }
    return written
  }

  private _writeDataField(field: keyof WebtoonPanelGeneratorNodeWriteData & string, value: YDocWriteValue, opts?: YDocWriteOpts): boolean {
    switch (field) {
      case 'in_images': return this.writeInImages(value as Exclude<WebtoonPanelGeneratorNodeWriteData['in_images'], undefined>, opts)
      case 'in_prompt': return this.writeInPrompt(value as Exclude<WebtoonPanelGeneratorNodeWriteData['in_prompt'], undefined>, opts)
      case 'in_beats': return this.writeInBeats(value as Exclude<WebtoonPanelGeneratorNodeWriteData['in_beats'], undefined>, opts)
      case 'in_dialogue': return this.writeInDialogue(value as Exclude<WebtoonPanelGeneratorNodeWriteData['in_dialogue'], undefined>, opts)
      case 'in_panel_index': return this.writeInPanelIndex(value as Exclude<WebtoonPanelGeneratorNodeWriteData['in_panel_index'], undefined>, opts)
      case 'in_aspect_ratio': return this.writeInAspectRatio(value as Exclude<WebtoonPanelGeneratorNodeWriteData['in_aspect_ratio'], undefined>, opts)
      case 'in_layout': return this.writeInLayout(value as Exclude<WebtoonPanelGeneratorNodeWriteData['in_layout'], undefined>, opts)
      case 'in_style': return this.writeInStyle(value as Exclude<WebtoonPanelGeneratorNodeWriteData['in_style'], undefined>, opts)
      case 'in_name': return this.writeInName(value as Exclude<WebtoonPanelGeneratorNodeWriteData['in_name'], undefined>, opts)
      case 'in_feedback': return this.writeInFeedback(value as Exclude<WebtoonPanelGeneratorNodeWriteData['in_feedback'], undefined>, opts)
      case 'in_feedback_history': return this.writeInFeedbackHistory(value as Exclude<WebtoonPanelGeneratorNodeWriteData['in_feedback_history'], undefined>, opts)
      case 'out_image': return this.writeOutImage(value as Exclude<WebtoonPanelGeneratorNodeWriteData['out_image'], undefined>, opts)
      case 'bubbles': return this.writeBubbles(value as Exclude<WebtoonPanelGeneratorNodeWriteData['bubbles'], undefined>, opts)
      case 'batch_pending': return this.writeBatchPending(value as Exclude<WebtoonPanelGeneratorNodeWriteData['batch_pending'], undefined>, opts)
      default: return this._writeCommonDataField(field, value)
    }
  }

  writeInImages(value: Exclude<WebtoonPanelGeneratorNodeWriteData['in_images'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_images', 'array', value, opts, false, undefined, undefined)
  }

  writeInPrompt(value: Exclude<WebtoonPanelGeneratorNodeWriteData['in_prompt'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_prompt', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInBeats(value: Exclude<WebtoonPanelGeneratorNodeWriteData['in_beats'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_beats', 'array', value, opts, false, undefined, undefined)
  }

  writeInDialogue(value: Exclude<WebtoonPanelGeneratorNodeWriteData['in_dialogue'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_dialogue', 'array', value, opts, false, undefined, undefined)
  }

  writeInPanelIndex(value: Exclude<WebtoonPanelGeneratorNodeWriteData['in_panel_index'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_panel_index', 'primitive', value, opts, false, 'number', undefined)
  }

  writeInAspectRatio(value: Exclude<WebtoonPanelGeneratorNodeWriteData['in_aspect_ratio'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_aspect_ratio', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInLayout(value: Exclude<WebtoonPanelGeneratorNodeWriteData['in_layout'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_layout', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInStyle(value: Exclude<WebtoonPanelGeneratorNodeWriteData['in_style'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_style', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInName(value: Exclude<WebtoonPanelGeneratorNodeWriteData['in_name'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_name', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInFeedback(value: Exclude<WebtoonPanelGeneratorNodeWriteData['in_feedback'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_feedback', 'primitive', value, opts, false, 'string', undefined)
  }

  writeInFeedbackHistory(value: Exclude<WebtoonPanelGeneratorNodeWriteData['in_feedback_history'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('in_feedback_history', 'array', value, opts, false, undefined, undefined)
  }

  writeOutImage(value: Exclude<WebtoonPanelGeneratorNodeWriteData['out_image'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('out_image', 'map', value, opts, false, undefined, undefined)
  }

  writeBubbles(value: Exclude<WebtoonPanelGeneratorNodeWriteData['bubbles'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('bubbles', 'array', value, opts, false, undefined, undefined)
  }

  writeBatchPending(value: Exclude<WebtoonPanelGeneratorNodeWriteData['batch_pending'], undefined>, opts?: YDocWriteOpts): boolean {
    return this._writeDataFieldByWireType('batch_pending', 'primitive', value, opts, false, 'number', undefined)
  }

  resolveInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocWriteValue | YDocWriteValue[] | undefined {
    return _resolveWebtoonPanelGeneratorInputFromEdgeRefs(targetHandle, nodes, edgeRefs)
  }

  flushInputFromEdgeRefs(
    targetHandle: string,
    nodes: readonly YDocInputFlushNode[],
    edgeRefs: readonly YDocInputFlushEdgeRef[],
  ): YDocInputFlushResult | undefined {
    switch (targetHandle) {
      case 'in_images': {
        const value = _resolveWebtoonPanelGeneratorInImagesInputFlushValue(nodes, edgeRefs)
        const hadPersistedValue = this.has('in_images')
        if (hadPersistedValue) this.delete('in_images')
        if (value === undefined && !hadPersistedValue) return undefined
        const written = hadPersistedValue
        return { field: 'in_images', value, written }
      }
      case 'in_prompt': {
        const value = _resolveWebtoonPanelGeneratorInPromptInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInPrompt(value as unknown as Exclude<WebtoonPanelGeneratorNodeWriteData['in_prompt'], undefined>)
        return { field: 'in_prompt', value, written }
      }
      case 'in_beats': {
        const value = _resolveWebtoonPanelGeneratorInBeatsInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInBeats(value as unknown as Exclude<WebtoonPanelGeneratorNodeWriteData['in_beats'], undefined>)
        return { field: 'in_beats', value, written }
      }
      case 'in_dialogue': {
        const value = _resolveWebtoonPanelGeneratorInDialogueInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInDialogue(value as unknown as Exclude<WebtoonPanelGeneratorNodeWriteData['in_dialogue'], undefined>)
        return { field: 'in_dialogue', value, written }
      }
      case 'in_panel_index': {
        const value = _resolveWebtoonPanelGeneratorInPanelIndexInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInPanelIndex(value as unknown as Exclude<WebtoonPanelGeneratorNodeWriteData['in_panel_index'], undefined>)
        return { field: 'in_panel_index', value, written }
      }
      case 'in_aspect_ratio': {
        const value = _resolveWebtoonPanelGeneratorInAspectRatioInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInAspectRatio(value as unknown as Exclude<WebtoonPanelGeneratorNodeWriteData['in_aspect_ratio'], undefined>)
        return { field: 'in_aspect_ratio', value, written }
      }
      case 'in_layout': {
        const value = _resolveWebtoonPanelGeneratorInLayoutInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInLayout(value as unknown as Exclude<WebtoonPanelGeneratorNodeWriteData['in_layout'], undefined>)
        return { field: 'in_layout', value, written }
      }
      case 'in_style': {
        const value = _resolveWebtoonPanelGeneratorInStyleInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInStyle(value as unknown as Exclude<WebtoonPanelGeneratorNodeWriteData['in_style'], undefined>)
        return { field: 'in_style', value, written }
      }
      case 'in_name': {
        const value = _resolveWebtoonPanelGeneratorInNameInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInName(value as unknown as Exclude<WebtoonPanelGeneratorNodeWriteData['in_name'], undefined>)
        return { field: 'in_name', value, written }
      }
      case 'in_feedback': {
        const value = _resolveWebtoonPanelGeneratorInFeedbackInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInFeedback(value as unknown as Exclude<WebtoonPanelGeneratorNodeWriteData['in_feedback'], undefined>)
        return { field: 'in_feedback', value, written }
      }
      case 'in_feedback_history': {
        const value = _resolveWebtoonPanelGeneratorInFeedbackHistoryInputFlushValue(nodes, edgeRefs)
        if (value === undefined) return undefined
        const written = this.writeInFeedbackHistory(value as unknown as Exclude<WebtoonPanelGeneratorNodeWriteData['in_feedback_history'], undefined>)
        return { field: 'in_feedback_history', value, written }
      }
      default:
        throw new Error(`Unknown input port ${targetHandle} for WebtoonPanelGeneratorCanvasNode`)
    }
  }
}

export const CANVAS_NODE_FIELD_TYPES: Record<string, Record<string, string>> = {
  audio: {
    type: "\"audio\"",
    in_file_name: "string",
    in_voice_profile: "VoiceProfileDictYMap",
    out_audio: "AudioAssetRefDictYMap",
    revision: "number",
  },
  character_designer: {
    type: "\"characterDesigner\"",
    in_upstream: "UpstreamContextDictYMap",
    in_images: "Y.Array<ImageAssetRefDict | null>",
    in_name: "string",
    in_role: "string",
    in_style: "string",
    in_description: "string",
    in_model: "string",
    in_feedback: "string",
    in_feedback_history: "Y.Array<FeedbackHistoryEntryDict>",
    in_pronunciation_guide: "string",
    in_bg_color: "string",
    in_vlm_validation: "boolean",
    out_name: "string",
    out_image: "CharacterAssetYMap",
    out_voice_profile: "VoiceProfileDictYMap",
    out_vlm_report: "VlmValidationReportDictYMap",
    batch_pending: "number",
    annotated_image_path: "string",
    revision: "number",
  },
  debug_hang: {
    type: "\"debugHang\"",
    in_label: "string",
    out_result: "string",
    revision: "number",
  },
  director: {
    type: "\"director\"",
    in_context: "string",
    out_response: "string",
    out_crew: "DirectorCrewDictYMap",
    pending_tool_state: "DirectorPendingToolStateDictYMap",
    revision: "number",
  },
  generated_image_with_history: {
    type: "\"generatedImageWithHistory\"",
    revision: "number",
  },
  image: {
    type: "\"image\"",
    in_file_name: "string",
    in_image: "ImageAssetRefDictYMap",
    out_image: "ImageAssetRefDictYMap",
    revision: "number",
  },
  image_generator: {
    type: "\"imageGenerator\"",
    in_images: "Y.Array<ImageAssetRefDict | null>",
    in_upstream: "UpstreamContextDictYMap",
    in_name: "string",
    in_prompt: "string",
    in_aspect_ratio: "AspectRatio",
    in_style: "string",
    in_quality: "string",
    in_model: "string",
    in_panel_refs: "Y.Array<string>",
    in_update: "boolean",
    in_image: "ImageAssetRefDictYMap",
    in_feedback: "string",
    in_video: "string",
    in_source_video: "GeneratedVideoWithHistoryYMap",
    in_expected_video_duration_ms: "number",
    in_frame: "string",
    in_get_frame: "boolean",
    in_feedback_history: "Y.Array<FeedbackHistoryEntryDict>",
    in_vlm_validation: "boolean",
    out_image: "GeneratedImageWithHistoryYMap",
    out_vlm_report: "VlmValidationReportDictYMap",
    batch_pending: "number",
    annotated_image_path: "string",
    name_autogen: "string",
    revision: "number",
  },
  location_designer: {
    type: "\"locationDesigner\"",
    in_images: "Y.Array<ImageAssetRefDict | null>",
    in_name: "string",
    in_style: "string",
    in_time_of_day: "string",
    in_weather: "string",
    in_description: "string",
    in_model: "string",
    in_feedback: "string",
    in_feedback_history: "Y.Array<FeedbackHistoryEntryDict>",
    in_bg_color: "string",
    in_vlm_validation: "boolean",
    in_720_enabled: "boolean",
    in_720_view: "LocationPanoramaViewDictYMap",
    out_name: "string",
    out_image: "LocationAssetYMap",
    out_metadata: "LocationMetadataDictYMap",
    out_vlm_report: "VlmValidationReportDictYMap",
    batch_pending: "number",
    annotated_image_path: "string",
    revision: "number",
  },
  node_group: {
    type: "\"nodeGroup\"",
    in_label: "string",
    in_child_node_ids: "Y.Array<string | null>",
    in_layout_mode: "string",
    in_collapsed: "boolean",
    in_collapsible: "boolean",
    in_bg_color: "string",
    name_autogen: "string",
    revision: "number",
  },
  object_designer: {
    type: "\"objectDesigner\"",
    in_images: "Y.Array<ImageAssetRefDict | null>",
    in_name: "string",
    in_style: "string",
    in_description: "string",
    in_model: "string",
    in_feedback: "string",
    in_feedback_history: "Y.Array<FeedbackHistoryEntryDict>",
    in_vlm_validation: "boolean",
    out_name: "string",
    out_image: "ObjectAssetYMap",
    out_metadata: "ObjectMetadataDictYMap",
    out_vlm_report: "VlmValidationReportDictYMap",
    batch_pending: "number",
    annotated_image_path: "string",
    revision: "number",
  },
  panel_source: {
    type: "\"panelSource\"",
    out_image: "ImageAssetRefDictYMap",
    out_action: "string",
    out_character_ids: "Y.Array<string>",
    out_appearances: "Y.Array<AppearanceDict>",
    out_dialogue: "Y.Array<PanelDialogueDict>",
    out_script: "string",
    out_composition: "CompositionDictYMap",
    revision: "number",
  },
  prompt_input: {
    type: "\"promptInput\"",
    out_prompt: "string",
    revision: "number",
  },
  script_writer: {
    type: "\"scriptWriter\"",
    in_prompt: "string",
    in_active_model: "string",
    in_active_variant_id: "string",
    in_name: "string",
    in_director_instruction: "string",
    in_format_only: "boolean",
    in_gemini: "boolean",
    in_claude: "boolean",
    in_gpt: "boolean",
    in_characters: "Y.Array<string | null>",
    in_feedback: "string",
    in_target_duration_s: "number",
    in_review_history: "Y.Array<ReviewHistoryEntryDict>",
    in_feedback_history: "Y.Array<FeedbackHistoryEntryDict>",
    in_bg_color: "string",
    out_script: "string",
    out_script_path: "string",
    out_screenplay: "Y.Array<ScriptScreenplaySceneDict>",
    out_dialogue: "Y.Array<ScriptDialogueDict>",
    out_voice_roles: "Y.Array<VoiceRoleDict>",
    out_voice_profiles: "Y.Array<VoiceProfileDict>",
    out_action_lines: "Y.Array<SceneTextDict>",
    out_characters: "Y.Array<string>",
    out_music_cues: "Y.Array<SceneTextDict>",
    out_sfx: "Y.Array<SceneTextDict>",
    out_gemini: "ScreenplayResultDictYMap",
    out_claude: "ScreenplayResultDictYMap",
    out_gpt: "ScreenplayResultDictYMap",
    out_locations: "Y.Array<string>",
    out_active_model: "string",
    out_scene_count: "number",
    out_logline: "string",
    out_genre_tone: "string",
    out_synopsis: "string",
    out_themes: "string",
    out_script_variants: "Y.Array<ScriptVariantDict>",
    revision: "number",
  },
  short_video_group: {
    type: "\"shortVideoGroup\"",
    in_label: "string",
    in_collapsed: "boolean",
    in_storyboard_path: "string",
    in_image: "ImageAssetRefDictYMap",
    in_child_node_ids: "Y.Array<string>",
    revision: "number",
  },
  sound_expert: {
    type: "\"soundExpert\"",
    in_name: "string",
    in_upstream: "UpstreamContextDictYMap",
    in_prompt: "string",
    in_mode: "string",
    in_duration: "string",
    in_voice_profile: "VoiceProfileDictYMap",
    in_text: "string",
    in_feedback: "string",
    in_feedback_history: "Y.Array<FeedbackHistoryEntryDict>",
    in_model: "string",
    in_loop: "string",
    in_lyrics_mode: "string",
    in_voice_map: "VoiceMapDictYMap",
    in_scene_id: "string",
    in_panel_index: "number",
    in_pause_ms: "number",
    in_character_name: "string",
    in_character_voice_source_for: "string",
    out_duration_seconds: "number",
    out_audio: "SoundGeneratedAudioDictYMap",
    out_voice_profile: "VoiceProfileDictYMap",
    batch_pending: "number",
    audio_file: "string",
    speech_segments: "SpeechSegmentDictYMap",
    selected_voice_provider: "string",
    selected_voice_id: "string",
    selected_voice_name: "string",
    selected_voice_ref: "string",
    revision: "number",
  },
  speech_generator: {
    type: "\"speechGenerator\"",
    in_mode: "string",
    in_script: "string",
    in_text: "string",
    in_character_name: "string",
    in_voice_id: "string",
    in_voice_profile: "VoiceProfileDictYMap",
    in_voice_map: "VoiceMapDictYMap",
    in_scene_id: "string",
    in_panel_index: "number",
    in_pause_ms: "number",
    in_pronunciation_guide: "string",
    in_language_code: "string",
    out_duration_seconds: "number",
    out_waveform: "Y.Array<number>",
    out_audio: "SoundGeneratedAudioDictYMap",
    revision: "number",
  },
  story_direction_preview: {
    type: "\"storyDirectionPreview\"",
    premise: "StoryDirectionFieldDictYMap",
    tone: "StoryDirectionFieldDictYMap",
    hook: "StoryDirectionFieldDictYMap",
    structure: "StoryDirectionFieldDictYMap",
    revision: "number",
  },
  storyboard_designer: {
    type: "\"storyboardDesigner\"",
    in_script: "string",
    in_characters: "Y.Array<ImageAssetRefDict | null>",
    in_character_names: "Y.Array<string | null>",
    in_locations: "Y.Array<ImageAssetRefDict | null>",
    in_location_names: "Y.Array<string | null>",
    in_objects: "Y.Array<ImageAssetRefDict | null>",
    in_object_names: "Y.Array<string | null>",
    in_image: "ImageAssetRefDictYMap",
    in_style: "string",
    in_panel_count: "number",
    in_shot_count: "number",
    in_aspect_ratio: "string",
    in_scene_id: "string",
    in_name: "string",
    in_location: "string",
    in_model: "string",
    in_feedback: "string",
    in_vlm_validation: "boolean",
    in_video_anchors: "Y.Array<ShotVideoAnchorDict>",
    out_image: "GeneratedImageWithHistoryYMap",
    out_grid_images: "Y.Array<ImageAssetRefDict>",
    out_metadata: "StoryboardMetadataDictYMap",
    out_beats: "Y.Array<string>",
    out_shots: "Y.Array<GeneratedShotRowV2Dict>",
    out_shot_seams: "Y.Array<ShotSeamDict>",
    out_production_plan: "ShotProductionPlanDictYMap",
    out_video_generation_plan: "ShotVideoGenerationPlanDictYMap",
    out_video_previous_plan: "ShotVideoGenerationPlanDictYMap",
    out_start_frames: "Y.Array<ImageAssetRefDict>",
    out_key_frames: "Y.Array<ImageAssetRefDict>",
    out_end_frames: "Y.Array<ImageAssetRefDict>",
    out_start_frame_prompts: "Y.Array<string>",
    out_key_frame_prompts: "Y.Array<string>",
    out_end_frame_prompts: "Y.Array<string>",
    out_frame_links: "Y.Array<ShotFrameLinkDict>",
    out_panel_refs: "Y.Array<Array<string>>",
    out_images: "Y.Array<ImageAssetRefDict>",
    out_grid_descriptions: "Y.Array<string>",
    out_vlm_report: "VlmValidationReportDictYMap",
    shot_guidance_kind: "string",
    shot_guidance_fingerprint: "string",
    shot_guidance_warning: "string",
    batch_pending: "number",
    storyboard_view: "string",
    shot_list_planner_version: "number",
    storyboard_mode: "string",
    shot_list: "Y.Array<ShotListRowDict>",
    shot_key_frame_relinks: "Y.Array<ShotKeyFrameRelinkDict>",
    name_autogen: "string",
    revision: "number",
  },
  storyboard_no_enhance_designer: {
    type: "\"storyboardNoEnhanceDesigner\"",
    in_script: "string",
    in_characters: "Y.Array<ImageAssetRefDict | null>",
    in_character_names: "Y.Array<string | null>",
    in_locations: "Y.Array<ImageAssetRefDict | null>",
    in_location_names: "Y.Array<string | null>",
    in_style: "string",
    in_panel_count: "number",
    in_scene_id: "string",
    in_location: "string",
    in_model: "string",
    in_vlm_validation: "boolean",
    out_image: "ImageAssetRefDictYMap",
    out_vlm_report: "VlmValidationReportDictYMap",
    revision: "number",
  },
  style_selector: {
    type: "\"styleSelector\"",
    out_style: "string",
    revision: "number",
  },
  text: {
    type: "\"text\"",
    in_input: "string",
    out_text: "string",
    revision: "number",
  },
  video: {
    type: "\"video\"",
    in_file_name: "string",
    in_depth_include_audio: "boolean",
    in_transform_video: "VideoAssetRefDictYMap",
    in_transform_target_resolution: "string",
    in_transform_source_asset_path: "string",
    in_transform_source_content_sha256: "string",
    in_transform_source_width: "number",
    in_transform_source_height: "number",
    in_transform_source_frame_count: "number",
    in_transform_source_fps: "number",
    out_video: "GeneratedVideoWithHistoryYMap",
    revision: "number",
  },
  video_editor: {
    type: "\"videoEditor\"",
    in_reference_media: "Y.Array<MediaAssetRefDict | null>",
    in_videos: "Y.Array<VideoAssetRefDict | null>",
    in_audios: "Y.Array<AudioAssetRefDict | null>",
    in_audio: "AudioAssetRefDictYMap",
    in_video_config: "TimelineConfigDictYMap",
    in_edit_spec: "EditSpecDictYMap",
    in_mode: "string",
    in_output_name: "string",
    in_start: "number",
    in_end: "number",
    in_volume: "number",
    in_export_name: "string",
    out_video: "VideoAssetRefDictYMap",
    out_rendered_spec_hash: "string",
    out_render_sources: "ShotVideoRenderSourcesDictYMap",
    last_export_node_id: "string",
    magnet_enabled: "boolean",
    edit_spec_compatibility_state: "string",
    edit_spec_migration_error: "string",
    revision: "number",
  },
  video_generator: {
    type: "\"videoGenerator\"",
    in_reference_media: "Y.Array<MediaAssetRefDict | null>",
    in_mode: "string",
    in_scene_id: "string",
    in_clip_number: "number",
    in_images: "Y.Array<ImageAssetRefDict | null>",
    in_reference_videos: "Y.Array<VideoAssetRefDict | null>",
    in_continuation_source: "GeneratedVideoWithHistoryYMap",
    in_shot_list_source_id: "string",
    in_shot_list_source_fingerprint: "string",
    in_shot_list_request_fingerprint: "string",
    in_reference_audios: "Y.Array<AudioAssetRefDict | null>",
    in_audio: "AudioAssetRefDictYMap",
    in_motion_prompt: "string",
    in_scene_context: "string",
    in_duration: "number",
    in_reference_video_edits: "Y.Array<VideoReferenceEditDict>",
    in_dialogue_prompt: "Y.Array<DialogueEntryDict>",
    in_model: "string",
    in_aspect_ratio: "string",
    in_resolution: "string",
    in_generate_audio: "boolean",
    in_provider_generate_audio: "boolean",
    in_use_voice_profile_audio_references: "boolean",
    in_audio_remix_mode: "\"off\" | \"voiceover_only\" | \"full_remix\"",
    in_allow_bgm: "boolean",
    in_tts_provider: "string",
    in_dub_target_language: "string",
    in_voice_profiles: "Y.Array<VoiceProfileDict | null>",
    in_voice_settings: "VoiceSettingsDictYMap",
    in_name: "string",
    in_resolved_voice_map: "ResolvedVoiceMapDictYMap",
    in_audio_remix_config: "AudioRemixConfigDictYMap",
    in_speech_transformer_config: "SpeechTransformerConfigDictYMap",
    in_audio_take_selections: "AudioTakeSelectionMapDictYMap",
    in_audio_variant_workspaces: "AudioVariantWorkspaceMapDictYMap",
    in_unified_audio_config: "UnifiedAudioProjectDictYMap",
    in_style: "string",
    out_video: "GeneratedVideoWithHistoryYMap",
    out_tts_segments: "Y.Array<TtsSegmentDict>",
    out_audio_remix_baseline: "AudioRemixConfigDictYMap",
    out_speech_transformer_spans: "SpeechTransformerDetectionDictYMap",
    out_auto_dialogue: "Y.Array<DialogueEntryDict>",
    out_speech_windows: "Y.Array<SpeechWindowDict>",
    out_native_speech_takes: "Y.Array<NativeSpeechTakeDict>",
    out_native_speech_spans: "Y.Array<NativeSpeechSpanDict>",
    out_native_speech_detect_seq: "number",
    out_video_prompt: "string",
    out_video_duration: "number",
    out_dialogue: "Y.Array<ReconciledDialogueEntryDict>",
    voice_acting_status: "string",
    full_remix_status: "VideoFullRemixStatusV1DictYMap",
    segment_index: "number",
    batch_pending: "number",
    thumbnail: "string",
    action: "string",
    closing_frame_handshake: "number",
    clip_id: "string",
    target_voice_id: "string",
    target_variant_path: "string",
    name_autogen: "string",
    revision: "number",
  },
  webtoon_group: {
    type: "\"webtoonGroup\"",
    in_scene_id: "string",
    in_label: "string",
    in_collapsed: "boolean",
    in_child_node_ids: "Y.Array<string>",
    revision: "number",
  },
  webtoon_panel_generator: {
    type: "\"webtoonPanelGenerator\"",
    in_images: "Y.Array<ImageAssetRefDict | null>",
    in_prompt: "string",
    in_beats: "Y.Array<string | null>",
    in_dialogue: "Y.Array<WebtoonDialogueDict | null>",
    in_panel_index: "number",
    in_aspect_ratio: "string",
    in_layout: "string",
    in_style: "string",
    in_name: "string",
    in_feedback: "string",
    in_feedback_history: "Y.Array<FeedbackHistoryEntryDict>",
    out_image: "GeneratedImageWithHistoryYMap",
    bubbles: "Y.Array<BubbleDict>",
    batch_pending: "number",
    revision: "number",
  },
}

function _requireRawCanvasNodeType(raw: Y.Map<YDocValue>, expectedType: FeNodeType): void {
  const actual = raw.get('type')
  if (actual !== expectedType) {
    throw new TypeError(`YDoc node type mismatch: expected ${expectedType}, got ${String(actual)}`)
  }
}

export type RawYDocNodeByBackendType = {
  'audio': AudioCanvasNode
  'character_designer': CharacterDesignerCanvasNode
  'debug_hang': DebugHangCanvasNode
  'director': DirectorCanvasNode
  'generated_image_with_history': GeneratedImageWithHistoryCanvasNode
  'image': ImageCanvasNode
  'image_generator': ImageGeneratorCanvasNode
  'location_designer': LocationDesignerCanvasNode
  'node_group': NodeGroupCanvasNode
  'object_designer': ObjectDesignerCanvasNode
  'panel_source': PanelSourceCanvasNode
  'prompt_input': PromptInputCanvasNode
  'script_writer': ScriptWriterCanvasNode
  'short_video_group': ShortVideoGroupCanvasNode
  'sound_expert': SoundExpertCanvasNode
  'speech_generator': SpeechGeneratorCanvasNode
  'story_direction_preview': StoryDirectionPreviewCanvasNode
  'storyboard_designer': StoryboardDesignerCanvasNode
  'storyboard_no_enhance_designer': StoryboardNoEnhanceDesignerCanvasNode
  'style_selector': StyleSelectorCanvasNode
  'text': TextCanvasNode
  'video': VideoCanvasNode
  'video_editor': VideoEditorCanvasNode
  'video_generator': VideoGeneratorCanvasNode
  'webtoon_group': WebtoonGroupCanvasNode
  'webtoon_panel_generator': WebtoonPanelGeneratorCanvasNode
}

export type RawYDocNode = RawYDocNodeByBackendType[keyof RawYDocNodeByBackendType]

export type CanvasNodeByFeType = {
  'audio': AudioCanvasNode
  'characterDesigner': CharacterDesignerCanvasNode
  'debugHang': DebugHangCanvasNode
  'director': DirectorCanvasNode
  'generatedImageWithHistory': GeneratedImageWithHistoryCanvasNode
  'image': ImageCanvasNode
  'imageGenerator': ImageGeneratorCanvasNode
  'locationDesigner': LocationDesignerCanvasNode
  'nodeGroup': NodeGroupCanvasNode
  'objectDesigner': ObjectDesignerCanvasNode
  'panelSource': PanelSourceCanvasNode
  'promptInput': PromptInputCanvasNode
  'scriptWriter': ScriptWriterCanvasNode
  'shortVideoGroup': ShortVideoGroupCanvasNode
  'soundExpert': SoundExpertCanvasNode
  'speechGenerator': SpeechGeneratorCanvasNode
  'storyDirectionPreview': StoryDirectionPreviewCanvasNode
  'storyboardDesigner': StoryboardDesignerCanvasNode
  'storyboardNoEnhanceDesigner': StoryboardNoEnhanceDesignerCanvasNode
  'styleSelector': StyleSelectorCanvasNode
  'text': TextCanvasNode
  'video': VideoCanvasNode
  'videoEditor': VideoEditorCanvasNode
  'videoGenerator': VideoGeneratorCanvasNode
  'webtoonGroup': WebtoonGroupCanvasNode
  'webtoonPanelGenerator': WebtoonPanelGeneratorCanvasNode
}

export function bindAudioCanvasNode(raw: Y.Map<YDocValue>): AudioCanvasNode {
  _requireRawCanvasNodeType(raw, 'audio')
  return new AudioCanvasNode(raw)
}

export function bindCharacterDesignerCanvasNode(raw: Y.Map<YDocValue>): CharacterDesignerCanvasNode {
  _requireRawCanvasNodeType(raw, 'characterDesigner')
  return new CharacterDesignerCanvasNode(raw)
}

export function bindDebugHangCanvasNode(raw: Y.Map<YDocValue>): DebugHangCanvasNode {
  _requireRawCanvasNodeType(raw, 'debugHang')
  return new DebugHangCanvasNode(raw)
}

export function bindDirectorCanvasNode(raw: Y.Map<YDocValue>): DirectorCanvasNode {
  _requireRawCanvasNodeType(raw, 'director')
  return new DirectorCanvasNode(raw)
}

export function bindGeneratedImageWithHistoryCanvasNode(raw: Y.Map<YDocValue>): GeneratedImageWithHistoryCanvasNode {
  _requireRawCanvasNodeType(raw, 'generatedImageWithHistory')
  return new GeneratedImageWithHistoryCanvasNode(raw)
}

export function bindImageCanvasNode(raw: Y.Map<YDocValue>): ImageCanvasNode {
  _requireRawCanvasNodeType(raw, 'image')
  return new ImageCanvasNode(raw)
}

export function bindImageGeneratorCanvasNode(raw: Y.Map<YDocValue>): ImageGeneratorCanvasNode {
  _requireRawCanvasNodeType(raw, 'imageGenerator')
  return new ImageGeneratorCanvasNode(raw)
}

export function bindLocationDesignerCanvasNode(raw: Y.Map<YDocValue>): LocationDesignerCanvasNode {
  _requireRawCanvasNodeType(raw, 'locationDesigner')
  return new LocationDesignerCanvasNode(raw)
}

export function bindNodeGroupCanvasNode(raw: Y.Map<YDocValue>): NodeGroupCanvasNode {
  _requireRawCanvasNodeType(raw, 'nodeGroup')
  return new NodeGroupCanvasNode(raw)
}

export function bindObjectDesignerCanvasNode(raw: Y.Map<YDocValue>): ObjectDesignerCanvasNode {
  _requireRawCanvasNodeType(raw, 'objectDesigner')
  return new ObjectDesignerCanvasNode(raw)
}

export function bindPanelSourceCanvasNode(raw: Y.Map<YDocValue>): PanelSourceCanvasNode {
  _requireRawCanvasNodeType(raw, 'panelSource')
  return new PanelSourceCanvasNode(raw)
}

export function bindPromptInputCanvasNode(raw: Y.Map<YDocValue>): PromptInputCanvasNode {
  _requireRawCanvasNodeType(raw, 'promptInput')
  return new PromptInputCanvasNode(raw)
}

export function bindScriptWriterCanvasNode(raw: Y.Map<YDocValue>): ScriptWriterCanvasNode {
  _requireRawCanvasNodeType(raw, 'scriptWriter')
  return new ScriptWriterCanvasNode(raw)
}

export function bindShortVideoGroupCanvasNode(raw: Y.Map<YDocValue>): ShortVideoGroupCanvasNode {
  _requireRawCanvasNodeType(raw, 'shortVideoGroup')
  return new ShortVideoGroupCanvasNode(raw)
}

export function bindSoundExpertCanvasNode(raw: Y.Map<YDocValue>): SoundExpertCanvasNode {
  _requireRawCanvasNodeType(raw, 'soundExpert')
  return new SoundExpertCanvasNode(raw)
}

export function bindSpeechGeneratorCanvasNode(raw: Y.Map<YDocValue>): SpeechGeneratorCanvasNode {
  _requireRawCanvasNodeType(raw, 'speechGenerator')
  return new SpeechGeneratorCanvasNode(raw)
}

export function bindStoryDirectionPreviewCanvasNode(raw: Y.Map<YDocValue>): StoryDirectionPreviewCanvasNode {
  _requireRawCanvasNodeType(raw, 'storyDirectionPreview')
  return new StoryDirectionPreviewCanvasNode(raw)
}

export function bindStoryboardDesignerCanvasNode(raw: Y.Map<YDocValue>): StoryboardDesignerCanvasNode {
  _requireRawCanvasNodeType(raw, 'storyboardDesigner')
  return new StoryboardDesignerCanvasNode(raw)
}

export function bindStoryboardNoEnhanceDesignerCanvasNode(raw: Y.Map<YDocValue>): StoryboardNoEnhanceDesignerCanvasNode {
  _requireRawCanvasNodeType(raw, 'storyboardNoEnhanceDesigner')
  return new StoryboardNoEnhanceDesignerCanvasNode(raw)
}

export function bindStyleSelectorCanvasNode(raw: Y.Map<YDocValue>): StyleSelectorCanvasNode {
  _requireRawCanvasNodeType(raw, 'styleSelector')
  return new StyleSelectorCanvasNode(raw)
}

export function bindTextCanvasNode(raw: Y.Map<YDocValue>): TextCanvasNode {
  _requireRawCanvasNodeType(raw, 'text')
  return new TextCanvasNode(raw)
}

export function bindVideoCanvasNode(raw: Y.Map<YDocValue>): VideoCanvasNode {
  _requireRawCanvasNodeType(raw, 'video')
  return new VideoCanvasNode(raw)
}

export function bindVideoEditorCanvasNode(raw: Y.Map<YDocValue>): VideoEditorCanvasNode {
  _requireRawCanvasNodeType(raw, 'videoEditor')
  return new VideoEditorCanvasNode(raw)
}

export function bindVideoGeneratorCanvasNode(raw: Y.Map<YDocValue>): VideoGeneratorCanvasNode {
  _requireRawCanvasNodeType(raw, 'videoGenerator')
  return new VideoGeneratorCanvasNode(raw)
}

export function bindWebtoonGroupCanvasNode(raw: Y.Map<YDocValue>): WebtoonGroupCanvasNode {
  _requireRawCanvasNodeType(raw, 'webtoonGroup')
  return new WebtoonGroupCanvasNode(raw)
}

export function bindWebtoonPanelGeneratorCanvasNode(raw: Y.Map<YDocValue>): WebtoonPanelGeneratorCanvasNode {
  _requireRawCanvasNodeType(raw, 'webtoonPanelGenerator')
  return new WebtoonPanelGeneratorCanvasNode(raw)
}

export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'audio'): AudioCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'character_designer'): CharacterDesignerCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'debug_hang'): DebugHangCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'director'): DirectorCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'generated_image_with_history'): GeneratedImageWithHistoryCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'image'): ImageCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'image_generator'): ImageGeneratorCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'location_designer'): LocationDesignerCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'node_group'): NodeGroupCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'object_designer'): ObjectDesignerCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'panel_source'): PanelSourceCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'prompt_input'): PromptInputCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'script_writer'): ScriptWriterCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'short_video_group'): ShortVideoGroupCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'sound_expert'): SoundExpertCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'speech_generator'): SpeechGeneratorCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'story_direction_preview'): StoryDirectionPreviewCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'storyboard_designer'): StoryboardDesignerCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'storyboard_no_enhance_designer'): StoryboardNoEnhanceDesignerCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'style_selector'): StyleSelectorCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'text'): TextCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'video'): VideoCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'video_editor'): VideoEditorCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'video_generator'): VideoGeneratorCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'webtoon_group'): WebtoonGroupCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: 'webtoon_panel_generator'): WebtoonPanelGeneratorCanvasNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: keyof RawYDocNodeByBackendType): RawYDocNode
export function bindRawCanvasNode(raw: Y.Map<YDocValue>, backendType: keyof RawYDocNodeByBackendType): RawYDocNode {
  switch (backendType) {
    case 'audio':
      return bindAudioCanvasNode(raw)
    case 'character_designer':
      return bindCharacterDesignerCanvasNode(raw)
    case 'debug_hang':
      return bindDebugHangCanvasNode(raw)
    case 'director':
      return bindDirectorCanvasNode(raw)
    case 'generated_image_with_history':
      return bindGeneratedImageWithHistoryCanvasNode(raw)
    case 'image':
      return bindImageCanvasNode(raw)
    case 'image_generator':
      return bindImageGeneratorCanvasNode(raw)
    case 'location_designer':
      return bindLocationDesignerCanvasNode(raw)
    case 'node_group':
      return bindNodeGroupCanvasNode(raw)
    case 'object_designer':
      return bindObjectDesignerCanvasNode(raw)
    case 'panel_source':
      return bindPanelSourceCanvasNode(raw)
    case 'prompt_input':
      return bindPromptInputCanvasNode(raw)
    case 'script_writer':
      return bindScriptWriterCanvasNode(raw)
    case 'short_video_group':
      return bindShortVideoGroupCanvasNode(raw)
    case 'sound_expert':
      return bindSoundExpertCanvasNode(raw)
    case 'speech_generator':
      return bindSpeechGeneratorCanvasNode(raw)
    case 'story_direction_preview':
      return bindStoryDirectionPreviewCanvasNode(raw)
    case 'storyboard_designer':
      return bindStoryboardDesignerCanvasNode(raw)
    case 'storyboard_no_enhance_designer':
      return bindStoryboardNoEnhanceDesignerCanvasNode(raw)
    case 'style_selector':
      return bindStyleSelectorCanvasNode(raw)
    case 'text':
      return bindTextCanvasNode(raw)
    case 'video':
      return bindVideoCanvasNode(raw)
    case 'video_editor':
      return bindVideoEditorCanvasNode(raw)
    case 'video_generator':
      return bindVideoGeneratorCanvasNode(raw)
    case 'webtoon_group':
      return bindWebtoonGroupCanvasNode(raw)
    case 'webtoon_panel_generator':
      return bindWebtoonPanelGeneratorCanvasNode(raw)
    default:
      throw new TypeError(`Unsupported YDoc backend type: ${String(backendType)}`)
  }
}

/** Typed binder lookup keyed by frontend node type. */
export const CANVAS_NODE_BINDERS: {
  readonly audio: (raw: Y.Map<YDocValue>) => AudioCanvasNode
  readonly characterDesigner: (raw: Y.Map<YDocValue>) => CharacterDesignerCanvasNode
  readonly debugHang: (raw: Y.Map<YDocValue>) => DebugHangCanvasNode
  readonly director: (raw: Y.Map<YDocValue>) => DirectorCanvasNode
  readonly generatedImageWithHistory: (raw: Y.Map<YDocValue>) => GeneratedImageWithHistoryCanvasNode
  readonly image: (raw: Y.Map<YDocValue>) => ImageCanvasNode
  readonly imageGenerator: (raw: Y.Map<YDocValue>) => ImageGeneratorCanvasNode
  readonly locationDesigner: (raw: Y.Map<YDocValue>) => LocationDesignerCanvasNode
  readonly nodeGroup: (raw: Y.Map<YDocValue>) => NodeGroupCanvasNode
  readonly objectDesigner: (raw: Y.Map<YDocValue>) => ObjectDesignerCanvasNode
  readonly panelSource: (raw: Y.Map<YDocValue>) => PanelSourceCanvasNode
  readonly promptInput: (raw: Y.Map<YDocValue>) => PromptInputCanvasNode
  readonly scriptWriter: (raw: Y.Map<YDocValue>) => ScriptWriterCanvasNode
  readonly shortVideoGroup: (raw: Y.Map<YDocValue>) => ShortVideoGroupCanvasNode
  readonly soundExpert: (raw: Y.Map<YDocValue>) => SoundExpertCanvasNode
  readonly speechGenerator: (raw: Y.Map<YDocValue>) => SpeechGeneratorCanvasNode
  readonly storyDirectionPreview: (raw: Y.Map<YDocValue>) => StoryDirectionPreviewCanvasNode
  readonly storyboardDesigner: (raw: Y.Map<YDocValue>) => StoryboardDesignerCanvasNode
  readonly storyboardNoEnhanceDesigner: (raw: Y.Map<YDocValue>) => StoryboardNoEnhanceDesignerCanvasNode
  readonly styleSelector: (raw: Y.Map<YDocValue>) => StyleSelectorCanvasNode
  readonly text: (raw: Y.Map<YDocValue>) => TextCanvasNode
  readonly video: (raw: Y.Map<YDocValue>) => VideoCanvasNode
  readonly videoEditor: (raw: Y.Map<YDocValue>) => VideoEditorCanvasNode
  readonly videoGenerator: (raw: Y.Map<YDocValue>) => VideoGeneratorCanvasNode
  readonly webtoonGroup: (raw: Y.Map<YDocValue>) => WebtoonGroupCanvasNode
  readonly webtoonPanelGenerator: (raw: Y.Map<YDocValue>) => WebtoonPanelGeneratorCanvasNode
} = {
  audio: bindAudioCanvasNode,
  characterDesigner: bindCharacterDesignerCanvasNode,
  debugHang: bindDebugHangCanvasNode,
  director: bindDirectorCanvasNode,
  generatedImageWithHistory: bindGeneratedImageWithHistoryCanvasNode,
  image: bindImageCanvasNode,
  imageGenerator: bindImageGeneratorCanvasNode,
  locationDesigner: bindLocationDesignerCanvasNode,
  nodeGroup: bindNodeGroupCanvasNode,
  objectDesigner: bindObjectDesignerCanvasNode,
  panelSource: bindPanelSourceCanvasNode,
  promptInput: bindPromptInputCanvasNode,
  scriptWriter: bindScriptWriterCanvasNode,
  shortVideoGroup: bindShortVideoGroupCanvasNode,
  soundExpert: bindSoundExpertCanvasNode,
  speechGenerator: bindSpeechGeneratorCanvasNode,
  storyDirectionPreview: bindStoryDirectionPreviewCanvasNode,
  storyboardDesigner: bindStoryboardDesignerCanvasNode,
  storyboardNoEnhanceDesigner: bindStoryboardNoEnhanceDesignerCanvasNode,
  styleSelector: bindStyleSelectorCanvasNode,
  text: bindTextCanvasNode,
  video: bindVideoCanvasNode,
  videoEditor: bindVideoEditorCanvasNode,
  videoGenerator: bindVideoGeneratorCanvasNode,
  webtoonGroup: bindWebtoonGroupCanvasNode,
  webtoonPanelGenerator: bindWebtoonPanelGeneratorCanvasNode,
}

export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'audio'): CanvasNodeByFeType['audio']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'characterDesigner'): CanvasNodeByFeType['characterDesigner']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'debugHang'): CanvasNodeByFeType['debugHang']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'director'): CanvasNodeByFeType['director']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'generatedImageWithHistory'): CanvasNodeByFeType['generatedImageWithHistory']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'image'): CanvasNodeByFeType['image']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'imageGenerator'): CanvasNodeByFeType['imageGenerator']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'locationDesigner'): CanvasNodeByFeType['locationDesigner']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'nodeGroup'): CanvasNodeByFeType['nodeGroup']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'objectDesigner'): CanvasNodeByFeType['objectDesigner']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'panelSource'): CanvasNodeByFeType['panelSource']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'promptInput'): CanvasNodeByFeType['promptInput']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'scriptWriter'): CanvasNodeByFeType['scriptWriter']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'shortVideoGroup'): CanvasNodeByFeType['shortVideoGroup']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'soundExpert'): CanvasNodeByFeType['soundExpert']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'speechGenerator'): CanvasNodeByFeType['speechGenerator']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'storyDirectionPreview'): CanvasNodeByFeType['storyDirectionPreview']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'storyboardDesigner'): CanvasNodeByFeType['storyboardDesigner']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'storyboardNoEnhanceDesigner'): CanvasNodeByFeType['storyboardNoEnhanceDesigner']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'styleSelector'): CanvasNodeByFeType['styleSelector']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'text'): CanvasNodeByFeType['text']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'video'): CanvasNodeByFeType['video']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'videoEditor'): CanvasNodeByFeType['videoEditor']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'videoGenerator'): CanvasNodeByFeType['videoGenerator']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'webtoonGroup'): CanvasNodeByFeType['webtoonGroup']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: 'webtoonPanelGenerator'): CanvasNodeByFeType['webtoonPanelGenerator']
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: FeNodeType): CanvasNodeByFeType[FeNodeType]
export function bindCanvasNodeByFeType(raw: Y.Map<YDocValue>, feType: FeNodeType): CanvasNodeByFeType[FeNodeType] {
  return CANVAS_NODE_BINDERS[feType](raw)
}

/** Type-narrow ReactFlow node.data by frontend node type */
export function getTypedNodeData<T extends FeNodeType>(node: TypedReactFlowNode<T>, type: T): ReactFlowCanvasNodeDataByType[T]
export function getTypedNodeData<T extends FeNodeType>(node: ReactFlowNodeLike, type: T): ReactFlowCanvasNodeDataByType[T] | undefined
export function getTypedNodeData(node: ReactFlowNodeLike, type: FeNodeType): ReactFlowCanvasNodeDataByType[FeNodeType] | undefined {
  if (node.type !== type) return undefined
  return node.data as ReactFlowCanvasNodeDataByType[FeNodeType] | undefined
}

export function requireTypedNodeData<T extends FeNodeType>(
  node: ReactFlowNodeLike,
  type: T,
  helper = 'requireTypedNodeData',
): ReactFlowCanvasNodeDataByType[T] {
  const data = getTypedNodeData(node, type)
  if (!data) {
    const renderedType = node.type ?? '<missing>'
    throw new Error(`${helper}: expected node type ${type}, received ${renderedType}`)
  }
  return data
}

function _throwUnknownNodeType(type: string | null | undefined, helper: string): never {
  const renderedType = type ?? '<missing>'
  throw new Error(`${helper}: unsupported node type ${renderedType}`)
}

function _firstNonEmptyNodeString(...values: Array<string | undefined>): string | undefined {
  for (const value of values) {
    const trimmed = value?.trim()
    if (trimmed) return trimmed
  }
  return undefined
}

/**
 * Schema-generated summary text for a node.
 * Known node types without configured description-like string fields return undefined.
 * Unknown node types throw so stale UI code does not silently hide schema drift.
 */
export function getNodeDescription(node: { type?: string | null; data?: unknown }): string | undefined {
  switch (node.type) {
    case 'audio': {
      return undefined
    }
    case 'characterDesigner': {
      const data = getTypedNodeData(node, 'characterDesigner')
      return _firstNonEmptyNodeString(data?.in_description)
    }
    case 'debugHang': {
      return undefined
    }
    case 'director': {
      return undefined
    }
    case 'generatedImageWithHistory': {
      return undefined
    }
    case 'image': {
      return undefined
    }
    case 'imageGenerator': {
      const data = getTypedNodeData(node, 'imageGenerator')
      return _firstNonEmptyNodeString(data?.in_prompt)
    }
    case 'locationDesigner': {
      const data = getTypedNodeData(node, 'locationDesigner')
      return _firstNonEmptyNodeString(data?.in_description)
    }
    case 'nodeGroup': {
      return undefined
    }
    case 'objectDesigner': {
      const data = getTypedNodeData(node, 'objectDesigner')
      return _firstNonEmptyNodeString(data?.in_description)
    }
    case 'panelSource': {
      const data = getTypedNodeData(node, 'panelSource')
      return _firstNonEmptyNodeString(data?.out_action)
    }
    case 'promptInput': {
      const data = getTypedNodeData(node, 'promptInput')
      return _firstNonEmptyNodeString(data?.out_prompt)
    }
    case 'scriptWriter': {
      const data = getTypedNodeData(node, 'scriptWriter')
      return _firstNonEmptyNodeString(data?.in_prompt)
    }
    case 'shortVideoGroup': {
      return undefined
    }
    case 'soundExpert': {
      const data = getTypedNodeData(node, 'soundExpert')
      return _firstNonEmptyNodeString(data?.in_prompt)
    }
    case 'speechGenerator': {
      const data = getTypedNodeData(node, 'speechGenerator')
      return _firstNonEmptyNodeString(data?.in_script)
    }
    case 'storyDirectionPreview': {
      return undefined
    }
    case 'storyboardDesigner': {
      const data = getTypedNodeData(node, 'storyboardDesigner')
      return _firstNonEmptyNodeString(data?.in_script)
    }
    case 'storyboardNoEnhanceDesigner': {
      const data = getTypedNodeData(node, 'storyboardNoEnhanceDesigner')
      return _firstNonEmptyNodeString(data?.in_script)
    }
    case 'styleSelector': {
      return undefined
    }
    case 'text': {
      const data = getTypedNodeData(node, 'text')
      return _firstNonEmptyNodeString(data?.out_text, data?.in_input)
    }
    case 'video': {
      return undefined
    }
    case 'videoEditor': {
      return undefined
    }
    case 'videoGenerator': {
      const data = getTypedNodeData(node, 'videoGenerator')
      return _firstNonEmptyNodeString(data?.in_motion_prompt, data?.in_scene_context)
    }
    case 'webtoonGroup': {
      return undefined
    }
    case 'webtoonPanelGenerator': {
      const data = getTypedNodeData(node, 'webtoonPanelGenerator')
      return _firstNonEmptyNodeString(data?.in_prompt)
    }
    default:
      return _throwUnknownNodeType(node.type, 'getNodeDescription')
  }
}

export type YDocWireType = YDocPortSchema['wireType']

export const YDOC_PORT_SCHEMAS: Record<string, YDocPortSchema> = {
  "aspect_ratio_aspect_ratio_aspect_ratio_single_primitive": { schemaType: "AspectRatio", pythonType: "AspectRatio", tsType: "AspectRatio", wireType: "primitive", isMulti: false },
  "audio_audio_asset_ref_dict_audio_asset_multi_array": { schemaType: "audio", pythonType: "AudioAssetRefDict", tsType: "AudioAssetRefDict", wireType: "array", isMulti: true },
  "audio_audio_asset_ref_dict_audio_asset_single_map": { schemaType: "audio", pythonType: "AudioAssetRefDict", tsType: "AudioAssetRefDict", wireType: "map", isMulti: false },
  "audio_remix_config_dict_audio_remix_config_dict_audio_remix_config_dict_single_map": { schemaType: "AudioRemixConfigDict", pythonType: "AudioRemixConfigDict", tsType: "AudioRemixConfigDict", wireType: "map", isMulti: false },
  "audio_sound_generated_audio_dict_audio_asset_single_map": { schemaType: "audio", pythonType: "SoundGeneratedAudioDict", tsType: "SoundGeneratedAudioDict", wireType: "map", isMulti: false },
  "audio_take_selection_map_dict_audio_take_selection_map_dict_audio_take_selection_map_dict_single_map": { schemaType: "AudioTakeSelectionMapDict", pythonType: "AudioTakeSelectionMapDict", tsType: "AudioTakeSelectionMapDict", wireType: "map", isMulti: false },
  "audio_variant_workspace_map_dict_audio_variant_workspace_map_dict_audio_variant_workspace_map_dict_single_map": { schemaType: "AudioVariantWorkspaceMapDict", pythonType: "AudioVariantWorkspaceMapDict", tsType: "AudioVariantWorkspaceMapDict", wireType: "map", isMulti: false },
  "boolean_bool_bool_single_primitive": { schemaType: "boolean", pythonType: "bool", tsType: "boolean", wireType: "primitive", isMulti: false },
  "composition_dict_composition_dict_composition_dict_single_map": { schemaType: "CompositionDict", pythonType: "CompositionDict", tsType: "CompositionDict", wireType: "map", isMulti: false },
  "director_crew_dict_director_crew_dict_director_crew_dict_single_map": { schemaType: "DirectorCrewDict", pythonType: "DirectorCrewDict", tsType: "DirectorCrewDict", wireType: "map", isMulti: false },
  "edit_spec_dict_edit_spec_dict_edit_spec_dict_single_map": { schemaType: "EditSpecDict", pythonType: "EditSpecDict", tsType: "EditSpecDict", wireType: "map", isMulti: false },
  "float_float_float_single_primitive": { schemaType: "float", pythonType: "float", tsType: "number", wireType: "primitive", isMulti: false },
  "generated_shot_row_v2_dict_generated_shot_row_v2_dict_generated_shot_row_v2_dict_multi_array": { schemaType: "GeneratedShotRowV2Dict", pythonType: "GeneratedShotRowV2Dict", tsType: "GeneratedShotRowV2Dict", wireType: "array", isMulti: true },
  "image_character_asset_image_asset_single_map": { schemaType: "image", pythonType: "CharacterAsset", tsType: "CharacterAsset", wireType: "map", isMulti: false },
  "image_generated_image_with_history_image_asset_single_map": { schemaType: "image", pythonType: "GeneratedImageWithHistory", tsType: "GeneratedImageWithHistory", wireType: "map", isMulti: false },
  "image_image_asset_ref_dict_image_asset_multi_array": { schemaType: "image", pythonType: "ImageAssetRefDict", tsType: "ImageAssetRefDict", wireType: "array", isMulti: true },
  "image_image_asset_ref_dict_image_asset_single_map": { schemaType: "image", pythonType: "ImageAssetRefDict", tsType: "ImageAssetRefDict", wireType: "map", isMulti: false },
  "image_location_asset_image_asset_single_map": { schemaType: "image", pythonType: "LocationAsset", tsType: "LocationAsset", wireType: "map", isMulti: false },
  "image_object_asset_image_asset_single_map": { schemaType: "image", pythonType: "ObjectAsset", tsType: "ObjectAsset", wireType: "map", isMulti: false },
  "image_video_asset_ref_dict_video_asset_single_map": { schemaType: "image", pythonType: "VideoAssetRefDict", tsType: "VideoAssetRefDict", wireType: "map", isMulti: false },
  "image_video_audio_media_asset_ref_dict_image_asset_video_asset_audio_asset_multi_array": { schemaType: "image|video|audio", pythonType: "MediaAssetRefDict", tsType: "MediaAssetRefDict", wireType: "array", isMulti: true },
  "int_int_int_single_primitive": { schemaType: "int", pythonType: "int", tsType: "number", wireType: "primitive", isMulti: false },
  "list_appearance_dict_list_appearance_dict_list_appearance_dict_single_array": { schemaType: "list[AppearanceDict]", pythonType: "list[AppearanceDict]", tsType: "Array<AppearanceDict>", wireType: "array", isMulti: false },
  "list_dialogue_entry_dict_list_dialogue_entry_dict_list_dialogue_entry_dict_single_array": { schemaType: "list[DialogueEntryDict]", pythonType: "list[DialogueEntryDict]", tsType: "Array<DialogueEntryDict>", wireType: "array", isMulti: false },
  "list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array": { schemaType: "list[FeedbackHistoryEntryDict]", pythonType: "list[FeedbackHistoryEntryDict]", tsType: "Array<FeedbackHistoryEntryDict>", wireType: "array", isMulti: false },
  "list_float_list_float_list_float_single_array": { schemaType: "list[float]", pythonType: "list[float]", tsType: "Array<number>", wireType: "array", isMulti: false },
  "list_native_speech_span_dict_list_native_speech_span_dict_list_native_speech_span_dict_single_array": { schemaType: "list[NativeSpeechSpanDict]", pythonType: "list[NativeSpeechSpanDict]", tsType: "Array<NativeSpeechSpanDict>", wireType: "array", isMulti: false },
  "list_native_speech_take_dict_list_native_speech_take_dict_list_native_speech_take_dict_single_array": { schemaType: "list[NativeSpeechTakeDict]", pythonType: "list[NativeSpeechTakeDict]", tsType: "Array<NativeSpeechTakeDict>", wireType: "array", isMulti: false },
  "list_panel_dialogue_dict_list_panel_dialogue_dict_list_panel_dialogue_dict_single_array": { schemaType: "list[PanelDialogueDict]", pythonType: "list[PanelDialogueDict]", tsType: "Array<PanelDialogueDict>", wireType: "array", isMulti: false },
  "list_reconciled_dialogue_entry_dict_list_reconciled_dialogue_entry_dict_list_reconciled_dialogue_entry_dict_single_array": { schemaType: "list[ReconciledDialogueEntryDict]", pythonType: "list[ReconciledDialogueEntryDict]", tsType: "Array<ReconciledDialogueEntryDict>", wireType: "array", isMulti: false },
  "list_review_history_entry_dict_list_review_history_entry_dict_list_review_history_entry_dict_single_array": { schemaType: "list[ReviewHistoryEntryDict]", pythonType: "list[ReviewHistoryEntryDict]", tsType: "Array<ReviewHistoryEntryDict>", wireType: "array", isMulti: false },
  "list_scene_text_dict_list_scene_text_dict_list_scene_text_dict_single_array": { schemaType: "list[SceneTextDict]", pythonType: "list[SceneTextDict]", tsType: "Array<SceneTextDict>", wireType: "array", isMulti: false },
  "list_script_dialogue_dict_list_script_dialogue_dict_list_script_dialogue_dict_single_array": { schemaType: "list[ScriptDialogueDict]", pythonType: "list[ScriptDialogueDict]", tsType: "Array<ScriptDialogueDict>", wireType: "array", isMulti: false },
  "list_script_screenplay_scene_dict_list_script_screenplay_scene_dict_list_script_screenplay_scene_dict_single_array": { schemaType: "list[ScriptScreenplaySceneDict]", pythonType: "list[ScriptScreenplaySceneDict]", tsType: "Array<ScriptScreenplaySceneDict>", wireType: "array", isMulti: false },
  "list_script_variant_dict_list_script_variant_dict_list_script_variant_dict_single_array": { schemaType: "list[ScriptVariantDict]", pythonType: "list[ScriptVariantDict]", tsType: "Array<ScriptVariantDict>", wireType: "array", isMulti: false },
  "list_shot_frame_link_dict_list_shot_frame_link_dict_list_shot_frame_link_dict_single_array": { schemaType: "list[ShotFrameLinkDict]", pythonType: "list[ShotFrameLinkDict]", tsType: "Array<ShotFrameLinkDict>", wireType: "array", isMulti: false },
  "list_shot_seam_dict_list_shot_seam_dict_list_shot_seam_dict_single_array": { schemaType: "list[ShotSeamDict]", pythonType: "list[ShotSeamDict]", tsType: "Array<ShotSeamDict>", wireType: "array", isMulti: false },
  "list_shot_video_anchor_dict_list_shot_video_anchor_dict_list_shot_video_anchor_dict_single_array": { schemaType: "list[ShotVideoAnchorDict]", pythonType: "list[ShotVideoAnchorDict]", tsType: "Array<ShotVideoAnchorDict>", wireType: "array", isMulti: false },
  "list_speech_window_dict_list_speech_window_dict_list_speech_window_dict_single_array": { schemaType: "list[SpeechWindowDict]", pythonType: "list[SpeechWindowDict]", tsType: "Array<SpeechWindowDict>", wireType: "array", isMulti: false },
  "list_tts_segment_dict_list_tts_segment_dict_list_tts_segment_dict_single_array": { schemaType: "list[TtsSegmentDict]", pythonType: "list[TtsSegmentDict]", tsType: "Array<TtsSegmentDict>", wireType: "array", isMulti: false },
  "list_video_reference_edit_dict_list_video_reference_edit_dict_list_video_reference_edit_dict_single_array": { schemaType: "list[VideoReferenceEditDict]", pythonType: "list[VideoReferenceEditDict]", tsType: "Array<VideoReferenceEditDict>", wireType: "array", isMulti: false },
  "location_metadata_dict_location_metadata_dict_location_metadata_dict_single_map": { schemaType: "LocationMetadataDict", pythonType: "LocationMetadataDict", tsType: "LocationMetadataDict", wireType: "map", isMulti: false },
  "location_panorama_view_dict_location_panorama_view_dict_location_panorama_view_dict_single_map": { schemaType: "LocationPanoramaViewDict", pythonType: "LocationPanoramaViewDict", tsType: "LocationPanoramaViewDict", wireType: "map", isMulti: false },
  "object_metadata_dict_object_metadata_dict_object_metadata_dict_single_map": { schemaType: "ObjectMetadataDict", pythonType: "ObjectMetadataDict", tsType: "ObjectMetadataDict", wireType: "map", isMulti: false },
  "resolved_voice_map_dict_resolved_voice_map_dict_resolved_voice_map_dict_single_map": { schemaType: "ResolvedVoiceMapDict", pythonType: "ResolvedVoiceMapDict", tsType: "ResolvedVoiceMapDict", wireType: "map", isMulti: false },
  "screenplay_result_dict_screenplay_result_dict_screenplay_result_dict_single_map": { schemaType: "ScreenplayResultDict", pythonType: "ScreenplayResultDict", tsType: "ScreenplayResultDict", wireType: "map", isMulti: false },
  "shot_production_plan_dict_shot_production_plan_dict_shot_production_plan_dict_single_map": { schemaType: "ShotProductionPlanDict", pythonType: "ShotProductionPlanDict", tsType: "ShotProductionPlanDict", wireType: "map", isMulti: false },
  "shot_video_generation_plan_dict_shot_video_generation_plan_dict_shot_video_generation_plan_dict_single_map": { schemaType: "ShotVideoGenerationPlanDict", pythonType: "ShotVideoGenerationPlanDict", tsType: "ShotVideoGenerationPlanDict", wireType: "map", isMulti: false },
  "shot_video_render_sources_dict_shot_video_render_sources_dict_shot_video_render_sources_dict_single_map": { schemaType: "ShotVideoRenderSourcesDict", pythonType: "ShotVideoRenderSourcesDict", tsType: "ShotVideoRenderSourcesDict", wireType: "map", isMulti: false },
  "speech_transformer_config_dict_speech_transformer_config_dict_speech_transformer_config_dict_single_map": { schemaType: "SpeechTransformerConfigDict", pythonType: "SpeechTransformerConfigDict", tsType: "SpeechTransformerConfigDict", wireType: "map", isMulti: false },
  "speech_transformer_detection_dict_speech_transformer_detection_dict_speech_transformer_detection_dict_single_map": { schemaType: "SpeechTransformerDetectionDict", pythonType: "SpeechTransformerDetectionDict", tsType: "SpeechTransformerDetectionDict", wireType: "map", isMulti: false },
  "storyboard_metadata_dict_storyboard_metadata_dict_storyboard_metadata_dict_single_map": { schemaType: "StoryboardMetadataDict", pythonType: "StoryboardMetadataDict", tsType: "StoryboardMetadataDict", wireType: "map", isMulti: false },
  "string_audio_remix_mode_audio_remix_mode_single_primitive": { schemaType: "string", pythonType: "AudioRemixMode", tsType: "\"off\" | \"voiceover_only\" | \"full_remix\"", wireType: "primitive", isMulti: false },
  "string_list_str_list_str_multi_array": { schemaType: "string", pythonType: "list[str]", tsType: "Array<string>", wireType: "array", isMulti: true },
  "string_list_str_list_str_single_array": { schemaType: "string", pythonType: "list[str]", tsType: "Array<string>", wireType: "array", isMulti: false },
  "string_list_str_none_list_str_none_single_array": { schemaType: "string", pythonType: "list[str | None]", tsType: "Array<string | null>", wireType: "array", isMulti: false },
  "string_str_str_multi_array": { schemaType: "string", pythonType: "str", tsType: "string", wireType: "array", isMulti: true },
  "string_str_str_single_primitive": { schemaType: "string", pythonType: "str", tsType: "string", wireType: "primitive", isMulti: false },
  "timeline_config_dict_timeline_config_dict_timeline_config_dict_single_map": { schemaType: "TimelineConfigDict", pythonType: "TimelineConfigDict", tsType: "TimelineConfigDict", wireType: "map", isMulti: false },
  "unified_audio_project_dict_unified_audio_project_dict_unified_audio_project_dict_single_map": { schemaType: "UnifiedAudioProjectDict", pythonType: "UnifiedAudioProjectDict", tsType: "UnifiedAudioProjectDict", wireType: "map", isMulti: false },
  "upstream_context_dict_upstream_context_dict_upstream_context_dict_single_map": { schemaType: "UpstreamContextDict", pythonType: "UpstreamContextDict", tsType: "UpstreamContextDict", wireType: "map", isMulti: false },
  "video_audio_media_asset_ref_dict_video_asset_audio_asset_multi_array": { schemaType: "video|audio", pythonType: "MediaAssetRefDict", tsType: "MediaAssetRefDict", wireType: "array", isMulti: true },
  "video_generated_video_with_history_video_asset_single_map": { schemaType: "video", pythonType: "GeneratedVideoWithHistory", tsType: "GeneratedVideoWithHistory", wireType: "map", isMulti: false },
  "video_video_asset_ref_dict_video_asset_multi_array": { schemaType: "video", pythonType: "VideoAssetRefDict", tsType: "VideoAssetRefDict", wireType: "array", isMulti: true },
  "video_video_asset_ref_dict_video_asset_single_map": { schemaType: "video", pythonType: "VideoAssetRefDict", tsType: "VideoAssetRefDict", wireType: "map", isMulti: false },
  "vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map": { schemaType: "VlmValidationReportDict", pythonType: "VlmValidationReportDict", tsType: "VlmValidationReportDict", wireType: "map", isMulti: false },
  "voice_map_dict_voice_map_dict_voice_map_dict_single_map": { schemaType: "VoiceMapDict", pythonType: "VoiceMapDict", tsType: "VoiceMapDict", wireType: "map", isMulti: false },
  "voice_profile_dict_voice_profile_dict_voice_profile_dict_multi_array": { schemaType: "VoiceProfileDict", pythonType: "VoiceProfileDict", tsType: "VoiceProfileDict", wireType: "array", isMulti: true },
  "voice_profile_dict_voice_profile_dict_voice_profile_dict_single_map": { schemaType: "VoiceProfileDict", pythonType: "VoiceProfileDict", tsType: "VoiceProfileDict", wireType: "map", isMulti: false },
  "voice_role_dict_voice_role_dict_voice_role_dict_multi_array": { schemaType: "VoiceRoleDict", pythonType: "VoiceRoleDict", tsType: "VoiceRoleDict", wireType: "array", isMulti: true },
  "voice_settings_dict_voice_settings_dict_voice_settings_dict_single_map": { schemaType: "VoiceSettingsDict", pythonType: "VoiceSettingsDict", tsType: "VoiceSettingsDict", wireType: "map", isMulti: false },
  "webtoon_dialogue_dict_webtoon_dialogue_dict_webtoon_dialogue_dict_multi_array": { schemaType: "WebtoonDialogueDict", pythonType: "WebtoonDialogueDict", tsType: "WebtoonDialogueDict", wireType: "array", isMulti: true },
}

export const YDOC_NODE_FIELDS: Record<string, Record<string, YDocFieldDef>> = {
  audio: {
    in_file_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_voice_profile: { schemaType: 'VoiceProfileDict', wireType: 'map', isMulti: false, baseType: 'VoiceProfileDict', portSchemaId: 'voice_profile_dict_voice_profile_dict_voice_profile_dict_single_map' },
    out_audio: { schemaType: 'audio', wireType: 'map', isMulti: false, baseType: 'AudioAsset', portSchemaId: 'audio_audio_asset_ref_dict_audio_asset_single_map' },
  },
  character_designer: {
    in_upstream: { schemaType: 'UpstreamContextDict', wireType: 'map', isMulti: false, baseType: 'UpstreamContextDict', portSchemaId: 'upstream_context_dict_upstream_context_dict_upstream_context_dict_single_map' },
    in_images: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'ImageAsset', portSchemaId: 'image_image_asset_ref_dict_image_asset_multi_array', allowsNullItems: true },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_role: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_description: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_feedback_history: { schemaType: 'list[FeedbackHistoryEntryDict]', wireType: 'array', isMulti: false, baseType: 'list[FeedbackHistoryEntryDict]', portSchemaId: 'list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array' },
    in_pronunciation_guide: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_bg_color: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_vlm_validation: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool', portSchemaId: 'boolean_bool_bool_single_primitive' },
    out_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    out_image: { schemaType: 'image', wireType: 'map', isMulti: false, baseType: 'ImageAsset', portSchemaId: 'image_character_asset_image_asset_single_map' },
    out_voice_profile: { schemaType: 'VoiceProfileDict', wireType: 'map', isMulti: false, baseType: 'VoiceProfileDict', portSchemaId: 'voice_profile_dict_voice_profile_dict_voice_profile_dict_single_map' },
    out_vlm_report: { schemaType: 'VlmValidationReportDict', wireType: 'map', isMulti: false, baseType: 'VlmValidationReportDict', portSchemaId: 'vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map' },
  },
  debug_hang: {
    in_label: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    out_result: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
  },
  director: {
    in_context: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    out_response: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    out_crew: { schemaType: 'DirectorCrewDict', wireType: 'map', isMulti: false, baseType: 'DirectorCrewDict', portSchemaId: 'director_crew_dict_director_crew_dict_director_crew_dict_single_map' },
  },
  generated_image_with_history: {
  },
  image: {
    in_file_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_image: { schemaType: 'image', wireType: 'map', isMulti: false, baseType: 'ImageAsset', portSchemaId: 'image_image_asset_ref_dict_image_asset_single_map' },
    out_image: { schemaType: 'image', wireType: 'map', isMulti: false, baseType: 'ImageAsset', portSchemaId: 'image_image_asset_ref_dict_image_asset_single_map' },
  },
  image_generator: {
    in_images: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'ImageAsset', portSchemaId: 'image_image_asset_ref_dict_image_asset_multi_array', allowsNullItems: true },
    in_upstream: { schemaType: 'UpstreamContextDict', wireType: 'map', isMulti: false, baseType: 'UpstreamContextDict', portSchemaId: 'upstream_context_dict_upstream_context_dict_upstream_context_dict_single_map' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_prompt: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_aspect_ratio: { schemaType: 'AspectRatio', wireType: 'primitive', isMulti: false, baseType: 'AspectRatio', portSchemaId: 'aspect_ratio_aspect_ratio_aspect_ratio_single_primitive' },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_quality: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_panel_refs: { schemaType: 'string', wireType: 'array', isMulti: false, baseType: 'list[str]', portSchemaId: 'string_list_str_list_str_single_array' },
    in_update: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool', portSchemaId: 'boolean_bool_bool_single_primitive' },
    in_image: { schemaType: 'image', wireType: 'map', isMulti: false, baseType: 'ImageAsset', portSchemaId: 'image_image_asset_ref_dict_image_asset_single_map' },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_video: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_source_video: { schemaType: 'video', wireType: 'map', isMulti: false, baseType: 'VideoAsset', portSchemaId: 'video_generated_video_with_history_video_asset_single_map', hiddenFromReferencePicker: true },
    in_expected_video_duration_ms: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int', portSchemaId: 'int_int_int_single_primitive' },
    in_frame: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_get_frame: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool', portSchemaId: 'boolean_bool_bool_single_primitive' },
    in_feedback_history: { schemaType: 'list[FeedbackHistoryEntryDict]', wireType: 'array', isMulti: false, baseType: 'list[FeedbackHistoryEntryDict]', portSchemaId: 'list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array' },
    in_vlm_validation: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool', portSchemaId: 'boolean_bool_bool_single_primitive' },
    out_image: { schemaType: 'image', wireType: 'map', isMulti: false, baseType: 'ImageAsset', portSchemaId: 'image_generated_image_with_history_image_asset_single_map' },
    out_vlm_report: { schemaType: 'VlmValidationReportDict', wireType: 'map', isMulti: false, baseType: 'VlmValidationReportDict', portSchemaId: 'vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map' },
  },
  location_designer: {
    in_images: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'ImageAsset', portSchemaId: 'image_image_asset_ref_dict_image_asset_multi_array', allowsNullItems: true },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_time_of_day: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_weather: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_description: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_feedback_history: { schemaType: 'list[FeedbackHistoryEntryDict]', wireType: 'array', isMulti: false, baseType: 'list[FeedbackHistoryEntryDict]', portSchemaId: 'list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array' },
    in_bg_color: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_vlm_validation: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool', portSchemaId: 'boolean_bool_bool_single_primitive' },
    in_720_enabled: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool', portSchemaId: 'boolean_bool_bool_single_primitive' },
    in_720_view: { schemaType: 'LocationPanoramaViewDict', wireType: 'map', isMulti: false, baseType: 'LocationPanoramaViewDict', portSchemaId: 'location_panorama_view_dict_location_panorama_view_dict_location_panorama_view_dict_single_map' },
    out_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    out_image: { schemaType: 'image', wireType: 'map', isMulti: false, baseType: 'ImageAsset', portSchemaId: 'image_location_asset_image_asset_single_map' },
    out_metadata: { schemaType: 'LocationMetadataDict', wireType: 'map', isMulti: false, baseType: 'LocationMetadataDict', portSchemaId: 'location_metadata_dict_location_metadata_dict_location_metadata_dict_single_map' },
    out_vlm_report: { schemaType: 'VlmValidationReportDict', wireType: 'map', isMulti: false, baseType: 'VlmValidationReportDict', portSchemaId: 'vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map' },
  },
  node_group: {
    in_label: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_child_node_ids: { schemaType: 'string', wireType: 'array', isMulti: false, baseType: 'list[str | None]', portSchemaId: 'string_list_str_none_list_str_none_single_array', allowsNullItems: true },
    in_layout_mode: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_collapsed: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool', portSchemaId: 'boolean_bool_bool_single_primitive' },
    in_collapsible: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool', portSchemaId: 'boolean_bool_bool_single_primitive' },
    in_bg_color: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
  },
  object_designer: {
    in_images: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'ImageAsset', portSchemaId: 'image_image_asset_ref_dict_image_asset_multi_array', allowsNullItems: true },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_description: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_feedback_history: { schemaType: 'list[FeedbackHistoryEntryDict]', wireType: 'array', isMulti: false, baseType: 'list[FeedbackHistoryEntryDict]', portSchemaId: 'list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array' },
    in_vlm_validation: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool', portSchemaId: 'boolean_bool_bool_single_primitive' },
    out_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    out_image: { schemaType: 'image', wireType: 'map', isMulti: false, baseType: 'ImageAsset', portSchemaId: 'image_object_asset_image_asset_single_map' },
    out_metadata: { schemaType: 'ObjectMetadataDict', wireType: 'map', isMulti: false, baseType: 'ObjectMetadataDict', portSchemaId: 'object_metadata_dict_object_metadata_dict_object_metadata_dict_single_map' },
    out_vlm_report: { schemaType: 'VlmValidationReportDict', wireType: 'map', isMulti: false, baseType: 'VlmValidationReportDict', portSchemaId: 'vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map' },
  },
  panel_source: {
    out_image: { schemaType: 'image', wireType: 'map', isMulti: false, baseType: 'ImageAsset', portSchemaId: 'image_image_asset_ref_dict_image_asset_single_map' },
    out_action: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    out_character_ids: { schemaType: 'string', wireType: 'array', isMulti: false, baseType: 'list[str]', portSchemaId: 'string_list_str_list_str_single_array' },
    out_appearances: { schemaType: 'list[AppearanceDict]', wireType: 'array', isMulti: false, baseType: 'list[AppearanceDict]', portSchemaId: 'list_appearance_dict_list_appearance_dict_list_appearance_dict_single_array' },
    out_dialogue: { schemaType: 'list[PanelDialogueDict]', wireType: 'array', isMulti: false, baseType: 'list[PanelDialogueDict]', portSchemaId: 'list_panel_dialogue_dict_list_panel_dialogue_dict_list_panel_dialogue_dict_single_array' },
    out_script: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    out_composition: { schemaType: 'CompositionDict', wireType: 'map', isMulti: false, baseType: 'CompositionDict', portSchemaId: 'composition_dict_composition_dict_composition_dict_single_map' },
  },
  prompt_input: {
    out_prompt: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
  },
  script_writer: {
    in_prompt: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_active_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_active_variant_id: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_director_instruction: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_format_only: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool', portSchemaId: 'boolean_bool_bool_single_primitive' },
    in_gemini: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool', portSchemaId: 'boolean_bool_bool_single_primitive' },
    in_claude: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool', portSchemaId: 'boolean_bool_bool_single_primitive' },
    in_gpt: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool', portSchemaId: 'boolean_bool_bool_single_primitive' },
    in_characters: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str', portSchemaId: 'string_str_str_multi_array', allowsNullItems: true },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_target_duration_s: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float', portSchemaId: 'float_float_float_single_primitive' },
    in_review_history: { schemaType: 'list[ReviewHistoryEntryDict]', wireType: 'array', isMulti: false, baseType: 'list[ReviewHistoryEntryDict]', portSchemaId: 'list_review_history_entry_dict_list_review_history_entry_dict_list_review_history_entry_dict_single_array' },
    in_feedback_history: { schemaType: 'list[FeedbackHistoryEntryDict]', wireType: 'array', isMulti: false, baseType: 'list[FeedbackHistoryEntryDict]', portSchemaId: 'list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array' },
    in_bg_color: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    out_script: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    out_script_path: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    out_screenplay: { schemaType: 'list[ScriptScreenplaySceneDict]', wireType: 'array', isMulti: false, baseType: 'list[ScriptScreenplaySceneDict]', portSchemaId: 'list_script_screenplay_scene_dict_list_script_screenplay_scene_dict_list_script_screenplay_scene_dict_single_array' },
    out_dialogue: { schemaType: 'list[ScriptDialogueDict]', wireType: 'array', isMulti: false, baseType: 'list[ScriptDialogueDict]', portSchemaId: 'list_script_dialogue_dict_list_script_dialogue_dict_list_script_dialogue_dict_single_array' },
    out_voice_roles: { schemaType: 'VoiceRoleDict', wireType: 'array', isMulti: true, baseType: 'VoiceRoleDict', portSchemaId: 'voice_role_dict_voice_role_dict_voice_role_dict_multi_array' },
    out_voice_profiles: { schemaType: 'VoiceProfileDict', wireType: 'array', isMulti: true, baseType: 'VoiceProfileDict', portSchemaId: 'voice_profile_dict_voice_profile_dict_voice_profile_dict_multi_array' },
    out_action_lines: { schemaType: 'list[SceneTextDict]', wireType: 'array', isMulti: false, baseType: 'list[SceneTextDict]', portSchemaId: 'list_scene_text_dict_list_scene_text_dict_list_scene_text_dict_single_array' },
    out_characters: { schemaType: 'string', wireType: 'array', isMulti: false, baseType: 'list[str]', portSchemaId: 'string_list_str_list_str_single_array' },
    out_music_cues: { schemaType: 'list[SceneTextDict]', wireType: 'array', isMulti: false, baseType: 'list[SceneTextDict]', portSchemaId: 'list_scene_text_dict_list_scene_text_dict_list_scene_text_dict_single_array' },
    out_sfx: { schemaType: 'list[SceneTextDict]', wireType: 'array', isMulti: false, baseType: 'list[SceneTextDict]', portSchemaId: 'list_scene_text_dict_list_scene_text_dict_list_scene_text_dict_single_array' },
    out_gemini: { schemaType: 'ScreenplayResultDict', wireType: 'map', isMulti: false, baseType: 'ScreenplayResultDict', portSchemaId: 'screenplay_result_dict_screenplay_result_dict_screenplay_result_dict_single_map' },
    out_claude: { schemaType: 'ScreenplayResultDict', wireType: 'map', isMulti: false, baseType: 'ScreenplayResultDict', portSchemaId: 'screenplay_result_dict_screenplay_result_dict_screenplay_result_dict_single_map' },
    out_gpt: { schemaType: 'ScreenplayResultDict', wireType: 'map', isMulti: false, baseType: 'ScreenplayResultDict', portSchemaId: 'screenplay_result_dict_screenplay_result_dict_screenplay_result_dict_single_map' },
    out_locations: { schemaType: 'string', wireType: 'array', isMulti: false, baseType: 'list[str]', portSchemaId: 'string_list_str_list_str_single_array' },
    out_active_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    out_scene_count: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int', portSchemaId: 'int_int_int_single_primitive' },
    out_logline: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    out_genre_tone: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    out_synopsis: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    out_themes: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    out_script_variants: { schemaType: 'list[ScriptVariantDict]', wireType: 'array', isMulti: false, baseType: 'list[ScriptVariantDict]', portSchemaId: 'list_script_variant_dict_list_script_variant_dict_list_script_variant_dict_single_array' },
  },
  short_video_group: {
    in_label: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_collapsed: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool', portSchemaId: 'boolean_bool_bool_single_primitive' },
    in_storyboard_path: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_image: { schemaType: 'image', wireType: 'map', isMulti: false, baseType: 'ImageAsset', portSchemaId: 'image_image_asset_ref_dict_image_asset_single_map' },
    in_child_node_ids: { schemaType: 'string', wireType: 'array', isMulti: false, baseType: 'list[str]', portSchemaId: 'string_list_str_list_str_single_array' },
  },
  sound_expert: {
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_upstream: { schemaType: 'UpstreamContextDict', wireType: 'map', isMulti: false, baseType: 'UpstreamContextDict', portSchemaId: 'upstream_context_dict_upstream_context_dict_upstream_context_dict_single_map' },
    in_prompt: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_mode: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_duration: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_voice_profile: { schemaType: 'VoiceProfileDict', wireType: 'map', isMulti: false, baseType: 'VoiceProfileDict', portSchemaId: 'voice_profile_dict_voice_profile_dict_voice_profile_dict_single_map' },
    in_text: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_feedback_history: { schemaType: 'list[FeedbackHistoryEntryDict]', wireType: 'array', isMulti: false, baseType: 'list[FeedbackHistoryEntryDict]', portSchemaId: 'list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array' },
    in_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_loop: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_lyrics_mode: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_voice_map: { schemaType: 'VoiceMapDict', wireType: 'map', isMulti: false, baseType: 'VoiceMapDict', portSchemaId: 'voice_map_dict_voice_map_dict_voice_map_dict_single_map' },
    in_scene_id: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_panel_index: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int', portSchemaId: 'int_int_int_single_primitive' },
    in_pause_ms: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int', portSchemaId: 'int_int_int_single_primitive' },
    in_character_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_character_voice_source_for: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    out_duration_seconds: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float', portSchemaId: 'float_float_float_single_primitive' },
    out_audio: { schemaType: 'audio', wireType: 'map', isMulti: false, baseType: 'AudioAsset', portSchemaId: 'audio_sound_generated_audio_dict_audio_asset_single_map' },
    out_voice_profile: { schemaType: 'VoiceProfileDict', wireType: 'map', isMulti: false, baseType: 'VoiceProfileDict', portSchemaId: 'voice_profile_dict_voice_profile_dict_voice_profile_dict_single_map' },
  },
  speech_generator: {
    in_mode: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_script: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_text: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_character_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_voice_id: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_voice_profile: { schemaType: 'VoiceProfileDict', wireType: 'map', isMulti: false, baseType: 'VoiceProfileDict', portSchemaId: 'voice_profile_dict_voice_profile_dict_voice_profile_dict_single_map' },
    in_voice_map: { schemaType: 'VoiceMapDict', wireType: 'map', isMulti: false, baseType: 'VoiceMapDict', portSchemaId: 'voice_map_dict_voice_map_dict_voice_map_dict_single_map' },
    in_scene_id: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_panel_index: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int', portSchemaId: 'int_int_int_single_primitive' },
    in_pause_ms: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int', portSchemaId: 'int_int_int_single_primitive' },
    in_pronunciation_guide: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_language_code: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    out_duration_seconds: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float', portSchemaId: 'float_float_float_single_primitive' },
    out_waveform: { schemaType: 'list[float]', wireType: 'array', isMulti: false, baseType: 'list[float]', portSchemaId: 'list_float_list_float_list_float_single_array' },
    out_audio: { schemaType: 'audio', wireType: 'map', isMulti: false, baseType: 'AudioAsset', portSchemaId: 'audio_sound_generated_audio_dict_audio_asset_single_map' },
  },
  story_direction_preview: {
  },
  storyboard_designer: {
    in_script: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_characters: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'ImageAsset', portSchemaId: 'image_image_asset_ref_dict_image_asset_multi_array', allowsNullItems: true },
    in_character_names: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str', portSchemaId: 'string_str_str_multi_array', allowsNullItems: true },
    in_locations: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'ImageAsset', portSchemaId: 'image_image_asset_ref_dict_image_asset_multi_array', allowsNullItems: true },
    in_location_names: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str', portSchemaId: 'string_str_str_multi_array', allowsNullItems: true },
    in_objects: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'ImageAsset', portSchemaId: 'image_image_asset_ref_dict_image_asset_multi_array', allowsNullItems: true },
    in_object_names: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str', portSchemaId: 'string_str_str_multi_array', allowsNullItems: true },
    in_image: { schemaType: 'image', wireType: 'map', isMulti: false, baseType: 'ImageAsset', portSchemaId: 'image_image_asset_ref_dict_image_asset_single_map' },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_panel_count: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int', portSchemaId: 'int_int_int_single_primitive' },
    in_shot_count: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int', portSchemaId: 'int_int_int_single_primitive' },
    in_aspect_ratio: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_scene_id: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_location: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_vlm_validation: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool', portSchemaId: 'boolean_bool_bool_single_primitive' },
    in_video_anchors: { schemaType: 'list[ShotVideoAnchorDict]', wireType: 'array', isMulti: false, baseType: 'list[ShotVideoAnchorDict]', portSchemaId: 'list_shot_video_anchor_dict_list_shot_video_anchor_dict_list_shot_video_anchor_dict_single_array' },
    out_image: { schemaType: 'image', wireType: 'map', isMulti: false, baseType: 'ImageAsset', portSchemaId: 'image_generated_image_with_history_image_asset_single_map' },
    out_grid_images: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'ImageAsset', portSchemaId: 'image_image_asset_ref_dict_image_asset_multi_array' },
    out_metadata: { schemaType: 'StoryboardMetadataDict', wireType: 'map', isMulti: false, baseType: 'StoryboardMetadataDict', portSchemaId: 'storyboard_metadata_dict_storyboard_metadata_dict_storyboard_metadata_dict_single_map' },
    out_beats: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str', portSchemaId: 'string_str_str_multi_array' },
    out_shots: { schemaType: 'GeneratedShotRowV2Dict', wireType: 'array', isMulti: true, baseType: 'GeneratedShotRowV2Dict', portSchemaId: 'generated_shot_row_v2_dict_generated_shot_row_v2_dict_generated_shot_row_v2_dict_multi_array' },
    out_shot_seams: { schemaType: 'list[ShotSeamDict]', wireType: 'array', isMulti: false, baseType: 'list[ShotSeamDict]', portSchemaId: 'list_shot_seam_dict_list_shot_seam_dict_list_shot_seam_dict_single_array' },
    out_production_plan: { schemaType: 'ShotProductionPlanDict', wireType: 'map', isMulti: false, baseType: 'ShotProductionPlanDict', portSchemaId: 'shot_production_plan_dict_shot_production_plan_dict_shot_production_plan_dict_single_map' },
    out_video_generation_plan: { schemaType: 'ShotVideoGenerationPlanDict', wireType: 'map', isMulti: false, baseType: 'ShotVideoGenerationPlanDict', portSchemaId: 'shot_video_generation_plan_dict_shot_video_generation_plan_dict_shot_video_generation_plan_dict_single_map' },
    out_video_previous_plan: { schemaType: 'ShotVideoGenerationPlanDict', wireType: 'map', isMulti: false, baseType: 'ShotVideoGenerationPlanDict', portSchemaId: 'shot_video_generation_plan_dict_shot_video_generation_plan_dict_shot_video_generation_plan_dict_single_map' },
    out_start_frames: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'ImageAsset', portSchemaId: 'image_image_asset_ref_dict_image_asset_multi_array' },
    out_key_frames: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'ImageAsset', portSchemaId: 'image_image_asset_ref_dict_image_asset_multi_array' },
    out_end_frames: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'ImageAsset', portSchemaId: 'image_image_asset_ref_dict_image_asset_multi_array' },
    out_start_frame_prompts: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str', portSchemaId: 'string_str_str_multi_array' },
    out_key_frame_prompts: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str', portSchemaId: 'string_str_str_multi_array' },
    out_end_frame_prompts: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str', portSchemaId: 'string_str_str_multi_array' },
    out_frame_links: { schemaType: 'list[ShotFrameLinkDict]', wireType: 'array', isMulti: false, baseType: 'list[ShotFrameLinkDict]', portSchemaId: 'list_shot_frame_link_dict_list_shot_frame_link_dict_list_shot_frame_link_dict_single_array' },
    out_panel_refs: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'list[str]', portSchemaId: 'string_list_str_list_str_multi_array' },
    out_images: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'ImageAsset', portSchemaId: 'image_image_asset_ref_dict_image_asset_multi_array' },
    out_grid_descriptions: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str', portSchemaId: 'string_str_str_multi_array' },
    out_vlm_report: { schemaType: 'VlmValidationReportDict', wireType: 'map', isMulti: false, baseType: 'VlmValidationReportDict', portSchemaId: 'vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map' },
  },
  storyboard_no_enhance_designer: {
    in_script: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_characters: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'ImageAsset', portSchemaId: 'image_image_asset_ref_dict_image_asset_multi_array', allowsNullItems: true },
    in_character_names: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str', portSchemaId: 'string_str_str_multi_array', allowsNullItems: true },
    in_locations: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'ImageAsset', portSchemaId: 'image_image_asset_ref_dict_image_asset_multi_array', allowsNullItems: true },
    in_location_names: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str', portSchemaId: 'string_str_str_multi_array', allowsNullItems: true },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_panel_count: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int', portSchemaId: 'int_int_int_single_primitive' },
    in_scene_id: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_location: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_vlm_validation: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool', portSchemaId: 'boolean_bool_bool_single_primitive' },
    out_image: { schemaType: 'image', wireType: 'map', isMulti: false, baseType: 'ImageAsset', portSchemaId: 'image_image_asset_ref_dict_image_asset_single_map' },
    out_vlm_report: { schemaType: 'VlmValidationReportDict', wireType: 'map', isMulti: false, baseType: 'VlmValidationReportDict', portSchemaId: 'vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map' },
  },
  style_selector: {
    out_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
  },
  text: {
    in_input: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    out_text: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
  },
  video: {
    in_file_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_depth_include_audio: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool', portSchemaId: 'boolean_bool_bool_single_primitive' },
    in_transform_video: { schemaType: 'image', wireType: 'map', isMulti: false, baseType: 'VideoAsset', portSchemaId: 'image_video_asset_ref_dict_video_asset_single_map' },
    in_transform_target_resolution: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_transform_source_asset_path: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_transform_source_content_sha256: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_transform_source_width: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int', portSchemaId: 'int_int_int_single_primitive' },
    in_transform_source_height: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int', portSchemaId: 'int_int_int_single_primitive' },
    in_transform_source_frame_count: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int', portSchemaId: 'int_int_int_single_primitive' },
    in_transform_source_fps: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float', portSchemaId: 'float_float_float_single_primitive' },
    out_video: { schemaType: 'video', wireType: 'map', isMulti: false, baseType: 'VideoAsset', portSchemaId: 'video_generated_video_with_history_video_asset_single_map' },
  },
  video_editor: {
    in_reference_media: { schemaType: 'video|audio', wireType: 'array', isMulti: true, baseType: 'VideoAsset|AudioAsset', portSchemaId: 'video_audio_media_asset_ref_dict_video_asset_audio_asset_multi_array', allowsNullItems: true },
    in_videos: { schemaType: 'video', wireType: 'array', isMulti: true, baseType: 'VideoAsset', portSchemaId: 'video_video_asset_ref_dict_video_asset_multi_array', allowsNullItems: true },
    in_audios: { schemaType: 'audio', wireType: 'array', isMulti: true, baseType: 'AudioAsset', portSchemaId: 'audio_audio_asset_ref_dict_audio_asset_multi_array', allowsNullItems: true },
    in_audio: { schemaType: 'audio', wireType: 'map', isMulti: false, baseType: 'AudioAsset', portSchemaId: 'audio_audio_asset_ref_dict_audio_asset_single_map' },
    in_video_config: { schemaType: 'TimelineConfigDict', wireType: 'map', isMulti: false, baseType: 'TimelineConfigDict', portSchemaId: 'timeline_config_dict_timeline_config_dict_timeline_config_dict_single_map' },
    in_edit_spec: { schemaType: 'EditSpecDict', wireType: 'map', isMulti: false, baseType: 'EditSpecDict', portSchemaId: 'edit_spec_dict_edit_spec_dict_edit_spec_dict_single_map' },
    in_mode: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_output_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_start: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float', portSchemaId: 'float_float_float_single_primitive' },
    in_end: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float', portSchemaId: 'float_float_float_single_primitive' },
    in_volume: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float', portSchemaId: 'float_float_float_single_primitive' },
    in_export_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    out_video: { schemaType: 'video', wireType: 'map', isMulti: false, baseType: 'VideoAsset', portSchemaId: 'video_video_asset_ref_dict_video_asset_single_map' },
    out_rendered_spec_hash: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    out_render_sources: { schemaType: 'ShotVideoRenderSourcesDict', wireType: 'map', isMulti: false, baseType: 'ShotVideoRenderSourcesDict', portSchemaId: 'shot_video_render_sources_dict_shot_video_render_sources_dict_shot_video_render_sources_dict_single_map' },
  },
  video_generator: {
    in_reference_media: { schemaType: 'image|video|audio', wireType: 'array', isMulti: true, baseType: 'ImageAsset|VideoAsset|AudioAsset', portSchemaId: 'image_video_audio_media_asset_ref_dict_image_asset_video_asset_audio_asset_multi_array', allowsNullItems: true },
    in_mode: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_scene_id: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_clip_number: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int', portSchemaId: 'int_int_int_single_primitive' },
    in_images: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'ImageAsset', portSchemaId: 'image_image_asset_ref_dict_image_asset_multi_array', allowsNullItems: true },
    in_reference_videos: { schemaType: 'video', wireType: 'array', isMulti: true, baseType: 'VideoAsset', portSchemaId: 'video_video_asset_ref_dict_video_asset_multi_array', allowsNullItems: true },
    in_continuation_source: { schemaType: 'video', wireType: 'map', isMulti: false, baseType: 'VideoAsset', portSchemaId: 'video_generated_video_with_history_video_asset_single_map' },
    in_shot_list_source_id: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_shot_list_source_fingerprint: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_shot_list_request_fingerprint: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_reference_audios: { schemaType: 'audio', wireType: 'array', isMulti: true, baseType: 'AudioAsset', portSchemaId: 'audio_audio_asset_ref_dict_audio_asset_multi_array', allowsNullItems: true },
    in_audio: { schemaType: 'audio', wireType: 'map', isMulti: false, baseType: 'AudioAsset', portSchemaId: 'audio_audio_asset_ref_dict_audio_asset_single_map' },
    in_motion_prompt: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_scene_context: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_duration: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float', portSchemaId: 'float_float_float_single_primitive' },
    in_reference_video_edits: { schemaType: 'list[VideoReferenceEditDict]', wireType: 'array', isMulti: false, baseType: 'list[VideoReferenceEditDict]', portSchemaId: 'list_video_reference_edit_dict_list_video_reference_edit_dict_list_video_reference_edit_dict_single_array' },
    in_dialogue_prompt: { schemaType: 'list[DialogueEntryDict]', wireType: 'array', isMulti: false, baseType: 'list[DialogueEntryDict]', portSchemaId: 'list_dialogue_entry_dict_list_dialogue_entry_dict_list_dialogue_entry_dict_single_array' },
    in_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_aspect_ratio: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_resolution: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_generate_audio: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool', portSchemaId: 'boolean_bool_bool_single_primitive' },
    in_provider_generate_audio: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool', portSchemaId: 'boolean_bool_bool_single_primitive' },
    in_use_voice_profile_audio_references: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool', portSchemaId: 'boolean_bool_bool_single_primitive' },
    in_audio_remix_mode: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'AudioRemixMode', portSchemaId: 'string_audio_remix_mode_audio_remix_mode_single_primitive' },
    in_allow_bgm: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool', portSchemaId: 'boolean_bool_bool_single_primitive' },
    in_tts_provider: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_dub_target_language: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_voice_profiles: { schemaType: 'VoiceProfileDict', wireType: 'array', isMulti: true, baseType: 'VoiceProfileDict', portSchemaId: 'voice_profile_dict_voice_profile_dict_voice_profile_dict_multi_array', allowsNullItems: true },
    in_voice_settings: { schemaType: 'VoiceSettingsDict', wireType: 'map', isMulti: false, baseType: 'VoiceSettingsDict', portSchemaId: 'voice_settings_dict_voice_settings_dict_voice_settings_dict_single_map' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_resolved_voice_map: { schemaType: 'ResolvedVoiceMapDict', wireType: 'map', isMulti: false, baseType: 'ResolvedVoiceMapDict', portSchemaId: 'resolved_voice_map_dict_resolved_voice_map_dict_resolved_voice_map_dict_single_map' },
    in_audio_remix_config: { schemaType: 'AudioRemixConfigDict', wireType: 'map', isMulti: false, baseType: 'AudioRemixConfigDict', portSchemaId: 'audio_remix_config_dict_audio_remix_config_dict_audio_remix_config_dict_single_map' },
    in_speech_transformer_config: { schemaType: 'SpeechTransformerConfigDict', wireType: 'map', isMulti: false, baseType: 'SpeechTransformerConfigDict', portSchemaId: 'speech_transformer_config_dict_speech_transformer_config_dict_speech_transformer_config_dict_single_map' },
    in_audio_take_selections: { schemaType: 'AudioTakeSelectionMapDict', wireType: 'map', isMulti: false, baseType: 'AudioTakeSelectionMapDict', portSchemaId: 'audio_take_selection_map_dict_audio_take_selection_map_dict_audio_take_selection_map_dict_single_map' },
    in_audio_variant_workspaces: { schemaType: 'AudioVariantWorkspaceMapDict', wireType: 'map', isMulti: false, baseType: 'AudioVariantWorkspaceMapDict', portSchemaId: 'audio_variant_workspace_map_dict_audio_variant_workspace_map_dict_audio_variant_workspace_map_dict_single_map' },
    in_unified_audio_config: { schemaType: 'UnifiedAudioProjectDict', wireType: 'map', isMulti: false, baseType: 'UnifiedAudioProjectDict', portSchemaId: 'unified_audio_project_dict_unified_audio_project_dict_unified_audio_project_dict_single_map' },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    out_video: { schemaType: 'video', wireType: 'map', isMulti: false, baseType: 'VideoAsset', portSchemaId: 'video_generated_video_with_history_video_asset_single_map' },
    out_tts_segments: { schemaType: 'list[TtsSegmentDict]', wireType: 'array', isMulti: false, baseType: 'list[TtsSegmentDict]', portSchemaId: 'list_tts_segment_dict_list_tts_segment_dict_list_tts_segment_dict_single_array' },
    out_audio_remix_baseline: { schemaType: 'AudioRemixConfigDict', wireType: 'map', isMulti: false, baseType: 'AudioRemixConfigDict', portSchemaId: 'audio_remix_config_dict_audio_remix_config_dict_audio_remix_config_dict_single_map' },
    out_speech_transformer_spans: { schemaType: 'SpeechTransformerDetectionDict', wireType: 'map', isMulti: false, baseType: 'SpeechTransformerDetectionDict', portSchemaId: 'speech_transformer_detection_dict_speech_transformer_detection_dict_speech_transformer_detection_dict_single_map' },
    out_auto_dialogue: { schemaType: 'list[DialogueEntryDict]', wireType: 'array', isMulti: false, baseType: 'list[DialogueEntryDict]', portSchemaId: 'list_dialogue_entry_dict_list_dialogue_entry_dict_list_dialogue_entry_dict_single_array' },
    out_speech_windows: { schemaType: 'list[SpeechWindowDict]', wireType: 'array', isMulti: false, baseType: 'list[SpeechWindowDict]', portSchemaId: 'list_speech_window_dict_list_speech_window_dict_list_speech_window_dict_single_array' },
    out_native_speech_takes: { schemaType: 'list[NativeSpeechTakeDict]', wireType: 'array', isMulti: false, baseType: 'list[NativeSpeechTakeDict]', portSchemaId: 'list_native_speech_take_dict_list_native_speech_take_dict_list_native_speech_take_dict_single_array' },
    out_native_speech_spans: { schemaType: 'list[NativeSpeechSpanDict]', wireType: 'array', isMulti: false, baseType: 'list[NativeSpeechSpanDict]', portSchemaId: 'list_native_speech_span_dict_list_native_speech_span_dict_list_native_speech_span_dict_single_array' },
    out_native_speech_detect_seq: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int', portSchemaId: 'int_int_int_single_primitive' },
    out_video_prompt: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    out_video_duration: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float', portSchemaId: 'float_float_float_single_primitive' },
    out_dialogue: { schemaType: 'list[ReconciledDialogueEntryDict]', wireType: 'array', isMulti: false, baseType: 'list[ReconciledDialogueEntryDict]', portSchemaId: 'list_reconciled_dialogue_entry_dict_list_reconciled_dialogue_entry_dict_list_reconciled_dialogue_entry_dict_single_array' },
  },
  webtoon_group: {
    in_scene_id: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_label: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_collapsed: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool', portSchemaId: 'boolean_bool_bool_single_primitive' },
    in_child_node_ids: { schemaType: 'string', wireType: 'array', isMulti: false, baseType: 'list[str]', portSchemaId: 'string_list_str_list_str_single_array' },
  },
  webtoon_panel_generator: {
    in_images: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'ImageAsset', portSchemaId: 'image_image_asset_ref_dict_image_asset_multi_array', allowsNullItems: true },
    in_prompt: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_beats: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str', portSchemaId: 'string_str_str_multi_array', allowsNullItems: true },
    in_dialogue: { schemaType: 'WebtoonDialogueDict', wireType: 'array', isMulti: true, baseType: 'WebtoonDialogueDict', portSchemaId: 'webtoon_dialogue_dict_webtoon_dialogue_dict_webtoon_dialogue_dict_multi_array', allowsNullItems: true },
    in_panel_index: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int', portSchemaId: 'int_int_int_single_primitive' },
    in_aspect_ratio: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_layout: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str', portSchemaId: 'string_str_str_single_primitive' },
    in_feedback_history: { schemaType: 'list[FeedbackHistoryEntryDict]', wireType: 'array', isMulti: false, baseType: 'list[FeedbackHistoryEntryDict]', portSchemaId: 'list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array' },
    out_image: { schemaType: 'image', wireType: 'map', isMulti: false, baseType: 'ImageAsset', portSchemaId: 'image_generated_image_with_history_image_asset_single_map' },
  },
}

export const YDOC_CREATION_ROOT_FIELDS: Readonly<Record<string, ReadonlySet<string>>> = {
  video_editor: new Set(["in_video_config"]),
  video_generator: new Set(["in_audio_take_selections"]),
}

export const YDOC_LEGACY_NULL_AS_ABSENT_FIELDS: Readonly<Record<string, ReadonlySet<string>>> = {
  video_editor: new Set(["in_video_config"]),
}

export const YDOC_EDGE_DERIVED_INPUT_FIELDS: Record<string, ReadonlySet<string>> = {
  audio: new Set(["in_voice_profile"]),
  character_designer: new Set(["in_images"]),
  image: new Set(["in_image"]),
  image_generator: new Set(["in_image", "in_images", "in_panel_refs"]),
  location_designer: new Set(["in_images"]),
  object_designer: new Set(["in_images"]),
  script_writer: new Set(["in_characters"]),
  short_video_group: new Set(["in_image"]),
  sound_expert: new Set(["in_voice_profile"]),
  speech_generator: new Set(["in_voice_profile"]),
  storyboard_designer: new Set(["in_characters", "in_image", "in_locations", "in_objects"]),
  storyboard_no_enhance_designer: new Set(["in_characters", "in_locations"]),
  video_editor: new Set(["in_audio", "in_audios", "in_reference_media", "in_videos"]),
  video_generator: new Set(["in_audio", "in_dialogue_prompt", "in_images", "in_reference_audios", "in_reference_media", "in_reference_videos", "in_voice_profiles"]),
  webtoon_panel_generator: new Set(["in_images"]),
}

export function isEdgeDerivedInputField(nodeType: string | undefined, field: string): boolean {
  if (!nodeType) return false
  const backendType = FE_TYPE_TO_BACKEND[nodeType] ?? nodeType
  return YDOC_EDGE_DERIVED_INPUT_FIELDS[backendType]?.has(field) === true
}

/** Node state field IDs declared in each node schema's 'state' section.
 *  These are non-port fields that round-trip to YDoc (e.g. 'batch_pending').
 *  ``revision`` is appended to every type since every node has revision state. */
export const NODE_STATE_FIELDS: Record<string, ReadonlySet<string>> = {
  audio: new Set(['revision']),
  character_designer: new Set(['annotated_image_path', 'batch_pending', 'revision']),
  debug_hang: new Set(['revision']),
  director: new Set(['pending_tool_state', 'revision']),
  generated_image_with_history: new Set(['revision']),
  image: new Set(['revision']),
  image_generator: new Set(['annotated_image_path', 'batch_pending', 'name_autogen', 'revision']),
  location_designer: new Set(['annotated_image_path', 'batch_pending', 'revision']),
  node_group: new Set(['name_autogen', 'revision']),
  object_designer: new Set(['annotated_image_path', 'batch_pending', 'revision']),
  panel_source: new Set(['revision']),
  prompt_input: new Set(['revision']),
  script_writer: new Set(['revision']),
  short_video_group: new Set(['revision']),
  sound_expert: new Set(['audio_file', 'batch_pending', 'revision', 'selected_voice_id', 'selected_voice_name', 'selected_voice_provider', 'selected_voice_ref', 'speech_segments']),
  speech_generator: new Set(['revision']),
  story_direction_preview: new Set(['hook', 'premise', 'revision', 'structure', 'tone']),
  storyboard_designer: new Set(['batch_pending', 'name_autogen', 'revision', 'shot_guidance_fingerprint', 'shot_guidance_kind', 'shot_guidance_warning', 'shot_key_frame_relinks', 'shot_list', 'shot_list_planner_version', 'storyboard_mode', 'storyboard_view']),
  storyboard_no_enhance_designer: new Set(['revision']),
  style_selector: new Set(['revision']),
  text: new Set(['revision']),
  video: new Set(['revision']),
  video_editor: new Set(['edit_spec_compatibility_state', 'edit_spec_migration_error', 'last_export_node_id', 'magnet_enabled', 'revision']),
  video_generator: new Set(['action', 'batch_pending', 'clip_id', 'closing_frame_handshake', 'full_remix_status', 'name_autogen', 'revision', 'segment_index', 'target_variant_path', 'target_voice_id', 'thumbnail', 'voice_acting_status']),
  webtoon_group: new Set(['revision']),
  webtoon_panel_generator: new Set(['batch_pending', 'bubbles', 'revision']),
}

/** Credit-facing labels for non-default execution actions (from schema actionLabels).
 *  Surfaced in the cost-confirmation popup so a non-default action charge
 *  can use its action label, not only the node label. Sparse: only nodes that declare
 *  labels appear; a missing label falls back to the node-type label at render time. */
export const EXECUTION_ACTION_LABELS: Record<string, Record<string, string>> = {
  script_writer: {
    "replace_from_script": "Replace script",
    "resync_from_script": "Sync edits",
    "rewrite_with_model": "Rewrite screenplay",
  },
  storyboard_designer: {
    "generate_production_plan": "Plan Production Details",
    "generate_shot_frames_all": "Generate All Shot Frames",
    "generate_shot_frames_key": "Generate Key Frames",
    "generate_shot_frames_start_end": "Generate Start and End Frames",
    "generate_shot_list": "Generate Shot List",
  },
  video: {
    "extract_depth": "Depth extraction",
    "upscale": "Upscale",
  },
  video_editor: {
    "timeline_render": "Video editing",
    "vibe_render": "Render vibe edit",
  },
  video_generator: {
    "reformat_motion_prompt": "Prompt cleanup",
    "run_speech_to_text": "Transcription",
  },
}

export const YDOC_NODE_FIELD_PORTS: Record<string, Record<string, string>> = {
  audio: {
    in_file_name: 'string_str_str_single_primitive',
    in_voice_profile: 'voice_profile_dict_voice_profile_dict_voice_profile_dict_single_map',
    out_audio: 'audio_audio_asset_ref_dict_audio_asset_single_map',
  },
  character_designer: {
    in_upstream: 'upstream_context_dict_upstream_context_dict_upstream_context_dict_single_map',
    in_images: 'image_image_asset_ref_dict_image_asset_multi_array',
    in_name: 'string_str_str_single_primitive',
    in_role: 'string_str_str_single_primitive',
    in_style: 'string_str_str_single_primitive',
    in_description: 'string_str_str_single_primitive',
    in_model: 'string_str_str_single_primitive',
    in_feedback: 'string_str_str_single_primitive',
    in_feedback_history: 'list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array',
    in_pronunciation_guide: 'string_str_str_single_primitive',
    in_bg_color: 'string_str_str_single_primitive',
    in_vlm_validation: 'boolean_bool_bool_single_primitive',
    out_name: 'string_str_str_single_primitive',
    out_image: 'image_character_asset_image_asset_single_map',
    out_voice_profile: 'voice_profile_dict_voice_profile_dict_voice_profile_dict_single_map',
    out_vlm_report: 'vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map',
  },
  debug_hang: {
    in_label: 'string_str_str_single_primitive',
    out_result: 'string_str_str_single_primitive',
  },
  director: {
    in_context: 'string_str_str_single_primitive',
    out_response: 'string_str_str_single_primitive',
    out_crew: 'director_crew_dict_director_crew_dict_director_crew_dict_single_map',
  },
  generated_image_with_history: {
  },
  image: {
    in_file_name: 'string_str_str_single_primitive',
    in_image: 'image_image_asset_ref_dict_image_asset_single_map',
    out_image: 'image_image_asset_ref_dict_image_asset_single_map',
  },
  image_generator: {
    in_images: 'image_image_asset_ref_dict_image_asset_multi_array',
    in_upstream: 'upstream_context_dict_upstream_context_dict_upstream_context_dict_single_map',
    in_name: 'string_str_str_single_primitive',
    in_prompt: 'string_str_str_single_primitive',
    in_aspect_ratio: 'aspect_ratio_aspect_ratio_aspect_ratio_single_primitive',
    in_style: 'string_str_str_single_primitive',
    in_quality: 'string_str_str_single_primitive',
    in_model: 'string_str_str_single_primitive',
    in_panel_refs: 'string_list_str_list_str_single_array',
    in_update: 'boolean_bool_bool_single_primitive',
    in_image: 'image_image_asset_ref_dict_image_asset_single_map',
    in_feedback: 'string_str_str_single_primitive',
    in_video: 'string_str_str_single_primitive',
    in_source_video: 'video_generated_video_with_history_video_asset_single_map',
    in_expected_video_duration_ms: 'int_int_int_single_primitive',
    in_frame: 'string_str_str_single_primitive',
    in_get_frame: 'boolean_bool_bool_single_primitive',
    in_feedback_history: 'list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array',
    in_vlm_validation: 'boolean_bool_bool_single_primitive',
    out_image: 'image_generated_image_with_history_image_asset_single_map',
    out_vlm_report: 'vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map',
  },
  location_designer: {
    in_images: 'image_image_asset_ref_dict_image_asset_multi_array',
    in_name: 'string_str_str_single_primitive',
    in_style: 'string_str_str_single_primitive',
    in_time_of_day: 'string_str_str_single_primitive',
    in_weather: 'string_str_str_single_primitive',
    in_description: 'string_str_str_single_primitive',
    in_model: 'string_str_str_single_primitive',
    in_feedback: 'string_str_str_single_primitive',
    in_feedback_history: 'list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array',
    in_bg_color: 'string_str_str_single_primitive',
    in_vlm_validation: 'boolean_bool_bool_single_primitive',
    in_720_enabled: 'boolean_bool_bool_single_primitive',
    in_720_view: 'location_panorama_view_dict_location_panorama_view_dict_location_panorama_view_dict_single_map',
    out_name: 'string_str_str_single_primitive',
    out_image: 'image_location_asset_image_asset_single_map',
    out_metadata: 'location_metadata_dict_location_metadata_dict_location_metadata_dict_single_map',
    out_vlm_report: 'vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map',
  },
  node_group: {
    in_label: 'string_str_str_single_primitive',
    in_child_node_ids: 'string_list_str_none_list_str_none_single_array',
    in_layout_mode: 'string_str_str_single_primitive',
    in_collapsed: 'boolean_bool_bool_single_primitive',
    in_collapsible: 'boolean_bool_bool_single_primitive',
    in_bg_color: 'string_str_str_single_primitive',
  },
  object_designer: {
    in_images: 'image_image_asset_ref_dict_image_asset_multi_array',
    in_name: 'string_str_str_single_primitive',
    in_style: 'string_str_str_single_primitive',
    in_description: 'string_str_str_single_primitive',
    in_model: 'string_str_str_single_primitive',
    in_feedback: 'string_str_str_single_primitive',
    in_feedback_history: 'list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array',
    in_vlm_validation: 'boolean_bool_bool_single_primitive',
    out_name: 'string_str_str_single_primitive',
    out_image: 'image_object_asset_image_asset_single_map',
    out_metadata: 'object_metadata_dict_object_metadata_dict_object_metadata_dict_single_map',
    out_vlm_report: 'vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map',
  },
  panel_source: {
    out_image: 'image_image_asset_ref_dict_image_asset_single_map',
    out_action: 'string_str_str_single_primitive',
    out_character_ids: 'string_list_str_list_str_single_array',
    out_appearances: 'list_appearance_dict_list_appearance_dict_list_appearance_dict_single_array',
    out_dialogue: 'list_panel_dialogue_dict_list_panel_dialogue_dict_list_panel_dialogue_dict_single_array',
    out_script: 'string_str_str_single_primitive',
    out_composition: 'composition_dict_composition_dict_composition_dict_single_map',
  },
  prompt_input: {
    out_prompt: 'string_str_str_single_primitive',
  },
  script_writer: {
    in_prompt: 'string_str_str_single_primitive',
    in_active_model: 'string_str_str_single_primitive',
    in_active_variant_id: 'string_str_str_single_primitive',
    in_name: 'string_str_str_single_primitive',
    in_director_instruction: 'string_str_str_single_primitive',
    in_format_only: 'boolean_bool_bool_single_primitive',
    in_gemini: 'boolean_bool_bool_single_primitive',
    in_claude: 'boolean_bool_bool_single_primitive',
    in_gpt: 'boolean_bool_bool_single_primitive',
    in_characters: 'string_str_str_multi_array',
    in_feedback: 'string_str_str_single_primitive',
    in_target_duration_s: 'float_float_float_single_primitive',
    in_review_history: 'list_review_history_entry_dict_list_review_history_entry_dict_list_review_history_entry_dict_single_array',
    in_feedback_history: 'list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array',
    in_bg_color: 'string_str_str_single_primitive',
    out_script: 'string_str_str_single_primitive',
    out_script_path: 'string_str_str_single_primitive',
    out_screenplay: 'list_script_screenplay_scene_dict_list_script_screenplay_scene_dict_list_script_screenplay_scene_dict_single_array',
    out_dialogue: 'list_script_dialogue_dict_list_script_dialogue_dict_list_script_dialogue_dict_single_array',
    out_voice_roles: 'voice_role_dict_voice_role_dict_voice_role_dict_multi_array',
    out_voice_profiles: 'voice_profile_dict_voice_profile_dict_voice_profile_dict_multi_array',
    out_action_lines: 'list_scene_text_dict_list_scene_text_dict_list_scene_text_dict_single_array',
    out_characters: 'string_list_str_list_str_single_array',
    out_music_cues: 'list_scene_text_dict_list_scene_text_dict_list_scene_text_dict_single_array',
    out_sfx: 'list_scene_text_dict_list_scene_text_dict_list_scene_text_dict_single_array',
    out_gemini: 'screenplay_result_dict_screenplay_result_dict_screenplay_result_dict_single_map',
    out_claude: 'screenplay_result_dict_screenplay_result_dict_screenplay_result_dict_single_map',
    out_gpt: 'screenplay_result_dict_screenplay_result_dict_screenplay_result_dict_single_map',
    out_locations: 'string_list_str_list_str_single_array',
    out_active_model: 'string_str_str_single_primitive',
    out_scene_count: 'int_int_int_single_primitive',
    out_logline: 'string_str_str_single_primitive',
    out_genre_tone: 'string_str_str_single_primitive',
    out_synopsis: 'string_str_str_single_primitive',
    out_themes: 'string_str_str_single_primitive',
    out_script_variants: 'list_script_variant_dict_list_script_variant_dict_list_script_variant_dict_single_array',
  },
  short_video_group: {
    in_label: 'string_str_str_single_primitive',
    in_collapsed: 'boolean_bool_bool_single_primitive',
    in_storyboard_path: 'string_str_str_single_primitive',
    in_image: 'image_image_asset_ref_dict_image_asset_single_map',
    in_child_node_ids: 'string_list_str_list_str_single_array',
  },
  sound_expert: {
    in_name: 'string_str_str_single_primitive',
    in_upstream: 'upstream_context_dict_upstream_context_dict_upstream_context_dict_single_map',
    in_prompt: 'string_str_str_single_primitive',
    in_mode: 'string_str_str_single_primitive',
    in_duration: 'string_str_str_single_primitive',
    in_voice_profile: 'voice_profile_dict_voice_profile_dict_voice_profile_dict_single_map',
    in_text: 'string_str_str_single_primitive',
    in_feedback: 'string_str_str_single_primitive',
    in_feedback_history: 'list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array',
    in_model: 'string_str_str_single_primitive',
    in_loop: 'string_str_str_single_primitive',
    in_lyrics_mode: 'string_str_str_single_primitive',
    in_voice_map: 'voice_map_dict_voice_map_dict_voice_map_dict_single_map',
    in_scene_id: 'string_str_str_single_primitive',
    in_panel_index: 'int_int_int_single_primitive',
    in_pause_ms: 'int_int_int_single_primitive',
    in_character_name: 'string_str_str_single_primitive',
    in_character_voice_source_for: 'string_str_str_single_primitive',
    out_duration_seconds: 'float_float_float_single_primitive',
    out_audio: 'audio_sound_generated_audio_dict_audio_asset_single_map',
    out_voice_profile: 'voice_profile_dict_voice_profile_dict_voice_profile_dict_single_map',
  },
  speech_generator: {
    in_mode: 'string_str_str_single_primitive',
    in_script: 'string_str_str_single_primitive',
    in_text: 'string_str_str_single_primitive',
    in_character_name: 'string_str_str_single_primitive',
    in_voice_id: 'string_str_str_single_primitive',
    in_voice_profile: 'voice_profile_dict_voice_profile_dict_voice_profile_dict_single_map',
    in_voice_map: 'voice_map_dict_voice_map_dict_voice_map_dict_single_map',
    in_scene_id: 'string_str_str_single_primitive',
    in_panel_index: 'int_int_int_single_primitive',
    in_pause_ms: 'int_int_int_single_primitive',
    in_pronunciation_guide: 'string_str_str_single_primitive',
    in_language_code: 'string_str_str_single_primitive',
    out_duration_seconds: 'float_float_float_single_primitive',
    out_waveform: 'list_float_list_float_list_float_single_array',
    out_audio: 'audio_sound_generated_audio_dict_audio_asset_single_map',
  },
  story_direction_preview: {
  },
  storyboard_designer: {
    in_script: 'string_str_str_single_primitive',
    in_characters: 'image_image_asset_ref_dict_image_asset_multi_array',
    in_character_names: 'string_str_str_multi_array',
    in_locations: 'image_image_asset_ref_dict_image_asset_multi_array',
    in_location_names: 'string_str_str_multi_array',
    in_objects: 'image_image_asset_ref_dict_image_asset_multi_array',
    in_object_names: 'string_str_str_multi_array',
    in_image: 'image_image_asset_ref_dict_image_asset_single_map',
    in_style: 'string_str_str_single_primitive',
    in_panel_count: 'int_int_int_single_primitive',
    in_shot_count: 'int_int_int_single_primitive',
    in_aspect_ratio: 'string_str_str_single_primitive',
    in_scene_id: 'string_str_str_single_primitive',
    in_name: 'string_str_str_single_primitive',
    in_location: 'string_str_str_single_primitive',
    in_model: 'string_str_str_single_primitive',
    in_feedback: 'string_str_str_single_primitive',
    in_vlm_validation: 'boolean_bool_bool_single_primitive',
    in_video_anchors: 'list_shot_video_anchor_dict_list_shot_video_anchor_dict_list_shot_video_anchor_dict_single_array',
    out_image: 'image_generated_image_with_history_image_asset_single_map',
    out_grid_images: 'image_image_asset_ref_dict_image_asset_multi_array',
    out_metadata: 'storyboard_metadata_dict_storyboard_metadata_dict_storyboard_metadata_dict_single_map',
    out_beats: 'string_str_str_multi_array',
    out_shots: 'generated_shot_row_v2_dict_generated_shot_row_v2_dict_generated_shot_row_v2_dict_multi_array',
    out_shot_seams: 'list_shot_seam_dict_list_shot_seam_dict_list_shot_seam_dict_single_array',
    out_production_plan: 'shot_production_plan_dict_shot_production_plan_dict_shot_production_plan_dict_single_map',
    out_video_generation_plan: 'shot_video_generation_plan_dict_shot_video_generation_plan_dict_shot_video_generation_plan_dict_single_map',
    out_video_previous_plan: 'shot_video_generation_plan_dict_shot_video_generation_plan_dict_shot_video_generation_plan_dict_single_map',
    out_start_frames: 'image_image_asset_ref_dict_image_asset_multi_array',
    out_key_frames: 'image_image_asset_ref_dict_image_asset_multi_array',
    out_end_frames: 'image_image_asset_ref_dict_image_asset_multi_array',
    out_start_frame_prompts: 'string_str_str_multi_array',
    out_key_frame_prompts: 'string_str_str_multi_array',
    out_end_frame_prompts: 'string_str_str_multi_array',
    out_frame_links: 'list_shot_frame_link_dict_list_shot_frame_link_dict_list_shot_frame_link_dict_single_array',
    out_panel_refs: 'string_list_str_list_str_multi_array',
    out_images: 'image_image_asset_ref_dict_image_asset_multi_array',
    out_grid_descriptions: 'string_str_str_multi_array',
    out_vlm_report: 'vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map',
  },
  storyboard_no_enhance_designer: {
    in_script: 'string_str_str_single_primitive',
    in_characters: 'image_image_asset_ref_dict_image_asset_multi_array',
    in_character_names: 'string_str_str_multi_array',
    in_locations: 'image_image_asset_ref_dict_image_asset_multi_array',
    in_location_names: 'string_str_str_multi_array',
    in_style: 'string_str_str_single_primitive',
    in_panel_count: 'int_int_int_single_primitive',
    in_scene_id: 'string_str_str_single_primitive',
    in_location: 'string_str_str_single_primitive',
    in_model: 'string_str_str_single_primitive',
    in_vlm_validation: 'boolean_bool_bool_single_primitive',
    out_image: 'image_image_asset_ref_dict_image_asset_single_map',
    out_vlm_report: 'vlm_validation_report_dict_vlm_validation_report_dict_vlm_validation_report_dict_single_map',
  },
  style_selector: {
    out_style: 'string_str_str_single_primitive',
  },
  text: {
    in_input: 'string_str_str_single_primitive',
    out_text: 'string_str_str_single_primitive',
  },
  video: {
    in_file_name: 'string_str_str_single_primitive',
    in_depth_include_audio: 'boolean_bool_bool_single_primitive',
    in_transform_video: 'image_video_asset_ref_dict_video_asset_single_map',
    in_transform_target_resolution: 'string_str_str_single_primitive',
    in_transform_source_asset_path: 'string_str_str_single_primitive',
    in_transform_source_content_sha256: 'string_str_str_single_primitive',
    in_transform_source_width: 'int_int_int_single_primitive',
    in_transform_source_height: 'int_int_int_single_primitive',
    in_transform_source_frame_count: 'int_int_int_single_primitive',
    in_transform_source_fps: 'float_float_float_single_primitive',
    out_video: 'video_generated_video_with_history_video_asset_single_map',
  },
  video_editor: {
    in_reference_media: 'video_audio_media_asset_ref_dict_video_asset_audio_asset_multi_array',
    in_videos: 'video_video_asset_ref_dict_video_asset_multi_array',
    in_audios: 'audio_audio_asset_ref_dict_audio_asset_multi_array',
    in_audio: 'audio_audio_asset_ref_dict_audio_asset_single_map',
    in_video_config: 'timeline_config_dict_timeline_config_dict_timeline_config_dict_single_map',
    in_edit_spec: 'edit_spec_dict_edit_spec_dict_edit_spec_dict_single_map',
    in_mode: 'string_str_str_single_primitive',
    in_output_name: 'string_str_str_single_primitive',
    in_start: 'float_float_float_single_primitive',
    in_end: 'float_float_float_single_primitive',
    in_volume: 'float_float_float_single_primitive',
    in_export_name: 'string_str_str_single_primitive',
    out_video: 'video_video_asset_ref_dict_video_asset_single_map',
    out_rendered_spec_hash: 'string_str_str_single_primitive',
    out_render_sources: 'shot_video_render_sources_dict_shot_video_render_sources_dict_shot_video_render_sources_dict_single_map',
  },
  video_generator: {
    in_reference_media: 'image_video_audio_media_asset_ref_dict_image_asset_video_asset_audio_asset_multi_array',
    in_mode: 'string_str_str_single_primitive',
    in_scene_id: 'string_str_str_single_primitive',
    in_clip_number: 'int_int_int_single_primitive',
    in_images: 'image_image_asset_ref_dict_image_asset_multi_array',
    in_reference_videos: 'video_video_asset_ref_dict_video_asset_multi_array',
    in_continuation_source: 'video_generated_video_with_history_video_asset_single_map',
    in_shot_list_source_id: 'string_str_str_single_primitive',
    in_shot_list_source_fingerprint: 'string_str_str_single_primitive',
    in_shot_list_request_fingerprint: 'string_str_str_single_primitive',
    in_reference_audios: 'audio_audio_asset_ref_dict_audio_asset_multi_array',
    in_audio: 'audio_audio_asset_ref_dict_audio_asset_single_map',
    in_motion_prompt: 'string_str_str_single_primitive',
    in_scene_context: 'string_str_str_single_primitive',
    in_duration: 'float_float_float_single_primitive',
    in_reference_video_edits: 'list_video_reference_edit_dict_list_video_reference_edit_dict_list_video_reference_edit_dict_single_array',
    in_dialogue_prompt: 'list_dialogue_entry_dict_list_dialogue_entry_dict_list_dialogue_entry_dict_single_array',
    in_model: 'string_str_str_single_primitive',
    in_aspect_ratio: 'string_str_str_single_primitive',
    in_resolution: 'string_str_str_single_primitive',
    in_generate_audio: 'boolean_bool_bool_single_primitive',
    in_provider_generate_audio: 'boolean_bool_bool_single_primitive',
    in_use_voice_profile_audio_references: 'boolean_bool_bool_single_primitive',
    in_audio_remix_mode: 'string_audio_remix_mode_audio_remix_mode_single_primitive',
    in_allow_bgm: 'boolean_bool_bool_single_primitive',
    in_tts_provider: 'string_str_str_single_primitive',
    in_dub_target_language: 'string_str_str_single_primitive',
    in_voice_profiles: 'voice_profile_dict_voice_profile_dict_voice_profile_dict_multi_array',
    in_voice_settings: 'voice_settings_dict_voice_settings_dict_voice_settings_dict_single_map',
    in_name: 'string_str_str_single_primitive',
    in_resolved_voice_map: 'resolved_voice_map_dict_resolved_voice_map_dict_resolved_voice_map_dict_single_map',
    in_audio_remix_config: 'audio_remix_config_dict_audio_remix_config_dict_audio_remix_config_dict_single_map',
    in_speech_transformer_config: 'speech_transformer_config_dict_speech_transformer_config_dict_speech_transformer_config_dict_single_map',
    in_audio_take_selections: 'audio_take_selection_map_dict_audio_take_selection_map_dict_audio_take_selection_map_dict_single_map',
    in_audio_variant_workspaces: 'audio_variant_workspace_map_dict_audio_variant_workspace_map_dict_audio_variant_workspace_map_dict_single_map',
    in_unified_audio_config: 'unified_audio_project_dict_unified_audio_project_dict_unified_audio_project_dict_single_map',
    in_style: 'string_str_str_single_primitive',
    out_video: 'video_generated_video_with_history_video_asset_single_map',
    out_tts_segments: 'list_tts_segment_dict_list_tts_segment_dict_list_tts_segment_dict_single_array',
    out_audio_remix_baseline: 'audio_remix_config_dict_audio_remix_config_dict_audio_remix_config_dict_single_map',
    out_speech_transformer_spans: 'speech_transformer_detection_dict_speech_transformer_detection_dict_speech_transformer_detection_dict_single_map',
    out_auto_dialogue: 'list_dialogue_entry_dict_list_dialogue_entry_dict_list_dialogue_entry_dict_single_array',
    out_speech_windows: 'list_speech_window_dict_list_speech_window_dict_list_speech_window_dict_single_array',
    out_native_speech_takes: 'list_native_speech_take_dict_list_native_speech_take_dict_list_native_speech_take_dict_single_array',
    out_native_speech_spans: 'list_native_speech_span_dict_list_native_speech_span_dict_list_native_speech_span_dict_single_array',
    out_native_speech_detect_seq: 'int_int_int_single_primitive',
    out_video_prompt: 'string_str_str_single_primitive',
    out_video_duration: 'float_float_float_single_primitive',
    out_dialogue: 'list_reconciled_dialogue_entry_dict_list_reconciled_dialogue_entry_dict_list_reconciled_dialogue_entry_dict_single_array',
  },
  webtoon_group: {
    in_scene_id: 'string_str_str_single_primitive',
    in_label: 'string_str_str_single_primitive',
    in_collapsed: 'boolean_bool_bool_single_primitive',
    in_child_node_ids: 'string_list_str_list_str_single_array',
  },
  webtoon_panel_generator: {
    in_images: 'image_image_asset_ref_dict_image_asset_multi_array',
    in_prompt: 'string_str_str_single_primitive',
    in_beats: 'string_str_str_multi_array',
    in_dialogue: 'webtoon_dialogue_dict_webtoon_dialogue_dict_webtoon_dialogue_dict_multi_array',
    in_panel_index: 'int_int_int_single_primitive',
    in_aspect_ratio: 'string_str_str_single_primitive',
    in_layout: 'string_str_str_single_primitive',
    in_style: 'string_str_str_single_primitive',
    in_name: 'string_str_str_single_primitive',
    in_feedback: 'string_str_str_single_primitive',
    in_feedback_history: 'list_feedback_history_entry_dict_list_feedback_history_entry_dict_list_feedback_history_entry_dict_single_array',
    out_image: 'image_generated_image_with_history_image_asset_single_map',
  },
}

// ---------------------------------------------------------------------------
// Generated Y.Map wrapper classes for map-wire-format types
// ---------------------------------------------------------------------------

/** Base class for Y.Map wrapper types. Provides raw Y.Map access. */
export class YMapWrapper {
  constructor(public readonly _raw: Y.Map<YDocValue>) {}
  get(key: string): unknown { return this._raw.get(key) }
  /** Convert the entire Y.Map to a plain JSON object */
  toJSON(): Record<string, unknown> { return this._raw.toJSON() as Record<string, unknown> }
}

export class YMapRecord<T, TWrite = T> {
  constructor(
    public readonly _raw: Y.Map<YDocValue>,
    private readonly _fieldLabel: string,
    private readonly _itemReader: (item: unknown, itemLabel: string) => T,
    private readonly _itemValidator: (item: unknown, itemLabel: string) => void,
  ) {}

  get(key: string): T | undefined {
    const value = this._raw.get(key)
    if (value === undefined) return undefined
    return this._itemReader(value, `${this._fieldLabel}.${key}`)
  }

  set(key: string, value: TWrite): void {
    const fieldLabel = `${this._fieldLabel}.${key}`
    const validationValue = _attachYDocValidationCandidate(value)
    this._itemValidator(validationValue, fieldLabel)
    this._raw.set(key, _toYDocValue(value))
  }

  delete(key: string): void { this._raw.delete(key) }

  keys(): IterableIterator<string> { return this._raw.keys() }

  entries(): Array<[string, T]> {
    return Array.from(this._raw.entries()).map(([key, value]) => [
      key,
      this._itemReader(value, `${this._fieldLabel}.${key}`),
    ])
  }

  values(): T[] { return this.entries().map(([, value]) => value) }

  toJSON(): Record<string, unknown> { return this._raw.toJSON() as Record<string, unknown> }
}

export type YMapReadable = Y.Map<YDocValue> | YMapWrapper | YMapRecord<YDocValue>

function _yDocTypeName(value: unknown): string {
  if (value === null) return 'null'
  if (value instanceof Y.Map) return 'Y.Map'
  if (value instanceof Y.Array) return 'Y.Array'
  if (Array.isArray(value)) return 'Array'
  return typeof value
}

function _assertYMapReadable(value: unknown, helper: string): YMapReadable {
  if (value instanceof Y.Map || value instanceof YMapWrapper || value instanceof YMapRecord) {
    return value as YMapReadable
  }
  throw new TypeError(`${helper} expected Y.Map-backed value, got ${_yDocTypeName(value)}`)
}

function _readYDocOptionalMapWrapper<T extends YMapWrapper>(
  value: unknown,
  Wrapper: new (raw: Y.Map<YDocValue>) => T,
  fieldLabel: string,
): T | undefined {
  if (value == null) return undefined
  if (value instanceof Wrapper) return value
  if (value instanceof YMapWrapper) return new Wrapper(value._raw)
  if (value instanceof Y.Map) return new Wrapper(value as Y.Map<YDocValue>)
  throw new TypeError(`${fieldLabel} must be Y.Map, got ${_yDocTypeName(value)}`)
}

function _readYDocMapWrapper<T extends YMapWrapper>(
  value: unknown,
  Wrapper: new (raw: Y.Map<YDocValue>) => T,
  fieldLabel: string,
): T {
  const wrapped = _readYDocOptionalMapWrapper(value, Wrapper, fieldLabel)
  if (wrapped == null) throw new TypeError(`${fieldLabel} must be Y.Map, got ${_yDocTypeName(value)}`)
  return wrapped
}

function _readYDocOptionalMapRecord<T, TWrite = T>(
  value: unknown,
  fieldLabel: string,
  itemReader: (item: unknown, itemLabel: string) => T,
  itemValidator: (item: unknown, itemLabel: string) => void,
): YMapRecord<T, TWrite> | undefined {
  if (value == null) return undefined
  if (!(value instanceof Y.Map)) throw new TypeError(`${fieldLabel} must be Y.Map, got ${_yDocTypeName(value)}`)
  return new YMapRecord<T, TWrite>(value as Y.Map<YDocValue>, fieldLabel, itemReader, itemValidator)
}

function _readYDocMapRecord<T, TWrite = T>(
  value: unknown,
  fieldLabel: string,
  itemReader: (item: unknown, itemLabel: string) => T,
  itemValidator: (item: unknown, itemLabel: string) => void,
): YMapRecord<T, TWrite> {
  const wrapped = _readYDocOptionalMapRecord<T, TWrite>(value, fieldLabel, itemReader, itemValidator)
  if (wrapped == null) throw new TypeError(`${fieldLabel} must be Y.Map, got ${_yDocTypeName(value)}`)
  return wrapped
}

function _attachYDocValidationCandidate(value: YDocWriteValue): YDocValue {
  const validationRoot = new Y.Doc().getMap<YDocValue>('validation')
  validationRoot.set('candidate', _toYDocValue(value))
  return validationRoot.get('candidate')
}

function _readYDocOptionalArray<T>(
  value: unknown,
  fieldLabel: string,
  itemReader: (item: unknown, itemLabel: string) => T,
): T[] | undefined {
  if (value == null) return undefined
  if (!(value instanceof Y.Array)) throw new TypeError(`${fieldLabel} must be Y.Array, got ${_yDocTypeName(value)}`)
  return value.toArray().map((item, index) => itemReader(item, `${fieldLabel}[${index}]`))
}

function _readYDocArray<T>(
  value: unknown,
  fieldLabel: string,
  itemReader: (item: unknown, itemLabel: string) => T,
): T[] {
  const result = _readYDocOptionalArray(value, fieldLabel, itemReader)
  if (result == null) throw new TypeError(`${fieldLabel} must be Y.Array, got ${_yDocTypeName(value)}`)
  return result
}

function _readYDocOptionalString(value: unknown, fieldLabel: string): string | undefined {
  if (value == null) return undefined
  if (typeof value !== 'string') throw new TypeError(`${fieldLabel} must be string, got ${_yDocTypeName(value)}`)
  return value
}

function _readYDocString(value: unknown, fieldLabel: string): string {
  const result = _readYDocOptionalString(value, fieldLabel)
  if (result == null) throw new TypeError(`${fieldLabel} must be string, got ${_yDocTypeName(value)}`)
  return result
}

function _readYDocEnum<T>(value: unknown, fieldLabel: string, allowed: readonly T[]): T {
  if (!allowed.includes(value as T)) throw new TypeError(`${fieldLabel} must be one of ${JSON.stringify(allowed)}, got ${String(value)}`)
  return value as T
}

function _readYDocOptionalEnum<T>(value: unknown, fieldLabel: string, allowed: readonly T[]): T | undefined {
  // `== null` catches BOTH undefined and null. _validateYDocMap treats a
  // null on a non-required property as absent and skips its validator, so
  // rejecting null here made the reader throw on a value validation had
  // just declared legal — an optional enum persisted as null was
  // unreadable.
  if (value == null) return undefined
  return _readYDocEnum(value, fieldLabel, allowed)
}

function _readYDocOptionalNumber(value: unknown, fieldLabel: string, exclusiveMinimum?: number): number | undefined {
  if (value == null) return undefined
  if (typeof value !== 'number' || !Number.isFinite(value)) throw new TypeError(`${fieldLabel} must be finite number, got ${_yDocTypeName(value)}`)
  if (exclusiveMinimum !== undefined && value <= exclusiveMinimum) throw new TypeError(`${fieldLabel} must be greater than ${exclusiveMinimum}`)
  return value
}

function _readYDocNumber(value: unknown, fieldLabel: string, exclusiveMinimum?: number): number {
  const result = _readYDocOptionalNumber(value, fieldLabel, exclusiveMinimum)
  if (result == null) throw new TypeError(`${fieldLabel} must be number, got ${_yDocTypeName(value)}`)
  return result
}

function _readYDocOptionalInteger(value: unknown, fieldLabel: string, exclusiveMinimum?: number): number | undefined {
  if (value == null) return undefined
  if (!Number.isInteger(value)) throw new TypeError(`${fieldLabel} must be integer, got ${_yDocTypeName(value)}`)
  if (exclusiveMinimum !== undefined && (value as number) <= exclusiveMinimum) throw new TypeError(`${fieldLabel} must be greater than ${exclusiveMinimum}`)
  return value as number
}

function _readYDocInteger(value: unknown, fieldLabel: string, exclusiveMinimum?: number): number {
  const result = _readYDocOptionalInteger(value, fieldLabel, exclusiveMinimum)
  if (result == null) throw new TypeError(`${fieldLabel} must be integer, got ${_yDocTypeName(value)}`)
  return result
}

function _readYDocNull(value: unknown, fieldLabel: string): null {
  if (value !== null) throw new TypeError(`${fieldLabel} must be null, got ${_yDocTypeName(value)}`)
  return null
}

type _YDocValidator = (value: unknown, fieldLabel: string) => void

function _lazyYDocValidator(factory: () => _YDocValidator): _YDocValidator {
  let validator: _YDocValidator | undefined
  return (value, fieldLabel) => {
    validator ??= factory()
    validator(value, fieldLabel)
  }
}

function _readYDocUnion<T>(
  value: unknown,
  fieldLabel: string,
  readers: ReadonlyArray<(value: unknown, fieldLabel: string) => T>,
): T {
  const errors: string[] = []
  for (const reader of readers) {
    try { return reader(value, fieldLabel) } catch (error) {
      errors.push(error instanceof Error ? error.message : String(error))
    }
  }
  throw new TypeError(`${fieldLabel} does not match any allowed schema: ${errors.join('; ')}`)
}

function _validateYDocUnion(
  value: unknown,
  fieldLabel: string,
  validators: ReadonlyArray<_YDocValidator>,
): void {
  const errors: string[] = []
  for (const validator of validators) {
    try { validator(value, fieldLabel); return } catch (error) {
      errors.push(error instanceof Error ? error.message : String(error))
    }
  }
  throw new TypeError(`${fieldLabel} does not match any allowed schema: ${errors.join('; ')}`)
}

type _YDocDiscriminatorReader<T> = (value: unknown, fieldLabel: string) => T

function _readYDocDiscriminatedUnion<T>(
  value: unknown,
  fieldLabel: string,
  propertyName: string,
  branches: ReadonlyArray<readonly [unknown, _YDocDiscriminatorReader<T>]>,
  absentReader: _YDocDiscriminatorReader<T> | undefined,
): T {
  if (!(value instanceof Y.Map)) throw new TypeError(fieldLabel + ' must be Y.Map, got ' + _yDocTypeName(value))
  if (!value.has(propertyName)) {
    if (absentReader !== undefined) return absentReader(value, fieldLabel)
    throw new TypeError(fieldLabel + ' is missing discriminator ' + propertyName)
  }
  const discriminatorValue = value.get(propertyName)
  for (const [expected, reader] of branches) {
    if (Object.is(discriminatorValue, expected)) return reader(value, fieldLabel)
  }
  throw new TypeError(fieldLabel + '.' + propertyName + ' has unsupported value ' + String(discriminatorValue))
}

function _validateYDocDiscriminatedUnion(
  value: unknown,
  fieldLabel: string,
  propertyName: string,
  branches: ReadonlyArray<readonly [unknown, _YDocValidator]>,
  absentValidator: _YDocValidator | undefined,
): void {
  if (!(value instanceof Y.Map)) throw new TypeError(fieldLabel + ' must be Y.Map, got ' + _yDocTypeName(value))
  if (!value.has(propertyName)) {
    if (absentValidator !== undefined) {
      absentValidator(value, fieldLabel)
      return
    }
    throw new TypeError(fieldLabel + ' is missing discriminator ' + propertyName)
  }
  const discriminatorValue = value.get(propertyName)
  for (const [expected, validator] of branches) {
    if (Object.is(discriminatorValue, expected)) {
      validator(value, fieldLabel)
      return
    }
  }
  throw new TypeError(fieldLabel + '.' + propertyName + ' has unsupported value ' + String(discriminatorValue))
}

function _readYDocOptionalBoolean(value: unknown, fieldLabel: string): boolean | undefined {
  if (value == null) return undefined
  if (typeof value !== 'boolean') throw new TypeError(`${fieldLabel} must be boolean, got ${_yDocTypeName(value)}`)
  return value
}

type _YDocPrimitiveTypeName = 'string' | 'number' | 'boolean'

function _readYDocPrimitiveUnion<T extends string | number | boolean>(
  value: unknown,
  fieldLabel: string,
  allowedTypes: readonly _YDocPrimitiveTypeName[],
): T {
  if (allowedTypes.includes(typeof value as _YDocPrimitiveTypeName)) return value as T
  throw new TypeError(`${fieldLabel} must be ${allowedTypes.join(' or ')}, got ${_yDocTypeName(value)}`)
}

function _validateYDocPrimitiveUnion(
  value: unknown,
  fieldLabel: string,
  allowedTypes: readonly _YDocPrimitiveTypeName[],
): void {
  if (allowedTypes.includes(typeof value as _YDocPrimitiveTypeName)) return
  throw new TypeError(`${fieldLabel} must be ${allowedTypes.join(' or ')}, got ${_yDocTypeName(value)}`)
}

export function _readYDocJsonValue<T = JsonValue>(value: unknown, fieldLabel: string): T {
  if (value === null || typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return value as T
  if (value instanceof Y.Array) {
    return value.toArray().map((item, index) => _readYDocJsonValue(item, `${fieldLabel}[${index}]`)) as T
  }
  if (value instanceof Y.Map) {
    const result: Record<string, JsonValue> = {}
    value.forEach((item, key) => {
      result[key] = _readYDocJsonValue<JsonValue>(item, `${fieldLabel}.${key}`)
    })
    return result as T
  }
  throw new TypeError(`${fieldLabel} must be JSON-compatible YDoc value, got ${_yDocTypeName(value)}`)
}

function _validateYDocString(value: unknown, fieldLabel: string): void {
  if (typeof value !== 'string') throw new TypeError(`${fieldLabel} must be string, got ${_yDocTypeName(value)}`)
}

function _validateYDocNumber(value: unknown, fieldLabel: string, exclusiveMinimum?: number, minimum?: number): void {
  const number = _readYDocNumber(value, fieldLabel, exclusiveMinimum)
  if (minimum !== undefined && number < minimum) throw new TypeError(`${fieldLabel} must be at least ${minimum}`)
}

function _validateYDocInteger(value: unknown, fieldLabel: string, exclusiveMinimum?: number, minimum?: number): void {
  const number = _readYDocInteger(value, fieldLabel, exclusiveMinimum)
  if (minimum !== undefined && number < minimum) throw new TypeError(`${fieldLabel} must be at least ${minimum}`)
}

function _validateYDocBoolean(value: unknown, fieldLabel: string): void {
  if (typeof value !== 'boolean') throw new TypeError(`${fieldLabel} must be boolean, got ${_yDocTypeName(value)}`)
}

function _validateYDocNull(value: unknown, fieldLabel: string): void {
  _readYDocNull(value, fieldLabel)
}

function _validateYDocArray(
  value: unknown,
  fieldLabel: string,
  itemValidator: _YDocValidator,
  maxItems?: number,
  minItems?: number,
): void {
  if (!(value instanceof Y.Array)) throw new TypeError(`${fieldLabel} must be Y.Array, got ${_yDocTypeName(value)}`)
  value.toArray().forEach((item, index) => itemValidator(item, `${fieldLabel}[${index}]`))
  if (minItems !== undefined && value.length < minItems) {
    throw new TypeError(fieldLabel + ' must contain at least ' + minItems + ' items, got ' + value.length)
  }
  if (maxItems !== undefined && value.length > maxItems) {
    throw new TypeError(fieldLabel + ' must contain at most ' + maxItems + ' items, got ' + value.length)
  }
}

/**
 * Precomputed shape of one Y.Map validator.
 *
 * Every field of this is derived from the JSON schema, so it is constant for
 * the life of the process. It used to be passed as four separate arguments
 * built inline at each call site, which meant re-allocating the argument
 * array, one tuple per property, one closure per property, and then two Sets
 * inside `_validateYDocMap` — on EVERY validation. `BasicAssetMetadata` alone
 * has 19 properties, and `BasicImage`/`BasicVideo`/`BasicAudio` each nest into
 * it, so a single asset read allocated on the order of a hundred objects.
 *
 * A canvas-pan CPU profile attributed 2369ms to this validator family, making
 * it the largest single cost in the trace. Hoisting the spec to a module
 * constant makes the steady-state allocation zero.
 */
interface _YDocMapSpec {
  readonly requiredFields: readonly string[]
  readonly requiredFieldNames: ReadonlySet<string>
  readonly propertyValidators: ReadonlyArray<readonly [string, _YDocValidator]>
  readonly propertyNames: ReadonlySet<string>
  readonly additionalPropertyValidator: _YDocValidator | undefined
  readonly rejectUnknownProperties: boolean
}

/**
 * Build a `_YDocMapSpec` once, at module load.
 *
 * Safe to reference validator FUNCTIONS that appear later in the file (they
 * are hoisted declarations), and safe to reference other specs, because those
 * references only ever appear inside arrow bodies that run at validation time
 * rather than during this initializer.
 */
function _ydocMapSpec(
  requiredFields: readonly string[],
  propertyValidators: ReadonlyArray<readonly [string, _YDocValidator]>,
  additionalPropertyValidator: _YDocValidator | undefined,
  rejectUnknownProperties: boolean,
): _YDocMapSpec {
  return {
    requiredFields,
    requiredFieldNames: new Set(requiredFields),
    propertyValidators,
    propertyNames: new Set(propertyValidators.map(([propertyName]) => propertyName)),
    additionalPropertyValidator,
    rejectUnknownProperties,
  }
}

function _validateYDocMap(value: unknown, fieldLabel: string, spec: _YDocMapSpec): void {
  if (!(value instanceof Y.Map)) throw new TypeError(`${fieldLabel} must be Y.Map, got ${_yDocTypeName(value)}`)
  const { requiredFieldNames, propertyNames, additionalPropertyValidator } = spec
  for (const requiredField of spec.requiredFields) {
    if (!value.has(requiredField) || value.get(requiredField) === undefined) {
      throw new TypeError(`${fieldLabel}.${requiredField} is required`)
    }
  }
  for (const [propertyName, validator] of spec.propertyValidators) {
    if (!value.has(propertyName)) continue
    const propertyValue = value.get(propertyName)
    if (propertyValue === null && !requiredFieldNames.has(propertyName)) continue
    validator(propertyValue, `${fieldLabel}.${propertyName}`)
  }
  if (additionalPropertyValidator != null) {
    value.forEach((item, key) => {
      if (!propertyNames.has(key)) additionalPropertyValidator(item, `${fieldLabel}.${key}`)
    })
  } else if (spec.rejectUnknownProperties) {
    const extraKeys = Array.from(value.keys()).filter((key) => !propertyNames.has(key))
    if (extraKeys.length > 0) {
      throw new TypeError(`${fieldLabel} has unknown keys: ${extraKeys.join(', ')}`)
    }
  }
}

function _readYDocBoolean(value: unknown, fieldLabel: string): boolean {
  const result = _readYDocOptionalBoolean(value, fieldLabel)
  if (result == null) throw new TypeError(`${fieldLabel} must be boolean, got ${_yDocTypeName(value)}`)
  return result
}

// Hoisted Y.Map validator specs — see `_YDocMapSpec`. Built once at module
// load so validation allocates nothing in steady state.
const _YDOC_MAP_SPEC_0: _YDocMapSpec = _ydocMapSpec(["image", "role", "shot_id"], [["exact", (value, fieldLabel) => _validateYDocBoolean(value, fieldLabel)], ["image", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["origin", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["user_relink"] as const)], ["role", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["first", "last"] as const)], ["shot_id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)]], undefined, true)
const _YDOC_MAP_SPEC_1: _YDocMapSpec = _ydocMapSpec(["shot_id", "image"], [["image", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["shot_id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)]], undefined, true)
const _YDOC_MAP_SPEC_2: _YDocMapSpec = _ydocMapSpec(["planFingerprint", "programId", "renderJobId", "sourceRevision", "sourceVariantRef"], [["planFingerprint", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["programId", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["renderJobId", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["sourceRevision", (value, fieldLabel) => _validateYDocInteger(value, fieldLabel)], ["sourceVariantRef", (value, fieldLabel) => _validateYDocString(value, fieldLabel)]], undefined, true)
const _YDOC_MAP_SPEC_3: _YDocMapSpec = _ydocMapSpec(["compositionFingerprint", "priorRevision", "programFingerprint", "programId", "resultingRevision"], [["compositionFingerprint", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["priorRevision", (value, fieldLabel) => _validateYDocInteger(value, fieldLabel)], ["programFingerprint", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["programId", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["resultingRevision", (value, fieldLabel) => _validateYDocInteger(value, fieldLabel)]], undefined, true)
const _YDOC_MAP_SPEC_4: _YDocMapSpec = _ydocMapSpec(["clip_id", "selected_label", "selected_path", "variant_path"], [["clip_id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["selected_label", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["selected_path", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["source_sig", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["variant_path", (value, fieldLabel) => _validateYDocString(value, fieldLabel)]], undefined, true)
const _YDOC_MAP_SPEC_5: _YDocMapSpec = _ydocMapSpec(["assetFingerprint", "assetPath", "durationS", "inS", "kind", "outS", "parentClipIds"], [["assetFingerprint", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["assetPath", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["durationS", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel, 0.0)], ["inS", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel)], ["kind", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["original", "tts", "voice_conversion", "dub", "isolated_voice", "isolated_background"] as const)], ["outS", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel)], ["parentClipIds", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocString(item, itemLabel))]], undefined, true)
const _YDOC_MAP_SPEC_6: _YDocMapSpec = _ydocMapSpec(["baseFingerprint", "composition", "recentMutationReceipts", "revision", "state", "variantAssetId", "variantPath", "variantRef", "workspaceVersion"], [["baseFingerprint", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["composition", (value, fieldLabel) => _validateYDocNull(value, fieldLabel)], ["recentMutationReceipts", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocAudioMutationReceiptDict(item, itemLabel), 32)], ["revision", (value, fieldLabel) => _validateYDocInteger(value, fieldLabel)], ["state", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["clean"] as const)], ["variantAssetId", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["variantPath", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["variantRef", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["workspaceVersion", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, [1] as const)]], undefined, true)
const _YDOC_MAP_SPEC_7: _YDocMapSpec = _ydocMapSpec(["baseFingerprint", "composition", "recentMutationReceipts", "revision", "state", "variantAssetId", "variantPath", "variantRef", "workspaceVersion"], [["baseFingerprint", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["composition", (value, fieldLabel) => _validateYDocUnifiedAudioProjectV2(value, fieldLabel)], ["recentMutationReceipts", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocAudioMutationReceiptDict(item, itemLabel), 32)], ["revision", (value, fieldLabel) => _validateYDocInteger(value, fieldLabel)], ["state", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["draft"] as const)], ["variantAssetId", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["variantPath", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["variantRef", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["workspaceVersion", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, [1] as const)]], undefined, true)
const _YDOC_MAP_SPEC_8: _YDocMapSpec = _ydocMapSpec([], [], (value, fieldLabel) => _validateYDocDiscriminatedUnion(value, fieldLabel, "state", [["clean", (value, fieldLabel) => _validateYDocAudioVariantWorkspaceCleanDict(value, fieldLabel)], ["draft", (value, fieldLabel) => _validateYDocAudioVariantWorkspaceDraftDict(value, fieldLabel)]], undefined), false)
const _YDOC_MAP_SPEC_9: _YDocMapSpec = _ydocMapSpec([], [["actual_height", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel)], ["actual_resolution", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["actual_width", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel)], ["aspect_ratio", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["byom_config_id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["byom_model_name", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["configured_provider_model", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["creation_time", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["duration_seconds", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel)], ["execution_route", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["native", "byom"] as const)], ["mode", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["model", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["provider", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["provider_reported_model", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["reference_adjustments", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocReferenceAdjustmentDict(item, itemLabel))], ["regenerated", (value, fieldLabel) => _validateYDocBoolean(value, fieldLabel)], ["regeneration_time", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["requested_model", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["requested_resolution", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["source", (value, fieldLabel) => _validateYDocString(value, fieldLabel)]], undefined, false)
const _YDOC_MAP_SPEC_10: _YDocMapSpec = _ydocMapSpec([], [["duration_seconds", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel)], ["id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["local_path", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["metadata", (value, fieldLabel) => _validateYDocBasicAssetMetadata(value, fieldLabel)], ["waveform", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocNumber(item, itemLabel))]], undefined, false)
const _YDOC_MAP_SPEC_11: _YDocMapSpec = _ydocMapSpec([], [["id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["local_path", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["metadata", (value, fieldLabel) => _validateYDocBasicAssetMetadata(value, fieldLabel)]], undefined, false)
const _YDOC_MAP_SPEC_12: _YDocMapSpec = _ydocMapSpec([], [["aspect_ratio", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["character_name", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["duration_seconds", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel)], ["eleven_lab_voice_id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["eleven_lab_voice_name", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["language", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["loop", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["mode", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["model", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["provider", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["regenerated", (value, fieldLabel) => _validateYDocBoolean(value, fieldLabel)], ["regeneration_time", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["segment_start_times", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocNumber(item, itemLabel))], ["segments", (value, fieldLabel) => _validateYDocInteger(value, fieldLabel)], ["type", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["voice_id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["voice_name", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["voice_type", (value, fieldLabel) => _validateYDocString(value, fieldLabel)]], undefined, false)
const _YDOC_MAP_SPEC_13: _YDocMapSpec = _ydocMapSpec([], [["metadata", (value, fieldLabel) => _validateYDocGeneratedAssetMetadata(value, fieldLabel)], ["refs", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocBasicAudio(item, itemLabel))], ["result", (value, fieldLabel) => _validateYDocBasicAudio(value, fieldLabel)], ["user_prompt", (value, fieldLabel) => _validateYDocString(value, fieldLabel)]], undefined, false)
const _YDOC_MAP_SPEC_14: _YDocMapSpec = _ydocMapSpec([], [["history", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocGeneratedAudio(item, itemLabel))], ["picked_index", (value, fieldLabel) => _validateYDocInteger(value, fieldLabel)]], undefined, false)
const _YDOC_MAP_SPEC_15: _YDocMapSpec = _ydocMapSpec([], [["metadata", (value, fieldLabel) => _validateYDocGeneratedAssetMetadata(value, fieldLabel)], ["refs", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocBasicImage(item, itemLabel))], ["result", (value, fieldLabel) => _validateYDocBasicImage(value, fieldLabel)], ["user_prompt", (value, fieldLabel) => _validateYDocString(value, fieldLabel)]], undefined, false)
const _YDOC_MAP_SPEC_16: _YDocMapSpec = _ydocMapSpec([], [["history", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocGeneratedImage(item, itemLabel))], ["picked_index", (value, fieldLabel) => _validateYDocInteger(value, fieldLabel)]], undefined, false)
const _YDOC_MAP_SPEC_17: _YDocMapSpec = _ydocMapSpec([], [["custom", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["preset_id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)]], undefined, true)
const _YDOC_MAP_SPEC_18: _YDocMapSpec = _ydocMapSpec(["focal_length_mm", "aperture_f_number"], [["aperture_f_number", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel, 0)], ["focal_length_mm", (value, fieldLabel) => _validateYDocInteger(value, fieldLabel, undefined, 1)], ["preset_id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)]], undefined, true)
const _YDOC_MAP_SPEC_19: _YDocMapSpec = _ydocMapSpec([], [["angle", (value, fieldLabel) => _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_17)], ["focus", (value, fieldLabel) => _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_17)], ["lens", (value, fieldLabel) => _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_18)], ["shot", (value, fieldLabel) => _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_17)]], undefined, true)
const _YDOC_MAP_SPEC_20: _YDocMapSpec = _ydocMapSpec(["id", "generation_id", "scene_ordinal", "scene_fingerprint", "source_unit_refs", "duration_ms", "visual_description", "location", "interior_exterior", "camera_movement", "dialogue_voiceover", "sfx", "source_truth"], [["camera_movement", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["continuity_in", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["continuity_out", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["dialogue_voiceover", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["duration_ms", (value, fieldLabel) => _validateYDocInteger(value, fieldLabel, undefined, 1)], ["framing", (value, fieldLabel) => _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_19)], ["generation_id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["interior_exterior", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["lighting", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["location", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["purpose", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["scene_fingerprint", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["scene_ordinal", (value, fieldLabel) => _validateYDocInteger(value, fieldLabel, undefined, 1)], ["sfx", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["source_truth", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["SUPPLIED", "PROPOSED", "TBC"] as const)], ["source_unit_refs", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocString(item, itemLabel))], ["time_of_day", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["visual_description", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["visual_prompt", (value, fieldLabel) => _validateYDocString(value, fieldLabel)]], undefined, true)
const _YDOC_MAP_SPEC_21: _YDocMapSpec = _ydocMapSpec([], [["audio_edit_provenance", (value, fieldLabel) => _validateYDocAudioEditProvenanceDict(value, fieldLabel)], ["baked_audio", (value, fieldLabel) => _validateYDocDiscriminatedUnion(value, fieldLabel, "contractVersion", [[2, (value, fieldLabel) => _validateYDocUnifiedAudioProjectV2(value, fieldLabel)]], (value, fieldLabel) => _validateYDocUnifiedAudioProjectDict(value, fieldLabel))], ["metadata", (value, fieldLabel) => _validateYDocGeneratedAssetMetadata(value, fieldLabel)], ["refs", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocBasicImage(item, itemLabel))], ["result", (value, fieldLabel) => _validateYDocBasicVideo(value, fieldLabel)], ["user_prompt", (value, fieldLabel) => _validateYDocString(value, fieldLabel)]], undefined, false)
const _YDOC_MAP_SPEC_22: _YDocMapSpec = _ydocMapSpec([], [["history", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocGeneratedVideo(item, itemLabel))], ["picked_index", (value, fieldLabel) => _validateYDocInteger(value, fieldLabel)], ["picked_variant_id", (value, fieldLabel) => _validateYDocUnion(value, fieldLabel, [(value, fieldLabel) => _validateYDocString(value, fieldLabel), (value, fieldLabel) => _validateYDocNull(value, fieldLabel)])]], undefined, false)
const _YDOC_MAP_SPEC_23: _YDocMapSpec = _ydocMapSpec([], [["action", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["converted", "reencoded", "downscaled", "first_frame", "transcoded"] as const)], ["after", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["before", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["index", (value, fieldLabel) => _validateYDocInteger(value, fieldLabel, undefined, 1)], ["kind", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["image", "video", "audio"] as const)]], undefined, true)
const _YDOC_MAP_SPEC_24: _YDocMapSpec = _ydocMapSpec(["id", "transition"], [["boundary_type", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["Continuous", "Soft", "Hard"] as const)], ["id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["motivation", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["transition", (value, fieldLabel) => _validateYDocString(value, fieldLabel)]], undefined, true)
const _YDOC_MAP_SPEC_25: _YDocMapSpec = _ydocMapSpec(["asset_path", "node_id", "port", "speaker"], [["asset_path", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["node_id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["port", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["speaker", (value, fieldLabel) => _validateYDocString(value, fieldLabel)]], undefined, false)
const _YDOC_MAP_SPEC_26: _YDocMapSpec = _ydocMapSpec(["node_id", "reason"], [["node_id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["reason", (value, fieldLabel) => _validateYDocString(value, fieldLabel)]], undefined, false)
const _YDOC_MAP_SPEC_27: _YDocMapSpec = _ydocMapSpec([], [], (value, fieldLabel) => _validateYDocString(value, fieldLabel), false)
const _YDOC_MAP_SPEC_28: _YDocMapSpec = _ydocMapSpec(["asset_paths", "packs", "request_fingerprint", "source_fingerprint", "source_generation_id", "version"], [["asset_paths", (value, fieldLabel) => _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_27)], ["excluded_visual_reference_ids", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocString(item, itemLabel))], ["excluded_voice_reference_ids", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocString(item, itemLabel))], ["packs", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocShotVideoPackDict(item, itemLabel))], ["reference_candidate_fingerprint", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["request_fingerprint", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["source_fingerprint", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["source_generation_id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["source_key_frames", (value, fieldLabel) => _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_27)], ["source_seams", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocShotSeamDict(item, itemLabel))], ["source_shots", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocGeneratedShotRowV2Dict(item, itemLabel))], ["speech_policy", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["screenplay_units_v1"] as const)], ["speech_source_fingerprint", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["version", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, [1, 2, 3] as const)], ["voice_candidate_fingerprint", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["voice_policy", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["screenplay_units", "disabled", "no_screenplay_evidence"] as const)]], undefined, true)
const _YDOC_MAP_SPEC_29: _YDocMapSpec = _ydocMapSpec(["cut_reason", "duration_ms", "generation_id", "id", "mode", "model", "references", "resolution", "shot_ids", "video_node_id"], [["audio_references", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocShotVideoAudioReferenceDict(item, itemLabel))], ["authoring_fingerprint", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["auto_references", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocString(item, itemLabel))], ["cut_reason", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["duration_ms", (value, fieldLabel) => _validateYDocInteger(value, fieldLabel)], ["exact_first", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["exact_last", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["generation_id", (value, fieldLabel) => _validateYDocInteger(value, fieldLabel)], ["id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["master_frames", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocString(item, itemLabel))], ["mixed_video_node_id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["mode", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["model", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["predecessor_id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["prompt_only_master_frames", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocString(item, itemLabel))], ["references", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocString(item, itemLabel))], ["resolution", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["reused_request_fingerprint", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["reused_source_fingerprint", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["shot_ids", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocString(item, itemLabel))], ["skipped_auto_references", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocShotVideoAutoReferenceDecisionDict(item, itemLabel))], ["skipped_voice_references", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocShotVideoVoiceDecisionDict(item, itemLabel))], ["speech_node_ids", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocString(item, itemLabel))], ["video_node_id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["voice_references", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocShotVideoVoiceReferenceDict(item, itemLabel))]], undefined, true)
const _YDOC_MAP_SPEC_30: _YDocMapSpec = _ydocMapSpec(["reason", "speaker"], [["node_id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["reason", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["speaker", (value, fieldLabel) => _validateYDocString(value, fieldLabel)]], undefined, false)
const _YDOC_MAP_SPEC_31: _YDocMapSpec = _ydocMapSpec(["brief_sha256", "node_id", "port", "speaker"], [["brief_sha256", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["node_id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["port", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["speaker", (value, fieldLabel) => _validateYDocString(value, fieldLabel)]], undefined, false)
const _YDOC_MAP_SPEC_32: _YDocMapSpec = _ydocMapSpec([], [["label", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["path", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["source_type", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["voice_id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["voice_name", (value, fieldLabel) => _validateYDocString(value, fieldLabel)]], undefined, false)
const _YDOC_MAP_SPEC_33: _YDocMapSpec = _ydocMapSpec([], [["added", (value, fieldLabel) => _validateYDocBoolean(value, fieldLabel)], ["end_s", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel)], ["fadeInS", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel)], ["fadeOutS", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel)], ["id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["language", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["muted", (value, fieldLabel) => _validateYDocBoolean(value, fieldLabel)], ["native_fill", (value, fieldLabel) => _validateYDocBoolean(value, fieldLabel)], ["original_path", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["path", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["selectedVersionLabel", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["sourceInS", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel, undefined, 0)], ["sourceSegmentIdx", (value, fieldLabel) => _validateYDocInteger(value, fieldLabel)], ["source_sig", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["speaker", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["speed", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel)], ["start_s", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel)], ["versions", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocTtsVersionDict(item, itemLabel))], ["volume", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel)]], undefined, false)
const _YDOC_MAP_SPEC_34: _YDocMapSpec = _ydocMapSpec(["activeTakeId", "contentRole", "endS", "fadeInS", "fadeOutS", "id", "language", "muted", "speaker", "startS", "takes", "transcript", "userSpeed", "volume"], [["activeTakeId", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["contentRole", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["speech", "background", "music", "sfx", "gap_fill", "overlap_unresolved"] as const)], ["endS", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel)], ["fadeInS", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel)], ["fadeOutS", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel)], ["id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["isolationGroupId", (value, fieldLabel) => _validateYDocUnion(value, fieldLabel, [(value, fieldLabel) => _validateYDocString(value, fieldLabel), (value, fieldLabel) => _validateYDocNull(value, fieldLabel)])], ["language", (value, fieldLabel) => _validateYDocUnion(value, fieldLabel, [(value, fieldLabel) => _validateYDocString(value, fieldLabel), (value, fieldLabel) => _validateYDocNull(value, fieldLabel)])], ["muted", (value, fieldLabel) => _validateYDocBoolean(value, fieldLabel)], ["speaker", (value, fieldLabel) => _validateYDocUnion(value, fieldLabel, [(value, fieldLabel) => _validateYDocString(value, fieldLabel), (value, fieldLabel) => _validateYDocNull(value, fieldLabel)])], ["startS", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel)], ["takes", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocUnifiedAudioTakeV2Dict(item, itemLabel))], ["transcript", (value, fieldLabel) => _validateYDocUnion(value, fieldLabel, [(value, fieldLabel) => _validateYDocString(value, fieldLabel), (value, fieldLabel) => _validateYDocNull(value, fieldLabel)])], ["userSpeed", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel, 0.0)], ["volume", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel)]], undefined, true)
const _YDOC_MAP_SPEC_35: _YDocMapSpec = _ydocMapSpec([], [["clips", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocUnifiedAudioClipDict(item, itemLabel))], ["duckDepthDb", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel)], ["id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["laneDuckMute", (value, fieldLabel) => _validateYDocBoolean(value, fieldLabel)], ["laneMute", (value, fieldLabel) => _validateYDocBoolean(value, fieldLabel)], ["laneVolume", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel)], ["source", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["native_split", "owned", "tts", "sts"] as const)], ["type", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["dialogue", "narration", "music", "sfx"] as const)]], undefined, false)
const _YDOC_MAP_SPEC_36: _YDocMapSpec = _ydocMapSpec(["clips", "duckDepthDb", "id", "laneDuckMute", "laneMute", "laneVolume", "type"], [["clips", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocUnifiedAudioClipV2Dict(item, itemLabel))], ["duckDepthDb", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel)], ["id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["laneDuckMute", (value, fieldLabel) => _validateYDocBoolean(value, fieldLabel)], ["laneMute", (value, fieldLabel) => _validateYDocBoolean(value, fieldLabel)], ["laneVolume", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel)], ["type", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["dialogue", "narration", "music", "sfx"] as const)]], undefined, true)
const _YDOC_MAP_SPEC_37: _YDocMapSpec = _ydocMapSpec([], [["deletedClipIds", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocString(item, itemLabel))], ["lanes", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocUnifiedAudioLaneDict(item, itemLabel))], ["mastering", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["lufs", "peak"] as const)], ["sourceOriginalIndex", (value, fieldLabel) => _validateYDocInteger(value, fieldLabel)], ["sourceOriginalPath", (value, fieldLabel) => _validateYDocString(value, fieldLabel)]], undefined, false)
const _YDOC_MAP_SPEC_38: _YDocMapSpec = _ydocMapSpec(["contractVersion", "lanes", "mastering"], [["contractVersion", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, [2] as const)], ["lanes", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocUnifiedAudioLaneV2Dict(item, itemLabel))], ["mastering", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["lufs", "peak"] as const)]], undefined, true)
const _YDOC_MAP_SPEC_39: _YDocMapSpec = _ydocMapSpec(["baseFitRate", "id", "language", "source", "voiceId"], [["baseFitRate", (value, fieldLabel) => _validateYDocNumber(value, fieldLabel, 0.0)], ["id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["language", (value, fieldLabel) => _validateYDocUnion(value, fieldLabel, [(value, fieldLabel) => _validateYDocString(value, fieldLabel), (value, fieldLabel) => _validateYDocNull(value, fieldLabel)])], ["source", (value, fieldLabel) => _validateYDocAudioTakeSourceV2Dict(value, fieldLabel)], ["voiceId", (value, fieldLabel) => _validateYDocUnion(value, fieldLabel, [(value, fieldLabel) => _validateYDocString(value, fieldLabel), (value, fieldLabel) => _validateYDocNull(value, fieldLabel)])]], undefined, true)
const _YDOC_MAP_SPEC_40: _YDocMapSpec = _ydocMapSpec([], [["history", (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocGeneratedVideo(item, itemLabel))], ["picked_index", (value, fieldLabel) => _validateYDocInteger(value, fieldLabel)]], undefined, false)
const _YDOC_MAP_SPEC_41: _YDocMapSpec = _ydocMapSpec(["attempt_id", "source", "state", "version"], [["attempt_id", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["batch_id", (value, fieldLabel) => _validateYDocUnion(value, fieldLabel, [(value, fieldLabel) => _validateYDocString(value, fieldLabel), (value, fieldLabel) => _validateYDocNull(value, fieldLabel)])], ["batch_revision", (value, fieldLabel) => _validateYDocUnion(value, fieldLabel, [(value, fieldLabel) => _validateYDocInteger(value, fieldLabel), (value, fieldLabel) => _validateYDocNull(value, fieldLabel)])], ["batch_state", (value, fieldLabel) => _validateYDocUnion(value, fieldLabel, [(value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["preflighting", "awaiting_confirmation", "applying", "completed", "partial_failure", "failed", "cancelled"] as const), (value, fieldLabel) => _validateYDocNull(value, fieldLabel)])], ["error", (value, fieldLabel) => _validateYDocUnion(value, fieldLabel, [(value, fieldLabel) => _validateYDocString(value, fieldLabel), (value, fieldLabel) => _validateYDocNull(value, fieldLabel)])], ["error_code", (value, fieldLabel) => _validateYDocUnion(value, fieldLabel, [(value, fieldLabel) => _validateYDocString(value, fieldLabel), (value, fieldLabel) => _validateYDocNull(value, fieldLabel)])], ["message", (value, fieldLabel) => _validateYDocUnion(value, fieldLabel, [(value, fieldLabel) => _validateYDocString(value, fieldLabel), (value, fieldLabel) => _validateYDocNull(value, fieldLabel)])], ["resulting_variant_index", (value, fieldLabel) => _validateYDocUnion(value, fieldLabel, [(value, fieldLabel) => _validateYDocInteger(value, fieldLabel), (value, fieldLabel) => _validateYDocNull(value, fieldLabel)])], ["resulting_variant_path", (value, fieldLabel) => _validateYDocUnion(value, fieldLabel, [(value, fieldLabel) => _validateYDocString(value, fieldLabel), (value, fieldLabel) => _validateYDocNull(value, fieldLabel)])], ["retryable", (value, fieldLabel) => _validateYDocBoolean(value, fieldLabel)], ["source", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["initial_generate", "manual_apply", "director_apply", "unknown"] as const)], ["source_variant_index", (value, fieldLabel) => _validateYDocUnion(value, fieldLabel, [(value, fieldLabel) => _validateYDocInteger(value, fieldLabel), (value, fieldLabel) => _validateYDocNull(value, fieldLabel)])], ["source_variant_path", (value, fieldLabel) => _validateYDocUnion(value, fieldLabel, [(value, fieldLabel) => _validateYDocString(value, fieldLabel), (value, fieldLabel) => _validateYDocNull(value, fieldLabel)])], ["source_variant_ref", (value, fieldLabel) => _validateYDocUnion(value, fieldLabel, [(value, fieldLabel) => _validateYDocString(value, fieldLabel), (value, fieldLabel) => _validateYDocNull(value, fieldLabel)])], ["state", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["requested", "preflighting", "applying", "completed", "failed", "cancelled", "skipped"] as const)], ["target_phase", (value, fieldLabel) => _validateYDocUnion(value, fieldLabel, [(value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["preflight", "execution"] as const), (value, fieldLabel) => _validateYDocNull(value, fieldLabel)])], ["target_state", (value, fieldLabel) => _validateYDocUnion(value, fieldLabel, [(value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["pending", "analyzing", "retry_wait", "ready", "queued", "running", "applied", "failed", "skipped"] as const), (value, fieldLabel) => _validateYDocNull(value, fieldLabel)])], ["target_step", (value, fieldLabel) => _validateYDocUnion(value, fieldLabel, [(value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["queued", "transcribing", "matching_characters", "isolating_speech", "ready", "applying", "completed", "failed"] as const), (value, fieldLabel) => _validateYDocNull(value, fieldLabel)])], ["updated_at", (value, fieldLabel) => _validateYDocString(value, fieldLabel)], ["version", (value, fieldLabel) => _readYDocEnum(value, fieldLabel, [1] as const)]], undefined, true)
const _YDOC_MAP_SPEC_42: _YDocMapSpec = _ydocMapSpec([], [], (value, fieldLabel) => _validateYDocUnion(value, fieldLabel, [(value, fieldLabel) => _validateYDocString(value, fieldLabel), (value, fieldLabel) => _validateYDocInteger(value, fieldLabel), (value, fieldLabel) => _validateYDocNumber(value, fieldLabel), (value, fieldLabel) => _validateYDocBoolean(value, fieldLabel), (value, fieldLabel) => _validateYDocNull(value, fieldLabel)]), false)

export function _validateYDocAudioEditProvenanceDict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_2)
}

export function _validateYDocAudioMutationReceiptDict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_3)
}

export function _validateYDocAudioTakeSelectionDict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_4)
}

export function _validateYDocAudioTakeSourceV2Dict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_5)
}

export function _validateYDocAudioVariantWorkspaceCleanDict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_6)
}

export function _validateYDocAudioVariantWorkspaceDraftDict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_7)
}

export function _validateYDocAudioVariantWorkspaceMapDict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_8)
}

export function _validateYDocBasicAssetMetadata(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_9)
}

export function _validateYDocBasicAudio(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_10)
}

export function _validateYDocBasicImage(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_11)
}

export function _validateYDocBasicVideo(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_11)
}

export function _validateYDocGeneratedAssetMetadata(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_12)
}

export function _validateYDocGeneratedAudio(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_13)
}

export function _validateYDocGeneratedAudioWithHistory(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_14)
}

export function _validateYDocGeneratedImage(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_15)
}

export function _validateYDocGeneratedImageWithHistory(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_16)
}

export function _validateYDocGeneratedShotRowV2Dict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_20)
}

export function _validateYDocGeneratedVideo(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_21)
}

export function _validateYDocGeneratedVideoWithHistory(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_22)
}

export function _validateYDocReferenceAdjustmentDict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_23)
}

export function _validateYDocShotListChoiceV2Dict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_17)
}

export function _validateYDocShotListFramingV2Dict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_19)
}

export function _validateYDocShotListLensV2Dict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_18)
}

export function _validateYDocShotSeamDict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_24)
}

export function _validateYDocShotVideoAudioReferenceDict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_25)
}

export function _validateYDocShotVideoAutoReferenceDecisionDict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_26)
}

export function _validateYDocShotVideoGenerationPlanDict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_28)
}

export function _validateYDocShotVideoPackDict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_29)
}

export function _validateYDocShotVideoVoiceDecisionDict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_30)
}

export function _validateYDocShotVideoVoiceReferenceDict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_31)
}

export function _validateYDocTtsVersionDict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_32)
}

export function _validateYDocUnifiedAudioClipDict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_33)
}

export function _validateYDocUnifiedAudioClipV2Dict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_34)
}

export function _validateYDocUnifiedAudioLaneDict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_35)
}

export function _validateYDocUnifiedAudioLaneV2Dict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_36)
}

export function _validateYDocUnifiedAudioProjectDict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_37)
}

export function _validateYDocUnifiedAudioProjectV2(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_38)
}

export function _validateYDocUnifiedAudioTakeV2Dict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_39)
}

export function _validateYDocVideoAssetRefDict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_40)
}

export function _validateYDocVideoFullRemixStatusV1Dict(value: unknown, fieldLabel: string): void {
  _validateYDocMap(value, fieldLabel, _YDOC_MAP_SPEC_41)
}

export function validateUnifiedAudioProjectDictJson(
  value: unknown,
  fieldLabel = 'UnifiedAudioProjectDict',
): UnifiedAudioProjectDict {
  const candidate = _attachYDocValidationCandidate(value as YDocWriteValue)
  _validateYDocUnifiedAudioProjectDict(candidate, fieldLabel)
  return _readYDocJsonValue<UnifiedAudioProjectDict>(candidate, fieldLabel)
}

export function validateUnifiedAudioProjectV2Json(
  value: unknown,
  fieldLabel = 'UnifiedAudioProjectV2',
): UnifiedAudioProjectV2 {
  const candidate = _attachYDocValidationCandidate(value as YDocWriteValue)
  _validateYDocUnifiedAudioProjectV2(candidate, fieldLabel)
  return _readYDocJsonValue<UnifiedAudioProjectV2>(candidate, fieldLabel)
}

export function validateUnifiedAudioVerdictJson(
  value: unknown,
  fieldLabel = 'UnifiedAudioVerdict',
): UnifiedAudioVerdict {
  return _readYDocEnum(value, fieldLabel, ["manifest", "pristine_native", "fallback"] as const)
}

/** Typed Y.Map wrapper for AnnotationPointDict. */
export class AnnotationPointDictYMap extends YMapWrapper {
  get x(): number | undefined { return _readYDocOptionalNumber(this._raw.get('x'), "AnnotationPointDict.x") }
  get y(): number | undefined { return _readYDocOptionalNumber(this._raw.get('y'), "AnnotationPointDict.y") }
}

/** Typed Y.Map wrapper for AppearanceDict. */
export class AppearanceDictYMap extends YMapWrapper {
  get character_id(): string | undefined { return _readYDocOptionalString(this._raw.get('character_id'), "AppearanceDict.character_id") }
  get expression(): string | undefined { return _readYDocOptionalString(this._raw.get('expression'), "AppearanceDict.expression") }
  get pose(): string | undefined { return _readYDocOptionalString(this._raw.get('pose'), "AppearanceDict.pose") }
  get position(): string | undefined { return _readYDocOptionalString(this._raw.get('position'), "AppearanceDict.position") }
}

/** Typed Y.Map wrapper for AudioAssetMetadataDict. */
export class AudioAssetMetadataDictYMap extends YMapWrapper {
  get creation_time(): string | undefined { return _readYDocOptionalString(this._raw.get('creation_time'), "AudioAssetMetadataDict.creation_time") }
  get model(): string | undefined { return _readYDocOptionalString(this._raw.get('model'), "AudioAssetMetadataDict.model") }
  get source(): string | undefined { return _readYDocOptionalString(this._raw.get('source'), "AudioAssetMetadataDict.source") }
}

/** Typed Y.Map wrapper for AudioAssetRefDict. */
export class AudioAssetRefDictYMap extends YMapWrapper {
  get history(): GeneratedAudioYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('history'), "AudioAssetRefDict.history", (item, itemLabel) => _readYDocMapWrapper(item, GeneratedAudioYMap, itemLabel)) }
  get picked_index(): number | undefined { return _readYDocOptionalInteger(this._raw.get('picked_index'), "AudioAssetRefDict.picked_index") }
}

/** Typed Y.Map wrapper for AudioEditOperationDict. */
export class AudioEditOperationDictYMap extends YMapWrapper {
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "AudioEditOperationDict.id") }
  get params(): YMapRecord<number | string, number | string> | undefined { return _readYDocOptionalMapRecord<number | string, number | string>(this._raw.get('params'), "AudioEditOperationDict.params", (item, itemLabel) => _readYDocPrimitiveUnion<number | string>(item, itemLabel, ['number', 'string']), _lazyYDocValidator(() => (item, itemLabel) => _validateYDocPrimitiveUnion(item, itemLabel, ['number', 'string']))) }
  get type(): string | undefined { return _readYDocOptionalString(this._raw.get('type'), "AudioEditOperationDict.type") }
}

/** Typed Y.Map wrapper for AudioEditProvenanceDict. */
export class AudioEditProvenanceDictYMap extends YMapWrapper {
  get planFingerprint(): string | undefined { return _readYDocOptionalString(this._raw.get('planFingerprint'), "AudioEditProvenanceDict.planFingerprint") }
  get programId(): string | undefined { return _readYDocOptionalString(this._raw.get('programId'), "AudioEditProvenanceDict.programId") }
  get renderJobId(): string | undefined { return _readYDocOptionalString(this._raw.get('renderJobId'), "AudioEditProvenanceDict.renderJobId") }
  get sourceRevision(): number | undefined { return _readYDocOptionalInteger(this._raw.get('sourceRevision'), "AudioEditProvenanceDict.sourceRevision") }
  get sourceVariantRef(): string | undefined { return _readYDocOptionalString(this._raw.get('sourceVariantRef'), "AudioEditProvenanceDict.sourceVariantRef") }
}

/** Typed Y.Map wrapper for AudioMutationReceiptDict. */
export class AudioMutationReceiptDictYMap extends YMapWrapper {
  get compositionFingerprint(): string | undefined { return _readYDocOptionalString(this._raw.get('compositionFingerprint'), "AudioMutationReceiptDict.compositionFingerprint") }
  get priorRevision(): number | undefined { return _readYDocOptionalInteger(this._raw.get('priorRevision'), "AudioMutationReceiptDict.priorRevision") }
  get programFingerprint(): string | undefined { return _readYDocOptionalString(this._raw.get('programFingerprint'), "AudioMutationReceiptDict.programFingerprint") }
  get programId(): string | undefined { return _readYDocOptionalString(this._raw.get('programId'), "AudioMutationReceiptDict.programId") }
  get resultingRevision(): number | undefined { return _readYDocOptionalInteger(this._raw.get('resultingRevision'), "AudioMutationReceiptDict.resultingRevision") }
}

/** Typed Y.Map wrapper for AudioRemixConfigDict. */
export class AudioRemixConfigDictYMap extends YMapWrapper {
  get duckDepthDb(): number | undefined { return _readYDocOptionalNumber(this._raw.get('duckDepthDb'), "AudioRemixConfigDict.duckDepthDb") }
  get groups(): AudioRemixGroupDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('groups'), "AudioRemixConfigDict.groups", (item, itemLabel) => _readYDocMapWrapper(item, AudioRemixGroupDictYMap, itemLabel)) }
  get sourceOriginalIndex(): number | undefined { return _readYDocOptionalInteger(this._raw.get('sourceOriginalIndex'), "AudioRemixConfigDict.sourceOriginalIndex") }
  get sourceOriginalPath(): string | undefined { return _readYDocOptionalString(this._raw.get('sourceOriginalPath'), "AudioRemixConfigDict.sourceOriginalPath") }
}

/** Typed Y.Map wrapper for AudioRemixGroupDict. */
export class AudioRemixGroupDictYMap extends YMapWrapper {
  get character(): string | undefined { return _readYDocOptionalString(this._raw.get('character'), "AudioRemixGroupDict.character") }
  get emotion(): string | undefined { return _readYDocOptionalString(this._raw.get('emotion'), "AudioRemixGroupDict.emotion") }
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "AudioRemixGroupDict.id") }
  get status(): string | undefined { return _readYDocOptionalString(this._raw.get('status'), "AudioRemixGroupDict.status") }
  get text(): string | undefined { return _readYDocOptionalString(this._raw.get('text'), "AudioRemixGroupDict.text") }
  get tracks(): AudioRemixTrackDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('tracks'), "AudioRemixGroupDict.tracks", (item, itemLabel) => _readYDocMapWrapper(item, AudioRemixTrackDictYMap, itemLabel)) }
  get type(): string | undefined { return _readYDocOptionalString(this._raw.get('type'), "AudioRemixGroupDict.type") }
  get voice_role_id(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_role_id'), "AudioRemixGroupDict.voice_role_id") }
}

/** Typed Y.Map wrapper for AudioRemixTrackDict. */
export class AudioRemixTrackDictYMap extends YMapWrapper {
  get endS(): number | undefined { return _readYDocOptionalNumber(this._raw.get('endS'), "AudioRemixTrackDict.endS") }
  get fadeInS(): number | undefined { return _readYDocOptionalNumber(this._raw.get('fadeInS'), "AudioRemixTrackDict.fadeInS") }
  get fadeOutS(): number | undefined { return _readYDocOptionalNumber(this._raw.get('fadeOutS'), "AudioRemixTrackDict.fadeOutS") }
  get highlighted(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('highlighted'), "AudioRemixTrackDict.highlighted") }
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "AudioRemixTrackDict.id") }
  get label(): string | undefined { return _readYDocOptionalString(this._raw.get('label'), "AudioRemixTrackDict.label") }
  get sourceDurationS(): number | undefined { return _readYDocOptionalNumber(this._raw.get('sourceDurationS'), "AudioRemixTrackDict.sourceDurationS") }
  get sourceSegmentIdx(): number | undefined { return _readYDocOptionalInteger(this._raw.get('sourceSegmentIdx'), "AudioRemixTrackDict.sourceSegmentIdx") }
  get sourceType(): string | undefined { return _readYDocOptionalString(this._raw.get('sourceType'), "AudioRemixTrackDict.sourceType") }
  get sourceVersionLabel(): string | undefined { return _readYDocOptionalString(this._raw.get('sourceVersionLabel'), "AudioRemixTrackDict.sourceVersionLabel") }
  get startS(): number | undefined { return _readYDocOptionalNumber(this._raw.get('startS'), "AudioRemixTrackDict.startS") }
}

/** Typed Y.Map wrapper for AudioTakeSelectionDict. */
export class AudioTakeSelectionDictYMap extends YMapWrapper {
  get clip_id(): string | undefined { return _readYDocOptionalString(this._raw.get('clip_id'), "AudioTakeSelectionDict.clip_id") }
  get selected_label(): string | undefined { return _readYDocOptionalString(this._raw.get('selected_label'), "AudioTakeSelectionDict.selected_label") }
  get selected_path(): string | undefined { return _readYDocOptionalString(this._raw.get('selected_path'), "AudioTakeSelectionDict.selected_path") }
  get source_sig(): string | undefined { return _readYDocOptionalString(this._raw.get('source_sig'), "AudioTakeSelectionDict.source_sig") }
  get variant_path(): string | undefined { return _readYDocOptionalString(this._raw.get('variant_path'), "AudioTakeSelectionDict.variant_path") }
}

/** Typed Y.Map wrapper for AudioTakeSelectionMapDict. */
export class AudioTakeSelectionMapDictYMap extends YMapWrapper {
  get(key: string): AudioTakeSelectionDictYMap | undefined {
    const value = this._raw.get(key)
    if (value === undefined) return undefined
    const fieldLabel = `${this.constructor.name}.${key}`
    _validateYDocAudioTakeSelectionDict(value, fieldLabel)
    return _readYDocMapWrapper(value, AudioTakeSelectionDictYMap, fieldLabel)
  }
  set(key: string, value: AudioTakeSelectionDict): void {
    const fieldLabel = `${this.constructor.name}.${key}`
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocAudioTakeSelectionDict(validationValue, fieldLabel)
    this._raw.set(key, _toYDocValue(value))
  }
  delete(key: string): void { this._raw.delete(key) }
}

/** Typed Y.Map wrapper for AudioTakeSourceV2Dict. */
export class AudioTakeSourceV2DictYMap extends YMapWrapper {
  get assetFingerprint(): string | undefined { return _readYDocOptionalString(this._raw.get('assetFingerprint'), "AudioTakeSourceV2Dict.assetFingerprint") }
  get assetPath(): string | undefined { return _readYDocOptionalString(this._raw.get('assetPath'), "AudioTakeSourceV2Dict.assetPath") }
  get durationS(): number | undefined { return _readYDocOptionalNumber(this._raw.get('durationS'), "AudioTakeSourceV2Dict.durationS", 0.0) }
  get inS(): number | undefined { return _readYDocOptionalNumber(this._raw.get('inS'), "AudioTakeSourceV2Dict.inS") }
  get kind(): "original" | "tts" | "voice_conversion" | "dub" | "isolated_voice" | "isolated_background" | undefined { return _readYDocOptionalEnum(this._raw.get('kind'), "AudioTakeSourceV2Dict.kind", ["original", "tts", "voice_conversion", "dub", "isolated_voice", "isolated_background"] as const) }
  get outS(): number | undefined { return _readYDocOptionalNumber(this._raw.get('outS'), "AudioTakeSourceV2Dict.outS") }
  get parentClipIds(): string[] | undefined { return _readYDocOptionalArray(this._raw.get('parentClipIds'), "AudioTakeSourceV2Dict.parentClipIds", (item, itemLabel) => _readYDocString(item, itemLabel)) }
}

/** Typed Y.Map wrapper for AudioVariantWorkspaceCleanDict. */
export class AudioVariantWorkspaceCleanDictYMap extends YMapWrapper {
  get baseFingerprint(): string | undefined { return _readYDocOptionalString(this._raw.get('baseFingerprint'), "AudioVariantWorkspaceCleanDict.baseFingerprint") }
  get composition(): null | undefined { return (this._raw.get('composition') === undefined ? undefined : _readYDocNull(this._raw.get('composition'), "AudioVariantWorkspaceCleanDict.composition")) }
  get recentMutationReceipts(): AudioMutationReceiptDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('recentMutationReceipts'), "AudioVariantWorkspaceCleanDict.recentMutationReceipts", (item, itemLabel) => (() => { _validateYDocAudioMutationReceiptDict(item, itemLabel); return _readYDocMapWrapper(item, AudioMutationReceiptDictYMap, itemLabel) })()) }
  get revision(): number | undefined { return _readYDocOptionalInteger(this._raw.get('revision'), "AudioVariantWorkspaceCleanDict.revision") }
  get state(): "clean" | undefined { return _readYDocOptionalEnum(this._raw.get('state'), "AudioVariantWorkspaceCleanDict.state", ["clean"] as const) }
  get variantAssetId(): string | undefined { return _readYDocOptionalString(this._raw.get('variantAssetId'), "AudioVariantWorkspaceCleanDict.variantAssetId") }
  get variantPath(): string | undefined { return _readYDocOptionalString(this._raw.get('variantPath'), "AudioVariantWorkspaceCleanDict.variantPath") }
  get variantRef(): string | undefined { return _readYDocOptionalString(this._raw.get('variantRef'), "AudioVariantWorkspaceCleanDict.variantRef") }
  get workspaceVersion(): 1 | undefined { return _readYDocOptionalEnum(this._raw.get('workspaceVersion'), "AudioVariantWorkspaceCleanDict.workspaceVersion", [1] as const) }
}

/** Typed Y.Map wrapper for AudioVariantWorkspaceDraftDict. */
export class AudioVariantWorkspaceDraftDictYMap extends YMapWrapper {
  get baseFingerprint(): string | undefined { return _readYDocOptionalString(this._raw.get('baseFingerprint'), "AudioVariantWorkspaceDraftDict.baseFingerprint") }
  get composition(): UnifiedAudioProjectV2YMap | undefined { return (this._raw.get('composition') == null ? undefined : (() => { _validateYDocUnifiedAudioProjectV2(this._raw.get('composition'), "AudioVariantWorkspaceDraftDict.composition"); return _readYDocMapWrapper(this._raw.get('composition'), UnifiedAudioProjectV2YMap, "AudioVariantWorkspaceDraftDict.composition") })()) }
  get recentMutationReceipts(): AudioMutationReceiptDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('recentMutationReceipts'), "AudioVariantWorkspaceDraftDict.recentMutationReceipts", (item, itemLabel) => (() => { _validateYDocAudioMutationReceiptDict(item, itemLabel); return _readYDocMapWrapper(item, AudioMutationReceiptDictYMap, itemLabel) })()) }
  get revision(): number | undefined { return _readYDocOptionalInteger(this._raw.get('revision'), "AudioVariantWorkspaceDraftDict.revision") }
  get state(): "draft" | undefined { return _readYDocOptionalEnum(this._raw.get('state'), "AudioVariantWorkspaceDraftDict.state", ["draft"] as const) }
  get variantAssetId(): string | undefined { return _readYDocOptionalString(this._raw.get('variantAssetId'), "AudioVariantWorkspaceDraftDict.variantAssetId") }
  get variantPath(): string | undefined { return _readYDocOptionalString(this._raw.get('variantPath'), "AudioVariantWorkspaceDraftDict.variantPath") }
  get variantRef(): string | undefined { return _readYDocOptionalString(this._raw.get('variantRef'), "AudioVariantWorkspaceDraftDict.variantRef") }
  get workspaceVersion(): 1 | undefined { return _readYDocOptionalEnum(this._raw.get('workspaceVersion'), "AudioVariantWorkspaceDraftDict.workspaceVersion", [1] as const) }
}

/** Typed Y.Map wrapper for AudioVariantWorkspaceMapDict. */
export class AudioVariantWorkspaceMapDictYMap extends YMapWrapper {
  get(key: string): AudioVariantWorkspaceCleanDictYMap | AudioVariantWorkspaceDraftDictYMap | undefined {
    const value = this._raw.get(key)
    if (value === undefined) return undefined
    const fieldLabel = `${this.constructor.name}.${key}`
    _validateYDocDiscriminatedUnion(value, fieldLabel, "state", [["clean", (value, fieldLabel) => _validateYDocAudioVariantWorkspaceCleanDict(value, fieldLabel)], ["draft", (value, fieldLabel) => _validateYDocAudioVariantWorkspaceDraftDict(value, fieldLabel)]], undefined)
    return _readYDocDiscriminatedUnion<AudioVariantWorkspaceCleanDictYMap | AudioVariantWorkspaceDraftDictYMap>(value, fieldLabel, "state", [["clean", (value, fieldLabel) => { return (() => { _validateYDocAudioVariantWorkspaceCleanDict(value, fieldLabel); return _readYDocMapWrapper(value, AudioVariantWorkspaceCleanDictYMap, fieldLabel) })() }], ["draft", (value, fieldLabel) => { return (() => { _validateYDocAudioVariantWorkspaceDraftDict(value, fieldLabel); return _readYDocMapWrapper(value, AudioVariantWorkspaceDraftDictYMap, fieldLabel) })() }]], undefined)
  }
  set(key: string, value: AudioVariantWorkspaceDict): void {
    const fieldLabel = `${this.constructor.name}.${key}`
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocDiscriminatedUnion(validationValue, fieldLabel, "state", [["clean", (value, fieldLabel) => _validateYDocAudioVariantWorkspaceCleanDict(value, fieldLabel)], ["draft", (value, fieldLabel) => _validateYDocAudioVariantWorkspaceDraftDict(value, fieldLabel)]], undefined)
    this._raw.set(key, _toYDocValue(value))
  }
  delete(key: string): void { this._raw.delete(key) }
}

/** Typed Y.Map wrapper for BasicAssetMetadata. */
export class BasicAssetMetadataYMap extends YMapWrapper {
  get actual_height(): number | undefined { return _readYDocOptionalNumber(this._raw.get('actual_height'), "BasicAssetMetadata.actual_height") }
  get actual_resolution(): string | undefined { return _readYDocOptionalString(this._raw.get('actual_resolution'), "BasicAssetMetadata.actual_resolution") }
  get actual_width(): number | undefined { return _readYDocOptionalNumber(this._raw.get('actual_width'), "BasicAssetMetadata.actual_width") }
  get aspect_ratio(): string | undefined { return _readYDocOptionalString(this._raw.get('aspect_ratio'), "BasicAssetMetadata.aspect_ratio") }
  get byom_config_id(): string | undefined { return _readYDocOptionalString(this._raw.get('byom_config_id'), "BasicAssetMetadata.byom_config_id") }
  get byom_model_name(): string | undefined { return _readYDocOptionalString(this._raw.get('byom_model_name'), "BasicAssetMetadata.byom_model_name") }
  get configured_provider_model(): string | undefined { return _readYDocOptionalString(this._raw.get('configured_provider_model'), "BasicAssetMetadata.configured_provider_model") }
  get creation_time(): string | undefined { return _readYDocOptionalString(this._raw.get('creation_time'), "BasicAssetMetadata.creation_time") }
  get duration_seconds(): number | undefined { return _readYDocOptionalNumber(this._raw.get('duration_seconds'), "BasicAssetMetadata.duration_seconds") }
  get execution_route(): "native" | "byom" | undefined { return _readYDocOptionalEnum(this._raw.get('execution_route'), "BasicAssetMetadata.execution_route", ["native", "byom"] as const) }
  get mode(): string | undefined { return _readYDocOptionalString(this._raw.get('mode'), "BasicAssetMetadata.mode") }
  get model(): string | undefined { return _readYDocOptionalString(this._raw.get('model'), "BasicAssetMetadata.model") }
  get provider(): string | undefined { return _readYDocOptionalString(this._raw.get('provider'), "BasicAssetMetadata.provider") }
  get provider_reported_model(): string | undefined { return _readYDocOptionalString(this._raw.get('provider_reported_model'), "BasicAssetMetadata.provider_reported_model") }
  get reference_adjustments(): ReferenceAdjustmentDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('reference_adjustments'), "BasicAssetMetadata.reference_adjustments", (item, itemLabel) => _readYDocMapWrapper(item, ReferenceAdjustmentDictYMap, itemLabel)) }
  get regenerated(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('regenerated'), "BasicAssetMetadata.regenerated") }
  get regeneration_time(): string | undefined { return _readYDocOptionalString(this._raw.get('regeneration_time'), "BasicAssetMetadata.regeneration_time") }
  get requested_model(): string | undefined { return _readYDocOptionalString(this._raw.get('requested_model'), "BasicAssetMetadata.requested_model") }
  get requested_resolution(): string | undefined { return _readYDocOptionalString(this._raw.get('requested_resolution'), "BasicAssetMetadata.requested_resolution") }
  get source(): string | undefined { return _readYDocOptionalString(this._raw.get('source'), "BasicAssetMetadata.source") }
}

/** Typed Y.Map wrapper for BasicAudio. */
export class BasicAudioYMap extends YMapWrapper {
  get duration_seconds(): number | undefined { return _readYDocOptionalNumber(this._raw.get('duration_seconds'), "BasicAudio.duration_seconds") }
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "BasicAudio.id") }
  get local_path(): string | undefined { return _readYDocOptionalString(this._raw.get('local_path'), "BasicAudio.local_path") }
  get metadata(): BasicAssetMetadataYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('metadata'), BasicAssetMetadataYMap, "BasicAudio.metadata") }
  get waveform(): number[] | undefined { return _readYDocOptionalArray(this._raw.get('waveform'), "BasicAudio.waveform", (item, itemLabel) => _readYDocNumber(item, itemLabel)) }
}

/** Typed Y.Map wrapper for BasicImage. */
export class BasicImageYMap extends YMapWrapper {
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "BasicImage.id") }
  get local_path(): string | undefined { return _readYDocOptionalString(this._raw.get('local_path'), "BasicImage.local_path") }
  get metadata(): BasicAssetMetadataYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('metadata'), BasicAssetMetadataYMap, "BasicImage.metadata") }
}

/** Typed Y.Map wrapper for BasicVideo. */
export class BasicVideoYMap extends YMapWrapper {
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "BasicVideo.id") }
  get local_path(): string | undefined { return _readYDocOptionalString(this._raw.get('local_path'), "BasicVideo.local_path") }
  get metadata(): BasicAssetMetadataYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('metadata'), BasicAssetMetadataYMap, "BasicVideo.metadata") }
}

/** Typed Y.Map wrapper for BubbleDict. */
export class BubbleDictYMap extends YMapWrapper {
  get height(): number | undefined { return _readYDocOptionalNumber(this._raw.get('height'), "BubbleDict.height") }
  get panel(): number | undefined { return _readYDocOptionalInteger(this._raw.get('panel'), "BubbleDict.panel") }
  get speaker(): string | undefined { return _readYDocOptionalString(this._raw.get('speaker'), "BubbleDict.speaker") }
  get text(): string | undefined { return _readYDocOptionalString(this._raw.get('text'), "BubbleDict.text") }
  get type(): string | undefined { return _readYDocOptionalString(this._raw.get('type'), "BubbleDict.type") }
  get width(): number | undefined { return _readYDocOptionalNumber(this._raw.get('width'), "BubbleDict.width") }
  get x(): number | undefined { return _readYDocOptionalNumber(this._raw.get('x'), "BubbleDict.x") }
  get y(): number | undefined { return _readYDocOptionalNumber(this._raw.get('y'), "BubbleDict.y") }
}

/** Typed Y.Map wrapper for CharacterAsset. */
export class CharacterAssetYMap extends YMapWrapper {
  get images(): YMapRecord<GeneratedImageWithHistoryYMap, GeneratedImageWithHistory> | undefined { return _readYDocOptionalMapRecord<GeneratedImageWithHistoryYMap, GeneratedImageWithHistory>(this._raw.get('images'), "CharacterAsset.images", (item, itemLabel) => _readYDocMapWrapper(item, GeneratedImageWithHistoryYMap, itemLabel), _validateYDocGeneratedImageWithHistory) }
  get user_prompt(): string | undefined { return _readYDocOptionalString(this._raw.get('user_prompt'), "CharacterAsset.user_prompt") }
  get voices(): YMapRecord<GeneratedAudioWithHistoryYMap, GeneratedAudioWithHistory> | undefined { return _readYDocOptionalMapRecord<GeneratedAudioWithHistoryYMap, GeneratedAudioWithHistory>(this._raw.get('voices'), "CharacterAsset.voices", (item, itemLabel) => _readYDocMapWrapper(item, GeneratedAudioWithHistoryYMap, itemLabel), _validateYDocGeneratedAudioWithHistory) }
}

/** Typed Y.Map wrapper for CompositionDict. */
export class CompositionDictYMap extends YMapWrapper {
  get angle(): string | undefined { return _readYDocOptionalString(this._raw.get('angle'), "CompositionDict.angle") }
  get focus(): string | undefined { return _readYDocOptionalString(this._raw.get('focus'), "CompositionDict.focus") }
  get shot_type(): string | undefined { return _readYDocOptionalString(this._raw.get('shot_type'), "CompositionDict.shot_type") }
}

/** Typed Y.Map wrapper for DialogueEntryDict. */
export class DialogueEntryDictYMap extends YMapWrapper {
  get clip_index(): number | undefined { return _readYDocOptionalInteger(this._raw.get('clip_index'), "DialogueEntryDict.clip_index") }
  get end_s(): number | undefined { return _readYDocOptionalNumber(this._raw.get('end_s'), "DialogueEntryDict.end_s") }
  get source_node_id(): string | undefined { return _readYDocOptionalString(this._raw.get('source_node_id'), "DialogueEntryDict.source_node_id") }
  get start_s(): number | undefined { return _readYDocOptionalNumber(this._raw.get('start_s'), "DialogueEntryDict.start_s") }
  get type(): string | undefined { return _readYDocOptionalString(this._raw.get('type'), "DialogueEntryDict.type") }
  get voice_character(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_character'), "DialogueEntryDict.voice_character") }
  get voice_role_id(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_role_id'), "DialogueEntryDict.voice_role_id") }
  get voice_text(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_text'), "DialogueEntryDict.voice_text") }
}

/** Typed Y.Map wrapper for DirectorCrewDict. */
export class DirectorCrewDictYMap extends YMapWrapper {
  get character(): string | undefined { return _readYDocOptionalString(this._raw.get('character'), "DirectorCrewDict.character") }
  get director(): string | undefined { return _readYDocOptionalString(this._raw.get('director'), "DirectorCrewDict.director") }
  get image(): string | undefined { return _readYDocOptionalString(this._raw.get('image'), "DirectorCrewDict.image") }
  get location(): string | undefined { return _readYDocOptionalString(this._raw.get('location'), "DirectorCrewDict.location") }
  get object(): string | undefined { return _readYDocOptionalString(this._raw.get('object'), "DirectorCrewDict.object") }
  get scriptwriter(): string | undefined { return _readYDocOptionalString(this._raw.get('scriptwriter'), "DirectorCrewDict.scriptwriter") }
  get sound(): string | undefined { return _readYDocOptionalString(this._raw.get('sound'), "DirectorCrewDict.sound") }
  get storyboard(): string | undefined { return _readYDocOptionalString(this._raw.get('storyboard'), "DirectorCrewDict.storyboard") }
  get video(): string | undefined { return _readYDocOptionalString(this._raw.get('video'), "DirectorCrewDict.video") }
}

/** Typed Y.Map wrapper for DirectorPendingToolStateDict. */
export class DirectorPendingToolStateDictYMap extends YMapWrapper {
  get conversation_id(): string | undefined { return _readYDocOptionalString(this._raw.get('conversation_id'), "DirectorPendingToolStateDict.conversation_id") }
  get last_tool_name(): string | undefined { return _readYDocOptionalString(this._raw.get('last_tool_name'), "DirectorPendingToolStateDict.last_tool_name") }
  get last_tool_status(): string | undefined { return _readYDocOptionalString(this._raw.get('last_tool_status'), "DirectorPendingToolStateDict.last_tool_status") }
  get pending_tool_id(): string | undefined { return _readYDocOptionalString(this._raw.get('pending_tool_id'), "DirectorPendingToolStateDict.pending_tool_id") }
  get pending_tool_name(): string | undefined { return _readYDocOptionalString(this._raw.get('pending_tool_name'), "DirectorPendingToolStateDict.pending_tool_name") }
}

/** Typed Y.Map wrapper for EditSpecAudioDict. */
export class EditSpecAudioDictYMap extends YMapWrapper {
  get duck_gain(): number | undefined { return _readYDocOptionalNumber(this._raw.get('duck_gain'), "EditSpecAudioDict.duck_gain") }
  get keep_original_audio(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('keep_original_audio'), "EditSpecAudioDict.keep_original_audio") }
  get original_audio_gain(): number | undefined { return _readYDocOptionalNumber(this._raw.get('original_audio_gain'), "EditSpecAudioDict.original_audio_gain") }
  get tracks(): EditSpecAudioTrackDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('tracks'), "EditSpecAudioDict.tracks", (item, itemLabel) => _readYDocMapWrapper(item, EditSpecAudioTrackDictYMap, itemLabel)) }
}

/** Typed Y.Map wrapper for EditSpecAudioTrackDict. */
export class EditSpecAudioTrackDictYMap extends YMapWrapper {
  get end_seconds(): number | undefined { return _readYDocOptionalNumber(this._raw.get('end_seconds'), "EditSpecAudioTrackDict.end_seconds") }
  get fade_in_seconds(): number | undefined { return _readYDocOptionalNumber(this._raw.get('fade_in_seconds'), "EditSpecAudioTrackDict.fade_in_seconds") }
  get fade_out_seconds(): number | undefined { return _readYDocOptionalNumber(this._raw.get('fade_out_seconds'), "EditSpecAudioTrackDict.fade_out_seconds") }
  get gain(): number | undefined { return _readYDocOptionalNumber(this._raw.get('gain'), "EditSpecAudioTrackDict.gain") }
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "EditSpecAudioTrackDict.id") }
  get loop(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('loop'), "EditSpecAudioTrackDict.loop") }
  get role(): "music" | "voiceover" | "sfx" | undefined { return _readYDocOptionalEnum(this._raw.get('role'), "EditSpecAudioTrackDict.role", ["music", "voiceover", "sfx"] as const) }
  get source(): EditSpecSourceRefDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('source'), EditSpecSourceRefDictYMap, "EditSpecAudioTrackDict.source") }
  get start_seconds(): number | undefined { return _readYDocOptionalNumber(this._raw.get('start_seconds'), "EditSpecAudioTrackDict.start_seconds") }
}

/** Typed Y.Map wrapper for EditSpecCaptionSegmentDict. */
export class EditSpecCaptionSegmentDictYMap extends YMapWrapper {
  get anchor(): "top_left" | "top_center" | "top_right" | "center" | "bottom_left" | "bottom_center" | "bottom_right" | undefined { return _readYDocOptionalEnum(this._raw.get('anchor'), "EditSpecCaptionSegmentDict.anchor", ["top_left", "top_center", "top_right", "center", "bottom_left", "bottom_center", "bottom_right"] as const) }
  get end_seconds(): number | undefined { return _readYDocOptionalNumber(this._raw.get('end_seconds'), "EditSpecCaptionSegmentDict.end_seconds") }
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "EditSpecCaptionSegmentDict.id") }
  get layer(): number | undefined { return _readYDocOptionalInteger(this._raw.get('layer'), "EditSpecCaptionSegmentDict.layer") }
  get rotation(): number | undefined { return _readYDocOptionalNumber(this._raw.get('rotation'), "EditSpecCaptionSegmentDict.rotation") }
  get start_seconds(): number | undefined { return _readYDocOptionalNumber(this._raw.get('start_seconds'), "EditSpecCaptionSegmentDict.start_seconds") }
  get style(): EditSpecTextStyleDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('style'), EditSpecTextStyleDictYMap, "EditSpecCaptionSegmentDict.style") }
  get text(): string | undefined { return _readYDocOptionalString(this._raw.get('text'), "EditSpecCaptionSegmentDict.text") }
  get visible(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('visible'), "EditSpecCaptionSegmentDict.visible") }
  get width_pct(): number | undefined { return _readYDocOptionalNumber(this._raw.get('width_pct'), "EditSpecCaptionSegmentDict.width_pct") }
  get words(): EditSpecCaptionWordDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('words'), "EditSpecCaptionSegmentDict.words", (item, itemLabel) => _readYDocMapWrapper(item, EditSpecCaptionWordDictYMap, itemLabel)) }
  get x(): number | undefined { return _readYDocOptionalNumber(this._raw.get('x'), "EditSpecCaptionSegmentDict.x") }
  get y(): number | undefined { return _readYDocOptionalNumber(this._raw.get('y'), "EditSpecCaptionSegmentDict.y") }
}

/** Typed Y.Map wrapper for EditSpecCaptionWordDict. */
export class EditSpecCaptionWordDictYMap extends YMapWrapper {
  get end_seconds(): number | undefined { return _readYDocOptionalNumber(this._raw.get('end_seconds'), "EditSpecCaptionWordDict.end_seconds") }
  get start_seconds(): number | undefined { return _readYDocOptionalNumber(this._raw.get('start_seconds'), "EditSpecCaptionWordDict.start_seconds") }
  get text(): string | undefined { return _readYDocOptionalString(this._raw.get('text'), "EditSpecCaptionWordDict.text") }
}

/** Typed Y.Map wrapper for EditSpecCaptionsDict. */
export class EditSpecCaptionsDictYMap extends YMapWrapper {
  get font_scale(): number | undefined { return _readYDocOptionalNumber(this._raw.get('font_scale'), "EditSpecCaptionsDict.font_scale") }
  get segments(): EditSpecCaptionSegmentDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('segments'), "EditSpecCaptionsDict.segments", (item, itemLabel) => _readYDocMapWrapper(item, EditSpecCaptionSegmentDictYMap, itemLabel)) }
  get style_preset(): "beasty" | "bold_white_upper" | "boxed" | "bubble_white" | "clean_white" | "cream_editorial" | "gold_lux" | "highlighter_mint" | "highlighter_yellow" | "karaoke_yellow" | "minimal_gray" | "mono_upper" | "neon_cyan" | "neon_magenta" | "purple_pop" | "red_alert" | "subtitle_classic" | "sunny" | "tiktok_pop" | "tiktok_pop_blue" | "tiktok_pop_green" | "word_pop_black" | undefined { return _readYDocOptionalEnum(this._raw.get('style_preset'), "EditSpecCaptionsDict.style_preset", ["beasty", "bold_white_upper", "boxed", "bubble_white", "clean_white", "cream_editorial", "gold_lux", "highlighter_mint", "highlighter_yellow", "karaoke_yellow", "minimal_gray", "mono_upper", "neon_cyan", "neon_magenta", "purple_pop", "red_alert", "subtitle_classic", "sunny", "tiktok_pop", "tiktok_pop_blue", "tiktok_pop_green", "word_pop_black"] as const) }
}

/** Typed Y.Map wrapper for EditSpecClipDict. */
export class EditSpecClipDictYMap extends YMapWrapper {
  get effects(): Array<"ken_burns_in" | "ken_burns_out" | "punch_in" | "grain"> | undefined { return _readYDocOptionalArray(this._raw.get('effects'), "EditSpecClipDict.effects", (item, itemLabel) => _readYDocEnum(item, itemLabel, ["ken_burns_in", "ken_burns_out", "punch_in", "grain"] as const)) }
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "EditSpecClipDict.id") }
  get in_seconds(): number | undefined { return _readYDocOptionalNumber(this._raw.get('in_seconds'), "EditSpecClipDict.in_seconds") }
  get muted(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('muted'), "EditSpecClipDict.muted") }
  get out_seconds(): number | undefined { return _readYDocOptionalNumber(this._raw.get('out_seconds'), "EditSpecClipDict.out_seconds") }
  get source(): EditSpecSourceRefDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('source'), EditSpecSourceRefDictYMap, "EditSpecClipDict.source") }
  get speed(): number | undefined { return _readYDocOptionalNumber(this._raw.get('speed'), "EditSpecClipDict.speed") }
  get transform(): EditSpecTransformDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('transform'), EditSpecTransformDictYMap, "EditSpecClipDict.transform") }
  get transition_in(): EditSpecTransitionDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('transition_in'), EditSpecTransitionDictYMap, "EditSpecClipDict.transition_in") }
  get volume(): number | undefined { return _readYDocOptionalNumber(this._raw.get('volume'), "EditSpecClipDict.volume") }
}

/** Typed Y.Map wrapper for EditSpecColorGradeDict. */
export class EditSpecColorGradeDictYMap extends YMapWrapper {
  get contrast(): number | undefined { return _readYDocOptionalNumber(this._raw.get('contrast'), "EditSpecColorGradeDict.contrast") }
  get exposure(): number | undefined { return _readYDocOptionalNumber(this._raw.get('exposure'), "EditSpecColorGradeDict.exposure") }
  get lut(): "none" | "warm" | "cool" | "teal_orange" | "vivid" | "film" | "bw" | undefined { return _readYDocOptionalEnum(this._raw.get('lut'), "EditSpecColorGradeDict.lut", ["none", "warm", "cool", "teal_orange", "vivid", "film", "bw"] as const) }
  get saturation(): number | undefined { return _readYDocOptionalNumber(this._raw.get('saturation'), "EditSpecColorGradeDict.saturation") }
  get temperature(): number | undefined { return _readYDocOptionalNumber(this._raw.get('temperature'), "EditSpecColorGradeDict.temperature") }
}

/** Typed Y.Map wrapper for EditSpecDict. */
export class EditSpecDictYMap extends YMapWrapper {
  get audio(): EditSpecAudioDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('audio'), EditSpecAudioDictYMap, "EditSpecDict.audio") }
  get captions(): EditSpecCaptionsDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('captions'), EditSpecCaptionsDictYMap, "EditSpecDict.captions") }
  get clips(): EditSpecClipDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('clips'), "EditSpecDict.clips", (item, itemLabel) => _readYDocMapWrapper(item, EditSpecClipDictYMap, itemLabel)) }
  get color_grade(): EditSpecColorGradeDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('color_grade'), EditSpecColorGradeDictYMap, "EditSpecDict.color_grade") }
  get format(): EditSpecFormatDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('format'), EditSpecFormatDictYMap, "EditSpecDict.format") }
  get overlay_clips(): EditSpecOverlayClipDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('overlay_clips'), "EditSpecDict.overlay_clips", (item, itemLabel) => _readYDocMapWrapper(item, EditSpecOverlayClipDictYMap, itemLabel)) }
  get overlays(): EditSpecOverlayDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('overlays'), "EditSpecDict.overlays", (item, itemLabel) => _readYDocMapWrapper(item, EditSpecOverlayDictYMap, itemLabel)) }
  get stage(): EditSpecStageDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('stage'), EditSpecStageDictYMap, "EditSpecDict.stage") }
  get version(): number | undefined { return _readYDocOptionalInteger(this._raw.get('version'), "EditSpecDict.version") }
}

/** Typed Y.Map wrapper for EditSpecFormatDict. */
export class EditSpecFormatDictYMap extends YMapWrapper {
  get aspect(): "9:16" | "1:1" | "16:9" | undefined { return _readYDocOptionalEnum(this._raw.get('aspect'), "EditSpecFormatDict.aspect", ["9:16", "1:1", "16:9"] as const) }
  get fps(): number | undefined { return _readYDocOptionalNumber(this._raw.get('fps'), "EditSpecFormatDict.fps") }
  get height(): number | undefined { return _readYDocOptionalInteger(this._raw.get('height'), "EditSpecFormatDict.height") }
  get width(): number | undefined { return _readYDocOptionalInteger(this._raw.get('width'), "EditSpecFormatDict.width") }
}

/** Typed Y.Map wrapper for EditSpecOverlayClipDict. */
export class EditSpecOverlayClipDictYMap extends YMapWrapper {
  get anchor(): "top_left" | "top_center" | "top_right" | "center" | "bottom_left" | "bottom_center" | "bottom_right" | undefined { return _readYDocOptionalEnum(this._raw.get('anchor'), "EditSpecOverlayClipDict.anchor", ["top_left", "top_center", "top_right", "center", "bottom_left", "bottom_center", "bottom_right"] as const) }
  get component_kind(): "chapter_card" | "quote_card" | "stat_countup" | "bar_chart" | "lower_third_card" | "image_card" | "top_list" | "atmosphere_bg" | "cta_card" | undefined { return _readYDocOptionalEnum(this._raw.get('component_kind'), "EditSpecOverlayClipDict.component_kind", ["chapter_card", "quote_card", "stat_countup", "bar_chart", "lower_third_card", "image_card", "top_list", "atmosphere_bg", "cta_card"] as const) }
  get component_props(): YMapRecord<string | number | boolean | null | Array<string | number | boolean | null> | YMapRecord<string | number | boolean | null, string | number | boolean | null>[], string | number | boolean | null | Array<string | number | boolean | null> | Record<string, string | number | boolean | null>[]> | undefined { return _readYDocOptionalMapRecord<string | number | boolean | null | Array<string | number | boolean | null> | YMapRecord<string | number | boolean | null, string | number | boolean | null>[], string | number | boolean | null | Array<string | number | boolean | null> | Record<string, string | number | boolean | null>[]>(this._raw.get('component_props'), "EditSpecOverlayClipDict.component_props", (item, itemLabel) => _readYDocUnion<string | number | boolean | null | Array<string | number | boolean | null> | YMapRecord<string | number | boolean | null, string | number | boolean | null>[]>(item, itemLabel, [(value, fieldLabel) => _readYDocString(value, fieldLabel), (value, fieldLabel) => _readYDocInteger(value, fieldLabel), (value, fieldLabel) => _readYDocBoolean(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel), (value, fieldLabel) => _readYDocArray(value, fieldLabel, (item, itemLabel) => _readYDocUnion<string | number | boolean | null>(item, itemLabel, [(value, fieldLabel) => _readYDocString(value, fieldLabel), (value, fieldLabel) => _readYDocInteger(value, fieldLabel), (value, fieldLabel) => _readYDocBoolean(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])), (value, fieldLabel) => _readYDocArray(value, fieldLabel, (item, itemLabel) => _readYDocMapRecord<string | number | boolean | null, string | number | boolean | null>(item, itemLabel, (item, itemLabel) => _readYDocUnion<string | number | boolean | null>(item, itemLabel, [(value, fieldLabel) => _readYDocString(value, fieldLabel), (value, fieldLabel) => _readYDocInteger(value, fieldLabel), (value, fieldLabel) => _readYDocBoolean(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)]), _lazyYDocValidator(() => (item, itemLabel) => _validateYDocUnion(item, itemLabel, [(value, fieldLabel) => _validateYDocString(value, fieldLabel), (value, fieldLabel) => _validateYDocInteger(value, fieldLabel), (value, fieldLabel) => _validateYDocNumber(value, fieldLabel), (value, fieldLabel) => _validateYDocBoolean(value, fieldLabel), (value, fieldLabel) => _validateYDocNull(value, fieldLabel)]))))]), _lazyYDocValidator(() => (item, itemLabel) => _validateYDocUnion(item, itemLabel, [(value, fieldLabel) => _validateYDocString(value, fieldLabel), (value, fieldLabel) => _validateYDocInteger(value, fieldLabel), (value, fieldLabel) => _validateYDocNumber(value, fieldLabel), (value, fieldLabel) => _validateYDocBoolean(value, fieldLabel), (value, fieldLabel) => _validateYDocNull(value, fieldLabel), (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocUnion(item, itemLabel, [(value, fieldLabel) => _validateYDocString(value, fieldLabel), (value, fieldLabel) => _validateYDocInteger(value, fieldLabel), (value, fieldLabel) => _validateYDocNumber(value, fieldLabel), (value, fieldLabel) => _validateYDocBoolean(value, fieldLabel), (value, fieldLabel) => _validateYDocNull(value, fieldLabel)])), (value, fieldLabel) => _validateYDocArray(value, fieldLabel, (item, itemLabel) => _validateYDocMap(item, itemLabel, _YDOC_MAP_SPEC_42))]))) }
  get duration_seconds(): number | undefined { return _readYDocOptionalNumber(this._raw.get('duration_seconds'), "EditSpecOverlayClipDict.duration_seconds") }
  get graphic_sources(): EditSpecSourceRefDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('graphic_sources'), "EditSpecOverlayClipDict.graphic_sources", (item, itemLabel) => _readYDocMapWrapper(item, EditSpecSourceRefDictYMap, itemLabel)) }
  get height_pct(): number | undefined { return _readYDocOptionalNumber(this._raw.get('height_pct'), "EditSpecOverlayClipDict.height_pct") }
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "EditSpecOverlayClipDict.id") }
  get layer(): number | undefined { return _readYDocOptionalInteger(this._raw.get('layer'), "EditSpecOverlayClipDict.layer") }
  get opacity(): number | undefined { return _readYDocOptionalNumber(this._raw.get('opacity'), "EditSpecOverlayClipDict.opacity") }
  get role(): "graphic" | "broll" | "pip" | undefined { return _readYDocOptionalEnum(this._raw.get('role'), "EditSpecOverlayClipDict.role", ["graphic", "broll", "pip"] as const) }
  get source(): EditSpecSourceRefDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('source'), EditSpecSourceRefDictYMap, "EditSpecOverlayClipDict.source") }
  get start_seconds(): number | undefined { return _readYDocOptionalNumber(this._raw.get('start_seconds'), "EditSpecOverlayClipDict.start_seconds") }
  get theme(): "dark" | "light" | "bold" | "editorial" | "neon" | undefined { return _readYDocOptionalEnum(this._raw.get('theme'), "EditSpecOverlayClipDict.theme", ["dark", "light", "bold", "editorial", "neon"] as const) }
  get width_pct(): number | undefined { return _readYDocOptionalNumber(this._raw.get('width_pct'), "EditSpecOverlayClipDict.width_pct") }
  get x(): number | undefined { return _readYDocOptionalNumber(this._raw.get('x'), "EditSpecOverlayClipDict.x") }
  get y(): number | undefined { return _readYDocOptionalNumber(this._raw.get('y'), "EditSpecOverlayClipDict.y") }
}

/** Typed Y.Map wrapper for EditSpecOverlayDict. */
export class EditSpecOverlayDictYMap extends YMapWrapper {
  get anchor(): "top_left" | "top_center" | "top_right" | "center" | "bottom_left" | "bottom_center" | "bottom_right" | undefined { return _readYDocOptionalEnum(this._raw.get('anchor'), "EditSpecOverlayDict.anchor", ["top_left", "top_center", "top_right", "center", "bottom_left", "bottom_center", "bottom_right"] as const) }
  get animation(): "none" | "pop" | "fade" | "slide_up" | "typewriter" | undefined { return _readYDocOptionalEnum(this._raw.get('animation'), "EditSpecOverlayDict.animation", ["none", "pop", "fade", "slide_up", "typewriter"] as const) }
  get duration_seconds(): number | undefined { return _readYDocOptionalNumber(this._raw.get('duration_seconds'), "EditSpecOverlayDict.duration_seconds") }
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "EditSpecOverlayDict.id") }
  get kind(): "text" | undefined { return _readYDocOptionalEnum(this._raw.get('kind'), "EditSpecOverlayDict.kind", ["text"] as const) }
  get layer(): number | undefined { return _readYDocOptionalInteger(this._raw.get('layer'), "EditSpecOverlayDict.layer") }
  get rotation(): number | undefined { return _readYDocOptionalNumber(this._raw.get('rotation'), "EditSpecOverlayDict.rotation") }
  get start_seconds(): number | undefined { return _readYDocOptionalNumber(this._raw.get('start_seconds'), "EditSpecOverlayDict.start_seconds") }
  get style(): EditSpecTextStyleDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('style'), EditSpecTextStyleDictYMap, "EditSpecOverlayDict.style") }
  get style_preset(): "bold_caption" | "title_card" | "tag" | "subtitle" | "lower_third" | "pill_pop" | "badge" | "highlight" | "kicker" | "editorial" | "editorial_sub" | undefined { return _readYDocOptionalEnum(this._raw.get('style_preset'), "EditSpecOverlayDict.style_preset", ["bold_caption", "title_card", "tag", "subtitle", "lower_third", "pill_pop", "badge", "highlight", "kicker", "editorial", "editorial_sub"] as const) }
  get text(): string | undefined { return _readYDocOptionalString(this._raw.get('text'), "EditSpecOverlayDict.text") }
  get visible(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('visible'), "EditSpecOverlayDict.visible") }
  get width_pct(): number | undefined { return _readYDocOptionalNumber(this._raw.get('width_pct'), "EditSpecOverlayDict.width_pct") }
  get x(): number | undefined { return _readYDocOptionalNumber(this._raw.get('x'), "EditSpecOverlayDict.x") }
  get y(): number | undefined { return _readYDocOptionalNumber(this._raw.get('y'), "EditSpecOverlayDict.y") }
}

/** Typed Y.Map wrapper for EditSpecSourceRefDict. */
export class EditSpecSourceRefDictYMap extends YMapWrapper {
  get history_index(): number | undefined { return _readYDocOptionalInteger(this._raw.get('history_index'), "EditSpecSourceRefDict.history_index") }
  get media_type(): "video" | "audio" | "image" | undefined { return _readYDocOptionalEnum(this._raw.get('media_type'), "EditSpecSourceRefDict.media_type", ["video", "audio", "image"] as const) }
  get node_id(): string | undefined { return _readYDocOptionalString(this._raw.get('node_id'), "EditSpecSourceRefDict.node_id") }
  get output_port(): "out_video" | "out_audio" | "out_image" | undefined { return _readYDocOptionalEnum(this._raw.get('output_port'), "EditSpecSourceRefDict.output_port", ["out_video", "out_audio", "out_image"] as const) }
}

/** Typed Y.Map wrapper for EditSpecStageBackgroundDict. */
export class EditSpecStageBackgroundDictYMap extends YMapWrapper {
  get color(): string | undefined { return _readYDocOptionalString(this._raw.get('color'), "EditSpecStageBackgroundDict.color") }
  get kind(): "solid" | "gradient" | "blur_broll" | undefined { return _readYDocOptionalEnum(this._raw.get('kind'), "EditSpecStageBackgroundDict.kind", ["solid", "gradient", "blur_broll"] as const) }
}

/** Typed Y.Map wrapper for EditSpecStageDict. */
export class EditSpecStageDictYMap extends YMapWrapper {
  get background(): EditSpecStageBackgroundDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('background'), EditSpecStageBackgroundDictYMap, "EditSpecStageDict.background") }
  get template(): "full" | "presenter_pip_tr" | "presenter_left" | "split_2up" | "grid_4up" | undefined { return _readYDocOptionalEnum(this._raw.get('template'), "EditSpecStageDict.template", ["full", "presenter_pip_tr", "presenter_left", "split_2up", "grid_4up"] as const) }
  get theme(): string | undefined { return _readYDocOptionalString(this._raw.get('theme'), "EditSpecStageDict.theme") }
}

/** Typed Y.Map wrapper for EditSpecTextPlacementDict. */
export class EditSpecTextPlacementDictYMap extends YMapWrapper {
  get anchor(): "top_left" | "top_center" | "top_right" | "center" | "bottom_left" | "bottom_center" | "bottom_right" | undefined { return _readYDocOptionalEnum(this._raw.get('anchor'), "EditSpecTextPlacementDict.anchor", ["top_left", "top_center", "top_right", "center", "bottom_left", "bottom_center", "bottom_right"] as const) }
  get layer(): number | undefined { return _readYDocOptionalInteger(this._raw.get('layer'), "EditSpecTextPlacementDict.layer") }
  get rotation(): number | undefined { return _readYDocOptionalNumber(this._raw.get('rotation'), "EditSpecTextPlacementDict.rotation") }
  get style(): EditSpecTextStyleDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('style'), EditSpecTextStyleDictYMap, "EditSpecTextPlacementDict.style") }
  get visible(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('visible'), "EditSpecTextPlacementDict.visible") }
  get width_pct(): number | undefined { return _readYDocOptionalNumber(this._raw.get('width_pct'), "EditSpecTextPlacementDict.width_pct") }
  get x(): number | undefined { return _readYDocOptionalNumber(this._raw.get('x'), "EditSpecTextPlacementDict.x") }
  get y(): number | undefined { return _readYDocOptionalNumber(this._raw.get('y'), "EditSpecTextPlacementDict.y") }
}

/** Typed Y.Map wrapper for EditSpecTextStyleDict. */
export class EditSpecTextStyleDictYMap extends YMapWrapper {
  get appearance_preset(): "none" | "white_black_outline" | "white_double_outline" | "white_shadow" | "white_soft_shadow" | "yellow_black_outline" | "red_white_outline" | "orange_white_outline" | "blue_white_outline" | "green_black_outline" | "black_gray_box" | "white_gray_box" | "black_yellow_box" | "white_purple_box" | "purple_white_box" | "black_white_box" | "white_black_box" | "green_black_box" | "green_offset" | "yellow_red_shadow" | "white_pink_glow" | "white_yellow_glow" | "white_green_glow" | undefined { return _readYDocOptionalEnum(this._raw.get('appearance_preset'), "EditSpecTextStyleDict.appearance_preset", ["none", "white_black_outline", "white_double_outline", "white_shadow", "white_soft_shadow", "yellow_black_outline", "red_white_outline", "orange_white_outline", "blue_white_outline", "green_black_outline", "black_gray_box", "white_gray_box", "black_yellow_box", "white_purple_box", "purple_white_box", "black_white_box", "white_black_box", "green_black_box", "green_offset", "yellow_red_shadow", "white_pink_glow", "white_yellow_glow", "white_green_glow"] as const) }
  get background_color(): string | undefined { return _readYDocOptionalString(this._raw.get('background_color'), "EditSpecTextStyleDict.background_color") }
  get background_opacity(): number | undefined { return _readYDocOptionalNumber(this._raw.get('background_opacity'), "EditSpecTextStyleDict.background_opacity") }
  get bold(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('bold'), "EditSpecTextStyleDict.bold") }
  get border_radius(): number | undefined { return _readYDocOptionalNumber(this._raw.get('border_radius'), "EditSpecTextStyleDict.border_radius") }
  get color(): string | undefined { return _readYDocOptionalString(this._raw.get('color'), "EditSpecTextStyleDict.color") }
  get font_family(): "display" | "sans" | "mono" | undefined { return _readYDocOptionalEnum(this._raw.get('font_family'), "EditSpecTextStyleDict.font_family", ["display", "sans", "mono"] as const) }
  get font_size(): number | undefined { return _readYDocOptionalNumber(this._raw.get('font_size'), "EditSpecTextStyleDict.font_size") }
  get italic(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('italic'), "EditSpecTextStyleDict.italic") }
  get letter_spacing(): number | undefined { return _readYDocOptionalNumber(this._raw.get('letter_spacing'), "EditSpecTextStyleDict.letter_spacing") }
  get line_height(): number | undefined { return _readYDocOptionalNumber(this._raw.get('line_height'), "EditSpecTextStyleDict.line_height") }
  get outline(): "none" | "soft" | "strong" | undefined { return _readYDocOptionalEnum(this._raw.get('outline'), "EditSpecTextStyleDict.outline", ["none", "soft", "strong"] as const) }
  get padding(): number | undefined { return _readYDocOptionalNumber(this._raw.get('padding'), "EditSpecTextStyleDict.padding") }
  get scale_x(): number | undefined { return _readYDocOptionalNumber(this._raw.get('scale_x'), "EditSpecTextStyleDict.scale_x") }
  get scale_y(): number | undefined { return _readYDocOptionalNumber(this._raw.get('scale_y'), "EditSpecTextStyleDict.scale_y") }
  get shadow(): "none" | "soft" | "strong" | undefined { return _readYDocOptionalEnum(this._raw.get('shadow'), "EditSpecTextStyleDict.shadow", ["none", "soft", "strong"] as const) }
  get text_align(): "left" | "center" | "right" | undefined { return _readYDocOptionalEnum(this._raw.get('text_align'), "EditSpecTextStyleDict.text_align", ["left", "center", "right"] as const) }
  get text_case(): "none" | "uppercase" | "lowercase" | "capitalize" | undefined { return _readYDocOptionalEnum(this._raw.get('text_case'), "EditSpecTextStyleDict.text_case", ["none", "uppercase", "lowercase", "capitalize"] as const) }
  get underline(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('underline'), "EditSpecTextStyleDict.underline") }
}

/** Typed Y.Map wrapper for EditSpecTransformDict. */
export class EditSpecTransformDictYMap extends YMapWrapper {
  get focus_x(): number | undefined { return _readYDocOptionalNumber(this._raw.get('focus_x'), "EditSpecTransformDict.focus_x") }
  get focus_y(): number | undefined { return _readYDocOptionalNumber(this._raw.get('focus_y'), "EditSpecTransformDict.focus_y") }
  get reframe(): "cover" | "contain" | "smart" | undefined { return _readYDocOptionalEnum(this._raw.get('reframe'), "EditSpecTransformDict.reframe", ["cover", "contain", "smart"] as const) }
  get scale(): number | undefined { return _readYDocOptionalNumber(this._raw.get('scale'), "EditSpecTransformDict.scale") }
}

/** Typed Y.Map wrapper for EditSpecTransitionDict. */
export class EditSpecTransitionDictYMap extends YMapWrapper {
  get direction(): "from_left" | "from_right" | "from_top" | "from_bottom" | undefined { return _readYDocOptionalEnum(this._raw.get('direction'), "EditSpecTransitionDict.direction", ["from_left", "from_right", "from_top", "from_bottom"] as const) }
  get duration_s(): number | undefined { return _readYDocOptionalNumber(this._raw.get('duration_s'), "EditSpecTransitionDict.duration_s") }
  get type(): "none" | "fade" | "slide" | "wipe" | "flip" | "clock_wipe" | undefined { return _readYDocOptionalEnum(this._raw.get('type'), "EditSpecTransitionDict.type", ["none", "fade", "slide", "wipe", "flip", "clock_wipe"] as const) }
}

/** Typed Y.Map wrapper for FeedbackHistoryEntryDict. */
export class FeedbackHistoryEntryDictYMap extends YMapWrapper {
  get applied_at(): string | undefined { return _readYDocOptionalString(this._raw.get('applied_at'), "FeedbackHistoryEntryDict.applied_at") }
  get feedback(): string | undefined { return _readYDocOptionalString(this._raw.get('feedback'), "FeedbackHistoryEntryDict.feedback") }
  get round(): number | undefined { return _readYDocOptionalInteger(this._raw.get('round'), "FeedbackHistoryEntryDict.round") }
}

/** Typed Y.Map wrapper for GeneratedAssetMetadata. */
export class GeneratedAssetMetadataYMap extends YMapWrapper {
  get aspect_ratio(): string | undefined { return _readYDocOptionalString(this._raw.get('aspect_ratio'), "GeneratedAssetMetadata.aspect_ratio") }
  get character_name(): string | undefined { return _readYDocOptionalString(this._raw.get('character_name'), "GeneratedAssetMetadata.character_name") }
  get duration_seconds(): number | undefined { return _readYDocOptionalNumber(this._raw.get('duration_seconds'), "GeneratedAssetMetadata.duration_seconds") }
  get eleven_lab_voice_id(): string | undefined { return _readYDocOptionalString(this._raw.get('eleven_lab_voice_id'), "GeneratedAssetMetadata.eleven_lab_voice_id") }
  get eleven_lab_voice_name(): string | undefined { return _readYDocOptionalString(this._raw.get('eleven_lab_voice_name'), "GeneratedAssetMetadata.eleven_lab_voice_name") }
  get language(): string | undefined { return _readYDocOptionalString(this._raw.get('language'), "GeneratedAssetMetadata.language") }
  get loop(): string | undefined { return _readYDocOptionalString(this._raw.get('loop'), "GeneratedAssetMetadata.loop") }
  get mode(): string | undefined { return _readYDocOptionalString(this._raw.get('mode'), "GeneratedAssetMetadata.mode") }
  get model(): string | undefined { return _readYDocOptionalString(this._raw.get('model'), "GeneratedAssetMetadata.model") }
  get provider(): string | undefined { return _readYDocOptionalString(this._raw.get('provider'), "GeneratedAssetMetadata.provider") }
  get regenerated(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('regenerated'), "GeneratedAssetMetadata.regenerated") }
  get regeneration_time(): string | undefined { return _readYDocOptionalString(this._raw.get('regeneration_time'), "GeneratedAssetMetadata.regeneration_time") }
  get segment_start_times(): number[] | undefined { return _readYDocOptionalArray(this._raw.get('segment_start_times'), "GeneratedAssetMetadata.segment_start_times", (item, itemLabel) => _readYDocNumber(item, itemLabel)) }
  get segments(): number | undefined { return _readYDocOptionalInteger(this._raw.get('segments'), "GeneratedAssetMetadata.segments") }
  get type(): string | undefined { return _readYDocOptionalString(this._raw.get('type'), "GeneratedAssetMetadata.type") }
  get voice_id(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_id'), "GeneratedAssetMetadata.voice_id") }
  get voice_name(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_name'), "GeneratedAssetMetadata.voice_name") }
  get voice_type(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_type'), "GeneratedAssetMetadata.voice_type") }
}

/** Typed Y.Map wrapper for GeneratedAudio. */
export class GeneratedAudioYMap extends YMapWrapper {
  get metadata(): GeneratedAssetMetadataYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('metadata'), GeneratedAssetMetadataYMap, "GeneratedAudio.metadata") }
  get refs(): BasicAudioYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('refs'), "GeneratedAudio.refs", (item, itemLabel) => _readYDocMapWrapper(item, BasicAudioYMap, itemLabel)) }
  get result(): BasicAudioYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('result'), BasicAudioYMap, "GeneratedAudio.result") }
  get user_prompt(): string | undefined { return _readYDocOptionalString(this._raw.get('user_prompt'), "GeneratedAudio.user_prompt") }
}

/** Typed Y.Map wrapper for GeneratedAudioWithHistory. */
export class GeneratedAudioWithHistoryYMap extends YMapWrapper {
  get history(): GeneratedAudioYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('history'), "GeneratedAudioWithHistory.history", (item, itemLabel) => _readYDocMapWrapper(item, GeneratedAudioYMap, itemLabel)) }
  get picked_index(): number | undefined { return _readYDocOptionalInteger(this._raw.get('picked_index'), "GeneratedAudioWithHistory.picked_index") }
}

/** Typed Y.Map wrapper for GeneratedImage. */
export class GeneratedImageYMap extends YMapWrapper {
  get metadata(): GeneratedAssetMetadataYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('metadata'), GeneratedAssetMetadataYMap, "GeneratedImage.metadata") }
  get refs(): BasicImageYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('refs'), "GeneratedImage.refs", (item, itemLabel) => _readYDocMapWrapper(item, BasicImageYMap, itemLabel)) }
  get result(): BasicImageYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('result'), BasicImageYMap, "GeneratedImage.result") }
  get user_prompt(): string | undefined { return _readYDocOptionalString(this._raw.get('user_prompt'), "GeneratedImage.user_prompt") }
}

/** Typed Y.Map wrapper for GeneratedImageWithHistory. */
export class GeneratedImageWithHistoryYMap extends YMapWrapper {
  get history(): GeneratedImageYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('history'), "GeneratedImageWithHistory.history", (item, itemLabel) => _readYDocMapWrapper(item, GeneratedImageYMap, itemLabel)) }
  get picked_index(): number | undefined { return _readYDocOptionalInteger(this._raw.get('picked_index'), "GeneratedImageWithHistory.picked_index") }
}

/** Typed Y.Map wrapper for GeneratedShotRowV2Dict. */
export class GeneratedShotRowV2DictYMap extends YMapWrapper {
  get camera_movement(): string | undefined { return _readYDocOptionalString(this._raw.get('camera_movement'), "GeneratedShotRowV2Dict.camera_movement") }
  setCameraMovement(value: string): void {
    const fieldLabel = "GeneratedShotRowV2Dict.camera_movement"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocString(validationValue, fieldLabel)
    this._raw.set('camera_movement', _toYDocValue(value))
  }
  get continuity_in(): string | undefined { return _readYDocOptionalString(this._raw.get('continuity_in'), "GeneratedShotRowV2Dict.continuity_in") }
  get continuity_out(): string | undefined { return _readYDocOptionalString(this._raw.get('continuity_out'), "GeneratedShotRowV2Dict.continuity_out") }
  get dialogue_voiceover(): string | undefined { return _readYDocOptionalString(this._raw.get('dialogue_voiceover'), "GeneratedShotRowV2Dict.dialogue_voiceover") }
  setDialogueVoiceover(value: string): void {
    const fieldLabel = "GeneratedShotRowV2Dict.dialogue_voiceover"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocString(validationValue, fieldLabel)
    this._raw.set('dialogue_voiceover', _toYDocValue(value))
  }
  get duration_ms(): number | undefined { return _readYDocOptionalInteger(this._raw.get('duration_ms'), "GeneratedShotRowV2Dict.duration_ms") }
  setDurationMs(value: number): void {
    const fieldLabel = "GeneratedShotRowV2Dict.duration_ms"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocInteger(validationValue, fieldLabel, undefined, 1)
    this._raw.set('duration_ms', _toYDocValue(value))
  }
  get framing(): ShotListFramingV2DictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('framing'), ShotListFramingV2DictYMap, "GeneratedShotRowV2Dict.framing") }
  setFraming(value: ShotListFramingV2Dict): void {
    const fieldLabel = "GeneratedShotRowV2Dict.framing"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocMap(validationValue, fieldLabel, _YDOC_MAP_SPEC_19)
    this._raw.set('framing', _toYDocValue(value))
  }
  deleteFraming(): void { this._raw.delete('framing') }
  get generation_id(): string | undefined { return _readYDocOptionalString(this._raw.get('generation_id'), "GeneratedShotRowV2Dict.generation_id") }
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "GeneratedShotRowV2Dict.id") }
  get interior_exterior(): string | undefined { return _readYDocOptionalString(this._raw.get('interior_exterior'), "GeneratedShotRowV2Dict.interior_exterior") }
  setInteriorExterior(value: string): void {
    const fieldLabel = "GeneratedShotRowV2Dict.interior_exterior"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocString(validationValue, fieldLabel)
    this._raw.set('interior_exterior', _toYDocValue(value))
  }
  get lighting(): string | undefined { return _readYDocOptionalString(this._raw.get('lighting'), "GeneratedShotRowV2Dict.lighting") }
  get location(): string | undefined { return _readYDocOptionalString(this._raw.get('location'), "GeneratedShotRowV2Dict.location") }
  setLocation(value: string): void {
    const fieldLabel = "GeneratedShotRowV2Dict.location"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocString(validationValue, fieldLabel)
    this._raw.set('location', _toYDocValue(value))
  }
  get purpose(): string | undefined { return _readYDocOptionalString(this._raw.get('purpose'), "GeneratedShotRowV2Dict.purpose") }
  get scene_fingerprint(): string | undefined { return _readYDocOptionalString(this._raw.get('scene_fingerprint'), "GeneratedShotRowV2Dict.scene_fingerprint") }
  get scene_ordinal(): number | undefined { return _readYDocOptionalInteger(this._raw.get('scene_ordinal'), "GeneratedShotRowV2Dict.scene_ordinal") }
  get sfx(): string | undefined { return _readYDocOptionalString(this._raw.get('sfx'), "GeneratedShotRowV2Dict.sfx") }
  setSfx(value: string): void {
    const fieldLabel = "GeneratedShotRowV2Dict.sfx"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocString(validationValue, fieldLabel)
    this._raw.set('sfx', _toYDocValue(value))
  }
  get source_truth(): "SUPPLIED" | "PROPOSED" | "TBC" | undefined { return _readYDocOptionalEnum(this._raw.get('source_truth'), "GeneratedShotRowV2Dict.source_truth", ["SUPPLIED", "PROPOSED", "TBC"] as const) }
  get source_unit_refs(): string[] | undefined { return _readYDocOptionalArray(this._raw.get('source_unit_refs'), "GeneratedShotRowV2Dict.source_unit_refs", (item, itemLabel) => _readYDocString(item, itemLabel)) }
  get time_of_day(): string | undefined { return _readYDocOptionalString(this._raw.get('time_of_day'), "GeneratedShotRowV2Dict.time_of_day") }
  setTimeOfDay(value: string): void {
    const fieldLabel = "GeneratedShotRowV2Dict.time_of_day"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocString(validationValue, fieldLabel)
    this._raw.set('time_of_day', _toYDocValue(value))
  }
  deleteTimeOfDay(): void { this._raw.delete('time_of_day') }
  get visual_description(): string | undefined { return _readYDocOptionalString(this._raw.get('visual_description'), "GeneratedShotRowV2Dict.visual_description") }
  setVisualDescription(value: string): void {
    const fieldLabel = "GeneratedShotRowV2Dict.visual_description"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocString(validationValue, fieldLabel)
    this._raw.set('visual_description', _toYDocValue(value))
  }
  get visual_prompt(): string | undefined { return _readYDocOptionalString(this._raw.get('visual_prompt'), "GeneratedShotRowV2Dict.visual_prompt") }
  setVisualPrompt(value: string): void {
    const fieldLabel = "GeneratedShotRowV2Dict.visual_prompt"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocString(validationValue, fieldLabel)
    this._raw.set('visual_prompt', _toYDocValue(value))
  }
  deleteVisualPrompt(): void { this._raw.delete('visual_prompt') }
}

/** Typed Y.Map wrapper for GeneratedVideo. */
export class GeneratedVideoYMap extends YMapWrapper {
  get audio_edit_provenance(): AudioEditProvenanceDictYMap | undefined { return (this._raw.get('audio_edit_provenance') == null ? undefined : (() => { _validateYDocAudioEditProvenanceDict(this._raw.get('audio_edit_provenance'), "GeneratedVideo.audio_edit_provenance"); return _readYDocMapWrapper(this._raw.get('audio_edit_provenance'), AudioEditProvenanceDictYMap, "GeneratedVideo.audio_edit_provenance") })()) }
  get baked_audio(): UnifiedAudioProjectDictYMap | UnifiedAudioProjectV2YMap | undefined { return (this._raw.get('baked_audio') == null ? undefined : _readYDocDiscriminatedUnion<UnifiedAudioProjectDictYMap | UnifiedAudioProjectV2YMap>(this._raw.get('baked_audio'), "GeneratedVideo.baked_audio", "contractVersion", [[2, (value, fieldLabel) => { return (() => { _validateYDocUnifiedAudioProjectV2(value, fieldLabel); return _readYDocMapWrapper(value, UnifiedAudioProjectV2YMap, fieldLabel) })() }]], (value, fieldLabel) => { _validateYDocUnifiedAudioProjectDict(value, fieldLabel); return _readYDocMapWrapper(value, UnifiedAudioProjectDictYMap, fieldLabel) })) }
  get metadata(): GeneratedAssetMetadataYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('metadata'), GeneratedAssetMetadataYMap, "GeneratedVideo.metadata") }
  get refs(): BasicImageYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('refs'), "GeneratedVideo.refs", (item, itemLabel) => _readYDocMapWrapper(item, BasicImageYMap, itemLabel)) }
  get result(): BasicVideoYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('result'), BasicVideoYMap, "GeneratedVideo.result") }
  get user_prompt(): string | undefined { return _readYDocOptionalString(this._raw.get('user_prompt'), "GeneratedVideo.user_prompt") }
}

/** Typed Y.Map wrapper for GeneratedVideoWithHistory. */
export class GeneratedVideoWithHistoryYMap extends YMapWrapper {
  get history(): GeneratedVideoYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('history'), "GeneratedVideoWithHistory.history", (item, itemLabel) => (() => { _validateYDocGeneratedVideo(item, itemLabel); return _readYDocMapWrapper(item, GeneratedVideoYMap, itemLabel) })()) }
  get picked_index(): number | undefined { return _readYDocOptionalInteger(this._raw.get('picked_index'), "GeneratedVideoWithHistory.picked_index") }
  get picked_variant_id(): string | null | undefined { return (this._raw.get('picked_variant_id') == null ? undefined : _readYDocUnion<string | null>(this._raw.get('picked_variant_id'), "GeneratedVideoWithHistory.picked_variant_id", [(value, fieldLabel) => _readYDocString(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
}

/** Typed Y.Map wrapper for ImageAnnotationDict. */
export class ImageAnnotationDictYMap extends YMapWrapper {
  get color(): string | undefined { return _readYDocOptionalString(this._raw.get('color'), "ImageAnnotationDict.color") }
  get font_size(): number | undefined { return _readYDocOptionalNumber(this._raw.get('font_size'), "ImageAnnotationDict.font_size") }
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "ImageAnnotationDict.id") }
  get kind(): string | undefined { return _readYDocOptionalString(this._raw.get('kind'), "ImageAnnotationDict.kind") }
  get label(): string | undefined { return _readYDocOptionalString(this._raw.get('label'), "ImageAnnotationDict.label") }
  get points(): AnnotationPointDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('points'), "ImageAnnotationDict.points", (item, itemLabel) => _readYDocMapWrapper(item, AnnotationPointDictYMap, itemLabel)) }
  get stroke_width(): number | undefined { return _readYDocOptionalNumber(this._raw.get('stroke_width'), "ImageAnnotationDict.stroke_width") }
  get text(): string | undefined { return _readYDocOptionalString(this._raw.get('text'), "ImageAnnotationDict.text") }
}

/** Typed Y.Map wrapper for ImageAssetRefDict. */
export class ImageAssetRefDictYMap extends YMapWrapper {
  get history(): GeneratedImageYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('history'), "ImageAssetRefDict.history", (item, itemLabel) => _readYDocMapWrapper(item, GeneratedImageYMap, itemLabel)) }
  get picked_index(): number | undefined { return _readYDocOptionalInteger(this._raw.get('picked_index'), "ImageAssetRefDict.picked_index") }
}

/** Typed Y.Map wrapper for LocationAsset. */
export class LocationAssetYMap extends YMapWrapper {
  get images(): YMapRecord<GeneratedImageWithHistoryYMap, GeneratedImageWithHistory> | undefined { return _readYDocOptionalMapRecord<GeneratedImageWithHistoryYMap, GeneratedImageWithHistory>(this._raw.get('images'), "LocationAsset.images", (item, itemLabel) => _readYDocMapWrapper(item, GeneratedImageWithHistoryYMap, itemLabel), _validateYDocGeneratedImageWithHistory) }
  get user_prompt(): string | undefined { return _readYDocOptionalString(this._raw.get('user_prompt'), "LocationAsset.user_prompt") }
}

/** Typed Y.Map wrapper for LocationMetadataDict. */
export class LocationMetadataDictYMap extends YMapWrapper {
  get name(): string | undefined { return _readYDocOptionalString(this._raw.get('name'), "LocationMetadataDict.name") }
  get style(): string | undefined { return _readYDocOptionalString(this._raw.get('style'), "LocationMetadataDict.style") }
  get time_of_day(): string | undefined { return _readYDocOptionalString(this._raw.get('time_of_day'), "LocationMetadataDict.time_of_day") }
  get weather(): string | undefined { return _readYDocOptionalString(this._raw.get('weather'), "LocationMetadataDict.weather") }
}

/** Typed Y.Map wrapper for LocationPanoramaViewDict. */
export class LocationPanoramaViewDictYMap extends YMapWrapper {
  get fov_degrees(): number | undefined { return _readYDocOptionalNumber(this._raw.get('fov_degrees'), "LocationPanoramaViewDict.fov_degrees") }
  get pitch_degrees(): number | undefined { return _readYDocOptionalNumber(this._raw.get('pitch_degrees'), "LocationPanoramaViewDict.pitch_degrees") }
  get yaw_degrees(): number | undefined { return _readYDocOptionalNumber(this._raw.get('yaw_degrees'), "LocationPanoramaViewDict.yaw_degrees") }
}

/** Typed Y.Map wrapper for MediaAssetRefDict. */
export class MediaAssetRefDictYMap extends YMapWrapper {
  get history(): Y.Map<unknown>[] | undefined { return _readYDocOptionalArray(this._raw.get('history'), "MediaAssetRefDict.history", (item, itemLabel) => _readYDocJsonValue<Y.Map<unknown>>(item, itemLabel)) }
  get media_type(): "image" | "video" | "audio" | undefined { return _readYDocOptionalEnum(this._raw.get('media_type'), "MediaAssetRefDict.media_type", ["image", "video", "audio"] as const) }
  get picked_index(): number | undefined { return _readYDocOptionalInteger(this._raw.get('picked_index'), "MediaAssetRefDict.picked_index") }
  get source_node_id(): string | undefined { return _readYDocOptionalString(this._raw.get('source_node_id'), "MediaAssetRefDict.source_node_id") }
}

/** Typed Y.Map wrapper for MotionDocumentDict. */
export class MotionDocumentDictYMap extends YMapWrapper {
  get elements(): MotionElementDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('elements'), "MotionDocumentDict.elements", (item, itemLabel) => _readYDocMapWrapper(item, MotionElementDictYMap, itemLabel)) }
  get version(): number | undefined { return _readYDocOptionalInteger(this._raw.get('version'), "MotionDocumentDict.version") }
}

/** Typed Y.Map wrapper for MotionElementDict. */
export class MotionElementDictYMap extends YMapWrapper {
  get border_radius(): number | undefined { return _readYDocOptionalNumber(this._raw.get('border_radius'), "MotionElementDict.border_radius") }
  get color(): string | undefined { return _readYDocOptionalString(this._raw.get('color'), "MotionElementDict.color") }
  get duration_seconds(): number | undefined { return _readYDocOptionalNumber(this._raw.get('duration_seconds'), "MotionElementDict.duration_seconds") }
  get fit(): "cover" | "contain" | "fill" | undefined { return _readYDocOptionalEnum(this._raw.get('fit'), "MotionElementDict.fit", ["cover", "contain", "fill"] as const) }
  get font_size(): number | undefined { return _readYDocOptionalNumber(this._raw.get('font_size'), "MotionElementDict.font_size") }
  get font_weight(): number | undefined { return _readYDocOptionalInteger(this._raw.get('font_weight'), "MotionElementDict.font_weight") }
  get height(): number | undefined { return _readYDocOptionalNumber(this._raw.get('height'), "MotionElementDict.height") }
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "MotionElementDict.id") }
  get keyframes(): MotionKeyframeDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('keyframes'), "MotionElementDict.keyframes", (item, itemLabel) => _readYDocMapWrapper(item, MotionKeyframeDictYMap, itemLabel)) }
  get kind(): "text" | "shape" | "image" | "video" | "audio" | undefined { return _readYDocOptionalEnum(this._raw.get('kind'), "MotionElementDict.kind", ["text", "shape", "image", "video", "audio"] as const) }
  get opacity(): number | undefined { return _readYDocOptionalNumber(this._raw.get('opacity'), "MotionElementDict.opacity") }
  get rotation(): number | undefined { return _readYDocOptionalNumber(this._raw.get('rotation'), "MotionElementDict.rotation") }
  get scale_x(): number | undefined { return _readYDocOptionalNumber(this._raw.get('scale_x'), "MotionElementDict.scale_x") }
  get scale_y(): number | undefined { return _readYDocOptionalNumber(this._raw.get('scale_y'), "MotionElementDict.scale_y") }
  get source(): MotionSourceRefDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('source'), MotionSourceRefDictYMap, "MotionElementDict.source") }
  get start_seconds(): number | undefined { return _readYDocOptionalNumber(this._raw.get('start_seconds'), "MotionElementDict.start_seconds") }
  get text(): string | undefined { return _readYDocOptionalString(this._raw.get('text'), "MotionElementDict.text") }
  get volume(): number | undefined { return _readYDocOptionalNumber(this._raw.get('volume'), "MotionElementDict.volume") }
  get width(): number | undefined { return _readYDocOptionalNumber(this._raw.get('width'), "MotionElementDict.width") }
  get x(): number | undefined { return _readYDocOptionalNumber(this._raw.get('x'), "MotionElementDict.x") }
  get y(): number | undefined { return _readYDocOptionalNumber(this._raw.get('y'), "MotionElementDict.y") }
}

/** Typed Y.Map wrapper for MotionKeyframeDict. */
export class MotionKeyframeDictYMap extends YMapWrapper {
  get at(): number | undefined { return _readYDocOptionalNumber(this._raw.get('at'), "MotionKeyframeDict.at") }
  get easing(): "linear" | "ease_in" | "ease_out" | "ease_in_out" | undefined { return _readYDocOptionalEnum(this._raw.get('easing'), "MotionKeyframeDict.easing", ["linear", "ease_in", "ease_out", "ease_in_out"] as const) }
  get opacity(): number | undefined { return _readYDocOptionalNumber(this._raw.get('opacity'), "MotionKeyframeDict.opacity") }
  get rotation(): number | undefined { return _readYDocOptionalNumber(this._raw.get('rotation'), "MotionKeyframeDict.rotation") }
  get scale_x(): number | undefined { return _readYDocOptionalNumber(this._raw.get('scale_x'), "MotionKeyframeDict.scale_x") }
  get scale_y(): number | undefined { return _readYDocOptionalNumber(this._raw.get('scale_y'), "MotionKeyframeDict.scale_y") }
  get x(): number | undefined { return _readYDocOptionalNumber(this._raw.get('x'), "MotionKeyframeDict.x") }
  get y(): number | undefined { return _readYDocOptionalNumber(this._raw.get('y'), "MotionKeyframeDict.y") }
}

/** Typed Y.Map wrapper for MotionSourceRefDict. */
export class MotionSourceRefDictYMap extends YMapWrapper {
  get history_index(): number | undefined { return _readYDocOptionalInteger(this._raw.get('history_index'), "MotionSourceRefDict.history_index") }
  get node_id(): string | undefined { return _readYDocOptionalString(this._raw.get('node_id'), "MotionSourceRefDict.node_id") }
  get output_port(): "out_video" | "out_audio" | "out_image" | undefined { return _readYDocOptionalEnum(this._raw.get('output_port'), "MotionSourceRefDict.output_port", ["out_video", "out_audio", "out_image"] as const) }
}

/** Typed Y.Map wrapper for NativeSpeechSpanDict. */
export class NativeSpeechSpanDictYMap extends YMapWrapper {
  get confidence(): number | undefined { return _readYDocOptionalNumber(this._raw.get('confidence'), "NativeSpeechSpanDict.confidence") }
  get end_s(): number | undefined { return _readYDocOptionalNumber(this._raw.get('end_s'), "NativeSpeechSpanDict.end_s") }
  get lane_id(): string | undefined { return _readYDocOptionalString(this._raw.get('lane_id'), "NativeSpeechSpanDict.lane_id") }
  get source_sig(): string | undefined { return _readYDocOptionalString(this._raw.get('source_sig'), "NativeSpeechSpanDict.source_sig") }
  get start_s(): number | undefined { return _readYDocOptionalNumber(this._raw.get('start_s'), "NativeSpeechSpanDict.start_s") }
  get text(): string | undefined { return _readYDocOptionalString(this._raw.get('text'), "NativeSpeechSpanDict.text") }
}

/** Typed Y.Map wrapper for NativeSpeechTakeDict. */
export class NativeSpeechTakeDictYMap extends YMapWrapper {
  get clip_id(): string | undefined { return _readYDocOptionalString(this._raw.get('clip_id'), "NativeSpeechTakeDict.clip_id") }
  get selected_label(): string | undefined { return _readYDocOptionalString(this._raw.get('selected_label'), "NativeSpeechTakeDict.selected_label") }
  get source_sig(): string | undefined { return _readYDocOptionalString(this._raw.get('source_sig'), "NativeSpeechTakeDict.source_sig") }
  get versions(): TtsVersionDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('versions'), "NativeSpeechTakeDict.versions", (item, itemLabel) => _readYDocMapWrapper(item, TtsVersionDictYMap, itemLabel)) }
}

/** Typed Y.Map wrapper for ObjectAsset. */
export class ObjectAssetYMap extends YMapWrapper {
  get images(): YMapRecord<GeneratedImageWithHistoryYMap, GeneratedImageWithHistory> | undefined { return _readYDocOptionalMapRecord<GeneratedImageWithHistoryYMap, GeneratedImageWithHistory>(this._raw.get('images'), "ObjectAsset.images", (item, itemLabel) => _readYDocMapWrapper(item, GeneratedImageWithHistoryYMap, itemLabel), _validateYDocGeneratedImageWithHistory) }
  get user_prompt(): string | undefined { return _readYDocOptionalString(this._raw.get('user_prompt'), "ObjectAsset.user_prompt") }
}

/** Typed Y.Map wrapper for ObjectMetadataDict. */
export class ObjectMetadataDictYMap extends YMapWrapper {
  get description(): string | undefined { return _readYDocOptionalString(this._raw.get('description'), "ObjectMetadataDict.description") }
  get name(): string | undefined { return _readYDocOptionalString(this._raw.get('name'), "ObjectMetadataDict.name") }
  get style(): string | undefined { return _readYDocOptionalString(this._raw.get('style'), "ObjectMetadataDict.style") }
}

/** Typed Y.Map wrapper for PanelDescriptionDict. */
export class PanelDescriptionDictYMap extends YMapWrapper {
  get characters(): string[] | undefined { return _readYDocOptionalArray(this._raw.get('characters'), "PanelDescriptionDict.characters", (item, itemLabel) => _readYDocString(item, itemLabel)) }
  get description(): string | undefined { return _readYDocOptionalString(this._raw.get('description'), "PanelDescriptionDict.description") }
  get location(): string | undefined { return _readYDocOptionalString(this._raw.get('location'), "PanelDescriptionDict.location") }
  get panel_id(): string | undefined { return _readYDocOptionalString(this._raw.get('panel_id'), "PanelDescriptionDict.panel_id") }
}

/** Typed Y.Map wrapper for PanelDialogueDict. */
export class PanelDialogueDictYMap extends YMapWrapper {
  get speaker(): string | undefined { return _readYDocOptionalString(this._raw.get('speaker'), "PanelDialogueDict.speaker") }
  get text(): string | undefined { return _readYDocOptionalString(this._raw.get('text'), "PanelDialogueDict.text") }
  get type(): string | undefined { return _readYDocOptionalString(this._raw.get('type'), "PanelDialogueDict.type") }
}

/** Typed Y.Map wrapper for ReconciledDialogueEntryDict. */
export class ReconciledDialogueEntryDictYMap extends YMapWrapper {
  get actual_text(): string | undefined { return _readYDocOptionalString(this._raw.get('actual_text'), "ReconciledDialogueEntryDict.actual_text") }
  get character(): string | undefined { return _readYDocOptionalString(this._raw.get('character'), "ReconciledDialogueEntryDict.character") }
  get duration_s(): number | undefined { return _readYDocOptionalNumber(this._raw.get('duration_s'), "ReconciledDialogueEntryDict.duration_s") }
  get emotion(): string | undefined { return _readYDocOptionalString(this._raw.get('emotion'), "ReconciledDialogueEntryDict.emotion") }
  get end_s(): number | undefined { return _readYDocOptionalNumber(this._raw.get('end_s'), "ReconciledDialogueEntryDict.end_s") }
  get intended_text(): string | undefined { return _readYDocOptionalString(this._raw.get('intended_text'), "ReconciledDialogueEntryDict.intended_text") }
  get intensity(): number | undefined { return _readYDocOptionalNumber(this._raw.get('intensity'), "ReconciledDialogueEntryDict.intensity") }
  get line_type(): string | undefined { return _readYDocOptionalString(this._raw.get('line_type'), "ReconciledDialogueEntryDict.line_type") }
  get replacement_text(): string | undefined { return _readYDocOptionalString(this._raw.get('replacement_text'), "ReconciledDialogueEntryDict.replacement_text") }
  get start_s(): number | undefined { return _readYDocOptionalNumber(this._raw.get('start_s'), "ReconciledDialogueEntryDict.start_s") }
  get status(): string | undefined { return _readYDocOptionalString(this._raw.get('status'), "ReconciledDialogueEntryDict.status") }
  get voice_role_id(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_role_id'), "ReconciledDialogueEntryDict.voice_role_id") }
}

/** Typed Y.Map wrapper for ReferenceAdjustmentDict. */
export class ReferenceAdjustmentDictYMap extends YMapWrapper {
  get action(): "converted" | "reencoded" | "downscaled" | "first_frame" | "transcoded" | undefined { return _readYDocOptionalEnum(this._raw.get('action'), "ReferenceAdjustmentDict.action", ["converted", "reencoded", "downscaled", "first_frame", "transcoded"] as const) }
  get after(): string | undefined { return _readYDocOptionalString(this._raw.get('after'), "ReferenceAdjustmentDict.after") }
  get before(): string | undefined { return _readYDocOptionalString(this._raw.get('before'), "ReferenceAdjustmentDict.before") }
  get index(): number | undefined { return _readYDocOptionalInteger(this._raw.get('index'), "ReferenceAdjustmentDict.index") }
  get kind(): "image" | "video" | "audio" | undefined { return _readYDocOptionalEnum(this._raw.get('kind'), "ReferenceAdjustmentDict.kind", ["image", "video", "audio"] as const) }
}

/** Typed Y.Map wrapper for ResolvedVoiceMapDict. */
export class ResolvedVoiceMapDictYMap extends YMapWrapper {
  get(key: string): string | undefined {
    const value = this._raw.get(key)
    if (value === undefined) return undefined
    const fieldLabel = `${this.constructor.name}.${key}`
    _validateYDocString(value, fieldLabel)
    return _readYDocString(value, fieldLabel)
  }
  set(key: string, value: string): void {
    const fieldLabel = `${this.constructor.name}.${key}`
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocString(validationValue, fieldLabel)
    this._raw.set(key, _toYDocValue(value))
  }
  delete(key: string): void { this._raw.delete(key) }
}

/** Typed Y.Map wrapper for ReviewHistoryEntryDict. */
export class ReviewHistoryEntryDictYMap extends YMapWrapper {
  get accepted(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('accepted'), "ReviewHistoryEntryDict.accepted") }
  get attempt(): number | undefined { return _readYDocOptionalInteger(this._raw.get('attempt'), "ReviewHistoryEntryDict.attempt") }
  get feedback(): string | undefined { return _readYDocOptionalString(this._raw.get('feedback'), "ReviewHistoryEntryDict.feedback") }
  get round(): number | undefined { return _readYDocOptionalInteger(this._raw.get('round'), "ReviewHistoryEntryDict.round") }
}

/** Typed Y.Map wrapper for SceneTextDict. */
export class SceneTextDictYMap extends YMapWrapper {
  get scene_number(): number | undefined { return _readYDocOptionalInteger(this._raw.get('scene_number'), "SceneTextDict.scene_number") }
  get text(): string | undefined { return _readYDocOptionalString(this._raw.get('text'), "SceneTextDict.text") }
}

/** Typed Y.Map wrapper for ScreenplayEntryDict. */
export class ScreenplayEntryDictYMap extends YMapWrapper {
  get character(): string | undefined { return _readYDocOptionalString(this._raw.get('character'), "ScreenplayEntryDict.character") }
  get emotion(): string | undefined { return _readYDocOptionalString(this._raw.get('emotion'), "ScreenplayEntryDict.emotion") }
  get text(): string | undefined { return _readYDocOptionalString(this._raw.get('text'), "ScreenplayEntryDict.text") }
  get type(): string | undefined { return _readYDocOptionalString(this._raw.get('type'), "ScreenplayEntryDict.type") }
  get voice_role_id(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_role_id'), "ScreenplayEntryDict.voice_role_id") }
}

/** Typed Y.Map wrapper for ScreenplayResultDict. */
export class ScreenplayResultDictYMap extends YMapWrapper {
  get error(): string | undefined { return _readYDocOptionalString(this._raw.get('error'), "ScreenplayResultDict.error") }
  get genre_tone(): string | undefined { return _readYDocOptionalString(this._raw.get('genre_tone'), "ScreenplayResultDict.genre_tone") }
  get logline(): string | undefined { return _readYDocOptionalString(this._raw.get('logline'), "ScreenplayResultDict.logline") }
  get scenes(): ScreenplayResultSceneDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('scenes'), "ScreenplayResultDict.scenes", (item, itemLabel) => _readYDocMapWrapper(item, ScreenplayResultSceneDictYMap, itemLabel)) }
  get synopsis(): string | undefined { return _readYDocOptionalString(this._raw.get('synopsis'), "ScreenplayResultDict.synopsis") }
  get themes(): string | undefined { return _readYDocOptionalString(this._raw.get('themes'), "ScreenplayResultDict.themes") }
  get voice_roles(): VoiceRoleDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('voice_roles'), "ScreenplayResultDict.voice_roles", (item, itemLabel) => _readYDocMapWrapper(item, VoiceRoleDictYMap, itemLabel)) }
}

/** Typed Y.Map wrapper for ScreenplayResultSceneDict. */
export class ScreenplayResultSceneDictYMap extends YMapWrapper {
  get characters(): string[] | undefined { return _readYDocOptionalArray(this._raw.get('characters'), "ScreenplayResultSceneDict.characters", (item, itemLabel) => _readYDocString(item, itemLabel)) }
  get entries(): ScreenplayEntryDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('entries'), "ScreenplayResultSceneDict.entries", (item, itemLabel) => _readYDocMapWrapper(item, ScreenplayEntryDictYMap, itemLabel)) }
  get interior_exterior(): string | undefined { return _readYDocOptionalString(this._raw.get('interior_exterior'), "ScreenplayResultSceneDict.interior_exterior") }
  get location(): string | undefined { return _readYDocOptionalString(this._raw.get('location'), "ScreenplayResultSceneDict.location") }
  get scene_number(): number | undefined { return _readYDocOptionalInteger(this._raw.get('scene_number'), "ScreenplayResultSceneDict.scene_number") }
  get time_of_day(): string | undefined { return _readYDocOptionalString(this._raw.get('time_of_day'), "ScreenplayResultSceneDict.time_of_day") }
}

/** Typed Y.Map wrapper for ScriptDialogueDict. */
export class ScriptDialogueDictYMap extends YMapWrapper {
  get character(): string | undefined { return _readYDocOptionalString(this._raw.get('character'), "ScriptDialogueDict.character") }
  get emotion(): string | undefined { return _readYDocOptionalString(this._raw.get('emotion'), "ScriptDialogueDict.emotion") }
  get scene_number(): number | undefined { return _readYDocOptionalInteger(this._raw.get('scene_number'), "ScriptDialogueDict.scene_number") }
  get text(): string | undefined { return _readYDocOptionalString(this._raw.get('text'), "ScriptDialogueDict.text") }
  get type(): string | undefined { return _readYDocOptionalString(this._raw.get('type'), "ScriptDialogueDict.type") }
  get voice_role_id(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_role_id'), "ScriptDialogueDict.voice_role_id") }
}

/** Typed Y.Map wrapper for ScriptScreenplaySceneDict. */
export class ScriptScreenplaySceneDictYMap extends YMapWrapper {
  get characters(): string[] | undefined { return _readYDocOptionalArray(this._raw.get('characters'), "ScriptScreenplaySceneDict.characters", (item, itemLabel) => _readYDocString(item, itemLabel)) }
  get entries(): YMapRecord<string, string>[] | undefined { return _readYDocOptionalArray(this._raw.get('entries'), "ScriptScreenplaySceneDict.entries", (item, itemLabel) => _readYDocMapRecord<string, string>(item, itemLabel, (item, itemLabel) => _readYDocString(item, itemLabel), _lazyYDocValidator(() => (item, itemLabel) => _validateYDocString(item, itemLabel)))) }
  get interior_exterior(): string | undefined { return _readYDocOptionalString(this._raw.get('interior_exterior'), "ScriptScreenplaySceneDict.interior_exterior") }
  get location(): string | undefined { return _readYDocOptionalString(this._raw.get('location'), "ScriptScreenplaySceneDict.location") }
  get scene_number(): number | undefined { return _readYDocOptionalInteger(this._raw.get('scene_number'), "ScriptScreenplaySceneDict.scene_number") }
  get time_of_day(): string | undefined { return _readYDocOptionalString(this._raw.get('time_of_day'), "ScriptScreenplaySceneDict.time_of_day") }
}

/** Typed Y.Map wrapper for ScriptVariantDict. */
export class ScriptVariantDictYMap extends YMapWrapper {
  get created_at(): string | undefined { return _readYDocOptionalString(this._raw.get('created_at'), "ScriptVariantDict.created_at") }
  get genre_tone(): string | undefined { return _readYDocOptionalString(this._raw.get('genre_tone'), "ScriptVariantDict.genre_tone") }
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "ScriptVariantDict.id") }
  get label(): string | undefined { return _readYDocOptionalString(this._raw.get('label'), "ScriptVariantDict.label") }
  get logline(): string | undefined { return _readYDocOptionalString(this._raw.get('logline'), "ScriptVariantDict.logline") }
  get model(): string | undefined { return _readYDocOptionalString(this._raw.get('model'), "ScriptVariantDict.model") }
  get ordinal(): number | undefined { return _readYDocOptionalInteger(this._raw.get('ordinal'), "ScriptVariantDict.ordinal") }
  get scene_count(): number | undefined { return _readYDocOptionalInteger(this._raw.get('scene_count'), "ScriptVariantDict.scene_count") }
  get screenplay(): ScreenplayResultSceneDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('screenplay'), "ScriptVariantDict.screenplay", (item, itemLabel) => _readYDocMapWrapper(item, ScreenplayResultSceneDictYMap, itemLabel)) }
  get script(): string | undefined { return _readYDocOptionalString(this._raw.get('script'), "ScriptVariantDict.script") }
  get synopsis(): string | undefined { return _readYDocOptionalString(this._raw.get('synopsis'), "ScriptVariantDict.synopsis") }
  get themes(): string | undefined { return _readYDocOptionalString(this._raw.get('themes'), "ScriptVariantDict.themes") }
}

/** Typed Y.Map wrapper for ShotFrameJobSlotDict. */
export class ShotFrameJobSlotDictYMap extends YMapWrapper {
  get prompt(): string | undefined { return _readYDocOptionalString(this._raw.get('prompt'), "ShotFrameJobSlotDict.prompt") }
  get role(): "start" | "key" | "end" | undefined { return _readYDocOptionalEnum(this._raw.get('role'), "ShotFrameJobSlotDict.role", ["start", "key", "end"] as const) }
  get shot_id(): string | undefined { return _readYDocOptionalString(this._raw.get('shot_id'), "ShotFrameJobSlotDict.shot_id") }
  get shot_index(): number | undefined { return _readYDocOptionalInteger(this._raw.get('shot_index'), "ShotFrameJobSlotDict.shot_index") }
}

/** Typed Y.Map wrapper for ShotFrameLinkDict. */
export class ShotFrameLinkDictYMap extends YMapWrapper {
  get error(): string | undefined { return _readYDocOptionalString(this._raw.get('error'), "ShotFrameLinkDict.error") }
  get node_id(): string | undefined { return _readYDocOptionalString(this._raw.get('node_id'), "ShotFrameLinkDict.node_id") }
  get role(): "start" | "key" | "end" | undefined { return _readYDocOptionalEnum(this._raw.get('role'), "ShotFrameLinkDict.role", ["start", "key", "end"] as const) }
  get shot_id(): string | undefined { return _readYDocOptionalString(this._raw.get('shot_id'), "ShotFrameLinkDict.shot_id") }
  get shot_index(): number | undefined { return _readYDocOptionalInteger(this._raw.get('shot_index'), "ShotFrameLinkDict.shot_index") }
  get source_fingerprint(): string | undefined { return _readYDocOptionalString(this._raw.get('source_fingerprint'), "ShotFrameLinkDict.source_fingerprint") }
  get status(): "pending" | "ready" | "failed" | "stale" | undefined { return _readYDocOptionalEnum(this._raw.get('status'), "ShotFrameLinkDict.status", ["pending", "ready", "failed", "stale"] as const) }
  get version(): number | undefined { return _readYDocOptionalInteger(this._raw.get('version'), "ShotFrameLinkDict.version") }
}

/** Typed Y.Map wrapper for ShotKeyFrameRelinkDict. */
export class ShotKeyFrameRelinkDictYMap extends YMapWrapper {
  get image(): string | undefined { return _readYDocOptionalString(this._raw.get('image'), "ShotKeyFrameRelinkDict.image") }
  get shot_id(): string | undefined { return _readYDocOptionalString(this._raw.get('shot_id'), "ShotKeyFrameRelinkDict.shot_id") }
}

/** Typed Y.Map wrapper for ShotListChoiceV2Dict. */
export class ShotListChoiceV2DictYMap extends YMapWrapper {
  get custom(): string | undefined { return _readYDocOptionalString(this._raw.get('custom'), "ShotListChoiceV2Dict.custom") }
  get preset_id(): string | undefined { return _readYDocOptionalString(this._raw.get('preset_id'), "ShotListChoiceV2Dict.preset_id") }
}

/** Typed Y.Map wrapper for ShotListFramingPresetCatalog. */
export class ShotListFramingPresetCatalogYMap extends YMapWrapper {
  get angle(): "Eye-Level" | "Low-Angle" | "High-Angle" | "Dutch Tilt" | "Over-the-Shoulder" | undefined { return _readYDocOptionalEnum(this._raw.get('angle'), "ShotListFramingPresetCatalog.angle", ["Eye-Level", "Low-Angle", "High-Angle", "Dutch Tilt", "Over-the-Shoulder"] as const) }
  get focus(): "Shallow Focus" | "Medium Focus" | "Deep Focus" | undefined { return _readYDocOptionalEnum(this._raw.get('focus'), "ShotListFramingPresetCatalog.focus", ["Shallow Focus", "Medium Focus", "Deep Focus"] as const) }
  get lens(): "24 mm / f2.8" | "35 mm / f2.8" | "50 mm / f2.2" | "85 mm / f1.8" | undefined { return _readYDocOptionalEnum(this._raw.get('lens'), "ShotListFramingPresetCatalog.lens", ["24 mm / f2.8", "35 mm / f2.8", "50 mm / f2.2", "85 mm / f1.8"] as const) }
  get shot(): "WS (Wide Shot)" | "MS (Medium Shot)" | "CU (Close-Up)" | "OTS" | "POV" | "ECU (Extreme Close-Up)" | undefined { return _readYDocOptionalEnum(this._raw.get('shot'), "ShotListFramingPresetCatalog.shot", ["WS (Wide Shot)", "MS (Medium Shot)", "CU (Close-Up)", "OTS", "POV", "ECU (Extreme Close-Up)"] as const) }
}

/** Typed Y.Map wrapper for ShotListFramingV2Dict. */
export class ShotListFramingV2DictYMap extends YMapWrapper {
  get angle(): ShotListChoiceV2DictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('angle'), ShotListChoiceV2DictYMap, "ShotListFramingV2Dict.angle") }
  setAngle(value: ShotListChoiceV2Dict): void {
    const fieldLabel = "ShotListFramingV2Dict.angle"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocMap(validationValue, fieldLabel, _YDOC_MAP_SPEC_17)
    this._raw.set('angle', _toYDocValue(value))
  }
  deleteAngle(): void { this._raw.delete('angle') }
  get focus(): ShotListChoiceV2DictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('focus'), ShotListChoiceV2DictYMap, "ShotListFramingV2Dict.focus") }
  setFocus(value: ShotListChoiceV2Dict): void {
    const fieldLabel = "ShotListFramingV2Dict.focus"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocMap(validationValue, fieldLabel, _YDOC_MAP_SPEC_17)
    this._raw.set('focus', _toYDocValue(value))
  }
  deleteFocus(): void { this._raw.delete('focus') }
  get lens(): ShotListLensV2DictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('lens'), ShotListLensV2DictYMap, "ShotListFramingV2Dict.lens") }
  setLens(value: ShotListLensV2Dict): void {
    const fieldLabel = "ShotListFramingV2Dict.lens"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocMap(validationValue, fieldLabel, _YDOC_MAP_SPEC_18)
    this._raw.set('lens', _toYDocValue(value))
  }
  deleteLens(): void { this._raw.delete('lens') }
  get shot(): ShotListChoiceV2DictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('shot'), ShotListChoiceV2DictYMap, "ShotListFramingV2Dict.shot") }
  setShot(value: ShotListChoiceV2Dict): void {
    const fieldLabel = "ShotListFramingV2Dict.shot"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocMap(validationValue, fieldLabel, _YDOC_MAP_SPEC_17)
    this._raw.set('shot', _toYDocValue(value))
  }
  deleteShot(): void { this._raw.delete('shot') }
}

/** Typed Y.Map wrapper for ShotListLensV2Dict. */
export class ShotListLensV2DictYMap extends YMapWrapper {
  get aperture_f_number(): number | undefined { return _readYDocOptionalNumber(this._raw.get('aperture_f_number'), "ShotListLensV2Dict.aperture_f_number", 0) }
  get focal_length_mm(): number | undefined { return _readYDocOptionalInteger(this._raw.get('focal_length_mm'), "ShotListLensV2Dict.focal_length_mm") }
  get preset_id(): string | undefined { return _readYDocOptionalString(this._raw.get('preset_id'), "ShotListLensV2Dict.preset_id") }
}

/** Typed Y.Map wrapper for ShotListRowDict. */
export class ShotListRowDictYMap extends YMapWrapper {
  get camera_movement(): string | undefined { return _readYDocOptionalString(this._raw.get('camera_movement'), "ShotListRowDict.camera_movement") }
  setCameraMovement(value: string): void {
    const fieldLabel = "ShotListRowDict.camera_movement"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocString(validationValue, fieldLabel)
    this._raw.set('camera_movement', _toYDocValue(value))
  }
  deleteCameraMovement(): void { this._raw.delete('camera_movement') }
  get dialogue_voiceover(): string | undefined { return _readYDocOptionalString(this._raw.get('dialogue_voiceover'), "ShotListRowDict.dialogue_voiceover") }
  setDialogueVoiceover(value: string): void {
    const fieldLabel = "ShotListRowDict.dialogue_voiceover"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocString(validationValue, fieldLabel)
    this._raw.set('dialogue_voiceover', _toYDocValue(value))
  }
  deleteDialogueVoiceover(): void { this._raw.delete('dialogue_voiceover') }
  get duration_ms(): number | undefined { return _readYDocOptionalInteger(this._raw.get('duration_ms'), "ShotListRowDict.duration_ms") }
  setDurationMs(value: number): void {
    const fieldLabel = "ShotListRowDict.duration_ms"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocInteger(validationValue, fieldLabel, undefined, 1)
    this._raw.set('duration_ms', _toYDocValue(value))
  }
  get framing_angle(): string | undefined { return _readYDocOptionalString(this._raw.get('framing_angle'), "ShotListRowDict.framing_angle") }
  setFramingAngle(value: string): void {
    const fieldLabel = "ShotListRowDict.framing_angle"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocString(validationValue, fieldLabel)
    this._raw.set('framing_angle', _toYDocValue(value))
  }
  deleteFramingAngle(): void { this._raw.delete('framing_angle') }
  get framing_focus(): string | undefined { return _readYDocOptionalString(this._raw.get('framing_focus'), "ShotListRowDict.framing_focus") }
  setFramingFocus(value: string): void {
    const fieldLabel = "ShotListRowDict.framing_focus"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocString(validationValue, fieldLabel)
    this._raw.set('framing_focus', _toYDocValue(value))
  }
  deleteFramingFocus(): void { this._raw.delete('framing_focus') }
  get framing_lens(): string | undefined { return _readYDocOptionalString(this._raw.get('framing_lens'), "ShotListRowDict.framing_lens") }
  setFramingLens(value: string): void {
    const fieldLabel = "ShotListRowDict.framing_lens"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocString(validationValue, fieldLabel)
    this._raw.set('framing_lens', _toYDocValue(value))
  }
  deleteFramingLens(): void { this._raw.delete('framing_lens') }
  get framing_shot(): string | undefined { return _readYDocOptionalString(this._raw.get('framing_shot'), "ShotListRowDict.framing_shot") }
  setFramingShot(value: string): void {
    const fieldLabel = "ShotListRowDict.framing_shot"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocString(validationValue, fieldLabel)
    this._raw.set('framing_shot', _toYDocValue(value))
  }
  deleteFramingShot(): void { this._raw.delete('framing_shot') }
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "ShotListRowDict.id") }
  get location(): string | undefined { return _readYDocOptionalString(this._raw.get('location'), "ShotListRowDict.location") }
  setLocation(value: string): void {
    const fieldLabel = "ShotListRowDict.location"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocString(validationValue, fieldLabel)
    this._raw.set('location', _toYDocValue(value))
  }
  deleteLocation(): void { this._raw.delete('location') }
  get scene_ordinal(): number | undefined { return _readYDocOptionalInteger(this._raw.get('scene_ordinal'), "ShotListRowDict.scene_ordinal") }
  get sfx(): string | undefined { return _readYDocOptionalString(this._raw.get('sfx'), "ShotListRowDict.sfx") }
  setSfx(value: string): void {
    const fieldLabel = "ShotListRowDict.sfx"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocString(validationValue, fieldLabel)
    this._raw.set('sfx', _toYDocValue(value))
  }
  deleteSfx(): void { this._raw.delete('sfx') }
  get shot_number(): string | undefined { return _readYDocOptionalString(this._raw.get('shot_number'), "ShotListRowDict.shot_number") }
  get transition_in(): string | undefined { return _readYDocOptionalString(this._raw.get('transition_in'), "ShotListRowDict.transition_in") }
  setTransitionIn(value: string): void {
    const fieldLabel = "ShotListRowDict.transition_in"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocString(validationValue, fieldLabel)
    this._raw.set('transition_in', _toYDocValue(value))
  }
  deleteTransitionIn(): void { this._raw.delete('transition_in') }
  get transition_out(): string | undefined { return _readYDocOptionalString(this._raw.get('transition_out'), "ShotListRowDict.transition_out") }
  setTransitionOut(value: string): void {
    const fieldLabel = "ShotListRowDict.transition_out"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocString(validationValue, fieldLabel)
    this._raw.set('transition_out', _toYDocValue(value))
  }
  deleteTransitionOut(): void { this._raw.delete('transition_out') }
  get visual_description(): string | undefined { return _readYDocOptionalString(this._raw.get('visual_description'), "ShotListRowDict.visual_description") }
  setVisualDescription(value: string): void {
    const fieldLabel = "ShotListRowDict.visual_description"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocString(validationValue, fieldLabel)
    this._raw.set('visual_description', _toYDocValue(value))
  }
}

/** Typed Y.Map wrapper for ShotProductionChangeDict. */
export class ShotProductionChangeDictYMap extends YMapWrapper {
  get account(): string | undefined { return _readYDocOptionalString(this._raw.get('account'), "ShotProductionChangeDict.account") }
  get element_id(): string | undefined { return _readYDocOptionalString(this._raw.get('element_id'), "ShotProductionChangeDict.element_id") }
  get owner(): "on_screen" | "off_screen" | undefined { return _readYDocOptionalEnum(this._raw.get('owner'), "ShotProductionChangeDict.owner", ["on_screen", "off_screen"] as const) }
  get value(): string | undefined { return _readYDocOptionalString(this._raw.get('value'), "ShotProductionChangeDict.value") }
}

/** Typed Y.Map wrapper for ShotProductionPlanDict. */
export class ShotProductionPlanDictYMap extends YMapWrapper {
  get baseline_generation_id(): string | undefined { return _readYDocOptionalString(this._raw.get('baseline_generation_id'), "ShotProductionPlanDict.baseline_generation_id") }
  get pending_decisions(): string[] | undefined { return _readYDocOptionalArray(this._raw.get('pending_decisions'), "ShotProductionPlanDict.pending_decisions", (item, itemLabel) => _readYDocString(item, itemLabel)) }
  get planning_status(): "DRAFT" | "PROMPT-COMPLETE" | undefined { return _readYDocOptionalEnum(this._raw.get('planning_status'), "ShotProductionPlanDict.planning_status", ["DRAFT", "PROMPT-COMPLETE"] as const) }
  get production_job_id(): string | undefined { return _readYDocOptionalString(this._raw.get('production_job_id'), "ShotProductionPlanDict.production_job_id") }
  get render_blockers(): string[] | undefined { return _readYDocOptionalArray(this._raw.get('render_blockers'), "ShotProductionPlanDict.render_blockers", (item, itemLabel) => _readYDocString(item, itemLabel)) }
  get render_readiness(): "BLOCKED" | undefined { return _readYDocOptionalEnum(this._raw.get('render_readiness'), "ShotProductionPlanDict.render_readiness", ["BLOCKED"] as const) }
  get scenes(): ShotProductionSceneProposalDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('scenes'), "ShotProductionPlanDict.scenes", (item, itemLabel) => _readYDocMapWrapper(item, ShotProductionSceneProposalDictYMap, itemLabel)) }
  get screenplay_fingerprint(): string | undefined { return _readYDocOptionalString(this._raw.get('screenplay_fingerprint'), "ShotProductionPlanDict.screenplay_fingerprint") }
  get seams(): ShotProductionSeamProposalDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('seams'), "ShotProductionPlanDict.seams", (item, itemLabel) => _readYDocMapWrapper(item, ShotProductionSeamProposalDictYMap, itemLabel)) }
  get shots(): ShotProductionShotDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('shots'), "ShotProductionPlanDict.shots", (item, itemLabel) => _readYDocMapWrapper(item, ShotProductionShotDictYMap, itemLabel)) }
  get version(): 1 | undefined { return _readYDocOptionalEnum(this._raw.get('version'), "ShotProductionPlanDict.version", [1] as const) }
}

/** Typed Y.Map wrapper for ShotProductionProposalDict. */
export class ShotProductionProposalDictYMap extends YMapWrapper {
  get pending_decisions(): string[] | undefined { return _readYDocOptionalArray(this._raw.get('pending_decisions'), "ShotProductionProposalDict.pending_decisions", (item, itemLabel) => _readYDocString(item, itemLabel)) }
  get scenes(): ShotProductionSceneProposalDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('scenes'), "ShotProductionProposalDict.scenes", (item, itemLabel) => _readYDocMapWrapper(item, ShotProductionSceneProposalDictYMap, itemLabel)) }
  get seams(): ShotProductionSeamProposalDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('seams'), "ShotProductionProposalDict.seams", (item, itemLabel) => _readYDocMapWrapper(item, ShotProductionSeamProposalDictYMap, itemLabel)) }
  get shots(): ShotProductionShotProposalDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('shots'), "ShotProductionProposalDict.shots", (item, itemLabel) => _readYDocMapWrapper(item, ShotProductionShotProposalDictYMap, itemLabel)) }
}

/** Typed Y.Map wrapper for ShotProductionSceneProposalDict. */
export class ShotProductionSceneProposalDictYMap extends YMapWrapper {
  get scene_ordinal(): number | undefined { return _readYDocOptionalInteger(this._raw.get('scene_ordinal'), "ShotProductionSceneProposalDict.scene_ordinal") }
  get strand_id(): string | undefined { return _readYDocOptionalString(this._raw.get('strand_id'), "ShotProductionSceneProposalDict.strand_id") }
}

/** Typed Y.Map wrapper for ShotProductionSeamProposalDict. */
export class ShotProductionSeamProposalDictYMap extends YMapWrapper {
  get carrier(): string | undefined { return _readYDocOptionalString(this._raw.get('carrier'), "ShotProductionSeamProposalDict.carrier") }
  get cut_point(): string | undefined { return _readYDocOptionalString(this._raw.get('cut_point'), "ShotProductionSeamProposalDict.cut_point") }
  get execution(): string | undefined { return _readYDocOptionalString(this._raw.get('execution'), "ShotProductionSeamProposalDict.execution") }
  get motivation(): string | undefined { return _readYDocOptionalString(this._raw.get('motivation'), "ShotProductionSeamProposalDict.motivation") }
  get seam_id(): string | undefined { return _readYDocOptionalString(this._raw.get('seam_id'), "ShotProductionSeamProposalDict.seam_id") }
  get time_relation(): "continuous" | "simultaneous" | "elapsed" | "unknown" | undefined { return _readYDocOptionalEnum(this._raw.get('time_relation'), "ShotProductionSeamProposalDict.time_relation", ["continuous", "simultaneous", "elapsed", "unknown"] as const) }
}

/** Typed Y.Map wrapper for ShotProductionShotDict. */
export class ShotProductionShotDictYMap extends YMapWrapper {
  get action(): string | undefined { return _readYDocOptionalString(this._raw.get('action'), "ShotProductionShotDict.action") }
  get audio_route(): "SILENT" | "SEPARATE" | "TBC" | undefined { return _readYDocOptionalEnum(this._raw.get('audio_route'), "ShotProductionShotDict.audio_route", ["SILENT", "SEPARATE", "TBC"] as const) }
  get changes(): ShotProductionChangeDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('changes'), "ShotProductionShotDict.changes", (item, itemLabel) => _readYDocMapWrapper(item, ShotProductionChangeDictYMap, itemLabel)) }
  get flow(): string | undefined { return _readYDocOptionalString(this._raw.get('flow'), "ShotProductionShotDict.flow") }
  get keyframe_prompt(): string | undefined { return _readYDocOptionalString(this._raw.get('keyframe_prompt'), "ShotProductionShotDict.keyframe_prompt") }
  get ledger_in(): ShotProductionStateDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('ledger_in'), "ShotProductionShotDict.ledger_in", (item, itemLabel) => _readYDocMapWrapper(item, ShotProductionStateDictYMap, itemLabel)) }
  get ledger_out(): ShotProductionStateDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('ledger_out'), "ShotProductionShotDict.ledger_out", (item, itemLabel) => _readYDocMapWrapper(item, ShotProductionStateDictYMap, itemLabel)) }
  get motion_prompt(): string | undefined { return _readYDocOptionalString(this._raw.get('motion_prompt'), "ShotProductionShotDict.motion_prompt") }
  get scene_ordinal(): number | undefined { return _readYDocOptionalInteger(this._raw.get('scene_ordinal'), "ShotProductionShotDict.scene_ordinal") }
  get shot_id(): string | undefined { return _readYDocOptionalString(this._raw.get('shot_id'), "ShotProductionShotDict.shot_id") }
  get source(): ShotProductionSourceDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('source'), "ShotProductionShotDict.source", (item, itemLabel) => _readYDocMapWrapper(item, ShotProductionSourceDictYMap, itemLabel)) }
  get strand_id(): string | undefined { return _readYDocOptionalString(this._raw.get('strand_id'), "ShotProductionShotDict.strand_id") }
}

/** Typed Y.Map wrapper for ShotProductionShotProposalDict. */
export class ShotProductionShotProposalDictYMap extends YMapWrapper {
  get action(): string | undefined { return _readYDocOptionalString(this._raw.get('action'), "ShotProductionShotProposalDict.action") }
  get changes(): ShotProductionChangeDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('changes'), "ShotProductionShotProposalDict.changes", (item, itemLabel) => _readYDocMapWrapper(item, ShotProductionChangeDictYMap, itemLabel)) }
  get flow(): string | undefined { return _readYDocOptionalString(this._raw.get('flow'), "ShotProductionShotProposalDict.flow") }
  get keyframe_prompt(): string | undefined { return _readYDocOptionalString(this._raw.get('keyframe_prompt'), "ShotProductionShotProposalDict.keyframe_prompt") }
  get motion_prompt(): string | undefined { return _readYDocOptionalString(this._raw.get('motion_prompt'), "ShotProductionShotProposalDict.motion_prompt") }
  get shot_id(): string | undefined { return _readYDocOptionalString(this._raw.get('shot_id'), "ShotProductionShotProposalDict.shot_id") }
  get source_refs(): string[] | undefined { return _readYDocOptionalArray(this._raw.get('source_refs'), "ShotProductionShotProposalDict.source_refs", (item, itemLabel) => _readYDocString(item, itemLabel)) }
}

/** Typed Y.Map wrapper for ShotProductionSourceDict. */
export class ShotProductionSourceDictYMap extends YMapWrapper {
  get entry_type(): string | undefined { return _readYDocOptionalString(this._raw.get('entry_type'), "ShotProductionSourceDict.entry_type") }
  get ref(): string | undefined { return _readYDocOptionalString(this._raw.get('ref'), "ShotProductionSourceDict.ref") }
  get speaker(): string | undefined { return _readYDocOptionalString(this._raw.get('speaker'), "ShotProductionSourceDict.speaker") }
  get text(): string | undefined { return _readYDocOptionalString(this._raw.get('text'), "ShotProductionSourceDict.text") }
}

/** Typed Y.Map wrapper for ShotProductionStateDict. */
export class ShotProductionStateDictYMap extends YMapWrapper {
  get element_id(): string | undefined { return _readYDocOptionalString(this._raw.get('element_id'), "ShotProductionStateDict.element_id") }
  get truth(): "SUPPLIED" | "PROPOSED" | "TBC" | undefined { return _readYDocOptionalEnum(this._raw.get('truth'), "ShotProductionStateDict.truth", ["SUPPLIED", "PROPOSED", "TBC"] as const) }
  get value(): string | undefined { return _readYDocOptionalString(this._raw.get('value'), "ShotProductionStateDict.value") }
}

/** Typed Y.Map wrapper for ShotSeamDict. */
export class ShotSeamDictYMap extends YMapWrapper {
  get boundary_type(): "Continuous" | "Soft" | "Hard" | undefined { return _readYDocOptionalEnum(this._raw.get('boundary_type'), "ShotSeamDict.boundary_type", ["Continuous", "Soft", "Hard"] as const) }
  setBoundaryType(value: "Continuous" | "Soft" | "Hard"): void {
    const fieldLabel = "ShotSeamDict.boundary_type"
    const validationValue = _attachYDocValidationCandidate(value)
    _readYDocEnum(validationValue, fieldLabel, ["Continuous", "Soft", "Hard"] as const)
    this._raw.set('boundary_type', _toYDocValue(value))
  }
  deleteBoundaryType(): void { this._raw.delete('boundary_type') }
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "ShotSeamDict.id") }
  get motivation(): string | undefined { return _readYDocOptionalString(this._raw.get('motivation'), "ShotSeamDict.motivation") }
  get transition(): string | undefined { return _readYDocOptionalString(this._raw.get('transition'), "ShotSeamDict.transition") }
  setTransition(value: string): void {
    const fieldLabel = "ShotSeamDict.transition"
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocString(validationValue, fieldLabel)
    this._raw.set('transition', _toYDocValue(value))
  }
}

/** Typed Y.Map wrapper for ShotVideoAnchorDict. */
export class ShotVideoAnchorDictYMap extends YMapWrapper {
  get exact(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('exact'), "ShotVideoAnchorDict.exact") }
  get image(): string | undefined { return _readYDocOptionalString(this._raw.get('image'), "ShotVideoAnchorDict.image") }
  get origin(): "user_relink" | undefined { return _readYDocOptionalEnum(this._raw.get('origin'), "ShotVideoAnchorDict.origin", ["user_relink"] as const) }
  get role(): "first" | "last" | undefined { return _readYDocOptionalEnum(this._raw.get('role'), "ShotVideoAnchorDict.role", ["first", "last"] as const) }
  get shot_id(): string | undefined { return _readYDocOptionalString(this._raw.get('shot_id'), "ShotVideoAnchorDict.shot_id") }
}

/** Typed Y.Map wrapper for ShotVideoAudioReferenceDict. */
export class ShotVideoAudioReferenceDictYMap extends YMapWrapper {
  get asset_path(): string | undefined { return _readYDocOptionalString(this._raw.get('asset_path'), "ShotVideoAudioReferenceDict.asset_path") }
  get node_id(): string | undefined { return _readYDocOptionalString(this._raw.get('node_id'), "ShotVideoAudioReferenceDict.node_id") }
  get port(): string | undefined { return _readYDocOptionalString(this._raw.get('port'), "ShotVideoAudioReferenceDict.port") }
  get speaker(): string | undefined { return _readYDocOptionalString(this._raw.get('speaker'), "ShotVideoAudioReferenceDict.speaker") }
}

/** Typed Y.Map wrapper for ShotVideoAutoReferenceDecisionDict. */
export class ShotVideoAutoReferenceDecisionDictYMap extends YMapWrapper {
  get node_id(): string | undefined { return _readYDocOptionalString(this._raw.get('node_id'), "ShotVideoAutoReferenceDecisionDict.node_id") }
  get reason(): string | undefined { return _readYDocOptionalString(this._raw.get('reason'), "ShotVideoAutoReferenceDecisionDict.reason") }
}

/** Typed Y.Map wrapper for ShotVideoGenerationPlanDict. */
export class ShotVideoGenerationPlanDictYMap extends YMapWrapper {
  get asset_paths(): YMapRecord<string, string> | undefined { return _readYDocOptionalMapRecord<string, string>(this._raw.get('asset_paths'), "ShotVideoGenerationPlanDict.asset_paths", (item, itemLabel) => _readYDocString(item, itemLabel), _lazyYDocValidator(() => (item, itemLabel) => _validateYDocString(item, itemLabel))) }
  get excluded_visual_reference_ids(): string[] | undefined { return _readYDocOptionalArray(this._raw.get('excluded_visual_reference_ids'), "ShotVideoGenerationPlanDict.excluded_visual_reference_ids", (item, itemLabel) => _readYDocString(item, itemLabel)) }
  get excluded_voice_reference_ids(): string[] | undefined { return _readYDocOptionalArray(this._raw.get('excluded_voice_reference_ids'), "ShotVideoGenerationPlanDict.excluded_voice_reference_ids", (item, itemLabel) => _readYDocString(item, itemLabel)) }
  get packs(): ShotVideoPackDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('packs'), "ShotVideoGenerationPlanDict.packs", (item, itemLabel) => _readYDocMapWrapper(item, ShotVideoPackDictYMap, itemLabel)) }
  get reference_candidate_fingerprint(): string | undefined { return _readYDocOptionalString(this._raw.get('reference_candidate_fingerprint'), "ShotVideoGenerationPlanDict.reference_candidate_fingerprint") }
  get request_fingerprint(): string | undefined { return _readYDocOptionalString(this._raw.get('request_fingerprint'), "ShotVideoGenerationPlanDict.request_fingerprint") }
  get source_fingerprint(): string | undefined { return _readYDocOptionalString(this._raw.get('source_fingerprint'), "ShotVideoGenerationPlanDict.source_fingerprint") }
  get source_generation_id(): string | undefined { return _readYDocOptionalString(this._raw.get('source_generation_id'), "ShotVideoGenerationPlanDict.source_generation_id") }
  get source_key_frames(): YMapRecord<string, string> | undefined { return _readYDocOptionalMapRecord<string, string>(this._raw.get('source_key_frames'), "ShotVideoGenerationPlanDict.source_key_frames", (item, itemLabel) => _readYDocString(item, itemLabel), _lazyYDocValidator(() => (item, itemLabel) => _validateYDocString(item, itemLabel))) }
  get source_seams(): ShotSeamDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('source_seams'), "ShotVideoGenerationPlanDict.source_seams", (item, itemLabel) => _readYDocMapWrapper(item, ShotSeamDictYMap, itemLabel)) }
  get source_shots(): GeneratedShotRowV2DictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('source_shots'), "ShotVideoGenerationPlanDict.source_shots", (item, itemLabel) => _readYDocMapWrapper(item, GeneratedShotRowV2DictYMap, itemLabel)) }
  get speech_policy(): "screenplay_units_v1" | undefined { return _readYDocOptionalEnum(this._raw.get('speech_policy'), "ShotVideoGenerationPlanDict.speech_policy", ["screenplay_units_v1"] as const) }
  get speech_source_fingerprint(): string | undefined { return _readYDocOptionalString(this._raw.get('speech_source_fingerprint'), "ShotVideoGenerationPlanDict.speech_source_fingerprint") }
  get version(): 1 | 2 | 3 | undefined { return _readYDocOptionalEnum(this._raw.get('version'), "ShotVideoGenerationPlanDict.version", [1, 2, 3] as const) }
  get voice_candidate_fingerprint(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_candidate_fingerprint'), "ShotVideoGenerationPlanDict.voice_candidate_fingerprint") }
  get voice_policy(): "screenplay_units" | "disabled" | "no_screenplay_evidence" | undefined { return _readYDocOptionalEnum(this._raw.get('voice_policy'), "ShotVideoGenerationPlanDict.voice_policy", ["screenplay_units", "disabled", "no_screenplay_evidence"] as const) }
}

/** Typed Y.Map wrapper for ShotVideoPackDict. */
export class ShotVideoPackDictYMap extends YMapWrapper {
  get audio_references(): ShotVideoAudioReferenceDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('audio_references'), "ShotVideoPackDict.audio_references", (item, itemLabel) => _readYDocMapWrapper(item, ShotVideoAudioReferenceDictYMap, itemLabel)) }
  get authoring_fingerprint(): string | undefined { return _readYDocOptionalString(this._raw.get('authoring_fingerprint'), "ShotVideoPackDict.authoring_fingerprint") }
  get auto_references(): string[] | undefined { return _readYDocOptionalArray(this._raw.get('auto_references'), "ShotVideoPackDict.auto_references", (item, itemLabel) => _readYDocString(item, itemLabel)) }
  get cut_reason(): string | undefined { return _readYDocOptionalString(this._raw.get('cut_reason'), "ShotVideoPackDict.cut_reason") }
  get duration_ms(): number | undefined { return _readYDocOptionalInteger(this._raw.get('duration_ms'), "ShotVideoPackDict.duration_ms") }
  get exact_first(): string | undefined { return _readYDocOptionalString(this._raw.get('exact_first'), "ShotVideoPackDict.exact_first") }
  get exact_last(): string | undefined { return _readYDocOptionalString(this._raw.get('exact_last'), "ShotVideoPackDict.exact_last") }
  get generation_id(): number | undefined { return _readYDocOptionalInteger(this._raw.get('generation_id'), "ShotVideoPackDict.generation_id") }
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "ShotVideoPackDict.id") }
  get master_frames(): string[] | undefined { return _readYDocOptionalArray(this._raw.get('master_frames'), "ShotVideoPackDict.master_frames", (item, itemLabel) => _readYDocString(item, itemLabel)) }
  get mixed_video_node_id(): string | undefined { return _readYDocOptionalString(this._raw.get('mixed_video_node_id'), "ShotVideoPackDict.mixed_video_node_id") }
  get mode(): string | undefined { return _readYDocOptionalString(this._raw.get('mode'), "ShotVideoPackDict.mode") }
  get model(): string | undefined { return _readYDocOptionalString(this._raw.get('model'), "ShotVideoPackDict.model") }
  get predecessor_id(): string | undefined { return _readYDocOptionalString(this._raw.get('predecessor_id'), "ShotVideoPackDict.predecessor_id") }
  get prompt_only_master_frames(): string[] | undefined { return _readYDocOptionalArray(this._raw.get('prompt_only_master_frames'), "ShotVideoPackDict.prompt_only_master_frames", (item, itemLabel) => _readYDocString(item, itemLabel)) }
  get references(): string[] | undefined { return _readYDocOptionalArray(this._raw.get('references'), "ShotVideoPackDict.references", (item, itemLabel) => _readYDocString(item, itemLabel)) }
  get resolution(): string | undefined { return _readYDocOptionalString(this._raw.get('resolution'), "ShotVideoPackDict.resolution") }
  get reused_request_fingerprint(): string | undefined { return _readYDocOptionalString(this._raw.get('reused_request_fingerprint'), "ShotVideoPackDict.reused_request_fingerprint") }
  get reused_source_fingerprint(): string | undefined { return _readYDocOptionalString(this._raw.get('reused_source_fingerprint'), "ShotVideoPackDict.reused_source_fingerprint") }
  get shot_ids(): string[] | undefined { return _readYDocOptionalArray(this._raw.get('shot_ids'), "ShotVideoPackDict.shot_ids", (item, itemLabel) => _readYDocString(item, itemLabel)) }
  get skipped_auto_references(): ShotVideoAutoReferenceDecisionDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('skipped_auto_references'), "ShotVideoPackDict.skipped_auto_references", (item, itemLabel) => _readYDocMapWrapper(item, ShotVideoAutoReferenceDecisionDictYMap, itemLabel)) }
  get skipped_voice_references(): ShotVideoVoiceDecisionDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('skipped_voice_references'), "ShotVideoPackDict.skipped_voice_references", (item, itemLabel) => _readYDocMapWrapper(item, ShotVideoVoiceDecisionDictYMap, itemLabel)) }
  get speech_node_ids(): string[] | undefined { return _readYDocOptionalArray(this._raw.get('speech_node_ids'), "ShotVideoPackDict.speech_node_ids", (item, itemLabel) => _readYDocString(item, itemLabel)) }
  get video_node_id(): string | undefined { return _readYDocOptionalString(this._raw.get('video_node_id'), "ShotVideoPackDict.video_node_id") }
  get voice_references(): ShotVideoVoiceReferenceDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('voice_references'), "ShotVideoPackDict.voice_references", (item, itemLabel) => _readYDocMapWrapper(item, ShotVideoVoiceReferenceDictYMap, itemLabel)) }
}

/** Typed Y.Map wrapper for ShotVideoRenderSourcesDict. */
export class ShotVideoRenderSourcesDictYMap extends YMapWrapper {
  get(key: string): string | undefined {
    const value = this._raw.get(key)
    if (value === undefined) return undefined
    const fieldLabel = `${this.constructor.name}.${key}`
    _validateYDocString(value, fieldLabel)
    return _readYDocString(value, fieldLabel)
  }
  set(key: string, value: string): void {
    const fieldLabel = `${this.constructor.name}.${key}`
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocString(validationValue, fieldLabel)
    this._raw.set(key, _toYDocValue(value))
  }
  delete(key: string): void { this._raw.delete(key) }
}

/** Typed Y.Map wrapper for ShotVideoVoiceDecisionDict. */
export class ShotVideoVoiceDecisionDictYMap extends YMapWrapper {
  get node_id(): string | undefined { return _readYDocOptionalString(this._raw.get('node_id'), "ShotVideoVoiceDecisionDict.node_id") }
  get reason(): string | undefined { return _readYDocOptionalString(this._raw.get('reason'), "ShotVideoVoiceDecisionDict.reason") }
  get speaker(): string | undefined { return _readYDocOptionalString(this._raw.get('speaker'), "ShotVideoVoiceDecisionDict.speaker") }
}

/** Typed Y.Map wrapper for ShotVideoVoiceReferenceDict. */
export class ShotVideoVoiceReferenceDictYMap extends YMapWrapper {
  get brief_sha256(): string | undefined { return _readYDocOptionalString(this._raw.get('brief_sha256'), "ShotVideoVoiceReferenceDict.brief_sha256") }
  get node_id(): string | undefined { return _readYDocOptionalString(this._raw.get('node_id'), "ShotVideoVoiceReferenceDict.node_id") }
  get port(): string | undefined { return _readYDocOptionalString(this._raw.get('port'), "ShotVideoVoiceReferenceDict.port") }
  get speaker(): string | undefined { return _readYDocOptionalString(this._raw.get('speaker'), "ShotVideoVoiceReferenceDict.speaker") }
}

/** Typed Y.Map wrapper for SoundAudioHistoryEntryDict. */
export class SoundAudioHistoryEntryDictYMap extends YMapWrapper {
  get metadata(): SoundGenerationMetadataDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('metadata'), SoundGenerationMetadataDictYMap, "SoundAudioHistoryEntryDict.metadata") }
  get result(): _SoundAudioResultDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('result'), _SoundAudioResultDictYMap, "SoundAudioHistoryEntryDict.result") }
  get user_prompt(): string | undefined { return _readYDocOptionalString(this._raw.get('user_prompt'), "SoundAudioHistoryEntryDict.user_prompt") }
  get voice_profile(): VoiceProfileDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('voice_profile'), VoiceProfileDictYMap, "SoundAudioHistoryEntryDict.voice_profile") }
}

/** Typed Y.Map wrapper for SoundGeneratedAudioDict. */
export class SoundGeneratedAudioDictYMap extends YMapWrapper {
  get history(): SoundAudioHistoryEntryDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('history'), "SoundGeneratedAudioDict.history", (item, itemLabel) => _readYDocMapWrapper(item, SoundAudioHistoryEntryDictYMap, itemLabel)) }
  get picked_index(): number | undefined { return _readYDocOptionalInteger(this._raw.get('picked_index'), "SoundGeneratedAudioDict.picked_index") }
}

/** Typed Y.Map wrapper for SoundGenerationMetadataDict. */
export class SoundGenerationMetadataDictYMap extends YMapWrapper {
  get character_name(): string | undefined { return _readYDocOptionalString(this._raw.get('character_name'), "SoundGenerationMetadataDict.character_name") }
  get duration_seconds(): number | undefined { return _readYDocOptionalNumber(this._raw.get('duration_seconds'), "SoundGenerationMetadataDict.duration_seconds") }
  get loop(): string | undefined { return _readYDocOptionalString(this._raw.get('loop'), "SoundGenerationMetadataDict.loop") }
  get lyrics_mode(): "auto" | "custom" | "instrumental" | undefined { return _readYDocOptionalEnum(this._raw.get('lyrics_mode'), "SoundGenerationMetadataDict.lyrics_mode", ["auto", "custom", "instrumental"] as const) }
  get mode(): string | undefined { return _readYDocOptionalString(this._raw.get('mode'), "SoundGenerationMetadataDict.mode") }
  get model(): string | undefined { return _readYDocOptionalString(this._raw.get('model'), "SoundGenerationMetadataDict.model") }
  get provider(): string | undefined { return _readYDocOptionalString(this._raw.get('provider'), "SoundGenerationMetadataDict.provider") }
  get segment_start_times(): number[] | undefined { return _readYDocOptionalArray(this._raw.get('segment_start_times'), "SoundGenerationMetadataDict.segment_start_times", (item, itemLabel) => _readYDocNumber(item, itemLabel)) }
  get segments(): number | undefined { return _readYDocOptionalInteger(this._raw.get('segments'), "SoundGenerationMetadataDict.segments") }
  get voice_id(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_id'), "SoundGenerationMetadataDict.voice_id") }
  get voice_type(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_type'), "SoundGenerationMetadataDict.voice_type") }
}

/** Typed Y.Map wrapper for SpeechSegmentDict. */
export class SpeechSegmentDictYMap extends YMapWrapper {
  get audioUrl(): string | undefined { return _readYDocOptionalString(this._raw.get('audioUrl'), "SpeechSegmentDict.audioUrl") }
  get character(): string | undefined { return _readYDocOptionalString(this._raw.get('character'), "SpeechSegmentDict.character") }
  get emotion(): string | undefined { return _readYDocOptionalString(this._raw.get('emotion'), "SpeechSegmentDict.emotion") }
  get selectedVersion(): number | undefined { return _readYDocOptionalInteger(this._raw.get('selectedVersion'), "SpeechSegmentDict.selectedVersion") }
  get timeRange(): string | undefined { return _readYDocOptionalString(this._raw.get('timeRange'), "SpeechSegmentDict.timeRange") }
  get versions(): number | undefined { return _readYDocOptionalInteger(this._raw.get('versions'), "SpeechSegmentDict.versions") }
}

/** Typed Y.Map wrapper for SpeechTransformerAudioSplitDict. */
export class SpeechTransformerAudioSplitDictYMap extends YMapWrapper {
  get backgroundKey(): string | undefined { return _readYDocOptionalString(this._raw.get('backgroundKey'), "SpeechTransformerAudioSplitDict.backgroundKey") }
  get enabled(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('enabled'), "SpeechTransformerAudioSplitDict.enabled") }
  get extractorVersion(): string | undefined { return _readYDocOptionalString(this._raw.get('extractorVersion'), "SpeechTransformerAudioSplitDict.extractorVersion") }
  get fallbackReason(): "silent_source" | "silent_vocals" | "provider_timeout" | "separator_model_missing" | "user_disabled" | "source_mismatch" | "source_too_long" | "no_audio_stream" | undefined { return _readYDocOptionalEnum(this._raw.get('fallbackReason'), "SpeechTransformerAudioSplitDict.fallbackReason", ["silent_source", "silent_vocals", "provider_timeout", "separator_model_missing", "user_disabled", "source_mismatch", "source_too_long", "no_audio_stream"] as const) }
  get jobId(): string | undefined { return _readYDocOptionalString(this._raw.get('jobId'), "SpeechTransformerAudioSplitDict.jobId") }
  get modelVersion(): string | undefined { return _readYDocOptionalString(this._raw.get('modelVersion'), "SpeechTransformerAudioSplitDict.modelVersion") }
  get provider(): string | undefined { return _readYDocOptionalString(this._raw.get('provider'), "SpeechTransformerAudioSplitDict.provider") }
  get sourceSha256(): string | undefined { return _readYDocOptionalString(this._raw.get('sourceSha256'), "SpeechTransformerAudioSplitDict.sourceSha256") }
  get status(): "success" | "skipped" | undefined { return _readYDocOptionalEnum(this._raw.get('status'), "SpeechTransformerAudioSplitDict.status", ["success", "skipped"] as const) }
  get vocalsKey(): string | undefined { return _readYDocOptionalString(this._raw.get('vocalsKey'), "SpeechTransformerAudioSplitDict.vocalsKey") }
}

/** Typed Y.Map wrapper for SpeechTransformerConfigDict. */
export class SpeechTransformerConfigDictYMap extends YMapWrapper {
  get audioSplit(): SpeechTransformerAudioSplitDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('audioSplit'), SpeechTransformerAudioSplitDictYMap, "SpeechTransformerConfigDict.audioSplit") }
  get duckDepthDb(): number | undefined { return _readYDocOptionalNumber(this._raw.get('duckDepthDb'), "SpeechTransformerConfigDict.duckDepthDb") }
  get rows(): SpeechTransformerSpeakerDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('rows'), "SpeechTransformerConfigDict.rows", (item, itemLabel) => _readYDocMapWrapper(item, SpeechTransformerSpeakerDictYMap, itemLabel)) }
  get sourceOriginalIndex(): number | undefined { return _readYDocOptionalInteger(this._raw.get('sourceOriginalIndex'), "SpeechTransformerConfigDict.sourceOriginalIndex") }
  get sourceOriginalPath(): string | undefined { return _readYDocOptionalString(this._raw.get('sourceOriginalPath'), "SpeechTransformerConfigDict.sourceOriginalPath") }
}

/** Typed Y.Map wrapper for SpeechTransformerDetectionDict. */
export class SpeechTransformerDetectionDictYMap extends YMapWrapper {
  get audioSplit(): SpeechTransformerAudioSplitDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('audioSplit'), SpeechTransformerAudioSplitDictYMap, "SpeechTransformerDetectionDict.audioSplit") }
  get detectStatus(): "ok" | "no_dialogue" | undefined { return _readYDocOptionalEnum(this._raw.get('detectStatus'), "SpeechTransformerDetectionDict.detectStatus", ["ok", "no_dialogue"] as const) }
  get rows(): SpeechTransformerSpeakerDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('rows'), "SpeechTransformerDetectionDict.rows", (item, itemLabel) => _readYDocMapWrapper(item, SpeechTransformerSpeakerDictYMap, itemLabel)) }
  get sourceOriginalIndex(): number | undefined { return _readYDocOptionalInteger(this._raw.get('sourceOriginalIndex'), "SpeechTransformerDetectionDict.sourceOriginalIndex") }
  get sourceOriginalPath(): string | undefined { return _readYDocOptionalString(this._raw.get('sourceOriginalPath'), "SpeechTransformerDetectionDict.sourceOriginalPath") }
}

/** Typed Y.Map wrapper for SpeechTransformerSpanDict. */
export class SpeechTransformerSpanDictYMap extends YMapWrapper {
  get dirty(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('dirty'), "SpeechTransformerSpanDict.dirty") }
  get end_s(): number | undefined { return _readYDocOptionalNumber(this._raw.get('end_s'), "SpeechTransformerSpanDict.end_s") }
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "SpeechTransformerSpanDict.id") }
  get start_s(): number | undefined { return _readYDocOptionalNumber(this._raw.get('start_s'), "SpeechTransformerSpanDict.start_s") }
  get synth_path(): string | undefined { return _readYDocOptionalString(this._raw.get('synth_path'), "SpeechTransformerSpanDict.synth_path") }
}

/** Typed Y.Map wrapper for SpeechTransformerSpeakerDict. */
export class SpeechTransformerSpeakerDictYMap extends YMapWrapper {
  get character(): string | undefined { return _readYDocOptionalString(this._raw.get('character'), "SpeechTransformerSpeakerDict.character") }
  get spans(): SpeechTransformerSpanDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('spans'), "SpeechTransformerSpeakerDict.spans", (item, itemLabel) => _readYDocMapWrapper(item, SpeechTransformerSpanDictYMap, itemLabel)) }
  get target_voice_id(): string | undefined { return _readYDocOptionalString(this._raw.get('target_voice_id'), "SpeechTransformerSpeakerDict.target_voice_id") }
  get voice_role_id(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_role_id'), "SpeechTransformerSpeakerDict.voice_role_id") }
}

/** Typed Y.Map wrapper for SpeechWindowDict. */
export class SpeechWindowDictYMap extends YMapWrapper {
  get confidence(): number | undefined { return _readYDocOptionalNumber(this._raw.get('confidence'), "SpeechWindowDict.confidence") }
  get end_s(): number | undefined { return _readYDocOptionalNumber(this._raw.get('end_s'), "SpeechWindowDict.end_s") }
  get start_s(): number | undefined { return _readYDocOptionalNumber(this._raw.get('start_s'), "SpeechWindowDict.start_s") }
  get text(): string | undefined { return _readYDocOptionalString(this._raw.get('text'), "SpeechWindowDict.text") }
}

/** Typed Y.Map wrapper for StoryContextDict. */
export class StoryContextDictYMap extends YMapWrapper {
  get characters(): string[] | undefined { return _readYDocOptionalArray(this._raw.get('characters'), "StoryContextDict.characters", (item, itemLabel) => _readYDocString(item, itemLabel)) }
  get setting(): string | undefined { return _readYDocOptionalString(this._raw.get('setting'), "StoryContextDict.setting") }
  get synopsis(): string | undefined { return _readYDocOptionalString(this._raw.get('synopsis'), "StoryContextDict.synopsis") }
}

/** Typed Y.Map wrapper for StoryDirectionFieldDict. */
export class StoryDirectionFieldDictYMap extends YMapWrapper {
  get status(): string | undefined { return _readYDocOptionalString(this._raw.get('status'), "StoryDirectionFieldDict.status") }
  get value(): string | undefined { return _readYDocOptionalString(this._raw.get('value'), "StoryDirectionFieldDict.value") }
}

/** Typed Y.Map wrapper for StoryboardEntryDict. */
export class StoryboardEntryDictYMap extends YMapWrapper {
  get characters(): string[] | undefined { return _readYDocOptionalArray(this._raw.get('characters'), "StoryboardEntryDict.characters", (item, itemLabel) => _readYDocString(item, itemLabel)) }
  get description(): string | undefined { return _readYDocOptionalString(this._raw.get('description'), "StoryboardEntryDict.description") }
  get panel_index(): number | undefined { return _readYDocOptionalInteger(this._raw.get('panel_index'), "StoryboardEntryDict.panel_index") }
}

/** Typed Y.Map wrapper for StoryboardMetadataDict. */
export class StoryboardMetadataDictYMap extends YMapWrapper {
  get aspect_ratio(): string | undefined { return _readYDocOptionalString(this._raw.get('aspect_ratio'), "StoryboardMetadataDict.aspect_ratio") }
  get model(): string | undefined { return _readYDocOptionalString(this._raw.get('model'), "StoryboardMetadataDict.model") }
  get regenerated(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('regenerated'), "StoryboardMetadataDict.regenerated") }
  get regeneration_time(): string | undefined { return _readYDocOptionalString(this._raw.get('regeneration_time'), "StoryboardMetadataDict.regeneration_time") }
  get scene_id(): string | undefined { return _readYDocOptionalString(this._raw.get('scene_id'), "StoryboardMetadataDict.scene_id") }
  get source_signature(): string | undefined { return _readYDocOptionalString(this._raw.get('source_signature'), "StoryboardMetadataDict.source_signature") }
}

/** Typed Y.Map wrapper for TimelineAudioConfigDict. */
export class TimelineAudioConfigDictYMap extends YMapWrapper {
  get audio_kind(): "audio" | "music" | "sfx" | "speech" | "extracted_original_audio" | "changed_voice" | "isolated_voice" | "isolated_background" | undefined { return _readYDocOptionalEnum(this._raw.get('audio_kind'), "TimelineAudioConfigDict.audio_kind", ["audio", "music", "sfx", "speech", "extracted_original_audio", "changed_voice", "isolated_voice", "isolated_background"] as const) }
  get end_time(): number | undefined { return _readYDocOptionalNumber(this._raw.get('end_time'), "TimelineAudioConfigDict.end_time") }
  get fade_in_s(): number | undefined { return _readYDocOptionalNumber(this._raw.get('fade_in_s'), "TimelineAudioConfigDict.fade_in_s") }
  get fade_out_s(): number | undefined { return _readYDocOptionalNumber(this._raw.get('fade_out_s'), "TimelineAudioConfigDict.fade_out_s") }
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "TimelineAudioConfigDict.id") }
  get label(): string | undefined { return _readYDocOptionalString(this._raw.get('label'), "TimelineAudioConfigDict.label") }
  get muted(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('muted'), "TimelineAudioConfigDict.muted") }
  get original_duration(): number | undefined { return _readYDocOptionalNumber(this._raw.get('original_duration'), "TimelineAudioConfigDict.original_duration") }
  get peak_dbfs(): number | null | undefined { return (this._raw.get('peak_dbfs') == null ? undefined : _readYDocUnion<number | null>(this._raw.get('peak_dbfs'), "TimelineAudioConfigDict.peak_dbfs", [(value, fieldLabel) => _readYDocNumber(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get planned_end_offset(): number | undefined { return _readYDocOptionalNumber(this._raw.get('planned_end_offset'), "TimelineAudioConfigDict.planned_end_offset") }
  get role(): "original" | "replacement" | "sfx" | "music" | undefined { return _readYDocOptionalEnum(this._raw.get('role'), "TimelineAudioConfigDict.role", ["original", "replacement", "sfx", "music"] as const) }
  get source_node_id(): string | undefined { return _readYDocOptionalString(this._raw.get('source_node_id'), "TimelineAudioConfigDict.source_node_id") }
  get source_path(): string | undefined { return _readYDocOptionalString(this._raw.get('source_path'), "TimelineAudioConfigDict.source_path") }
  get source_video_clip_id(): string | undefined { return _readYDocOptionalString(this._raw.get('source_video_clip_id'), "TimelineAudioConfigDict.source_video_clip_id") }
  get speed(): number | undefined { return _readYDocOptionalNumber(this._raw.get('speed'), "TimelineAudioConfigDict.speed") }
  get split_group_id(): string | null | undefined { return (this._raw.get('split_group_id') == null ? undefined : _readYDocUnion<string | null>(this._raw.get('split_group_id'), "TimelineAudioConfigDict.split_group_id", [(value, fieldLabel) => _readYDocString(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get start_offset(): number | undefined { return _readYDocOptionalNumber(this._raw.get('start_offset'), "TimelineAudioConfigDict.start_offset") }
  get start_time(): number | undefined { return _readYDocOptionalNumber(this._raw.get('start_time'), "TimelineAudioConfigDict.start_time") }
  get track_index(): number | undefined { return _readYDocOptionalInteger(this._raw.get('track_index'), "TimelineAudioConfigDict.track_index") }
  get volume(): number | undefined { return _readYDocOptionalNumber(this._raw.get('volume'), "TimelineAudioConfigDict.volume") }
}

/** Typed Y.Map wrapper for TimelineClipConfigDict. */
export class TimelineClipConfigDictYMap extends YMapWrapper {
  get adjustments(): TimelineVisualAdjustmentsDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('adjustments'), TimelineVisualAdjustmentsDictYMap, "TimelineClipConfigDict.adjustments") }
  get audio_fade_in_s(): number | undefined { return _readYDocOptionalNumber(this._raw.get('audio_fade_in_s'), "TimelineClipConfigDict.audio_fade_in_s") }
  get audio_fade_out_s(): number | undefined { return _readYDocOptionalNumber(this._raw.get('audio_fade_out_s'), "TimelineClipConfigDict.audio_fade_out_s") }
  get end_time(): number | undefined { return _readYDocOptionalNumber(this._raw.get('end_time'), "TimelineClipConfigDict.end_time") }
  get fade_color(): "black" | "white" | undefined { return _readYDocOptionalEnum(this._raw.get('fade_color'), "TimelineClipConfigDict.fade_color", ["black", "white"] as const) }
  get fade_in_s(): number | undefined { return _readYDocOptionalNumber(this._raw.get('fade_in_s'), "TimelineClipConfigDict.fade_in_s") }
  get fade_out_s(): number | undefined { return _readYDocOptionalNumber(this._raw.get('fade_out_s'), "TimelineClipConfigDict.fade_out_s") }
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "TimelineClipConfigDict.id") }
  get muted(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('muted'), "TimelineClipConfigDict.muted") }
  get order(): number | undefined { return _readYDocOptionalInteger(this._raw.get('order'), "TimelineClipConfigDict.order") }
  get original_duration(): number | undefined { return _readYDocOptionalNumber(this._raw.get('original_duration'), "TimelineClipConfigDict.original_duration") }
  get source_node_id(): string | undefined { return _readYDocOptionalString(this._raw.get('source_node_id'), "TimelineClipConfigDict.source_node_id") }
  get source_path(): string | undefined { return _readYDocOptionalString(this._raw.get('source_path'), "TimelineClipConfigDict.source_path") }
  get speed(): number | undefined { return _readYDocOptionalNumber(this._raw.get('speed'), "TimelineClipConfigDict.speed") }
  get speed_curve(): TimelineSpeedCurveDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('speed_curve'), TimelineSpeedCurveDictYMap, "TimelineClipConfigDict.speed_curve") }
  get start_offset(): number | undefined { return _readYDocOptionalNumber(this._raw.get('start_offset'), "TimelineClipConfigDict.start_offset") }
  get start_time(): number | undefined { return _readYDocOptionalNumber(this._raw.get('start_time'), "TimelineClipConfigDict.start_time") }
  get track_index(): number | undefined { return _readYDocOptionalInteger(this._raw.get('track_index'), "TimelineClipConfigDict.track_index") }
  get volume(): number | undefined { return _readYDocOptionalNumber(this._raw.get('volume'), "TimelineClipConfigDict.volume") }
}

/** Typed Y.Map wrapper for TimelineConfigDict. */
export class TimelineConfigDictYMap extends YMapWrapper {
  get operation(): "timeline_render" | undefined { return _readYDocOptionalEnum(this._raw.get('operation'), "TimelineConfigDict.operation", ["timeline_render"] as const) }
  get timeline(): TimelinePayloadDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('timeline'), TimelinePayloadDictYMap, "TimelineConfigDict.timeline") }
}

/** Typed Y.Map wrapper for TimelinePayloadDict. */
export class TimelinePayloadDictYMap extends YMapWrapper {
  get audio(): TimelineAudioConfigDictYMap | null | undefined { return (this._raw.get('audio') == null ? undefined : _readYDocUnion<TimelineAudioConfigDictYMap | null>(this._raw.get('audio'), "TimelinePayloadDict.audio", [(value, fieldLabel) => _readYDocMapWrapper(value, TimelineAudioConfigDictYMap, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get audio_track_count(): number | undefined { return _readYDocOptionalInteger(this._raw.get('audio_track_count'), "TimelinePayloadDict.audio_track_count") }
  get audio_tracks(): TimelineAudioConfigDictYMap[] | null | undefined { return (this._raw.get('audio_tracks') == null ? undefined : _readYDocUnion<TimelineAudioConfigDictYMap[] | null>(this._raw.get('audio_tracks'), "TimelinePayloadDict.audio_tracks", [(value, fieldLabel) => _readYDocArray(value, fieldLabel, (item, itemLabel) => _readYDocMapWrapper(item, TimelineAudioConfigDictYMap, itemLabel)), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get audio_tracks_meta(): TimelineTrackMetaDictYMap[] | null | undefined { return (this._raw.get('audio_tracks_meta') == null ? undefined : _readYDocUnion<TimelineTrackMetaDictYMap[] | null>(this._raw.get('audio_tracks_meta'), "TimelinePayloadDict.audio_tracks_meta", [(value, fieldLabel) => _readYDocArray(value, fieldLabel, (item, itemLabel) => _readYDocMapWrapper(item, TimelineTrackMetaDictYMap, itemLabel)), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get clips(): TimelineClipConfigDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('clips'), "TimelinePayloadDict.clips", (item, itemLabel) => _readYDocMapWrapper(item, TimelineClipConfigDictYMap, itemLabel)) }
  get magnet_enabled(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('magnet_enabled'), "TimelinePayloadDict.magnet_enabled") }
  get text_format(): EditSpecFormatDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('text_format'), EditSpecFormatDictYMap, "TimelinePayloadDict.text_format") }
  get text_overlays(): EditSpecOverlayDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('text_overlays'), "TimelinePayloadDict.text_overlays", (item, itemLabel) => _readYDocMapWrapper(item, EditSpecOverlayDictYMap, itemLabel)) }
  get total_duration(): number | undefined { return _readYDocOptionalNumber(this._raw.get('total_duration'), "TimelinePayloadDict.total_duration") }
  get video_track_count(): number | undefined { return _readYDocOptionalInteger(this._raw.get('video_track_count'), "TimelinePayloadDict.video_track_count") }
  get video_tracks_meta(): TimelineTrackMetaDictYMap[] | null | undefined { return (this._raw.get('video_tracks_meta') == null ? undefined : _readYDocUnion<TimelineTrackMetaDictYMap[] | null>(this._raw.get('video_tracks_meta'), "TimelinePayloadDict.video_tracks_meta", [(value, fieldLabel) => _readYDocArray(value, fieldLabel, (item, itemLabel) => _readYDocMapWrapper(item, TimelineTrackMetaDictYMap, itemLabel)), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
}

/** Typed Y.Map wrapper for TimelineSpeedCurveDict. */
export class TimelineSpeedCurveDictYMap extends YMapWrapper {
  get points(): TimelineSpeedPointDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('points'), "TimelineSpeedCurveDict.points", (item, itemLabel) => _readYDocMapWrapper(item, TimelineSpeedPointDictYMap, itemLabel)) }
  get render_duration(): number | undefined { return _readYDocOptionalNumber(this._raw.get('render_duration'), "TimelineSpeedCurveDict.render_duration") }
  get source_end(): number | undefined { return _readYDocOptionalNumber(this._raw.get('source_end'), "TimelineSpeedCurveDict.source_end") }
  get source_path(): string | undefined { return _readYDocOptionalString(this._raw.get('source_path'), "TimelineSpeedCurveDict.source_path") }
  get source_start(): number | undefined { return _readYDocOptionalNumber(this._raw.get('source_start'), "TimelineSpeedCurveDict.source_start") }
}

/** Typed Y.Map wrapper for TimelineSpeedPointDict. */
export class TimelineSpeedPointDictYMap extends YMapWrapper {
  get position(): number | undefined { return _readYDocOptionalNumber(this._raw.get('position'), "TimelineSpeedPointDict.position") }
  get speed(): number | undefined { return _readYDocOptionalNumber(this._raw.get('speed'), "TimelineSpeedPointDict.speed") }
}

/** Typed Y.Map wrapper for TimelineTimeEditRequestDict. */
export class TimelineTimeEditRequestDictYMap extends YMapWrapper {
  get end_time(): number | undefined { return _readYDocOptionalNumber(this._raw.get('end_time'), "TimelineTimeEditRequestDict.end_time") }
  get freeze_at(): number | undefined { return _readYDocOptionalNumber(this._raw.get('freeze_at'), "TimelineTimeEditRequestDict.freeze_at") }
  get mode(): "reverse" | "freeze" | "speed_curve" | undefined { return _readYDocOptionalEnum(this._raw.get('mode'), "TimelineTimeEditRequestDict.mode", ["reverse", "freeze", "speed_curve"] as const) }
  get points(): TimelineSpeedPointDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('points'), "TimelineTimeEditRequestDict.points", (item, itemLabel) => _readYDocMapWrapper(item, TimelineSpeedPointDictYMap, itemLabel)) }
  get source_path(): string | undefined { return _readYDocOptionalString(this._raw.get('source_path'), "TimelineTimeEditRequestDict.source_path") }
  get start_time(): number | undefined { return _readYDocOptionalNumber(this._raw.get('start_time'), "TimelineTimeEditRequestDict.start_time") }
}

/** Typed Y.Map wrapper for TimelineTimeEditStatusDict. */
export class TimelineTimeEditStatusDictYMap extends YMapWrapper {
  get duration(): number | null | undefined { return (this._raw.get('duration') == null ? undefined : _readYDocUnion<number | null>(this._raw.get('duration'), "TimelineTimeEditStatusDict.duration", [(value, fieldLabel) => _readYDocNumber(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get error(): string | null | undefined { return (this._raw.get('error') == null ? undefined : _readYDocUnion<string | null>(this._raw.get('error'), "TimelineTimeEditStatusDict.error", [(value, fieldLabel) => _readYDocString(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get job_id(): string | undefined { return _readYDocOptionalString(this._raw.get('job_id'), "TimelineTimeEditStatusDict.job_id") }
  get source_path(): string | null | undefined { return (this._raw.get('source_path') == null ? undefined : _readYDocUnion<string | null>(this._raw.get('source_path'), "TimelineTimeEditStatusDict.source_path", [(value, fieldLabel) => _readYDocString(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get status(): "pending" | "running" | "success" | "failed" | "cancelled" | undefined { return _readYDocOptionalEnum(this._raw.get('status'), "TimelineTimeEditStatusDict.status", ["pending", "running", "success", "failed", "cancelled"] as const) }
}

/** Typed Y.Map wrapper for TimelineTrackMetaDict. */
export class TimelineTrackMetaDictYMap extends YMapWrapper {
  get muted(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('muted'), "TimelineTrackMetaDict.muted") }
  get track_index(): number | undefined { return _readYDocOptionalInteger(this._raw.get('track_index'), "TimelineTrackMetaDict.track_index") }
}

/** Typed Y.Map wrapper for TimelineVisualAdjustmentsDict. */
export class TimelineVisualAdjustmentsDictYMap extends YMapWrapper {
  get brightness(): number | undefined { return _readYDocOptionalNumber(this._raw.get('brightness'), "TimelineVisualAdjustmentsDict.brightness") }
  get contrast(): number | undefined { return _readYDocOptionalNumber(this._raw.get('contrast'), "TimelineVisualAdjustmentsDict.contrast") }
  get flip_horizontal(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('flip_horizontal'), "TimelineVisualAdjustmentsDict.flip_horizontal") }
  get flip_vertical(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('flip_vertical'), "TimelineVisualAdjustmentsDict.flip_vertical") }
  get position_x(): number | undefined { return _readYDocOptionalNumber(this._raw.get('position_x'), "TimelineVisualAdjustmentsDict.position_x") }
  get position_y(): number | undefined { return _readYDocOptionalNumber(this._raw.get('position_y'), "TimelineVisualAdjustmentsDict.position_y") }
  get rotation(): number | undefined { return _readYDocOptionalNumber(this._raw.get('rotation'), "TimelineVisualAdjustmentsDict.rotation") }
  get saturation(): number | undefined { return _readYDocOptionalNumber(this._raw.get('saturation'), "TimelineVisualAdjustmentsDict.saturation") }
  get scale(): number | undefined { return _readYDocOptionalNumber(this._raw.get('scale'), "TimelineVisualAdjustmentsDict.scale") }
}

/** Typed Y.Map wrapper for TransitionDict. */
export class TransitionDictYMap extends YMapWrapper {
  get description(): string | undefined { return _readYDocOptionalString(this._raw.get('description'), "TransitionDict.description") }
  get from_panel(): string | undefined { return _readYDocOptionalString(this._raw.get('from_panel'), "TransitionDict.from_panel") }
  get to_panel(): string | undefined { return _readYDocOptionalString(this._raw.get('to_panel'), "TransitionDict.to_panel") }
  get type(): string | undefined { return _readYDocOptionalString(this._raw.get('type'), "TransitionDict.type") }
}

/** Typed Y.Map wrapper for TtsSegmentDict. */
export class TtsSegmentDictYMap extends YMapWrapper {
  get audio_path(): string | undefined { return _readYDocOptionalString(this._raw.get('audio_path'), "TtsSegmentDict.audio_path") }
  get character(): string | undefined { return _readYDocOptionalString(this._raw.get('character'), "TtsSegmentDict.character") }
  get duration_s(): number | undefined { return _readYDocOptionalNumber(this._raw.get('duration_s'), "TtsSegmentDict.duration_s") }
  get emotion(): string | undefined { return _readYDocOptionalString(this._raw.get('emotion'), "TtsSegmentDict.emotion") }
  get end_s(): number | undefined { return _readYDocOptionalNumber(this._raw.get('end_s'), "TtsSegmentDict.end_s") }
  get index(): number | undefined { return _readYDocOptionalInteger(this._raw.get('index'), "TtsSegmentDict.index") }
  get original_path(): string | undefined { return _readYDocOptionalString(this._raw.get('original_path'), "TtsSegmentDict.original_path") }
  get path(): string | undefined { return _readYDocOptionalString(this._raw.get('path'), "TtsSegmentDict.path") }
  get start_s(): number | undefined { return _readYDocOptionalNumber(this._raw.get('start_s'), "TtsSegmentDict.start_s") }
  get status(): string | undefined { return _readYDocOptionalString(this._raw.get('status'), "TtsSegmentDict.status") }
  get text(): string | undefined { return _readYDocOptionalString(this._raw.get('text'), "TtsSegmentDict.text") }
  get tts_end_s(): number | undefined { return _readYDocOptionalNumber(this._raw.get('tts_end_s'), "TtsSegmentDict.tts_end_s") }
  get type(): string | undefined { return _readYDocOptionalString(this._raw.get('type'), "TtsSegmentDict.type") }
  get versions(): TtsVersionDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('versions'), "TtsSegmentDict.versions", (item, itemLabel) => _readYDocMapWrapper(item, TtsVersionDictYMap, itemLabel)) }
  get voice_role_id(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_role_id'), "TtsSegmentDict.voice_role_id") }
}

/** Typed Y.Map wrapper for TtsVersionDict. */
export class TtsVersionDictYMap extends YMapWrapper {
  get label(): string | undefined { return _readYDocOptionalString(this._raw.get('label'), "TtsVersionDict.label") }
  get path(): string | undefined { return _readYDocOptionalString(this._raw.get('path'), "TtsVersionDict.path") }
  get source_type(): string | undefined { return _readYDocOptionalString(this._raw.get('source_type'), "TtsVersionDict.source_type") }
  get voice_id(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_id'), "TtsVersionDict.voice_id") }
  get voice_name(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_name'), "TtsVersionDict.voice_name") }
}

/** Typed Y.Map wrapper for UnifiedAudioClipDict. */
export class UnifiedAudioClipDictYMap extends YMapWrapper {
  get added(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('added'), "UnifiedAudioClipDict.added") }
  get end_s(): number | undefined { return _readYDocOptionalNumber(this._raw.get('end_s'), "UnifiedAudioClipDict.end_s") }
  get fadeInS(): number | undefined { return _readYDocOptionalNumber(this._raw.get('fadeInS'), "UnifiedAudioClipDict.fadeInS") }
  get fadeOutS(): number | undefined { return _readYDocOptionalNumber(this._raw.get('fadeOutS'), "UnifiedAudioClipDict.fadeOutS") }
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "UnifiedAudioClipDict.id") }
  get language(): string | undefined { return _readYDocOptionalString(this._raw.get('language'), "UnifiedAudioClipDict.language") }
  get muted(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('muted'), "UnifiedAudioClipDict.muted") }
  get native_fill(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('native_fill'), "UnifiedAudioClipDict.native_fill") }
  get original_path(): string | undefined { return _readYDocOptionalString(this._raw.get('original_path'), "UnifiedAudioClipDict.original_path") }
  get path(): string | undefined { return _readYDocOptionalString(this._raw.get('path'), "UnifiedAudioClipDict.path") }
  get selectedVersionLabel(): string | undefined { return _readYDocOptionalString(this._raw.get('selectedVersionLabel'), "UnifiedAudioClipDict.selectedVersionLabel") }
  get sourceInS(): number | undefined { return _readYDocOptionalNumber(this._raw.get('sourceInS'), "UnifiedAudioClipDict.sourceInS") }
  get sourceSegmentIdx(): number | undefined { return _readYDocOptionalInteger(this._raw.get('sourceSegmentIdx'), "UnifiedAudioClipDict.sourceSegmentIdx") }
  get source_sig(): string | undefined { return _readYDocOptionalString(this._raw.get('source_sig'), "UnifiedAudioClipDict.source_sig") }
  get speaker(): string | undefined { return _readYDocOptionalString(this._raw.get('speaker'), "UnifiedAudioClipDict.speaker") }
  get speed(): number | undefined { return _readYDocOptionalNumber(this._raw.get('speed'), "UnifiedAudioClipDict.speed") }
  get start_s(): number | undefined { return _readYDocOptionalNumber(this._raw.get('start_s'), "UnifiedAudioClipDict.start_s") }
  get versions(): TtsVersionDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('versions'), "UnifiedAudioClipDict.versions", (item, itemLabel) => _readYDocMapWrapper(item, TtsVersionDictYMap, itemLabel)) }
  get volume(): number | undefined { return _readYDocOptionalNumber(this._raw.get('volume'), "UnifiedAudioClipDict.volume") }
}

/** Typed Y.Map wrapper for UnifiedAudioClipV2Dict. */
export class UnifiedAudioClipV2DictYMap extends YMapWrapper {
  get activeTakeId(): string | undefined { return _readYDocOptionalString(this._raw.get('activeTakeId'), "UnifiedAudioClipV2Dict.activeTakeId") }
  get contentRole(): "speech" | "background" | "music" | "sfx" | "gap_fill" | "overlap_unresolved" | undefined { return _readYDocOptionalEnum(this._raw.get('contentRole'), "UnifiedAudioClipV2Dict.contentRole", ["speech", "background", "music", "sfx", "gap_fill", "overlap_unresolved"] as const) }
  get endS(): number | undefined { return _readYDocOptionalNumber(this._raw.get('endS'), "UnifiedAudioClipV2Dict.endS") }
  get fadeInS(): number | undefined { return _readYDocOptionalNumber(this._raw.get('fadeInS'), "UnifiedAudioClipV2Dict.fadeInS") }
  get fadeOutS(): number | undefined { return _readYDocOptionalNumber(this._raw.get('fadeOutS'), "UnifiedAudioClipV2Dict.fadeOutS") }
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "UnifiedAudioClipV2Dict.id") }
  get isolationGroupId(): string | null | undefined { return (this._raw.get('isolationGroupId') == null ? undefined : _readYDocUnion<string | null>(this._raw.get('isolationGroupId'), "UnifiedAudioClipV2Dict.isolationGroupId", [(value, fieldLabel) => _readYDocString(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get language(): string | null | undefined { return (this._raw.get('language') == null ? undefined : _readYDocUnion<string | null>(this._raw.get('language'), "UnifiedAudioClipV2Dict.language", [(value, fieldLabel) => _readYDocString(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get muted(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('muted'), "UnifiedAudioClipV2Dict.muted") }
  get speaker(): string | null | undefined { return (this._raw.get('speaker') == null ? undefined : _readYDocUnion<string | null>(this._raw.get('speaker'), "UnifiedAudioClipV2Dict.speaker", [(value, fieldLabel) => _readYDocString(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get startS(): number | undefined { return _readYDocOptionalNumber(this._raw.get('startS'), "UnifiedAudioClipV2Dict.startS") }
  get takes(): UnifiedAudioTakeV2DictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('takes'), "UnifiedAudioClipV2Dict.takes", (item, itemLabel) => (() => { _validateYDocUnifiedAudioTakeV2Dict(item, itemLabel); return _readYDocMapWrapper(item, UnifiedAudioTakeV2DictYMap, itemLabel) })()) }
  get transcript(): string | null | undefined { return (this._raw.get('transcript') == null ? undefined : _readYDocUnion<string | null>(this._raw.get('transcript'), "UnifiedAudioClipV2Dict.transcript", [(value, fieldLabel) => _readYDocString(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get userSpeed(): number | undefined { return _readYDocOptionalNumber(this._raw.get('userSpeed'), "UnifiedAudioClipV2Dict.userSpeed", 0.0) }
  get volume(): number | undefined { return _readYDocOptionalNumber(this._raw.get('volume'), "UnifiedAudioClipV2Dict.volume") }
}

/** Typed Y.Map wrapper for UnifiedAudioLaneDict. */
export class UnifiedAudioLaneDictYMap extends YMapWrapper {
  get clips(): UnifiedAudioClipDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('clips'), "UnifiedAudioLaneDict.clips", (item, itemLabel) => _readYDocMapWrapper(item, UnifiedAudioClipDictYMap, itemLabel)) }
  get duckDepthDb(): number | undefined { return _readYDocOptionalNumber(this._raw.get('duckDepthDb'), "UnifiedAudioLaneDict.duckDepthDb") }
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "UnifiedAudioLaneDict.id") }
  get laneDuckMute(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('laneDuckMute'), "UnifiedAudioLaneDict.laneDuckMute") }
  get laneMute(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('laneMute'), "UnifiedAudioLaneDict.laneMute") }
  get laneVolume(): number | undefined { return _readYDocOptionalNumber(this._raw.get('laneVolume'), "UnifiedAudioLaneDict.laneVolume") }
  get source(): "native_split" | "owned" | "tts" | "sts" | undefined { return _readYDocOptionalEnum(this._raw.get('source'), "UnifiedAudioLaneDict.source", ["native_split", "owned", "tts", "sts"] as const) }
  get type(): "dialogue" | "narration" | "music" | "sfx" | undefined { return _readYDocOptionalEnum(this._raw.get('type'), "UnifiedAudioLaneDict.type", ["dialogue", "narration", "music", "sfx"] as const) }
}

/** Typed Y.Map wrapper for UnifiedAudioLaneV2Dict. */
export class UnifiedAudioLaneV2DictYMap extends YMapWrapper {
  get clips(): UnifiedAudioClipV2DictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('clips'), "UnifiedAudioLaneV2Dict.clips", (item, itemLabel) => (() => { _validateYDocUnifiedAudioClipV2Dict(item, itemLabel); return _readYDocMapWrapper(item, UnifiedAudioClipV2DictYMap, itemLabel) })()) }
  get duckDepthDb(): number | undefined { return _readYDocOptionalNumber(this._raw.get('duckDepthDb'), "UnifiedAudioLaneV2Dict.duckDepthDb") }
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "UnifiedAudioLaneV2Dict.id") }
  get laneDuckMute(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('laneDuckMute'), "UnifiedAudioLaneV2Dict.laneDuckMute") }
  get laneMute(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('laneMute'), "UnifiedAudioLaneV2Dict.laneMute") }
  get laneVolume(): number | undefined { return _readYDocOptionalNumber(this._raw.get('laneVolume'), "UnifiedAudioLaneV2Dict.laneVolume") }
  get type(): "dialogue" | "narration" | "music" | "sfx" | undefined { return _readYDocOptionalEnum(this._raw.get('type'), "UnifiedAudioLaneV2Dict.type", ["dialogue", "narration", "music", "sfx"] as const) }
}

/** Typed Y.Map wrapper for UnifiedAudioProjectDict. */
export class UnifiedAudioProjectDictYMap extends YMapWrapper {
  get deletedClipIds(): string[] | undefined { return _readYDocOptionalArray(this._raw.get('deletedClipIds'), "UnifiedAudioProjectDict.deletedClipIds", (item, itemLabel) => _readYDocString(item, itemLabel)) }
  get lanes(): UnifiedAudioLaneDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('lanes'), "UnifiedAudioProjectDict.lanes", (item, itemLabel) => _readYDocMapWrapper(item, UnifiedAudioLaneDictYMap, itemLabel)) }
  get mastering(): "lufs" | "peak" | undefined { return _readYDocOptionalEnum(this._raw.get('mastering'), "UnifiedAudioProjectDict.mastering", ["lufs", "peak"] as const) }
  get sourceOriginalIndex(): number | undefined { return _readYDocOptionalInteger(this._raw.get('sourceOriginalIndex'), "UnifiedAudioProjectDict.sourceOriginalIndex") }
  get sourceOriginalPath(): string | undefined { return _readYDocOptionalString(this._raw.get('sourceOriginalPath'), "UnifiedAudioProjectDict.sourceOriginalPath") }
}

/** Typed Y.Map wrapper for UnifiedAudioProjectV2. */
export class UnifiedAudioProjectV2YMap extends YMapWrapper {
  get contractVersion(): 2 | undefined { return _readYDocOptionalEnum(this._raw.get('contractVersion'), "UnifiedAudioProjectV2.contractVersion", [2] as const) }
  get lanes(): UnifiedAudioLaneV2DictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('lanes'), "UnifiedAudioProjectV2.lanes", (item, itemLabel) => (() => { _validateYDocUnifiedAudioLaneV2Dict(item, itemLabel); return _readYDocMapWrapper(item, UnifiedAudioLaneV2DictYMap, itemLabel) })()) }
  get mastering(): "lufs" | "peak" | undefined { return _readYDocOptionalEnum(this._raw.get('mastering'), "UnifiedAudioProjectV2.mastering", ["lufs", "peak"] as const) }
}

/** Typed Y.Map wrapper for UnifiedAudioTakeV2Dict. */
export class UnifiedAudioTakeV2DictYMap extends YMapWrapper {
  get baseFitRate(): number | undefined { return _readYDocOptionalNumber(this._raw.get('baseFitRate'), "UnifiedAudioTakeV2Dict.baseFitRate", 0.0) }
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "UnifiedAudioTakeV2Dict.id") }
  get language(): string | null | undefined { return (this._raw.get('language') == null ? undefined : _readYDocUnion<string | null>(this._raw.get('language'), "UnifiedAudioTakeV2Dict.language", [(value, fieldLabel) => _readYDocString(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get source(): AudioTakeSourceV2DictYMap | undefined { return (this._raw.get('source') == null ? undefined : (() => { _validateYDocAudioTakeSourceV2Dict(this._raw.get('source'), "UnifiedAudioTakeV2Dict.source"); return _readYDocMapWrapper(this._raw.get('source'), AudioTakeSourceV2DictYMap, "UnifiedAudioTakeV2Dict.source") })()) }
  get voiceId(): string | null | undefined { return (this._raw.get('voiceId') == null ? undefined : _readYDocUnion<string | null>(this._raw.get('voiceId'), "UnifiedAudioTakeV2Dict.voiceId", [(value, fieldLabel) => _readYDocString(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
}

/** Typed Y.Map wrapper for UpstreamContextDict. */
export class UpstreamContextDictYMap extends YMapWrapper {
  get aspect_ratio(): string | undefined { return _readYDocOptionalString(this._raw.get('aspect_ratio'), "UpstreamContextDict.aspect_ratio") }
  get description(): string | undefined { return _readYDocOptionalString(this._raw.get('description'), "UpstreamContextDict.description") }
  get local_path(): string | undefined { return _readYDocOptionalString(this._raw.get('local_path'), "UpstreamContextDict.local_path") }
  get name(): string | undefined { return _readYDocOptionalString(this._raw.get('name'), "UpstreamContextDict.name") }
  get prompt(): string | undefined { return _readYDocOptionalString(this._raw.get('prompt'), "UpstreamContextDict.prompt") }
  get role(): string | undefined { return _readYDocOptionalString(this._raw.get('role'), "UpstreamContextDict.role") }
  get scene_id(): string | undefined { return _readYDocOptionalString(this._raw.get('scene_id'), "UpstreamContextDict.scene_id") }
  get source_node_id(): string | undefined { return _readYDocOptionalString(this._raw.get('source_node_id'), "UpstreamContextDict.source_node_id") }
  get source_node_type(): string | undefined { return _readYDocOptionalString(this._raw.get('source_node_type'), "UpstreamContextDict.source_node_type") }
  get source_output(): string | undefined { return _readYDocOptionalString(this._raw.get('source_output'), "UpstreamContextDict.source_output") }
  get style(): string | undefined { return _readYDocOptionalString(this._raw.get('style'), "UpstreamContextDict.style") }
}

/** Typed Y.Map wrapper for VideoAssetRefDict. */
export class VideoAssetRefDictYMap extends YMapWrapper {
  get history(): GeneratedVideoYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('history'), "VideoAssetRefDict.history", (item, itemLabel) => (() => { _validateYDocGeneratedVideo(item, itemLabel); return _readYDocMapWrapper(item, GeneratedVideoYMap, itemLabel) })()) }
  get picked_index(): number | undefined { return _readYDocOptionalInteger(this._raw.get('picked_index'), "VideoAssetRefDict.picked_index") }
}

/** Typed Y.Map wrapper for VideoFullRemixStatusV1Dict. */
export class VideoFullRemixStatusV1DictYMap extends YMapWrapper {
  get attempt_id(): string | undefined { return _readYDocOptionalString(this._raw.get('attempt_id'), "VideoFullRemixStatusV1Dict.attempt_id") }
  get batch_id(): string | null | undefined { return (this._raw.get('batch_id') == null ? undefined : _readYDocUnion<string | null>(this._raw.get('batch_id'), "VideoFullRemixStatusV1Dict.batch_id", [(value, fieldLabel) => _readYDocString(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get batch_revision(): number | null | undefined { return (this._raw.get('batch_revision') == null ? undefined : _readYDocUnion<number | null>(this._raw.get('batch_revision'), "VideoFullRemixStatusV1Dict.batch_revision", [(value, fieldLabel) => _readYDocInteger(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get batch_state(): "preflighting" | "awaiting_confirmation" | "applying" | "completed" | "partial_failure" | "failed" | "cancelled" | null | undefined { return (this._raw.get('batch_state') == null ? undefined : _readYDocUnion<"preflighting" | "awaiting_confirmation" | "applying" | "completed" | "partial_failure" | "failed" | "cancelled" | null>(this._raw.get('batch_state'), "VideoFullRemixStatusV1Dict.batch_state", [(value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["preflighting", "awaiting_confirmation", "applying", "completed", "partial_failure", "failed", "cancelled"] as const), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get error(): string | null | undefined { return (this._raw.get('error') == null ? undefined : _readYDocUnion<string | null>(this._raw.get('error'), "VideoFullRemixStatusV1Dict.error", [(value, fieldLabel) => _readYDocString(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get error_code(): string | null | undefined { return (this._raw.get('error_code') == null ? undefined : _readYDocUnion<string | null>(this._raw.get('error_code'), "VideoFullRemixStatusV1Dict.error_code", [(value, fieldLabel) => _readYDocString(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get message(): string | null | undefined { return (this._raw.get('message') == null ? undefined : _readYDocUnion<string | null>(this._raw.get('message'), "VideoFullRemixStatusV1Dict.message", [(value, fieldLabel) => _readYDocString(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get resulting_variant_index(): number | null | undefined { return (this._raw.get('resulting_variant_index') == null ? undefined : _readYDocUnion<number | null>(this._raw.get('resulting_variant_index'), "VideoFullRemixStatusV1Dict.resulting_variant_index", [(value, fieldLabel) => _readYDocInteger(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get resulting_variant_path(): string | null | undefined { return (this._raw.get('resulting_variant_path') == null ? undefined : _readYDocUnion<string | null>(this._raw.get('resulting_variant_path'), "VideoFullRemixStatusV1Dict.resulting_variant_path", [(value, fieldLabel) => _readYDocString(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get retryable(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('retryable'), "VideoFullRemixStatusV1Dict.retryable") }
  get source(): "initial_generate" | "manual_apply" | "director_apply" | "unknown" | undefined { return _readYDocOptionalEnum(this._raw.get('source'), "VideoFullRemixStatusV1Dict.source", ["initial_generate", "manual_apply", "director_apply", "unknown"] as const) }
  get source_variant_index(): number | null | undefined { return (this._raw.get('source_variant_index') == null ? undefined : _readYDocUnion<number | null>(this._raw.get('source_variant_index'), "VideoFullRemixStatusV1Dict.source_variant_index", [(value, fieldLabel) => _readYDocInteger(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get source_variant_path(): string | null | undefined { return (this._raw.get('source_variant_path') == null ? undefined : _readYDocUnion<string | null>(this._raw.get('source_variant_path'), "VideoFullRemixStatusV1Dict.source_variant_path", [(value, fieldLabel) => _readYDocString(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get source_variant_ref(): string | null | undefined { return (this._raw.get('source_variant_ref') == null ? undefined : _readYDocUnion<string | null>(this._raw.get('source_variant_ref'), "VideoFullRemixStatusV1Dict.source_variant_ref", [(value, fieldLabel) => _readYDocString(value, fieldLabel), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get state(): "requested" | "preflighting" | "applying" | "completed" | "failed" | "cancelled" | "skipped" | undefined { return _readYDocOptionalEnum(this._raw.get('state'), "VideoFullRemixStatusV1Dict.state", ["requested", "preflighting", "applying", "completed", "failed", "cancelled", "skipped"] as const) }
  get target_phase(): "preflight" | "execution" | null | undefined { return (this._raw.get('target_phase') == null ? undefined : _readYDocUnion<"preflight" | "execution" | null>(this._raw.get('target_phase'), "VideoFullRemixStatusV1Dict.target_phase", [(value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["preflight", "execution"] as const), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get target_state(): "pending" | "analyzing" | "retry_wait" | "ready" | "queued" | "running" | "applied" | "failed" | "skipped" | null | undefined { return (this._raw.get('target_state') == null ? undefined : _readYDocUnion<"pending" | "analyzing" | "retry_wait" | "ready" | "queued" | "running" | "applied" | "failed" | "skipped" | null>(this._raw.get('target_state'), "VideoFullRemixStatusV1Dict.target_state", [(value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["pending", "analyzing", "retry_wait", "ready", "queued", "running", "applied", "failed", "skipped"] as const), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get target_step(): "queued" | "transcribing" | "matching_characters" | "isolating_speech" | "ready" | "applying" | "completed" | "failed" | null | undefined { return (this._raw.get('target_step') == null ? undefined : _readYDocUnion<"queued" | "transcribing" | "matching_characters" | "isolating_speech" | "ready" | "applying" | "completed" | "failed" | null>(this._raw.get('target_step'), "VideoFullRemixStatusV1Dict.target_step", [(value, fieldLabel) => _readYDocEnum(value, fieldLabel, ["queued", "transcribing", "matching_characters", "isolating_speech", "ready", "applying", "completed", "failed"] as const), (value, fieldLabel) => _readYDocNull(value, fieldLabel)])) }
  get updated_at(): string | undefined { return _readYDocOptionalString(this._raw.get('updated_at'), "VideoFullRemixStatusV1Dict.updated_at") }
  get version(): 1 | undefined { return _readYDocOptionalEnum(this._raw.get('version'), "VideoFullRemixStatusV1Dict.version", [1] as const) }
}

/** Typed Y.Map wrapper for VideoReferenceEditDict. */
export class VideoReferenceEditDictYMap extends YMapWrapper {
  get asset_path(): string | undefined { return _readYDocOptionalString(this._raw.get('asset_path'), "VideoReferenceEditDict.asset_path") }
  get end_time(): number | undefined { return _readYDocOptionalNumber(this._raw.get('end_time'), "VideoReferenceEditDict.end_time") }
  get keep_last_seconds(): number | undefined { return _readYDocOptionalNumber(this._raw.get('keep_last_seconds'), "VideoReferenceEditDict.keep_last_seconds", 0) }
  get source_node_id(): string | undefined { return _readYDocOptionalString(this._raw.get('source_node_id'), "VideoReferenceEditDict.source_node_id") }
  get start_time(): number | undefined { return _readYDocOptionalNumber(this._raw.get('start_time'), "VideoReferenceEditDict.start_time") }
}

/** Typed Y.Map wrapper for VlmValidationIssueDict. */
export class VlmValidationIssueDictYMap extends YMapWrapper {
  get category(): string | undefined { return _readYDocOptionalString(this._raw.get('category'), "VlmValidationIssueDict.category") }
  get description(): string | undefined { return _readYDocOptionalString(this._raw.get('description'), "VlmValidationIssueDict.description") }
  get region(): string | undefined { return _readYDocOptionalString(this._raw.get('region'), "VlmValidationIssueDict.region") }
  get severity(): string | undefined { return _readYDocOptionalString(this._raw.get('severity'), "VlmValidationIssueDict.severity") }
}

/** Typed Y.Map wrapper for VlmValidationReportDict. */
export class VlmValidationReportDictYMap extends YMapWrapper {
  get issues(): VlmValidationIssueDictYMap[] | undefined { return _readYDocOptionalArray(this._raw.get('issues'), "VlmValidationReportDict.issues", (item, itemLabel) => _readYDocMapWrapper(item, VlmValidationIssueDictYMap, itemLabel)) }
  get model_used(): string | undefined { return _readYDocOptionalString(this._raw.get('model_used'), "VlmValidationReportDict.model_used") }
  get overall_score(): number | undefined { return _readYDocOptionalInteger(this._raw.get('overall_score'), "VlmValidationReportDict.overall_score") }
  get passed(): boolean | undefined { return _readYDocOptionalBoolean(this._raw.get('passed'), "VlmValidationReportDict.passed") }
  get summary(): string | undefined { return _readYDocOptionalString(this._raw.get('summary'), "VlmValidationReportDict.summary") }
  get validated_at(): string | undefined { return _readYDocOptionalString(this._raw.get('validated_at'), "VlmValidationReportDict.validated_at") }
}

/** Typed Y.Map wrapper for VoiceMapDict. */
export class VoiceMapDictYMap extends YMapWrapper {
  get(key: string): string | undefined {
    const value = this._raw.get(key)
    if (value === undefined) return undefined
    const fieldLabel = `${this.constructor.name}.${key}`
    _validateYDocString(value, fieldLabel)
    return _readYDocString(value, fieldLabel)
  }
  set(key: string, value: string): void {
    const fieldLabel = `${this.constructor.name}.${key}`
    const validationValue = _attachYDocValidationCandidate(value)
    _validateYDocString(validationValue, fieldLabel)
    this._raw.set(key, _toYDocValue(value))
  }
  delete(key: string): void { this._raw.delete(key) }
}

/** Typed Y.Map wrapper for VoiceMapEntryDict. */
export class VoiceMapEntryDictYMap extends YMapWrapper {
  get voice_id(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_id'), "VoiceMapEntryDict.voice_id") }
  get voice_name(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_name'), "VoiceMapEntryDict.voice_name") }
}

/** Typed Y.Map wrapper for VoiceProfileDict. */
export class VoiceProfileDictYMap extends YMapWrapper {
  get audio_sample(): string | undefined { return _readYDocOptionalString(this._raw.get('audio_sample'), "VoiceProfileDict.audio_sample") }
  get characteristics(): string[] | undefined { return _readYDocOptionalArray(this._raw.get('characteristics'), "VoiceProfileDict.characteristics", (item, itemLabel) => _readYDocString(item, itemLabel)) }
  get description(): string | undefined { return _readYDocOptionalString(this._raw.get('description'), "VoiceProfileDict.description") }
  get descriptors(): string[] | undefined { return _readYDocOptionalArray(this._raw.get('descriptors'), "VoiceProfileDict.descriptors", (item, itemLabel) => _readYDocString(item, itemLabel)) }
  get language(): string | undefined { return _readYDocOptionalString(this._raw.get('language'), "VoiceProfileDict.language") }
  get locale(): string | undefined { return _readYDocOptionalString(this._raw.get('locale'), "VoiceProfileDict.locale") }
  get name(): string | undefined { return _readYDocOptionalString(this._raw.get('name'), "VoiceProfileDict.name") }
  get pronunciation_guide(): string | undefined { return _readYDocOptionalString(this._raw.get('pronunciation_guide'), "VoiceProfileDict.pronunciation_guide") }
  get provider(): string | undefined { return _readYDocOptionalString(this._raw.get('provider'), "VoiceProfileDict.provider") }
  get speech_text(): string | undefined { return _readYDocOptionalString(this._raw.get('speech_text'), "VoiceProfileDict.speech_text") }
  get use_case(): string | undefined { return _readYDocOptionalString(this._raw.get('use_case'), "VoiceProfileDict.use_case") }
  get voice_id(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_id'), "VoiceProfileDict.voice_id") }
  get voice_name(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_name'), "VoiceProfileDict.voice_name") }
  get voice_prompt(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_prompt'), "VoiceProfileDict.voice_prompt") }
  get voice_ref(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_ref'), "VoiceProfileDict.voice_ref") }
  get voice_source(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_source'), "VoiceProfileDict.voice_source") }
}

/** Typed Y.Map wrapper for VoiceRoleDict. */
export class VoiceRoleDictYMap extends YMapWrapper {
  get id(): string | undefined { return _readYDocOptionalString(this._raw.get('id'), "VoiceRoleDict.id") }
  get kind(): string | undefined { return _readYDocOptionalString(this._raw.get('kind'), "VoiceRoleDict.kind") }
  get label(): string | undefined { return _readYDocOptionalString(this._raw.get('label'), "VoiceRoleDict.label") }
  get source_character(): string | undefined { return _readYDocOptionalString(this._raw.get('source_character'), "VoiceRoleDict.source_character") }
  get voice_description(): string | undefined { return _readYDocOptionalString(this._raw.get('voice_description'), "VoiceRoleDict.voice_description") }
}

/** Typed Y.Map wrapper for VoiceSettingsDict. */
export class VoiceSettingsDictYMap extends YMapWrapper {
  get similarity_boost(): number | undefined { return _readYDocOptionalNumber(this._raw.get('similarity_boost'), "VoiceSettingsDict.similarity_boost") }
  get speed(): number | undefined { return _readYDocOptionalNumber(this._raw.get('speed'), "VoiceSettingsDict.speed") }
  get stability(): number | undefined { return _readYDocOptionalNumber(this._raw.get('stability'), "VoiceSettingsDict.stability") }
  get style(): number | undefined { return _readYDocOptionalNumber(this._raw.get('style'), "VoiceSettingsDict.style") }
}

/** Typed Y.Map wrapper for WebtoonDialogueDict. */
export class WebtoonDialogueDictYMap extends YMapWrapper {
  get character(): string | undefined { return _readYDocOptionalString(this._raw.get('character'), "WebtoonDialogueDict.character") }
  get text(): string | undefined { return _readYDocOptionalString(this._raw.get('text'), "WebtoonDialogueDict.text") }
}

/** Typed Y.Map wrapper for _SoundAudioResultDict. */
export class _SoundAudioResultDictYMap extends YMapWrapper {
  get local_path(): string | undefined { return _readYDocOptionalString(this._raw.get('local_path'), "_SoundAudioResultDict.local_path") }
  get metadata(): AudioAssetMetadataDictYMap | undefined { return _readYDocOptionalMapWrapper(this._raw.get('metadata'), AudioAssetMetadataDictYMap, "_SoundAudioResultDict.metadata") }
}

/** Create a typed Y.Map wrapper from a raw Y.Map and its pythonType name. */
export function wrapYMap(raw: Y.Map<YDocValue> | undefined | null): YMapWrapper | undefined {
  if (raw == null || !(raw instanceof Y.Map)) return undefined
  return new YMapWrapper(raw)
}

// ---------------------------------------------------------------------------
// Y.Map/Y.Array navigation helpers (replaces ymapAccess.ts)
// ---------------------------------------------------------------------------

/**
 * Read a field from a Y.Map-backed generated wrapper.
 * Returns undefined if the container is nullish or the key is missing.
 */
export function ymapGet(container: YMapReadable | null | undefined, key: string): unknown {
  if (container == null) return undefined
  const readable = _assertYMapReadable(container, 'ymapGet')
  if (readable instanceof Y.Map) return readable.get(key)
  if (readable instanceof YMapWrapper) return readable.get(key)
  if (readable instanceof YMapRecord) return readable.get(key)
  throw new TypeError(`ymapGet reached unsupported Y.Map-backed value ${_yDocTypeName(readable)}`)
}

/** Read a field as a string, returning undefined if not a string. */
export function ymapGetStr(container: YMapReadable | null | undefined, key: string): string | undefined {
  const v = ymapGet(container, key)
  return typeof v === 'string' ? v : undefined
}

/** Read a field as a number, returning undefined if not a number. */
export function ymapGetNum(container: YMapReadable | null | undefined, key: string): number | undefined {
  const v = ymapGet(container, key)
  return typeof v === 'number' ? v : undefined
}

/** Read a field as a boolean, returning undefined if not a boolean. */
export function ymapGetBool(container: YMapReadable | null | undefined, key: string): boolean | undefined {
  const v = ymapGet(container, key)
  return typeof v === 'boolean' ? v : undefined
}

/**
 * Convert a Y.Array or nullish value to a plain JS array.
 * The generic parameter allows callers to specify the expected element type
 * without needing an `as` cast at the call site.
 */
export function ymapToArray<T = YDocValue>(value: Y.Array<YDocValue> | null | undefined): T[] {
  if (value == null) return []
  if (value instanceof Y.Array) return value.toArray() as T[]
  throw new TypeError(`ymapToArray expected Y.Array, got ${_yDocTypeName(value)}`)
}

/** Read the picked_index from a GeneratedImageWithHistory-shaped Y.Map. */
export function ymapPickedIndex(container: YMapReadable | null | undefined): number {
  const raw = ymapGet(container, 'picked_index')
  return typeof raw === 'number' ? raw : 0
}

/**
 * Read `result.local_path` from a history entry Y.Map.
 * Common shorthand for `ymapGetStr(ymapGet(entry, 'result'), 'local_path')`.
 */
export function ymapEntryLocalPath(entry: YMapReadable | null | undefined): string | undefined {
  const result = ymapGet(entry, 'result')
  if (result == null) return undefined
  return ymapGetStr(_assertYMapReadable(result, 'ymapEntryLocalPath.result'), 'local_path')
}

/** Frontend type to backend type mapping (from schema type → backendType) */
export const FE_TYPE_TO_BACKEND: Record<string, string> & {
  readonly audio: 'audio',
  readonly characterDesigner: 'character_designer',
  readonly debugHang: 'debug_hang',
  readonly director: 'director',
  readonly generatedImageWithHistory: 'generated_image_with_history',
  readonly image: 'image',
  readonly imageGenerator: 'image_generator',
  readonly locationDesigner: 'location_designer',
  readonly nodeGroup: 'node_group',
  readonly objectDesigner: 'object_designer',
  readonly panelSource: 'panel_source',
  readonly promptInput: 'prompt_input',
  readonly scriptWriter: 'script_writer',
  readonly shortVideoGroup: 'short_video_group',
  readonly soundExpert: 'sound_expert',
  readonly speechGenerator: 'speech_generator',
  readonly storyDirectionPreview: 'story_direction_preview',
  readonly storyboardDesigner: 'storyboard_designer',
  readonly storyboardNoEnhanceDesigner: 'storyboard_no_enhance_designer',
  readonly styleSelector: 'style_selector',
  readonly text: 'text',
  readonly video: 'video',
  readonly videoEditor: 'video_editor',
  readonly videoGenerator: 'video_generator',
  readonly webtoonGroup: 'webtoon_group',
  readonly webtoonPanelGenerator: 'webtoon_panel_generator',
} = {
  audio: 'audio',
  characterDesigner: 'character_designer',
  debugHang: 'debug_hang',
  director: 'director',
  generatedImageWithHistory: 'generated_image_with_history',
  image: 'image',
  imageGenerator: 'image_generator',
  locationDesigner: 'location_designer',
  nodeGroup: 'node_group',
  objectDesigner: 'object_designer',
  panelSource: 'panel_source',
  promptInput: 'prompt_input',
  scriptWriter: 'script_writer',
  shortVideoGroup: 'short_video_group',
  soundExpert: 'sound_expert',
  speechGenerator: 'speech_generator',
  storyDirectionPreview: 'story_direction_preview',
  storyboardDesigner: 'storyboard_designer',
  storyboardNoEnhanceDesigner: 'storyboard_no_enhance_designer',
  styleSelector: 'style_selector',
  text: 'text',
  video: 'video',
  videoEditor: 'video_editor',
  videoGenerator: 'video_generator',
  webtoonGroup: 'webtoon_group',
  webtoonPanelGenerator: 'webtoon_panel_generator',
}
/** Node types hidden on the ReactFlow canvas (from canvasHidden in schemas) */
export const CANVAS_HIDDEN_FE_TYPES: ReadonlySet<string> = new Set(['director', 'storyDirectionPreview'])
